"use strict";

// esbuild tries to load these packages via require so I have to provide "require" in the runtime
function require(lib) {
	var map = {
		"howler": window,
		"@sentry/browser": Sentry,
		"@sentry/types": Sentry,
		"css-element-queries": { ResizeSensor },
		"idb-keyval": idbKeyval,
	}

	return map[lib] || window[lib]
}

(function(root, factory) {
	if (typeof module === "object" && module.exports) {
		module.exports = factory()
	} else {
		root.game = {
			config: factory(),
		}
	}
})(typeof self !== "undefined" ? self : this, function() {
	/**
	 * @param value {{ days?: number, hours?: number, minutes?: number, seconds?: number, ms?: number }}
	 * @returns {number}
	 */
	function toMs(value) {
		Object.assign({ days: 0, hours: 0, minutes: 0, seconds: 0, ms: 0 }, value)

		let sum = 0

		if (typeof value.days === "number") {
			sum += value.days * 24 * 60 * 60 * 1000
		}

		if (typeof value.hours === "number") {
			sum += value.hours * 60 * 60 * 1000
		}

		if (typeof value.minutes === "number") {
			sum += value.minutes * 60 * 1000
		}

		if (typeof value.seconds === "number") {
			sum += value.seconds * 1000
		}

		if (typeof value.ms === "number") {
			sum += value.ms
		}

		return sum
	}

	return {
		build_time: "01.06.2021 12:03:56",
		build_version: 640,
		publisher: "game-monetize",
		game_title: "Papa Cherry Saga",
		game_slug: "papa-cherry-saga",
		initial_lives: 5,
		wheel_unlock_level: 15,
		second_chance_price: 1000,
		default_language: "en",
		feedback_enabled: true,
		feedback_url: "https://api.steinhq.com/v1/storages/600187bcf62b6004b3eb6503/Лист1",
		analytics_enabled: true,
		ads: {
			rewarded: true,
			interstitials: true,
			minIntervalMs: toMs({ seconds: 90 }),
		},
		purchases: {
			enabled: false,
			currency: {
				code: "RUB", // https://oxr.readme.io/docs/supported-currencies
				conversionRate: 10,
				template: {
					en: "# voices",
					ru: "# голосов",
				},
			},
		},
		piggy_bank: {
			enabled: true,
			breakMethod: "auto", // auto, rewarded_ad or purchase
			max_capacity: 2000,
			min_amount_to_open: 100,
		},
		widget_button: {
			start_level_screen: {
				enabled: false,
				frame: "popups/start_level/widget_button_2.png",
			},
			pause_screen: {
				enabled: false,
				frame: "pause_screen/widget_button",
			},
		},
		greetings_screen: {
			enabled: true,
			displayInterval: toMs({ hours: 8 }),
			bonus: {
				unlimitedLivesMs: 0,
				coins: 500,
			},
			superBonus: {
				unlimitedLivesMs: 0,
				coins: 1500,
			},
		},
		pregame_boosters_unlock: {
			stripes: 12,
			bomb: 12,
			super_sphere: 12,
		},
		boosters_unlock: {
			glove: 8,
			rolling_pin: 10,
			lollipop: 11,
		},
		video_rewards: {
			lives: 1,
			extra_moves: 5,
			coins: 1000,
			stripes: 2,
			bomb: 2,
			super_sphere: 1,
			glove: 2,
			rolling_pin: 1,
			lollipop: 1,
			undo: 4,
		},
		wheel_rewards: {
			coins: 500,
			stripes: 1,
			bomb: 1,
			undo: 1,
			glove: 1,
			rolling_pin: 1,
			lollipop: 1,
			super_sphere: 1,
		},
	}
});

(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __defProps = Object.defineProperties;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __propIsEnum = Object.prototype.propertyIsEnumerable;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {enumerable: true, configurable: true, writable: true, value}) : obj[key] = value;
  var __spreadValues = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(b)) {
        if (__propIsEnum.call(b, prop))
          __defNormalProp(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
  var __markAsModule = (target) => __defProp(target, "__esModule", {value: true});
  var __objRest = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  var __reExport = (target, module2, desc) => {
    if (module2 && typeof module2 === "object" || typeof module2 === "function") {
      for (let key of __getOwnPropNames(module2))
        if (!__hasOwnProp.call(target, key) && key !== "default")
          __defProp(target, key, {get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable});
    }
    return target;
  };
  var __toModule = (module2) => {
    return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? {get: () => module2.default, enumerable: true} : {value: module2, enumerable: true})), module2);
  };
  var __async = (__this, __arguments, generator) => {
    return new Promise((resolve, reject) => {
      var fulfilled = (value) => {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      };
      var rejected = (value) => {
        try {
          step(generator.throw(value));
        } catch (e) {
          reject(e);
        }
      };
      var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
      step((generator = generator.apply(__this, __arguments)).next());
    });
  };

  // src/robowhale/storage/RuntimeStorage.ts
  var RuntimeStorage = class {
    constructor() {
      this.name = "Runtime Storage";
      this.storage = {};
    }
    get namespace() {
      return this._namespace;
    }
    init() {
    }
    setNamespace(namespace) {
      this._namespace = namespace;
    }
    saveValue(key, value) {
      this.storage[this.getSaveKey(key)] = value;
    }
    getValue(key) {
      return this.storage[this.getSaveKey(key)];
    }
    getNumber(key) {
      return this.getValue(key) || 0;
    }
    getBoolean(key) {
      return this.getValue(key) || false;
    }
    getString(key) {
      return this.getValue(key) || "";
    }
    getObject(key) {
      return this.getValue(key) || {};
    }
    getContent(ignoreNamespace = false) {
      if (ignoreNamespace) {
        return this.storage;
      }
      let keys2 = Object.keys(this.storage).filter((key) => {
        return key.indexOf(this._namespace) > -1;
      });
      let content = {};
      keys2.forEach((key) => {
        content[key] = this.storage[key];
      });
      return content;
    }
    clear(ignoreNamespace = false) {
      if (ignoreNamespace) {
        this.storage = {};
        return;
      }
      Object.keys(this.storage).filter((key) => {
        if (key.includes(this._namespace)) {
          delete this.storage[key];
        }
      });
    }
    getSaveKey(key) {
      return this._namespace + "__" + key;
    }
  };

  // src/boosters/BoosterType.ts
  var BoosterType;
  (function(BoosterType2) {
    BoosterType2["UNDO"] = "undo";
    BoosterType2["GLOVE"] = "glove";
    BoosterType2["ROLLING_PIN"] = "rolling_pin";
    BoosterType2["LOLLIPOP"] = "lollipop";
  })(BoosterType || (BoosterType = {}));

  // src/robowhale/storage/LocalStorageWrapper.ts
  function isLocalStorageAvailable() {
    try {
      let key = "__storage_test__";
      localStorage.setItem(key, key);
      localStorage.removeItem(key);
      return true;
    } catch (e) {
      return false;
    }
  }
  var LocalStorageWrapper = class {
    constructor(storeName) {
      this.type = "LocalStorage";
      this.prefix = storeName;
    }
    init() {
      return Promise.resolve();
    }
    saveValue(key, value) {
      try {
        let dataToSave = this.stringify(value);
        localStorage.setItem(this.getStorageKey(key), dataToSave);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    }
    stringify(value) {
      return typeof value === "string" ? value : JSON.stringify(value);
    }
    getStorageKey(key) {
      return `${this.prefix}__${key}`;
    }
    getValue(key) {
      return Promise.resolve(localStorage.getItem(this.getStorageKey(key)));
    }
    getNumber(key) {
      return __async(this, null, function* () {
        let value = yield this.getValue(key);
        if (value === null) {
          return Promise.resolve(0);
        } else {
          let num = parseFloat(value) || 0;
          return Promise.resolve(num);
        }
      });
    }
    getBoolean(key) {
      return __async(this, null, function* () {
        let value = yield this.getValue(key);
        if (value === null) {
          return Promise.resolve(false);
        } else {
          let bool = value === "true";
          return Promise.resolve(bool);
        }
      });
    }
    getString(key) {
      return __async(this, null, function* () {
        let value = yield this.getValue(key);
        if (value === null) {
          return Promise.resolve("");
        } else {
          return Promise.resolve(value);
        }
      });
    }
    getObject(key) {
      return __async(this, null, function* () {
        let value = yield this.getValue(key);
        let obj = null;
        try {
          obj = JSON.parse(value);
        } catch (e) {
          console.error(e);
        }
        return Promise.resolve(obj);
      });
    }
    remove(key) {
      localStorage.removeItem(this.getStorageKey(key));
    }
    clear() {
      Object.keys(localStorage).filter((key) => key.includes(this.prefix)).forEach((key) => {
        localStorage.removeItem(key);
      });
      return Promise.resolve();
    }
  };

  // src/robowhale/storage/IdbKeyvalWrapper.ts
  var import_idb_keyval = __toModule(require("idb-keyval"));
  function isIndexedDbAvailable() {
    return "indexedDB" in window;
  }
  var IdbKeyvalWrapper = class {
    constructor(storeName) {
      this.type = "IndexedDb";
      this.storeName = storeName;
      this.store = (0, import_idb_keyval.createStore)("robowhale", this.storeName);
    }
    init() {
      return __async(this, null, function* () {
        try {
          let key = "__test_key";
          yield (0, import_idb_keyval.set)(key, key, this.store);
          yield (0, import_idb_keyval.get)(key, this.store);
          yield (0, import_idb_keyval.del)(key);
        } catch (error) {
          return Promise.reject(error);
        }
      });
    }
    saveValue(key, value) {
      return (0, import_idb_keyval.set)(key, value, this.store);
    }
    getValue(key) {
      return (0, import_idb_keyval.get)(key, this.store);
    }
    getNumber(key) {
      return __async(this, null, function* () {
        let value = yield this.getValue(key);
        if (typeof value !== "number") {
          return Promise.resolve(0);
        } else {
          return value;
        }
      });
    }
    getBoolean(key) {
      return __async(this, null, function* () {
        let value = yield this.getValue(key);
        if (typeof value !== "boolean") {
          return false;
        } else {
          return value;
        }
      });
    }
    getString(key) {
      return __async(this, null, function* () {
        let value = yield this.getValue(key);
        if (typeof value !== "string") {
          return "";
        } else {
          return value;
        }
      });
    }
    getObject(key) {
      return __async(this, null, function* () {
        let value = yield this.getValue(key);
        if (typeof value !== "object") {
          return null;
        } else {
          return value;
        }
      });
    }
    remove(key) {
      return (0, import_idb_keyval.del)(key, this.store);
    }
    clear() {
      return (0, import_idb_keyval.clear)(this.store);
    }
  };

  // src/UrlParams.ts
  var UrlParams = class {
    static get(name) {
      let normalizedName = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      let regex = new RegExp("[\\?&]" + normalizedName + "=([^&#]*)");
      let results = regex.exec(location.search);
      return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
    static has(name) {
      return this.get(name) !== null;
    }
    static getNumber(name, _default = 0) {
      let value = this.get(name);
      if (value) {
        let num = parseFloat(value);
        return isNaN(num) ? _default : num;
      }
      return _default;
    }
    static getNumbers(name, _default) {
      let value = this.get(name);
      if (!value) {
        return _default != null ? _default : null;
      }
      if (value[0] !== "[" || value[value.length - 1] !== "]") {
        console.warn("Malformed url param input", value);
        return null;
      }
      let content = value.slice(1, value.length - 1);
      return content.split(",").map((numStr) => {
        return parseFloat(numStr);
      });
    }
    static getBool(name, expectedValue = "1") {
      let value = this.get(name);
      return !!(value && value === expectedValue);
    }
  };

  // src/scale/GraphicsQuality.ts
  var GraphicsQuality;
  (function(GraphicsQuality3) {
    GraphicsQuality3["LOW"] = "low";
    GraphicsQuality3["MEDIUM"] = "medium";
    GraphicsQuality3["HIGH"] = "high";
  })(GraphicsQuality || (GraphicsQuality = {}));
  function getGraphicsQualityAsNumber(quality) {
    switch (quality) {
      case GraphicsQuality.LOW:
        return 0.5;
      case GraphicsQuality.MEDIUM:
        return 0.75;
      case GraphicsQuality.HIGH:
        return 1;
      default:
        return 1;
    }
  }
  function isQualityOption(value) {
    return GRAPHICS_QUALITY_OPTIONS.includes(value);
  }
  var GRAPHICS_QUALITY_OPTIONS = Object.values(GraphicsQuality);

  // node_modules/lodash-es/_freeGlobal.js
  var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
  var freeGlobal_default = freeGlobal;

  // node_modules/lodash-es/_root.js
  var freeSelf = typeof self == "object" && self && self.Object === Object && self;
  var root = freeGlobal_default || freeSelf || Function("return this")();
  var root_default = root;

  // node_modules/lodash-es/_Symbol.js
  var Symbol = root_default.Symbol;
  var Symbol_default = Symbol;

  // node_modules/lodash-es/_getRawTag.js
  var objectProto = Object.prototype;
  var hasOwnProperty = objectProto.hasOwnProperty;
  var nativeObjectToString = objectProto.toString;
  var symToStringTag = Symbol_default ? Symbol_default.toStringTag : void 0;
  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
      value[symToStringTag] = void 0;
      var unmasked = true;
    } catch (e) {
    }
    var result = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }
  var getRawTag_default = getRawTag;

  // node_modules/lodash-es/_objectToString.js
  var objectProto2 = Object.prototype;
  var nativeObjectToString2 = objectProto2.toString;
  function objectToString(value) {
    return nativeObjectToString2.call(value);
  }
  var objectToString_default = objectToString;

  // node_modules/lodash-es/_baseGetTag.js
  var nullTag = "[object Null]";
  var undefinedTag = "[object Undefined]";
  var symToStringTag2 = Symbol_default ? Symbol_default.toStringTag : void 0;
  function baseGetTag(value) {
    if (value == null) {
      return value === void 0 ? undefinedTag : nullTag;
    }
    return symToStringTag2 && symToStringTag2 in Object(value) ? getRawTag_default(value) : objectToString_default(value);
  }
  var baseGetTag_default = baseGetTag;

  // node_modules/lodash-es/isObjectLike.js
  function isObjectLike(value) {
    return value != null && typeof value == "object";
  }
  var isObjectLike_default = isObjectLike;

  // node_modules/lodash-es/isSymbol.js
  var symbolTag = "[object Symbol]";
  function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike_default(value) && baseGetTag_default(value) == symbolTag;
  }
  var isSymbol_default = isSymbol;

  // node_modules/lodash-es/_arrayMap.js
  function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }
  var arrayMap_default = arrayMap;

  // node_modules/lodash-es/isArray.js
  var isArray = Array.isArray;
  var isArray_default = isArray;

  // node_modules/lodash-es/_baseToString.js
  var INFINITY = 1 / 0;
  var symbolProto = Symbol_default ? Symbol_default.prototype : void 0;
  var symbolToString = symbolProto ? symbolProto.toString : void 0;
  function baseToString(value) {
    if (typeof value == "string") {
      return value;
    }
    if (isArray_default(value)) {
      return arrayMap_default(value, baseToString) + "";
    }
    if (isSymbol_default(value)) {
      return symbolToString ? symbolToString.call(value) : "";
    }
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
  }
  var baseToString_default = baseToString;

  // node_modules/lodash-es/_trimmedEndIndex.js
  var reWhitespace = /\s/;
  function trimmedEndIndex(string) {
    var index = string.length;
    while (index-- && reWhitespace.test(string.charAt(index))) {
    }
    return index;
  }
  var trimmedEndIndex_default = trimmedEndIndex;

  // node_modules/lodash-es/_baseTrim.js
  var reTrimStart = /^\s+/;
  function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex_default(string) + 1).replace(reTrimStart, "") : string;
  }
  var baseTrim_default = baseTrim;

  // node_modules/lodash-es/isObject.js
  function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
  }
  var isObject_default = isObject;

  // node_modules/lodash-es/toNumber.js
  var NAN = 0 / 0;
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
  var reIsBinary = /^0b[01]+$/i;
  var reIsOctal = /^0o[0-7]+$/i;
  var freeParseInt = parseInt;
  function toNumber(value) {
    if (typeof value == "number") {
      return value;
    }
    if (isSymbol_default(value)) {
      return NAN;
    }
    if (isObject_default(value)) {
      var other = typeof value.valueOf == "function" ? value.valueOf() : value;
      value = isObject_default(other) ? other + "" : other;
    }
    if (typeof value != "string") {
      return value === 0 ? value : +value;
    }
    value = baseTrim_default(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
  }
  var toNumber_default = toNumber;

  // node_modules/lodash-es/toFinite.js
  var INFINITY2 = 1 / 0;
  var MAX_INTEGER = 17976931348623157e292;
  function toFinite(value) {
    if (!value) {
      return value === 0 ? value : 0;
    }
    value = toNumber_default(value);
    if (value === INFINITY2 || value === -INFINITY2) {
      var sign = value < 0 ? -1 : 1;
      return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
  }
  var toFinite_default = toFinite;

  // node_modules/lodash-es/toInteger.js
  function toInteger(value) {
    var result = toFinite_default(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
  }
  var toInteger_default = toInteger;

  // node_modules/lodash-es/after.js
  var FUNC_ERROR_TEXT = "Expected a function";
  function after(n, func) {
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    n = toInteger_default(n);
    return function() {
      if (--n < 1) {
        return func.apply(this, arguments);
      }
    };
  }
  var after_default = after;

  // node_modules/lodash-es/identity.js
  function identity(value) {
    return value;
  }
  var identity_default = identity;

  // node_modules/lodash-es/isFunction.js
  var asyncTag = "[object AsyncFunction]";
  var funcTag = "[object Function]";
  var genTag = "[object GeneratorFunction]";
  var proxyTag = "[object Proxy]";
  function isFunction(value) {
    if (!isObject_default(value)) {
      return false;
    }
    var tag = baseGetTag_default(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }
  var isFunction_default = isFunction;

  // node_modules/lodash-es/_coreJsData.js
  var coreJsData = root_default["__core-js_shared__"];
  var coreJsData_default = coreJsData;

  // node_modules/lodash-es/_isMasked.js
  var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData_default && coreJsData_default.keys && coreJsData_default.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  var isMasked_default = isMasked;

  // node_modules/lodash-es/_toSource.js
  var funcProto = Function.prototype;
  var funcToString = funcProto.toString;
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  var toSource_default = toSource;

  // node_modules/lodash-es/_baseIsNative.js
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  var funcProto2 = Function.prototype;
  var objectProto3 = Object.prototype;
  var funcToString2 = funcProto2.toString;
  var hasOwnProperty2 = objectProto3.hasOwnProperty;
  var reIsNative = RegExp("^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
  function baseIsNative(value) {
    if (!isObject_default(value) || isMasked_default(value)) {
      return false;
    }
    var pattern = isFunction_default(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource_default(value));
  }
  var baseIsNative_default = baseIsNative;

  // node_modules/lodash-es/_getValue.js
  function getValue(object, key) {
    return object == null ? void 0 : object[key];
  }
  var getValue_default = getValue;

  // node_modules/lodash-es/_getNative.js
  function getNative(object, key) {
    var value = getValue_default(object, key);
    return baseIsNative_default(value) ? value : void 0;
  }
  var getNative_default = getNative;

  // node_modules/lodash-es/_WeakMap.js
  var WeakMap = getNative_default(root_default, "WeakMap");
  var WeakMap_default = WeakMap;

  // node_modules/lodash-es/_baseCreate.js
  var objectCreate = Object.create;
  var baseCreate = function() {
    function object() {
    }
    return function(proto) {
      if (!isObject_default(proto)) {
        return {};
      }
      if (objectCreate) {
        return objectCreate(proto);
      }
      object.prototype = proto;
      var result = new object();
      object.prototype = void 0;
      return result;
    };
  }();
  var baseCreate_default = baseCreate;

  // node_modules/lodash-es/_apply.js
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);
      case 1:
        return func.call(thisArg, args[0]);
      case 2:
        return func.call(thisArg, args[0], args[1]);
      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }
  var apply_default = apply;

  // node_modules/lodash-es/noop.js
  function noop() {
  }
  var noop_default = noop;

  // node_modules/lodash-es/_copyArray.js
  function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while (++index < length) {
      array[index] = source[index];
    }
    return array;
  }
  var copyArray_default = copyArray;

  // node_modules/lodash-es/_shortOut.js
  var HOT_COUNT = 800;
  var HOT_SPAN = 16;
  var nativeNow = Date.now;
  function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
      var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
      lastCalled = stamp;
      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }
      return func.apply(void 0, arguments);
    };
  }
  var shortOut_default = shortOut;

  // node_modules/lodash-es/constant.js
  function constant(value) {
    return function() {
      return value;
    };
  }
  var constant_default = constant;

  // node_modules/lodash-es/_defineProperty.js
  var defineProperty = function() {
    try {
      var func = getNative_default(Object, "defineProperty");
      func({}, "", {});
      return func;
    } catch (e) {
    }
  }();
  var defineProperty_default = defineProperty;

  // node_modules/lodash-es/_baseSetToString.js
  var baseSetToString = !defineProperty_default ? identity_default : function(func, string) {
    return defineProperty_default(func, "toString", {
      "configurable": true,
      "enumerable": false,
      "value": constant_default(string),
      "writable": true
    });
  };
  var baseSetToString_default = baseSetToString;

  // node_modules/lodash-es/_setToString.js
  var setToString = shortOut_default(baseSetToString_default);
  var setToString_default = setToString;

  // node_modules/lodash-es/_arrayEach.js
  function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }
  var arrayEach_default = arrayEach;

  // node_modules/lodash-es/_baseFindIndex.js
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while (fromRight ? index-- : ++index < length) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }
  var baseFindIndex_default = baseFindIndex;

  // node_modules/lodash-es/_baseIsNaN.js
  function baseIsNaN(value) {
    return value !== value;
  }
  var baseIsNaN_default = baseIsNaN;

  // node_modules/lodash-es/_strictIndexOf.js
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }
  var strictIndexOf_default = strictIndexOf;

  // node_modules/lodash-es/_baseIndexOf.js
  function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf_default(array, value, fromIndex) : baseFindIndex_default(array, baseIsNaN_default, fromIndex);
  }
  var baseIndexOf_default = baseIndexOf;

  // node_modules/lodash-es/_arrayIncludes.js
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf_default(array, value, 0) > -1;
  }
  var arrayIncludes_default = arrayIncludes;

  // node_modules/lodash-es/_isIndex.js
  var MAX_SAFE_INTEGER = 9007199254740991;
  var reIsUint = /^(?:0|[1-9]\d*)$/;
  function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
  }
  var isIndex_default = isIndex;

  // node_modules/lodash-es/_baseAssignValue.js
  function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty_default) {
      defineProperty_default(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
      });
    } else {
      object[key] = value;
    }
  }
  var baseAssignValue_default = baseAssignValue;

  // node_modules/lodash-es/eq.js
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  var eq_default = eq;

  // node_modules/lodash-es/_assignValue.js
  var objectProto4 = Object.prototype;
  var hasOwnProperty3 = objectProto4.hasOwnProperty;
  function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty3.call(object, key) && eq_default(objValue, value)) || value === void 0 && !(key in object)) {
      baseAssignValue_default(object, key, value);
    }
  }
  var assignValue_default = assignValue;

  // node_modules/lodash-es/_copyObject.js
  function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while (++index < length) {
      var key = props[index];
      var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
      if (newValue === void 0) {
        newValue = source[key];
      }
      if (isNew) {
        baseAssignValue_default(object, key, newValue);
      } else {
        assignValue_default(object, key, newValue);
      }
    }
    return object;
  }
  var copyObject_default = copyObject;

  // node_modules/lodash-es/_overRest.js
  var nativeMax = Math.max;
  function overRest(func, start, transform) {
    start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
    return function() {
      var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
      while (++index < length) {
        array[index] = args[start + index];
      }
      index = -1;
      var otherArgs = Array(start + 1);
      while (++index < start) {
        otherArgs[index] = args[index];
      }
      otherArgs[start] = transform(array);
      return apply_default(func, this, otherArgs);
    };
  }
  var overRest_default = overRest;

  // node_modules/lodash-es/_baseRest.js
  function baseRest(func, start) {
    return setToString_default(overRest_default(func, start, identity_default), func + "");
  }
  var baseRest_default = baseRest;

  // node_modules/lodash-es/isLength.js
  var MAX_SAFE_INTEGER2 = 9007199254740991;
  function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
  }
  var isLength_default = isLength;

  // node_modules/lodash-es/isArrayLike.js
  function isArrayLike(value) {
    return value != null && isLength_default(value.length) && !isFunction_default(value);
  }
  var isArrayLike_default = isArrayLike;

  // node_modules/lodash-es/_isIterateeCall.js
  function isIterateeCall(value, index, object) {
    if (!isObject_default(object)) {
      return false;
    }
    var type = typeof index;
    if (type == "number" ? isArrayLike_default(object) && isIndex_default(index, object.length) : type == "string" && index in object) {
      return eq_default(object[index], value);
    }
    return false;
  }
  var isIterateeCall_default = isIterateeCall;

  // node_modules/lodash-es/_isPrototype.js
  var objectProto5 = Object.prototype;
  function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto5;
    return value === proto;
  }
  var isPrototype_default = isPrototype;

  // node_modules/lodash-es/_baseTimes.js
  function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }
  var baseTimes_default = baseTimes;

  // node_modules/lodash-es/_baseIsArguments.js
  var argsTag = "[object Arguments]";
  function baseIsArguments(value) {
    return isObjectLike_default(value) && baseGetTag_default(value) == argsTag;
  }
  var baseIsArguments_default = baseIsArguments;

  // node_modules/lodash-es/isArguments.js
  var objectProto6 = Object.prototype;
  var hasOwnProperty4 = objectProto6.hasOwnProperty;
  var propertyIsEnumerable = objectProto6.propertyIsEnumerable;
  var isArguments = baseIsArguments_default(function() {
    return arguments;
  }()) ? baseIsArguments_default : function(value) {
    return isObjectLike_default(value) && hasOwnProperty4.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
  };
  var isArguments_default = isArguments;

  // node_modules/lodash-es/stubFalse.js
  function stubFalse() {
    return false;
  }
  var stubFalse_default = stubFalse;

  // node_modules/lodash-es/isBuffer.js
  var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
  var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer2 = moduleExports ? root_default.Buffer : void 0;
  var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
  var isBuffer = nativeIsBuffer || stubFalse_default;
  var isBuffer_default = isBuffer;

  // node_modules/lodash-es/_baseIsTypedArray.js
  var argsTag2 = "[object Arguments]";
  var arrayTag = "[object Array]";
  var boolTag = "[object Boolean]";
  var dateTag = "[object Date]";
  var errorTag = "[object Error]";
  var funcTag2 = "[object Function]";
  var mapTag = "[object Map]";
  var numberTag = "[object Number]";
  var objectTag = "[object Object]";
  var regexpTag = "[object RegExp]";
  var setTag = "[object Set]";
  var stringTag = "[object String]";
  var weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]";
  var dataViewTag = "[object DataView]";
  var float32Tag = "[object Float32Array]";
  var float64Tag = "[object Float64Array]";
  var int8Tag = "[object Int8Array]";
  var int16Tag = "[object Int16Array]";
  var int32Tag = "[object Int32Array]";
  var uint8Tag = "[object Uint8Array]";
  var uint8ClampedTag = "[object Uint8ClampedArray]";
  var uint16Tag = "[object Uint16Array]";
  var uint32Tag = "[object Uint32Array]";
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag2] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag2] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  function baseIsTypedArray(value) {
    return isObjectLike_default(value) && isLength_default(value.length) && !!typedArrayTags[baseGetTag_default(value)];
  }
  var baseIsTypedArray_default = baseIsTypedArray;

  // node_modules/lodash-es/_baseUnary.js
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }
  var baseUnary_default = baseUnary;

  // node_modules/lodash-es/_nodeUtil.js
  var freeExports2 = typeof exports == "object" && exports && !exports.nodeType && exports;
  var freeModule2 = freeExports2 && typeof module == "object" && module && !module.nodeType && module;
  var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
  var freeProcess = moduleExports2 && freeGlobal_default.process;
  var nodeUtil = function() {
    try {
      var types = freeModule2 && freeModule2.require && freeModule2.require("util").types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {
    }
  }();
  var nodeUtil_default = nodeUtil;

  // node_modules/lodash-es/isTypedArray.js
  var nodeIsTypedArray = nodeUtil_default && nodeUtil_default.isTypedArray;
  var isTypedArray = nodeIsTypedArray ? baseUnary_default(nodeIsTypedArray) : baseIsTypedArray_default;
  var isTypedArray_default = isTypedArray;

  // node_modules/lodash-es/_arrayLikeKeys.js
  var objectProto7 = Object.prototype;
  var hasOwnProperty5 = objectProto7.hasOwnProperty;
  function arrayLikeKeys(value, inherited) {
    var isArr = isArray_default(value), isArg = !isArr && isArguments_default(value), isBuff = !isArr && !isArg && isBuffer_default(value), isType = !isArr && !isArg && !isBuff && isTypedArray_default(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes_default(value.length, String) : [], length = result.length;
    for (var key in value) {
      if ((inherited || hasOwnProperty5.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex_default(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }
  var arrayLikeKeys_default = arrayLikeKeys;

  // node_modules/lodash-es/_overArg.js
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  var overArg_default = overArg;

  // node_modules/lodash-es/_nativeKeys.js
  var nativeKeys = overArg_default(Object.keys, Object);
  var nativeKeys_default = nativeKeys;

  // node_modules/lodash-es/_baseKeys.js
  var objectProto8 = Object.prototype;
  var hasOwnProperty6 = objectProto8.hasOwnProperty;
  function baseKeys(object) {
    if (!isPrototype_default(object)) {
      return nativeKeys_default(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty6.call(object, key) && key != "constructor") {
        result.push(key);
      }
    }
    return result;
  }
  var baseKeys_default = baseKeys;

  // node_modules/lodash-es/keys.js
  function keys(object) {
    return isArrayLike_default(object) ? arrayLikeKeys_default(object) : baseKeys_default(object);
  }
  var keys_default = keys;

  // node_modules/lodash-es/_nativeKeysIn.js
  function nativeKeysIn(object) {
    var result = [];
    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }
    return result;
  }
  var nativeKeysIn_default = nativeKeysIn;

  // node_modules/lodash-es/_baseKeysIn.js
  var objectProto9 = Object.prototype;
  var hasOwnProperty7 = objectProto9.hasOwnProperty;
  function baseKeysIn(object) {
    if (!isObject_default(object)) {
      return nativeKeysIn_default(object);
    }
    var isProto = isPrototype_default(object), result = [];
    for (var key in object) {
      if (!(key == "constructor" && (isProto || !hasOwnProperty7.call(object, key)))) {
        result.push(key);
      }
    }
    return result;
  }
  var baseKeysIn_default = baseKeysIn;

  // node_modules/lodash-es/keysIn.js
  function keysIn(object) {
    return isArrayLike_default(object) ? arrayLikeKeys_default(object, true) : baseKeysIn_default(object);
  }
  var keysIn_default = keysIn;

  // node_modules/lodash-es/_isKey.js
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
  var reIsPlainProp = /^\w*$/;
  function isKey(value, object) {
    if (isArray_default(value)) {
      return false;
    }
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol_default(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
  }
  var isKey_default = isKey;

  // node_modules/lodash-es/_nativeCreate.js
  var nativeCreate = getNative_default(Object, "create");
  var nativeCreate_default = nativeCreate;

  // node_modules/lodash-es/_hashClear.js
  function hashClear() {
    this.__data__ = nativeCreate_default ? nativeCreate_default(null) : {};
    this.size = 0;
  }
  var hashClear_default = hashClear;

  // node_modules/lodash-es/_hashDelete.js
  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  var hashDelete_default = hashDelete;

  // node_modules/lodash-es/_hashGet.js
  var HASH_UNDEFINED = "__lodash_hash_undefined__";
  var objectProto10 = Object.prototype;
  var hasOwnProperty8 = objectProto10.hasOwnProperty;
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate_default) {
      var result = data[key];
      return result === HASH_UNDEFINED ? void 0 : result;
    }
    return hasOwnProperty8.call(data, key) ? data[key] : void 0;
  }
  var hashGet_default = hashGet;

  // node_modules/lodash-es/_hashHas.js
  var objectProto11 = Object.prototype;
  var hasOwnProperty9 = objectProto11.hasOwnProperty;
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate_default ? data[key] !== void 0 : hasOwnProperty9.call(data, key);
  }
  var hashHas_default = hashHas;

  // node_modules/lodash-es/_hashSet.js
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate_default && value === void 0 ? HASH_UNDEFINED2 : value;
    return this;
  }
  var hashSet_default = hashSet;

  // node_modules/lodash-es/_Hash.js
  function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  Hash.prototype.clear = hashClear_default;
  Hash.prototype["delete"] = hashDelete_default;
  Hash.prototype.get = hashGet_default;
  Hash.prototype.has = hashHas_default;
  Hash.prototype.set = hashSet_default;
  var Hash_default = Hash;

  // node_modules/lodash-es/_listCacheClear.js
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }
  var listCacheClear_default = listCacheClear;

  // node_modules/lodash-es/_assocIndexOf.js
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq_default(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  var assocIndexOf_default = assocIndexOf;

  // node_modules/lodash-es/_listCacheDelete.js
  var arrayProto = Array.prototype;
  var splice = arrayProto.splice;
  function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf_default(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    --this.size;
    return true;
  }
  var listCacheDelete_default = listCacheDelete;

  // node_modules/lodash-es/_listCacheGet.js
  function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf_default(data, key);
    return index < 0 ? void 0 : data[index][1];
  }
  var listCacheGet_default = listCacheGet;

  // node_modules/lodash-es/_listCacheHas.js
  function listCacheHas(key) {
    return assocIndexOf_default(this.__data__, key) > -1;
  }
  var listCacheHas_default = listCacheHas;

  // node_modules/lodash-es/_listCacheSet.js
  function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf_default(data, key);
    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }
  var listCacheSet_default = listCacheSet;

  // node_modules/lodash-es/_ListCache.js
  function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  ListCache.prototype.clear = listCacheClear_default;
  ListCache.prototype["delete"] = listCacheDelete_default;
  ListCache.prototype.get = listCacheGet_default;
  ListCache.prototype.has = listCacheHas_default;
  ListCache.prototype.set = listCacheSet_default;
  var ListCache_default = ListCache;

  // node_modules/lodash-es/_Map.js
  var Map2 = getNative_default(root_default, "Map");
  var Map_default = Map2;

  // node_modules/lodash-es/_mapCacheClear.js
  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash_default(),
      "map": new (Map_default || ListCache_default)(),
      "string": new Hash_default()
    };
  }
  var mapCacheClear_default = mapCacheClear;

  // node_modules/lodash-es/_isKeyable.js
  function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }
  var isKeyable_default = isKeyable;

  // node_modules/lodash-es/_getMapData.js
  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable_default(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  var getMapData_default = getMapData;

  // node_modules/lodash-es/_mapCacheDelete.js
  function mapCacheDelete(key) {
    var result = getMapData_default(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  var mapCacheDelete_default = mapCacheDelete;

  // node_modules/lodash-es/_mapCacheGet.js
  function mapCacheGet(key) {
    return getMapData_default(this, key).get(key);
  }
  var mapCacheGet_default = mapCacheGet;

  // node_modules/lodash-es/_mapCacheHas.js
  function mapCacheHas(key) {
    return getMapData_default(this, key).has(key);
  }
  var mapCacheHas_default = mapCacheHas;

  // node_modules/lodash-es/_mapCacheSet.js
  function mapCacheSet(key, value) {
    var data = getMapData_default(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }
  var mapCacheSet_default = mapCacheSet;

  // node_modules/lodash-es/_MapCache.js
  function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  MapCache.prototype.clear = mapCacheClear_default;
  MapCache.prototype["delete"] = mapCacheDelete_default;
  MapCache.prototype.get = mapCacheGet_default;
  MapCache.prototype.has = mapCacheHas_default;
  MapCache.prototype.set = mapCacheSet_default;
  var MapCache_default = MapCache;

  // node_modules/lodash-es/memoize.js
  var FUNC_ERROR_TEXT2 = "Expected a function";
  function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") {
      throw new TypeError(FUNC_ERROR_TEXT2);
    }
    var memoized = function() {
      var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result) || cache;
      return result;
    };
    memoized.cache = new (memoize.Cache || MapCache_default)();
    return memoized;
  }
  memoize.Cache = MapCache_default;
  var memoize_default = memoize;

  // node_modules/lodash-es/_memoizeCapped.js
  var MAX_MEMOIZE_SIZE = 500;
  function memoizeCapped(func) {
    var result = memoize_default(func, function(key) {
      if (cache.size === MAX_MEMOIZE_SIZE) {
        cache.clear();
      }
      return key;
    });
    var cache = result.cache;
    return result;
  }
  var memoizeCapped_default = memoizeCapped;

  // node_modules/lodash-es/_stringToPath.js
  var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
  var reEscapeChar = /\\(\\)?/g;
  var stringToPath = memoizeCapped_default(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46) {
      result.push("");
    }
    string.replace(rePropName, function(match, number, quote, subString) {
      result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
  });
  var stringToPath_default = stringToPath;

  // node_modules/lodash-es/toString.js
  function toString(value) {
    return value == null ? "" : baseToString_default(value);
  }
  var toString_default = toString;

  // node_modules/lodash-es/_castPath.js
  function castPath(value, object) {
    if (isArray_default(value)) {
      return value;
    }
    return isKey_default(value, object) ? [value] : stringToPath_default(toString_default(value));
  }
  var castPath_default = castPath;

  // node_modules/lodash-es/_toKey.js
  var INFINITY3 = 1 / 0;
  function toKey(value) {
    if (typeof value == "string" || isSymbol_default(value)) {
      return value;
    }
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY3 ? "-0" : result;
  }
  var toKey_default = toKey;

  // node_modules/lodash-es/_baseGet.js
  function baseGet(object, path) {
    path = castPath_default(path, object);
    var index = 0, length = path.length;
    while (object != null && index < length) {
      object = object[toKey_default(path[index++])];
    }
    return index && index == length ? object : void 0;
  }
  var baseGet_default = baseGet;

  // node_modules/lodash-es/get.js
  function get2(object, path, defaultValue) {
    var result = object == null ? void 0 : baseGet_default(object, path);
    return result === void 0 ? defaultValue : result;
  }
  var get_default = get2;

  // node_modules/lodash-es/_arrayPush.js
  function arrayPush(array, values2) {
    var index = -1, length = values2.length, offset = array.length;
    while (++index < length) {
      array[offset + index] = values2[index];
    }
    return array;
  }
  var arrayPush_default = arrayPush;

  // node_modules/lodash-es/_isFlattenable.js
  var spreadableSymbol = Symbol_default ? Symbol_default.isConcatSpreadable : void 0;
  function isFlattenable(value) {
    return isArray_default(value) || isArguments_default(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
  }
  var isFlattenable_default = isFlattenable;

  // node_modules/lodash-es/_baseFlatten.js
  function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable_default);
    result || (result = []);
    while (++index < length) {
      var value = array[index];
      if (depth > 0 && predicate(value)) {
        if (depth > 1) {
          baseFlatten(value, depth - 1, predicate, isStrict, result);
        } else {
          arrayPush_default(result, value);
        }
      } else if (!isStrict) {
        result[result.length] = value;
      }
    }
    return result;
  }
  var baseFlatten_default = baseFlatten;

  // node_modules/lodash-es/_getPrototype.js
  var getPrototype = overArg_default(Object.getPrototypeOf, Object);
  var getPrototype_default = getPrototype;

  // node_modules/lodash-es/isPlainObject.js
  var objectTag2 = "[object Object]";
  var funcProto3 = Function.prototype;
  var objectProto12 = Object.prototype;
  var funcToString3 = funcProto3.toString;
  var hasOwnProperty10 = objectProto12.hasOwnProperty;
  var objectCtorString = funcToString3.call(Object);
  function isPlainObject(value) {
    if (!isObjectLike_default(value) || baseGetTag_default(value) != objectTag2) {
      return false;
    }
    var proto = getPrototype_default(value);
    if (proto === null) {
      return true;
    }
    var Ctor = hasOwnProperty10.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString3.call(Ctor) == objectCtorString;
  }
  var isPlainObject_default = isPlainObject;

  // node_modules/lodash-es/isError.js
  var domExcTag = "[object DOMException]";
  var errorTag2 = "[object Error]";
  function isError(value) {
    if (!isObjectLike_default(value)) {
      return false;
    }
    var tag = baseGetTag_default(value);
    return tag == errorTag2 || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject_default(value);
  }
  var isError_default = isError;

  // node_modules/lodash-es/attempt.js
  var attempt = baseRest_default(function(func, args) {
    try {
      return apply_default(func, void 0, args);
    } catch (e) {
      return isError_default(e) ? e : new Error(e);
    }
  });
  var attempt_default = attempt;

  // node_modules/lodash-es/before.js
  var FUNC_ERROR_TEXT3 = "Expected a function";
  function before(n, func) {
    var result;
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT3);
    }
    n = toInteger_default(n);
    return function() {
      if (--n > 0) {
        result = func.apply(this, arguments);
      }
      if (n <= 1) {
        func = void 0;
      }
      return result;
    };
  }
  var before_default = before;

  // node_modules/lodash-es/_baseSlice.js
  function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) {
      start = -start > length ? 0 : length + start;
    }
    end = end > length ? length : end;
    if (end < 0) {
      end += length;
    }
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while (++index < length) {
      result[index] = array[index + start];
    }
    return result;
  }
  var baseSlice_default = baseSlice;

  // node_modules/lodash-es/_castSlice.js
  function castSlice(array, start, end) {
    var length = array.length;
    end = end === void 0 ? length : end;
    return !start && end >= length ? array : baseSlice_default(array, start, end);
  }
  var castSlice_default = castSlice;

  // node_modules/lodash-es/_hasUnicode.js
  var rsAstralRange = "\\ud800-\\udfff";
  var rsComboMarksRange = "\\u0300-\\u036f";
  var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange = "\\u20d0-\\u20ff";
  var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
  var rsVarRange = "\\ufe0e\\ufe0f";
  var rsZWJ = "\\u200d";
  var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }
  var hasUnicode_default = hasUnicode;

  // node_modules/lodash-es/_asciiToArray.js
  function asciiToArray(string) {
    return string.split("");
  }
  var asciiToArray_default = asciiToArray;

  // node_modules/lodash-es/_unicodeToArray.js
  var rsAstralRange2 = "\\ud800-\\udfff";
  var rsComboMarksRange2 = "\\u0300-\\u036f";
  var reComboHalfMarksRange2 = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange2 = "\\u20d0-\\u20ff";
  var rsComboRange2 = rsComboMarksRange2 + reComboHalfMarksRange2 + rsComboSymbolsRange2;
  var rsVarRange2 = "\\ufe0e\\ufe0f";
  var rsAstral = "[" + rsAstralRange2 + "]";
  var rsCombo = "[" + rsComboRange2 + "]";
  var rsFitz = "\\ud83c[\\udffb-\\udfff]";
  var rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")";
  var rsNonAstral = "[^" + rsAstralRange2 + "]";
  var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
  var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
  var rsZWJ2 = "\\u200d";
  var reOptMod = rsModifier + "?";
  var rsOptVar = "[" + rsVarRange2 + "]?";
  var rsOptJoin = "(?:" + rsZWJ2 + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*";
  var rsSeq = rsOptVar + reOptMod + rsOptJoin;
  var rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
  var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }
  var unicodeToArray_default = unicodeToArray;

  // node_modules/lodash-es/_stringToArray.js
  function stringToArray(string) {
    return hasUnicode_default(string) ? unicodeToArray_default(string) : asciiToArray_default(string);
  }
  var stringToArray_default = stringToArray;

  // node_modules/lodash-es/_stackClear.js
  function stackClear() {
    this.__data__ = new ListCache_default();
    this.size = 0;
  }
  var stackClear_default = stackClear;

  // node_modules/lodash-es/_stackDelete.js
  function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
  }
  var stackDelete_default = stackDelete;

  // node_modules/lodash-es/_stackGet.js
  function stackGet(key) {
    return this.__data__.get(key);
  }
  var stackGet_default = stackGet;

  // node_modules/lodash-es/_stackHas.js
  function stackHas(key) {
    return this.__data__.has(key);
  }
  var stackHas_default = stackHas;

  // node_modules/lodash-es/_stackSet.js
  var LARGE_ARRAY_SIZE = 200;
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache_default) {
      var pairs = data.__data__;
      if (!Map_default || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache_default(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }
  var stackSet_default = stackSet;

  // node_modules/lodash-es/_Stack.js
  function Stack(entries) {
    var data = this.__data__ = new ListCache_default(entries);
    this.size = data.size;
  }
  Stack.prototype.clear = stackClear_default;
  Stack.prototype["delete"] = stackDelete_default;
  Stack.prototype.get = stackGet_default;
  Stack.prototype.has = stackHas_default;
  Stack.prototype.set = stackSet_default;
  var Stack_default = Stack;

  // node_modules/lodash-es/_baseAssign.js
  function baseAssign(object, source) {
    return object && copyObject_default(source, keys_default(source), object);
  }
  var baseAssign_default = baseAssign;

  // node_modules/lodash-es/_baseAssignIn.js
  function baseAssignIn(object, source) {
    return object && copyObject_default(source, keysIn_default(source), object);
  }
  var baseAssignIn_default = baseAssignIn;

  // node_modules/lodash-es/_cloneBuffer.js
  var freeExports3 = typeof exports == "object" && exports && !exports.nodeType && exports;
  var freeModule3 = freeExports3 && typeof module == "object" && module && !module.nodeType && module;
  var moduleExports3 = freeModule3 && freeModule3.exports === freeExports3;
  var Buffer3 = moduleExports3 ? root_default.Buffer : void 0;
  var allocUnsafe = Buffer3 ? Buffer3.allocUnsafe : void 0;
  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }
  var cloneBuffer_default = cloneBuffer;

  // node_modules/lodash-es/_arrayFilter.js
  function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }
  var arrayFilter_default = arrayFilter;

  // node_modules/lodash-es/stubArray.js
  function stubArray() {
    return [];
  }
  var stubArray_default = stubArray;

  // node_modules/lodash-es/_getSymbols.js
  var objectProto13 = Object.prototype;
  var propertyIsEnumerable2 = objectProto13.propertyIsEnumerable;
  var nativeGetSymbols = Object.getOwnPropertySymbols;
  var getSymbols = !nativeGetSymbols ? stubArray_default : function(object) {
    if (object == null) {
      return [];
    }
    object = Object(object);
    return arrayFilter_default(nativeGetSymbols(object), function(symbol) {
      return propertyIsEnumerable2.call(object, symbol);
    });
  };
  var getSymbols_default = getSymbols;

  // node_modules/lodash-es/_copySymbols.js
  function copySymbols(source, object) {
    return copyObject_default(source, getSymbols_default(source), object);
  }
  var copySymbols_default = copySymbols;

  // node_modules/lodash-es/_getSymbolsIn.js
  var nativeGetSymbols2 = Object.getOwnPropertySymbols;
  var getSymbolsIn = !nativeGetSymbols2 ? stubArray_default : function(object) {
    var result = [];
    while (object) {
      arrayPush_default(result, getSymbols_default(object));
      object = getPrototype_default(object);
    }
    return result;
  };
  var getSymbolsIn_default = getSymbolsIn;

  // node_modules/lodash-es/_copySymbolsIn.js
  function copySymbolsIn(source, object) {
    return copyObject_default(source, getSymbolsIn_default(source), object);
  }
  var copySymbolsIn_default = copySymbolsIn;

  // node_modules/lodash-es/_baseGetAllKeys.js
  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray_default(object) ? result : arrayPush_default(result, symbolsFunc(object));
  }
  var baseGetAllKeys_default = baseGetAllKeys;

  // node_modules/lodash-es/_getAllKeys.js
  function getAllKeys(object) {
    return baseGetAllKeys_default(object, keys_default, getSymbols_default);
  }
  var getAllKeys_default = getAllKeys;

  // node_modules/lodash-es/_getAllKeysIn.js
  function getAllKeysIn(object) {
    return baseGetAllKeys_default(object, keysIn_default, getSymbolsIn_default);
  }
  var getAllKeysIn_default = getAllKeysIn;

  // node_modules/lodash-es/_DataView.js
  var DataView = getNative_default(root_default, "DataView");
  var DataView_default = DataView;

  // node_modules/lodash-es/_Promise.js
  var Promise2 = getNative_default(root_default, "Promise");
  var Promise_default = Promise2;

  // node_modules/lodash-es/_Set.js
  var Set = getNative_default(root_default, "Set");
  var Set_default = Set;

  // node_modules/lodash-es/_getTag.js
  var mapTag2 = "[object Map]";
  var objectTag3 = "[object Object]";
  var promiseTag = "[object Promise]";
  var setTag2 = "[object Set]";
  var weakMapTag2 = "[object WeakMap]";
  var dataViewTag2 = "[object DataView]";
  var dataViewCtorString = toSource_default(DataView_default);
  var mapCtorString = toSource_default(Map_default);
  var promiseCtorString = toSource_default(Promise_default);
  var setCtorString = toSource_default(Set_default);
  var weakMapCtorString = toSource_default(WeakMap_default);
  var getTag = baseGetTag_default;
  if (DataView_default && getTag(new DataView_default(new ArrayBuffer(1))) != dataViewTag2 || Map_default && getTag(new Map_default()) != mapTag2 || Promise_default && getTag(Promise_default.resolve()) != promiseTag || Set_default && getTag(new Set_default()) != setTag2 || WeakMap_default && getTag(new WeakMap_default()) != weakMapTag2) {
    getTag = function(value) {
      var result = baseGetTag_default(value), Ctor = result == objectTag3 ? value.constructor : void 0, ctorString = Ctor ? toSource_default(Ctor) : "";
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag2;
          case mapCtorString:
            return mapTag2;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag2;
          case weakMapCtorString:
            return weakMapTag2;
        }
      }
      return result;
    };
  }
  var getTag_default = getTag;

  // node_modules/lodash-es/_initCloneArray.js
  var objectProto14 = Object.prototype;
  var hasOwnProperty11 = objectProto14.hasOwnProperty;
  function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    if (length && typeof array[0] == "string" && hasOwnProperty11.call(array, "index")) {
      result.index = array.index;
      result.input = array.input;
    }
    return result;
  }
  var initCloneArray_default = initCloneArray;

  // node_modules/lodash-es/_Uint8Array.js
  var Uint8Array2 = root_default.Uint8Array;
  var Uint8Array_default = Uint8Array2;

  // node_modules/lodash-es/_cloneArrayBuffer.js
  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array_default(result).set(new Uint8Array_default(arrayBuffer));
    return result;
  }
  var cloneArrayBuffer_default = cloneArrayBuffer;

  // node_modules/lodash-es/_cloneDataView.js
  function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer_default(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
  }
  var cloneDataView_default = cloneDataView;

  // node_modules/lodash-es/_cloneRegExp.js
  var reFlags = /\w*$/;
  function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
  }
  var cloneRegExp_default = cloneRegExp;

  // node_modules/lodash-es/_cloneSymbol.js
  var symbolProto2 = Symbol_default ? Symbol_default.prototype : void 0;
  var symbolValueOf = symbolProto2 ? symbolProto2.valueOf : void 0;
  function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
  }
  var cloneSymbol_default = cloneSymbol;

  // node_modules/lodash-es/_cloneTypedArray.js
  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer_default(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }
  var cloneTypedArray_default = cloneTypedArray;

  // node_modules/lodash-es/_initCloneByTag.js
  var boolTag2 = "[object Boolean]";
  var dateTag2 = "[object Date]";
  var mapTag3 = "[object Map]";
  var numberTag2 = "[object Number]";
  var regexpTag2 = "[object RegExp]";
  var setTag3 = "[object Set]";
  var stringTag2 = "[object String]";
  var symbolTag2 = "[object Symbol]";
  var arrayBufferTag2 = "[object ArrayBuffer]";
  var dataViewTag3 = "[object DataView]";
  var float32Tag2 = "[object Float32Array]";
  var float64Tag2 = "[object Float64Array]";
  var int8Tag2 = "[object Int8Array]";
  var int16Tag2 = "[object Int16Array]";
  var int32Tag2 = "[object Int32Array]";
  var uint8Tag2 = "[object Uint8Array]";
  var uint8ClampedTag2 = "[object Uint8ClampedArray]";
  var uint16Tag2 = "[object Uint16Array]";
  var uint32Tag2 = "[object Uint32Array]";
  function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch (tag) {
      case arrayBufferTag2:
        return cloneArrayBuffer_default(object);
      case boolTag2:
      case dateTag2:
        return new Ctor(+object);
      case dataViewTag3:
        return cloneDataView_default(object, isDeep);
      case float32Tag2:
      case float64Tag2:
      case int8Tag2:
      case int16Tag2:
      case int32Tag2:
      case uint8Tag2:
      case uint8ClampedTag2:
      case uint16Tag2:
      case uint32Tag2:
        return cloneTypedArray_default(object, isDeep);
      case mapTag3:
        return new Ctor();
      case numberTag2:
      case stringTag2:
        return new Ctor(object);
      case regexpTag2:
        return cloneRegExp_default(object);
      case setTag3:
        return new Ctor();
      case symbolTag2:
        return cloneSymbol_default(object);
    }
  }
  var initCloneByTag_default = initCloneByTag;

  // node_modules/lodash-es/_initCloneObject.js
  function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype_default(object) ? baseCreate_default(getPrototype_default(object)) : {};
  }
  var initCloneObject_default = initCloneObject;

  // node_modules/lodash-es/_baseIsMap.js
  var mapTag4 = "[object Map]";
  function baseIsMap(value) {
    return isObjectLike_default(value) && getTag_default(value) == mapTag4;
  }
  var baseIsMap_default = baseIsMap;

  // node_modules/lodash-es/isMap.js
  var nodeIsMap = nodeUtil_default && nodeUtil_default.isMap;
  var isMap = nodeIsMap ? baseUnary_default(nodeIsMap) : baseIsMap_default;
  var isMap_default = isMap;

  // node_modules/lodash-es/_baseIsSet.js
  var setTag4 = "[object Set]";
  function baseIsSet(value) {
    return isObjectLike_default(value) && getTag_default(value) == setTag4;
  }
  var baseIsSet_default = baseIsSet;

  // node_modules/lodash-es/isSet.js
  var nodeIsSet = nodeUtil_default && nodeUtil_default.isSet;
  var isSet = nodeIsSet ? baseUnary_default(nodeIsSet) : baseIsSet_default;
  var isSet_default = isSet;

  // node_modules/lodash-es/_baseClone.js
  var CLONE_DEEP_FLAG = 1;
  var CLONE_FLAT_FLAG = 2;
  var CLONE_SYMBOLS_FLAG = 4;
  var argsTag3 = "[object Arguments]";
  var arrayTag2 = "[object Array]";
  var boolTag3 = "[object Boolean]";
  var dateTag3 = "[object Date]";
  var errorTag3 = "[object Error]";
  var funcTag3 = "[object Function]";
  var genTag2 = "[object GeneratorFunction]";
  var mapTag5 = "[object Map]";
  var numberTag3 = "[object Number]";
  var objectTag4 = "[object Object]";
  var regexpTag3 = "[object RegExp]";
  var setTag5 = "[object Set]";
  var stringTag3 = "[object String]";
  var symbolTag3 = "[object Symbol]";
  var weakMapTag3 = "[object WeakMap]";
  var arrayBufferTag3 = "[object ArrayBuffer]";
  var dataViewTag4 = "[object DataView]";
  var float32Tag3 = "[object Float32Array]";
  var float64Tag3 = "[object Float64Array]";
  var int8Tag3 = "[object Int8Array]";
  var int16Tag3 = "[object Int16Array]";
  var int32Tag3 = "[object Int32Array]";
  var uint8Tag3 = "[object Uint8Array]";
  var uint8ClampedTag3 = "[object Uint8ClampedArray]";
  var uint16Tag3 = "[object Uint16Array]";
  var uint32Tag3 = "[object Uint32Array]";
  var cloneableTags = {};
  cloneableTags[argsTag3] = cloneableTags[arrayTag2] = cloneableTags[arrayBufferTag3] = cloneableTags[dataViewTag4] = cloneableTags[boolTag3] = cloneableTags[dateTag3] = cloneableTags[float32Tag3] = cloneableTags[float64Tag3] = cloneableTags[int8Tag3] = cloneableTags[int16Tag3] = cloneableTags[int32Tag3] = cloneableTags[mapTag5] = cloneableTags[numberTag3] = cloneableTags[objectTag4] = cloneableTags[regexpTag3] = cloneableTags[setTag5] = cloneableTags[stringTag3] = cloneableTags[symbolTag3] = cloneableTags[uint8Tag3] = cloneableTags[uint8ClampedTag3] = cloneableTags[uint16Tag3] = cloneableTags[uint32Tag3] = true;
  cloneableTags[errorTag3] = cloneableTags[funcTag3] = cloneableTags[weakMapTag3] = false;
  function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) {
      result = object ? customizer(value, key, object, stack) : customizer(value);
    }
    if (result !== void 0) {
      return result;
    }
    if (!isObject_default(value)) {
      return value;
    }
    var isArr = isArray_default(value);
    if (isArr) {
      result = initCloneArray_default(value);
      if (!isDeep) {
        return copyArray_default(value, result);
      }
    } else {
      var tag = getTag_default(value), isFunc = tag == funcTag3 || tag == genTag2;
      if (isBuffer_default(value)) {
        return cloneBuffer_default(value, isDeep);
      }
      if (tag == objectTag4 || tag == argsTag3 || isFunc && !object) {
        result = isFlat || isFunc ? {} : initCloneObject_default(value);
        if (!isDeep) {
          return isFlat ? copySymbolsIn_default(value, baseAssignIn_default(result, value)) : copySymbols_default(value, baseAssign_default(result, value));
        }
      } else {
        if (!cloneableTags[tag]) {
          return object ? value : {};
        }
        result = initCloneByTag_default(value, tag, isDeep);
      }
    }
    stack || (stack = new Stack_default());
    var stacked = stack.get(value);
    if (stacked) {
      return stacked;
    }
    stack.set(value, result);
    if (isSet_default(value)) {
      value.forEach(function(subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
      });
    } else if (isMap_default(value)) {
      value.forEach(function(subValue, key2) {
        result.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
      });
    }
    var keysFunc = isFull ? isFlat ? getAllKeysIn_default : getAllKeys_default : isFlat ? keysIn_default : keys_default;
    var props = isArr ? void 0 : keysFunc(value);
    arrayEach_default(props || value, function(subValue, key2) {
      if (props) {
        key2 = subValue;
        subValue = value[key2];
      }
      assignValue_default(result, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
    });
    return result;
  }
  var baseClone_default = baseClone;

  // node_modules/lodash-es/cloneDeep.js
  var CLONE_DEEP_FLAG2 = 1;
  var CLONE_SYMBOLS_FLAG2 = 4;
  function cloneDeep(value) {
    return baseClone_default(value, CLONE_DEEP_FLAG2 | CLONE_SYMBOLS_FLAG2);
  }
  var cloneDeep_default = cloneDeep;

  // node_modules/lodash-es/_setCacheAdd.js
  var HASH_UNDEFINED3 = "__lodash_hash_undefined__";
  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED3);
    return this;
  }
  var setCacheAdd_default = setCacheAdd;

  // node_modules/lodash-es/_setCacheHas.js
  function setCacheHas(value) {
    return this.__data__.has(value);
  }
  var setCacheHas_default = setCacheHas;

  // node_modules/lodash-es/_SetCache.js
  function SetCache(values2) {
    var index = -1, length = values2 == null ? 0 : values2.length;
    this.__data__ = new MapCache_default();
    while (++index < length) {
      this.add(values2[index]);
    }
  }
  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd_default;
  SetCache.prototype.has = setCacheHas_default;
  var SetCache_default = SetCache;

  // node_modules/lodash-es/_arraySome.js
  function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }
  var arraySome_default = arraySome;

  // node_modules/lodash-es/_cacheHas.js
  function cacheHas(cache, key) {
    return cache.has(key);
  }
  var cacheHas_default = cacheHas;

  // node_modules/lodash-es/_equalArrays.js
  var COMPARE_PARTIAL_FLAG = 1;
  var COMPARE_UNORDERED_FLAG = 2;
  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) {
      return arrStacked == other && othStacked == array;
    }
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache_default() : void 0;
    stack.set(array, other);
    stack.set(other, array);
    while (++index < arrLength) {
      var arrValue = array[index], othValue = other[index];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== void 0) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      if (seen) {
        if (!arraySome_default(other, function(othValue2, othIndex) {
          if (!cacheHas_default(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
  }
  var equalArrays_default = equalArrays;

  // node_modules/lodash-es/_mapToArray.js
  function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }
  var mapToArray_default = mapToArray;

  // node_modules/lodash-es/_setToArray.js
  function setToArray(set2) {
    var index = -1, result = Array(set2.size);
    set2.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }
  var setToArray_default = setToArray;

  // node_modules/lodash-es/_equalByTag.js
  var COMPARE_PARTIAL_FLAG2 = 1;
  var COMPARE_UNORDERED_FLAG2 = 2;
  var boolTag4 = "[object Boolean]";
  var dateTag4 = "[object Date]";
  var errorTag4 = "[object Error]";
  var mapTag6 = "[object Map]";
  var numberTag4 = "[object Number]";
  var regexpTag4 = "[object RegExp]";
  var setTag6 = "[object Set]";
  var stringTag4 = "[object String]";
  var symbolTag4 = "[object Symbol]";
  var arrayBufferTag4 = "[object ArrayBuffer]";
  var dataViewTag5 = "[object DataView]";
  var symbolProto3 = Symbol_default ? Symbol_default.prototype : void 0;
  var symbolValueOf2 = symbolProto3 ? symbolProto3.valueOf : void 0;
  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag5:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;
      case arrayBufferTag4:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array_default(object), new Uint8Array_default(other))) {
          return false;
        }
        return true;
      case boolTag4:
      case dateTag4:
      case numberTag4:
        return eq_default(+object, +other);
      case errorTag4:
        return object.name == other.name && object.message == other.message;
      case regexpTag4:
      case stringTag4:
        return object == other + "";
      case mapTag6:
        var convert = mapToArray_default;
      case setTag6:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG2;
        convert || (convert = setToArray_default);
        if (object.size != other.size && !isPartial) {
          return false;
        }
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG2;
        stack.set(object, other);
        var result = equalArrays_default(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack["delete"](object);
        return result;
      case symbolTag4:
        if (symbolValueOf2) {
          return symbolValueOf2.call(object) == symbolValueOf2.call(other);
        }
    }
    return false;
  }
  var equalByTag_default = equalByTag;

  // node_modules/lodash-es/_equalObjects.js
  var COMPARE_PARTIAL_FLAG3 = 1;
  var objectProto15 = Object.prototype;
  var hasOwnProperty12 = objectProto15.hasOwnProperty;
  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG3, objProps = getAllKeys_default(object), objLength = objProps.length, othProps = getAllKeys_default(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty12.call(other, key))) {
        return false;
      }
    }
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) {
      return objStacked == other && othStacked == object;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key], othValue = other[key];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      }
      if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor, othCtor = other.constructor;
      if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
  }
  var equalObjects_default = equalObjects;

  // node_modules/lodash-es/_baseIsEqualDeep.js
  var COMPARE_PARTIAL_FLAG4 = 1;
  var argsTag4 = "[object Arguments]";
  var arrayTag3 = "[object Array]";
  var objectTag5 = "[object Object]";
  var objectProto16 = Object.prototype;
  var hasOwnProperty13 = objectProto16.hasOwnProperty;
  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray_default(object), othIsArr = isArray_default(other), objTag = objIsArr ? arrayTag3 : getTag_default(object), othTag = othIsArr ? arrayTag3 : getTag_default(other);
    objTag = objTag == argsTag4 ? objectTag5 : objTag;
    othTag = othTag == argsTag4 ? objectTag5 : othTag;
    var objIsObj = objTag == objectTag5, othIsObj = othTag == objectTag5, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer_default(object)) {
      if (!isBuffer_default(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack_default());
      return objIsArr || isTypedArray_default(object) ? equalArrays_default(object, other, bitmask, customizer, equalFunc, stack) : equalByTag_default(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG4)) {
      var objIsWrapped = objIsObj && hasOwnProperty13.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty13.call(other, "__wrapped__");
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack_default());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack_default());
    return equalObjects_default(object, other, bitmask, customizer, equalFunc, stack);
  }
  var baseIsEqualDeep_default = baseIsEqualDeep;

  // node_modules/lodash-es/_baseIsEqual.js
  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObjectLike_default(value) && !isObjectLike_default(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep_default(value, other, bitmask, customizer, baseIsEqual, stack);
  }
  var baseIsEqual_default = baseIsEqual;

  // node_modules/lodash-es/_baseIsMatch.js
  var COMPARE_PARTIAL_FLAG5 = 1;
  var COMPARE_UNORDERED_FLAG3 = 2;
  function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) {
      return !length;
    }
    object = Object(object);
    while (index--) {
      var data = matchData[index];
      if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
        return false;
      }
    }
    while (++index < length) {
      data = matchData[index];
      var key = data[0], objValue = object[key], srcValue = data[1];
      if (noCustomizer && data[2]) {
        if (objValue === void 0 && !(key in object)) {
          return false;
        }
      } else {
        var stack = new Stack_default();
        if (customizer) {
          var result = customizer(objValue, srcValue, key, object, source, stack);
        }
        if (!(result === void 0 ? baseIsEqual_default(srcValue, objValue, COMPARE_PARTIAL_FLAG5 | COMPARE_UNORDERED_FLAG3, customizer, stack) : result)) {
          return false;
        }
      }
    }
    return true;
  }
  var baseIsMatch_default = baseIsMatch;

  // node_modules/lodash-es/_isStrictComparable.js
  function isStrictComparable(value) {
    return value === value && !isObject_default(value);
  }
  var isStrictComparable_default = isStrictComparable;

  // node_modules/lodash-es/_getMatchData.js
  function getMatchData(object) {
    var result = keys_default(object), length = result.length;
    while (length--) {
      var key = result[length], value = object[key];
      result[length] = [key, value, isStrictComparable_default(value)];
    }
    return result;
  }
  var getMatchData_default = getMatchData;

  // node_modules/lodash-es/_matchesStrictComparable.js
  function matchesStrictComparable(key, srcValue) {
    return function(object) {
      if (object == null) {
        return false;
      }
      return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
    };
  }
  var matchesStrictComparable_default = matchesStrictComparable;

  // node_modules/lodash-es/_baseMatches.js
  function baseMatches(source) {
    var matchData = getMatchData_default(source);
    if (matchData.length == 1 && matchData[0][2]) {
      return matchesStrictComparable_default(matchData[0][0], matchData[0][1]);
    }
    return function(object) {
      return object === source || baseIsMatch_default(object, source, matchData);
    };
  }
  var baseMatches_default = baseMatches;

  // node_modules/lodash-es/_baseHasIn.js
  function baseHasIn(object, key) {
    return object != null && key in Object(object);
  }
  var baseHasIn_default = baseHasIn;

  // node_modules/lodash-es/_hasPath.js
  function hasPath(object, path, hasFunc) {
    path = castPath_default(path, object);
    var index = -1, length = path.length, result = false;
    while (++index < length) {
      var key = toKey_default(path[index]);
      if (!(result = object != null && hasFunc(object, key))) {
        break;
      }
      object = object[key];
    }
    if (result || ++index != length) {
      return result;
    }
    length = object == null ? 0 : object.length;
    return !!length && isLength_default(length) && isIndex_default(key, length) && (isArray_default(object) || isArguments_default(object));
  }
  var hasPath_default = hasPath;

  // node_modules/lodash-es/hasIn.js
  function hasIn(object, path) {
    return object != null && hasPath_default(object, path, baseHasIn_default);
  }
  var hasIn_default = hasIn;

  // node_modules/lodash-es/_baseMatchesProperty.js
  var COMPARE_PARTIAL_FLAG6 = 1;
  var COMPARE_UNORDERED_FLAG4 = 2;
  function baseMatchesProperty(path, srcValue) {
    if (isKey_default(path) && isStrictComparable_default(srcValue)) {
      return matchesStrictComparable_default(toKey_default(path), srcValue);
    }
    return function(object) {
      var objValue = get_default(object, path);
      return objValue === void 0 && objValue === srcValue ? hasIn_default(object, path) : baseIsEqual_default(srcValue, objValue, COMPARE_PARTIAL_FLAG6 | COMPARE_UNORDERED_FLAG4);
    };
  }
  var baseMatchesProperty_default = baseMatchesProperty;

  // node_modules/lodash-es/_baseProperty.js
  function baseProperty(key) {
    return function(object) {
      return object == null ? void 0 : object[key];
    };
  }
  var baseProperty_default = baseProperty;

  // node_modules/lodash-es/_basePropertyDeep.js
  function basePropertyDeep(path) {
    return function(object) {
      return baseGet_default(object, path);
    };
  }
  var basePropertyDeep_default = basePropertyDeep;

  // node_modules/lodash-es/property.js
  function property(path) {
    return isKey_default(path) ? baseProperty_default(toKey_default(path)) : basePropertyDeep_default(path);
  }
  var property_default = property;

  // node_modules/lodash-es/_baseIteratee.js
  function baseIteratee(value) {
    if (typeof value == "function") {
      return value;
    }
    if (value == null) {
      return identity_default;
    }
    if (typeof value == "object") {
      return isArray_default(value) ? baseMatchesProperty_default(value[0], value[1]) : baseMatches_default(value);
    }
    return property_default(value);
  }
  var baseIteratee_default = baseIteratee;

  // node_modules/lodash-es/_arrayAggregator.js
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }
  var arrayAggregator_default = arrayAggregator;

  // node_modules/lodash-es/_createBaseFor.js
  function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
      var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
      while (length--) {
        var key = props[fromRight ? length : ++index];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }
  var createBaseFor_default = createBaseFor;

  // node_modules/lodash-es/_baseFor.js
  var baseFor = createBaseFor_default();
  var baseFor_default = baseFor;

  // node_modules/lodash-es/_baseForOwn.js
  function baseForOwn(object, iteratee) {
    return object && baseFor_default(object, iteratee, keys_default);
  }
  var baseForOwn_default = baseForOwn;

  // node_modules/lodash-es/_createBaseEach.js
  function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
      if (collection == null) {
        return collection;
      }
      if (!isArrayLike_default(collection)) {
        return eachFunc(collection, iteratee);
      }
      var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
      while (fromRight ? index-- : ++index < length) {
        if (iteratee(iterable[index], index, iterable) === false) {
          break;
        }
      }
      return collection;
    };
  }
  var createBaseEach_default = createBaseEach;

  // node_modules/lodash-es/_baseEach.js
  var baseEach = createBaseEach_default(baseForOwn_default);
  var baseEach_default = baseEach;

  // node_modules/lodash-es/_baseAggregator.js
  function baseAggregator(collection, setter, iteratee, accumulator) {
    baseEach_default(collection, function(value, key, collection2) {
      setter(accumulator, value, iteratee(value), collection2);
    });
    return accumulator;
  }
  var baseAggregator_default = baseAggregator;

  // node_modules/lodash-es/_createAggregator.js
  function createAggregator(setter, initializer) {
    return function(collection, iteratee) {
      var func = isArray_default(collection) ? arrayAggregator_default : baseAggregator_default, accumulator = initializer ? initializer() : {};
      return func(collection, setter, baseIteratee_default(iteratee, 2), accumulator);
    };
  }
  var createAggregator_default = createAggregator;

  // node_modules/lodash-es/countBy.js
  var objectProto17 = Object.prototype;
  var hasOwnProperty14 = objectProto17.hasOwnProperty;
  var countBy = createAggregator_default(function(result, value, key) {
    if (hasOwnProperty14.call(result, key)) {
      ++result[key];
    } else {
      baseAssignValue_default(result, key, 1);
    }
  });
  var countBy_default = countBy;

  // node_modules/lodash-es/now.js
  var now = function() {
    return root_default.Date.now();
  };
  var now_default = now;

  // node_modules/lodash-es/debounce.js
  var FUNC_ERROR_TEXT4 = "Expected a function";
  var nativeMax2 = Math.max;
  var nativeMin = Math.min;
  function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT4);
    }
    wait = toNumber_default(wait) || 0;
    if (isObject_default(options)) {
      leading = !!options.leading;
      maxing = "maxWait" in options;
      maxWait = maxing ? nativeMax2(toNumber_default(options.maxWait) || 0, wait) : maxWait;
      trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
      var args = lastArgs, thisArg = lastThis;
      lastArgs = lastThis = void 0;
      lastInvokeTime = time;
      result = func.apply(thisArg, args);
      return result;
    }
    function leadingEdge(time) {
      lastInvokeTime = time;
      timerId = setTimeout(timerExpired, wait);
      return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
      var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
      return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
      var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
      return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
      var time = now_default();
      if (shouldInvoke(time)) {
        return trailingEdge(time);
      }
      timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
      timerId = void 0;
      if (trailing && lastArgs) {
        return invokeFunc(time);
      }
      lastArgs = lastThis = void 0;
      return result;
    }
    function cancel() {
      if (timerId !== void 0) {
        clearTimeout(timerId);
      }
      lastInvokeTime = 0;
      lastArgs = lastCallTime = lastThis = timerId = void 0;
    }
    function flush() {
      return timerId === void 0 ? result : trailingEdge(now_default());
    }
    function debounced() {
      var time = now_default(), isInvoking = shouldInvoke(time);
      lastArgs = arguments;
      lastThis = this;
      lastCallTime = time;
      if (isInvoking) {
        if (timerId === void 0) {
          return leadingEdge(lastCallTime);
        }
        if (maxing) {
          clearTimeout(timerId);
          timerId = setTimeout(timerExpired, wait);
          return invokeFunc(lastCallTime);
        }
      }
      if (timerId === void 0) {
        timerId = setTimeout(timerExpired, wait);
      }
      return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
  }
  var debounce_default = debounce;

  // node_modules/lodash-es/isArrayLikeObject.js
  function isArrayLikeObject(value) {
    return isObjectLike_default(value) && isArrayLike_default(value);
  }
  var isArrayLikeObject_default = isArrayLikeObject;

  // node_modules/lodash-es/_arrayIncludesWith.js
  function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }
  var arrayIncludesWith_default = arrayIncludesWith;

  // node_modules/lodash-es/_baseDifference.js
  var LARGE_ARRAY_SIZE2 = 200;
  function baseDifference(array, values2, iteratee, comparator) {
    var index = -1, includes = arrayIncludes_default, isCommon = true, length = array.length, result = [], valuesLength = values2.length;
    if (!length) {
      return result;
    }
    if (iteratee) {
      values2 = arrayMap_default(values2, baseUnary_default(iteratee));
    }
    if (comparator) {
      includes = arrayIncludesWith_default;
      isCommon = false;
    } else if (values2.length >= LARGE_ARRAY_SIZE2) {
      includes = cacheHas_default;
      isCommon = false;
      values2 = new SetCache_default(values2);
    }
    outer:
      while (++index < length) {
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values2[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        } else if (!includes(values2, computed, comparator)) {
          result.push(value);
        }
      }
    return result;
  }
  var baseDifference_default = baseDifference;

  // node_modules/lodash-es/difference.js
  var difference = baseRest_default(function(array, values2) {
    return isArrayLikeObject_default(array) ? baseDifference_default(array, baseFlatten_default(values2, 1, isArrayLikeObject_default, true)) : [];
  });
  var difference_default = difference;

  // node_modules/lodash-es/last.js
  function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : void 0;
  }
  var last_default = last;

  // node_modules/lodash-es/_castFunction.js
  function castFunction(value) {
    return typeof value == "function" ? value : identity_default;
  }
  var castFunction_default = castFunction;

  // node_modules/lodash-es/_baseFindKey.js
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection2) {
      if (predicate(value, key, collection2)) {
        result = key;
        return false;
      }
    });
    return result;
  }
  var baseFindKey_default = baseFindKey;

  // node_modules/lodash-es/findKey.js
  function findKey(object, predicate) {
    return baseFindKey_default(object, baseIteratee_default(predicate, 3), baseForOwn_default);
  }
  var findKey_default = findKey;

  // node_modules/lodash-es/_baseMap.js
  function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike_default(collection) ? Array(collection.length) : [];
    baseEach_default(collection, function(value, key, collection2) {
      result[++index] = iteratee(value, key, collection2);
    });
    return result;
  }
  var baseMap_default = baseMap;

  // node_modules/lodash-es/groupBy.js
  var objectProto18 = Object.prototype;
  var hasOwnProperty15 = objectProto18.hasOwnProperty;
  var groupBy = createAggregator_default(function(result, value, key) {
    if (hasOwnProperty15.call(result, key)) {
      result[key].push(value);
    } else {
      baseAssignValue_default(result, key, [value]);
    }
  });
  var groupBy_default = groupBy;

  // node_modules/lodash-es/_baseGt.js
  function baseGt(value, other) {
    return value > other;
  }
  var baseGt_default = baseGt;

  // node_modules/lodash-es/_baseValues.js
  function baseValues(object, props) {
    return arrayMap_default(props, function(key) {
      return object[key];
    });
  }
  var baseValues_default = baseValues;

  // node_modules/lodash-es/values.js
  function values(object) {
    return object == null ? [] : baseValues_default(object, keys_default(object));
  }
  var values_default = values;

  // node_modules/lodash-es/_baseIntersection.js
  var nativeMin2 = Math.min;
  function baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? arrayIncludesWith_default : arrayIncludes_default, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while (othIndex--) {
      var array = arrays[othIndex];
      if (othIndex && iteratee) {
        array = arrayMap_default(array, baseUnary_default(iteratee));
      }
      maxLength = nativeMin2(array.length, maxLength);
      caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache_default(othIndex && array) : void 0;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? cacheHas_default(seen, computed) : includes(result, computed, comparator))) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache ? cacheHas_default(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
    return result;
  }
  var baseIntersection_default = baseIntersection;

  // node_modules/lodash-es/_castArrayLikeObject.js
  function castArrayLikeObject(value) {
    return isArrayLikeObject_default(value) ? value : [];
  }
  var castArrayLikeObject_default = castArrayLikeObject;

  // node_modules/lodash-es/intersection.js
  var intersection = baseRest_default(function(arrays) {
    var mapped = arrayMap_default(arrays, castArrayLikeObject_default);
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection_default(mapped) : [];
  });
  var intersection_default = intersection;

  // node_modules/lodash-es/_baseLt.js
  function baseLt(value, other) {
    return value < other;
  }
  var baseLt_default = baseLt;

  // node_modules/lodash-es/_baseExtremum.js
  function baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while (++index < length) {
      var value = array[index], current = iteratee(value);
      if (current != null && (computed === void 0 ? current === current && !isSymbol_default(current) : comparator(current, computed))) {
        var computed = current, result = value;
      }
    }
    return result;
  }
  var baseExtremum_default = baseExtremum;

  // node_modules/lodash-es/maxBy.js
  function maxBy(array, iteratee) {
    return array && array.length ? baseExtremum_default(array, baseIteratee_default(iteratee, 2), baseGt_default) : void 0;
  }
  var maxBy_default = maxBy;

  // node_modules/lodash-es/minBy.js
  function minBy(array, iteratee) {
    return array && array.length ? baseExtremum_default(array, baseIteratee_default(iteratee, 2), baseLt_default) : void 0;
  }
  var minBy_default = minBy;

  // node_modules/lodash-es/_baseSet.js
  function baseSet(object, path, value, customizer) {
    if (!isObject_default(object)) {
      return object;
    }
    path = castPath_default(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while (nested != null && ++index < length) {
      var key = toKey_default(path[index]), newValue = value;
      if (key === "__proto__" || key === "constructor" || key === "prototype") {
        return object;
      }
      if (index != lastIndex) {
        var objValue = nested[key];
        newValue = customizer ? customizer(objValue, key, nested) : void 0;
        if (newValue === void 0) {
          newValue = isObject_default(objValue) ? objValue : isIndex_default(path[index + 1]) ? [] : {};
        }
      }
      assignValue_default(nested, key, newValue);
      nested = nested[key];
    }
    return object;
  }
  var baseSet_default = baseSet;

  // node_modules/lodash-es/_basePickBy.js
  function basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while (++index < length) {
      var path = paths[index], value = baseGet_default(object, path);
      if (predicate(value, path)) {
        baseSet_default(result, castPath_default(path, object), value);
      }
    }
    return result;
  }
  var basePickBy_default = basePickBy;

  // node_modules/lodash-es/pickBy.js
  function pickBy(object, predicate) {
    if (object == null) {
      return {};
    }
    var props = arrayMap_default(getAllKeysIn_default(object), function(prop) {
      return [prop];
    });
    predicate = baseIteratee_default(predicate);
    return basePickBy_default(object, props, function(value, path) {
      return predicate(value, path[0]);
    });
  }
  var pickBy_default = pickBy;

  // node_modules/lodash-es/once.js
  function once(func) {
    return before_default(2, func);
  }
  var once_default = once;

  // node_modules/lodash-es/_baseSortBy.js
  function baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }
  var baseSortBy_default = baseSortBy;

  // node_modules/lodash-es/_compareAscending.js
  function compareAscending(value, other) {
    if (value !== other) {
      var valIsDefined = value !== void 0, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol_default(value);
      var othIsDefined = other !== void 0, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol_default(other);
      if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
        return 1;
      }
      if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
        return -1;
      }
    }
    return 0;
  }
  var compareAscending_default = compareAscending;

  // node_modules/lodash-es/_compareMultiple.js
  function compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while (++index < length) {
      var result = compareAscending_default(objCriteria[index], othCriteria[index]);
      if (result) {
        if (index >= ordersLength) {
          return result;
        }
        var order = orders[index];
        return result * (order == "desc" ? -1 : 1);
      }
    }
    return object.index - other.index;
  }
  var compareMultiple_default = compareMultiple;

  // node_modules/lodash-es/_baseOrderBy.js
  function baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) {
      iteratees = arrayMap_default(iteratees, function(iteratee) {
        if (isArray_default(iteratee)) {
          return function(value) {
            return baseGet_default(value, iteratee.length === 1 ? iteratee[0] : iteratee);
          };
        }
        return iteratee;
      });
    } else {
      iteratees = [identity_default];
    }
    var index = -1;
    iteratees = arrayMap_default(iteratees, baseUnary_default(baseIteratee_default));
    var result = baseMap_default(collection, function(value, key, collection2) {
      var criteria = arrayMap_default(iteratees, function(iteratee) {
        return iteratee(value);
      });
      return {"criteria": criteria, "index": ++index, "value": value};
    });
    return baseSortBy_default(result, function(object, other) {
      return compareMultiple_default(object, other, orders);
    });
  }
  var baseOrderBy_default = baseOrderBy;

  // node_modules/lodash-es/partition.js
  var partition = createAggregator_default(function(result, value, key) {
    result[key ? 0 : 1].push(value);
  }, function() {
    return [[], []];
  });
  var partition_default = partition;

  // node_modules/lodash-es/_baseIndexOfWith.js
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }
  var baseIndexOfWith_default = baseIndexOfWith;

  // node_modules/lodash-es/_basePullAll.js
  var arrayProto2 = Array.prototype;
  var splice2 = arrayProto2.splice;
  function basePullAll(array, values2, iteratee, comparator) {
    var indexOf = comparator ? baseIndexOfWith_default : baseIndexOf_default, index = -1, length = values2.length, seen = array;
    if (array === values2) {
      values2 = copyArray_default(values2);
    }
    if (iteratee) {
      seen = arrayMap_default(array, baseUnary_default(iteratee));
    }
    while (++index < length) {
      var fromIndex = 0, value = values2[index], computed = iteratee ? iteratee(value) : value;
      while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
        if (seen !== array) {
          splice2.call(seen, fromIndex, 1);
        }
        splice2.call(array, fromIndex, 1);
      }
    }
    return array;
  }
  var basePullAll_default = basePullAll;

  // node_modules/lodash-es/pullAll.js
  function pullAll(array, values2) {
    return array && array.length && values2 && values2.length ? basePullAll_default(array, values2) : array;
  }
  var pullAll_default = pullAll;

  // node_modules/lodash-es/pull.js
  var pull = baseRest_default(pullAll_default);
  var pull_default = pull;

  // node_modules/lodash-es/_baseRandom.js
  var nativeFloor = Math.floor;
  var nativeRandom = Math.random;
  function baseRandom(lower, upper) {
    return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
  }
  var baseRandom_default = baseRandom;

  // node_modules/lodash-es/_baseRange.js
  var nativeCeil = Math.ceil;
  var nativeMax3 = Math.max;
  function baseRange(start, end, step, fromRight) {
    var index = -1, length = nativeMax3(nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while (length--) {
      result[fromRight ? length : ++index] = start;
      start += step;
    }
    return result;
  }
  var baseRange_default = baseRange;

  // node_modules/lodash-es/_createRange.js
  function createRange(fromRight) {
    return function(start, end, step) {
      if (step && typeof step != "number" && isIterateeCall_default(start, end, step)) {
        end = step = void 0;
      }
      start = toFinite_default(start);
      if (end === void 0) {
        end = start;
        start = 0;
      } else {
        end = toFinite_default(end);
      }
      step = step === void 0 ? start < end ? 1 : -1 : toFinite_default(step);
      return baseRange_default(start, end, step, fromRight);
    };
  }
  var createRange_default = createRange;

  // node_modules/lodash-es/range.js
  var range = createRange_default();
  var range_default = range;

  // node_modules/lodash-es/_shuffleSelf.js
  function shuffleSelf(array, size) {
    var index = -1, length = array.length, lastIndex = length - 1;
    size = size === void 0 ? length : size;
    while (++index < size) {
      var rand = baseRandom_default(index, lastIndex), value = array[rand];
      array[rand] = array[index];
      array[index] = value;
    }
    array.length = size;
    return array;
  }
  var shuffleSelf_default = shuffleSelf;

  // node_modules/lodash-es/_arrayShuffle.js
  function arrayShuffle(array) {
    return shuffleSelf_default(copyArray_default(array));
  }
  var arrayShuffle_default = arrayShuffle;

  // node_modules/lodash-es/_baseShuffle.js
  function baseShuffle(collection) {
    return shuffleSelf_default(values_default(collection));
  }
  var baseShuffle_default = baseShuffle;

  // node_modules/lodash-es/shuffle.js
  function shuffle(collection) {
    var func = isArray_default(collection) ? arrayShuffle_default : baseShuffle_default;
    return func(collection);
  }
  var shuffle_default = shuffle;

  // node_modules/lodash-es/sortBy.js
  var sortBy = baseRest_default(function(collection, iteratees) {
    if (collection == null) {
      return [];
    }
    var length = iteratees.length;
    if (length > 1 && isIterateeCall_default(collection, iteratees[0], iteratees[1])) {
      iteratees = [];
    } else if (length > 2 && isIterateeCall_default(iteratees[0], iteratees[1], iteratees[2])) {
      iteratees = [iteratees[0]];
    }
    return baseOrderBy_default(collection, baseFlatten_default(iteratees, 1), []);
  });
  var sortBy_default = sortBy;

  // node_modules/lodash-es/throttle.js
  var FUNC_ERROR_TEXT5 = "Expected a function";
  function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT5);
    }
    if (isObject_default(options)) {
      leading = "leading" in options ? !!options.leading : leading;
      trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return debounce_default(func, wait, {
      "leading": leading,
      "maxWait": wait,
      "trailing": trailing
    });
  }
  var throttle_default = throttle;

  // node_modules/lodash-es/times.js
  var MAX_SAFE_INTEGER3 = 9007199254740991;
  var MAX_ARRAY_LENGTH = 4294967295;
  var nativeMin3 = Math.min;
  function times(n, iteratee) {
    n = toInteger_default(n);
    if (n < 1 || n > MAX_SAFE_INTEGER3) {
      return [];
    }
    var index = MAX_ARRAY_LENGTH, length = nativeMin3(n, MAX_ARRAY_LENGTH);
    iteratee = castFunction_default(iteratee);
    n -= MAX_ARRAY_LENGTH;
    var result = baseTimes_default(length, iteratee);
    while (++index < n) {
      iteratee(index);
    }
    return result;
  }
  var times_default = times;

  // node_modules/lodash-es/_charsEndIndex.js
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while (index-- && baseIndexOf_default(chrSymbols, strSymbols[index], 0) > -1) {
    }
    return index;
  }
  var charsEndIndex_default = charsEndIndex;

  // node_modules/lodash-es/_charsStartIndex.js
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while (++index < length && baseIndexOf_default(chrSymbols, strSymbols[index], 0) > -1) {
    }
    return index;
  }
  var charsStartIndex_default = charsStartIndex;

  // node_modules/lodash-es/trim.js
  function trim(string, chars, guard) {
    string = toString_default(string);
    if (string && (guard || chars === void 0)) {
      return baseTrim_default(string);
    }
    if (!string || !(chars = baseToString_default(chars))) {
      return string;
    }
    var strSymbols = stringToArray_default(string), chrSymbols = stringToArray_default(chars), start = charsStartIndex_default(strSymbols, chrSymbols), end = charsEndIndex_default(strSymbols, chrSymbols) + 1;
    return castSlice_default(strSymbols, start, end).join("");
  }
  var trim_default = trim;

  // node_modules/lodash-es/_createSet.js
  var INFINITY4 = 1 / 0;
  var createSet = !(Set_default && 1 / setToArray_default(new Set_default([, -0]))[1] == INFINITY4) ? noop_default : function(values2) {
    return new Set_default(values2);
  };
  var createSet_default = createSet;

  // node_modules/lodash-es/_baseUniq.js
  var LARGE_ARRAY_SIZE3 = 200;
  function baseUniq(array, iteratee, comparator) {
    var index = -1, includes = arrayIncludes_default, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
      isCommon = false;
      includes = arrayIncludesWith_default;
    } else if (length >= LARGE_ARRAY_SIZE3) {
      var set2 = iteratee ? null : createSet_default(array);
      if (set2) {
        return setToArray_default(set2);
      }
      isCommon = false;
      includes = cacheHas_default;
      seen = new SetCache_default();
    } else {
      seen = iteratee ? [] : result;
    }
    outer:
      while (++index < length) {
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        } else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
    return result;
  }
  var baseUniq_default = baseUniq;

  // node_modules/lodash-es/uniq.js
  function uniq(array) {
    return array && array.length ? baseUniq_default(array) : [];
  }
  var uniq_default = uniq;

  // node_modules/lodash-es/without.js
  var without = baseRest_default(function(array, values2) {
    return isArrayLikeObject_default(array) ? baseDifference_default(array, values2) : [];
  });
  var without_default = without;

  // node_modules/lodash-es/_baseXor.js
  function baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) {
      return length ? baseUniq_default(arrays[0]) : [];
    }
    var index = -1, result = Array(length);
    while (++index < length) {
      var array = arrays[index], othIndex = -1;
      while (++othIndex < length) {
        if (othIndex != index) {
          result[index] = baseDifference_default(result[index] || array, arrays[othIndex], iteratee, comparator);
        }
      }
    }
    return baseUniq_default(baseFlatten_default(result, 1), iteratee, comparator);
  }
  var baseXor_default = baseXor;

  // node_modules/lodash-es/xor.js
  var xor = baseRest_default(function(arrays) {
    return baseXor_default(arrayFilter_default(arrays, isArrayLikeObject_default));
  });
  var xor_default = xor;

  // node_modules/lodash-es/_baseZipObject.js
  function baseZipObject(props, values2, assignFunc) {
    var index = -1, length = props.length, valsLength = values2.length, result = {};
    while (++index < length) {
      var value = index < valsLength ? values2[index] : void 0;
      assignFunc(result, props[index], value);
    }
    return result;
  }
  var baseZipObject_default = baseZipObject;

  // node_modules/lodash-es/zipObject.js
  function zipObject(props, values2) {
    return baseZipObject_default(props || [], values2 || [], assignValue_default);
  }
  var zipObject_default = zipObject;

  // src/scenes/gameplay/hints/HintDelay.ts
  var HintDelay;
  (function(HintDelay3) {
    HintDelay3["SHORT"] = "short";
    HintDelay3["LONG"] = "long";
    HintDelay3["OFF"] = "off";
  })(HintDelay || (HintDelay = {}));
  function convertHintDelayToMs(delay) {
    switch (delay) {
      case HintDelay.SHORT:
        return 3e3;
      case HintDelay.LONG:
        return 6e3;
      case HintDelay.OFF:
        return Number.MAX_VALUE;
      default:
        let x = delay;
    }
  }
  var HINT_DELAY_OPTIONS = Object.values(HintDelay);

  // src/GameStore.ts
  var GameStoreKey;
  (function(GameStoreKey2) {
    GameStoreKey2["LANGUAGE"] = "language";
    GameStoreKey2["GRAPHICS_QUALITY"] = "graphics_quality";
    GameStoreKey2["GRAPHICS_QUALITY_MANUALLY"] = "graphics_quality_manually";
    GameStoreKey2["HINT_DELAY"] = "hint_delay";
    GameStoreKey2["MUSIC_MUTED"] = "music_muted";
    GameStoreKey2["SOUND_MUTED"] = "sound_muted";
    GameStoreKey2["LEVELS"] = "levels";
    GameStoreKey2["COMPLETE_TUTORIALS"] = "complete_tutorials";
    GameStoreKey2["EDITOR_ZOOM"] = "editor_zoom";
    GameStoreKey2["BOOSTERS"] = "boosters";
    GameStoreKey2["PREGAME_BOOSTERS"] = "pregame_boosters";
    GameStoreKey2["LIVES"] = "lives";
    GameStoreKey2["LIVES_REFILL_TIMER_START"] = "lives_refill_timestamp";
    GameStoreKey2["LIVES_REFILL_TIMER_DURATION"] = "lives_refill_timer_duration";
    GameStoreKey2["LIVES_UNLIMITED_TIMER_START"] = "lives_unlimited_timestamp";
    GameStoreKey2["LIVES_UNLIMITED_TIMER_DURATION"] = "lives_unlimited_timer_duration";
    GameStoreKey2["COINS"] = "coins";
    GameStoreKey2["PIGGY_BANK_COINS"] = "piggy_bank_coins";
    GameStoreKey2["GIFT_STARS_NUM"] = "gift_stars_num";
    GameStoreKey2["GIFTS_OPENED"] = "gifts_opened";
    GameStoreKey2["WHEEL_LOCKED"] = "wheel_locked";
    GameStoreKey2["WHEEL_RESET_TIMESTAMP"] = "wheel_reset_timestamp";
    GameStoreKey2["GAVE_FEEDBACK"] = "gave_feedback";
    GameStoreKey2["BUILD"] = "build";
    GameStoreKey2["INTERSTITIAL_ADS_WATCHED"] = "interstitial_ads_watched";
    GameStoreKey2["REWARDED_ADS_WATCHED"] = "rewarded_ads_watched";
    GameStoreKey2["SHOP_SPECIAL_OFFER_BOUGHT"] = "shop_special_offer_bought";
    GameStoreKey2["SHOP_ANY_PURCHASE_COMPLETE"] = "shop_any_purchase_complete";
    GameStoreKey2["SHOP_SPECIAL_OFFER_DISPLAY_TS"] = "shop_special_offer_display_ts";
    GameStoreKey2["GREETING_GIFT_OPEN_TS"] = "greeting_gift_open_ts";
    GameStoreKey2["LOGIN_NUM"] = "login_num";
  })(GameStoreKey || (GameStoreKey = {}));
  var GameStoreEvent;
  (function(GameStoreEvent2) {
    GameStoreEvent2["CLEAR"] = "__CLEAR";
    GameStoreEvent2["SAVE"] = "__SAVE";
  })(GameStoreEvent || (GameStoreEvent = {}));
  var GameStore = class extends Phaser.Events.EventEmitter {
    constructor(game, storeName) {
      super();
      this.game = game;
      this.storeName = storeName;
      this.sendSaveErrorToSentry = once_default((error, saveKey) => {
        var _a;
        (_a = this.game.sentry) == null ? void 0 : _a.captureException("Save error", {
          extra: {
            error,
            saveKey
          }
        });
      });
      this.initRuntimeStorage();
    }
    initRuntimeStorage() {
      this._runtimeStorage = new RuntimeStorage();
      this._runtimeStorage.setNamespace(this.storeName);
    }
    initActualStorage() {
      let {primaryStorage, backupStorage} = this.getStorages();
      return primaryStorage().catch(() => backupStorage()).finally(() => {
        var _a, _b, _c, _d;
        let storageType = (_b = (_a = this._storage) == null ? void 0 : _a.type) != null ? _b : "none";
        (_c = this.game.sentry) == null ? void 0 : _c.setTag("storage", storageType);
        (_d = this.game.analytics) == null ? void 0 : _d.sendDesignEvent(`Storage:${storageType}`);
        this.logStorageType(storageType);
      });
    }
    getStorages() {
      let urlParam = UrlParams.get("storage");
      if (urlParam === "idb" || urlParam === "indexedDB" || urlParam === "indexed") {
        return {
          primaryStorage: this.useIndexedDb.bind(this),
          backupStorage: this.useLocalStorage.bind(this)
        };
      }
      return {
        primaryStorage: this.useLocalStorage.bind(this),
        backupStorage: this.useIndexedDb.bind(this)
      };
    }
    useLocalStorage() {
      if (isLocalStorageAvailable() === false) {
        return Promise.reject("localStorage is not available");
      }
      let localStorage2 = new LocalStorageWrapper("Papa Cherry Saga");
      this.setStorage(localStorage2);
      return Promise.resolve();
    }
    useIndexedDb() {
      return __async(this, null, function* () {
        if (isIndexedDbAvailable() === false) {
          return Promise.reject("indexedDB is not available");
        }
        try {
          let idb = new IdbKeyvalWrapper(this.storeName);
          yield idb.init();
          this.setStorage(idb);
          return Promise.resolve();
        } catch (error) {
          return Promise.reject(error);
        }
      });
    }
    setStorage(storage) {
      this._storage = storage;
    }
    logStorageType(storageType) {
      storageType === "none" ? console.warn("Storage: ", storageType) : console.log("Storage:", storageType);
    }
    getValue(key) {
      return this._runtimeStorage.getValue(key);
    }
    getBoolean(key) {
      return this._runtimeStorage.getBoolean(key);
    }
    getNumber(key) {
      return this._runtimeStorage.getNumber(key);
    }
    getObject(key) {
      return this._runtimeStorage.getObject(key);
    }
    saveValue(key, value) {
      var _a;
      (_a = this._storage) == null ? void 0 : _a.saveValue(key, value).catch((error) => {
        var _a2;
        this.sendSaveErrorToSentry(error, key);
        (_a2 = this.game.analytics) == null ? void 0 : _a2.sendError("Storage:Save_Error");
      });
      this._runtimeStorage.saveValue(key, value);
      this.emit(`${GameStoreEvent.SAVE}-${key}`, value);
    }
    changeNumber(key, delta, min = -Number.MAX_VALUE, max = Number.MAX_VALUE) {
      let oldValue = this.getNumber(key);
      let newValue = oldValue + delta;
      newValue = Phaser.Math.Clamp(newValue, min, max);
      this.saveValue(key, newValue);
      return newValue;
    }
    loadInitialValues() {
      return __async(this, null, function* () {
        yield Promise.all([
          this.loadValue(GameStoreKey.LANGUAGE, ""),
          this.loadValue(GameStoreKey.GRAPHICS_QUALITY, GraphicsQuality.HIGH),
          this.loadValue(GameStoreKey.GRAPHICS_QUALITY_MANUALLY, false),
          this.loadValue(GameStoreKey.HINT_DELAY, HintDelay.LONG),
          this.loadValue(GameStoreKey.SOUND_MUTED, false),
          this.loadValue(GameStoreKey.MUSIC_MUTED, false),
          this.loadValue(GameStoreKey.EDITOR_ZOOM, 1),
          this.loadValue(GameStoreKey.PREGAME_BOOSTERS, {}),
          this.loadValue(GameStoreKey.BOOSTERS, {[BoosterType.UNDO]: 2}),
          this.loadValue(GameStoreKey.LEVELS, {}),
          this.loadValue(GameStoreKey.LIVES, window.game.config.initial_lives),
          this.loadValue(GameStoreKey.LIVES_REFILL_TIMER_START, 0),
          this.loadValue(GameStoreKey.LIVES_REFILL_TIMER_DURATION, 0),
          this.loadValue(GameStoreKey.LIVES_UNLIMITED_TIMER_START, 0),
          this.loadValue(GameStoreKey.LIVES_UNLIMITED_TIMER_DURATION, 0),
          this.loadValue(GameStoreKey.COINS, 0),
          this.loadValue(GameStoreKey.PIGGY_BANK_COINS, 0),
          this.loadValue(GameStoreKey.GIFT_STARS_NUM, 0),
          this.loadValue(GameStoreKey.GIFTS_OPENED, 0),
          this.loadValue(GameStoreKey.COMPLETE_TUTORIALS, []),
          this.loadValue(GameStoreKey.WHEEL_LOCKED, false),
          this.loadValue(GameStoreKey.WHEEL_RESET_TIMESTAMP, 0),
          this.loadValue(GameStoreKey.GAVE_FEEDBACK, false),
          this.loadValue(GameStoreKey.BUILD, window.game.config.build_version),
          this.loadValue(GameStoreKey.INTERSTITIAL_ADS_WATCHED, 0),
          this.loadValue(GameStoreKey.REWARDED_ADS_WATCHED, 0),
          this.loadValue(GameStoreKey.SHOP_SPECIAL_OFFER_BOUGHT, false),
          this.loadValue(GameStoreKey.SHOP_ANY_PURCHASE_COMPLETE, false),
          this.loadValue(GameStoreKey.SHOP_SPECIAL_OFFER_DISPLAY_TS, 0),
          this.loadValue(GameStoreKey.GREETING_GIFT_OPEN_TS, 0),
          this.loadValue(GameStoreKey.LOGIN_NUM, 0)
        ]);
      });
    }
    loadValue(key, defaultValue, callback, callbackContext) {
      return __async(this, null, function* () {
        if (!this._storage) {
          this._runtimeStorage.saveValue(key, defaultValue);
          return;
        }
        const cb = callback || this.getLoadCallbackByValueType(defaultValue);
        const cbContext = callbackContext || this._storage;
        const loadedValue = yield cb.call(cbContext, key);
        const value = loadedValue || defaultValue;
        this._runtimeStorage.saveValue(key, value);
      });
    }
    getLoadCallbackByValueType(value) {
      let valueType = typeof value;
      switch (valueType) {
        case "number":
          return this._storage.getNumber;
        case "string":
          return this._storage.getValue;
        case "boolean":
          return this._storage.getBoolean;
        case "object":
          return this._storage.getObject;
        default:
          return this._storage.getValue;
      }
    }
    checkLoadedValues() {
      let keys2 = Object.keys(GameStoreKey).map((key) => {
        return GameStoreKey[key];
      });
      let loadedKeys = Object.keys(this._runtimeStorage.getContent()).map((key) => {
        return key.split("__")[1];
      });
      let diff = xor_default(keys2, loadedKeys);
      if (diff.length > 0) {
        console.warn("Not all saved values were loaded!", diff);
      }
    }
    resetSaveData() {
      return __async(this, null, function* () {
        let lives = this.getNumber(GameStoreKey.LIVES);
        if (lives > this.game.lives.getInitialLivesNum()) {
          this.saveValue(GameStoreKey.LIVES, this.game.lives.getInitialLivesNum());
        }
        this.saveValue(GameStoreKey.PREGAME_BOOSTERS, {});
        this.saveValue(GameStoreKey.BOOSTERS, {});
        this.saveValue(GameStoreKey.LEVELS, {});
        this.saveValue(GameStoreKey.COINS, 0);
        this.saveValue(GameStoreKey.PIGGY_BANK_COINS, 0);
        this.saveValue(GameStoreKey.COMPLETE_TUTORIALS, []);
        this.saveValue(GameStoreKey.GIFT_STARS_NUM, 0);
        this.saveValue(GameStoreKey.GIFTS_OPENED, 0);
        this.saveValue(GameStoreKey.SHOP_SPECIAL_OFFER_BOUGHT, false);
        this.saveValue(GameStoreKey.SHOP_ANY_PURCHASE_COMPLETE, false);
        this.saveValue(GameStoreKey.LIVES_UNLIMITED_TIMER_START, 0);
        this.saveValue(GameStoreKey.LIVES_UNLIMITED_TIMER_DURATION, 0);
        this.saveValue(GameStoreKey.SHOP_SPECIAL_OFFER_DISPLAY_TS, 0);
        this.saveValue(GameStoreKey.GREETING_GIFT_OPEN_TS, 0);
        this.saveValue(GameStoreKey.LOGIN_NUM, 1);
        this.emit(GameStoreEvent.CLEAR, this);
      });
    }
    migrateSaveData() {
      try {
        Object.keys(localStorage).filter((key) => key.includes("Papa Cherry Saga")).forEach((key) => {
          let newKey = key.split("__")[1];
          let oldValue = localStorage.getItem(key);
          let newValue = JSON.parse(oldValue);
          this.saveValue(newKey, newValue);
          localStorage.removeItem(key);
        });
      } catch (error) {
      }
    }
    isLevelComplete(levelNumber) {
      let result = this.getLevelResult(levelNumber);
      return result && result.complete;
    }
    getLevelResult(levelNumber) {
      let allData = this.getObject(GameStoreKey.LEVELS);
      return allData[levelNumber];
    }
    saveLevelResult(levelNumber, data) {
      let allData = this.getObject(GameStoreKey.LEVELS);
      let newData = __spreadValues(__spreadValues({}, allData), {[levelNumber]: data});
      this.saveValue(GameStoreKey.LEVELS, newData);
    }
    removeLevelResult(levelNumber) {
      let allData = this.getObject(GameStoreKey.LEVELS);
      delete allData[levelNumber];
      this.saveValue(GameStoreKey.LEVELS, allData);
    }
    getCompletedLevelNumbers() {
      let levelResults = this.game.store.getObject(GameStoreKey.LEVELS);
      let levelNumbers = Object.keys(levelResults);
      let completedLevelNumbers = levelNumbers.filter((level) => levelResults[level].complete);
      return completedLevelNumbers.map((levelStr) => parseInt(levelStr));
    }
    getCompleteLevelsNum() {
      return this.getCompletedLevelNumbers().length;
    }
    fixLevelResults() {
      this.getCompletedLevelNumbers().forEach((levelNumber) => {
        var _a, _b, _c;
        let result = this.getLevelResult(levelNumber);
        if (result) {
          (_a = result.pregameBoostersUsedNum) != null ? _a : result.pregameBoostersUsedNum = 0;
          (_b = result.boostersUsedNum) != null ? _b : result.boostersUsedNum = 0;
          (_c = result.secondChancesNum) != null ? _c : result.secondChancesNum = 0;
        }
      });
    }
  };

  // src/robowhale/Polyfills.ts
  function callAllMethods(obj, exclude = []) {
    Object.getOwnPropertyNames(obj).forEach((property2) => {
      let isFunction2 = typeof obj[property2] === "function";
      let isExcluded = exclude.includes(property2);
      if (isFunction2 && isExcluded === false) {
        obj[property2]();
      }
    });
  }
  var Polyfills = class {
    static polyfill() {
      callAllMethods(Polyfills, ["polyfill"]);
    }
    static nodeRemove() {
      let arr = [Element, CharacterData, DocumentType];
      let args = [];
      arr.forEach(function(item) {
        if (item) {
          args.push(item.prototype);
        }
      });
      (function(arr2) {
        arr2.forEach(function(item) {
          if (item.hasOwnProperty("remove")) {
            return;
          }
          Object.defineProperty(item, "remove", {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function remove() {
              this.parentNode.removeChild(this);
            }
          });
        });
      })(args);
    }
  };

  // src/robowhale/phaser3/gameObjects/buttons/ButtonEvent.ts
  var ButtonEvent;
  (function(ButtonEvent2) {
    ButtonEvent2["PRESS"] = "button_press";
    ButtonEvent2["RELEASE"] = "button_release";
  })(ButtonEvent || (ButtonEvent = {}));

  // src/robowhale/phaser3/gameObjects/buttons/SimpleButton.ts
  var SimpleButton = class extends Phaser.GameObjects.Image {
    constructor(scene, texture, frame, parent) {
      super(scene, 0, 0, texture, frame);
      this._enabled = true;
      this.originalScale = 1;
      this.areTweensEnabled = true;
      this.checkIfOver = true;
      this.soundKey = "tap";
      this.soundVolume = 1;
      if (parent) {
        parent.add(this);
      } else {
        this.scene.add.existing(this);
      }
      this.setInteractive();
      this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onPointerDown, this);
      this.scene.input.on(Phaser.Input.Events.POINTER_UP, this.onScenePointerUp, this);
      this.input.cursor = "pointer";
    }
    onPointerDown(pointer) {
      this.playPressedTween();
      this.playSound();
      this.emit(ButtonEvent.PRESS, this, pointer);
      this.currentPointer = pointer;
    }
    playPressedTween() {
      if (!this.areTweensEnabled) {
        return;
      }
      this.originalScale = this.scale;
      this.scene.tweens.add({
        targets: this,
        scale: this.scale * 0.9,
        ease: Phaser.Math.Easing.Cubic.Out,
        duration: 50
      });
    }
    playSound() {
      this.scene.audio.play(this.soundKey, {volume: this.soundVolume});
    }
    onScenePointerUp(pointer, objects) {
      if (this.currentPointer && this.currentPointer === pointer) {
        this.currentPointer = null;
        let isPointerOverButton = objects.includes(this);
        if (this.checkIfOver === false || isPointerOverButton) {
          this.onPointerUp();
          this.emit(ButtonEvent.RELEASE, this, pointer);
        }
        this.playReleasedTween();
      }
    }
    playReleasedTween() {
      if (!this.scene) {
        return;
      }
      if (!this.areTweensEnabled) {
        return;
      }
      this.scene.tweens.add({
        targets: this,
        scale: this.originalScale,
        ease: Phaser.Math.Easing.Back.Out,
        duration: 300
      });
    }
    onPointerUp() {
    }
    enableInput() {
      if (this._enabled) {
        return;
      }
      this._enabled = true;
      this.setInteractive();
    }
    disableInput() {
      if (this._enabled === false) {
        return;
      }
      this._enabled = false;
      this.disableInteractive();
    }
    inflateHitArea(x, y) {
      let hitArea = this.input.hitArea;
      if (hitArea && hitArea instanceof Phaser.Geom.Rectangle) {
        Phaser.Geom.Rectangle.Inflate(hitArea, x, y);
      }
    }
    emulatePressEvent(args = []) {
      this.emit(ButtonEvent.PRESS, this, ...args);
    }
    emulateReleaseEvent(args = []) {
      this.emit(ButtonEvent.RELEASE, this, ...args);
    }
    destroy() {
      if (this.scene) {
        this.scene.input.off(Phaser.Input.Events.POINTER_UP, this.onScenePointerUp, this);
      }
      super.destroy();
    }
  };

  // src/robowhale/phaser3/gameObjects/buttons/ToggleButton.ts
  var ToggleButtonState;
  (function(ToggleButtonState2) {
    ToggleButtonState2[ToggleButtonState2["STATE_1"] = 1] = "STATE_1";
    ToggleButtonState2[ToggleButtonState2["STATE_2"] = 2] = "STATE_2";
  })(ToggleButtonState || (ToggleButtonState = {}));
  var ToggleButton = class extends SimpleButton {
    constructor(scene, texture, frame_1, frame_2, parent) {
      super(scene, texture, frame_1, parent);
      this.frame_1 = frame_1;
      this.frame_2 = frame_2;
      this._buttonState = 1;
    }
    onPointerUp() {
      super.onPointerUp();
      this.toggleFrames();
    }
    toggleFrames() {
      this.buttonState = this._buttonState === 1 ? 2 : 1;
    }
    get buttonState() {
      return this._buttonState;
    }
    set buttonState(value) {
      this._buttonState = value;
      this._buttonState === 1 ? this.setFrame(this.frame_1) : this.setFrame(this.frame_2);
    }
  };

  // src/audio/HowlerWrapper.ts
  var import_howler = __toModule(require("howler"));

  // src/audio/GameSoundKey.ts
  var GameSoundKey;
  (function(GameSoundKey2) {
    GameSoundKey2["MUSIC_LOOP"] = "music_loop_short";
    GameSoundKey2["TAP"] = "tap";
    GameSoundKey2["FANCY_TAP"] = "fancy_tap";
    GameSoundKey2["APPLE_COLLECT"] = "apple_collect";
    GameSoundKey2["BOMB_IGNITE"] = "bomb_ignite";
    GameSoundKey2["BOMB"] = "bomb_1";
    GameSoundKey2["STAR_WHOOSH"] = "star_whoosh";
    GameSoundKey2["BOOSTER_WHOOSH"] = "booster_whoosh";
    GameSoundKey2["BOOSTER_LAND"] = "booster_land";
    GameSoundKey2["BOOSTER_CANT_USE"] = "booster_cant";
    GameSoundKey2["BOOSTER_GLOVE"] = "booster_glove_2";
    GameSoundKey2["BOOSTER_LOLLIPOP"] = "booster_lollipop";
    GameSoundKey2["BOOSTER_ROLLING_PIN"] = "booster_piping_bag";
    GameSoundKey2["CANDY_BOTTLE_OPEN"] = "candy_bottle_open";
    GameSoundKey2["CANT_SWAP"] = "cant_swap_1";
    GameSoundKey2["COLOR_CAKE_BITE"] = "color_cake_bite";
    GameSoundKey2["COLOR_CAKE_EXPLODE"] = "color_cake_explode";
    GameSoundKey2["COLOR_CAKE_INFLATE"] = "color_cake_inflate";
    GameSoundKey2["BISCUIT_COLLECT"] = "cookie_collect";
    GameSoundKey2["COOKIE_UNLOCK"] = "cookie_unlock";
    GameSoundKey2["DONUT_BITE"] = "donut_bite";
    GameSoundKey2["DONUT_BOX_CLOSE"] = "donut_box_close";
    GameSoundKey2["DOUBLE_SPHERES_CHARGE"] = "double_spheres_charge";
    GameSoundKey2["DOUBLE_SPHERES_EXPLODE"] = "double_spheres_explode";
    GameSoundKey2["DROP_ITEM_COLLECT"] = "drop_item_collect";
    GameSoundKey2["EXTRA_MOVES"] = "extra_moves";
    GameSoundKey2["GOAL_UPDATE"] = "goal_update_3";
    GameSoundKey2["GOAL_COMPLETE"] = "goal_complete";
    GameSoundKey2["LEVEL_FAILED"] = "level_failed_2";
    GameSoundKey2["LEVEL_ICON_UNLOCK"] = "level_icon_unlock_2";
    GameSoundKey2["LEVEL_PRE_COMPLETE"] = "level_pre_complete_2";
    GameSoundKey2["LEVEL_PRE_COMPLETE_MUSIC"] = "level_pre_complete_music";
    GameSoundKey2["VICTORY"] = "victory";
    GameSoundKey2["LIFE_GRANTED"] = "life_granted_2";
    GameSoundKey2["MATCH_1"] = "match_1";
    GameSoundKey2["MATCH_2"] = "match_2";
    GameSoundKey2["MATCH_3"] = "match_3";
    GameSoundKey2["MATCH_4"] = "match_4";
    GameSoundKey2["MATCH_5"] = "match_5";
    GameSoundKey2["STRIPES_CREATED"] = "stripes_created";
    GameSoundKey2["BOMB_CREATED"] = "bomb_created";
    GameSoundKey2["SPHERE_CREATED"] = "sphere_created";
    GameSoundKey2["MOVES_WARNING"] = "moves_warning";
    GameSoundKey2["OUT_OF_MOVES"] = "out_of_moves";
    GameSoundKey2["POWERUP_FROM_CHEF"] = "powerup_from_chef";
    GameSoundKey2["POWERUP_TO_CHEF"] = "powerup_to_chef";
    GameSoundKey2["STRIPES"] = "stripes_3";
    GameSoundKey2["SUPER_SPHERE"] = "super_sphere";
    GameSoundKey2["SWAP"] = "swap_1";
    GameSoundKey2["SWAP_BACK"] = "swap_back_3";
    GameSoundKey2["UNDO"] = "undo";
    GameSoundKey2["WHEEL_OPEN"] = "wheel_open";
    GameSoundKey2["WHEEL_SPIN_TICK"] = "wheel_spin_tick_2";
    GameSoundKey2["WHEEL_REWARD"] = "wheel_reward";
    GameSoundKey2["SHUFFLE"] = "shuffle_2";
    GameSoundKey2["WHOOSH_1"] = "whoosh_1";
    GameSoundKey2["WHOOSH_2"] = "whoosh_2";
    GameSoundKey2["COIN_ADD"] = "coin_add_5";
    GameSoundKey2["COIN_SPEND"] = "coin_spend";
    GameSoundKey2["TWINKLE_1"] = "twinkle_1";
    GameSoundKey2["TWINKLE_2"] = "twinkle_2";
    GameSoundKey2["TWINKLE_3"] = "twinkle_3";
    GameSoundKey2["TWINKLE_4"] = "twinkle_4";
    GameSoundKey2["GIFT_REVEAL"] = "gift_reveal";
    GameSoundKey2["GIFT_DROP"] = "gift_drop";
    GameSoundKey2["GIFT_EXPLODE"] = "gift_explode";
    GameSoundKey2["GUMMY_COLLECT"] = "gummy_1";
    GameSoundKey2["GUMMY_BLOCK_DROP"] = "gummy_block_drop_3";
    GameSoundKey2["MYSTERY_BOX"] = "mystery_box_1";
    GameSoundKey2["CUPCAKE"] = "cupcake_1";
    GameSoundKey2["CHICK"] = "chick_1";
    GameSoundKey2["GENERATOR"] = "generator_1";
    GameSoundKey2["SHOP_OPEN"] = "shop_open_2";
  })(GameSoundKey || (GameSoundKey = {}));

  // src/GameEnvironment.ts
  var GameEnvironment;
  (function(GameEnvironment2) {
    GameEnvironment2["DEVELOP"] = "develop";
    GameEnvironment2["PRODUCTION"] = "production";
  })(GameEnvironment || (GameEnvironment = {}));

  // src/CacheBuster.ts
  var useCacheBusting = false;
  function initCacheBusters() {
    if (window.environment !== GameEnvironment.PRODUCTION) {
      return;
    }
    if (typeof cacheBusters === "undefined") {
      console.warn("Cache busting data is missing!");
      return;
    }
    if (typeof cacheBustingMethod === "undefined") {
      console.warn("Cache busting method is not set!");
      return;
    }
    useCacheBusting = true;
    patchLoader();
  }
  function patchLoader() {
    let transformUrl2 = (file) => {
      if (typeof file.url === "string") {
        file.url = getCacheBustingUrl(file.url);
      }
    };
    let methodName = Phaser.Utils.String.UUID();
    let loaderProto = Phaser.Loader.LoaderPlugin.prototype;
    loaderProto[methodName] = loaderProto.addFile;
    loaderProto.addFile = function(files) {
      if (Array.isArray(files)) {
        files.forEach((file) => transformUrl2(file));
      } else {
        transformUrl2(files);
      }
      return this[methodName](files);
    };
  }
  function getCacheBustingUrl(originalUrl) {
    if (useCacheBusting) {
      let hash = cacheBusters[originalUrl];
      if (hash) {
        return transformUrl(originalUrl, hash);
      }
      return originalUrl;
    }
    return originalUrl;
  }
  function transformUrl(originalUrl, hash) {
    if (cacheBustingMethod === "filenames") {
      return transformFilename(originalUrl, hash);
    } else {
      return `${originalUrl}?v=${hash}`;
    }
  }
  function transformFilename(originalUrl, hash) {
    let dotIndex = originalUrl.indexOf(".");
    let firstPart = originalUrl.slice(0, dotIndex);
    let lastPart = originalUrl.slice(dotIndex);
    return `${firstPart}.${hash}${lastPart}`;
  }

  // src/audio/HowlerWrapper.ts
  var SoundFormat;
  (function(SoundFormat2) {
    SoundFormat2["MP3"] = "mp3";
    SoundFormat2["WAV"] = "wav";
    SoundFormat2["WEBM"] = "webm";
    SoundFormat2["OGG"] = "ogg";
  })(SoundFormat || (SoundFormat = {}));
  var HowlerWrapperEvent;
  (function(HowlerWrapperEvent2) {
    HowlerWrapperEvent2["SOUND_MUTE_CHANGE"] = "__SOUND_MUTE_CHANGE";
    HowlerWrapperEvent2["MUSIC_MUTE_CHANGE"] = "__MUSIC_MUTE_CHANGE";
  })(HowlerWrapperEvent || (HowlerWrapperEvent = {}));
  var HowlerWrapper = class extends Phaser.Events.EventEmitter {
    constructor(game, options) {
      super();
      this.musicLoopVolume = 0.2;
      this._soundMute = false;
      this._musicMute = false;
      this.wasMuted = false;
      this.game = game;
      this.options = options;
      this.global = import_howler.Howler;
      this.global.autoUnlock = true;
      this.sounds = {};
      if (options.muteTrigger === "hidden") {
        this.game.events.on(Phaser.Core.Events.HIDDEN, this.onPageHidden, this);
        this.game.events.on(Phaser.Core.Events.VISIBLE, this.onPageVisible, this);
      } else {
        this.onPageVisibleDebounced = debounce_default(this.onPageVisible.bind(this), 150);
        this.game.events.on(Phaser.Core.Events.BLUR, this.onPageHidden, this);
        this.game.events.on(Phaser.Core.Events.FOCUS, this.onPageVisibleDebounced);
      }
    }
    onPageHidden() {
      this.suspendAudioContext();
    }
    onPageVisible() {
      this.resumeAudioContext();
    }
    loadSound(loader, key, options) {
      if (this.sounds[key]) {
        console.warn(`Sound ${key} was already loaded!`);
        return loader;
      }
      return loader.rexAwait(key, {
        callback: (onSuccess, onFail) => {
          let howl = this.doLoadSound(key, options);
          howl.on("loaderror", (soundId, error) => onFail(soundId, error));
          howl.on("load", () => onSuccess());
        }
      });
    }
    doLoadSound(key, options) {
      var _a;
      let formats = (_a = options == null ? void 0 : options.formats) != null ? _a : [SoundFormat.MP3];
      let src = formats.map((format) => getCacheBustingUrl(`assets/audio/${key}.${format}`));
      let mute = key === GameSoundKey.MUSIC_LOOP ? this._musicMute : this._soundMute;
      let sound = new import_howler.Howl(__spreadValues({
        src,
        mute
      }, options));
      this.sounds[key] = sound;
      return sound;
    }
    has(key) {
      return !!this.sounds[key];
    }
    get(key) {
      return this.sounds[key];
    }
    play(key, options, playIfLocked = false) {
      if (this.isLocked() && playIfLocked === false) {
        return;
      }
      let sound = this.get(key);
      if (sound === void 0) {
        console.warn("Sound doesn't exist!", key);
        return;
      }
      if (sound.state() !== "loaded") {
        console.warn("Sound is not loaded!", key);
        return sound;
      }
      if (typeof (options == null ? void 0 : options.volume) !== "undefined") {
        sound.volume(options.volume);
      }
      if (typeof (options == null ? void 0 : options.rate) !== "undefined") {
        sound.rate(options.rate);
      }
      if (typeof (options == null ? void 0 : options.seek) !== "undefined") {
        sound.seek(options.seek);
      }
      if (typeof (options == null ? void 0 : options.loop) !== "undefined") {
        sound.loop(options.loop);
      }
      sound.play();
      return sound;
    }
    stop(key, id) {
      let sound = this.get(key);
      if (sound) {
        sound.stop(id);
      }
    }
    playClick(options) {
      return this.play(GameSoundKey.TAP, options, true);
    }
    addMusicLooop() {
      this.musicLoop = this.get(GameSoundKey.MUSIC_LOOP);
      if (!this.musicLoop) {
        return;
      }
      if (this.global.usingWebAudio === false) {
        this.playMusicLoop();
        return;
      }
      this.onAudioUnlocked().then(() => {
        this.playMusicLoop();
      });
    }
    onAudioUnlocked() {
      return new Promise((resolve, reject) => {
        if (this.global._audioUnlocked) {
          return resolve();
        }
        this.musicLoop.once("unlock", () => resolve());
      });
    }
    playMusicLoop() {
      if (!this.musicLoop) {
        return;
      }
      this.musicLoop.play();
      this.musicLoop.mute(this._musicMute);
      this.musicLoop.loop(true);
      this.musicLoop.fade(0, this.musicLoopVolume, 1e3);
    }
    fadeInMusicLoop(duration) {
      var _a;
      (_a = this.musicLoop) == null ? void 0 : _a.fade(0, this.musicLoopVolume, duration);
    }
    fadeOutMusicLoop(duration) {
      var _a;
      (_a = this.musicLoop) == null ? void 0 : _a.fade(this.musicLoop.volume(), 0, duration);
    }
    suspendAudioContext() {
      let audioContext = this.global.ctx;
      if (!audioContext) {
        this.wasMuted = Boolean(this.global._muted);
        this.global.mute(true);
        return Promise.resolve();
      }
      if (audioContext.state !== "running") {
        return Promise.resolve();
      }
      return audioContext.suspend();
    }
    resumeAudioContext() {
      let audioContext = this.global.ctx;
      if (!audioContext) {
        this.global.mute(this.wasMuted);
        return Promise.resolve();
      }
      let state = audioContext.state;
      if (state === "suspended" || state === "interrupted") {
        return audioContext.resume();
      }
      return Promise.resolve();
    }
    isLocked() {
      if (this.global.usingWebAudio === false) {
        return false;
      }
      return !this.global._audioUnlocked;
    }
    set rate(value) {
      Object.values(this.sounds).forEach((sound) => {
        sound.rate(value);
      });
    }
    get musicMute() {
      return this._musicMute;
    }
    set musicMute(value) {
      var _a;
      this._musicMute = value;
      (_a = this.musicLoop) == null ? void 0 : _a.mute(this._musicMute);
      this.emit(HowlerWrapperEvent.MUSIC_MUTE_CHANGE, this, this._musicMute);
    }
    get soundMute() {
      return this._soundMute;
    }
    set soundMute(value) {
      this._soundMute = value;
      Object.values(this.sounds).forEach((sound) => {
        if (sound !== this.musicLoop) {
          sound.mute(this._soundMute);
        }
      });
      this.emit(HowlerWrapperEvent.SOUND_MUTE_CHANGE, this, this._soundMute);
    }
  };

  // src/robowhale/phaser3/gameObjects/buttons/SoundButton.ts
  var SoundButton = class extends SimpleButton {
    constructor(scene, texture, frame_1, frame_2, parent) {
      super(scene, texture, frame_1, parent);
      this.frame_1 = frame_1;
      this.frame_2 = frame_2;
      this.store = this.scene.game.store;
      this.soundManager = this.scene.audio;
      this.soundManager.on(HowlerWrapperEvent.SOUND_MUTE_CHANGE, this.onMuteChange, this);
      this.updateFrame(this.soundManager.soundMute);
    }
    onMuteChange(soundManager, mute) {
      this.updateFrame(mute);
    }
    updateFrame(mute) {
      this.setFrame(mute ? this.frame_2 : this.frame_1);
    }
    onPointerUp() {
      super.onPointerUp();
      this.soundManager.soundMute = !this.soundManager.soundMute;
      this.store.saveValue(GameStoreKey.SOUND_MUTED, this.soundManager.soundMute);
    }
    destroy() {
      this.soundManager.off(HowlerWrapperEvent.SOUND_MUTE_CHANGE, this.onMuteChange, this);
      super.destroy();
    }
  };

  // src/robowhale/phaser3/gameObjects/text/AutosizeText.ts
  var AutosizeText = class extends Phaser.GameObjects.Text {
    constructor(scene, x, y, text, style) {
      super(scene, x, y, text, style);
      this.maxWidth = 0;
      this.maxHeight = 0;
      this.setOrigin(0.5, 0.5);
    }
    setMaxSize(width, height) {
      this.maxWidth = width;
      this.maxHeight = height;
      this.adjustTextSize();
    }
    setText(value) {
      super.setText(value);
      this.adjustTextSize();
      return this;
    }
    adjustTextSize() {
      for (let i = 0; i < 3; i++) {
        this.setWordWrapWidth(this.maxWidth / this.scale, true);
        this.scale = this.maxHeight / this.height;
      }
    }
  };

  // src/robowhale/phaser3/gameObjects/buttons/ComplexButton.ts
  var ComplexButton = class extends Phaser.GameObjects.Container {
    constructor(scene, atlas, frame, parent) {
      super(scene);
      this.soundKey = "tap";
      this.soundVolume = 1;
      this.areTweensEnabled = true;
      this.checkIfOver = true;
      this.originalScale = 1;
      if (parent) {
        parent.add(this);
      } else {
        this.scene.add.existing(this);
      }
      this.name = "button_" + frame;
      this.addBack(atlas, frame);
      this.setSize(this.back.width, this.back.height);
      this.setInteractive();
      this.input.cursor = "pointer";
      this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onPointerDown, this);
      this.scene.input.on(Phaser.Input.Events.POINTER_UP, this.onScenePointerUp, this);
    }
    enableInput() {
      this.setInteractive();
    }
    disableInput() {
      this.disableInteractive();
    }
    addBack(atlas, frame) {
      this.back = this.scene.add.image(0, 0, atlas, frame);
      this.add(this.back);
    }
    onPointerDown(pointer) {
      this.currentPointer = pointer;
      this.playSound();
      this.playPressedTween();
      this.emit(ButtonEvent.PRESS, this, ...Array.from(arguments));
    }
    playSound() {
      this.scene.audio.play(this.soundKey, {volume: this.soundVolume});
    }
    playPressedTween() {
      if (!this.areTweensEnabled) {
        return;
      }
      this.scene.tweens.add({
        targets: this,
        scale: this.originalScale * 0.9,
        ease: Phaser.Math.Easing.Cubic.Out,
        duration: 50
      });
    }
    onScenePointerUp(pointer, objects) {
      if (!this.currentPointer || this.currentPointer !== pointer) {
        return;
      }
      this.currentPointer = null;
      let isPointerOverButton = objects.includes(this);
      if (this.checkIfOver === false || isPointerOverButton) {
        this.onPointerUp();
        this.emit(ButtonEvent.RELEASE, this, ...Array.from(arguments));
      }
      this.playReleasedTween();
    }
    onPointerUp() {
    }
    playReleasedTween() {
      var _a;
      if (this.areTweensEnabled) {
        (_a = this.scene) == null ? void 0 : _a.tweens.add({
          targets: this,
          scale: this.originalScale,
          ease: Phaser.Math.Easing.Back.Out,
          duration: 300
        });
      }
    }
    addIcon(atlasKey, frame, offsetX = 0, offsetY = 0) {
      this.icon = this.scene.make.image({key: atlasKey, frame}, false);
      this.icon.x = offsetX;
      this.icon.y = offsetY;
      this.add(this.icon);
      return this.icon;
    }
    addBitmapText(content, font, fontSize, offsetX = 0, offsetY = 0) {
      this.bitmapText = this.scene.make.bitmapText({
        font,
        size: fontSize,
        text: content,
        add: false
      });
      this.bitmapText.align = Phaser.Display.Align.CENTER;
      this.bitmapText.setOrigin(0.5, 0.5);
      this.bitmapText.x = this.back.x + offsetX;
      this.bitmapText.y = this.back.y + offsetY;
      this.add(this.bitmapText);
      return this.bitmapText;
    }
    addText(content, style, offsetX = 0, offsetY = 0) {
      this.text = this.scene.make.text({
        text: content,
        style
      });
      this.text.setOrigin(0.5, 0.5);
      this.text.x = this.back.x + offsetX;
      this.text.y = this.back.y + offsetY;
      this.add(this.text);
      return this.text;
    }
    inflateHitArea(x, y) {
      let hitArea = this.input.hitArea;
      if (hitArea && hitArea instanceof Phaser.Geom.Rectangle) {
        Phaser.Geom.Rectangle.Inflate(hitArea, x, y);
      }
    }
    emulatePressEvent(args = []) {
      this.emit(ButtonEvent.PRESS, this, ...args);
    }
    emulateReleaseEvent(args = []) {
      this.emit(ButtonEvent.RELEASE, this, ...args);
    }
    preDestroy() {
      var _a;
      (_a = this.scene) == null ? void 0 : _a.input.off(Phaser.Input.Events.POINTER_UP, this.onScenePointerUp, this);
      super.preDestroy();
    }
  };

  // src/robowhale/phaser3/gameObjects/buttons/MusicButton.ts
  var MusicButton = class extends SimpleButton {
    constructor(scene, texture, frame_1, frame_2, parent) {
      super(scene, texture, frame_1, parent);
      this.frame_1 = frame_1;
      this.frame_2 = frame_2;
      this.store = this.scene.game.store;
      this.soundManager = this.scene.audio;
      this.soundManager.on(HowlerWrapperEvent.MUSIC_MUTE_CHANGE, this.onMuteChange, this);
      this.updateFrame(this.soundManager.musicMute);
    }
    onMuteChange(soundManager, mute) {
      this.updateFrame(mute);
    }
    updateFrame(mute) {
      this.setFrame(mute ? this.frame_2 : this.frame_1);
    }
    onPointerUp() {
      super.onPointerUp();
      this.soundManager.musicMute = !this.soundManager.musicMute;
      this.store.saveValue(GameStoreKey.MUSIC_MUTED, this.soundManager.musicMute);
    }
    destroy() {
      this.soundManager.off(HowlerWrapperEvent.MUSIC_MUTE_CHANGE, this.onMuteChange, this);
      super.destroy();
    }
  };

  // src/robowhale/phaser3/Phaser3Extensions.ts
  var Phaser3Extensions = class {
    static extend() {
      callAllMethods(Phaser3Extensions, ["extend"]);
    }
    static extendGroup() {
      Phaser.GameObjects.Group.prototype.createItems = function(quantity) {
        let items = [];
        for (let i = 0; i < quantity; i++) {
          items.push(this.create());
        }
        return items;
      };
    }
    static extendGraphics() {
      Phaser.GameObjects.Graphics.prototype.inverseSlice = function(x, y, radius, startAngle, endAngle, anticlockwise, overshoot) {
        let inverseStartAngle = endAngle;
        let inverseEndAngle = startAngle;
        return this.slice(x, y, radius, inverseStartAngle, inverseEndAngle, anticlockwise, overshoot);
      };
    }
    static extendTweens() {
      Phaser.Tweens.TweenManager.prototype.addYoyoTween = function(config2) {
        var _a;
        let baseValue = (_a = config2.base) != null ? _a : config2.target[config2.property];
        let repeatCounter = 0;
        let _b = config2, {target, property: property2, base, delta} = _b, tweenProps = __objRest(_b, ["target", "property", "base", "delta"]);
        return this.add(__spreadProps(__spreadValues({
          ease: Phaser.Math.Easing.Sine.Out
        }, tweenProps), {
          targets: config2.target,
          yoyo: true,
          [config2.property]: (target2, key) => {
            if (++repeatCounter % 2 === 0) {
              return baseValue - config2.delta;
            } else {
              return baseValue + config2.delta;
            }
          }
        }));
      };
      Phaser.Tweens.TweenManager.prototype.addCircleTween = function(config2) {
        var _a, _b;
        (_a = config2.startAngle) != null ? _a : config2.startAngle = -90;
        (_b = config2.endAngle) != null ? _b : config2.endAngle = config2.startAngle + 360;
        return this.addCounter(__spreadProps(__spreadValues({}, config2), {
          onUpdate: (tween, target, param) => {
            let angle = config2.startAngle + (config2.endAngle - config2.startAngle) * target.value;
            let angleRad = Phaser.Math.DegToRad(angle);
            config2.target.x = config2.centerX + Math.cos(angleRad) * config2.radius;
            config2.target.y = config2.centerY + Math.sin(angleRad) * config2.radius;
            if (config2.onUpdate) {
              config2.onUpdate(tween, target, param);
            }
          }
        }));
      };
      Phaser.Tweens.TweenManager.prototype.addCurveTween = function(config2) {
        var _a;
        let position = new Phaser.Math.Vector2();
        let tangent;
        if (config2.rotateToCurve) {
          tangent = new Phaser.Math.Vector2();
          (_a = config2.rotateOffset) != null ? _a : config2.rotateOffset = 0;
        }
        return this.addCounter(__spreadProps(__spreadValues({}, config2), {
          onUpdate: (tween, target, param) => {
            config2.curve.getPoint(target.value, position);
            config2.target.x = position.x;
            config2.target.y = position.y;
            if (config2.rotateToCurve) {
              config2.curve.getTangent(target.value, tangent);
              config2.target.angle = tangent.angle() * Phaser.Math.RAD_TO_DEG + config2.rotateOffset;
            }
            if (config2.onUpdate) {
              config2.onUpdate(tween, target, param);
            }
          }
        }));
      };
      Phaser.Tweens.TweenManager.prototype.killTweensByProperty = function(target, ...properties) {
        this.getTweensOf(target).filter((tween) => {
          return tween.data.some((data) => properties.includes(data.key));
        }).forEach((tween) => tween.stop());
        return this;
      };
    }
    static addGetGlobalPosition() {
      let getWorldPosition = function(out) {
        let worldMatrix = this.getWorldTransformMatrix();
        out = out != null ? out : {x: 0, y: 0};
        out.x = worldMatrix.tx;
        out.y = worldMatrix.ty;
        return out;
      };
      let getGlobalCenter = function() {
        let center = this.getCenter();
        return this.prepareBoundsOutput(center, true);
      };
      let classes = [
        Phaser.GameObjects.Container,
        Phaser.GameObjects.Image,
        Phaser.GameObjects.Sprite,
        Phaser.GameObjects.Graphics,
        Phaser.GameObjects.Shape,
        Phaser.GameObjects.Text,
        Phaser.GameObjects.BitmapText
      ].forEach((clazz) => {
        clazz.prototype.getWorldPosition = getWorldPosition;
        if (clazz.prototype.hasOwnProperty("getCenter") && clazz.prototype.hasOwnProperty("prepareBoundsOutput")) {
          clazz.prototype.getGlobalCenter = getGlobalCenter;
        }
      });
    }
    static addKillRevive() {
      let kill = function() {
        this.visible = false;
        this.active = false;
      };
      let revive = function() {
        this.visible = true;
        this.active = true;
      };
      let classes = [
        Phaser.GameObjects.RenderTexture,
        Phaser.GameObjects.Container,
        Phaser.GameObjects.Image,
        Phaser.GameObjects.Sprite,
        Phaser.GameObjects.Graphics,
        Phaser.GameObjects.Shape,
        Phaser.GameObjects.Text,
        Phaser.GameObjects.BitmapText,
        Phaser.GameObjects.Particles.ParticleEmitter,
        Phaser.GameObjects.Particles.ParticleEmitterManager
      ].forEach((clazz) => {
        clazz.prototype.kill = kill;
        clazz.prototype.revive = revive;
      });
    }
    static extendContainer() {
      Phaser.GameObjects.Container.prototype.gridAlign = function(options, startIndex, endIndex) {
        if (typeof startIndex === "undefined") {
          startIndex = 0;
        }
        if (typeof endIndex === "undefined") {
          endIndex = this.length;
        }
        let items = this.list.slice(startIndex, endIndex);
        Phaser.Actions.GridAlign(items, options);
        return this;
      };
    }
    static extendAnimationManager() {
      if (typeof Phaser.Animations === "undefined") {
        return;
      }
      let sortByFrameNumbers = (frame_1, frame_2) => {
        let index_1 = getFrameNumber(frame_1);
        let index_2 = getFrameNumber(frame_2);
        return index_1 - index_2;
      };
      let getFrameNumber = (frameName, zeroPad = 4) => {
        return parseInt(frameName.slice(-zeroPad));
      };
      Phaser.Animations.AnimationManager.prototype.getFrameNames = function(atlasKey, prefix) {
        let allFrames = this.game.textures.get(atlasKey).getFrameNames();
        let animationFrameNames = allFrames.filter((frameName) => frameName.includes(prefix)).sort(sortByFrameNumbers);
        return animationFrameNames.map((frameName) => {
          return {
            key: atlasKey,
            frame: frameName
          };
        });
      };
    }
    static extendMath() {
      Phaser.Math.Sign = (value) => {
        return value >= 0 ? 1 : -1;
      };
      Phaser.Math.MapLinear = function(x, a1, a2, b1, b2) {
        return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
      };
    }
    static extendRandomDataGenerator() {
      Phaser.Math.RandomDataGenerator.prototype.bool = function() {
        return this.frac() > 0.5;
      };
      Phaser.Math.RandomDataGenerator.prototype.pickMultiple = function(array, num) {
        num = Math.min(num, array.length);
        let result = [];
        while (result.length < num) {
          let item = this.pick(array);
          if (result.includes(item) === false) {
            result.push(item);
          }
        }
        return result;
      };
      Phaser.Math.RandomDataGenerator.prototype.pickExcept = function(array, exception) {
        let item;
        let safetyCounter = array.length;
        do {
          item = this.pick(array);
        } while (exception === item && --safetyCounter > 0);
        return item;
      };
      Phaser.Math.RandomDataGenerator.prototype.pickExceptMultiple = function(array, exceptions, safetyCounter = 100) {
        let item;
        do {
          item = this.pick(array);
        } while (exceptions.includes(item) && --safetyCounter > 0);
        return item;
      };
    }
    static extendFactory() {
      let factory = Phaser.GameObjects.GameObjectFactory.prototype;
      factory.existingMultiple = function(children) {
        return children.map((child) => this.existing(child));
      };
      factory.button = function(texture, frame, parent) {
        return new SimpleButton(this.scene, texture, frame, parent);
      };
      factory.toggleButton = function(texture, frame_1, frame_2, parent) {
        return new ToggleButton(this.scene, texture, frame_1, frame_2, parent);
      };
      factory.soundButton = function(texture, frame_1, frame_2, parent) {
        return new SoundButton(this.scene, texture, frame_1, frame_2, parent);
      };
      factory.musicButton = function(texture, frame_1, frame_2, parent) {
        return new MusicButton(this.scene, texture, frame_1, frame_2, parent);
      };
      factory.complexButton = function(backTexture, backFrame, parent) {
        return new ComplexButton(this.scene, backTexture, backFrame, parent);
      };
      factory.autoText = function(content, style, parent) {
        let text = new AutosizeText(this.scene, 0, 0, content, style);
        parent ? parent.add(text) : this.scene.add.existing(text);
        return text;
      };
    }
    static addScaleMethods() {
      let hasScale = (object) => {
        return typeof object.setScale !== "undefined";
      };
      Phaser.GameObjects.GameObject.prototype.fitWidth = function(width) {
        if (hasScale(this) === false) {
          return;
        }
        this.setScale(1);
        this.setScale(width / this.width);
      };
      Phaser.GameObjects.GameObject.prototype.fitHeight = function(maxHeight) {
        if (hasScale(this) === false) {
          return;
        }
        this.setScale(Math.min(1, maxHeight / this.height));
      };
      Phaser.GameObjects.GameObject.prototype.fitIn = function(maxWidth, maxHeight) {
        if (hasScale(this) === false) {
          return;
        }
        let scaleX = maxWidth / this.width;
        let scaleY = maxHeight / this.height;
        this.scale = Math.min(1, scaleX, scaleY);
      };
      Phaser.GameObjects.GameObject.prototype.fillWidth = function(maxWidth) {
        if (hasScale(this) === false) {
          return;
        }
        this.setScale(Math.max(1, maxWidth / this.width));
      };
      Phaser.GameObjects.GameObject.prototype.fillHeight = function(maxHeight) {
        if (hasScale(this) === false) {
          return;
        }
        this.setScale(Math.max(1, maxHeight / this.height));
      };
      Phaser.GameObjects.GameObject.prototype.envelop = function(maxWidth, maxHeight) {
        if (hasScale(this) === false) {
          return;
        }
        let scaleX = maxWidth / this.width;
        let scaleY = maxHeight / this.height;
        this.scale = Math.max(scaleX, scaleY);
      };
    }
    static addAlighMethods() {
      Object.defineProperty(Phaser.GameObjects.GameObject.prototype, "top", {
        get: function() {
          return Phaser.Display.Bounds.GetTop(this);
        },
        set: function(value) {
          return Phaser.Display.Bounds.SetTop(this, value);
        }
      });
      Object.defineProperty(Phaser.GameObjects.GameObject.prototype, "right", {
        get: function() {
          return Phaser.Display.Bounds.GetRight(this);
        },
        set: function(value) {
          return Phaser.Display.Bounds.SetRight(this, value);
        }
      });
      Object.defineProperty(Phaser.GameObjects.GameObject.prototype, "bottom", {
        get: function() {
          return Phaser.Display.Bounds.GetBottom(this);
        },
        set: function(value) {
          return Phaser.Display.Bounds.SetBottom(this, value);
        }
      });
      Object.defineProperty(Phaser.GameObjects.GameObject.prototype, "left", {
        get: function() {
          return Phaser.Display.Bounds.GetLeft(this);
        },
        set: function(value) {
          return Phaser.Display.Bounds.SetLeft(this, value);
        }
      });
    }
    static extendLoader() {
      Phaser.Loader.LoaderPlugin.prototype.scriptTag = function(key, url, onSuccess, onFail) {
        return this.rexAwait(key, {
          callback: (_onSuccess, _onFail) => {
            let script = document.createElement("script");
            script.setAttribute("src", url);
            script.setAttribute("type", "text/javascript");
            script.onload = (event) => {
              onSuccess == null ? void 0 : onSuccess(event);
              _onSuccess();
            };
            script.onerror = (event) => {
              onFail == null ? void 0 : onFail(event);
              _onFail();
            };
            document.head.appendChild(script);
          }
        });
      };
      Phaser.Loader.LoaderPlugin.prototype.bitmapFontFromAtlas = function(fontKey, atlasKey, atlasFrame, dataURL, xSpacing, ySpacing) {
        let xmlKey = fontKey + "_data";
        this.xml(xmlKey, dataURL);
        this.once(Phaser.Loader.Events.COMPLETE, () => {
          let wasParsed = Phaser.GameObjects.BitmapText.ParseFromAtlas(this.scene, fontKey, atlasKey, atlasFrame, xmlKey, xSpacing, ySpacing);
          if (wasParsed === false) {
            console.warn(`Can't add bitmap font ${fontKey}`);
          }
        });
        return this;
      };
    }
  };

  // src/robowhale/utils/DeviceUtil.ts
  var DeviceUtil = class {
    static isDesktop() {
      let ua = navigator.userAgent;
      let OS = {
        android: false,
        chromeOS: false,
        cordova: false,
        crosswalk: false,
        desktop: false,
        ejecta: false,
        electron: false,
        iOS: false,
        iOSVersion: 0,
        iPad: false,
        iPhone: false,
        kindle: false,
        linux: false,
        macOS: false,
        node: false,
        nodeWebkit: false,
        pixelRatio: 1,
        webApp: false,
        windows: false,
        windowsPhone: false
      };
      if (/Windows/.test(ua)) {
        OS.windows = true;
      } else if (/Mac OS/.test(ua) && !/like Mac OS/.test(ua)) {
        OS.macOS = true;
      } else if (/Android/.test(ua)) {
        OS.android = true;
      } else if (/Linux/.test(ua)) {
        OS.linux = true;
      } else if (/iP[ao]d|iPhone/i.test(ua)) {
        OS.iOS = true;
        navigator.appVersion.match(/OS (\d+)/);
        OS.iOSVersion = parseInt(RegExp.$1, 10);
        OS.iPhone = ua.toLowerCase().indexOf("iphone") !== -1;
        OS.iPad = ua.toLowerCase().indexOf("ipad") !== -1;
      } else if (/Kindle/.test(ua) || /\bKF[A-Z][A-Z]+/.test(ua) || /Silk.*Mobile Safari/.test(ua)) {
        OS.kindle = true;
      } else if (/CrOS/.test(ua)) {
        OS.chromeOS = true;
      }
      if (/Windows Phone/i.test(ua) || /IEMobile/i.test(ua)) {
        OS.android = false;
        OS.iOS = false;
        OS.macOS = false;
        OS.windows = true;
        OS.windowsPhone = true;
      }
      let silk = /Silk/.test(ua);
      if (OS.windows || OS.macOS || OS.linux && !silk || OS.chromeOS) {
        OS.desktop = true;
      }
      if (OS.windowsPhone || /Windows NT/i.test(ua) && /Touch/i.test(ua)) {
        OS.desktop = false;
      }
      if (OS.macOS && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
        OS.desktop = false;
      }
      return OS.desktop;
    }
  };
  function getDeviceMemory() {
    try {
      if (typeof navigator["deviceMemory"] === "number") {
        return navigator["deviceMemory"] * 1024;
      }
    } catch (error) {
    }
  }

  // src/Config.ts
  var _Config = class {
  };
  var Config = _Config;
  Config.SERVER_URL = "https://robowhale.com/html5/papa-louie-levels/";
  Config.SOURCE_GAME_WIDTH = 750;
  Config.SOURCE_GAME_HEIGHT = 1e3;
  Config.IS_LANDSCAPE = _Config.SOURCE_GAME_WIDTH > _Config.SOURCE_GAME_HEIGHT;
  Config.IS_PORTRAIT = _Config.SOURCE_GAME_HEIGHT >= _Config.SOURCE_GAME_WIDTH;
  Config.GAME_WIDTH = _Config.SOURCE_GAME_WIDTH;
  Config.GAME_HEIGHT = _Config.SOURCE_GAME_HEIGHT;
  Config.HALF_GAME_WIDTH = _Config.GAME_WIDTH * 0.5;
  Config.HALF_GAME_HEIGHT = _Config.GAME_HEIGHT * 0.5;
  Config.ASPECT_RATIO = _Config.SOURCE_GAME_WIDTH / _Config.SOURCE_GAME_HEIGHT;
  Config.ASSETS_SCALE = 1;

  // src/GameConfigCreator.ts
  var RendererType;
  (function(RendererType3) {
    RendererType3["WEBGL"] = "webgl";
    RendererType3["CANVAS"] = "canvas";
  })(RendererType || (RendererType = {}));
  var AudioType;
  (function(AudioType3) {
    AudioType3["NO_AUDIO"] = "no_audio";
    AudioType3["HTML5_AUDIO"] = "html5_audio";
    AudioType3["WEB_AUDIO"] = "web_audio";
  })(AudioType || (AudioType = {}));
  var GameConfigCreator = class {
    static create() {
      return {
        scale: this.getScaleConfig(),
        parent: "canvas-container",
        type: this.getRenderType(),
        fps: {
          deltaHistory: 20
        },
        render: {
          clearBeforeRender: false,
          transparent: false,
          failIfMajorPerformanceCaveat: true,
          maxTextures: this.getMaxTexturesNum()
        },
        banner: {
          background: ["rgba(0,0,255,0.4)"]
        },
        audio: {
          noAudio: true
        },
        plugins: {
          global: [
            {
              key: "rexWebfontLoader",
              plugin: rexwebfontloaderplugin,
              start: true
            },
            {
              key: "rexawaitloaderplugin",
              plugin: rexawaitloaderplugin,
              start: true
            }
          ]
        },
        callbacks: {
          preBoot: this.preBootCallback.bind(this),
          postBoot: this.postBootCallback.bind(this)
        }
      };
    }
    static getMaxTexturesNum() {
      if (UrlParams.has("maxTextures")) {
        return UrlParams.getNumber("maxTextures", 0);
      }
      return void 0;
    }
    static getScaleConfig() {
      return DeviceUtil.isDesktop() ? this.getDesktopScaleConfig() : this.getMobileScaleConfig();
    }
    static getDesktopScaleConfig() {
      let config2 = {
        width: Config.SOURCE_GAME_WIDTH,
        height: Config.SOURCE_GAME_HEIGHT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        mode: Phaser.Scale.FIT
      };
      let useOriginalSize = UrlParams.getBool("originalSize");
      if (useOriginalSize) {
        config2.max = {
          width: Config.SOURCE_GAME_WIDTH,
          height: Config.SOURCE_GAME_HEIGHT
        };
      }
      return config2;
    }
    static getMobileScaleConfig() {
      return {
        width: Config.SOURCE_GAME_WIDTH,
        height: Config.SOURCE_GAME_HEIGHT,
        mode: Phaser.Scale.NONE
      };
    }
    static getRenderType() {
      let canvas = UrlParams.getBool("forceCanvas");
      if (canvas) {
        return Phaser.CANVAS;
      }
      return Phaser.AUTO;
    }
    static preBootCallback(game) {
    }
    static postBootCallback(game) {
    }
  };

  // src/scenes/SceneKey.ts
  var SceneKey;
  (function(SceneKey2) {
    SceneKey2["GLOBAL"] = "GLOBAL";
    SceneKey2["BOOT"] = "BOOT";
    SceneKey2["PRELOADER"] = "PRELOADER";
    SceneKey2["LEVEL_MAP"] = "LEVEL_MAP";
    SceneKey2["GAMEPLAY_ROOT"] = "GAMEPLAY_ROOT";
    SceneKey2["GAMEPLAY"] = "GAMEPLAY";
    SceneKey2["GAMEPLAY_GUI"] = "GAMEPLAY_GUI";
    SceneKey2["LEVEL_MAP_EDITOR"] = "LEVEL_MAP_EDITOR";
    SceneKey2["LEVEL_EDITOR_ROOT"] = "LEVEL_EDITOR_ROOT";
    SceneKey2["LEVEL_EDITOR"] = "LEVEL_EDITOR";
    SceneKey2["LEVEL_EDITOR_GUI"] = "LEVEL_EDITOR_GUI";
  })(SceneKey || (SceneKey = {}));

  // src/robowhale/phaser3/RenderStatsDOM.ts
  var CanvasRenderer = Phaser.Renderer.Canvas.CanvasRenderer;
  var RenderStatsDOM = class {
    constructor(scene) {
      this.scene = scene;
      this.gameLoop = this.scene.game.loop;
      this.renderer = this.scene.game.renderer;
      this.span = document.createElement("span");
      this.span.id = "stats";
      this.span.addEventListener("click", this.toggleVisibility.bind(this));
      document.body.appendChild(this.span);
      this.scene.scale.on(Phaser.Scale.Events.RESIZE, this.onResize, this);
      this.onResize();
    }
    toggleVisibility() {
      if (this.span.style.opacity === "0") {
        this.span.style.opacity = "1";
      } else {
        this.span.style.opacity = "0";
      }
    }
    onResize() {
      if (this.scene.scale.scaleMode === Phaser.Scale.FIT) {
        let canvasBounds = this.scene.scale.canvasBounds;
        this.span.style.left = canvasBounds.left + "px";
      }
    }
    update(delta) {
      this.updateStats(delta);
    }
    updateStats(delta) {
      let fps = `FPS: ${Math.round(this.gameLoop.actualFps)}`;
      let ms = `MS: ${this.gameLoop.delta.toFixed(1)}`;
      let drawCalls = `DC: ${this.getDrawCallsNum()}`;
      let result = `${fps} | ${ms} | ${drawCalls}`;
      this.span.innerText = result;
    }
    getDrawCallsNum() {
      if (this.renderer instanceof CanvasRenderer) {
        return 0;
      } else {
        return this.renderer.textureFlush;
      }
    }
  };

  // src/GameFonts.ts
  var FontWeight;
  (function(FontWeight23) {
    FontWeight23["NORMAL"] = "400";
    FontWeight23["BOLD"] = "700";
  })(FontWeight || (FontWeight = {}));
  var FontFamily;
  (function(FontFamily23) {
    FontFamily23["POETSEN"] = "PoetsenOne";
    FontFamily23["SANS_SERIF"] = "sans-serif";
  })(FontFamily || (FontFamily = {}));
  var WebFonts = class {
  };
  WebFonts.DEFAULT_FAMILY = FontFamily.POETSEN;
  WebFonts.DEFAULT_WEIGHT = FontWeight.NORMAL;
  var BitmapFont;
  (function(BitmapFont3) {
    BitmapFont3["LEVEL_EDITOR_GRID"] = "LEVEL_EDITOR_GRID";
    BitmapFont3["GAME_FIELD_LABELS"] = "GAME_FIELD_LABELS";
    BitmapFont3["LEVEL_ICONS_CLASSIC"] = "LEVEL_ICONS_CLASSIC";
    BitmapFont3["LEVEL_ICONS_HARD"] = "LEVEL_ICONS_HARD";
    BitmapFont3["POPUP_GOAL_LABELS"] = "POPUP_GOAL_LABELS";
    BitmapFont3["PREGAME_BOOSTERS_LABELS"] = "PREGAME_BOOSTERS_LABELS";
    BitmapFont3["TOP_PANEL_GOAL_LABELS"] = "TOP_PANEL_GOAL_LABELS";
    BitmapFont3["MOVES_LABEL"] = "MOVES_LABEL";
    BitmapFont3["LEVEL_MAP_BOTTOM_LABELS"] = "LEVEL_MAP_BOTTOM_LABELS";
    BitmapFont3["LEVEL_MAP_TOP_PANEL"] = "LEVEL_MAP_TOP_PANEL";
    BitmapFont3["LEVELS_EDITOR_LIST"] = "LEVELS_EDITOR_LIST";
    BitmapFont3["POWERUP_CHEF"] = "POWERUP_CHEF";
    BitmapFont3["BOOSTER_LABELS"] = "BOOSTER_LABELS";
    BitmapFont3["SHOP_COINS"] = "SHOP_COINS";
    BitmapFont3["LABELS_POPUPS"] = "LABELS_POPUPS";
    BitmapFont3["LABELS_GAMEPLAY_GUI"] = "LABELS_GAMEPLAY_GUI";
    BitmapFont3["GENERATOR_TURNS"] = "GENERATOR_TURNS";
  })(BitmapFont || (BitmapFont = {}));
  var INFINITY_SIGN = "\u221E";

  // src/robowhale/phaser3/gameObjects/toast/Toast.ts
  var Toast = class extends Phaser.GameObjects.Container {
    constructor(scene, options) {
      super(scene);
      this.name = "toast";
      this.options = options;
      this.addBack();
      this.addText(options.message);
      this.setSize(this.back.width, this.back.height);
      this.setInteractive();
      this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.dismiss, this);
      this.input.cursor = "pointer";
    }
    addBack() {
      this.back = this.scene.add.graphics({
        fillStyle: {
          color: 0,
          alpha: 0.8
        },
        lineStyle: {
          width: 0,
          color: 0,
          alpha: 1
        }
      });
      let width = Config.SOURCE_GAME_WIDTH * 0.7;
      let height = 110;
      this.back.fillRoundedRect(-width / 2, -height / 2, width, height, {tl: 20, bl: 0, br: 0, tr: 20});
      this.back.stroke();
      this.back.width = width;
      this.back.height = height;
      this.add(this.back);
    }
    addText(textContent) {
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "28px",
        color: "#ffffff",
        align: "center",
        padding: {x: 0, y: 4}
      };
      this.text = this.scene.add.text(0, 0, textContent, style);
      this.text.setOrigin(0.5, 0.5);
      this.text.setLineSpacing(0);
      this.text.setWordWrapWidth(this.back.width * 0.85, true);
      this.text.setShadow(0, 3, "rgba(0,0,0,0.5)", 0);
      this.add(this.text);
      this.adjustTextSize();
    }
    adjustTextSize() {
      let maxHeight = this.back.height * 0.8;
      this.text.scale = Math.min(1, maxHeight / this.text.height);
    }
    show(lifespan) {
      let deltaY = 20;
      this.alpha = 0;
      this.y += deltaY;
      this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1,
        y: this.y - deltaY,
        onComplete: this.onShowCompelete.bind(this, lifespan)
      });
    }
    onShowCompelete(lifespan) {
      this.dismissTimerEvent = this.scene.time.delayedCall(lifespan, () => {
        this.dismiss();
      });
    }
    dismiss() {
      var _a, _b;
      (_a = this.dismissTimerEvent) == null ? void 0 : _a.remove();
      (_b = this.scene) == null ? void 0 : _b.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Linear,
        alpha: 0,
        y: "+=15",
        onComplete: this.destroy.bind(this)
      });
    }
    preDestroy() {
      var _a;
      (_a = this.dismissTimerEvent) == null ? void 0 : _a.remove();
      this.scene.tweens.killTweensOf(this);
    }
  };

  // src/robowhale/phaser3/scenes/Pinner.ts
  var Pinner = class {
    constructor() {
      this.pins = new Map();
    }
    pin(obj, x, y, offsetX, offsetY) {
      this.pins.set(obj, {
        obj,
        x: Phaser.Math.Clamp(x, 0, 1),
        y: Phaser.Math.Clamp(y, 0, 1),
        offsetX: offsetX != null ? offsetX : 0,
        offsetY: offsetY != null ? offsetY : 0
      });
    }
    unpin(item) {
      this.pins.delete(item);
    }
    getPin(item) {
      return this.pins.get(item);
    }
    align(item, width, height, scale) {
      let pin = this.getPin(item);
      if (pin) {
        this.usePin(pin, width, height, scale);
      }
    }
    onResize(width, height, scale) {
      this.pins.forEach((pin) => {
        this.usePin(pin, width, height, scale);
      });
    }
    usePin(pin, width, height, scale) {
      pin.obj.x = width * pin.x + pin.offsetX * scale;
      pin.obj.y = height * pin.y + pin.offsetY * scale;
      if (typeof pin.obj.originalX !== "undefined") {
        pin.obj.originalX = pin.obj.x;
      }
      if (typeof pin.obj.originalY !== "undefined") {
        pin.obj.originalY = pin.obj.y;
      }
    }
    destroy() {
      this.pins.clear();
      this.pins = null;
    }
  };

  // src/robowhale/phaser3/gameObjects/container/screen/Screen.ts
  var PhaserScreenEvent;
  (function(PhaserScreenEvent2) {
    PhaserScreenEvent2["SHOW"] = "__SHOW";
    PhaserScreenEvent2["HIDE_START"] = "__HIDE_START";
    PhaserScreenEvent2["HIDE_COMPLETE"] = "__HIDE_COMPLETE";
  })(PhaserScreenEvent || (PhaserScreenEvent = {}));
  var PhaserScreen = class extends Phaser.GameObjects.Container {
    constructor(scene, options) {
      super(scene);
      var _a;
      this.name = (_a = options.name) != null ? _a : "screen";
      this.options = __spreadValues({
        backgroundKey: "__BLACK",
        backgroundAlpha: 0.8,
        backgroundPadding: 4,
        backgroundInteractive: true
      }, options);
      this.pinner = new Pinner();
      this.setSize(Config.SOURCE_GAME_WIDTH, Config.SOURCE_GAME_HEIGHT);
      this.addBackground();
      this.updateScreenSize();
    }
    addBackground() {
      this.background = this.scene.add.image(0, 0, this.options.backgroundKey, this.options.backgroundFrame);
      this.background.alpha = this.options.backgroundAlpha;
      this.background.name = this.name + "_bg";
      this.background.setOrigin(0.5, 0.5);
      this.background.displayWidth = this.width + this.options.backgroundPadding;
      this.background.displayHeight = this.height + this.options.backgroundPadding;
      this.add(this.background);
      if (this.options.backgroundInteractive) {
        this.background.setInteractive();
      }
    }
    updateScreenSize() {
      if (Config.IS_PORTRAIT) {
        this.screenWidth = this.width;
        this.screenHeight = Config.GAME_HEIGHT / this.scale;
      } else {
        this.screenWidth = Config.GAME_WIDTH / this.scale;
        this.screenHeight = this.height;
      }
      this.screenCenter = {x: this.screenWidth / 2, y: this.screenHeight / 2};
    }
    resize() {
      if (Config.IS_PORTRAIT) {
        this.scale = Config.GAME_WIDTH / this.width;
        this.background.displayHeight = (Config.GAME_HEIGHT + this.options.backgroundPadding) / this.scale;
      } else {
        this.scale = Config.GAME_HEIGHT / this.height;
        this.background.displayWidth = (Config.GAME_WIDTH + this.options.backgroundPadding) / this.scale;
      }
      this.updateScreenSize();
      this.pinner.onResize(this.screenWidth, this.screenHeight, 1);
      this.background.x = this.screenCenter.x;
      this.background.y = this.screenCenter.y;
    }
    pin(obj, x, y, offsetX, offsetY) {
      this.pinner.pin(obj, x, y, offsetX, offsetY);
    }
    emitShowEvent(...args) {
      this.emit(PhaserScreenEvent.SHOW, this, ...args);
    }
    emitHideStartEvent(...args) {
      this.emit(PhaserScreenEvent.HIDE_START, this, ...args);
    }
    emitHideCompleteEvent(...args) {
      this.emit(PhaserScreenEvent.HIDE_COMPLETE, this, ...args);
    }
    showBackground(props = {}) {
      var _a, _b, _c;
      this.background.alpha = 0;
      this.scene.tweens.add({
        targets: this.background,
        duration: (_a = props.duration) != null ? _a : 150,
        ease: (_b = props.ease) != null ? _b : Phaser.Math.Easing.Cubic.Out,
        alpha: (_c = props.targetAlpha) != null ? _c : this.options.backgroundAlpha
      });
    }
  };

  // src/robowhale/phaser3/gameObjects/toast/ToastsManager.ts
  var ToastsManager = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "toasts",
        backgroundAlpha: 0,
        backgroundInteractive: false,
        backgroundKey: "level_map",
        backgroundFrame: "black_rect"
      });
      this.toasts = [];
    }
    show(options) {
      this.dismissAll();
      let toast = new Toast(this.scene, options);
      this.toasts.push(toast);
      this.add(toast);
      this.pin(toast, 0.5, 1, 0, -toast.height / 2 + 1);
      this.pinner.align(toast, this.screenWidth, this.screenHeight, 1);
      toast.once(Phaser.GameObjects.Events.DESTROY, this.onToastDestroy, this);
      toast.show(options.lifespan);
    }
    showVideoAdWarning() {
      this.show({
        lifespan: 3e3,
        message: this.getRewardedAdsWarningText()
      });
    }
    getRewardedAdsWarningText() {
      let texts = this.scene.texts;
      let message;
      let language = this.scene.game.texts.language;
      if (language === "ru" || language === "en") {
        message = texts.ads.no_rewarded_ads + " " + texts.ads.adblock_rewarded_ads;
      } else {
        message = texts.ads.no_rewarded_ads;
      }
      return message;
    }
    onToastDestroy(toast) {
      let index = this.toasts.indexOf(toast);
      if (index > -1) {
        this.toasts.splice(index, 1);
        this.pinner.unpin(toast);
      }
    }
    dismissAll() {
      this.toasts.forEach((toast) => toast.dismiss());
    }
    resize() {
      super.resize();
    }
  };

  // src/scenes/global/GlobalSceneDepth.ts
  var GlobalSceneDepth;
  (function(GlobalSceneDepth2) {
    GlobalSceneDepth2[GlobalSceneDepth2["TOASTS"] = 1] = "TOASTS";
    GlobalSceneDepth2[GlobalSceneDepth2["SCENE_TRANSITION"] = 2] = "SCENE_TRANSITION";
    GlobalSceneDepth2[GlobalSceneDepth2["AD_OVERLAY"] = 3] = "AD_OVERLAY";
    GlobalSceneDepth2[GlobalSceneDepth2["PURCHASE_OVERLAY"] = 4] = "PURCHASE_OVERLAY";
  })(GlobalSceneDepth || (GlobalSceneDepth = {}));

  // src/scenes/global/DelayedLoader.ts
  var DelayedLoaderEvent;
  (function(DelayedLoaderEvent2) {
    DelayedLoaderEvent2["GAMEPLAY_ASSETS_READY"] = "__GAMEPLAY_ASSETS_READY";
  })(DelayedLoaderEvent || (DelayedLoaderEvent = {}));
  var DelayedLoader = class extends Phaser.Loader.LoaderPlugin {
    constructor(scene) {
      super(scene);
      this.areGameplayAssetsReady = false;
      this.howler = scene.game.audio;
    }
    startLoading() {
      this.once(Phaser.Loader.Events.COMPLETE, this.onGameplayAssetsLoaded, this);
      this.loadGameplayAssets();
      this.start();
    }
    loadGameplayAssets() {
      this.image("gameplay_bg_1", "assets/graphics/gameplay_bg_1.jpg");
      this.atlas("gameplay", "assets/graphics/gameplay.png", "assets/graphics/gameplay.json");
      this.atlas("gameplay_gui", "assets/graphics/gameplay_gui.png", "assets/graphics/gameplay_gui.json");
      this.bitmapFontFromAtlas(BitmapFont.GAME_FIELD_LABELS, "gameplay", "field_labels", "assets/fonts/bitmap/field_labels.xml");
      this.bitmapFontFromAtlas(BitmapFont.TOP_PANEL_GOAL_LABELS, "gameplay_gui", "top_panel_goal_labels", "assets/fonts/bitmap/top_panel_goal_labels.xml");
      this.bitmapFontFromAtlas(BitmapFont.MOVES_LABEL, "gameplay_gui", "moves_label", "assets/fonts/bitmap/moves_label.xml");
      this.bitmapFontFromAtlas(BitmapFont.POWERUP_CHEF, "gameplay_gui", "powerup_chef_label", "assets/fonts/bitmap/powerup_chef_label.xml");
      this.bitmapFontFromAtlas(BitmapFont.BOOSTER_LABELS, "gameplay_gui", "boosters/booster_labels", "assets/fonts/bitmap/booster_labels.xml");
      this.bitmapFontFromAtlas(BitmapFont.LABELS_GAMEPLAY_GUI, "gameplay_gui", "level_complete/labels/labels", "assets/fonts/bitmap/labels.xml");
      this.bitmapFontFromAtlas(BitmapFont.GENERATOR_TURNS, "gameplay", "generator_turns", "assets/fonts/bitmap/generator_turns.xml");
    }
    onGameplayAssetsLoaded() {
      this.areGameplayAssetsReady = true;
      this.emit(DelayedLoaderEvent.GAMEPLAY_ASSETS_READY, this);
      this.once(Phaser.Loader.Events.COMPLETE, this.onSoundsLoaded, this);
      this.on(Phaser.Loader.Events.FILE_COMPLETE, this.onFileComplete, this);
      this.loadSounds();
      this.start();
    }
    loadSounds() {
      this.loadSound(GameSoundKey.STRIPES_CREATED);
      this.loadSound(GameSoundKey.BOMB_CREATED);
      this.loadSound(GameSoundKey.SPHERE_CREATED);
      this.loadSound(GameSoundKey.FANCY_TAP);
      this.loadSound(GameSoundKey.WHOOSH_1);
      this.loadSound(GameSoundKey.WHOOSH_2);
      this.loadSound(GameSoundKey.BOMB_IGNITE);
      this.loadSound(GameSoundKey.DROP_ITEM_COLLECT);
      this.loadSound(GameSoundKey.APPLE_COLLECT);
      this.loadSound(GameSoundKey.CANDY_BOTTLE_OPEN);
      this.loadSound(GameSoundKey.DONUT_BITE);
      this.loadSound(GameSoundKey.DONUT_BOX_CLOSE);
      this.loadSound(GameSoundKey.COOKIE_UNLOCK);
      this.loadSound(GameSoundKey.COLOR_CAKE_BITE);
      this.loadSound(GameSoundKey.COLOR_CAKE_INFLATE);
      this.loadSound(GameSoundKey.COLOR_CAKE_EXPLODE);
      this.loadSound(GameSoundKey.BISCUIT_COLLECT);
      this.loadSound(GameSoundKey.SHUFFLE);
      this.loadSound(GameSoundKey.STAR_WHOOSH);
      this.loadSound(GameSoundKey.BOOSTER_WHOOSH);
      this.loadSound(GameSoundKey.BOOSTER_LAND);
      this.loadSound(GameSoundKey.BOOSTER_CANT_USE, {volume: 0.33});
      this.loadSound(GameSoundKey.BOOSTER_GLOVE);
      this.loadSound(GameSoundKey.BOOSTER_ROLLING_PIN);
      this.loadSound(GameSoundKey.BOOSTER_LOLLIPOP);
      this.loadSound(GameSoundKey.UNDO);
      this.loadSound(GameSoundKey.DOUBLE_SPHERES_CHARGE);
      this.loadSound(GameSoundKey.DOUBLE_SPHERES_EXPLODE);
      this.loadSound(GameSoundKey.EXTRA_MOVES);
      this.loadSound(GameSoundKey.VICTORY);
      this.loadSound(GameSoundKey.LEVEL_FAILED);
      this.loadSound(GameSoundKey.LEVEL_ICON_UNLOCK);
      this.loadSound(GameSoundKey.COIN_ADD);
      this.loadSound(GameSoundKey.COIN_SPEND);
      this.loadSound(GameSoundKey.LEVEL_PRE_COMPLETE);
      this.loadSound(GameSoundKey.LEVEL_PRE_COMPLETE_MUSIC);
      this.loadSound(GameSoundKey.LIFE_GRANTED);
      this.loadSound(GameSoundKey.MOVES_WARNING);
      this.loadSound(GameSoundKey.OUT_OF_MOVES);
      this.loadSound(GameSoundKey.POWERUP_FROM_CHEF);
      this.loadSound(GameSoundKey.POWERUP_TO_CHEF);
      this.loadSound(GameSoundKey.WHEEL_OPEN);
      this.loadSound(GameSoundKey.WHEEL_SPIN_TICK);
      this.loadSound(GameSoundKey.WHEEL_REWARD);
      this.loadSound(GameSoundKey.TWINKLE_1);
      this.loadSound(GameSoundKey.TWINKLE_2);
      this.loadSound(GameSoundKey.TWINKLE_3);
      this.loadSound(GameSoundKey.TWINKLE_4);
      this.loadSound(GameSoundKey.GIFT_REVEAL);
      this.loadSound(GameSoundKey.GIFT_EXPLODE);
      this.loadSound(GameSoundKey.GIFT_DROP);
      this.loadSound(GameSoundKey.GUMMY_COLLECT);
      this.loadSound(GameSoundKey.GUMMY_BLOCK_DROP);
      this.loadSound(GameSoundKey.MYSTERY_BOX);
      this.loadSound(GameSoundKey.CUPCAKE);
      this.loadSound(GameSoundKey.GENERATOR);
      this.loadSound(GameSoundKey.MUSIC_LOOP);
    }
    loadSound(key, options) {
      this.howler.loadSound(this, key, options);
    }
    onFileComplete(key) {
      if (key === GameSoundKey.MUSIC_LOOP) {
        this.scene.audio.addMusicLooop();
      }
    }
    onSoundsLoaded() {
    }
  };

  // src/ads/overlay/AdOverlaySpinner.ts
  var AdOverlaySpinner = class extends Phaser.GameObjects.Container {
    constructor(scene, options, parent) {
      super(scene);
      if (parent) {
        parent.add(this);
      } else {
        scene.add.existing(this);
      }
      this.options = options;
      this.addDots();
    }
    addDots() {
      let textureKey = "spinner_dot_" + Phaser.Math.RND.uuid();
      let graphics = this.scene.make.graphics({fillStyle: {color: 16777215}}, false);
      graphics.fillCircle(this.options.dotRadius, this.options.dotRadius, this.options.dotRadius);
      graphics.generateTexture(textureKey, this.options.dotRadius * 2, this.options.dotRadius * 2);
      graphics.destroy();
      this.dots = times_default(this.options.dotsNum, (index) => {
        let dot = this.scene.add.image(0, 0, textureKey);
        dot.displayOriginY = this.options.radius;
        dot.angle = index * 16;
        dot.originalAngle = dot.angle;
        this.add(dot);
        return dot;
      });
    }
    startAnimation() {
      this.dots.forEach((dot) => {
        dot.angle = dot.originalAngle;
      });
      this.scene.tweens.add({
        targets: this.dots.slice().reverse(),
        duration: 1800,
        ease: Phaser.Math.Easing.Cubic.InOut,
        angle: "+=360",
        repeat: -1,
        repeatDelay: 0,
        delay: this.scene.tweens.stagger(33)
      });
    }
    stopAnimation() {
      this.scene.tweens.killTweensOf(this.dots);
    }
  };

  // src/ads/overlay/AdTimer.ts
  var AdTimer = class extends Phaser.GameObjects.Text {
    constructor(scene) {
      super(scene, 0, 0, "0", {
        fontFamily: "Arial",
        fontSize: "40px",
        color: "#ffffff",
        align: "center"
      });
    }
  };

  // src/ads/AdsHelper.ts
  var AdType;
  (function(AdType2) {
    AdType2["INTERSTITIAL"] = "interstitial";
    AdType2["REWARDED"] = "rewarded";
  })(AdType || (AdType = {}));
  var AdsHelper = class extends Phaser.Events.EventEmitter {
    constructor(game, options) {
      super();
      this.adInProgress = false;
      this.options = options;
      this.game = game;
    }
    onBeforeAdStart(adType) {
      if (this.adInProgress) {
        return Promise.reject(`${adType} ad in progress`);
      }
      this.adInProgress = true;
      this.disableInput();
      this.showAdOverlay(adType);
      return this.mute();
    }
    disableInput() {
      if (this.options.disableInput === false) {
        return;
      }
      this.wasInputEnabled = this.game.input.enabled;
      this.game.input.enabled = false;
    }
    showAdOverlay(adType) {
      if (!this.adOverlay) {
        return;
      }
      this.adOverlay.off(AdOverlayEvent.CLOSE_BUTTON_CLICK);
      this.adOverlay.once(AdOverlayEvent.CLOSE_BUTTON_CLICK, this.onAdComplete.bind(this, adType));
      this.adOverlay.show(adType);
    }
    mute() {
      if (this.options.muteMethod === "context_suspend") {
        return this.game.audio.suspendAudioContext();
      }
      this.wasMuted = this.game.audio.global._muted;
      this.game.audio.global.mute(true);
      return Promise.resolve();
    }
    onAdComplete(adType) {
      if (this.adInProgress === false) {
        return;
      }
      this.adInProgress = false;
      this.enableInput();
      this.hideAdOverlay(adType);
      this.unmute();
    }
    enableInput() {
      if (this.options.disableInput === false) {
        return;
      }
      this.game.input.enabled = this.wasInputEnabled;
    }
    hideAdOverlay(adType) {
      var _a, _b;
      (_a = this.adOverlay) == null ? void 0 : _a.off(AdOverlayEvent.CLOSE_BUTTON_CLICK);
      (_b = this.adOverlay) == null ? void 0 : _b.hide(adType);
    }
    unmute() {
      if (this.options.muteMethod === "context_suspend") {
        this.game.audio.resumeAudioContext();
        return;
      }
      this.game.audio.global.mute(this.wasMuted);
    }
    onLanguageChange() {
      var _a;
      (_a = this.adOverlay) == null ? void 0 : _a.onLanguageChange();
    }
    waitUntilAdTimeComplete() {
      if (!this.adOverlay || !this.adOverlay.isTimerRunning) {
        return Promise.resolve();
      }
      return new Promise((resolve) => {
        this.adOverlay.once(AdOverlayEvent.TIMER_COMPLETE, () => resolve());
      });
    }
    get adOverlay() {
      return this.game.globalScene.adOverlay;
    }
  };

  // src/ads/overlay/CloseAdButton.ts
  var CloseAdButton = class extends ComplexButton {
    static createTexture(scene) {
      let textureKey = "ad_close_button";
      let lineWidth = 3;
      let graphics = scene.make.graphics({
        fillStyle: {
          alpha: 0,
          color: 0
        },
        lineStyle: {
          color: 16777215,
          width: lineWidth
        }
      });
      let width = 240;
      let height = 60;
      graphics.strokeRoundedRect(lineWidth / 2, lineWidth / 2, width, height, 25);
      graphics.generateTexture(textureKey, width + lineWidth, height + lineWidth);
      graphics.destroy();
      return textureKey;
    }
    constructor(scene) {
      super(scene, CloseAdButton.createTexture(scene), null);
    }
  };

  // src/ads/overlay/AdOverlay.ts
  var AdOverlayEvent;
  (function(AdOverlayEvent2) {
    AdOverlayEvent2["TIMER_COMPLETE"] = "__TIMER_COMPLETE";
    AdOverlayEvent2["CLOSE_BUTTON_CLICK"] = "__CLOSE_BUTTON_CLICK";
  })(AdOverlayEvent || (AdOverlayEvent = {}));
  var AdOverlay2 = class extends PhaserScreen {
    constructor(scene, options) {
      super(scene, {
        name: "ad_overlay",
        backgroundAlpha: 1
      });
      this._isTimerRunning = false;
      this.adOptions = options;
      this.addSpinner();
      this.addTimer();
      this.addCloseButton();
    }
    get isTimerRunning() {
      return this._isTimerRunning;
    }
    addSpinner() {
      this.spinner = new AdOverlaySpinner(this.scene, {
        dotsNum: 8,
        dotRadius: 5,
        radius: 50
      }, this);
      this.spinner.angle = 180;
      this.pin(this.spinner, 0.5, 0.5);
    }
    addTimer() {
      this.timer = new AdTimer(this.scene);
      this.timer.setOrigin(0.5, 0.5);
      this.add(this.timer);
      this.pin(this.timer, 0.5, 1, 0, -85);
    }
    addCloseButton() {
      let timerPin = this.pinner.getPin(this.timer);
      this.closeButton = new CloseAdButton(this.scene);
      this.closeButton.addText("\u0417\u0430\u043A\u0440\u044B\u0442\u044C", {fontFamily: "Arial, serif", fontSize: "22px"});
      this.closeButton.on(ButtonEvent.PRESS, this.onCloseButtonClick, this);
      this.closeButton.kill();
      this.add(this.closeButton);
      this.pin(this.closeButton, timerPin.x, timerPin.y, timerPin.offsetX, timerPin.offsetY);
    }
    onCloseButtonClick() {
      this.emit(AdOverlayEvent.CLOSE_BUTTON_CLICK, this);
    }
    resize() {
      super.resize();
      this.timer.originalY = this.timer.y;
      this.closeButton.originalY = this.closeButton.y;
    }
    show(adType) {
      this.revive();
      this.alpha = 0;
      this.scene.tweens.add({
        targets: this,
        duration: 100,
        ease: Phaser.Math.Easing.Linear,
        alpha: 1
      });
      this.showSpinner();
      this.timer.kill();
      this.closeButton.kill();
      if (adType === AdType.REWARDED && this.adOptions.displayTimer) {
        this.startTimer();
      }
    }
    showSpinner() {
      this.spinner.startAnimation();
      this.spinner.scale = 1.5;
      this.scene.tweens.add({
        targets: this.spinner,
        duration: 200,
        scale: 1,
        ease: Phaser.Math.Easing.Quadratic.Out
      });
    }
    startTimer() {
      this._isTimerRunning = true;
      let waitSeconds = this.adOptions.timeoutSeconds;
      let secondsPassed = 0;
      this.timer.text = waitSeconds.toString();
      this.timerIntervalId = setInterval(() => {
        if (--waitSeconds === 0) {
          this.onTimerComplete();
        }
        if (++secondsPassed === 3) {
          this.showTimer();
        }
        this.timer.text = waitSeconds.toString();
      }, 1e3);
    }
    showTimer() {
      this.timer.revive();
      this.timer.alpha = 0;
      this.timer.y = this.timer.originalY + 20;
      this.scene.tweens.add({
        targets: this.timer,
        duration: 300,
        ease: Phaser.Math.Easing.Quadratic.Out,
        y: this.timer.originalY,
        alpha: 1
      });
    }
    onTimerComplete() {
      clearInterval(this.timerIntervalId);
      this.timer.kill();
      this._isTimerRunning = false;
      if (this.adOptions.displayCloseButton) {
        this.showCloseButton();
      }
      this.emit(AdOverlayEvent.TIMER_COMPLETE, this);
    }
    showCloseButton() {
      this.closeButton.revive();
      this.closeButton.alpha = 0;
      this.closeButton.y = this.closeButton.originalY + 20;
      this.scene.tweens.add({
        targets: this.closeButton,
        duration: 300,
        ease: Phaser.Math.Easing.Quadratic.Out,
        y: this.closeButton.originalY,
        alpha: 1
      });
    }
    hide(adType) {
      clearInterval(this.timerIntervalId);
      this.scene.tweens.killTweensOf(this);
      this.scene.tweens.add({
        targets: this,
        duration: 100,
        ease: Phaser.Math.Easing.Linear,
        alpha: 0,
        onComplete: () => {
          this.kill();
          this.spinner.stopAnimation();
        }
      });
    }
    onLanguageChange() {
      this.closeButton.text.setText(this.scene.texts.ads.close);
    }
  };

  // src/purchases/PurchaseOverlay.ts
  var PurchaseOverlay = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "purchase_overlay",
        backgroundAlpha: 0.85
      });
      this.addSpinner();
    }
    addSpinner() {
      this.spinner = new AdOverlaySpinner(this.scene, {
        dotsNum: 8,
        dotRadius: 5,
        radius: 50
      }, this);
      this.spinner.angle = 180;
      this.pin(this.spinner, 0.5, 0.5);
    }
    resize() {
      super.resize();
    }
    show() {
      this.revive();
      this.alpha = 0;
      this.scene.tweens.add({
        targets: this,
        duration: 100,
        ease: Phaser.Math.Easing.Linear,
        alpha: 1
      });
      this.showSpinner();
    }
    showSpinner() {
      this.spinner.startAnimation();
      this.spinner.scale = 1.5;
      this.scene.tweens.add({
        targets: this.spinner,
        duration: 200,
        scale: 1,
        ease: Phaser.Math.Easing.Quadratic.Out
      });
    }
    hide() {
      this.scene.tweens.killTweensOf(this);
      this.scene.tweens.add({
        targets: this,
        duration: 100,
        ease: Phaser.Math.Easing.Linear,
        alpha: 0,
        onComplete: () => {
          this.kill();
          this.spinner.stopAnimation();
        }
      });
    }
  };

  // src/scenes/global/GlobalScene.ts
  var GlobalScene = class extends Phaser.Scene {
    init() {
    }
    create() {
      this.addRenderStats();
      this.addAdOverlay();
      this.addPurchaseOverlay();
      this.resize();
    }
    addRenderStats() {
      let showRenderStats = UrlParams.getBool("stats");
      if (showRenderStats === false) {
        return;
      }
      this.renderStats = new RenderStatsDOM(this);
    }
    addAdOverlay() {
      let options = {
        displayTimer: true,
        displayCloseButton: false,
        timeoutSeconds: 15
      };
      this.adOverlay = new AdOverlay2(this, options);
      this.adOverlay.setDepth(GlobalSceneDepth.AD_OVERLAY);
      this.adOverlay.kill();
      this.add.existing(this.adOverlay);
    }
    addPurchaseOverlay() {
      this.purchaseOverlay = new PurchaseOverlay(this);
      this.purchaseOverlay.setDepth(GlobalSceneDepth.PURCHASE_OVERLAY);
      this.purchaseOverlay.kill();
      this.add.existing(this.purchaseOverlay);
    }
    addSceneTranstion(transition) {
      this.sceneTransition = transition;
      this.sceneTransition.setDepth(GlobalSceneDepth.SCENE_TRANSITION);
      this.sceneTransition.visible = false;
      this.sceneTransition.active = false;
      this.add.existing(this.sceneTransition);
    }
    addToasts() {
      this.toasts = new ToastsManager(this);
      this.toasts.setDepth(GlobalSceneDepth.TOASTS);
      this.toasts.resize();
      this.add.existing(this.toasts);
      return this.toasts;
    }
    addBlackRect() {
      this.blackRect = this.make.image({key: "gameplay", frame: "black_rect_big"}, false);
      this.blackRect.alpha = 0.85;
      return this.blackRect;
    }
    addDelayedLoader() {
      this.delayedLoader = new DelayedLoader(this);
      return this.delayedLoader;
    }
    update(time, delta) {
      if (this.renderStats) {
        this.renderStats.update(delta);
      }
    }
    resize() {
      var _a, _b, _c;
      (_a = this.toasts) == null ? void 0 : _a.resize();
      (_b = this.sceneTransition) == null ? void 0 : _b.resize();
      this.adOverlay.resize();
      (_c = this.purchaseOverlay) == null ? void 0 : _c.resize();
    }
  };

  // src/pregameBoosters/PregameBoosterType.ts
  var PregameBoosterType;
  (function(PregameBoosterType2) {
    PregameBoosterType2["STRIPES"] = "stripes";
    PregameBoosterType2["BOMB"] = "bomb";
    PregameBoosterType2["SUPER_SPHERE"] = "super_sphere";
  })(PregameBoosterType || (PregameBoosterType = {}));

  // src/robowhale/utils/check-webassembly.ts
  function isWebAssemblySupported() {
    try {
      if (typeof WebAssembly === "object" && typeof WebAssembly.instantiate === "function") {
        let module2 = new WebAssembly.Module(Uint8Array.of(0, 97, 115, 109, 1, 0, 0, 0));
        if (module2 instanceof WebAssembly.Module) {
          return new WebAssembly.Instance(module2) instanceof WebAssembly.Instance;
        }
      }
    } catch (error) {
    }
    return false;
  }

  // src/GameAnalyticsWrapper.ts
  var ScaleModes = Phaser.Scale.ScaleModes;
  var WebGLRenderer = Phaser.Renderer.WebGL.WebGLRenderer;
  var ResourceCurrency;
  (function(ResourceCurrency2) {
    ResourceCurrency2["COINS"] = "coins";
    ResourceCurrency2["BOOSTERS"] = "boosters";
    ResourceCurrency2["PREGAME_BOOSTERS"] = "pregameBoosters";
  })(ResourceCurrency || (ResourceCurrency = {}));
  var ResourceItemType;
  (function(ResourceItemType2) {
    ResourceItemType2["COIN"] = "coin";
    ResourceItemType2["STRIPES"] = "stripes";
    ResourceItemType2["BOMB"] = "bomb";
    ResourceItemType2["SUPER_SPHERE"] = "super_sphere";
    ResourceItemType2["UNDO"] = "undo";
    ResourceItemType2["GLOVE"] = "glove";
    ResourceItemType2["ROLLING_PIN"] = "rolling_pin";
    ResourceItemType2["LOLLIPOP"] = "lollipop";
  })(ResourceItemType || (ResourceItemType = {}));
  var EGAAdAction;
  (function(EGAAdAction2) {
    EGAAdAction2[EGAAdAction2["Clicked"] = 1] = "Clicked";
    EGAAdAction2[EGAAdAction2["Show"] = 2] = "Show";
    EGAAdAction2[EGAAdAction2["FailedShow"] = 3] = "FailedShow";
    EGAAdAction2[EGAAdAction2["RewardReceived"] = 4] = "RewardReceived";
  })(EGAAdAction || (EGAAdAction = {}));
  var EGAAdType;
  (function(EGAAdType2) {
    EGAAdType2[EGAAdType2["Video"] = 1] = "Video";
    EGAAdType2[EGAAdType2["RewardedVideo"] = 2] = "RewardedVideo";
    EGAAdType2[EGAAdType2["Playable"] = 3] = "Playable";
    EGAAdType2[EGAAdType2["Interstitial"] = 4] = "Interstitial";
    EGAAdType2[EGAAdType2["OfferWall"] = 5] = "OfferWall";
    EGAAdType2[EGAAdType2["Banner"] = 6] = "Banner";
  })(EGAAdType || (EGAAdType = {}));
  var EGAAdError;
  (function(EGAAdError2) {
    EGAAdError2[EGAAdError2["Undefined"] = 0] = "Undefined";
    EGAAdError2[EGAAdError2["Unknown"] = 1] = "Unknown";
    EGAAdError2[EGAAdError2["Offline"] = 2] = "Offline";
    EGAAdError2[EGAAdError2["NoFill"] = 3] = "NoFill";
    EGAAdError2[EGAAdError2["InternalError"] = 4] = "InternalError";
    EGAAdError2[EGAAdError2["InvalidRequest"] = 5] = "InvalidRequest";
    EGAAdError2[EGAAdError2["UnableToPrecache"] = 6] = "UnableToPrecache";
  })(EGAAdError || (EGAAdError = {}));
  var EGAErrorSeverity;
  (function(EGAErrorSeverity2) {
    EGAErrorSeverity2[EGAErrorSeverity2["Undefined"] = 0] = "Undefined";
    EGAErrorSeverity2[EGAErrorSeverity2["Debug"] = 1] = "Debug";
    EGAErrorSeverity2[EGAErrorSeverity2["Info"] = 2] = "Info";
    EGAErrorSeverity2[EGAErrorSeverity2["Warning"] = 3] = "Warning";
    EGAErrorSeverity2[EGAErrorSeverity2["Error"] = 4] = "Error";
    EGAErrorSeverity2[EGAErrorSeverity2["Critical"] = 5] = "Critical";
  })(EGAErrorSeverity || (EGAErrorSeverity = {}));
  var EGAResourceFlowType;
  (function(EGAResourceFlowType2) {
    EGAResourceFlowType2[EGAResourceFlowType2["Source"] = 1] = "Source";
    EGAResourceFlowType2[EGAResourceFlowType2["Sink"] = 2] = "Sink";
  })(EGAResourceFlowType || (EGAResourceFlowType = {}));
  var EGAProgressionStatus;
  (function(EGAProgressionStatus2) {
    EGAProgressionStatus2[EGAProgressionStatus2["Start"] = 1] = "Start";
    EGAProgressionStatus2[EGAProgressionStatus2["Complete"] = 2] = "Complete";
    EGAProgressionStatus2[EGAProgressionStatus2["Fail"] = 3] = "Fail";
  })(EGAProgressionStatus || (EGAProgressionStatus = {}));
  var RemoteConfigKey;
  (function(RemoteConfigKey2) {
    RemoteConfigKey2["SKIP_FIRST_INTERSTITIAL"] = "skip_1st_ad";
    RemoteConfigKey2["LIVES_NUM"] = "lives_num";
    RemoteConfigKey2["MOVES_DELTA"] = "moves_delta";
  })(RemoteConfigKey || (RemoteConfigKey = {}));
  var REMOTE_CONFIG = {
    [RemoteConfigKey.SKIP_FIRST_INTERSTITIAL]: "true",
    [RemoteConfigKey.LIVES_NUM]: "5",
    [RemoteConfigKey.MOVES_DELTA]: "0"
  };
  var GameAnalyticsWrapper = class extends Phaser.Events.EventEmitter {
    constructor(game) {
      super();
      this.isEnabled = false;
      this.game = game;
      if (typeof gameanalytics === "undefined") {
        this.isEnabled = false;
        return;
      }
      this.ga = gameanalytics.GameAnalytics;
      this.isEnabled = true;
      this.loadingTimes = {};
      this.setCustomDimensions();
      this.checkRemoteConfigKeys();
    }
    setCustomDimensions() {
      this.ga.setCustomDimension01(window.game.config.publisher);
      this.ga.setCustomDimension02(this.game.rendererType);
    }
    checkRemoteConfigKeys() {
      let keys2 = Object.values(RemoteConfigKey);
      keys2.forEach((key) => {
        let length = key.length;
        if (length < 1 || length > 12) {
          console.warn(`Invalid remote config key "${key}". Length should be 1 to 12, current is ${length}!`);
        }
      });
    }
    sendLevelStart(level) {
      this.sendProgressionEvent(1, level);
    }
    sendLevelComplete(level, movesNum) {
      this.sendProgressionEvent(2, level, movesNum);
    }
    sendLevelFail(level, score) {
      this.sendProgressionEvent(3, level, score);
    }
    sendProgressionEvent(type, level, score) {
      if (this.isEnabled === false) {
        return;
      }
      let levelKey = "level_" + level.toString().padStart(3, "0");
      this.ga.addProgressionEvent(type, levelKey, "", "", score);
    }
    sendAdEvent(action, type, placement, adProvider) {
      if (this.isEnabled === false) {
        return;
      }
      this.ga.addAdEvent(action, type, adProvider, placement);
    }
    sendAdFailedEvent(type, placement, adProvider, reason) {
      if (this.isEnabled === false) {
        return;
      }
      if (typeof reason === "undefined") {
        this.ga.addAdEvent(3, type, adProvider, placement);
      } else {
        this.ga.addAdEventWithNoAdReason(3, type, adProvider, placement, reason);
      }
    }
    sendBusinessEvent(currency, amount, itemType, itemId, cartType) {
      if (this.isEnabled === false) {
        return;
      }
      this.ga.addBusinessEvent(currency, amount, itemType, itemId, cartType);
    }
    addResource(currency, amount = 1, itemType, itemId) {
      if (this.isEnabled === false) {
        return;
      }
      this.ga.addResourceEvent(1, currency, amount, this.getResourceItemType(itemType), itemId);
    }
    subtractResource(currency, amount = 1, itemType, itemId) {
      if (this.isEnabled === false) {
        return;
      }
      this.ga.addResourceEvent(2, currency, amount, this.getResourceItemType(itemType), itemId);
    }
    getResourceItemType(source) {
      switch (source) {
        case ResourceItemType.COIN:
          return ResourceItemType.COIN;
        case PregameBoosterType.STRIPES:
          return ResourceItemType.STRIPES;
        case PregameBoosterType.BOMB:
          return ResourceItemType.BOMB;
        case PregameBoosterType.SUPER_SPHERE:
          return ResourceItemType.SUPER_SPHERE;
        case BoosterType.UNDO:
          return ResourceItemType.UNDO;
        case BoosterType.GLOVE:
          return ResourceItemType.GLOVE;
        case BoosterType.ROLLING_PIN:
          return ResourceItemType.ROLLING_PIN;
        case BoosterType.LOLLIPOP:
          return ResourceItemType.LOLLIPOP;
        default:
          break;
      }
    }
    sendLoadingEvent(place, type) {
      if (this.isEnabled === false) {
        return;
      }
      if (type === "start") {
        this.loadingTimes[place] = Date.now();
        this.ga.addDesignEvent(`Loading:${place}:${type}`);
      }
      if (type === "complete") {
        let durationMs = Date.now() - this.loadingTimes[place];
        let duration = Phaser.Math.RoundTo(durationMs / 1e3, -1);
        this.ga.addDesignEvent(`Loading:${place}:${type}`, duration);
      }
    }
    sendDesignEvent(event, value) {
      if (this.isEnabled === false) {
        return;
      }
      this.ga.addDesignEvent(event, value);
    }
    sendError(message, severity = 4) {
      if (this.isEnabled === false) {
        return;
      }
      this.ga.addErrorEvent(severity, message);
    }
    sendBrowser() {
      if (this.isEnabled === false) {
        return;
      }
      let browsers = ["chrome", "edge", "firefox", "ie", "mobileSafari", "opera", "safari", "silk", "trident", "other"];
      let browser = this.getCurrentBrowser(browsers);
      this.sendDesignEvent(`Browser:${browser}`);
    }
    getCurrentBrowser(browsers) {
      var _a;
      let browser;
      let deviceInfo = this.game.device;
      if (deviceInfo.os.android && deviceInfo.browser.chrome) {
        browser = "chrome-android";
      } else {
        browser = (_a = browsers.find((browser2) => deviceInfo.browser[browser2] === true)) != null ? _a : "other";
      }
      if (browser === "mobileSafari") {
        browser = "safari-mobile";
      }
      return browser;
    }
    sendAvifStatus(avif) {
      let event = avif ? "avif:supported" : "avif:not_supported";
      this.sendDesignEvent(event);
    }
    sendWebpStatus(webp) {
      let event = webp ? "webp:supported" : "webp:not_supported";
      this.sendDesignEvent(event);
    }
    sendDesktopScreenResolution() {
      let isDesktop = this.game.scale.scaleMode === ScaleModes.FIT;
      if (isDesktop === false) {
        return;
      }
      try {
        let {width, height} = screen;
        if (width > 0 && height > 0) {
          this.sendDesignEvent(`Screen:Resolution:${width}x${height}`);
        }
      } catch (error) {
      }
    }
    sendWebWorkerStatus() {
      let isSupported = typeof Worker === "function";
      let event = isSupported ? "WebWorker:supported" : "WebWorker:not_supported";
      this.sendDesignEvent(event);
    }
    sendConnectionStatus() {
      var _a, _b;
      let connectionType = (_b = (_a = navigator["connection"]) == null ? void 0 : _a.effectiveType) != null ? _b : "not_supported";
      let event = `Connection:${connectionType}`;
      this.sendDesignEvent(event);
    }
    sendServiceWorkerStatus() {
      let isEnabled = "serviceWorker" in navigator;
      let event = isEnabled ? "ServiceWorker:supported" : "ServiceWorker:not_supported";
      this.sendDesignEvent(event);
    }
    sendDeviceMemory() {
      let value = getDeviceMemory();
      let event = `DeviceMemory:${value != null ? value : "Unknown"}`;
      this.sendDesignEvent(event);
    }
    sendWebAssemblyStatus() {
      let isSupported = isWebAssemblySupported();
      let event = isSupported ? "WebAssembly:supported" : "WebAssembly:not_supported";
      this.sendDesignEvent(event);
    }
    sendWebGlParams() {
      let renderer = this.game.renderer;
      if (!(renderer instanceof WebGLRenderer)) {
        return;
      }
      this.sendDesignEvent(`WebGL:MaxTextures:${renderer.maxTextures}`);
      this.sendDesignEvent(`WebGL:TextureSize:${renderer.getMaxTextureSize()}`);
      this.sendTextureCompressionInfo(renderer.gl);
    }
    sendTextureCompressionInfo(gl) {
      let extString = "WEBGL_compressed_texture_";
      let wkExtString = "WEBKIT_" + extString;
      let getExtension = (format) => gl.getExtension(extString + format) || gl.getExtension(wkExtString + format);
      let formats = {
        ETC1: getExtension("etc1"),
        PVRTC: getExtension("pvrtc"),
        S3TC: getExtension("s3tc"),
        ASTC: getExtension("astc")
      };
      let supportedFormats = pickBy_default(formats, (value) => value !== null);
      let isAnyFormatSupported = Object.keys(supportedFormats).length > 0;
      if (isAnyFormatSupported === false) {
        this.sendDesignEvent(`WebGL:TextureCompression:not_supported`);
        return;
      }
      Object.keys(supportedFormats).forEach((key) => {
        this.sendDesignEvent(`WebGL:TextureCompression:${key}`);
      });
    }
    getRemoteConfigValue(key, defaultValue) {
      defaultValue != null ? defaultValue : defaultValue = REMOTE_CONFIG[key];
      if (this.isEnabled === false) {
        return defaultValue;
      }
      return this.ga.getRemoteConfigsValueAsString(key, defaultValue);
    }
    loadRemoteConfig() {
      if (this.isEnabled === false) {
        return Promise.reject();
      }
      if (this.ga.isRemoteConfigsReady()) {
        this.onRemoteConfigsReady();
        return Promise.resolve();
      }
      return new Promise((resolve) => {
        this.ga.addRemoteConfigsListener({
          onRemoteConfigsUpdated: () => {
            this.onRemoteConfigsReady();
            resolve();
          }
        });
      });
    }
    onRemoteConfigsReady() {
      console.groupCollapsed("Remote config");
      console.log("Config:", this.ga.getRemoteConfigsContentAsString());
      console.log("AB Testing Id:", this.ga.getABTestingId());
      console.log("AB Variant Id:", this.ga.getABTestingVariantId());
      console.groupEnd();
    }
  };

  // src/scale/GameScaler.ts
  var import_css_element_queries = __toModule(require("css-element-queries"));
  var GameScaler = class {
    constructor(game, options) {
      this._quality = GraphicsQuality.HIGH;
      this.game = game;
      this.options = options;
      this.scale = this.game.scale;
      this.canvas = this.scale.canvas;
      this.rotateOverlay = document.getElementById("rotate");
      if (this.game.config.scaleMode === Phaser.Scale.NONE) {
        this.scale.zoom = Phaser.Scale.NO_ZOOM;
        this.setupCanvasStyle();
        this.addResizeListener();
        this.updateScreenConstants();
      }
    }
    get quality() {
      return this._quality;
    }
    get qualityValue() {
      return getGraphicsQualityAsNumber(this._quality);
    }
    setupCanvasStyle() {
      let parentStyle = this.canvas.parentElement.style;
      parentStyle.width = "100%";
      parentStyle.height = "100%";
      parentStyle.position = "absolute";
      parentStyle.top = "0";
      parentStyle.bottom = "0";
    }
    addResizeListener() {
      let onCanvasResize = this.onCanvasResize.bind(this);
      let callback = this.options.resizeDebounceInterval > 0 ? debounce_default(onCanvasResize, 200, {leading: false}) : onCanvasResize;
      let sensor = new import_css_element_queries.ResizeSensor(this.canvas.parentElement, callback);
    }
    onCanvasResize(size) {
      if (typeof this.resizeTimeoutId !== "undefined") {
        clearTimeout(this.resizeTimeoutId);
      }
      if (document.hidden) {
        return;
      }
      let width = size.width;
      let height = size.height;
      if (width === 0 || height === 0) {
        this.scheduleResize();
        return;
      }
      let zoom = Math.min(Config.SOURCE_GAME_WIDTH / width, 2);
      let quality = getGraphicsQualityAsNumber(this._quality);
      this.addResizeBreadcrumb(width, height, zoom);
      this.canvas.style.width = `${width}px`;
      this.canvas.style.height = `${height}px`;
      this.scale.resize(width * zoom * quality, height * zoom * quality);
      let isCorrectOrientation = this.isCorrectOrientation(width, height);
      if (isCorrectOrientation) {
        this.updateScreenConstants();
        this.resizeActiveScenes();
        this.hideRotateIcon();
      } else {
        this.showRotateIcon();
      }
    }
    scheduleResize(delay = 1e3) {
      this.resizeTimeoutId = setTimeout(() => {
        let bounds = this.canvas.getBoundingClientRect();
        this.onCanvasResize({width: bounds.width, height: bounds.height});
      }, delay);
    }
    addResizeBreadcrumb(width, height, zoom) {
      this.game.sentry.addBreadcrumb({
        category: "game",
        message: "resize",
        data: {
          width,
          height,
          zoom
        }
      });
    }
    isCorrectOrientation(width, height) {
      let isPortrait = height > width;
      let isLandscape = width > height;
      let correctPortrait = Config.IS_PORTRAIT && isPortrait;
      let correctLandscape = Config.IS_LANDSCAPE && isLandscape;
      return correctPortrait || correctLandscape;
    }
    resizeActiveScenes() {
      let scenes = this.game.scene.getScenes(true);
      let preloader = this.game.scene.getScene(SceneKey.PRELOADER);
      if (scenes.includes(preloader) === false) {
        if (preloader.scene.settings.status === Phaser.Scenes.LOADING) {
          scenes.push(preloader);
        }
      }
      scenes.forEach((scene) => {
        if (scene.resize) {
          scene.resize();
        }
      });
    }
    updateScreenConstants() {
      Config.GAME_WIDTH = this.game.scale.width;
      Config.GAME_HEIGHT = this.game.scale.height;
      Config.HALF_GAME_WIDTH = Config.GAME_WIDTH * 0.5;
      Config.HALF_GAME_HEIGHT = Config.GAME_HEIGHT * 0.5;
      Config.ASPECT_RATIO = Config.GAME_WIDTH / Config.GAME_HEIGHT;
      Config.ASSETS_SCALE = Config.IS_PORTRAIT ? Config.GAME_WIDTH / Config.SOURCE_GAME_WIDTH : Config.GAME_HEIGHT / Config.SOURCE_GAME_HEIGHT;
    }
    showRotateIcon() {
      this.rotateOverlay.style.display = "flex";
    }
    hideRotateIcon() {
      this.rotateOverlay.style.display = "none";
    }
    setQuality(value) {
      if (value === this._quality) {
        return;
      }
      this._quality = value;
      let {width, height} = this.canvas.getBoundingClientRect();
      this.onCanvasResize({width, height});
    }
  };

  // src/scenes/Boot.ts
  var import_howler2 = __toModule(require("howler"));

  // src/sceneTransition/ISceneTransition.ts
  var SceneTransitionEvent;
  (function(SceneTransitionEvent2) {
    SceneTransitionEvent2["START"] = "start";
    SceneTransitionEvent2["COMPLETE"] = "complete";
  })(SceneTransitionEvent || (SceneTransitionEvent = {}));

  // src/SentryWrapper.ts
  var Sentry = __toModule(require("@sentry/browser"));
  var import_types = __toModule(require("@sentry/types"));
  var SentryWrapper = class {
    constructor(game) {
      this._isEnabled = false;
      this.game = game;
      this._isEnabled = typeof Sentry.getCurrentHub().getClient() !== "undefined";
    }
    get isEnabled() {
      return this._isEnabled;
    }
    addBreadcrumb(breadcrumb) {
      if (this._isEnabled === false) {
        return;
      }
      Sentry.addBreadcrumb(breadcrumb);
    }
    setTag(tag, value) {
      if (this._isEnabled === false) {
        return;
      }
      Sentry.setTag(tag, value);
    }
    setTags(tags) {
      if (this._isEnabled === false) {
        return;
      }
      Sentry.setTags(tags);
    }
    trackGameGlobalEvents() {
      if (this._isEnabled === false) {
        return;
      }
      let events = this.game.events;
      let category = "game.global";
      events.on(Phaser.Core.Events.HIDDEN, () => {
        Sentry.addBreadcrumb({category, message: "document hidden"});
      });
      events.on(Phaser.Core.Events.VISIBLE, () => {
        Sentry.addBreadcrumb({category, message: "document visible"});
      });
      events.on(Phaser.Core.Events.CONTEXT_LOST, () => {
        Sentry.addBreadcrumb({category, message: "WebGL context lost", level: import_types.Severity.Warning});
      });
      events.on(Phaser.Core.Events.CONTEXT_RESTORED, () => {
        Sentry.addBreadcrumb({category, message: "WebGL context restored"});
      });
    }
    addInitialBreadcrumb() {
      if (this._isEnabled === false) {
        return;
      }
      this.addBreadcrumb({
        message: "sentry init",
        data: {
          "document.visibility": document.hidden === true ? "hidden" : "visible",
          "renderer.state": this.getRendererState()
        }
      });
    }
    getRendererState() {
      let renderer = this.game.renderer;
      if (renderer instanceof Phaser.Renderer.Canvas.CanvasRenderer) {
        return "canvas_renderer";
      }
      return renderer.contextLost ? "webgl_context_lost" : "webgl_context_is_fine";
    }
    setTagsOnStart() {
      var _a, _b, _c;
      if (this._isEnabled === false) {
        return;
      }
      Sentry.setTags({
        publisher: window.game.config.publisher,
        renderer: this.game.rendererType,
        audio: this.game.audioType,
        browserLanguage: navigator.language,
        webp: this.game.webp.toString(),
        avif: this.game.avif.toString(),
        connectionType: (_b = (_a = navigator["connection"]) == null ? void 0 : _a.effectiveType) != null ? _b : "unknown",
        webWorker: typeof Worker === "function",
        serviceWorker: "serviceWorker" in navigator,
        engine: "Phaser",
        "engine.version": Phaser.VERSION,
        "device.memory": (_c = getDeviceMemory()) != null ? _c : "unknown"
      });
    }
    trackSceneChanges(transition) {
      if (this._isEnabled === false) {
        return;
      }
      transition.on(SceneTransitionEvent.COMPLETE, this.onSceneTransitionComplete, this);
    }
    onSceneTransitionComplete(transition, oldSceneKey, newSceneKey, newSceneData) {
      let scenesData = __spreadProps(__spreadValues({
        currentScene: newSceneKey
      }, newSceneData && {currentSceneData: this.prettifySceneData(newSceneData)}), {
        lastScene: oldSceneKey
      });
      Sentry.addBreadcrumb({
        category: "game.flow",
        message: `transition ${oldSceneKey} => ${newSceneKey}`,
        data: {
          newSceneData
        }
      });
      Sentry.setContext("game", __spreadValues({}, scenesData));
      this.trackSceneInput(newSceneKey);
    }
    prettifySceneData(sceneData) {
      let prettySceneData = {};
      Object.keys(sceneData).forEach((key) => {
        let value = sceneData[key];
        if (typeof value === "object") {
          prettySceneData[key] = JSON.stringify(value);
        } else {
          prettySceneData[key] = value;
        }
      });
      return prettySceneData;
    }
    trackSceneInput(sceneKey) {
      var _a;
      if (this._isEnabled === false) {
        return;
      }
      let scene = this.game.scene.getScene(sceneKey);
      if (scene) {
        scene.events.once(Phaser.Scenes.Events.SHUTDOWN, this.removePointerDownListener.bind(this, scene));
        (_a = scene.input) == null ? void 0 : _a.on(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
      }
    }
    removePointerDownListener(scene) {
      var _a;
      (_a = scene.input) == null ? void 0 : _a.off(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
    }
    onPointerDown(pointer, objects) {
      let clicked = objects.map((obj) => {
        var _a, _b;
        return obj.name || ((_a = obj["frame"]) == null ? void 0 : _a.name) || ((_b = obj["texture"]) == null ? void 0 : _b.key);
      });
      if (clicked.length === 0) {
        return;
      }
      Sentry.addBreadcrumb({
        category: "game.click",
        data: {
          objects: clicked.join(),
          scene: objects[0].scene.scene.key,
          parent: !!objects[0].parentContainer ? objects[0].parentContainer.name : "scene"
        }
      });
    }
    captureMessage(message, captureContext) {
      if (this._isEnabled) {
        Sentry.captureMessage(message, captureContext);
      }
    }
    captureException(exception, captureContext) {
      if (this._isEnabled) {
        Sentry.captureException(exception, captureContext);
      }
    }
    sendFeedback(message, email) {
      if (this._isEnabled === false) {
        return Promise.reject();
      }
      return new Promise((resolve) => {
        Sentry.withScope((scope) => {
          let completedLevels = this.game.store.getCompletedLevelNumbers();
          scope.setContext("feedback", {
            completedLevels: completedLevels.join(", "),
            completedLevelsNum: completedLevels.length,
            email: email != null ? email : "<empty>",
            message: message != null ? message : "<empty>"
          });
          let eventId = Sentry.captureMessage("Feedback");
          resolve(eventId);
        });
      });
    }
    getGameSnapshotAsBlob(options = {format: "image/jpeg", quality: 0.25}) {
      return new Promise((resolve, reject) => {
        this.game.renderer.snapshot((snapshot) => __async(this, null, function* () {
          let screenshotBase64 = snapshot.src;
          let blob = yield fetch(screenshotBase64).then((res) => res.blob());
          resolve(blob);
        }), options.format, options.quality);
      });
    }
  };

  // src/robowhale/utils/WebpChecker.ts
  function isWebpSupported(localStorage2) {
    let disableWebP = UrlParams.getBool("noWebp");
    if (disableWebP) {
      return false;
    }
    let isDevelop = window.environment === GameEnvironment.DEVELOP;
    if (isDevelop) {
      return false;
    }
    let localStorageKey = "robowhale__webp";
    if ((localStorage2 == null ? void 0 : localStorage2.getItem(localStorageKey)) === "true") {
      return true;
    }
    let isSupported = doCheckWebP();
    if (isSupported) {
      localStorage2 == null ? void 0 : localStorage2.setItem(localStorageKey, "true");
    }
    return isSupported;
  }
  function doCheckWebP() {
    let match = navigator.userAgent.match(/(Edge|Firefox)\/(\d+)\.(\d*)/);
    if (match && match[1] === "Firefox" && +match[2] >= 65) {
      return true;
    }
    if (match && match[1] === "Edge" && +match[2] === 18 && +match[3] === 17763) {
      return false;
    }
    let canvas = Phaser.Display.Canvas.CanvasPool.create(document);
    let supported = canvas.toDataURL ? canvas.toDataURL("image/webp").indexOf("data:image/webp") == 0 : false;
    Phaser.Display.Canvas.CanvasPool.remove(canvas);
    return supported;
  }

  // src/robowhale/utils/AvifChecker.ts
  function isAvifSupported(localStorage2) {
    let disableAvif = UrlParams.getBool("noAvif");
    if (disableAvif) {
      return Promise.resolve(false);
    }
    let isDevelop = window.environment === GameEnvironment.DEVELOP;
    if (isDevelop) {
      return Promise.resolve(false);
    }
    let localStorageKey = "robowhale__avif";
    if ((localStorage2 == null ? void 0 : localStorage2.getItem(localStorageKey)) === "true") {
      return Promise.resolve(true);
    }
    return new Promise((resolve) => {
      let callback = () => {
        if (image.height === 2) {
          localStorage2 == null ? void 0 : localStorage2.setItem(localStorageKey, "true");
          resolve(true);
        } else {
          resolve(false);
        }
      };
      let image = new Image();
      image.onload = callback;
      image.onerror = callback;
      image.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=";
    });
  }

  // src/scenes/Boot.ts
  var WebGLRenderer2 = Phaser.Renderer.WebGL.WebGLRenderer;
  var ImageFile = Phaser.Loader.FileTypes.ImageFile;
  var Boot = class extends Phaser.Scene {
    init() {
      return __async(this, null, function* () {
        let localStorage2 = isLocalStorageAvailable() ? window.localStorage : null;
        this.game.avif = yield isAvifSupported(localStorage2);
        this.game.webp = isWebpSupported(localStorage2);
        if (this.game.avif || this.game.webp) {
          this.patchImageLoader();
        }
      });
    }
    patchImageLoader() {
      let newFormat = this.getDefaultImageFormat();
      let formats = [".png", ".jpg"];
      let replaceUrl = (file) => {
        if (file instanceof ImageFile && typeof file.url === "string") {
          let fileUrl = file.url;
          let format = formats.find((format2) => fileUrl.includes(format2));
          if (format) {
            file.url = file.url.replace(format, newFormat);
          }
        }
      };
      Phaser.Loader.LoaderPlugin.prototype["addFileOld"] = Phaser.Loader.LoaderPlugin.prototype.addFile;
      Phaser.Loader.LoaderPlugin.prototype.addFile = function(files) {
        if (Array.isArray(files)) {
          files.forEach((file) => replaceUrl(file));
        } else {
          replaceUrl(files);
        }
        return this["addFileOld"](files);
      };
    }
    getDefaultImageFormat() {
      if (this.game.avif) {
        return ".avif";
      } else if (this.game.webp) {
        return ".webp";
      } else {
        return ".png";
      }
    }
    preload() {
      this.loadWebFonts();
      this.loadGdSdk();
      this.loadGameAnalytics();
    }
    loadWebFonts() {
      this.load.rexWebFont({
        custom: {
          families: ["PoetsenOne:n4"],
          urls: [getCacheBustingUrl("css/fonts.css")]
        }
      });
      this.load.on("webfontinactive", (arg_1, arg_2) => {
        console.warn("Can't load webfont", arg_1, arg_2);
      });
    }
    loadGdSdk() {
      let disableSdk = UrlParams.getBool("gdDisable");
      if (disableSdk) {
        return;
      }
      this.load.script("gd-sdk", "https://api.gamemonetize.com/sdk.js");
    }
    loadGameAnalytics() {
      if (window.game.config.analytics_enabled === false) {
        return;
      }
      if (UrlParams.getBool("analytics", "0") === true) {
        return;
      }
      this.load.script("game-analytics", "js/GameAnalytics.min.js");
    }
    create() {
      this.setupSentry();
      this.setupAnalytics();
      this.addBlackTexture();
      this.removeUnusedPipelines();
      this.addScaler();
      this.addCpuThrottling();
      this.game.injectIntoScenes(this.game.audio, "audio");
      this.launchGlobalScene();
    }
    setupSentry() {
      this.game.audioType = this.getAudioType(import_howler2.Howler);
      this.game.rendererType = this.getRendererType(this.game.renderer);
      this.game.sentry = new SentryWrapper(this.game);
      this.game.sentry.trackGameGlobalEvents();
      this.game.sentry.addInitialBreadcrumb();
      this.game.sentry.setTagsOnStart();
      this.game.injectIntoScenes(this.game.sentry, "sentry");
    }
    getAudioType(howler) {
      if (howler.noAudio) {
        return AudioType.NO_AUDIO;
      }
      return howler.usingWebAudio ? AudioType.WEB_AUDIO : AudioType.HTML5_AUDIO;
    }
    getRendererType(renderer) {
      if (renderer instanceof WebGLRenderer2) {
        return RendererType.WEBGL;
      }
      return RendererType.CANVAS;
    }
    setupAnalytics() {
      this.game.analytics = new GameAnalyticsWrapper(this.game);
      this.game.analytics.sendBrowser();
      this.game.analytics.sendAvifStatus(this.game.avif);
      this.game.analytics.sendWebpStatus(this.game.webp);
      this.game.analytics.sendDesktopScreenResolution();
      this.game.analytics.sendWebAssemblyStatus();
      this.game.analytics.sendWebWorkerStatus();
      this.game.analytics.sendServiceWorkerStatus();
      this.game.analytics.sendConnectionStatus();
      this.game.analytics.sendDeviceMemory();
      this.game.analytics.sendWebGlParams();
      try {
        let webglErrorKey = "webgl_error";
        let webglError = localStorage.getItem(webglErrorKey);
        if (webglError) {
          localStorage.removeItem(webglErrorKey);
          this.game.analytics.sendError(`WebGL:${webglError}`);
        }
      } catch (error) {
      }
      this.game.injectIntoScenes(this.game.analytics, "analytics");
    }
    addBlackTexture() {
      let graphics = this.make.graphics({fillStyle: {color: 0}}, false);
      graphics.fillRect(0, 0, 1, 1);
      graphics.generateTexture("__BLACK", 1, 1);
      graphics.destroy();
    }
    removeUnusedPipelines() {
      let renderer = this.renderer;
      if (!(renderer instanceof WebGLRenderer2)) {
        return;
      }
      let {pipelines: manager} = renderer;
      let pipelines = Phaser.Renderer.WebGL.Pipelines;
      let list = [pipelines.LIGHT_PIPELINE, pipelines.POINTLIGHT_PIPELINE, pipelines.ROPE_PIPELINE, pipelines.BITMAPMASK_PIPELINE];
      list.forEach((pipelineName) => {
        var _a;
        (_a = manager.get(pipelineName)) == null ? void 0 : _a.destroy();
        manager.remove(pipelineName);
      });
    }
    addScaler() {
      let resizeDebounceInterval = Main.development ? 0 : 200;
      let options = {
        resizeDebounceInterval
      };
      this.game.scaler = new GameScaler(this.game, options);
    }
    addCpuThrottling() {
      let throttle2 = UrlParams.getNumber("throttle");
      if (throttle2 <= 0) {
        return;
      }
      this.events.on(Phaser.Scenes.Events.PRE_UPDATE, () => {
        let i = throttle2 * 1e6;
        let a = 0;
        while (--i) {
          a += Math.sqrt(i);
        }
      });
      console.log(`\u26A0 \uFE0FThrottling x${throttle2} is enabled \u26A0`);
    }
    launchGlobalScene() {
      let globalScene = this.scene.get(SceneKey.GLOBAL);
      globalScene.events.once(Phaser.Scenes.Events.READY, this.onGlobalSceneReady.bind(this, globalScene));
      globalScene.scene.start(SceneKey.GLOBAL);
    }
    onGlobalSceneReady(globalScene) {
      this.game.globalScene = globalScene;
      globalScene.scene.launch(SceneKey.PRELOADER);
      globalScene.scene.bringToTop();
    }
  };

  // src/texts/LanguageUtil.ts
  var LANGUAGES_MAP = {
    ru: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
    en: "English",
    fr: "Fran\xE7ais",
    it: "Italiano",
    de: "Deutsch",
    es: "Espa\xF1ol",
    nl: "Nederlands",
    no: "Norsk",
    fi: "Suomi",
    br: "Brasileiro",
    pt: "Portugu\xEAs",
    jp: "\u65E5\u672C\u8A9E",
    ar: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
    tr: "T\xFCrk\xE7e",
    se: "Svenska",
    pl: "Polski"
  };
  function getLanguageTitle(shortCode) {
    return LANGUAGES_MAP[shortCode];
  }
  function convertLanguageCodeToGameLanguage(code) {
    switch (code) {
      case "pt-BR":
        return "br";
      case "ja-JP":
      case "ja-jp":
      case "ja":
        return "jp";
      case "uk-UA":
      case "uk-ua":
      case "uk":
        return "ru";
      default:
        return code.split("-")[0].toLowerCase();
    }
  }

  // src/texts/GameTexts.ts
  var EventEmitter = Phaser.Events.EventEmitter;
  var GameTextsEvent;
  (function(GameTextsEvent2) {
    GameTextsEvent2["LANGUAGE_CHANGE"] = "__LANGUAGE_CHANGE";
  })(GameTextsEvent || (GameTextsEvent = {}));
  var GameTexts = class extends EventEmitter {
    get language() {
      return this._language;
    }
    constructor(_game) {
      super();
      this.game = _game;
      this.allTexts = this.game.cache.json.get("texts");
      this.allLanguages = this.getSupportedLanguages();
      this._language = this.detectLanguage();
      this.texts = this.allTexts[this._language];
      this.setSentryLanguageTag();
      this.setDocumentLanguage();
      this.updateDefaultFont();
      this.sendLanguagesToAnalytics();
      console.info(`Language: ${this._language}`);
    }
    getSupportedLanguages() {
      let keys2 = Object.keys(this.allTexts);
      return keys2.filter((language) => {
        let value = this.allTexts[language];
        return Object.keys(value).length > 0;
      });
    }
    detectLanguage() {
      return this.getLanguageFromUrlParam() || this.getSavedLanguage() || this.getLanguageFromBrowser() || window.game.config.default_language;
    }
    getLanguageFromUrlParam() {
      let language = UrlParams.get("language") || UrlParams.get("lang");
      if (language && this.isLanguageSupported(language)) {
        return language;
      }
      return null;
    }
    getSavedLanguage() {
      let language = this.game.store.getValue(GameStoreKey.LANGUAGE);
      if (language && this.isLanguageSupported(language)) {
        return language;
      }
      return null;
    }
    getLanguageFromBrowser() {
      let language = convertLanguageCodeToGameLanguage(navigator.language);
      if (language && this.isLanguageSupported(language)) {
        return language;
      }
      if (typeof navigator.languages !== "undefined") {
        let languages = navigator.languages.map((code) => convertLanguageCodeToGameLanguage(code));
        let supported = languages.find((language2) => this.isLanguageSupported(language2));
        if (supported) {
          return supported;
        }
      }
      return null;
    }
    isLanguageSupported(language) {
      return this.allLanguages.includes(language);
    }
    injectTextsIntoScenes() {
      this.game.scene.getScenes(false).forEach((scene) => {
        scene["texts"] = this.texts;
      });
    }
    setLanguage(language) {
      if (!this.isLanguageSupported(language)) {
        console.warn(`Language ${language} is not supported!`);
        return false;
      }
      this._language = language;
      this.texts = this.allTexts[language];
      this.injectTextsIntoScenes();
      this.setSentryLanguageTag();
      this.setDocumentLanguage();
      this.updateDefaultFont();
      this.emit(GameTextsEvent.LANGUAGE_CHANGE, language);
      console.log("Current language:", this._language);
      return true;
    }
    setSentryLanguageTag() {
      this.game.sentry.setTag("language", this._language);
    }
    setDocumentLanguage() {
      document.documentElement.lang = this._language;
    }
    updateDefaultFont() {
      if (this._language === "jp") {
        WebFonts.DEFAULT_FAMILY = FontFamily.SANS_SERIF;
        WebFonts.DEFAULT_WEIGHT = FontWeight.BOLD;
      } else {
        WebFonts.DEFAULT_FAMILY = FontFamily.POETSEN;
        WebFonts.DEFAULT_WEIGHT = FontWeight.NORMAL;
      }
    }
    sendLanguagesToAnalytics() {
      var _a, _b;
      (_a = this.game.analytics) == null ? void 0 : _a.sendDesignEvent(`Language:browser:${navigator.language}`);
      (_b = this.game.analytics) == null ? void 0 : _b.sendDesignEvent(`Language:game:${this._language}`);
    }
  };

  // src/sceneTransition/CanvasSceneTransition.ts
  var CanvasSceneTransition = class extends Phaser.GameObjects.Image {
    constructor(scene, key, frame) {
      super(scene, 0, 0, key, frame);
      this.sceneManager = this.scene.game.scene;
    }
    changeScene(currentSceneKey, newSceneKey, newSceneData) {
      if (this.instantChange) {
        this.emit(SceneTransitionEvent.START, this, currentSceneKey, newSceneKey, newSceneData);
        this.emit(SceneTransitionEvent.COMPLETE, this, currentSceneKey, newSceneKey, newSceneData);
        let currenScene = this.sceneManager.getScene(currentSceneKey);
        currenScene.scene.start(newSceneKey, newSceneData);
        return;
      }
      this.emit(SceneTransitionEvent.START, this, currentSceneKey, newSceneKey, newSceneData);
      this.resize();
      this.fadeIn(currentSceneKey, newSceneKey, newSceneData);
    }
    fadeIn(currentSceneKey, newSceneKey, newSceneData) {
      this.revive();
      this.alpha = 0;
      this.scene.tweens.add({
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Quadratic.In,
        alpha: 1,
        onComplete: () => {
          this.doChangeScenes(currentSceneKey, newSceneKey, newSceneData);
        }
      });
    }
    doChangeScenes(currentSceneKey, newSceneKey, newSceneData) {
      let currentScene = this.sceneManager.getScene(currentSceneKey);
      currentScene.events.once(Phaser.Scenes.Events.SHUTDOWN, this.fadeOut.bind(this, currentSceneKey, newSceneKey));
      currentScene.scene.start(newSceneKey, newSceneData);
      this.emit(SceneTransitionEvent.COMPLETE, this, currentSceneKey, newSceneKey, newSceneData);
    }
    fadeOut() {
      this.scene.tweens.add({
        targets: this,
        duration: 400,
        ease: Phaser.Math.Easing.Quadratic.In,
        alpha: 0,
        onComplete: () => {
          this.kill();
        }
      });
    }
    resize() {
      this.setDisplaySize(Config.GAME_WIDTH + 4, Config.GAME_HEIGHT + 4);
      this.x = Config.HALF_GAME_WIDTH;
      this.y = Config.HALF_GAME_HEIGHT;
    }
    destroy() {
      super.destroy();
    }
  };

  // src/robowhale/phaser3/scenes/Scaler.ts
  var ScaleType;
  (function(ScaleType2) {
    ScaleType2["EXACT"] = "EXACT";
    ScaleType2["FIT"] = "FIT";
    ScaleType2["FILL"] = "FILL";
    ScaleType2["ENVELOP"] = "ENVELOP";
  })(ScaleType || (ScaleType = {}));
  var Scaler = class {
    constructor(scene) {
      this.scene = scene;
      this.items = new Map();
    }
    scale(obj, type = ScaleType.EXACT, options) {
      this.items.set(obj, {
        obj,
        type,
        options
      });
    }
    onResize() {
      this.items.forEach((item) => {
        switch (item.type) {
          case ScaleType.FILL:
            item.obj.displayWidth = Config.GAME_WIDTH;
            item.obj.displayHeight = Config.GAME_HEIGHT;
            break;
          case ScaleType.ENVELOP:
            let scaleX = (Config.GAME_WIDTH + 2) / item.obj.width;
            let scaleY = (Config.GAME_HEIGHT + 2) / item.obj.height;
            item.obj.scale = Math.max(scaleX, scaleY);
            break;
          case ScaleType.FIT:
            let fitScaleX = Config.GAME_WIDTH / item.obj.width;
            let fitScaleY = Config.GAME_HEIGHT / item.obj.height;
            item.obj.scale = Math.min(fitScaleX, fitScaleY);
            break;
          default:
            item.obj.scale = Config.ASSETS_SCALE;
            break;
        }
      });
    }
    destroy() {
      this.items.clear();
      this.items = null;
    }
  };

  // src/robowhale/phaser3/scenes/FastForward.ts
  var FastForwardEvent;
  (function(FastForwardEvent2) {
    FastForwardEvent2["START"] = "__START";
    FastForwardEvent2["STOP"] = "__STOP";
  })(FastForwardEvent || (FastForwardEvent = {}));
  var FastForward = class extends Phaser.Events.EventEmitter {
    constructor(scene) {
      super();
      this.isActive = false;
      this._timeScale = 1;
      this.scene = scene;
    }
    get timeScale() {
      return this._timeScale;
    }
    start(timeScale) {
      if (this.isActive) {
        return;
      }
      this.isActive = true;
      this._timeScale = timeScale;
      this.scene.tweens.timeScale = timeScale;
      this.scene.time.timeScale = timeScale;
      this.getFastForwardables().forEach((item) => item.timeScale = timeScale);
      this.emit(FastForwardEvent.START, this, timeScale);
    }
    stop() {
      if (this.isActive === false) {
        return;
      }
      this.isActive = false;
      this._timeScale = 1;
      this.scene.tweens.timeScale = 1;
      this.scene.time.timeScale = 1;
      this.getFastForwardables().forEach((item) => item.timeScale = 1);
      this.emit(FastForwardEvent.STOP, this);
    }
    getFastForwardables() {
      return this.scene.sys.updateList.getActive().filter((item) => this.isFastForwardable(item));
    }
    isFastForwardable(item) {
      return typeof item["timeScale"] === "number";
    }
    destroy() {
      this.stop();
      super.destroy();
    }
  };

  // src/robowhale/phaser3/scenes/BaseScene.ts
  var BaseScene = class extends Phaser.Scene {
    get keyboard() {
      return this.input.keyboard;
    }
    get activePointer() {
      return this.input.activePointer;
    }
    init(data) {
      var _a, _b;
      this.initData = data != null ? data : void 0;
      this.events.once("shutdown", this.onShutdown, this);
      this.pinner = new Pinner();
      this.sizer = new Scaler(this);
      this.fastForward = new FastForward(this);
      this.shiftKey = (_a = this.shiftKey) != null ? _a : this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SHIFT);
      this.ctrlKey = (_b = this.ctrlKey) != null ? _b : this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.CTRL);
    }
    create() {
    }
    size(obj, type = ScaleType.EXACT, options) {
      this.sizer.scale(obj, type, options);
    }
    pin(obj, x, y, offsetX, offsetY) {
      this.pinner.pin(obj, x, y, offsetX, offsetY);
    }
    resize() {
      this.sizer.onResize();
      this.pinner.onResize(Config.GAME_WIDTH, Config.GAME_HEIGHT, Config.ASSETS_SCALE);
    }
    restart(data) {
      this.game.restartScene(this.scene.key, data != null ? data : this.initData);
    }
    onKeyDown(key, callback, context) {
      this.keyboard.on(`keydown-${key}`, callback, context);
    }
    onceKeyDown(key, callback, context) {
      this.keyboard.once(`keydown-${key}`, callback, context);
    }
    changeScene(newScene, data) {
      this.game.changeScene(this.scene.key, newScene, data);
    }
    onShutdown() {
      this.pinner.destroy();
      this.pinner = null;
      this.sizer.destroy();
      this.sizer = null;
      this.fastForward.destroy();
      this.fastForward = null;
    }
  };

  // src/boosters/Booster.ts
  var EventEmitter2 = Phaser.Events.EventEmitter;
  var BoosterEvent;
  (function(BoosterEvent2) {
    BoosterEvent2["NUM_CHANGED"] = "IngameBooster_NUM_CHANGED";
  })(BoosterEvent || (BoosterEvent = {}));
  var Booster = class extends EventEmitter2 {
    get num() {
      return this._num;
    }
    set num(value) {
      this._num = Math.max(0, value);
      this.emit(BoosterEvent.NUM_CHANGED, this);
    }
    get type() {
      return this._type;
    }
    constructor(type, num) {
      super();
      this._type = type;
      this._num = num;
    }
  };

  // src/boosters/BoostersManager.ts
  var BoostersManager = class {
    constructor(game) {
      this.game = game;
      this.store = this.game.store;
      this.store.on(GameStoreEvent.CLEAR, this.onSaveDataCleared, this);
      this.texts = this.game.texts;
      this.texts.on(GameTextsEvent.LANGUAGE_CHANGE, this.onLanguageChange, this);
      this.createBoosters();
    }
    onSaveDataCleared() {
      this.boosters.forEach((booster) => {
        booster.num = 0;
      });
    }
    onLanguageChange() {
      let allTexts = this.game.texts.texts.boosters;
      this.boosters.forEach((booster) => {
        let texts = allTexts[booster.type];
        booster.title = texts.title;
        booster.hint = texts.hint;
      });
    }
    createBoosters() {
      let allTexts = this.game.texts.texts.boosters;
      let saveData = this.store.getValue(GameStoreKey.BOOSTERS);
      let types = [BoosterType.GLOVE, BoosterType.ROLLING_PIN, BoosterType.LOLLIPOP, BoosterType.UNDO];
      this.boosters = types.map((type) => {
        var _a;
        let num = (_a = saveData[type]) != null ? _a : 0;
        let texts = allTexts[type];
        let booster = new Booster(type, num);
        booster.title = texts.title;
        booster.hint = texts.hint;
        booster.on(BoosterEvent.NUM_CHANGED, this.onBoosterNumChanged, this);
        return booster;
      });
    }
    onBoosterNumChanged(booster) {
      let currentData = this.store.getValue(GameStoreKey.BOOSTERS);
      let newData = __spreadProps(__spreadValues({}, currentData), {[booster.type]: booster.num});
      this.store.saveValue(GameStoreKey.BOOSTERS, newData);
    }
    getByType(type) {
      return this.boosters.find((booster) => booster.type === type);
    }
    getRandom() {
      return Phaser.Math.RND.pick(this.boosters);
    }
    save() {
      return {
        [BoosterType.GLOVE]: this.getByType(BoosterType.GLOVE).num,
        [BoosterType.ROLLING_PIN]: this.getByType(BoosterType.ROLLING_PIN).num,
        [BoosterType.LOLLIPOP]: this.getByType(BoosterType.LOLLIPOP).num
      };
    }
    restore(savedBoosters) {
      Object.entries(savedBoosters).forEach(([type, num]) => {
        this.getByType(type).num = num;
      });
    }
  };

  // src/pregameBoosters/PregameBooster.ts
  var EventEmitter3 = Phaser.Events.EventEmitter;
  var PregameBoosterEvent;
  (function(PregameBoosterEvent2) {
    PregameBoosterEvent2["NUM_CHANGED"] = "PregameBooster_NUM_CHANGED";
  })(PregameBoosterEvent || (PregameBoosterEvent = {}));
  var PregameBooster = class extends EventEmitter3 {
    get num() {
      return this._num;
    }
    set num(value) {
      this._num = Math.max(0, value);
      this.emit(PregameBoosterEvent.NUM_CHANGED, this);
    }
    get type() {
      return this._type;
    }
    constructor(type, num) {
      super();
      this._type = type;
      this._num = num;
    }
    updateTexts(texts) {
      let boosterTexts = texts.pregame_boosters;
      this.title = boosterTexts[this._type];
    }
  };

  // src/pregameBoosters/PregameBoostersManager.ts
  var PregameBoostersManager = class {
    constructor(game) {
      this.game = game;
      this.store = this.game.store;
      this.store.on(GameStoreEvent.CLEAR, this.onSaveDataCleared, this);
      this.texts = this.game.texts;
      this.texts.on(GameTextsEvent.LANGUAGE_CHANGE, this.onLanguageChange, this);
      this.initBoosters();
    }
    onSaveDataCleared() {
      this.items.forEach((booster) => {
        booster.num = 0;
      });
    }
    onLanguageChange() {
      this.items.forEach((booster) => {
        booster.updateTexts(this.texts.texts);
      });
    }
    initBoosters() {
      let saveData = this.store.getValue(GameStoreKey.PREGAME_BOOSTERS);
      let types = [PregameBoosterType.STRIPES, PregameBoosterType.BOMB, PregameBoosterType.SUPER_SPHERE];
      this.items = types.map((type) => {
        var _a;
        let num = (_a = saveData[type]) != null ? _a : 0;
        let booster = new PregameBooster(type, num);
        booster.updateTexts(this.texts.texts);
        booster.on(PregameBoosterEvent.NUM_CHANGED, this.onBoosterNumChanged, this);
        return booster;
      });
    }
    onBoosterNumChanged(booster) {
      let saveKey = GameStoreKey.PREGAME_BOOSTERS;
      let currentData = this.store.getValue(saveKey);
      let newData = __spreadProps(__spreadValues({}, currentData), {[booster.type]: booster.num});
      this.store.saveValue(saveKey, newData);
    }
    getByType(type) {
      return this.items.find((booster) => booster.type === type);
    }
  };

  // src/robowhale/utils/to-ms.ts
  function toMs(value) {
    let sum = 0;
    if (typeof value.days === "number") {
      sum += value.days * 24 * 60 * 60 * 1e3;
    }
    if (typeof value.hours === "number") {
      sum += value.hours * 60 * 60 * 1e3;
    }
    if (typeof value.minutes === "number") {
      sum += value.minutes * 60 * 1e3;
    }
    if (typeof value.seconds === "number") {
      sum += value.seconds * 1e3;
    }
    if (typeof value.ms === "number") {
      sum += value.ms;
    }
    return sum;
  }

  // src/lives/LifeTimer.ts
  var LifeTimerEvent;
  (function(LifeTimerEvent2) {
    LifeTimerEvent2["START"] = "LifeTimer_START";
    LifeTimerEvent2["COMPLETE"] = "LifeTimer_COMPLETE";
  })(LifeTimerEvent || (LifeTimerEvent = {}));
  var _LifeTimer = class extends Phaser.Events.EventEmitter {
    constructor(game) {
      super();
      this._isRunning = false;
      this.isPaused = false;
      this._timer = 0;
      this.game = game;
    }
    static getDefaulDuration() {
      if (UrlParams.has("lifeTimerMs")) {
        return UrlParams.getNumber("lifeTimerMs", 1e4);
      }
      return toMs({minutes: 30});
    }
    get isRunning() {
      return this._isRunning;
    }
    start(durationMs) {
      this.startTime = Date.now();
      this.duration = durationMs;
      this._timer = 0;
      this._isRunning = true;
      this.game.events.on(Phaser.Core.Events.STEP, this.update, this);
      this.emit(LifeTimerEvent.START, this);
    }
    update() {
      if (this._isRunning === false || this.isPaused) {
        return;
      }
      this._timer = Date.now() - this.startTime;
      if (this._timer >= this.duration) {
        this.onTimerComplete();
      }
    }
    getRemainingMs() {
      return this.duration - this._timer;
    }
    getRemainingSeconds() {
      return Math.ceil(this.getRemainingMs() / 1e3);
    }
    getFormattedTime() {
      let ms = this.getRemainingMs();
      let hours = Math.floor(ms / 36e5);
      let minutes = Math.floor(ms % 36e5 / 6e4);
      let seconds = Math.floor(ms % 36e4 % 6e4 / 1e3);
      let hoursStr = hours.toString().padStart(2, "0");
      let minutesStr = minutes.toString().padStart(2, "0");
      let secondsStr = seconds.toString().padStart(2, "0");
      if (hours > 0) {
        return `${hoursStr}:${minutesStr}:${secondsStr}`;
      } else {
        return `${minutesStr}:${secondsStr}`;
      }
    }
    onTimerComplete() {
      this._isRunning = false;
      this.game.events.off(Phaser.Core.Events.STEP, this.update, this);
      this.emit(LifeTimerEvent.COMPLETE, this);
    }
    pause() {
      this.isPaused = true;
    }
    resume() {
      this.isPaused = false;
    }
    forceComplete() {
      this._timer = this.duration;
      this.onTimerComplete();
    }
    destroy() {
      this.game.events.off(Phaser.Core.Events.STEP, this.update, this);
    }
  };
  var LifeTimer = _LifeTimer;
  LifeTimer.DURATION_MS = _LifeTimer.getDefaulDuration();

  // src/lives/LivesManager.ts
  var LivesManagerEvent;
  (function(LivesManagerEvent2) {
    LivesManagerEvent2["REFILL_TIMER_START"] = "__REFILL_TIMER_START";
    LivesManagerEvent2["REFILL_TIMER_COMPLETE"] = "__REFILL_TIMER_COMPLETE";
    LivesManagerEvent2["UNLIMITED_TIMER_START"] = "__UNLIMITED_TIMER_START";
    LivesManagerEvent2["UNLIMITED_TIMER_COMPLETE"] = "__UNLIMITED_TIMER_COMPLETE";
    LivesManagerEvent2["LIVES_ADDED"] = "__LIFE_ADDED";
    LivesManagerEvent2["PAGE_VISIBLE"] = "__PAGE_VISIBLE";
  })(LivesManagerEvent || (LivesManagerEvent = {}));
  var LivesManager = class extends Phaser.Events.EventEmitter {
    constructor(game) {
      super();
      this.livesOnHidden = 0;
      this.game = game;
      this.game.store.on(GameStoreEvent.CLEAR, this.onSaveDataReset, this);
      this.checkUrlParam();
      this.initUnlimitedTimerOnStart();
      this.initRefillTimerOnStart();
      this.addVisibilityEventHandlers();
    }
    get refillTimer() {
      return this._refillTimer;
    }
    get unlimitedTimer() {
      return this._unlimitedTimer;
    }
    onSaveDataReset() {
      if (this._unlimitedTimer) {
        this.onUnlimitedTimerComplete();
      }
    }
    checkUrlParam() {
      if (UrlParams.has("lives") === false) {
        return;
      }
      let lives = UrlParams.getNumber("lives", this.getInitialLivesNum());
      let clampedLives = Phaser.Math.Clamp(Math.round(lives), 0, this.getInitialLivesNum());
      this.game.store.saveValue(GameStoreKey.LIVES, clampedLives);
      this.game.store.saveValue(GameStoreKey.LIVES_REFILL_TIMER_START, Date.now());
      this.game.store.saveValue(GameStoreKey.LIVES_REFILL_TIMER_DURATION, LifeTimer.DURATION_MS);
    }
    initUnlimitedTimerOnStart() {
      let savedStartTime = this.game.store.getNumber(GameStoreKey.LIVES_UNLIMITED_TIMER_START);
      let savedDuration = this.game.store.getNumber(GameStoreKey.LIVES_UNLIMITED_TIMER_DURATION);
      let queryValue = UrlParams.getNumber("livesUnlim", 0);
      if (queryValue > 0) {
        savedStartTime = Date.now();
        savedDuration = queryValue;
      }
      let completeTime = savedStartTime + savedDuration;
      let now2 = Date.now();
      if (now2 < completeTime) {
        let newDuration = completeTime - now2;
        this.startUnlimitedTimer(newDuration);
      }
    }
    initRefillTimerOnStart() {
      if (this.isFull() || this.isUnlimited()) {
        return;
      }
      let savedStartTime = this.game.store.getNumber(GameStoreKey.LIVES_REFILL_TIMER_START);
      let savedDuration = this.game.store.getNumber(GameStoreKey.LIVES_REFILL_TIMER_DURATION);
      let completeTime = savedStartTime + savedDuration;
      let msPassed = Date.now() - savedStartTime;
      let now2 = Date.now();
      if (now2 < completeTime) {
        let newDuration = completeTime - now2;
        this.startRefillTimer(newDuration);
        return;
      }
      if (now2 >= completeTime) {
        msPassed -= savedDuration;
        this.changeLivesNum(1);
      }
      let livesReplenished = Math.floor(msPassed / LifeTimer.DURATION_MS);
      let livesNum = this.changeLivesNum(livesReplenished);
      if (livesNum < this.getInitialLivesNum()) {
        let msRemain = msPassed - livesReplenished * LifeTimer.DURATION_MS;
        let timerDuration = LifeTimer.DURATION_MS - msRemain;
        this.startRefillTimer(timerDuration);
      }
    }
    addVisibilityEventHandlers() {
      this.game.events.on(Phaser.Core.Events.HIDDEN, this.onHidden, this);
      this.game.events.on(Phaser.Core.Events.VISIBLE, this.onVisible, this);
    }
    onHidden() {
      this.livesOnHidden = this.getLivesNum();
      this.removeRefillTimer();
    }
    onVisible() {
      this.initRefillTimerOnStart();
      let livesGained = this.getLivesNum() - this.livesOnHidden;
      this.emit(LivesManagerEvent.PAGE_VISIBLE, this, livesGained);
    }
    addLives(num) {
      if (this.isUnlimited()) {
        return;
      }
      this.changeLivesNum(num);
      if (this.isFull()) {
        this.removeRefillTimer();
        this.emit(LivesManagerEvent.REFILL_TIMER_COMPLETE, this);
      }
      this.emit(LivesManagerEvent.LIVES_ADDED, this, num);
    }
    removeLife() {
      if (this.isUnlimited()) {
        return;
      }
      this.changeLivesNum(-1);
      this.removeRefillTimer();
      this.startRefillTimer();
    }
    removeRefillTimer() {
      if (!this._refillTimer) {
        return;
      }
      this._refillTimer.off(LifeTimerEvent.COMPLETE, this.onRefillTimerComplete, this);
      this._refillTimer.destroy();
      this._refillTimer = null;
    }
    startRefillTimer(duration = LifeTimer.DURATION_MS) {
      this._refillTimer = new LifeTimer(this.game);
      this._refillTimer.once(LifeTimerEvent.COMPLETE, this.onRefillTimerComplete, this);
      this._refillTimer.start(duration);
      this.game.store.saveValue(GameStoreKey.LIVES_REFILL_TIMER_START, Date.now());
      this.game.store.saveValue(GameStoreKey.LIVES_REFILL_TIMER_DURATION, duration);
      this.emit(LivesManagerEvent.REFILL_TIMER_START, this, this._refillTimer.getRemainingSeconds());
    }
    onRefillTimerComplete(startNewTimer = true) {
      this.changeLivesNum(1);
      this.removeRefillTimer();
      this.emit(LivesManagerEvent.REFILL_TIMER_COMPLETE, this);
      if (startNewTimer && this.isFull() === false) {
        this.startRefillTimer();
      }
    }
    changeLivesNum(delta) {
      return this.game.store.changeNumber(GameStoreKey.LIVES, delta, 0, this.getInitialLivesNum());
    }
    getLivesNum() {
      return this.game.store.getNumber(GameStoreKey.LIVES);
    }
    getInitialLivesNum() {
      return window.game.config.initial_lives;
    }
    isFull() {
      return this.getLivesNum() >= this.getInitialLivesNum();
    }
    startUnlimitedLives(durationMs) {
      this.refillAllLives();
      this.removeRefillTimer();
      let remainingMs = 0;
      if (this._unlimitedTimer) {
        remainingMs = this._unlimitedTimer.getRemainingMs();
        this._unlimitedTimer.destroy();
        this._unlimitedTimer = null;
      }
      this.startUnlimitedTimer(durationMs + remainingMs);
    }
    refillAllLives() {
      if (this.getLivesNum() >= this.getInitialLivesNum()) {
        return;
      }
      let livesToAdd = this.getInitialLivesNum() - this.getLivesNum();
      this.changeLivesNum(livesToAdd);
    }
    startUnlimitedTimer(durationMs) {
      this._unlimitedTimer = new LifeTimer(this.game);
      this._unlimitedTimer.once(LifeTimerEvent.COMPLETE, this.onUnlimitedTimerComplete, this);
      this._unlimitedTimer.start(durationMs);
      this.game.store.saveValue(GameStoreKey.LIVES_UNLIMITED_TIMER_START, Date.now());
      this.game.store.saveValue(GameStoreKey.LIVES_UNLIMITED_TIMER_DURATION, durationMs);
      this.emit(LivesManagerEvent.UNLIMITED_TIMER_START, this, this._unlimitedTimer.getRemainingSeconds());
    }
    onUnlimitedTimerComplete() {
      this._unlimitedTimer.destroy();
      this._unlimitedTimer = null;
      this.emit(LivesManagerEvent.UNLIMITED_TIMER_COMPLETE, this);
      if (this.isFull() === false) {
        this.startRefillTimer();
      }
    }
    isUnlimited() {
      return Boolean(this._unlimitedTimer);
    }
  };

  // src/scenes/levelMap/wheelReward/WheelRewardType.ts
  var WheelRewardEvent;
  (function(WheelRewardEvent2) {
    WheelRewardEvent2["COLLECT_START"] = "__COLLECT_START";
    WheelRewardEvent2["COLLECT_COMPLETE"] = "__COLLECT_COMPLETE";
  })(WheelRewardEvent || (WheelRewardEvent = {}));
  var WheelRewardType;
  (function(WheelRewardType5) {
    WheelRewardType5["COINS"] = "coins";
    WheelRewardType5["UNDO"] = "undo";
    WheelRewardType5["GLOVE"] = "glove";
    WheelRewardType5["ROLLING_PIN"] = "rolling_pin";
    WheelRewardType5["LOLLIPOP"] = "lollipop";
    WheelRewardType5["STRIPES"] = "stripes";
    WheelRewardType5["BOMB"] = "bomb";
    WheelRewardType5["SUPER_SPHERE"] = "super_sphere";
  })(WheelRewardType || (WheelRewardType = {}));
  var WheelRewardUtils = class {
    static getAllTypes() {
      return Object.values(WheelRewardType);
    }
    static getRewardNum(type) {
      var _a;
      return (_a = window.game.config.wheel_rewards[type]) != null ? _a : 1;
    }
    static getRewardData(type) {
      return {
        type,
        num: this.getRewardNum(type)
      };
    }
  };

  // src/GiftsManager.ts
  var GiftsManager = class extends Phaser.Events.EventEmitter {
    constructor(game) {
      super();
      this.game = game;
      this.store = this.game.store;
      let reset = UrlParams.getBool("resetGift");
      if (reset) {
        this.store.saveValue(GameStoreKey.GIFT_STARS_NUM, 0);
        this.store.saveValue(GameStoreKey.GIFTS_OPENED, 0);
        console.log("Gift save data was cleared!");
      }
    }
    getCurrentStars() {
      return this.store.getNumber(GameStoreKey.GIFT_STARS_NUM);
    }
    getTargetStars() {
      let openedGiftsNum = this.getOpenedGiftsNum();
      if (openedGiftsNum === 0) {
        return 11;
      } else if (openedGiftsNum === 1) {
        return 9;
      }
      return 10;
    }
    getOpenedGiftsNum() {
      return this.store.getNumber(GameStoreKey.GIFTS_OPENED);
    }
    getGiftRewards(rewardsNum) {
      let isFirstGift = this.getOpenedGiftsNum() === 0;
      if (isFirstGift) {
        return [
          WheelRewardUtils.getRewardData(WheelRewardType.STRIPES),
          WheelRewardUtils.getRewardData(WheelRewardType.BOMB),
          WheelRewardUtils.getRewardData(WheelRewardType.SUPER_SPHERE)
        ];
      }
      let rewardTypes = shuffle_default(WheelRewardUtils.getAllTypes()).slice(0, rewardsNum);
      return rewardTypes.map((type) => WheelRewardUtils.getRewardData(type));
    }
    saveRewards(...rewards) {
      rewards.forEach((reward) => {
        this.saveReward(reward.type, reward.num);
      });
    }
    saveReward(rewardType, rewardNum) {
      switch (rewardType) {
        case WheelRewardType.STRIPES:
          this.game.pregameBoosters.getByType(PregameBoosterType.STRIPES).num += rewardNum;
          this.game.analytics.addResource(ResourceCurrency.PREGAME_BOOSTERS, rewardNum, PregameBoosterType.STRIPES, "Gift");
          break;
        case WheelRewardType.BOMB:
          this.game.pregameBoosters.getByType(PregameBoosterType.BOMB).num += rewardNum;
          this.game.analytics.addResource(ResourceCurrency.PREGAME_BOOSTERS, rewardNum, PregameBoosterType.BOMB, "Gift");
          break;
        case WheelRewardType.SUPER_SPHERE:
          this.game.pregameBoosters.getByType(PregameBoosterType.SUPER_SPHERE).num += rewardNum;
          this.game.analytics.addResource(ResourceCurrency.PREGAME_BOOSTERS, rewardNum, PregameBoosterType.SUPER_SPHERE, "Gift");
          break;
        case WheelRewardType.UNDO:
          this.game.boosters.getByType(BoosterType.UNDO).num += rewardNum;
          this.game.analytics.addResource(ResourceCurrency.BOOSTERS, rewardNum, BoosterType.UNDO, "Gift");
          break;
        case WheelRewardType.GLOVE:
          this.game.boosters.getByType(BoosterType.GLOVE).num += rewardNum;
          this.game.analytics.addResource(ResourceCurrency.BOOSTERS, rewardNum, BoosterType.GLOVE, "Gift");
          break;
        case WheelRewardType.ROLLING_PIN:
          this.game.boosters.getByType(BoosterType.ROLLING_PIN).num += rewardNum;
          this.game.analytics.addResource(ResourceCurrency.BOOSTERS, rewardNum, BoosterType.ROLLING_PIN, "Gift");
          break;
        case WheelRewardType.LOLLIPOP:
          this.game.boosters.getByType(BoosterType.LOLLIPOP).num += rewardNum;
          this.game.analytics.addResource(ResourceCurrency.BOOSTERS, rewardNum, BoosterType.LOLLIPOP, "Gift");
          break;
        case WheelRewardType.COINS:
          this.game.store.changeNumber(GameStoreKey.COINS, rewardNum);
          this.game.analytics.addResource(ResourceCurrency.COINS, rewardNum, ResourceItemType.COIN, "Gift");
          break;
        default:
          break;
      }
    }
    onGiftOpen() {
      this.store.changeNumber(GameStoreKey.GIFT_STARS_NUM, -this.getTargetStars(), 0);
      this.store.changeNumber(GameStoreKey.GIFTS_OPENED, 1);
    }
  };

  // src/scenes/levelEditor/items/ItemType.ts
  var ItemSuperType;
  (function(ItemSuperType7) {
    ItemSuperType7["BISCUIT"] = "BISCUIT";
    ItemSuperType7["COOKIE"] = "COOKIE";
    ItemSuperType7["MARSHMALLOW"] = "MARSHMALLOW";
    ItemSuperType7["DROP_ITEM"] = "DROP_ITEM";
    ItemSuperType7["CHOCOLATE"] = "CHOCOLATE";
    ItemSuperType7["DONUT_BOX"] = "DONUT_BOX";
    ItemSuperType7["CANDY_BOTTLE"] = "CANDY_BOTTLE";
    ItemSuperType7["APPLE_PLATTER"] = "APPLE_PLATTER";
    ItemSuperType7["COLOR_CAKE"] = "COLOR_CAKE";
    ItemSuperType7["LICORICE"] = "LICORICE";
    ItemSuperType7["GUMMY"] = "GUMMY";
    ItemSuperType7["GUMMY_BLOCKER"] = "GUMMY_BLOCKER";
    ItemSuperType7["MYSTERY_BOX"] = "MYSTERY_BOX";
    ItemSuperType7["GENERATOR"] = "GENERATOR";
    ItemSuperType7["CHICK"] = "CHICK";
  })(ItemSuperType || (ItemSuperType = {}));
  var ItemType;
  (function(ItemType19) {
    ItemType19["COOKIE_RED"] = "COOKIE_RED";
    ItemType19["COOKIE_BLUE"] = "COOKIE_BLUE";
    ItemType19["COOKIE_ORANGE"] = "COOKIE_ORANGE";
    ItemType19["COOKIE_PURPLE"] = "COOKIE_PURPLE";
    ItemType19["COOKIE_PINK"] = "COOKIE_PINK";
    ItemType19["COOKIE_YELLOW"] = "COOKIE_YELLOW";
    ItemType19["MARSHMALLOW_COMMON"] = "MARSHMALLOW_COMMON";
    ItemType19["MARSHMALLOW_RED"] = "MARSHMALLOW_RED";
    ItemType19["MARSHMALLOW_BLUE"] = "MARSHMALLOW_BLUE";
    ItemType19["MARSHMALLOW_ORANGE"] = "MARSHMALLOW_ORANGE";
    ItemType19["MARSHMALLOW_PURPLE"] = "MARSHMALLOW_PURPLE";
    ItemType19["MARSHMALLOW_PINK"] = "MARSHMALLOW_PINK";
    ItemType19["MARSHMALLOW_YELLOW"] = "MARSHMALLOW_YELLOW";
    ItemType19["MARSHMALLOW_DOUBLE"] = "MARSHMALLOW_DOUBLE";
    ItemType19["CHOCOLATE_COMMON"] = "CHOCOLATE_COMMON";
    ItemType19["CHOCOLATE_RED"] = "CHOCOLATE_RED";
    ItemType19["CHOCOLATE_BLUE"] = "CHOCOLATE_BLUE";
    ItemType19["CHOCOLATE_ORANGE"] = "CHOCOLATE_ORANGE";
    ItemType19["CHOCOLATE_PURPLE"] = "CHOCOLATE_PURPLE";
    ItemType19["CHOCOLATE_PINK"] = "CHOCOLATE_PINK";
    ItemType19["CHOCOLATE_YELLOW"] = "CHOCOLATE_YELLOW";
    ItemType19["CHOCOLATE_DOUBLE"] = "CHOCOLATE_DOUBLE";
    ItemType19["CHOCOLATE_TRIPLE"] = "CHOCOLATE_TRIPLE";
    ItemType19["GUMMY_VERTICAL"] = "GUMMY_VERTICAL";
    ItemType19["GUMMY_VERTICAL_LARGE"] = "GUMMY_VERTICAL_LARGE";
    ItemType19["GUMMY_HORIZONTAL"] = "GUMMY_HORIZONTAL";
    ItemType19["GUMMY_HORIZONTAL_LARGE"] = "GUMMY_HORIZONTAL_LARGE";
    ItemType19["GUMMY_BLOCKER"] = "GUMMY_BLOCKER";
    ItemType19["LICORICE_CHOCO"] = "LICORICE_CHOCO";
    ItemType19["LICORICE_YELLOW"] = "LICORICE_YELLOW";
    ItemType19["BISCUIT"] = "BISCUIT";
    ItemType19["CANDY_BOTTLE"] = "CANDY_BOTTLE";
    ItemType19["DROP_ITEM"] = "DROP_ITEM";
    ItemType19["DONUT_BOX"] = "DONUT_BOX";
    ItemType19["APPLES_PLATTER"] = "APPLES_PLATTER";
    ItemType19["COLOR_CAKE"] = "COLOR_CAKE";
    ItemType19["MYSTERY_BOX"] = "MYSTERY_BOX";
    ItemType19["GENERATOR"] = "GENERATOR";
    ItemType19["CHICK"] = "CHICK";
  })(ItemType || (ItemType = {}));
  var _ItemTypeUtil = class {
    static getAllTypes() {
      return Object.values(ItemType);
    }
    static getAllSuperTypes() {
      return Object.values(ItemSuperType);
    }
    static getItemTypeByFrame(frame) {
      return findKey_default(_ItemTypeUtil.ITEM_TYPES_FRAMES_MAP, (_frame) => {
        return _frame === frame;
      });
    }
    static getFrameByItemType(itemType) {
      return _ItemTypeUtil.ITEM_TYPES_FRAMES_MAP[itemType];
    }
    static getSubtypes(superType) {
      return this.ITEM_SUPER_TYPES_MAP[superType];
    }
    static getItemSuperType(itemType) {
      return findKey_default(this.ITEM_SUPER_TYPES_MAP, (value) => value.includes(itemType));
    }
  };
  var ItemTypeUtil = _ItemTypeUtil;
  ItemTypeUtil.ITEM_TYPES_FRAMES_MAP = {
    [ItemType.COOKIE_RED]: "cookies/Circle-Cookie-Red",
    [ItemType.COOKIE_BLUE]: "cookies/Cube-Cookie-Blue",
    [ItemType.COOKIE_ORANGE]: "cookies/Polygon-Cookie-Orange",
    [ItemType.COOKIE_PURPLE]: "cookies/Donut-Cookie-Purple",
    [ItemType.COOKIE_PINK]: "cookies/Moon-Cookie-Pink",
    [ItemType.COOKIE_YELLOW]: "cookies/Heart-Cookie-Yellow",
    [ItemType.MARSHMALLOW_COMMON]: "marshmallows/marshmallow_common",
    [ItemType.MARSHMALLOW_RED]: "marshmallows/marshmallow_red",
    [ItemType.MARSHMALLOW_BLUE]: "marshmallows/marshmallow_blue",
    [ItemType.MARSHMALLOW_ORANGE]: "marshmallows/marshmallow_orange",
    [ItemType.MARSHMALLOW_PURPLE]: "marshmallows/marshmallow_purple",
    [ItemType.MARSHMALLOW_PINK]: "marshmallows/marshmallow_pink",
    [ItemType.MARSHMALLOW_YELLOW]: "marshmallows/marshmallow_yellow",
    [ItemType.MARSHMALLOW_DOUBLE]: "marshmallows/marshmallow_double",
    [ItemType.CHOCOLATE_COMMON]: "chocolate/chocolate",
    [ItemType.CHOCOLATE_RED]: "chocolate/chocolate-red",
    [ItemType.CHOCOLATE_BLUE]: "chocolate/chocolate-blue",
    [ItemType.CHOCOLATE_ORANGE]: "chocolate/chocolate-orange",
    [ItemType.CHOCOLATE_PURPLE]: "chocolate/chocolate-purple",
    [ItemType.CHOCOLATE_PINK]: "chocolate/chocolate-pink",
    [ItemType.CHOCOLATE_YELLOW]: "chocolate/chocolate-yellow",
    [ItemType.CHOCOLATE_DOUBLE]: "chocolate/chocolate-double",
    [ItemType.CHOCOLATE_TRIPLE]: "chocolate/chocolate-triple",
    [ItemType.GUMMY_VERTICAL]: "gummies/gummy_vertical",
    [ItemType.GUMMY_VERTICAL_LARGE]: "gummies/gummy_vertical_large",
    [ItemType.GUMMY_HORIZONTAL]: "gummies/gummy_horizontal",
    [ItemType.GUMMY_HORIZONTAL_LARGE]: "gummies/gummy_horizontal_large",
    [ItemType.BISCUIT]: "biscuits/biscuit",
    [ItemType.DROP_ITEM]: "drop_items/cookie_2",
    [ItemType.DONUT_BOX]: "donut_box/box_00",
    [ItemType.CANDY_BOTTLE]: "candy_bottle/candy_bottle",
    [ItemType.APPLES_PLATTER]: "apples_platter/Tray_00",
    [ItemType.COLOR_CAKE]: "color_cake/Cake_00",
    [ItemType.MYSTERY_BOX]: "mystery_box/mystery_box_2",
    [ItemType.GENERATOR]: "generator/generator",
    [ItemType.CHICK]: "chick/Cupcake",
    [ItemType.GUMMY_BLOCKER]: "gummies/blocker",
    [ItemType.LICORICE_CHOCO]: "licorice/Cream-Choco",
    [ItemType.LICORICE_YELLOW]: "licorice/Cream-Yellow"
  };
  ItemTypeUtil.ITEM_SUPER_TYPES_MAP = {
    [ItemSuperType.BISCUIT]: [ItemType.BISCUIT],
    [ItemSuperType.COOKIE]: [ItemType.COOKIE_PURPLE, ItemType.COOKIE_ORANGE, ItemType.COOKIE_BLUE, ItemType.COOKIE_RED, ItemType.COOKIE_PINK, ItemType.COOKIE_YELLOW],
    [ItemSuperType.MARSHMALLOW]: [ItemType.MARSHMALLOW_COMMON, ItemType.MARSHMALLOW_PURPLE, ItemType.MARSHMALLOW_ORANGE, ItemType.MARSHMALLOW_BLUE, ItemType.MARSHMALLOW_RED, ItemType.MARSHMALLOW_PINK, ItemType.MARSHMALLOW_YELLOW, ItemType.MARSHMALLOW_DOUBLE],
    [ItemSuperType.DROP_ITEM]: [ItemType.DROP_ITEM],
    [ItemSuperType.CHOCOLATE]: [ItemType.CHOCOLATE_COMMON, ItemType.CHOCOLATE_PURPLE, ItemType.CHOCOLATE_ORANGE, ItemType.CHOCOLATE_BLUE, ItemType.CHOCOLATE_RED, ItemType.CHOCOLATE_PINK, ItemType.CHOCOLATE_YELLOW, ItemType.CHOCOLATE_DOUBLE, ItemType.CHOCOLATE_TRIPLE],
    [ItemSuperType.DONUT_BOX]: [ItemType.DONUT_BOX],
    [ItemSuperType.CANDY_BOTTLE]: [ItemType.CANDY_BOTTLE],
    [ItemSuperType.APPLE_PLATTER]: [ItemType.APPLES_PLATTER],
    [ItemSuperType.COLOR_CAKE]: [ItemType.COLOR_CAKE],
    [ItemSuperType.LICORICE]: [ItemType.LICORICE_YELLOW, ItemType.LICORICE_CHOCO],
    [ItemSuperType.GUMMY]: [ItemType.GUMMY_VERTICAL, ItemType.GUMMY_VERTICAL_LARGE, ItemType.GUMMY_HORIZONTAL, ItemType.GUMMY_HORIZONTAL_LARGE],
    [ItemSuperType.GUMMY_BLOCKER]: [ItemType.GUMMY_BLOCKER],
    [ItemSuperType.MYSTERY_BOX]: [ItemType.MYSTERY_BOX],
    [ItemSuperType.GENERATOR]: [ItemType.GENERATOR],
    [ItemSuperType.CHICK]: [ItemType.CHICK]
  };

  // src/scenes/gameplay/goals/Goal.ts
  var GoalType;
  (function(GoalType2) {
    GoalType2["COOKIE_RED"] = "COOKIE_RED";
    GoalType2["COOKIE_BLUE"] = "COOKIE_BLUE";
    GoalType2["COOKIE_ORANGE"] = "COOKIE_ORANGE";
    GoalType2["COOKIE_PURPLE"] = "COOKIE_PURPLE";
    GoalType2["COOKIE_PINK"] = "COOKIE_PINK";
    GoalType2["COOKIE_YELLOW"] = "COOKIE_YELLOW";
    GoalType2["LICORICE"] = "LICORICE";
    GoalType2["BISCUIT"] = "BISCUIT";
    GoalType2["MARSHMALLOW"] = "MARSHMALLOW";
    GoalType2["CHOCOLATE"] = "CHOCOLATE";
    GoalType2["DROP_ITEM"] = "DROP_ITEM";
    GoalType2["CANDY"] = "CANDY";
    GoalType2["APPLE"] = "APPLE";
    GoalType2["DONUT"] = "DONUT";
    GoalType2["GUMMY"] = "GUMMY";
    GoalType2["CHICK"] = "CHICK";
  })(GoalType || (GoalType = {}));
  var GoalItemType;
  (function(GoalItemType2) {
    GoalItemType2["COOKIE_RED"] = "COOKIE_RED";
    GoalItemType2["COOKIE_BLUE"] = "COOKIE_BLUE";
    GoalItemType2["COOKIE_ORANGE"] = "COOKIE_ORANGE";
    GoalItemType2["COOKIE_PURPLE"] = "COOKIE_PURPLE";
    GoalItemType2["COOKIE_PINK"] = "COOKIE_PINK";
    GoalItemType2["COOKIE_YELLOW"] = "COOKIE_YELLOW";
    GoalItemType2["MARSHMALLOW_COMMON"] = "MARSHMALLOW_COMMON";
    GoalItemType2["MARSHMALLOW_RED"] = "MARSHMALLOW_RED";
    GoalItemType2["MARSHMALLOW_BLUE"] = "MARSHMALLOW_BLUE";
    GoalItemType2["MARSHMALLOW_ORANGE"] = "MARSHMALLOW_ORANGE";
    GoalItemType2["MARSHMALLOW_PURPLE"] = "MARSHMALLOW_PURPLE";
    GoalItemType2["MARSHMALLOW_PINK"] = "MARSHMALLOW_PINK";
    GoalItemType2["MARSHMALLOW_YELLOW"] = "MARSHMALLOW_YELLOW";
    GoalItemType2["MARSHMALLOW_DOUBLE"] = "MARSHMALLOW_DOUBLE";
    GoalItemType2["CHOCOLATE_COMMON"] = "CHOCOLATE_COMMON";
    GoalItemType2["CHOCOLATE_RED"] = "CHOCOLATE_RED";
    GoalItemType2["CHOCOLATE_BLUE"] = "CHOCOLATE_BLUE";
    GoalItemType2["CHOCOLATE_ORANGE"] = "CHOCOLATE_ORANGE";
    GoalItemType2["CHOCOLATE_PURPLE"] = "CHOCOLATE_PURPLE";
    GoalItemType2["CHOCOLATE_PINK"] = "CHOCOLATE_PINK";
    GoalItemType2["CHOCOLATE_YELLOW"] = "CHOCOLATE_YELLOW";
    GoalItemType2["CHOCOLATE_DOUBLE"] = "CHOCOLATE_DOUBLE";
    GoalItemType2["CHOCOLATE_TRIPLE"] = "CHOCOLATE_TRIPLE";
    GoalItemType2["LICORICE"] = "LICORICE";
    GoalItemType2["BISCUIT"] = "BISCUIT";
    GoalItemType2["CANDY"] = "CANDY";
    GoalItemType2["DROP_ITEM"] = "DROP_ITEM";
    GoalItemType2["DONUT"] = "DONUT";
    GoalItemType2["APPLE"] = "APPLE";
    GoalItemType2["CHICK"] = "CHICK";
    GoalItemType2["GUMMY_VERTICAL"] = "GUMMY_VERTICAL";
    GoalItemType2["GUMMY_VERTICAL_LARGE"] = "GUMMY_VERTICAL_LARGE";
    GoalItemType2["GUMMY_HORIZONTAL"] = "GUMMY_HORIZONTAL";
    GoalItemType2["GUMMY_HORIZONTAL_LARGE"] = "GUMMY_HORIZONTAL_LARGE";
  })(GoalItemType || (GoalItemType = {}));
  var GoalUtils = class {
    static createGoalsArray(goalsConfig) {
      let nonZeroKeys = Object.keys(goalsConfig).filter((key) => goalsConfig[key] > 0);
      return nonZeroKeys.map((goalType) => {
        return {
          type: goalType,
          collectedNum: 0,
          targetNum: goalsConfig[goalType]
        };
      });
    }
    static getAllTypes() {
      return Object.values(GoalType);
    }
    static getGoalType(itemType) {
      return findKey_default(this.SUBTYPES_MAP, (value) => value.includes(itemType));
    }
    static getItemTypes(goalType) {
      return this.GOALS_ITEM_TYPES_MAP[goalType];
    }
  };
  GoalUtils.SUBTYPES_MAP = {
    [GoalType.LICORICE]: [GoalItemType.LICORICE],
    [GoalType.BISCUIT]: [GoalItemType.BISCUIT],
    [GoalType.COOKIE_PURPLE]: [GoalItemType.COOKIE_PURPLE],
    [GoalType.COOKIE_RED]: [GoalItemType.COOKIE_RED],
    [GoalType.COOKIE_YELLOW]: [GoalItemType.COOKIE_YELLOW],
    [GoalType.COOKIE_PINK]: [GoalItemType.COOKIE_PINK],
    [GoalType.COOKIE_BLUE]: [GoalItemType.COOKIE_BLUE],
    [GoalType.COOKIE_ORANGE]: [GoalItemType.COOKIE_ORANGE],
    [GoalType.DROP_ITEM]: [GoalItemType.DROP_ITEM],
    [GoalType.MARSHMALLOW]: [GoalItemType.MARSHMALLOW_COMMON, GoalItemType.MARSHMALLOW_PURPLE, GoalItemType.MARSHMALLOW_ORANGE, GoalItemType.MARSHMALLOW_BLUE, GoalItemType.MARSHMALLOW_RED, GoalItemType.MARSHMALLOW_PINK, GoalItemType.MARSHMALLOW_YELLOW, GoalItemType.MARSHMALLOW_DOUBLE],
    [GoalType.CHOCOLATE]: [GoalItemType.CHOCOLATE_COMMON, GoalItemType.CHOCOLATE_PURPLE, GoalItemType.CHOCOLATE_ORANGE, GoalItemType.CHOCOLATE_BLUE, GoalItemType.CHOCOLATE_RED, GoalItemType.CHOCOLATE_PINK, GoalItemType.CHOCOLATE_YELLOW, GoalItemType.CHOCOLATE_DOUBLE, GoalItemType.CHOCOLATE_TRIPLE],
    [GoalType.DONUT]: [GoalItemType.DONUT],
    [GoalType.CANDY]: [GoalItemType.CANDY],
    [GoalType.APPLE]: [GoalItemType.APPLE],
    [GoalType.GUMMY]: [GoalItemType.GUMMY_VERTICAL, GoalItemType.GUMMY_VERTICAL_LARGE, GoalItemType.GUMMY_HORIZONTAL, GoalItemType.GUMMY_HORIZONTAL_LARGE],
    [GoalType.CHICK]: [GoalItemType.CHICK]
  };
  GoalUtils.GOALS_ITEM_TYPES_MAP = {
    [GoalType.COOKIE_BLUE]: [ItemType.COOKIE_BLUE],
    [GoalType.COOKIE_RED]: [ItemType.COOKIE_RED],
    [GoalType.COOKIE_ORANGE]: [ItemType.COOKIE_ORANGE],
    [GoalType.COOKIE_YELLOW]: [ItemType.COOKIE_YELLOW],
    [GoalType.COOKIE_PINK]: [ItemType.COOKIE_PINK],
    [GoalType.COOKIE_PURPLE]: [ItemType.COOKIE_PURPLE],
    [GoalType.APPLE]: [ItemType.APPLES_PLATTER],
    [GoalType.DROP_ITEM]: [ItemType.DROP_ITEM],
    [GoalType.MARSHMALLOW]: ItemTypeUtil.getSubtypes(ItemSuperType.MARSHMALLOW),
    [GoalType.CHOCOLATE]: ItemTypeUtil.getSubtypes(ItemSuperType.CHOCOLATE),
    [GoalType.BISCUIT]: [ItemType.BISCUIT],
    [GoalType.LICORICE]: ItemTypeUtil.getSubtypes(ItemSuperType.LICORICE),
    [GoalType.DONUT]: [ItemType.DONUT_BOX],
    [GoalType.CANDY]: [ItemType.CANDY_BOTTLE],
    [GoalType.GUMMY]: ItemTypeUtil.getSubtypes(ItemSuperType.GUMMY),
    [GoalType.CHICK]: [ItemType.CHICK]
  };

  // src/scenes/gameplay/items/cookies/common/CookiePowerup.ts
  var CookiePowerup;
  (function(CookiePowerup3) {
    CookiePowerup3["VERTICAL_STRIPES"] = "VERTICAL_STRIPES";
    CookiePowerup3["HORIZONTAL_STRIPES"] = "HORIZONTAL_STRIPES";
    CookiePowerup3["BOMB"] = "BOMB";
    CookiePowerup3["SUPER_SPHERE"] = "SUPER_SPHERE";
  })(CookiePowerup || (CookiePowerup = {}));
  var COOKIE_POWERUPS = [CookiePowerup.VERTICAL_STRIPES, CookiePowerup.HORIZONTAL_STRIPES, CookiePowerup.BOMB, CookiePowerup.SUPER_SPHERE];

  // src/LevelConfigsManager.ts
  var LevelConfigsManager = class {
    constructor(allConfigs) {
      this.allConfigs = allConfigs;
    }
    removeGaps() {
      let levelNumbers = this.getLevelNumbers();
      for (let i = 0; i < levelNumbers.length - 1; i++) {
        let level = levelNumbers[i];
        let nextLevel = levelNumbers[i + 1];
        let diff = nextLevel - level;
        if (diff > 1) {
          this.allConfigs[level + 1] = cloneDeep_default(this.allConfigs[nextLevel]);
          this.allConfigs[level + 1].levelNumber = level + 1;
          this.allConfigs[level + 1].originalLevelNumber = nextLevel;
          console.log(`Level ${nextLevel} => Level ${level + 1}`);
          delete this.allConfigs[nextLevel];
          return this.removeGaps();
        }
      }
      this.fixConfigs();
    }
    fixConfigs() {
      this.getAll().forEach((config2) => {
      });
      this.saveLocally().then(() => {
        console.log("Configs were fixed!");
      }).catch(() => {
        console.warn("Can't fix configs!");
      });
    }
    getAll() {
      return Object.values(this.allConfigs);
    }
    get(levelNumber) {
      return this.allConfigs[levelNumber];
    }
    remove(levelNumber) {
      delete this.allConfigs[levelNumber.toString()];
    }
    removeAndShift(levelNumberToRemove) {
      if (this.check(levelNumberToRemove) === false) {
        return;
      }
      this.remove(levelNumberToRemove);
      let fixedCopy = {};
      Object.entries(this.allConfigs).forEach(([key, value]) => {
        let levelNumber = parseInt(key);
        let newLevelNumber = levelNumber > levelNumberToRemove ? levelNumber - 1 : levelNumber;
        value.levelNumber = newLevelNumber;
        fixedCopy[newLevelNumber] = value;
      });
      this.allConfigs = fixedCopy;
    }
    check(levelNumber) {
      return this.allConfigs.hasOwnProperty(levelNumber.toString());
    }
    add(config2) {
      this.allConfigs[config2.levelNumber] = config2;
    }
    create(levelNumber, add = true) {
      let config2 = this.createDefaultLevelConfig(levelNumber);
      if (add) {
        this.allConfigs[levelNumber] = config2;
      }
      return config2;
    }
    createDefaultLevelConfig(levelNumber) {
      return {
        levelNumber,
        originalLevelNumber: levelNumber,
        showHintOnStart: true,
        verticalStripesChance: 0.5,
        hard: false,
        moves: 10,
        background: "background_001",
        generator: this.createDefaultGeneratorConfig(),
        goals: this.createDefaultGoals(),
        chefPowerups: this.createDefaultChefPowerupsConfig(),
        boosters: this.createDefaultBoostersConfig(),
        preGameBoosters: this.createDefaulPregameBoostersConfig(),
        preGameBoostersHints: this.createDefaulPregameBoostersHintsConfig(),
        tutorial: {autoGenerated: true, steps: []},
        grid: {columns: 9, rows: 10},
        field: [],
        items: [],
        newElement: "none",
        mysteryBoxes: LevelConfigsManager.createDefaultMysteryBoxesConfig(),
        newItemsTypes: ""
      };
    }
    createDefaultGeneratorConfig() {
      return {
        weights: LevelConfigsManager.getDefaultWeights()
      };
    }
    static getDefaultWeights() {
      let defaultWeight = 50;
      return {
        [ItemType.COOKIE_ORANGE]: defaultWeight,
        [ItemType.COOKIE_RED]: defaultWeight,
        [ItemType.COOKIE_BLUE]: defaultWeight,
        [ItemType.COOKIE_PURPLE]: defaultWeight,
        [ItemType.COOKIE_PINK]: defaultWeight,
        [ItemType.COOKIE_YELLOW]: 0,
        [ItemType.MYSTERY_BOX]: 0
      };
    }
    createDefaultGoals() {
      let goalTypes = GoalUtils.getAllTypes();
      let goalValues = goalTypes.map((type) => 0);
      let goals = zipObject_default(goalTypes, goalValues);
      return goals;
    }
    createDefaultChefPowerupsConfig() {
      return {
        isEnabled: true,
        powerupsNum: 5,
        [CookiePowerup.VERTICAL_STRIPES]: 50,
        [CookiePowerup.HORIZONTAL_STRIPES]: 50,
        [CookiePowerup.BOMB]: 25,
        [CookiePowerup.SUPER_SPHERE]: 10
      };
    }
    createDefaultBoostersConfig() {
      return {
        [BoosterType.UNDO]: true,
        [BoosterType.GLOVE]: true,
        [BoosterType.ROLLING_PIN]: true,
        [BoosterType.LOLLIPOP]: true
      };
    }
    createDefaulPregameBoostersConfig() {
      return {
        [PregameBoosterType.STRIPES]: true,
        [PregameBoosterType.BOMB]: true,
        [PregameBoosterType.SUPER_SPHERE]: true
      };
    }
    createDefaulPregameBoostersHintsConfig() {
      return {
        [PregameBoosterType.STRIPES]: false,
        [PregameBoosterType.BOMB]: false,
        [PregameBoosterType.SUPER_SPHERE]: false
      };
    }
    static createDefaultMysteryBoxesConfig() {
      return {
        COOKIE_BASIC: 0,
        COOKIE_STRIPED: 0,
        COOKIE_BOMB: 0,
        COOKIE_SUPER_SPHERE: 0,
        [ItemType.CHOCOLATE_COMMON]: 0,
        [ItemType.MARSHMALLOW_COMMON]: 0,
        [ItemType.MARSHMALLOW_DOUBLE]: 0,
        MARSHMALLOW_COLORED: 0,
        [ItemType.CANDY_BOTTLE]: 0,
        [ItemType.DONUT_BOX]: 0
      };
    }
    saveLocally() {
      let isBrowserSyncAvailable = typeof window["___browserSync___"] !== "undefined";
      if (isBrowserSyncAvailable === false) {
        return Promise.resolve(false);
      }
      let url = `${location.protocol}//${location.host}/files`;
      let path = "dev/assets/configs/";
      return this.doSave(url, path);
    }
    saveRemotely() {
      let url = Config.SERVER_URL + "upload.php";
      return this.doSave(url, "");
    }
    doSave(url, filepath) {
      return new Promise((resolve, reject) => {
        var _a;
        let filename = (_a = UrlParams.get("levelsFile")) != null ? _a : "levels";
        let data = {
          filename: filepath + filename + ".json",
          content: JSON.stringify(this.allConfigs)
        };
        let xhr = new XMLHttpRequest();
        xhr.open("POST", url, true);
        xhr.onload = function() {
          resolve(xhr);
        };
        xhr.onerror = function() {
          reject(xhr);
        };
        xhr.send(this.convertObjectToURLSearchParams(data));
      });
    }
    convertObjectToURLSearchParams(obj) {
      return new URLSearchParams(obj);
    }
    getLevelNumbers() {
      let levelNumbers = Object.keys(this.allConfigs);
      return levelNumbers.map((num) => {
        return parseInt(num);
      });
    }
    getPrevExistingLevel(levelNumber) {
      let levels = this.getLevelNumbers();
      let index = levels.indexOf(levelNumber);
      if (index === -1) {
        return void 0;
      }
      return levels[index - 1];
    }
    getNextExistingLevel(levelNumber) {
      let levels = this.getLevelNumbers();
      let index = levels.indexOf(levelNumber);
      if (index === -1) {
        return void 0;
      }
      return levels[index + 1];
    }
    isLastLevel(levelNumber) {
      let levels = this.getLevelNumbers();
      return levels.indexOf(levelNumber) === levels.length - 1;
    }
    getLastLevelNumber() {
      return Math.max(...this.getLevelNumbers());
    }
    getGaps() {
      let gaps = [];
      let lastLevel = this.getLastLevelNumber();
      for (let levelNumber = 1; levelNumber < lastLevel; levelNumber++) {
        if (this.check(levelNumber) === false) {
          gaps.push(levelNumber);
        }
      }
      return gaps;
    }
    getHardLevelNumbers() {
      return this.getAll().filter((config2) => config2.hard).map((config2) => config2.levelNumber);
    }
  };

  // src/FpsTracker.ts
  var FpsTracker = class extends Phaser.Events.EventEmitter {
    constructor(game, options) {
      super();
      this.isRunning = false;
      this.sceneStartTs = 0;
      this.game = game;
      this.options = options;
    }
    track(transition) {
      transition.on(SceneTransitionEvent.COMPLETE, this.onSceneTransitionComplete, this);
    }
    onSceneTransitionComplete(transition, oldSceneKey, newSceneKey, newSceneData) {
      let scene = this.game.scene.getScene(newSceneKey);
      scene.events.once(Phaser.Scenes.Events.UPDATE, this.start.bind(this, newSceneKey));
      scene.events.once(Phaser.Scenes.Events.SHUTDOWN, this.stop, this);
    }
    start(sceneKey) {
      if (this.isRunning) {
        return;
      }
      this.isRunning = true;
      this.sceneStartTs = Date.now();
      this.updateTimer = this.options.updateInterval;
      this.currentSceneKey = sceneKey;
      this.history = [];
      this.game.events.on(Phaser.Core.Events.POST_STEP, this.onPostStep, this);
    }
    stop() {
      if (this.isRunning === false) {
        return;
      }
      this.isRunning = false;
      this.game.events.off(Phaser.Core.Events.POST_STEP, this.onPostStep, this);
      let timePassed = Date.now() - this.sceneStartTs;
      if (timePassed > this.options.minSceneDuration && this.history.length > 10) {
        let median = this.getMedianFps();
        this.sendToAnalytics(median);
        this.adjustGraphicsQuality(median);
      }
    }
    onPostStep(time, delta) {
      this.updateTimer -= delta;
      if (this.updateTimer < 0) {
        this.updateTimer += this.options.updateInterval;
        this.history.push(this.game.loop.actualFps);
      }
    }
    sendToAnalytics(fps) {
      var _a;
      (_a = this.game.analytics) == null ? void 0 : _a.sendDesignEvent(`Fps:${this.currentSceneKey}`, fps);
    }
    adjustGraphicsQuality(medianFps) {
      if (this.options.graphicsQualityAutoAdjustment.enabled === false) {
        return;
      }
      let wasSetManually = this.game.store.getBoolean(GameStoreKey.GRAPHICS_QUALITY_MANUALLY);
      if (wasSetManually) {
        return;
      }
      let isLowFps = medianFps < this.options.graphicsQualityAutoAdjustment.lowFps;
      if (isLowFps) {
        this.downgradeGraphicsQuality();
        return;
      }
      let isHighFps = medianFps > this.options.graphicsQualityAutoAdjustment.highFps;
      if (isHighFps) {
        this.upgradeGraphicsQuality();
        return;
      }
    }
    downgradeGraphicsQuality() {
      var _a, _b;
      let currentQuality = this.game.scaler.quality;
      let currentQualityIndex = GRAPHICS_QUALITY_OPTIONS.indexOf(currentQuality);
      if (currentQualityIndex <= 0) {
        return;
      }
      let lowerQuality = GRAPHICS_QUALITY_OPTIONS[currentQualityIndex - 1];
      this.game.scaler.setQuality(lowerQuality);
      let message = `Graphics quality was downgraded! (${currentQuality} -> ${lowerQuality})`;
      (_a = this.game.sentry) == null ? void 0 : _a.addBreadcrumb({message});
      (_b = this.game.analytics) == null ? void 0 : _b.sendDesignEvent(`Fps:DowngradeTo:${lowerQuality}`);
      console.log(message);
    }
    upgradeGraphicsQuality() {
      var _a, _b;
      let currentQuality = this.game.scaler.quality;
      let currentQualityIndex = GRAPHICS_QUALITY_OPTIONS.indexOf(currentQuality);
      if (currentQualityIndex === GRAPHICS_QUALITY_OPTIONS.length - 1) {
        return;
      }
      let betterQuality = GRAPHICS_QUALITY_OPTIONS[currentQualityIndex + 1];
      this.game.scaler.setQuality(betterQuality);
      let message = `Graphics quality was upgraded! (${currentQuality} -> ${betterQuality})`;
      (_a = this.game.sentry) == null ? void 0 : _a.addBreadcrumb({message});
      (_b = this.game.analytics) == null ? void 0 : _b.sendDesignEvent(`Fps:UpgradeTo:${betterQuality}`);
      console.log(message);
    }
    getMedianFps() {
      if (!this.history) {
        return 0;
      }
      return Math.round(Phaser.Math.Median(this.history));
    }
  };

  // src/purchases/PurchasesManager.ts
  var PurchasesManager = class extends Phaser.Events.EventEmitter {
    constructor(game, offers, overlay) {
      super();
      this.game = game;
      this.store = this.game.store;
      this.offers = offers;
      this.overlay = overlay;
      this.currency = window.game.config.purchases.currency.code;
    }
    make(offerId, referrer) {
      this.overlay.show();
      return new Promise((resolve, reject) => {
        this.game.globalScene.time.delayedCall(1e3, () => {
          this.overlay.hide();
          this.sendPurchaseCompleteEvent(offerId, referrer);
          resolve();
        });
      });
    }
    sendPurchaseCompleteEvent(offerId, referrer = "Shop") {
      var _a;
      let offer = this.getOfferById(offerId);
      let amount = offer.price * window.game.config.purchases.currency.conversionRate;
      let itemType = "bundle";
      let itemId = offerId;
      (_a = this.game.analytics) == null ? void 0 : _a.sendBusinessEvent(this.currency, amount, itemType, itemId, referrer);
    }
    getOfferById(id) {
      return this.offers.find((item) => item.id === id);
    }
    sendPurchaseErrorToSentry(offerId, error = "Unknown") {
      var _a;
      let ignore = this.shouldIgnorePurchaseError(error);
      if (ignore) {
        return;
      }
      (_a = this.game.sentry) == null ? void 0 : _a.captureMessage("Purchase error", {
        extra: {
          offerId,
          error,
          description: this.stringifyPurchaseError(error)
        }
      });
    }
    shouldIgnorePurchaseError(error) {
      return false;
    }
    stringifyPurchaseError(error) {
      if (error.message) {
        return error.message;
      }
      return error.toString();
    }
    isSpecialOffer(offerId) {
      var _a;
      return (_a = this.getOfferById(offerId)) == null ? void 0 : _a.isSpecial;
    }
    wasSpecialOfferBought() {
      return this.store.getBoolean(GameStoreKey.SHOP_SPECIAL_OFFER_BOUGHT);
    }
    wasAnyPurchaseMade() {
      return this.store.getBoolean(GameStoreKey.SHOP_ANY_PURCHASE_COMPLETE);
    }
    savePurchase(offerId) {
      let offer = this.getOfferById(offerId);
      if (offer === void 0) {
        console.warn(`Offer ${offerId} doesn't exist!`);
        return;
      }
      this.store.saveValue(GameStoreKey.SHOP_ANY_PURCHASE_COMPLETE, true);
      if (this.isSpecialOffer(offerId)) {
        this.store.saveValue(GameStoreKey.SHOP_SPECIAL_OFFER_BOUGHT, true);
      }
      this.applyOfferContent(offer.content);
    }
    applyOfferContent(content) {
      this.store.changeNumber(GameStoreKey.COINS, content.coins);
      this.applyUnlimitedLives(content.lives);
    }
    applyUnlimitedLives(hoursOfUnlimitedLives) {
      let ms = toMs({hours: hoursOfUnlimitedLives});
      this.game.lives.startUnlimitedLives(ms);
    }
  };

  // src/PiggyBank.ts
  var PiggyBank = class extends Phaser.Events.EventEmitter {
    constructor(game) {
      super();
      this.game = game;
    }
    reset() {
      this.game.store.saveValue(GameStoreKey.PIGGY_BANK_COINS, 0);
    }
    setCoinsNum(value) {
      let newValue = Phaser.Math.Clamp(value, 0, this.getMaxCoins());
      this.game.store.saveValue(GameStoreKey.PIGGY_BANK_COINS, newValue);
    }
    changeCoinsNum(delta) {
      let newValue = Phaser.Math.Clamp(this.getCurrentCoins() + delta, 0, this.getMaxCoins());
      this.game.store.saveValue(GameStoreKey.PIGGY_BANK_COINS, newValue);
    }
    getCurrentCoins() {
      return this.game.store.getNumber(GameStoreKey.PIGGY_BANK_COINS);
    }
    getMaxCoins() {
      return window.game.config.piggy_bank.max_capacity;
    }
    getBreakMethod() {
      let configBreakMethod = window.game.config.piggy_bank.breakMethod;
      if (!configBreakMethod || configBreakMethod === "auto") {
        return this.calculateBreakMethod();
      }
      return configBreakMethod;
    }
    calculateBreakMethod() {
      if (this.game.purchases) {
        return "purchase";
      }
      return "rewarded_ad";
    }
    isFull() {
      return this.getCurrentCoins() >= this.getMaxCoins();
    }
    isAlmostFull() {
      return this.getFullnessPercent() >= 0.9;
    }
    getFullnessPercent() {
      return Math.min(1, this.getCurrentCoins() / this.getMaxCoins());
    }
  };

  // src/scenes/preloader/Preloader.ts
  var Preloader = class extends BaseScene {
    init(data) {
      super.init(data);
      this.decoratePage();
      this.game.loadingScreen.showPreloader();
    }
    decoratePage() {
      let isDesktopScaling = this.game.config.scaleMode === Phaser.Scale.FIT;
      if (isDesktopScaling === false) {
        return;
      }
      let noDecor = UrlParams.getBool("noDecor");
      if (noDecor) {
        return;
      }
      let canvas = this.game.canvas;
      canvas.parentElement.style.backgroundImage = this.getBackgroundImageUrl();
      canvas.parentElement.style.backgroundColor = "#EB8F4E";
      canvas.style.boxShadow = "0px 0px 16px 16px rgba(0, 0, 0, 0.1)";
      this.surroundCanvasWithSidebars(canvas);
      this.scale.updateBounds();
    }
    getBackgroundImageUrl() {
      let format = this.getDefaultImageFormat();
      let url = getCacheBustingUrl(`assets/graphics/page_background.${format}`);
      return `url('${url}')`;
    }
    getDefaultImageFormat() {
      if (this.game.avif) {
        return "avif";
      } else if (this.game.webp) {
        return "webp";
      } else {
        return "jpg";
      }
    }
    surroundCanvasWithSidebars(canvas) {
      let leftSidebar = document.createElement("div");
      leftSidebar.className = "sidebar";
      leftSidebar.id = "left-sidebar";
      canvas.parentNode.insertBefore(leftSidebar, canvas);
      let rightSidebar = document.createElement("div");
      rightSidebar.className = "sidebar";
      rightSidebar.id = "right-sidebar";
      canvas.parentNode.insertBefore(rightSidebar, canvas.nextSibling);
    }
    preload() {
      this.analytics.sendLoadingEvent("main", "start");
      this.load.on(Phaser.Loader.Events.PROGRESS, this.onLoadProgress, this);
      this.load.on(Phaser.Loader.Events.COMPLETE, this.onLoadComplete, this);
      this.loadGraphics();
      this.loadFonts();
      this.loadAudio();
      this.loadOtherAssets();
      this.loadShopOffers();
      this.loadEditor();
      this.loadSaveData();
      this.loadRemoteConfig();
    }
    onLoadProgress() {
      this.game.loadingScreen.preloader.updateProgress(this.load.progress);
    }
    onLoadComplete() {
      this.load.off(Phaser.Loader.Events.PROGRESS, this.onLoadProgress, this);
      this.load.off(Phaser.Loader.Events.COMPLETE, this.onLoadComplete, this);
    }
    loadAudio() {
      this.loadSound(GameSoundKey.TAP);
      this.loadSound(GameSoundKey.SWAP);
      this.loadSound(GameSoundKey.SWAP_BACK);
      this.loadSound(GameSoundKey.CANT_SWAP);
      this.loadSound(GameSoundKey.MATCH_1);
      this.loadSound(GameSoundKey.MATCH_2);
      this.loadSound(GameSoundKey.MATCH_3);
      this.loadSound(GameSoundKey.MATCH_4);
      this.loadSound(GameSoundKey.MATCH_5);
      this.loadSound(GameSoundKey.STRIPES);
      this.loadSound(GameSoundKey.BOMB);
      this.loadSound(GameSoundKey.SUPER_SPHERE);
      this.loadSound(GameSoundKey.GOAL_UPDATE);
      this.loadSound(GameSoundKey.GOAL_COMPLETE);
      if (window.game.config.purchases.enabled) {
        this.loadSound(GameSoundKey.SHOP_OPEN);
      }
    }
    loadSound(key, options) {
      this.audio.loadSound(this.load, key, options);
    }
    loadOtherAssets() {
      this.load.json("texts", "assets/texts.json");
      this.load.json("levels", "assets/configs/levels.json");
      this.load.json("level_map_config", "assets/configs/level_map_config.json");
      if (UrlParams.getBool("replay")) {
        this.load.json("replay", "assets/replay.json");
      }
    }
    loadShopOffers() {
      if (window.game.config.purchases.enabled === false) {
        return;
      }
      this.load.json("shop_offers", "assets/configs/shop_offers.json");
    }
    loadFonts() {
      this.load.bitmapFontFromAtlas(BitmapFont.POPUP_GOAL_LABELS, "popups", "goal_num_label.png", "assets/fonts/bitmap/goal_num_label.xml");
      this.load.bitmapFontFromAtlas(BitmapFont.PREGAME_BOOSTERS_LABELS, "popups", "pregame_boosters_labels.png", "assets/fonts/bitmap/pregame_boosters_labels.xml");
      this.load.bitmapFontFromAtlas(BitmapFont.SHOP_COINS, "popups", "popups/shop/shop_coins.png", "assets/fonts/bitmap/shop_coins.xml");
      this.load.bitmapFontFromAtlas(BitmapFont.LABELS_POPUPS, "popups", "labels.png", "assets/fonts/bitmap/labels.xml");
      this.load.bitmapFontFromAtlas(BitmapFont.LEVEL_ICONS_CLASSIC, "level_map", "level_icons/level_icons_classic", "assets/fonts/bitmap/level_icons_classic.xml");
      this.load.bitmapFontFromAtlas(BitmapFont.LEVEL_MAP_TOP_PANEL, "level_map", "level_map_top_panel_font", "assets/fonts/bitmap/level_map_top_panel_font.xml");
      this.load.bitmapFontFromAtlas(BitmapFont.LEVEL_MAP_BOTTOM_LABELS, "level_map", "level_map_bottom_labels", "assets/fonts/bitmap/level_map_bottom_labels.xml");
      this.load.bitmapFontFromAtlas(BitmapFont.LEVEL_ICONS_HARD, "level_map", "level_icons/level_icons_hard", "assets/fonts/bitmap/level_icons_hard.xml");
    }
    loadGraphics() {
      this.load.atlas("rewards", "assets/graphics/rewards.png", "assets/graphics/rewards.json");
      this.load.atlas("popups", "assets/graphics/popups.png", "assets/graphics/popups.json");
      this.load.image("level_map_bg_1", "assets/graphics/level_map_1.jpg");
      this.load.image("level_map_bg_2", "assets/graphics/level_map_2.jpg");
      this.load.image("level_map_bg_3", "assets/graphics/level_map_3.jpg");
      this.load.image("level_map_bg_4", "assets/graphics/level_map_4.jpg");
      this.load.atlas("level_map", "assets/graphics/level_map.png", "assets/graphics/level_map.json");
    }
    loadEditor() {
      if (Main.editorEnabled === false) {
        return;
      }
      this.load.script("tweakpane", "js/tweakpane.min.js");
      this.load.css("editor-css", "css/editor.css");
      this.load.atlas("editor", "assets/graphics/editor.png", "assets/graphics/editor.json");
      this.load.bitmapFontFromAtlas(BitmapFont.LEVEL_EDITOR_GRID, "editor", "grid_labels", "assets/fonts/bitmap/grid_labels.xml");
      this.load.bitmapFontFromAtlas(BitmapFont.LEVELS_EDITOR_LIST, "editor", "levels_list", "assets/fonts/bitmap/levels_list.xml");
    }
    loadSaveData() {
      this.load.rexAwait("init_game_store", {
        callback: (onSuccess) => {
          this.game.store.initActualStorage().catch((error) => {
            this.game.analytics.sendError(`Storage:Not_Available`);
          }).finally(() => __async(this, null, function* () {
            yield this.game.store.loadInitialValues();
            this.game.store.fixLevelResults();
            onSuccess();
          }));
        }
      });
    }
    loadRemoteConfig() {
      this.load.rexAwait("remote_config", {
        callback: (onSuccess, onFail) => {
          this.analytics.loadRemoteConfig().then(() => onSuccess()).catch(() => onFail());
        }
      });
    }
    create() {
      this.initStore();
      this.initGraphicsQuality();
      this.initGifts();
      this.initLives();
      this.initTexts();
      this.initLevelConfigs();
      this.initPregameBoosters();
      this.initBoosters();
      this.initAudio();
      this.addDelayedLoader();
      this.addScenesTransition();
      this.addFpsTracker();
      this.addToasts();
      this.addPurchaseManager();
      this.addPiggyBank();
      this.analytics.sendLoadingEvent("main", "complete");
      this.startGame();
    }
    initStore() {
      if (UrlParams.getBool("resetWheel")) {
        this.game.store.saveValue(GameStoreKey.WHEEL_LOCKED, false);
      }
      let coins = UrlParams.getNumber("coins", -1);
      if (coins > -1) {
        this.game.store.saveValue(GameStoreKey.COINS, coins);
      }
      this.game.store.changeNumber(GameStoreKey.LOGIN_NUM, 1);
    }
    initGraphicsQuality() {
      let qualityUrlParam = UrlParams.get("quality");
      if (isQualityOption(qualityUrlParam)) {
        this.game.scaler.setQuality(qualityUrlParam);
        return;
      }
      let savedQuality = this.game.store.getValue(GameStoreKey.GRAPHICS_QUALITY);
      if (isQualityOption(savedQuality)) {
        this.game.scaler.setQuality(savedQuality);
        return;
      }
    }
    initGifts() {
      this.game.gifts = new GiftsManager(this.game);
    }
    initLives() {
      this.game.lives = new LivesManager(this.game);
    }
    initTexts() {
      this.game.texts = new GameTexts(this.game);
      this.game.texts.injectTextsIntoScenes();
      this.game.adsHelper.onLanguageChange();
      this.game.texts.on(GameTextsEvent.LANGUAGE_CHANGE, () => {
        this.game.adsHelper.onLanguageChange();
      });
    }
    initLevelConfigs() {
      let configs = this.cache.json.get("levels");
      this.game.levelConfigs = new LevelConfigsManager(configs);
      this.game.injectIntoScenes(this.game.levelConfigs, "configs");
      let movesDelta = parseInt(this.analytics.getRemoteConfigValue(RemoteConfigKey.MOVES_DELTA, "0"));
      this.game.levelConfigs.getAll().forEach((config2) => config2.moves += movesDelta);
    }
    initPregameBoosters() {
      this.game.pregameBoosters = new PregameBoostersManager(this.game);
      let boostersNum = UrlParams.getNumber("pregameBoosters", -1);
      if (boostersNum > -1) {
        this.game.pregameBoosters.items.forEach((booster) => {
          booster.num = boostersNum;
        });
      }
    }
    initBoosters() {
      this.game.boosters = new BoostersManager(this.game);
      let boostersNum = UrlParams.getNumber("boosters", -1);
      if (boostersNum > -1) {
        this.game.boosters.boosters.forEach((booster) => {
          if (booster.type !== BoosterType.UNDO) {
            booster.num = boostersNum;
          }
        });
      }
      let undoNum = UrlParams.getNumber("undo", -1);
      if (undoNum > -1) {
        this.game.boosters.getByType(BoosterType.UNDO).num = undoNum;
      }
    }
    initAudio() {
      this.audio.soundMute = this.game.store.getBoolean(GameStoreKey.SOUND_MUTED);
      this.audio.musicMute = this.game.store.getBoolean(GameStoreKey.MUSIC_MUTED);
    }
    addDelayedLoader() {
      this.game.globalScene.addDelayedLoader();
      let noExtraLoad = UrlParams.getBool("noExtraLoad");
      if (noExtraLoad) {
        return;
      }
      this.game.globalScene.delayedLoader.startLoading();
    }
    addScenesTransition() {
      let transition = new CanvasSceneTransition(this.game.globalScene, "level_map", "black_rect");
      this.game.globalScene.addSceneTranstion(transition);
      this.game.globalScene.sceneTransition.instantChange = UrlParams.getBool("instantSceneChange");
      this.game.sentry.trackSceneChanges(transition);
    }
    addFpsTracker() {
      this.game.fpsTracker = new FpsTracker(this.game, {
        updateInterval: 250,
        minSceneDuration: 8e3,
        graphicsQualityAutoAdjustment: {
          enabled: window.environment === GameEnvironment.PRODUCTION,
          highFps: 57,
          lowFps: 45
        }
      });
      this.game.fpsTracker.track(this.game.globalScene.sceneTransition);
    }
    addToasts() {
      this.game.toasts = this.game.globalScene.addToasts();
    }
    addPurchaseManager() {
      if (window.game.config.purchases.enabled === false) {
        return;
      }
      let offersData = this.cache.json.get("shop_offers");
      this.game.purchases = new PurchasesManager(this.game, offersData, this.game.globalScene.purchaseOverlay);
    }
    addPiggyBank() {
      if (window.game.config.piggy_bank.enabled === false) {
        return;
      }
      let rewardedAds = window.game.config.ads.rewarded;
      let purchases = Boolean(this.game.purchases);
      if (!rewardedAds && !purchases) {
        return;
      }
      this.game.piggyBank = new PiggyBank(this.game);
      let piggyBankCoins = UrlParams.getNumber("piggyBank", -1);
      if (piggyBankCoins > -1) {
        this.game.piggyBank.setCoinsNum(piggyBankCoins);
      }
    }
    startGame() {
      let isReplay = UrlParams.getBool("replay");
      if (isReplay && this.isReplayConfigValid()) {
        this.startLevelReplay();
        return;
      }
      let levelNumber = UrlParams.getNumber("level");
      if (levelNumber && this.game.levelConfigs.check(levelNumber)) {
        this.startLevel(levelNumber);
        return;
      }
      let editorLevelNumber = UrlParams.getNumber("levelEditor");
      if (editorLevelNumber) {
        this.startLevelEditor(editorLevelNumber);
        return;
      }
      this.startScene(SceneKey.LEVEL_MAP);
    }
    startScene(scene, data) {
      this.game.changeScene(this.scene.key, scene, data);
    }
    isReplayConfigValid() {
      let replay = this.cache.json.get("replay");
      let isEmpty = JSON.stringify(replay) === "{}";
      let isValid = replay && isEmpty === false;
      if (isValid === false) {
        console.warn("Invalid replay config!", replay);
      }
      return isValid;
    }
    startLevelReplay() {
      this.startScene(SceneKey.GAMEPLAY_ROOT, {type: "replay", session: this.cache.json.get("replay")});
    }
    startLevel(levelNumber, pregameBoosters = []) {
      this.startScene(SceneKey.GAMEPLAY_ROOT, {type: "play", levelNumber, pregameBoosters});
    }
    startLevelEditor(levelNumber) {
      this.startScene(SceneKey.LEVEL_EDITOR_ROOT, {levelNumber});
    }
    resize() {
      super.resize();
    }
    onShutdown() {
      super.onShutdown();
      this.game.loadingScreen.fadeOut();
    }
  };

  // src/robowhale/phaser3/Easing.ts
  var Ease;
  (function(Ease2) {
    Ease2["Linear"] = "Linear";
    Ease2["Stepped"] = "Stepped";
    Ease2["QuadIn"] = "Quadratic.In";
    Ease2["CubicIn"] = "Cubic.In";
    Ease2["QuartIn"] = "Quartic.In";
    Ease2["QuintIn"] = "Quintic.In";
    Ease2["SineIn"] = "Sine.In";
    Ease2["ExpoIn"] = "Expo.In";
    Ease2["CircIn"] = "Circular.In";
    Ease2["ElasticIn"] = "Elastic.In";
    Ease2["BackIn"] = "Back.In";
    Ease2["BounceIn"] = "Bounce.In";
    Ease2["QuadOut"] = "Quadratic.Out";
    Ease2["CubicOut"] = "Cubic.Out";
    Ease2["QuartOut"] = "Quartic.Out";
    Ease2["QuintOut"] = "Quintic.Out";
    Ease2["SineOut"] = "Sine.Out";
    Ease2["ExpoOut"] = "Expo.Out";
    Ease2["CircOut"] = "Circular.Out";
    Ease2["ElasticOut"] = "Elastic.Out";
    Ease2["BackOut"] = "Back.Out";
    Ease2["BounceOut"] = "Bounce.Out";
    Ease2["QuadInOut"] = "Quadratic.InOut";
    Ease2["CubicInOut"] = "Cubic.InOut";
    Ease2["QuartInOut"] = "Quartic.InOut";
    Ease2["QuintInOut"] = "Quintic.InOut";
    Ease2["SineInOut"] = "Sine.InOut";
    Ease2["ExpoInOut"] = "Expo.InOut";
    Ease2["CircInOut"] = "Circular.InOut";
    Ease2["ElasticInOut"] = "Elastic.InOut";
    Ease2["BackInOut"] = "Back.InOut";
    Ease2["BounceInOut"] = "Bounce.InOut";
  })(Ease || (Ease = {}));
  var CustomEase = {
    Bell: (t, a = 1) => Math.pow(4, a) * Math.pow(t * (1 - t), a),
    BellCbrt: (t) => Math.cbrt(4) * Math.cbrt(t * (1 - t)),
    BellSqrt: (t) => Math.sqrt(4) * Math.sqrt(t * (1 - t)),
    BellBasic: (t) => 4 * (t * (1 - t)),
    BellQuad: (t) => 4 * 4 * (t * (1 - t) * (t * (1 - t))),
    BellCubic: (t) => 4 * 4 * 4 * (t * (1 - t) * (t * (1 - t)) * (t * (1 - t)))
  };

  // src/scenes/gameplayGui/topPanel/goalsPanel/GoalView.ts
  var GoalView = class extends Phaser.GameObjects.Container {
    constructor(scene, goalType, goalNum) {
      super(scene);
      this.goalNum = 0;
      this.name = `goal_${goalType}`;
      this.goalType = goalType;
      this.goalNum = goalNum;
      this.addIconParticles();
      this.addIcon();
      this.addTick();
      this.addTickParticles();
      this.addText();
      this.playDecrementTweensThrottled = throttle_default(this.playDecrementTweens.bind(this), 500, {trailing: false});
    }
    addIconParticles() {
      this.iconParticles = this.scene.add.particles("gameplay_gui");
      this.add(this.iconParticles);
      this.largeCirclesEmitter = this.iconParticles.createEmitter({
        frame: "particles/circle_fx",
        scale: {start: 0.33, end: 1.4, ease: Ease.ExpoOut},
        alpha: {start: 0.9, end: 0, ease: Ease.ExpoOut},
        lifespan: 2e3,
        on: false
      });
    }
    addIcon() {
      let iconFrame = "top_panel/goals/" + this.goalType.toLowerCase();
      this.icon = this.scene.add.image(0, 0, "gameplay_gui", iconFrame);
      this.add(this.icon);
    }
    addTick() {
      this.tick = this.scene.add.image(0, 0, "gameplay_gui", "top_panel/goals/tick");
      this.tick.kill();
      this.tick.x = 20;
      this.tick.y = 16;
      this.tick.originalY = this.tick.y;
      this.add(this.tick);
    }
    addText() {
      let content = this.goalNum.toString();
      this.text = this.scene.add.bitmapText(0, 0, BitmapFont.TOP_PANEL_GOAL_LABELS, content, 24);
      this.text.setOrigin(0.5, 0.5);
      this.text.x = this.tick.x;
      this.text.y = this.tick.y + 1;
      this.text.originalY = this.text.y;
      this.add(this.text);
    }
    addTickParticles() {
      this.tickParticles = this.scene.add.particles("gameplay_gui");
      this.add(this.tickParticles);
      this.circlesEmitter = this.tickParticles.createEmitter({
        frame: "particles/circle_fx",
        scale: {start: 0, end: 1.2, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        lifespan: 2e3,
        on: false
      });
    }
    decrementNum() {
      if (this.goalNum > 0) {
        if (--this.goalNum === 0) {
          this.text.kill();
          this.tick.revive();
          this.showTick();
          this.showTickParticles();
          this.scene.gameplay.sounds.goalComplete();
        } else {
          this.text.setText(this.goalNum.toString());
        }
      }
      this.scene.gameplay.sounds.goalUpdate();
      this.playDecrementTweensThrottled();
    }
    playDecrementTweens() {
      this.tweenIcon();
      this.tweenTickOrText();
      if (this.isComplete() === false) {
        this.largeCirclesEmitter.explode(1, this.icon.x, this.icon.y);
      }
    }
    tweenIcon() {
      this.icon.scale = 1;
      this.scene.tweens.killTweensOf(this.icon);
      this.scene.tweens.add({
        targets: this.icon,
        duration: 233,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.2,
        yoyo: true
      });
    }
    tweenTickOrText() {
      let item = this.tick.visible ? this.tick : this.text;
      item.y = item.originalY;
      this.scene.tweens.killTweensByProperty(item, "y");
      this.scene.tweens.add({
        targets: item,
        duration: 200,
        ease: Phaser.Math.Easing.Sine.InOut,
        y: "-=10",
        yoyo: true
      });
    }
    showTick() {
      this.tick.alpha = 0;
      this.scene.tweens.add({
        targets: this.tick,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.tick.scale = 1.33;
      this.scene.tweens.add({
        targets: this.tick,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1
      });
    }
    showTickParticles() {
      this.circlesEmitter.explode(1, this.tick.x, this.tick.y);
    }
    updateNum(value) {
      this.goalNum = value;
      if (this.goalNum === 0) {
        this.tick.revive();
        this.text.kill();
      } else {
        this.tick.kill();
        this.text.revive();
        this.text.setText(this.goalNum.toString());
      }
    }
    isComplete() {
      return this.goalNum === 0;
    }
  };

  // src/scenes/gameplayGui/topPanel/goalsPanel/GoalsPanel.ts
  var GoalsPanel = class extends Phaser.GameObjects.Container {
    constructor(scene, goals) {
      super(scene);
      this.columns = 2;
      this.cellWidth = 84;
      this.cellHeight = 62;
      this.name = "goals";
      this.goals = goals;
      this.addViews();
      this.alignViews();
      this.centerLastView();
      let rowsNum = Math.ceil(this.views.length / this.columns);
      this.setSize(this.columns * this.cellWidth, rowsNum * this.cellHeight);
    }
    addViews() {
      this.views = this.goals.map((goal) => {
        let view = new GoalView(this.scene, goal.type, goal.targetNum);
        this.add(view);
        return view;
      });
    }
    alignViews() {
      this.gridAlign({
        cellWidth: this.cellWidth,
        cellHeight: this.cellHeight,
        position: Phaser.Display.Align.CENTER,
        width: this.columns,
        x: this.cellWidth / 2,
        y: this.cellWidth / 2
      });
    }
    centerLastView() {
      if (this.views.length % 2 === 0) {
        return;
      }
      this.views[this.views.length - 1].x += this.cellWidth / 2;
    }
    updateData(goals) {
      goals.forEach((goal) => {
        let view = this.views.find((view2) => view2.goalType === goal.type);
        if (view) {
          view.updateNum(goal.targetNum - goal.collectedNum);
        }
      });
    }
    getViewByGoalType(goalType) {
      return this.views.find((view) => view.goalType === goalType);
    }
  };

  // src/scenes/gameplayGui/topPanel/MovesLabel.ts
  var MovesLabel = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.scheduleSwapIconAlign = false;
      this.scene.sys.updateList.add(this);
      this.name = "moves_label";
      this.addSwapIcon();
      this.addMovesNumText();
      this.scheduleSwapIconAlign = true;
    }
    addSwapIcon() {
      this.swapIcon = this.scene.add.image(0, 0, "gameplay_gui", "top_panel/swap_icon_2");
      this.swapIcon.y = -6;
      this.add(this.swapIcon);
    }
    addMovesNumText() {
      let content = "0";
      this.movesNumText = this.scene.add.bitmapText(0, 0, BitmapFont.MOVES_LABEL, content, 62);
      this.movesNumText.setOrigin(0.5, 0.5);
      this.movesNumText.originalY = this.movesNumText.y;
      this.add(this.movesNumText);
    }
    updateMovesNum(value, instant = true) {
      if (instant) {
        this.movesNumText.setText(value.toString());
        this.scheduleSwapIconAlign = true;
        return;
      }
      this.scene.tweens.add({
        targets: this.movesNumText,
        duration: 333,
        ease: Phaser.Math.Easing.Cubic.Out,
        scale: 0.75,
        onUpdate: () => {
          this.scheduleSwapIconAlign = true;
        },
        onComplete: () => {
          this.movesNumText.setText(value.toString());
          this.scene.tweens.add({
            targets: this.movesNumText,
            duration: 800,
            ease: Phaser.Math.Easing.Elastic.Out,
            easeParams: [0.1, 0.45],
            scale: 1,
            onUpdate: () => {
              this.scheduleSwapIconAlign = true;
            }
          });
        }
      });
    }
    onExtraMovesGranted(moves) {
      this.updateMovesNum(moves, true);
      this.movesNumText.alpha = 0;
      this.scene.tweens.add({
        targets: this.movesNumText,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.movesNumText.scale = 0.5;
      this.scene.tweens.add({
        targets: this.movesNumText,
        duration: 1e3,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.5],
        scale: 1,
        onUpdate: () => {
          this.scheduleSwapIconAlign = true;
        }
      });
    }
    decrementNum() {
      let movesNum = parseInt(this.movesNumText.text);
      this.updateMovesNum(movesNum - 1, true);
    }
    preUpdate(time, delta) {
      if (this.scheduleSwapIconAlign) {
        this.scheduleSwapIconAlign = false;
        this.swapIcon.x = this.movesNumText.x - this.movesNumText.width / 2 - 18;
      }
    }
    preDestroy() {
      this.scene.sys.updateList.remove(this);
      super.preDestroy();
    }
  };

  // src/scenes/levelEditor/ItemsGenerator.ts
  var ItemsGenerator = class {
    constructor(weights, seed) {
      this.weights = weights;
      this.rnd = new Phaser.Math.RandomDataGenerator([seed != null ? seed : Date.now().toString()]);
      this.items = this.generateItems(this.weights);
    }
    generateItems(weights) {
      let items = [];
      Object.entries(weights).forEach(([itemType, itemsNum]) => {
        for (let i = 0; i < itemsNum; i++) {
          items.push(itemType);
        }
      });
      return this.rnd.shuffle(items);
    }
    getItem() {
      if (this.items.length === 0) {
        this.items = this.generateItems(this.weights);
      }
      return this.items.pop();
    }
    getState() {
      return {
        rnd: this.rnd.state(),
        items: this.items.slice(0)
      };
    }
    setState(state) {
      this.rnd.state(state.rnd);
      this.items = state.items;
    }
    getItemTypes() {
      return Object.keys(this.weights).filter((itemType) => this.weights[itemType] > 0);
    }
  };

  // src/scenes/gameplayGui/topPanel/powerupChef/CircularProgressBar.ts
  var DegToRad = Phaser.Math.DegToRad;
  var CircularProgressBarEvent;
  (function(CircularProgressBarEvent2) {
    CircularProgressBarEvent2["PROGRESS"] = "__PROGRESS";
  })(CircularProgressBarEvent || (CircularProgressBarEvent = {}));
  var CircularProgressBar = class extends Phaser.GameObjects.Graphics {
    constructor(scene, options) {
      super(scene);
      this.progress = 1;
      this.options = options;
      this.setStyles(options);
      this.thickness = options.thickness;
      this.radius = options.radius;
      this.startAngle = Phaser.Math.Angle.Normalize(DegToRad(options.startAngle));
      this.endAngle = Phaser.Math.Angle.Normalize(DegToRad(options.endAngle));
      this.totalRange = Math.PI * 2 - Math.abs(Phaser.Math.Angle.ShortestBetween(this.startAngle, this.endAngle));
    }
    setStyles(options) {
      this.setDefaultStyles({
        fillStyle: {
          color: options.color
        },
        lineStyle: {
          width: options.thickness,
          color: options.color
        }
      });
    }
    setProgressInstant(value) {
      this.progress = Phaser.Math.Clamp(value, 0, 1);
      if (this.progress === 0) {
        this.clear();
        this.emit(CircularProgressBarEvent.PROGRESS, this.progress, 0, 0);
        return;
      }
      let startAngle = this.endAngle - this.totalRange * this.progress;
      let endAngle = this.endAngle;
      this.clear();
      this.beginPath();
      this.arc(0, 0, this.radius, startAngle, endAngle);
      this.strokePath();
      if (this.options.useRoundCaps) {
        this.fillCircle(this.radius * Math.cos(startAngle), this.radius * Math.sin(startAngle), this.thickness / 2);
        this.fillCircle(this.radius * Math.cos(endAngle), this.radius * Math.sin(endAngle), this.thickness / 2);
      }
      this.emit(CircularProgressBarEvent.PROGRESS, this.progress, startAngle, endAngle);
    }
    setProgress(value) {
      var _a;
      let delta = Math.abs(value - this.progress);
      let duration = Math.max(200, delta * 1e3);
      (_a = this.progressTween) == null ? void 0 : _a.remove();
      this.progressTween = this.scene.tweens.add({
        targets: this,
        duration,
        ease: Phaser.Math.Easing.Quadratic.Out,
        progress: Phaser.Math.Clamp(value, 0, 1),
        onUpdate: () => {
          this.setProgressInstant(this.progress);
        }
      });
    }
    stopProgressTween() {
      var _a;
      (_a = this.progressTween) == null ? void 0 : _a.remove();
    }
  };

  // src/scenes/gameplayGui/topPanel/powerupChef/PowerupChef.ts
  var PowerupChef = class extends Phaser.GameObjects.Container {
    constructor(scene, config2, rndSeed) {
      super(scene);
      this.config = config2;
      this.current = 0;
      this.total = this.config.powerupsNum;
      this.name = "powerup_chef";
      this.createPowerupTypesGenerator(rndSeed);
      this.addBack();
      this.addChef();
      this.addProgressBarBack();
      this.addProgressBarFill();
      this.addLabel();
      if (this.config.isEnabled === false) {
        this.label.kill();
        this.progressBarBack.kill();
        this.progressBarFill.kill();
      }
    }
    createPowerupTypesGenerator(rndSeed) {
      let _a = this.config, {isEnabled, powerupsNum} = _a, weights = __objRest(_a, ["isEnabled", "powerupsNum"]);
      this.powerupTypesGenerator = new ItemsGenerator(weights, rndSeed);
    }
    addProgressBarBack() {
      this.progressBarBack = this.scene.add.image(0, 0, "gameplay_gui", "powerup_chef/progress_bar_back");
      this.progressBarBack.y = 25;
      this.add(this.progressBarBack);
    }
    addProgressBarFill() {
      let angleOffset = 24;
      let options = {
        radius: 85,
        thickness: 13,
        color: 16733558,
        startAngle: -angleOffset,
        endAngle: 180 + angleOffset,
        useRoundCaps: true
      };
      this.progressBarFill = new CircularProgressBar(this.scene, options);
      this.progressBarFill.x = this.progressBarBack.x;
      this.progressBarFill.y = this.progressBarBack.y - 25;
      this.progressBarFill.setProgressInstant(0);
      this.add(this.progressBarFill);
    }
    addLabel() {
      let content = this.getLabelContent();
      this.label = this.scene.add.bitmapText(0, 0, BitmapFont.POWERUP_CHEF, content, 25);
      this.label.setLetterSpacing(1);
      this.label.setOrigin(0.5, 0.5);
      this.label.x = -2;
      this.label.y = this.back.bottom + 15;
      this.add(this.label);
    }
    getLabelContent() {
      return `${this.current}/${this.total}`;
    }
    updateLabelContent() {
      this.label.text = this.getLabelContent();
    }
    animateLabel() {
      this.label.scale = 1;
      this.scene.tweens.killTweensOf(this.label);
      this.scene.tweens.add({
        targets: this.label,
        duration: 233,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.25,
        yoyo: true
      });
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "gameplay_gui", "powerup_chef/Moves Circle");
      this.back.scale = 0.96;
      this.add(this.back);
    }
    addChef() {
      this.chef = this.scene.add.image(0, 0, "gameplay_gui", "powerup_chef/chef");
      this.chef.x = 0;
      this.chef.y = this.back.bottom - 4;
      this.chef.originalY = this.chef.y;
      this.add(this.chef);
    }
    incrementCurrent() {
      this.current++;
      this.updateProgress();
    }
    updateProgress() {
      let progress = Phaser.Math.Clamp(this.current / this.total, 0, 1);
      this.progressBarFill.setProgress(progress);
      this.updateLabelContent();
      this.animateLabel();
    }
    isPowerupReady() {
      return this.current >= this.total;
    }
    emitPowerup() {
      this.current -= this.total;
      this.updateProgress();
      this.playEmitTweens();
      return this.powerupTypesGenerator.getItem();
    }
    resetProgress() {
      this.current = 0;
      this.progressBarFill.stopProgressTween();
      this.progressBarFill.setProgressInstant(0);
      this.updateLabelContent();
      this.animateLabel();
    }
    playEmitTweens() {
      this.scene.tweens.add({
        targets: this.chef,
        duration: 233,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.1,
        yoyo: true
      });
    }
  };

  // src/scenes/gameplayGui/topPanel/TopPanel.ts
  var TopPanel = class extends Phaser.GameObjects.Container {
    constructor(scene, levelConfig) {
      super(scene);
      this.name = "top_panel";
      this.addBack();
      this.addGoalsPanel(levelConfig.goals);
      this.addLevelLabelBack();
      this.addLevelLabel(levelConfig.levelNumber);
      this.addMovesLabel(levelConfig.moves);
      this.addPowerupChef(levelConfig);
      if (levelConfig.hard) {
        this.addSkullIcon();
      }
      this.bringToTop(this.movesLabel);
      this.bringToTop(this.levelLabel);
      this.setSize(this.back.width, this.back.height);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "gameplay_gui", "top_panel/top_panel_back");
      this.back.clicksNum = 0;
      this.back.clicksEnabled = true;
      this.back.lastClickTs = 0;
      this.back.eventsSent = 0;
      this.back.setInteractive();
      this.add(this.back);
      let fastSwitch = UrlParams.getBool("fastSwitch");
      if (fastSwitch || Main.development) {
        this.back.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onBackClickDev, this);
      } else {
        this.back.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onBackClick, this);
      }
    }
    onBackClickDev(pointer, x, y) {
      if (x > this.back.width * 0.66) {
        this.scene.events.emit(GameplayGuiEvent.GOTO_NEXT_LEVEL);
      } else if (x < this.back.width * 0.33) {
        this.scene.events.emit(GameplayGuiEvent.GOTO_PREV_LEVEL);
      } else {
        this.handleBackCenterClick();
      }
    }
    onBackClick(pointer, x, y) {
      if (x > this.back.width * 0.33 && x < this.back.width * 0.66) {
        this.handleBackCenterClick();
      }
    }
    handleBackCenterClick() {
      if (this.back.clicksEnabled === false) {
        return;
      }
      let timePassed = Date.now() - this.back.lastClickTs;
      if (timePassed > 500) {
        this.back.lastClickTs = Date.now();
        this.back.clicksNum = 0;
        return;
      }
      this.back.lastClickTs = Date.now();
      this.back.clicksNum++;
      if (this.back.clicksNum === 5) {
        if (++this.back.eventsSent === 3) {
          this.back.clicksEnabled = false;
        }
        this.back.clicksNum = 0;
        this.back.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onBackClick, this);
        this.scene.audio.play(GameSoundKey.FANCY_TAP);
        this.scene.events.emit(GameplayGuiEvent.SEND_GAMEPLAY_SESSION);
      }
    }
    addGoalsPanel(goalsConfig) {
      let center = this.back.getCenter();
      let goals = GoalUtils.createGoalsArray(goalsConfig);
      this.goalsPanel = new GoalsPanel(this.scene, goals);
      this.goalsPanel.x = center.x - this.goalsPanel.width / 2 - 212;
      this.goalsPanel.y = center.y - this.goalsPanel.height / 2 - 30;
      this.add(this.goalsPanel);
    }
    addPowerupChef(levelConfig) {
      let backCenter = this.back.getCenter();
      this.chef = new PowerupChef(this.scene, levelConfig.chefPowerups, this.scene.gameplay.initData.rndSeed);
      this.chef.y = backCenter.y - 12;
      this.add(this.chef);
    }
    addSkullIcon() {
      let skull = this.scene.add.image(0, 0, "gameplay_gui", "top_panel/skull_small");
      skull.x = 286;
      skull.y = 128;
      skull.angle = 2;
      this.add(skull);
    }
    addMovesLabel(moves) {
      let backCenter = this.back.getCenter();
      this.movesLabel = new MovesLabel(this.scene);
      this.movesLabel.updateMovesNum(moves, true);
      this.movesLabel.x = backCenter.x + 220;
      this.movesLabel.y = backCenter.y + 3;
      this.add(this.movesLabel);
    }
    addLevelLabelBack() {
      this.levelLabelBack = this.scene.add.image(0, 0, "gameplay_gui", "top_panel/PopupCreamChoco");
      this.levelLabelBack.x = this.back.getCenter().x + 210;
      this.levelLabelBack.y = 32;
      this.add(this.levelLabelBack);
    }
    addLevelLabel(levelNumber) {
      let content = `~ ${levelNumber} ~`;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "22px",
        color: "#FFE0AD",
        align: "center"
      };
      this.levelLabel = this.scene.add.text(0, 0, content, style);
      this.levelLabel.setOrigin(0.5, 0.5);
      this.levelLabel.x = this.levelLabelBack.x + 4;
      this.levelLabel.y = this.levelLabelBack.y - 10;
      this.add(this.levelLabel);
    }
  };

  // src/scenes/gameplayGui/GameplayGuiDepth.ts
  var GameplayGuiDepth;
  (function(GameplayGuiDepth2) {
    GameplayGuiDepth2[GameplayGuiDepth2["TOP_PANEL"] = 0] = "TOP_PANEL";
    GameplayGuiDepth2[GameplayGuiDepth2["GOAL_ITEMS"] = 1] = "GOAL_ITEMS";
    GameplayGuiDepth2[GameplayGuiDepth2["MOVES_WARNING"] = 2] = "MOVES_WARNING";
    GameplayGuiDepth2[GameplayGuiDepth2["BOOSTER_HINT_SCREEN"] = 3] = "BOOSTER_HINT_SCREEN";
    GameplayGuiDepth2[GameplayGuiDepth2["BOOSTER_HINT_WARNING"] = 4] = "BOOSTER_HINT_WARNING";
    GameplayGuiDepth2[GameplayGuiDepth2["BOOSTERS_PANEL"] = 5] = "BOOSTERS_PANEL";
    GameplayGuiDepth2[GameplayGuiDepth2["GOALS_SCREEN"] = 6] = "GOALS_SCREEN";
    GameplayGuiDepth2[GameplayGuiDepth2["PARTICLES"] = 7] = "PARTICLES";
    GameplayGuiDepth2[GameplayGuiDepth2["TUTORIAL"] = 8] = "TUTORIAL";
    GameplayGuiDepth2[GameplayGuiDepth2["SECOND_CHANCE_SCREEN"] = 9] = "SECOND_CHANCE_SCREEN";
    GameplayGuiDepth2[GameplayGuiDepth2["LEVEL_FAILED_SCREEN"] = 10] = "LEVEL_FAILED_SCREEN";
    GameplayGuiDepth2[GameplayGuiDepth2["START_LEVEL_SCREEN"] = 11] = "START_LEVEL_SCREEN";
    GameplayGuiDepth2[GameplayGuiDepth2["VIDEO_REWARDS_SCREEN"] = 12] = "VIDEO_REWARDS_SCREEN";
    GameplayGuiDepth2[GameplayGuiDepth2["PIGGY_BANK_SCREEN"] = 13] = "PIGGY_BANK_SCREEN";
    GameplayGuiDepth2[GameplayGuiDepth2["LIVES_SCREEN"] = 14] = "LIVES_SCREEN";
    GameplayGuiDepth2[GameplayGuiDepth2["SHOP_SCREEN"] = 15] = "SHOP_SCREEN";
    GameplayGuiDepth2[GameplayGuiDepth2["LEVEL_PRE_COMPLETE_SCREEN"] = 16] = "LEVEL_PRE_COMPLETE_SCREEN";
    GameplayGuiDepth2[GameplayGuiDepth2["LEVEL_COMPLETE_SCREEN"] = 17] = "LEVEL_COMPLETE_SCREEN";
    GameplayGuiDepth2[GameplayGuiDepth2["PAUSE_SCREEN"] = 18] = "PAUSE_SCREEN";
    GameplayGuiDepth2[GameplayGuiDepth2["QUIT_SCREEN"] = 19] = "QUIT_SCREEN";
    GameplayGuiDepth2[GameplayGuiDepth2["UNDO_OVERLAY"] = 20] = "UNDO_OVERLAY";
    GameplayGuiDepth2[GameplayGuiDepth2["DEBUG_GUIDES"] = 21] = "DEBUG_GUIDES";
  })(GameplayGuiDepth || (GameplayGuiDepth = {}));

  // src/scenes/gameplayGui/boosters/BoosterNumLabel.ts
  var BoosterNumLabel = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.name = "num_label";
      this.addBack();
      this.addText();
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "gameplay_gui", "boosters/Booster Amound Circle");
      this.add(this.back);
    }
    addText() {
      let content = "0";
      this.text = this.scene.add.bitmapText(0, 0, BitmapFont.BOOSTER_LABELS, content, 22);
      this.text.setLetterSpacing(-1);
      this.text.setOrigin(0.5, 0.5);
      this.text.x = 0;
      this.text.y = 5;
      this.add(this.text);
    }
    updateNum(value) {
      this.text.setText(value.toString());
    }
  };

  // src/scenes/gameplayGui/boosters/BoosterIcon.ts
  var BoosterIcon = class extends Phaser.GameObjects.Container {
    constructor(scene, booster, isEnabled) {
      super(scene);
      this._isSelected = false;
      this.originalY = 0;
      this.name = "booster_" + booster.type;
      this.isLocked = !isEnabled;
      this._booster = booster;
      this._booster.on(BoosterEvent.NUM_CHANGED, this.onBoosterNumChanged, this);
      this.addParticles();
      this.addIcon();
      this.addNumLabelEmitter();
      this.addNumLabel();
      this.addPlusButton();
      this.addCloseButton();
      this.setSize(this.icon.width, this.icon.height);
      this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onInputDown, this);
      this.scene.input.on(Phaser.Input.Events.POINTER_UP, this.onInputUp, this);
      this.enableInteractive();
      this.updateView();
    }
    get isSelected() {
      return this._isSelected;
    }
    get booster() {
      return this._booster;
    }
    onBoosterNumChanged() {
      this.updateView();
    }
    updateView() {
      if (this.isLocked) {
        let frameName = `boosters/booster_disabled`;
        this.icon.setFrame(frameName);
        this.plusButton.kill();
        this.numLabel.kill();
        return;
      }
      if (this._booster.num === 0) {
        this.plusButton.revive();
        this.numLabel.kill();
      } else {
        this.plusButton.kill();
        this.numLabel.revive();
        this.numLabel.updateNum(this._booster.num);
      }
    }
    enableInteractive() {
      this.setInteractive();
      this.input.cursor = "pointer";
    }
    onInputDown(pointer) {
      this.currentPointer = pointer;
      this.scene.tweens.add({
        targets: this,
        scale: this.scale * 0.9,
        ease: Phaser.Math.Easing.Cubic.Out,
        duration: 50
      });
      if (this.scene.cache.audio.has(GameSoundKey.TAP)) {
        this.scene.sound.play(GameSoundKey.TAP, {volume: 1});
      }
    }
    onInputUp(pointer) {
      if (this.currentPointer && this.currentPointer === pointer) {
        this.currentPointer = null;
        this.scene.tweens.add({
          targets: this,
          scale: 1,
          ease: Phaser.Math.Easing.Back.Out,
          duration: 300
        });
      }
    }
    addParticles() {
      this.particles = this.scene.add.particles("gameplay_gui");
      this.emitter = this.particles.createEmitter({
        frame: "particles/circle_fx",
        scale: {start: 1.1, end: 1.5, ease: Ease.ExpoOut},
        alpha: {start: 0.66, end: 0, ease: Ease.ExpoOut},
        lifespan: 2e3,
        frequency: 500,
        on: false
      });
      this.add(this.particles);
    }
    addIcon() {
      let frameName = "boosters/" + this._booster.type;
      this.icon = this.scene.add.image(0, 0, "gameplay_gui", frameName);
      this.add(this.icon);
    }
    addNumLabelEmitter() {
      this.numLabelEmitter = this.particles.createEmitter({
        frame: "particles/circle_fx",
        scale: {start: 0.4, end: 1, ease: Ease.ExpoOut},
        alpha: {start: 0.66, end: 0, ease: Ease.ExpoOut},
        lifespan: 2e3,
        frequency: 500,
        on: false
      });
    }
    addNumLabel() {
      let offset = this.icon.width / 2 - 15;
      this.numLabel = new BoosterNumLabel(this.scene);
      this.numLabel.updateNum(this._booster.num);
      this.numLabel.x = offset;
      this.numLabel.y = offset - 6;
      this.numLabel.originalX = this.numLabel.x;
      this.add(this.numLabel);
    }
    addPlusButton() {
      this.plusButton = this.scene.add.image(0, 0, "gameplay_gui", "boosters/plus_button_3");
      this.plusButton.x = this.numLabel.x - 1;
      this.plusButton.y = this.numLabel.y - 1;
      this.add(this.plusButton);
    }
    addCloseButton() {
      this.closeButton = this.scene.add.image(0, 0, "gameplay_gui", "boosters/button_close");
      this.closeButton.x = this.plusButton.x + 2;
      this.closeButton.y = -36;
      this.closeButton.originalY = this.closeButton.y;
      this.closeButton.kill();
      this.add(this.closeButton);
    }
    highlight() {
      this._isSelected = true;
      this.emitter.flow(800);
      this.showCloseButton();
      this.scene.tweens.add({
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Quadratic.InOut,
        y: this.originalY - 12
      });
    }
    showCloseButton() {
      this.closeButton.revive();
      this.closeButton.alpha = 0;
      this.closeButton.y = this.closeButton.originalY - 20;
      this.scene.tweens.killTweensOf(this.closeButton);
      this.scene.tweens.add({
        targets: this.closeButton,
        duration: 200,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 1,
        y: this.closeButton.originalY
      });
    }
    resetHighlight() {
      this._isSelected = false;
      this.emitter.on = false;
      this.emitter.killAll();
      this.hideCloseButton();
      this.scene.tweens.add({
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Quadratic.InOut,
        y: this.originalY
      });
    }
    hideCloseButton() {
      this.scene.tweens.killTweensOf(this.closeButton);
      this.closeButton.kill();
    }
    dim() {
      this.alpha = 0.4;
      if (this.isLocked === false) {
        this.numLabel.alpha = 0;
        this.plusButton.alpha = 0;
        this.disableInteractive();
      }
    }
    resetDim() {
      this.alpha = 1;
      if (this.isLocked === false) {
        this.numLabel.alpha = 1;
        this.plusButton.alpha = 1;
        this.enableInteractive();
      }
    }
    onBoosterIncrease() {
      this.scene.audio.play(GameSoundKey.TWINKLE_3, {volume: 0.5});
      this.numLabelEmitter.emitParticle(1, this.numLabel.x, this.numLabel.y);
      this.scene.tweens.killTweensOf(this.numLabel);
      this.numLabel.alpha = 0;
      this.scene.tweens.add({
        targets: this.numLabel,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.numLabel.scale = 2;
      this.scene.tweens.add({
        targets: this.numLabel,
        duration: 900,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
    }
    preDestroy() {
      this.scene.input.off(Phaser.Input.Events.POINTER_UP, this.onInputUp, this);
      this._booster.off(BoosterEvent.NUM_CHANGED, this.onBoosterNumChanged, this);
      super.preDestroy();
    }
  };

  // src/scenes/gameplayGui/boosters/IngameBoosterLockedPopover.ts
  var IngameBoosterLockedPopoverEvent;
  (function(IngameBoosterLockedPopoverEvent2) {
    IngameBoosterLockedPopoverEvent2["SHOW"] = "__SHOW";
    IngameBoosterLockedPopoverEvent2["HIDE_COMPLETE"] = "__HIDE_COMPLETE";
  })(IngameBoosterLockedPopoverEvent || (IngameBoosterLockedPopoverEvent = {}));
  var IngameBoosterLockedPopover = class extends Phaser.GameObjects.Container {
    constructor(scene, backTexture, backFrame) {
      super(scene);
      this.name = "booster_locked_popover";
      this.addBack(backTexture, backFrame);
      this.addTitleBack();
      this.addTitle();
      this.addText();
      this.setSize(this.back.displayWidth, this.back.displayHeight);
    }
    addBack(backTexture, backFrame) {
      this.back = this.scene.add.image(0, 0, backTexture, backFrame);
      this.add(this.back);
    }
    addTitleBack() {
      this.titleBack = this.scene.add.image(0, 0, "gameplay_gui", "boosters/popover_hint");
      this.titleBack.y = this.back.top + 6;
      this.add(this.titleBack);
    }
    addTitle() {
      let content = "Booster";
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "26px",
        color: "#ffffff",
        align: "center",
        padding: {x: 0, y: 4}
      };
      this.title = this.scene.add.text(0, 0, content, style);
      this.title.setOrigin(0.5, 0.5);
      this.title.setShadow(0, 2, "rgba(0,0,0,0.2)", 0);
      this.title.x = this.titleBack.x;
      this.title.y = this.titleBack.y - 2;
      this.add(this.title);
      this.adjustTitleSize();
    }
    addText() {
      let content = this.scene.texts.booster_lock;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "26px",
        color: "#B35F44",
        align: "center"
      };
      this.text = this.scene.add.text(0, 0, content, style);
      this.text.setOrigin(0.5, 0.5);
      this.text.setWordWrapWidth(300, true);
      this.text.setLineSpacing(-2);
      this.add(this.text);
      this.adjustTextSize();
    }
    show(options) {
      this.emit(IngameBoosterLockedPopoverEvent.SHOW, this);
      this.scene.tweens.killTweensOf(this);
      this.revive();
      this.alpha = 0;
      this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.scale = 0.66;
      this.scene.tweens.add({
        targets: this,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1,
        onComplete: () => {
          this.hide(options.duration);
        }
      });
    }
    hide(delay) {
      this.scene.tweens.killTweensOf(this);
      this.scene.tweens.add({
        delay,
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.emit(IngameBoosterLockedPopoverEvent.HIDE_COMPLETE, this);
          this.kill();
        }
      });
    }
    forceHide() {
      this.scene.tweens.killTweensOf(this);
      this.emit(IngameBoosterLockedPopoverEvent.HIDE_COMPLETE, this);
      this.kill();
    }
    updateContent(title, content) {
      this.title.text = title;
      this.adjustTitleSize();
      this.text.text = content;
      this.adjustTextSize();
    }
    adjustTitleSize() {
      let maxWidth = this.titleBack.width * 0.8;
      this.title.scale = Math.min(1, maxWidth / this.title.width);
    }
    adjustTextSize() {
      let top = this.titleBack.bottom - 16;
      let bottom = this.back.top + 126;
      let height = bottom - top;
      let maxHeight = height * 0.7;
      this.text.scale = Math.min(1, maxHeight / this.text.height);
      this.text.y = top + height / 2;
    }
  };

  // src/scenes/gameplayGui/boosters/BoostersPanel.ts
  var BoostersPanelEvent;
  (function(BoostersPanelEvent2) {
    BoostersPanelEvent2["SELECT"] = "__SELECT";
    BoostersPanelEvent2["CANCEL"] = "__CANCEL";
    BoostersPanelEvent2["BUY_BOOSTER"] = "__BUY_BOOSTER";
  })(BoostersPanelEvent || (BoostersPanelEvent = {}));
  var BoostersPanel = class extends Phaser.GameObjects.Container {
    constructor(scene, boosters, boostersConfig) {
      super(scene);
      this.cellWidth = 140;
      this.cellHeight = 110;
      this.originalY = 0;
      this.name = "boosters_panel";
      this.addIcons(boosters, boostersConfig);
      this.alignIcons();
      this.addPopover();
      this.setSize(this.icons.length * this.cellWidth, this.cellHeight);
      this.addOverlay();
    }
    addIcons(boosters, boostersConfig) {
      this.icons = boosters.map((booster) => {
        let icon = new BoosterIcon(this.scene, booster, boostersConfig[booster.type]);
        icon.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onIconClick.bind(this, icon));
        this.add(icon);
        return icon;
      });
      this.iconsReversed = this.icons.slice().reverse();
    }
    onIconClick(icon) {
      this.scene.audio.playClick();
      if (icon.isLocked) {
        this.showPopoverAt(icon);
        return;
      }
      if (icon.booster.num === 0) {
        this.emit(BoostersPanelEvent.BUY_BOOSTER, icon.booster);
        return;
      }
      if (icon.isSelected) {
        this.emit(BoostersPanelEvent.CANCEL, icon.booster);
      } else {
        this.emit(BoostersPanelEvent.SELECT, icon.booster);
      }
    }
    alignIcons() {
      this.gridAlign({
        cellWidth: this.cellWidth,
        cellHeight: this.cellHeight,
        x: this.cellWidth / 2,
        y: this.cellHeight / 2,
        position: Phaser.Display.Align.CENTER,
        height: 1
      });
      this.icons.forEach((icon) => {
        icon.originalY = icon.y;
      });
    }
    addPopover() {
      let hasLockedBoosters = this.icons.some((icon) => icon.isLocked);
      if (hasLockedBoosters === false) {
        return;
      }
      this.popover = new IngameBoosterLockedPopover(this.scene, "gameplay_gui", "boosters/popover");
      this.popover.kill();
      this.add(this.popover);
      this.scene.input.on(Phaser.Input.Events.POINTER_DOWN, this.onScenePointerDown, this);
    }
    onScenePointerDown(pointer, objects) {
      if (this.popover.visible === false) {
        return;
      }
      let isBoosterIcon = objects.some((item) => item instanceof BoosterIcon && item.isLocked);
      if (isBoosterIcon) {
        return;
      }
      this.popover.hide(0);
    }
    showPopoverAt(icon) {
      let booster = icon.booster;
      let unlockLevel = window.game.config.boosters_unlock[booster.type];
      let content = this.scene.texts.booster_lock.replace("#", unlockLevel.toString());
      this.popover.x = icon.x;
      this.popover.y = icon.y - 50;
      this.popover.updateContent(booster.title, content);
      this.popover.show({duration: 1700});
    }
    addOverlay() {
      this.overlay = this.scene.add.image(0, 0, "gameplay_gui", "black_rect");
      this.overlay.displayWidth = this.width;
      this.overlay.displayHeight = this.height * 1.2;
      this.overlay.x = this.width / 2;
      this.overlay.y = this.height / 2;
      this.overlay.alpha = 1e-3;
      this.overlay.visible = false;
      this.overlay.setInteractive();
      this.add(this.overlay);
    }
    show() {
      this.revive();
      this.iconsReversed.forEach((icon) => {
        icon.alpha = 0;
        icon.y = icon.originalY - 10;
        this.scene.tweens.add({
          delay: 150,
          targets: icon,
          duration: 150,
          ease: Phaser.Math.Easing.Cubic.Out,
          alpha: 1,
          y: icon.originalY
        });
      });
    }
    hide() {
      this.scene.tweens.add({
        targets: this.icons,
        duration: 100,
        ease: Phaser.Math.Easing.Linear,
        alpha: 0,
        y: "+=10"
      }).on(Phaser.Tweens.Events.TIMELINE_COMPLETE, () => {
        this.kill();
      });
    }
    getIconByType(boosterType) {
      return this.icons.find((icon) => icon.booster.type === boosterType);
    }
    highlight(boosterType) {
      this.icons.forEach((icon) => {
        if (icon.booster.type === boosterType) {
          icon.highlight();
        } else {
          icon.dim();
        }
      });
    }
    resetHighlight() {
      this.icons.forEach((icon) => {
        if (icon.isSelected) {
          icon.resetHighlight();
        } else {
          icon.resetDim();
        }
      });
    }
    killIconsExcept(boosterType) {
      this.icons.forEach((icon) => {
        if (icon.booster.type !== boosterType) {
          icon.kill();
        }
      });
    }
    reviveAllIcons() {
      this.icons.forEach((icon) => icon.revive());
    }
    enableInput() {
      this.overlay.visible = false;
    }
    disableInput() {
      this.overlay.visible = true;
    }
    emulateClickOnIcon(boosterType) {
      this.onIconClick(this.getIconByType(boosterType));
    }
    preDestroy() {
      super.preDestroy();
      this.scene.input.off(Phaser.Input.Events.POINTER_DOWN, this.onScenePointerDown, this);
    }
  };

  // src/scenes/gameplay/GridUtils.ts
  var CELL_SIZE = 78;
  function gridToPixels(column, row) {
    return {
      x: CELL_SIZE / 2 + column * CELL_SIZE,
      y: CELL_SIZE / 2 + row * CELL_SIZE
    };
  }
  function pixelsToGridXY(x, y) {
    return {
      column: Math.floor(x / CELL_SIZE),
      row: Math.floor(y / CELL_SIZE)
    };
  }
  function pixelsToGrid(position) {
    return pixelsToGridXY(position.x, position.y);
  }
  function getGridBounds(positions) {
    let left = minBy_default(positions, "column").column;
    let right = maxBy_default(positions, "column").column;
    let top = minBy_default(positions, "row").row;
    let bottom = maxBy_default(positions, "row").row;
    let width = right - left + 1;
    let height = bottom - top + 1;
    return {width, height, top, left};
  }
  function gridDistanceXY(column_1, row_1, column_2, row_2) {
    return Phaser.Math.Distance.Between(column_1, row_1, column_2, row_2);
  }
  function alignToGrid(item, column, row) {
    column = column != null ? column : item.column;
    row = row != null ? row : item.row;
    let position = gridToPixels(column, row);
    item.x = position.x;
    item.y = position.y;
  }
  function alignMulticellItemToGrid(item, column, row) {
    column = column != null ? column : item.column;
    row = row != null ? row : item.row;
    let position = gridToPixels(column, row);
    item.x = position.x + item.displayWidth / 2 - CELL_SIZE / 2;
    item.y = position.y + item.displayHeight / 2 - CELL_SIZE / 2;
  }
  function sortUpBottom(item_1, item_2) {
    if (item_1.row === item_2.row) {
      return item_1.column - item_2.column;
    }
    return item_1.row - item_2.row;
  }
  function sortBottomUp(item_1, item_2) {
    if (item_1.row === item_2.row) {
      return item_2.column - item_1.column;
    }
    return item_2.row - item_1.row;
  }
  function calculateDimensions(items) {
    let leftItem = minBy_default(items, "column");
    let rightItem = maxBy_default(items, "column");
    let topItem = minBy_default(items, "row");
    let bottomItem = maxBy_default(items, "row");
    return {
      left: leftItem.column,
      right: rightItem.column,
      top: topItem.row,
      bottom: bottomItem.row,
      width: rightItem.column - leftItem.column + 1,
      height: bottomItem.row - topItem.row + 1
    };
  }
  function gridMedianPosition(positions) {
    let columns = [];
    let rows = [];
    positions.forEach((position, index) => {
      columns[index] = position.column;
      rows[index] = position.row;
    });
    return {
      column: Phaser.Math.Median(columns),
      row: Phaser.Math.Median(rows)
    };
  }

  // src/scenes/gameplayGui/tutorial/TapTutorialHand.ts
  var TapTutorialHand = class extends Phaser.GameObjects.Container {
    constructor(scene, texture, frame) {
      super(scene);
      this.name = "tap_hand";
      this.addHand(texture, frame);
    }
    addHand(texture, frame) {
      this.hand = this.scene.add.image(0, 0, texture, frame);
      this.add(this.hand);
    }
    playAnimation(startDelay = 0, repeatDelay = 800) {
      var _a, _b, _c;
      this.hand.alpha = 0;
      (_a = this.scene) == null ? void 0 : _a.tweens.add({
        delay: startDelay,
        targets: this.hand,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.hand.scale = 1.5;
      (_b = this.scene) == null ? void 0 : _b.tweens.add({
        delay: startDelay,
        targets: this.hand,
        duration: 400,
        ease: Phaser.Math.Easing.Cubic.Out,
        scale: 1
      });
      this.hand.angle = 30;
      (_c = this.scene) == null ? void 0 : _c.tweens.add({
        delay: startDelay,
        targets: this.hand,
        duration: 400,
        ease: Phaser.Math.Easing.Cubic.Out,
        angle: 0,
        onComplete: () => {
          var _a2;
          (_a2 = this.scene) == null ? void 0 : _a2.tweens.add({
            delay: 200,
            targets: this.hand,
            duration: 200,
            ease: Phaser.Math.Easing.Cubic.Out,
            alpha: 0,
            onComplete: () => {
              this.hand.x = 0;
              this.hand.y = 0;
              this.playAnimation(repeatDelay);
            }
          });
        }
      });
    }
    stopAnimation() {
      this.scene.tweens.killTweensOf(this.hand);
    }
    preDestroy() {
      this.scene.tweens.killTweensOf(this.hand);
    }
  };

  // src/scenes/gameplayGui/BoosterHintScreen.ts
  var BoosterHintScreen = class extends PhaserScreen {
    constructor(scene, gameplay) {
      super(scene, {
        name: "booster_hint_screen",
        backgroundKey: "gameplay_gui",
        backgroundFrame: "black_rect",
        backgroundAlpha: 1e-3,
        backgroundInteractive: false
      });
      this.gameplay = gameplay;
      this.background.kill();
      this.addHand();
      this.addBoosterTitle();
      this.addBoosterHint();
    }
    addHand() {
      this.hand = new TapTutorialHand(this.scene, "gameplay_gui", "tutorial/hand");
      this.add(this.hand);
    }
    addBoosterTitle() {
      let content = this.scene.texts.boosters.lollipop.title;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "50px",
        color: "#FCE916",
        align: "center",
        padding: {x: 0, y: 10}
      };
      this.title = this.scene.add.text(0, 0, content, style);
      this.title.setOrigin(0.5, 0.5);
      this.title.setShadow(0, 3, "#AC4717", 2);
      this.add(this.title);
    }
    addBoosterHint() {
      let content = this.scene.texts.boosters.lollipop.hint;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "32px",
        color: "#ffffff",
        align: "center",
        padding: {x: 0, y: 10}
      };
      this.hint = this.scene.add.text(0, 0, content, style);
      this.hint.setOrigin(0.5, 0.5);
      this.hint.setShadow(0, 4, "rgba(0,0,0,0.5)", 0);
      this.add(this.hint);
    }
    resize() {
      super.resize();
      this.alignHand();
      this.alignHint();
      this.alignTitle();
    }
    alignHand() {
      var _a, _b;
      let column = (_a = this.hand.column) != null ? _a : 0;
      let row = (_b = this.hand.row) != null ? _b : 0;
      let position = gridToPixels(column, row);
      let gameplayPosition = this.gameplay.camera.getWorldPosition(position);
      let localPos = this.pointToContainer(gameplayPosition);
      this.hand.x = localPos.x + 70;
      this.hand.y = localPos.y + 80;
    }
    alignHint() {
      let top = 0;
      let bottom = this.getFieldTop() - 5 * this.scale;
      let height = bottom - top;
      this.hint.setWordWrapWidth(this.screenWidth * 0.8, true);
      this.hint.x = this.screenCenter.x;
      this.hint.y = top + height * 0.66;
      this.hint.originalY = this.hint.y;
    }
    alignTitle() {
      let top = 0;
      let bottom = this.hint.y - this.hint.height / 2;
      let height = bottom - top;
      let y = top + height / 2;
      this.title.x = this.screenCenter.x;
      this.title.y = Math.max(y, this.hint.y - this.hint.height / 2 - this.title.height / 2 - 8);
      this.title.originalY = this.title.y;
    }
    getFieldTop() {
      let camera = this.gameplay.camera.camera;
      let cameraCenter = camera.centerY - camera.y + this.gameplay.camera.getTopOffset();
      let fieldDimensions = this.gameplay.field.dimensions;
      let fieldHeight = fieldDimensions.height * CELL_SIZE;
      let fieldDisplayHeight = fieldHeight * camera.zoom;
      return (cameraCenter - fieldDisplayHeight / 2) / this.scale;
    }
    updateData(booster, handCell) {
      this.title.text = booster.title;
      this.hint.text = booster.hint;
      this.alignTitle();
      if (handCell) {
        this.hand.column = handCell.column;
        this.hand.row = handCell.row;
        this.alignHand();
        this.hand.revive();
      } else {
        this.hand.kill();
      }
    }
    show() {
      this.revive();
      this.scene.tweens.killTweensOf(this);
      this.alpha = 1;
      this.showTexts();
      this.showHand(300);
    }
    showTexts() {
      let texts = [this.hint, this.title];
      texts.forEach((text, index) => {
        let delay = index * 66;
        text.alpha = 0;
        this.scene.tweens.add({
          delay,
          targets: text,
          duration: 200,
          ease: Phaser.Math.Easing.Cubic.Out,
          alpha: 1
        });
        text.scale = 0.75;
        this.scene.tweens.add({
          delay,
          targets: text,
          duration: 400,
          ease: Phaser.Math.Easing.Back.Out,
          scale: 1
        });
        text.y = text.originalY - 30;
        this.scene.tweens.add({
          delay,
          targets: text,
          duration: 500,
          ease: Phaser.Math.Easing.Back.Out,
          y: text.originalY
        });
      });
    }
    showHand(delay) {
      if (this.hand.visible === false) {
        return;
      }
      this.hand.kill();
      this.showHandTimerEvent = this.scene.time.delayedCall(delay, () => {
        this.hand.revive();
        this.hand.playAnimation();
      });
    }
    hide() {
      var _a;
      this.emitHideStartEvent();
      if (this.hand.visible) {
        (_a = this.showHandTimerEvent) == null ? void 0 : _a.remove();
        this.hand.stopAnimation();
      }
      this.scene.tweens.add({
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.kill();
          this.emitHideCompleteEvent();
        }
      });
    }
  };

  // src/scenes/gameplayGui/UndoButton.ts
  var UndoButton = class extends ComplexButton {
    get undoBooster() {
      return this._undoBooster;
    }
    constructor(scene, undoBooster) {
      super(scene, "gameplay_gui", "Blue-RectangleButton");
      this._undoBooster = undoBooster;
      this._undoBooster.on(BoosterEvent.NUM_CHANGED, this.onBoosterNumChange, this);
      this.setName("undo_button");
      this.addIcon("gameplay_gui", "Repeat-Left-Icon");
      this.addParticles();
      this.addNumLabel();
      this.addPlusButton();
      this.updateView();
    }
    onBoosterNumChange() {
      this.updateView();
    }
    updateView() {
      if (this._undoBooster.num === 0) {
        this.setEmptyView();
      } else {
        this.setNonEmptyView();
      }
    }
    setEmptyView() {
      this.numLabel.updateNum(0);
      if (window.game.config.ads.rewarded) {
        this.numLabel.kill();
        this.plusButton.revive();
      } else {
        this.plusButton.kill();
      }
    }
    setNonEmptyView() {
      this.numLabel.revive();
      this.numLabel.updateNum(this._undoBooster.num);
      this.plusButton.kill();
    }
    addParticles() {
      this.particles = this.scene.add.particles("gameplay_gui");
      this.emitter = this.particles.createEmitter({
        frame: "particles/circle_fx",
        scale: {start: 0.4, end: 1, ease: Ease.ExpoOut},
        alpha: {start: 0.66, end: 0, ease: Ease.ExpoOut},
        lifespan: 2e3,
        frequency: 500,
        on: false
      });
      this.add(this.particles);
    }
    addNumLabel() {
      this.numLabel = new BoosterNumLabel(this.scene);
      this.numLabel.x = -34;
      this.numLabel.y = -34;
      this.numLabel.originalX = this.numLabel.x;
      this.numLabel.originalY = this.numLabel.y;
      this.add(this.numLabel);
    }
    addPlusButton() {
      this.plusButton = this.scene.add.image(0, 0, "gameplay_gui", "boosters/plus_button_3");
      this.plusButton.x = this.numLabel.x;
      this.plusButton.y = this.numLabel.y;
      this.add(this.plusButton);
    }
    shakeNumLabel() {
      this.numLabel.scale = 1;
      this.scene.tweens.killTweensByProperty(this.numLabel, "scale");
      this.scene.tweens.add({
        targets: this.numLabel,
        duration: 233,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.33,
        hold: 200,
        yoyo: true
      });
    }
    onRewardGranted() {
      this.scene.audio.play(GameSoundKey.TWINKLE_3, {volume: 0.5});
      this.emitter.emitParticle(1, this.numLabel.x, this.numLabel.y);
      this.scene.tweens.killTweensOf(this.numLabel);
      this.numLabel.alpha = 0;
      this.scene.tweens.add({
        targets: this.numLabel,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.numLabel.scale = 2;
      this.scene.tweens.add({
        targets: this.numLabel,
        duration: 900,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
    }
    preDestroy() {
      super.preDestroy();
      this._undoBooster.off(BoosterEvent.NUM_CHANGED, this.onBoosterNumChange, this);
    }
  };

  // src/scenes/levelMap/videoRewardPopup/VideoRewardType.ts
  var VideoRewardSuperType;
  (function(VideoRewardSuperType2) {
    VideoRewardSuperType2["PREGAME_BOOSTER"] = "PREGAME_BOOSTER";
    VideoRewardSuperType2["BOOSTER"] = "BOOSTER";
    VideoRewardSuperType2["OTHER"] = "OTHER";
  })(VideoRewardSuperType || (VideoRewardSuperType = {}));
  var VideoRewardType;
  (function(VideoRewardType3) {
    VideoRewardType3["COINS"] = "coins";
    VideoRewardType3["LIVES"] = "lives";
    VideoRewardType3["STRIPES"] = "stripes";
    VideoRewardType3["BOMB"] = "bomb";
    VideoRewardType3["SUPER_SPHERE"] = "super_sphere";
    VideoRewardType3["UNDO"] = "undo";
    VideoRewardType3["GLOVE"] = "glove";
    VideoRewardType3["ROLLING_PIN"] = "rolling_pin";
    VideoRewardType3["LOLLIPOP"] = "lollipop";
    VideoRewardType3["EXTRA_MOVES"] = "extra_moves";
  })(VideoRewardType || (VideoRewardType = {}));
  var _VideoRewardUtils = class {
    static isPregameBooster(type) {
      return type === VideoRewardType.BOMB || type === VideoRewardType.STRIPES || type === VideoRewardType.SUPER_SPHERE;
    }
    static getRewardByPregameBooster(boosterType) {
      return this.PREGAME_BOOSTERS_REWARDS_MAP[boosterType];
    }
    static getPregameBoosterByReward(rewardType) {
      return findKey_default(this.PREGAME_BOOSTERS_REWARDS_MAP, (value) => value === rewardType);
    }
    static getRewardByBooster(boosterType) {
      return this.BOOSTERS_REWARDS_MAP[boosterType];
    }
    static getBoosterByReward(rewardType) {
      return findKey_default(this.BOOSTERS_REWARDS_MAP, (value) => value === rewardType);
    }
    static getRewardNum(type) {
      var _a;
      return (_a = window.game.config.video_rewards[type]) != null ? _a : 0;
    }
    static getVideoRewardScreenData(rewardType, texts) {
      let rewardNum = _VideoRewardUtils.getRewardNum(rewardType);
      let {title, description} = texts.video_rewards[rewardType];
      return {
        rewardType,
        rewardNum,
        title,
        description
      };
    }
  };
  var VideoRewardUtils = _VideoRewardUtils;
  VideoRewardUtils.SUBTYPES = {
    [VideoRewardSuperType.PREGAME_BOOSTER]: [VideoRewardType.STRIPES, VideoRewardType.BOMB, VideoRewardType.SUPER_SPHERE],
    [VideoRewardSuperType.BOOSTER]: [VideoRewardType.UNDO, VideoRewardType.GLOVE, VideoRewardType.ROLLING_PIN, VideoRewardType.LOLLIPOP],
    [VideoRewardSuperType.OTHER]: [VideoRewardType.COINS, VideoRewardType.LIVES]
  };
  VideoRewardUtils.PREGAME_BOOSTERS_REWARDS_MAP = {
    [PregameBoosterType.STRIPES]: VideoRewardType.STRIPES,
    [PregameBoosterType.BOMB]: VideoRewardType.BOMB,
    [PregameBoosterType.SUPER_SPHERE]: VideoRewardType.SUPER_SPHERE
  };
  VideoRewardUtils.BOOSTERS_REWARDS_MAP = {
    [BoosterType.UNDO]: VideoRewardType.UNDO,
    [BoosterType.GLOVE]: VideoRewardType.GLOVE,
    [BoosterType.ROLLING_PIN]: VideoRewardType.ROLLING_PIN,
    [BoosterType.LOLLIPOP]: VideoRewardType.LOLLIPOP
  };

  // src/scenes/levelMap/videoRewardPopup/VideoRewardIcon.ts
  var VideoRewardIcon = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.name = "booster_icon";
      this.addIcon();
      this.addBubble();
      this.addLabel();
      this.setSize(this.bubble.width, this.bubble.height);
    }
    addIcon() {
      this.icon = this.scene.add.image(0, 0, "popups", "popups/reward/bomb.png");
      this.add(this.icon);
    }
    addBubble() {
      this.bubble = this.scene.add.image(0, 0, "popups", "popups/reward/booster_bubble.png");
      this.add(this.bubble);
    }
    addLabel() {
      let content = "x0";
      this.label = this.scene.add.bitmapText(0, 0, BitmapFont.PREGAME_BOOSTERS_LABELS, content, 40);
      this.label.setOrigin(0.5, 0.5);
      this.label.x = 60;
      this.label.y = 56;
      this.add(this.label);
    }
    updateData(rewardType, num) {
      let iconFrame = `popups/reward/${this.getIconFrameByRewardType(rewardType)}.png`;
      this.icon.setFrame(iconFrame);
      this.label.text = `+${num}`;
    }
    getIconFrameByRewardType(rewardType) {
      let map = {
        [VideoRewardType.LIVES]: "lives",
        [VideoRewardType.EXTRA_MOVES]: "extra_moves",
        [VideoRewardType.COINS]: "coins",
        [VideoRewardType.STRIPES]: "stripes",
        [VideoRewardType.BOMB]: "bomb",
        [VideoRewardType.SUPER_SPHERE]: "super_sphere",
        [VideoRewardType.UNDO]: "undo",
        [VideoRewardType.GLOVE]: "glove",
        [VideoRewardType.ROLLING_PIN]: "rolling_pin",
        [VideoRewardType.LOLLIPOP]: "lollipop"
      };
      return map[rewardType] || map[VideoRewardType.COINS];
    }
    startFloat(initialDelay = 0) {
      this.scene.tweens.add({
        targets: [this.bubble, this.icon],
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        y: "-=10",
        delay: this.scene.tweens.stagger(133, {start: initialDelay}),
        yoyo: true,
        repeat: -1
      });
    }
  };

  // src/scenes/levelMap/videoRewardPopup/VideoRewardPopup.ts
  var VideoRewardPopup = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.name = "reward_popup";
      this.addBack();
      this.addTitleText();
      this.addCloseButton();
      this.addRewardBubble();
      this.addTextBack();
      this.addText();
      this.addPlayButton();
      this.bringToTop(this.rewardBubble);
      this.bringToTop(this.title);
      this.bringToTop(this.text);
      this.setSize(this.back.width, this.back.height);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "popups", "popups/popup_back.png");
      this.add(this.back);
    }
    addTitleText() {
      let content = "Reward";
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "40px",
        color: "#FFE0AD",
        align: "center",
        stroke: "#522923",
        strokeThickness: 10
      };
      this.title = this.scene.add.text(0, 0, content, style);
      this.title.setOrigin(0.5, 0.5);
      this.title.scale = Math.min(1, 290 / this.title.width);
      this.title.y = this.back.top + 62;
      this.add(this.title);
    }
    addCloseButton() {
      this.closeButton = this.scene.add.button("popups", "popups/Close Button.png", this);
      this.closeButton.x = this.back.right - 60;
      this.closeButton.y = this.back.top + 46;
    }
    addRewardBubble() {
      this.rewardBubble = new VideoRewardIcon(this.scene);
      this.rewardBubble.y = -150;
      this.rewardBubble.startFloat();
      this.add(this.rewardBubble);
    }
    addTextBack() {
      this.textBack = this.scene.add.image(0, 0, "popups", "popups/reward/Sale Background.png");
      this.textBack.y = this.rewardBubble.y + this.textBack.height / 2 + 24;
      this.add(this.textBack);
    }
    addText() {
      let content = "Long reward description";
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "40px",
        color: "#ffffff",
        align: "center",
        stroke: "#E69969",
        strokeThickness: 8
      };
      this.text = this.scene.add.text(0, 0, content, style);
      this.text.setOrigin(0.5, 0.5);
      this.text.lineSpacing = -8;
      this.text.y = this.textBack.y + 22;
      this.text.setWordWrapWidth(this.textBack.width * 0.85, true);
      this.adjustTextSize();
      this.add(this.text);
    }
    adjustTextSize() {
      let maxHeight = this.textBack.height * 0.65;
      this.text.scale = Math.min(1, maxHeight / this.text.height);
    }
    addPlayButton() {
      this.playButton = new ComplexButton(this.scene, "popups", "popups/Pink-Button-Long.png", this);
      this.playButton.addIcon("popups", "popups/reward/watch ad.png", 0, -20);
      this.playButton.y = 204;
    }
    updateData(data) {
      this.name = `reward_popup_${data.rewardType}`;
      this.rewardType = data.rewardType;
      this.rewardNum = data.rewardNum;
      this.rewardBubble.updateData(this.rewardType, this.rewardNum);
      this.title.text = data.title;
      this.text.text = data.description;
      this.adjustTextSize();
    }
    onShow() {
      this.startAnimatingPlayButton();
    }
    onHide() {
      this.stopAnimatingPlayButton();
    }
    startAnimatingPlayButton() {
      this.playButtonAnimateEvent = this.scene.time.addEvent({
        repeat: -1,
        startAt: 2500,
        delay: 3e3,
        callback: this.shakePlayButton,
        callbackScope: this
      });
    }
    stopAnimatingPlayButton() {
      var _a;
      (_a = this.playButtonAnimateEvent) == null ? void 0 : _a.remove();
      this.scene.tweens.killTweensOf(this.playButton);
      this.playButton.scale = 1;
      this.scene.tweens.killTweensOf(this.playButton.icon);
      this.playButton.icon.y = -20;
    }
    shakePlayButton() {
      this.scene.tweens.add({
        targets: this.playButton,
        duration: 600,
        ease: Phaser.Math.Easing.Quadratic.Out,
        scale: 0.83,
        onComplete: () => {
          this.scene.tweens.add({
            targets: this.playButton,
            duration: 900,
            ease: Phaser.Math.Easing.Elastic.Out,
            easeParams: [0.1, 0.4],
            scale: 1
          });
        }
      });
      this.scene.tweens.add({
        targets: this.playButton.icon,
        duration: 600,
        ease: Phaser.Math.Easing.Quadratic.Out,
        y: "-=14",
        onComplete: () => {
          this.scene.tweens.add({
            targets: this.playButton.icon,
            duration: 1100,
            ease: Phaser.Math.Easing.Elastic.Out,
            easeParams: [0.1, 0.4],
            y: "+=14"
          });
        }
      });
    }
  };

  // src/scenes/gameplayGui/secondChanceScreen/SecondChancePopup.ts
  var SecondChancePopup = class extends VideoRewardPopup {
    constructor(scene) {
      super(scene);
      this.playButton.kill();
      this.addCoinsButton();
      this.addVideoButton();
      let gameConfig = window.game.config;
      if (gameConfig.ads.rewarded === false) {
        this.hideVideoButton();
      }
    }
    addCoinsButton() {
      let coinsNum = window.game.config.second_chance_price;
      let textContent = coinsNum.toString();
      let textStyle = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "35px",
        color: "#ffffff",
        align: "center"
      };
      this.coinsButton = new ComplexButton(this.scene, "popups", "popups/second_chance/button_coins.png", this);
      this.coinsButton.addIcon("popups", "popups/second_chance/coin.png", -44, -7);
      this.coinsButton.addText(textContent, textStyle, 36, this.coinsButton.icon.y - 6);
      this.coinsButton.text.setShadow(0, 3, "rgba(0,0,0,0.2)", 0);
      this.coinsButton.x = -126;
      this.coinsButton.y = this.playButton.y + 4;
      this.coinsButton.coinsNum = coinsNum;
    }
    addVideoButton() {
      this.videoButton = new ComplexButton(this.scene, "popups", "popups/second_chance/button_video.png", this);
      this.videoButton.addIcon("popups", "popups/reward/watch ad.png", 0, -26).setScale(0.85);
      this.videoButton.x = 126;
      this.videoButton.y = this.playButton.y + 4;
    }
    enableButtons() {
      this.videoButton.enableInput();
      this.coinsButton.enableInput();
    }
    disableButtons() {
      this.videoButton.disableInput();
      this.coinsButton.disableInput();
    }
    onShow() {
      this.showButtons({delay: 200});
    }
    showButtons(options) {
      ;
      [this.coinsButton, this.videoButton].forEach((button) => {
        button.alpha = 0;
        this.scene.tweens.add({
          delay: options.delay,
          targets: button,
          duration: 150,
          ease: Phaser.Math.Easing.Cubic.Out,
          alpha: 1
        });
        let originalScale = button.scale;
        button.scale = originalScale * 0.75;
        this.scene.tweens.add({
          delay: options.delay,
          targets: button,
          duration: 900,
          ease: Phaser.Math.Easing.Elastic.Out,
          easeParams: [0.1, 0.45],
          scale: originalScale
        });
      });
    }
    onHide() {
    }
    hideVideoButton() {
      this.videoButton.kill();
      this.coinsButton.x = 0;
      this.coinsButton.scale = 1.1;
      this.coinsButton.originalScale = this.coinsButton.scale;
    }
    hideCoinsButton() {
      this.coinsButton.kill();
      this.videoButton.x = 0;
      this.videoButton.scale = 1.1;
      this.videoButton.originalScale = this.coinsButton.scale;
    }
  };

  // src/scenes/gameplayGui/levelComplete/labels/LevelCompleteLabel.ts
  var LevelCompleteLabel = class extends Phaser.GameObjects.Container {
    constructor(scene, options) {
      super(scene);
      this.name = "label";
      this.options = options;
      this.addBack();
      this.addCircleParticles();
      this.addIcon();
      this.addSparksParticles();
      this.addText();
      this.doSetSize();
    }
    addCircleParticles() {
      this.circlesParticles = this.scene.add.particles(this.options.atlas);
      this.circlesParticles.setPosition(this.options.iconOffset.x, this.options.iconOffset.y);
      this.add(this.circlesParticles);
      this.circlesEmitter = this.circlesParticles.createEmitter({
        frame: "particles/circle_fx_3",
        scale: {start: 0.5, end: 2, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.CubicOut},
        lifespan: 1600,
        on: false
      });
    }
    addSparksParticles() {
      this.sparksManager = this.scene.add.particles(this.options.atlas);
      this.sparksManager.setPosition(this.options.iconOffset.x, this.options.iconOffset.y);
      this.add(this.sparksManager);
      let particlesNum = 10;
      this.sparksEmitter = this.sparksManager.createEmitter({
        delay: {min: 0, max: 500, steps: particlesNum},
        frame: "particles/star_particle",
        lifespan: 400,
        scale: {start: 0, end: 1, ease: CustomEase.BellQuad},
        on: false
      });
      this.sparksEmitter.setEmitZone({
        source: new Phaser.Geom.Circle(0, 0, this.icon.displayWidth * 0.5),
        type: "random",
        quantity: 360
      });
      this.sparksEmitter.reserve(particlesNum);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, this.options.atlas, this.options.backFrame);
      this.back.setOrigin(0, 0.5);
      this.add(this.back);
    }
    addIcon() {
      this.icon = this.scene.add.image(0, 0, this.options.atlas, this.options.iconFrame);
      this.icon.x += this.options.iconOffset.x;
      this.icon.y += this.options.iconOffset.y;
      this.add(this.icon);
    }
    addText() {
      this.text = this.createText(this.options.text);
      this.text.setOrigin(1, 0.5);
      this.text.originalX = this.text.x;
      this.add(this.text);
    }
    createText(options) {
      let content = "0000";
      let text = options.type === "text" ? this.createCanvasText(content) : this.createBitmapText(options, content);
      return text;
    }
    createCanvasText(content) {
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "28px",
        color: "#912D13",
        align: "center"
      };
      let text = this.scene.add.text(0, 0, content, style);
      text.x = this.back.right - 24;
      text.y = -2;
      return text;
    }
    createBitmapText(options, content) {
      let text = this.scene.add.bitmapText(0, 0, options.font, content, 28);
      text.x = this.back.right - 24;
      text.y = 2;
      text.setLetterSpacing(-1);
      return text;
    }
    doSetSize() {
      let left = this.icon.left;
      let right = this.back.right;
      let width = right - left;
      this.setSize(width, this.back.displayHeight);
    }
    setInteractive() {
      super.setInteractive();
      this.input.cursor = "pointer";
      this.input.hitArea.x = this.icon.left + this.width / 2;
      return this;
    }
    getTextContent() {
      return this.text.text;
    }
    updateTextContent(content) {
      this.text.text = content;
    }
    playTextTween() {
      this.text.x = this.text.originalX;
      this.scene.tweens.killTweensOf(this.text);
      this.scene.tweens.add({
        targets: this.text,
        duration: 233,
        ease: Phaser.Math.Easing.Sine.InOut,
        x: this.text.originalX - 12,
        yoyo: true
      });
    }
    playAnimation() {
      this.circlesEmitter.emitParticle(1);
      this.sparksEmitter.explode(10, 0, 0);
      this.scene.tweens.add({
        targets: this.icon,
        duration: 233,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.2,
        yoyo: true
      });
    }
    showTextFx(content) {
      let textFx = this.createTextFx(content);
      textFx.setOrigin(0.5, 0.5);
      textFx.setShadow(0, 3, "rgba(0,0,0,0.33)", 0, true, false);
      textFx.x = this.back.x + this.back.displayWidth / 2 + 4;
      textFx.y = this.text.y + 22;
      this.add(textFx);
      this.animateTextFx(textFx);
    }
    createTextFx(content) {
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "26px",
        color: "#912D13",
        align: "center",
        stroke: "#FFCFB2",
        strokeThickness: 5
      };
      return this.scene.add.text(0, 0, content, style);
    }
    animateTextFx(text) {
      text.alpha = 0;
      this.scene.tweens.add({
        targets: text,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1,
        onComplete: () => {
          this.scene.tweens.add({
            delay: 1300,
            targets: text,
            duration: 500,
            ease: Phaser.Math.Easing.Cubic.Out,
            alpha: 0,
            onComplete: () => {
              text.destroy();
            }
          });
        }
      });
      text.scale = 0.5;
      this.scene.tweens.add({
        targets: text,
        duration: 900,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.5],
        scale: 1
      });
      this.scene.tweens.add({
        targets: text,
        duration: 1800,
        ease: Phaser.Math.Easing.Linear,
        y: "+=25"
      });
    }
  };

  // src/scenes/gameplayGui/levelComplete/labels/LevelCompleteCoinsLabel.ts
  var LevelCompleteCoinsLabel = class extends LevelCompleteLabel {
    constructor(scene, options) {
      super(scene, options);
      this.coinsNum = 0;
      this.text.originalX = this.text.x;
    }
    updateCoinsNumInstant(value) {
      this.coinsNum = value;
      this.text.text = this.coinsNum.toLocaleString();
    }
    updateCoinsNum(value) {
      var _a;
      let currentValue = this.coinsNum;
      this.coinsNum = value;
      (_a = this.counterTween) == null ? void 0 : _a.remove();
      this.counterTween = this.scene.tweens.addCounter({
        from: currentValue,
        to: value,
        onUpdate: (tween) => {
          let content = Math.round(tween.getValue()).toLocaleString();
          this.updateTextContent(content);
        }
      });
    }
    shakeText() {
      var _a;
      this.text.x = this.text.originalX;
      (_a = this.shakeTextTween) == null ? void 0 : _a.remove();
      this.shakeTextTween = this.scene.tweens.add({
        targets: this.text,
        duration: 33,
        ease: Phaser.Math.Easing.Sine.InOut,
        x: "-=10",
        yoyo: true,
        repeat: 3
      });
    }
    syncWithGameStore(instant) {
      let coinsNum = this.scene.game.store.getNumber(GameStoreKey.COINS);
      if (instant) {
        this.updateCoinsNumInstant(coinsNum);
      } else {
        this.updateCoinsNum(coinsNum);
      }
    }
  };

  // src/scenes/gameplayGui/goalsScreen/GoalView.ts
  var GoalView2 = class extends Phaser.GameObjects.Container {
    constructor(scene, goalType, goalNum) {
      super(scene);
      this.name = goalType;
      this.addIcon(goalType);
      this.addText(goalNum);
      this.setSize(this.icon.width, this.icon.height);
    }
    addIcon(type) {
      let frame = `popups/start_level/goals/${type.toLowerCase()}.png`;
      this.icon = this.scene.add.image(0, 0, "popups", frame);
      this.add(this.icon);
    }
    addText(targetNum) {
      let content = targetNum.toString();
      this.text = this.scene.add.bitmapText(0, 0, BitmapFont.POPUP_GOAL_LABELS, content, 29);
      this.text.setOrigin(0.5, 0.5);
      this.text.x = 30;
      this.text.y = 30;
      this.add(this.text);
    }
  };

  // src/scenes/gameplayGui/secondChanceScreen/FailedGoalsPanel.ts
  var FailedGoalsPanel = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.name = "panel";
      this.addBack();
      this.setSize(this.back.width, this.back.height);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "popups", "popups/goals_popup/Small Popup Background.png");
      this.add(this.back);
    }
    updateData(goals) {
      if (this.goals) {
        this.goals.destroy();
        this.goals = null;
      }
      this.addGoals(goals);
    }
    addGoals(goals) {
      let cellSize = 120;
      this.goals = this.scene.add.container(0, 0, this.createGoalViews(goals));
      this.goals.gridAlign({
        width: this.goals.length,
        cellWidth: cellSize,
        cellHeight: cellSize,
        position: Phaser.Display.Align.CENTER,
        x: cellSize / 2,
        y: cellSize / 2
      });
      this.goals.setSize(this.goals.length * cellSize, cellSize);
      this.goals.x = -this.goals.width / 2;
      this.goals.y = -this.goals.height / 2 - 6;
      this.add(this.goals);
    }
    createGoalViews(goals) {
      return goals.filter((goal) => goal.collectedNum !== goal.targetNum).map((goal) => {
        return new GoalView2(this.scene, goal.type, goal.targetNum - goal.collectedNum);
      });
    }
  };

  // src/scenes/gameplayGui/secondChanceScreen/OutOfMovesPopup.ts
  var OutOfMovesPopup = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.name = "pre_second_chance";
      this.addTitle();
      this.addSubtitle();
      this.addPanel();
      this.doSetSize();
    }
    addTitle() {
      let content = this.scene.texts.out_of_moves.title;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "74px",
        color: "#FFDFAD",
        align: "center",
        stroke: "#8C463B",
        strokeThickness: 14
      };
      let maxWidth = Config.SOURCE_GAME_WIDTH * 0.8;
      this.title = this.scene.add.text(0, 0, content, style);
      this.title.setOrigin(0.5, 0.5);
      this.title.setShadow(0, 6, "rgba(0,0,0,0.25)", 0, true, false);
      this.title.scale = Math.min(1, maxWidth / this.title.width);
      this.title.originalScale = this.title.scale;
      this.title.y = this.title.height / 2;
      this.title.originalY = this.title.y;
      this.add(this.title);
    }
    addSubtitle() {
      let content = this.scene.texts.out_of_moves.subtitle;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "32px",
        color: "#FFDFAD",
        align: "center"
      };
      this.subtitle = this.scene.add.text(0, 0, content, style);
      this.subtitle.setOrigin(0.5, 0.5);
      this.subtitle.setShadow(0, 4, "rgba(0,0,0,0.25)");
      this.subtitle.y = this.title.y + this.title.displayHeight / 2 + 22;
      this.subtitle.originalY = this.subtitle.y;
      this.add(this.subtitle);
    }
    addPanel() {
      this.panel = new FailedGoalsPanel(this.scene);
      this.panel.y = this.subtitle.y + 100;
      this.panel.originalY = this.panel.y;
      this.add(this.panel);
    }
    doSetSize() {
      let top = this.title.top;
      let bottom = this.panel.y + this.panel.height / 2;
      let height = bottom - top;
      this.setSize(this.panel.width, height);
    }
    updateData(goals) {
      this.panel.updateData(goals);
    }
    show() {
      this.showTitle(0);
      this.showItems(1600);
    }
    showTitle(delay) {
      this.title.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.title,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.title.scale = this.title.originalScale * 0.75;
      this.scene.tweens.add({
        delay,
        targets: this.title,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: this.title.originalScale,
        onComplete: () => {
          this.startTitleAnimation();
        }
      });
      this.title.y = this.height / 2;
      this.scene.tweens.add({
        delay: delay + 1e3,
        targets: this.title,
        duration: 600,
        ease: Phaser.Math.Easing.Back.InOut,
        y: this.title.originalY
      });
    }
    showItems(baseDelay) {
      let items = [this.subtitle, this.panel];
      items.forEach((item, index) => {
        let delay = baseDelay + index * 100;
        item.alpha = 0;
        this.scene.tweens.add({
          delay,
          targets: item,
          duration: 150,
          ease: Phaser.Math.Easing.Cubic.Out,
          alpha: 1
        });
        item.y = item.originalY + 50;
        this.scene.tweens.add({
          delay,
          targets: item,
          duration: 400,
          ease: Phaser.Math.Easing.Back.Out,
          easeParams: [1.6],
          y: item.originalY
        });
      });
    }
    startTitleAnimation() {
      this.scene.tweens.add({
        delay: 700,
        targets: this.title,
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: this.title.originalScale * 0.95,
        yoyo: true,
        repeat: -1
      });
    }
    stopTitleAnimation() {
      this.scene.tweens.killTweensOf(this.title);
    }
    hide() {
      this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.stopTitleAnimation();
          this.kill();
        }
      });
    }
  };

  // src/scenes/gameplayGui/secondChanceScreen/SecondChanceScreen.ts
  var SecondChanceScreenEvent;
  (function(SecondChanceScreenEvent2) {
    SecondChanceScreenEvent2["PROCEED"] = "__PROCEED";
    SecondChanceScreenEvent2["SHOW_SHOP"] = "__SHOW_SHOP";
  })(SecondChanceScreenEvent || (SecondChanceScreenEvent = {}));
  var SecondChanceScreen = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "second_chance_screen",
        backgroundAlpha: 0.85,
        backgroundKey: "popups",
        backgroundFrame: "popups/black_rect.png"
      });
      this.isDeactivated = false;
      this.gameplay = this.scene.gameplay;
      this.addOutOfMovesPopup();
      this.addSecondChancePopup();
      this.addCoinsLabel();
      this.addShowFieldHint();
    }
    addOutOfMovesPopup() {
      this.outOfMovesPopup = new OutOfMovesPopup(this.scene);
      this.add(this.outOfMovesPopup);
      this.pin(this.outOfMovesPopup, 0.5, 0.5, 0, -this.outOfMovesPopup.height / 2);
    }
    addSecondChancePopup() {
      let rewardType = VideoRewardType.EXTRA_MOVES;
      let texts = this.scene.texts.second_chance;
      let data = {
        rewardType,
        rewardNum: VideoRewardUtils.getRewardNum(rewardType),
        title: texts.title,
        description: texts.description
      };
      this.secondChancePopup = new SecondChancePopup(this.scene);
      this.secondChancePopup.updateData(data);
      this.secondChancePopup.coinsButton.on(ButtonEvent.PRESS, this.onCoinsButtonClick, this);
      this.secondChancePopup.videoButton.on(ButtonEvent.RELEASE, this.onVideoButtonClick, this);
      this.add(this.secondChancePopup);
      this.pin(this.secondChancePopup, 0.5, 0.5);
    }
    onCoinsButtonClick(button) {
      let coins = this.scene.game.store.getNumber(GameStoreKey.COINS);
      let price = button.coinsNum;
      if (price > coins) {
        this.onNotEnoughCoins();
        return;
      }
      let newCoinsNum = this.scene.game.store.changeNumber(GameStoreKey.COINS, -price);
      this.coinsLabel.updateCoinsNum(newCoinsNum);
      this.secondChancePopup.hideCoinsButton();
      this.scene.analytics.subtractResource(ResourceCurrency.COINS, price, ResourceItemType.COIN, `Level_${this.gameplay.levelNumber}.SecondChance`);
      this.giveSecondChance();
    }
    onNotEnoughCoins() {
      if (this.scene.game.purchases) {
        this.emit(SecondChanceScreenEvent.SHOW_SHOP, this);
        return;
      }
      this.scene.audio.play(GameSoundKey.BOOSTER_CANT_USE);
      this.coinsLabel.shakeText();
    }
    onVideoButtonClick() {
      this.scene.game.gdSdk.showRewardedAd("Gameplay:SecondChanceScreen").then((success) => {
        if (success) {
          this.secondChancePopup.hideVideoButton();
          this.giveSecondChance();
        }
      });
    }
    giveSecondChance() {
      this.scene.audio.fadeInMusicLoop(500);
      this.secondChancePopup.disableButtons();
      this.activateGameplay();
      this.emit(SecondChanceScreenEvent.PROCEED, this);
    }
    addCoinsLabel() {
      let options = {
        atlas: "gameplay_gui",
        backFrame: "level_complete/labels/label_back",
        iconOffset: {x: 0, y: 0},
        iconFrame: "level_complete/labels/Coin_2",
        text: {
          type: "bitmap",
          font: BitmapFont.LABELS_GAMEPLAY_GUI
        }
      };
      this.coinsLabel = new LevelCompleteCoinsLabel(this.scene, options);
      this.coinsLabel.syncWithGameStore(true);
      this.pin(this.coinsLabel, 0, 0, 70, 66);
      this.add(this.coinsLabel);
      if (this.scene.game.purchases) {
        this.coinsLabel.setInteractive();
        this.coinsLabel.input.cursor = "pointer";
        this.coinsLabel.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onCoinsLabelClick, this);
      }
    }
    onCoinsLabelClick() {
      this.emit(SecondChanceScreenEvent.SHOW_SHOP, this);
    }
    addShowFieldHint() {
      let content = this.scene.texts.second_chance.hint;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "36px",
        color: "#ffffff",
        align: "center",
        stroke: "rgba(0,0,0,0.25)",
        strokeThickness: 8,
        padding: {x: 20, y: 20}
      };
      this.hint = this.scene.add.text(0, 0, content, style);
      this.hint.setOrigin(0.5, 0.5);
      this.hint.setWordWrapWidth(Config.SOURCE_GAME_WIDTH * 0.75, true);
      this.hint.setLineSpacing(-12);
      this.hint.setInteractive();
      this.hint.input.cursor = "pointer";
      this.hint.name = "show_board_text";
      this.hint.originalScale = 1;
      this.add(this.hint);
    }
    resize() {
      super.resize();
      this.coinsLabel.originalY = this.coinsLabel.y;
      this.secondChancePopup.originalY = this.secondChancePopup.y;
      this.resizeSecondChancePopup();
      this.alignShowFieldHint();
    }
    resizeSecondChancePopup() {
      let maxHeight = this.screenHeight * 0.75;
      this.secondChancePopup.scale = Math.min(1, maxHeight / this.secondChancePopup.height);
      this.secondChancePopup.originalScale = this.secondChancePopup.scale;
    }
    alignShowFieldHint() {
      let top = this.secondChancePopup.y + this.secondChancePopup.displayHeight / 2 - 40;
      let bottom = this.screenHeight;
      let height = bottom - top;
      this.hint.x = this.screenWidth / 2;
      this.hint.y = top + height / 2;
      this.hint.originalY = this.hint.y;
    }
    show() {
      var _a;
      this.revive();
      this.reset();
      (_a = this.scene.audio.play(GameSoundKey.OUT_OF_MOVES)) == null ? void 0 : _a.fade(0, 0.75, 500);
      this.scene.audio.fadeOutMusicLoop(200);
      this.showBackground({duration: 1e3, ease: Ease.QuadIn});
      this.coinsLabel.kill();
      this.secondChancePopup.kill();
      this.hint.kill();
      this.outOfMovesPopup.show();
      let timerEvent = this.scene.time.delayedCall(6e3, () => {
        this.background.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN);
        this.hideOutOfMovesPopup();
      });
      this.scene.time.delayedCall(400, () => {
        this.background.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
          timerEvent.remove();
          this.hideOutOfMovesPopup();
        });
      });
    }
    reset() {
      this.alpha = 1;
      this.outOfMovesPopup.alpha = 1;
      this.outOfMovesPopup.revive();
    }
    hideOutOfMovesPopup() {
      this.fadeOutOfMovesSound();
      this.outOfMovesPopup.hide();
      this.scene.time.delayedCall(100, () => {
        this.deactivateGameplay();
        this.coinsLabel.revive();
        this.secondChancePopup.revive();
        this.hint.revive();
        this.showCoinsLabel();
        this.showItems();
        this.hint.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.revealGameField, this);
      });
    }
    fadeOutOfMovesSound() {
      let sound = this.scene.audio.get(GameSoundKey.OUT_OF_MOVES);
      if (sound && sound.playing()) {
        sound.fade(sound.volume(), 0, 1e3);
      }
    }
    showCoinsLabel() {
      this.coinsLabel.alpha = 0;
      this.scene.tweens.add({
        targets: this.coinsLabel,
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.coinsLabel.y = this.coinsLabel.originalY - 50;
      this.scene.tweens.add({
        targets: this.coinsLabel,
        duration: 400,
        ease: Phaser.Math.Easing.Cubic.Out,
        y: this.coinsLabel.originalY
      });
    }
    showItems() {
      let items = [this.secondChancePopup, this.hint];
      items.forEach((item, index) => {
        let delay = index * 100;
        item.alpha = 0;
        this.scene.tweens.add({
          delay,
          targets: item,
          duration: 300,
          ease: Phaser.Math.Easing.Cubic.Out,
          alpha: 1
        });
        item.y = item.originalY + 50;
        this.scene.tweens.add({
          delay,
          targets: item,
          duration: 400,
          ease: Phaser.Math.Easing.Cubic.Out,
          y: item.originalY
        });
      });
      this.secondChancePopup.onShow();
      this.secondChancePopup.enableButtons();
    }
    revealGameField() {
      this.activateGameplay();
      this.scene.audio.playClick();
      this.scene.tweens.killTweensOf(this.list);
      this.scene.tweens.add({
        targets: this.background,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1e-3
      });
      this.scene.tweens.add({
        targets: this.coinsLabel,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        y: "-=50"
      });
      this.scene.tweens.add({
        targets: [this.hint, this.secondChancePopup],
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        y: "+=50"
      });
      this.background.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.hideGameField, this);
    }
    hideGameField() {
      this.deactivateGameplay();
      this.scene.tweens.killTweensOf(this.list);
      this.scene.tweens.add({
        targets: this.background,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: this.options.backgroundAlpha
      });
      this.scene.tweens.add({
        targets: this.coinsLabel,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.scene.tweens.add({
        targets: this.coinsLabel,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        y: this.coinsLabel.originalY
      });
      let items = [this.secondChancePopup, this.hint];
      items.forEach((item, index) => {
        let delay = index * 66;
        this.scene.tweens.add({
          delay,
          targets: item,
          duration: 200,
          ease: Phaser.Math.Easing.Cubic.Out,
          alpha: 1
        });
        item.y = item.originalY + 50;
        this.scene.tweens.add({
          delay,
          targets: item,
          duration: 400,
          ease: Phaser.Math.Easing.Back.Out,
          y: item.originalY
        });
      });
      this.hint.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.revealGameField, this);
    }
    hideFast() {
      this.emitHideStartEvent();
      this.scene.tweens.add({
        targets: this,
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.secondChancePopup.onHide();
          this.kill();
          this.emitHideCompleteEvent();
        }
      });
    }
    hide() {
      this.emitHideStartEvent();
      this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.secondChancePopup.onHide();
          this.kill();
          this.emitHideCompleteEvent();
        }
      });
    }
    activateGameplay() {
      this.gameplay.scene.setActive(true);
      this.gameplay.scene.setVisible(true);
    }
    deactivateGameplay() {
      this.gameplay.scene.setActive(false);
      this.gameplay.scene.setVisible(false);
    }
    activate() {
      if (this.isDeactivated === false) {
        return;
      }
      this.isDeactivated = false;
      this.coinsLabel.revive();
      this.secondChancePopup.revive();
      this.hint.revive();
    }
    deactivate() {
      if (this.isDeactivated) {
        return;
      }
      this.isDeactivated = true;
      this.coinsLabel.kill();
      this.secondChancePopup.kill();
      this.hint.kill();
    }
  };

  // src/scenes/gameplayGui/levelFailed/goals/LevelFailedGoalView.ts
  var LevelFailedGoalView = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.name = "goal";
      this.addBack();
      this.addIcon();
      this.addNumLabel();
      this.addCross();
      this.addCheck();
      this.setSize(this.back.width, this.back.height);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "popups", "popups/level_failed/Cookie Background Box.png");
      this.add(this.back);
    }
    addIcon() {
      this.icon = this.scene.add.image(0, 0, "popups", "popups/start_level/goals/apple.png");
      this.add(this.icon);
    }
    addNumLabel() {
      let content = "0/0";
      this.numLabel = this.scene.add.bitmapText(0, 0, BitmapFont.POPUP_GOAL_LABELS, content, 28);
      this.numLabel.setOrigin(0.5, 0.5);
      this.numLabel.y = this.back.bottom + 25;
      this.add(this.numLabel);
    }
    updateData(goal) {
      this.icon.setFrame(`popups/start_level/goals/${goal.type.toLowerCase()}.png`);
      this.numLabel.text = `${goal.collectedNum}/${goal.targetNum}`;
      if (goal.collectedNum >= goal.targetNum) {
        this.check.revive();
      } else {
        this.cross.revive();
      }
    }
    addCross() {
      this.cross = this.scene.add.image(0, 0, "popups", "popups/level_failed/cross.png");
      this.cross.x = this.back.right - 8;
      this.cross.y = this.back.bottom - 12;
      this.cross.kill();
      this.add(this.cross);
    }
    addCheck() {
      this.check = this.scene.add.image(0, 0, "popups", "popups/level_failed/check.png");
      this.check.x = this.back.right - 8;
      this.check.y = this.back.bottom - 13;
      this.check.kill();
      this.add(this.check);
    }
  };

  // src/scenes/gameplayGui/levelFailed/goals/LevelFailedGoalsPanel.ts
  var LevelFailedGoalsPanel = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.cellWidth = 110;
      this.name = "goals_panel";
      this.addViews();
      this.alignViews();
      this.updateSize();
    }
    addViews() {
      this.views = times_default(3, () => {
        let view = new LevelFailedGoalView(this.scene);
        this.add(view);
        return view;
      });
    }
    alignViews() {
      this.gridAlign({
        cellWidth: this.cellWidth,
        width: this.views.length,
        position: Phaser.Display.Align.CENTER,
        x: this.cellWidth / 2,
        y: this.views[0].height / 2
      });
    }
    updateSize() {
      let visibleViewsNum = this.views.filter((item) => item.visible).length;
      this.setSize(this.cellWidth * visibleViewsNum, this.views[0].height);
    }
    updateData(data) {
      this.updateViews(data);
      this.updateSize();
    }
    updateViews(data) {
      this.views.forEach((view, index) => {
        let goal = data[index];
        if (goal) {
          view.revive();
          view.updateData(goal);
        } else {
          view.kill();
        }
      });
    }
  };

  // src/scenes/gameplayGui/levelFailed/LevelFailedPopup.ts
  var LevelFailedPopup = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.name = "level_failed_popup";
      this.addBack();
      this.addTitleText();
      this.addLevelText();
      this.addGoalsPanelBack();
      this.addChef();
      this.addTears();
      this.addGoalsPanel();
      this.addCloseButton();
      this.alignGoalsPanel();
      this.bringToTop(this.goalsPanel);
      this.bringToTop(this.tears);
      this.bringToTop(this.title);
      this.bringToTop(this.level);
      this.setSize(this.back.width, this.back.height);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "popups", "popups/popup_small_back.png");
      this.add(this.back);
    }
    addTitleText() {
      let content = this.scene.texts.level_failed;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "40px",
        color: "#FFE0AD",
        align: "center",
        stroke: "#522923",
        strokeThickness: 10
      };
      this.title = this.scene.add.text(0, 0, content, style);
      this.title.setOrigin(0.5, 0.5);
      this.title.scale = Math.min(1, 290 / this.title.width);
      this.title.y = -214;
      this.add(this.title);
    }
    addLevelText() {
      let content = this.getLevelTextContent(0);
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "42px",
        color: "#B86D52",
        align: "center"
      };
      this.level = this.scene.add.text(0, 0, content, style);
      this.level.setOrigin(0.5, 0.5);
      this.level.x = 112;
      this.level.y = -96;
      this.add(this.level);
    }
    getLevelTextContent(levelNumber) {
      return this.scene.texts.level.replace("#", levelNumber.toString());
    }
    addGoalsPanelBack() {
      this.goalsPanelBack = this.scene.add.image(0, 0, "popups", "popups/level_failed/popup_panel_wide.png");
      this.goalsPanelBack.scaleX = 0.99;
      this.goalsPanelBack.x = 1.5;
      this.goalsPanelBack.y = 46;
      this.add(this.goalsPanelBack);
    }
    addChef() {
      this.chef = this.scene.add.image(0, 0, "popups", "popups/level_failed/chef_sad.png");
      this.chef.x = -190;
      this.chef.y = this.goalsPanelBack.bottom - 10;
      this.add(this.chef);
    }
    addTears() {
      this.tears = this.scene.add.particles("popups");
      this.add(this.tears);
      this.leftTears = this.createTearEmitter();
      this.leftTears.setPosition(this.chef.x - 10, 0);
      this.rightTears = this.createTearEmitter(325);
      this.rightTears.setPosition(this.chef.x + 53, 5);
    }
    createTearEmitter(delay = 0) {
      return this.tears.createEmitter({
        delay,
        frame: "popups/level_failed/tear.png",
        lifespan: 1200,
        speedY: {min: 40, max: 60},
        gravityY: 50,
        frequency: 700,
        quantity: 1,
        scale: {start: 0, end: 0.3, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.ExpoIn},
        on: false
      });
    }
    addGoalsPanel() {
      this.goalsPanel = new LevelFailedGoalsPanel(this.scene);
      this.goalsPanel.y = this.goalsPanelBack.y - this.goalsPanel.displayHeight / 2 - 16;
      this.add(this.goalsPanel);
    }
    addCloseButton() {
      this.closeButton = this.scene.add.button("popups", "popups/Close Button.png", this);
      this.closeButton.x = this.back.right - 60;
      this.closeButton.y = this.back.top + 46;
    }
    alignGoalsPanel() {
      let left = -90;
      let right = this.goalsPanelBack.right;
      let width = right - left;
      this.goalsPanel.x = left + (width - this.goalsPanel.displayWidth) / 2;
    }
    updateData(data) {
      this.level.text = this.getLevelTextContent(data.levelNumber);
      this.updateGoalsPanel(data.goals);
    }
    updateGoalsPanel(goals) {
      this.goalsPanel.updateData(goals);
      this.alignGoalsPanel();
    }
    onShow() {
      this.showChef(100);
      this.showTears(300);
    }
    showChef(delay) {
      this.chef.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.chef,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.chef.scale = 0.8;
      this.scene.tweens.add({
        delay,
        targets: this.chef,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1,
        onComplete: () => {
          this.playChefAnimation();
        }
      });
    }
    showTears(delay) {
      this.scene.time.delayedCall(delay, () => {
        this.leftTears.on = true;
        this.rightTears.on = true;
      });
    }
    playChefAnimation() {
      this.scene.tweens.add({
        targets: this.chef,
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        scaleX: 1.03,
        scaleY: 0.97,
        yoyo: true,
        repeat: -1
      });
    }
    onHide() {
      this.leftTears.on = false;
      this.rightTears.on = false;
      this.tears.kill();
      this.stopChefAnimation();
    }
    stopChefAnimation() {
      this.scene.tweens.killTweensOf(this.chef);
      this.chef.scale = 1;
    }
  };

  // src/scenes/gameplayGui/levelFailed/LevelFailedScreen.ts
  var LevelFailedScreen = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "level_failed_screen",
        backgroundKey: "popups",
        backgroundFrame: "popups/black_rect.png",
        backgroundAlpha: 0.85
      });
      this.addPopup();
      this.addBrokenHeart();
      this.addRestartText();
    }
    addPopup() {
      this.popup = new LevelFailedPopup(this.scene);
      this.add(this.popup);
      this.pin(this.popup, 0.5, 0.47);
    }
    addBrokenHeart() {
      this.brokenHeart = this.scene.add.image(0, 0, "popups", "popups/level_failed/broken_heart.png");
      this.pin(this.brokenHeart, 0.5, 0.25);
      this.add(this.brokenHeart);
    }
    addRestartText() {
      let content = this.scene.texts.tap_to_continue;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "45px",
        color: "#FFCFB2",
        align: "center",
        padding: {x: 40, y: 40}
      };
      this.restartText = this.scene.add.text(0, 0, content, style);
      this.restartText.setWordWrapWidth(Config.SOURCE_GAME_WIDTH * 0.66, true);
      this.restartText.setLineSpacing(-5);
      this.restartText.setOrigin(0.5, 0.5);
      this.restartText.setInteractive();
      this.restartText.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onRestartTextClick, this);
      this.restartText.input.cursor = "pointer";
      this.add(this.restartText);
    }
    onRestartTextClick() {
      this.scene.audio.playClick();
    }
    resize() {
      super.resize();
      this.alignBrokenHeart();
      this.alignRestartText();
    }
    alignBrokenHeart() {
      this.brokenHeart.y = this.popup.y - this.popup.displayHeight / 2 - 10 * this.scale;
      this.brokenHeart.originalY = this.brokenHeart.y;
    }
    alignRestartText() {
      let top = this.popup.y + this.popup.displayHeight / 2 - 54;
      let bottom = this.screenHeight;
      let height = bottom - top;
      this.restartText.x = this.screenWidth / 2;
      this.restartText.y = top + height / 2;
      this.restartText.originalY = this.restartText.y;
    }
    updateData(data) {
      this.popup.updateData(data);
    }
    show(options) {
      if (options.smooth) {
        this.showSmooth();
      } else {
        this.showFast();
      }
    }
    showSmooth() {
      this.onShow();
      this.showBackground({duration: 600, ease: Ease.Linear});
      this.showPopupSmooth(200);
      this.showRestartTextSmooth(200);
      this.showBrokenHeart(600);
    }
    showPopupSmooth(delay) {
      this.popup.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.popup,
        duration: 200,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 1
      });
      this.popup.y -= 50;
      this.scene.tweens.add({
        delay,
        targets: this.popup,
        duration: 500,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.6],
        y: "+=50"
      });
      this.popup.onShow();
    }
    showRestartTextSmooth(delay) {
      this.restartText.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.restartText,
        duration: 200,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 1
      });
      this.restartText.y += 50;
      this.scene.tweens.add({
        delay,
        targets: this.restartText,
        duration: 500,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.6],
        y: "-=50",
        onComplete: () => {
          this.animateRestartText();
        }
      });
    }
    showFast() {
      this.onShow();
      this.showPopup();
      this.showRestartText();
      this.showBrokenHeart(200);
    }
    onShow() {
      var _a;
      this.scene.audio.fadeOutMusicLoop(300);
      (_a = this.scene.audio.play(GameSoundKey.LEVEL_FAILED)) == null ? void 0 : _a.fade(0, 0.66, 1e3);
      this.emitShowEvent();
      this.revive();
    }
    showPopup() {
      this.popup.onShow();
      this.popup.alpha = 0;
      this.scene.tweens.add({
        targets: this.popup,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.popup.scale = 0.85;
      this.scene.tweens.add({
        targets: this.popup,
        duration: 1e3,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
      this.popup.y -= 50;
      this.scene.tweens.add({
        targets: this.popup,
        duration: 500,
        ease: Phaser.Math.Easing.Back.Out,
        y: "+=50"
      });
    }
    showRestartText() {
      this.restartText.alpha = 0;
      this.scene.tweens.add({
        targets: this.restartText,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.restartText.scale = 0.85;
      this.scene.tweens.add({
        targets: this.restartText,
        duration: 1e3,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1,
        onComplete: () => {
          this.animateRestartText({startAt: 3e3});
        }
      });
      this.restartText.y = this.restartText.originalY + 50;
      this.scene.tweens.add({
        targets: this.restartText,
        duration: 500,
        ease: Phaser.Math.Easing.Back.Out,
        y: this.restartText.originalY
      });
    }
    showBrokenHeart(delay) {
      this.brokenHeart.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.brokenHeart,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.brokenHeart.y = this.brokenHeart.originalY;
      this.scene.tweens.add({
        delay,
        targets: this.brokenHeart,
        duration: 3800,
        ease: Phaser.Math.Easing.Linear,
        y: "-=200"
      });
      this.brokenHeart.scale = 0.66;
      this.scene.tweens.add({
        delay,
        targets: this.brokenHeart,
        duration: 1e3,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.55],
        scale: 1,
        onComplete: () => {
          this.scene.tweens.add({
            targets: this.brokenHeart,
            duration: 500,
            ease: Phaser.Math.Easing.Quadratic.Out,
            alpha: 0,
            scale: 1.4,
            onComplete: () => {
              this.scene.tweens.killTweensOf(this.brokenHeart);
              this.brokenHeart.kill();
            }
          });
        }
      });
    }
    hide() {
      this.scene.audio.fadeInMusicLoop(1e3);
      this.fadeOutFailedSound();
      this.popup.onHide();
      this.kill();
    }
    fadeOutFailedSound() {
      let sound = this.scene.audio.get(GameSoundKey.LEVEL_FAILED);
      if (sound) {
        sound.fade(sound.volume(), 0, 200);
      }
    }
    animateRestartText(options = {startAt: 1500}) {
      this.scene.time.addEvent({
        repeat: -1,
        delay: 3e3,
        startAt: options.startAt,
        callback: this.shakeRestartText,
        callbackScope: this
      });
    }
    shakeRestartText() {
      this.scene.tweens.add({
        targets: this.restartText,
        duration: 333,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.1,
        repeat: 2,
        yoyo: true
      });
    }
    preDestroy() {
      this.fadeOutFailedSound();
      super.preDestroy();
    }
  };

  // src/scenes/gameplayGui/levelComplete/confetti/ConfettiParticle.ts
  var ConfettiParticle = class extends Phaser.GameObjects.Image {
    constructor(scene, atlas, frame) {
      super(scene, 0, 0, atlas, frame);
      this.angularVelocity = 0;
      this.deltaScale = 0;
      this.speedX = 0;
      this.speedY = 0;
    }
    onEmit() {
      this.active = true;
      this.visible = true;
      this.scaleY = 1;
      this.angularVelocity = Phaser.Math.RND.realInRange(0.1, 0.15) * Phaser.Math.RND.sign();
      this.deltaScale = this.angularVelocity / 20;
      this.speedX = Phaser.Math.RND.realInRange(-0.08, 0.08);
      this.speedY = Phaser.Math.RND.realInRange(0.18, 0.3);
    }
    update(delta) {
      if (!this.visible) {
        return;
      }
      this.x += this.speedX * delta;
      this.y += this.speedY * delta;
      this.angle += this.angularVelocity * delta;
      this.updateScale(delta);
    }
    updateScale(delta) {
      this.scaleY += this.deltaScale * delta;
      if (this.scaleY < -1) {
        this.scaleY = -1;
        this.deltaScale *= -1;
      } else if (this.scaleY > 1) {
        this.scaleY = 1;
        this.deltaScale *= -1;
      }
    }
  };

  // src/scenes/gameplayGui/levelComplete/confetti/LevelCompleteConfetti.ts
  var LevelCompleteConfetti = class {
    constructor(scene, parent, particlesNum = 100) {
      this.timer = 0;
      this.frequency = 66;
      this.particlesEmitAmount = 1;
      this.isPaused = false;
      this.scene = scene;
      this.parent = parent;
      this.frames = [1, 2, 3].map((num) => `level_complete/confetti/particle_Confetti_${num}`);
      this.createParticles(particlesNum);
    }
    createParticles(particlesNum) {
      this.particles = times_default(particlesNum, (index) => this.createNewParticle());
    }
    createNewParticle() {
      let frame = Phaser.Math.RND.pick(this.frames);
      let p = new ConfettiParticle(this.scene, "gameplay_gui", frame);
      p.kill();
      this.parent.add(p);
      return p;
    }
    update(delta) {
      if (this.isPaused) {
        return;
      }
      this.emit(delta);
      this.updateParticles(delta);
    }
    emit(delta) {
      this.timer += delta;
      if (this.timer > this.frequency) {
        this.timer -= this.frequency;
        this.doEmit();
      }
    }
    doEmit() {
      for (let i = 0; i < this.particlesEmitAmount; i++) {
        let p = this.particles.find((p2) => p2.active === false);
        if (!p) {
          p = this.createNewParticle();
          this.particles.push(p);
        }
        p.x = Phaser.Math.RND.between(0, this.parent.screenWidth);
        p.y = 0;
        p.onEmit();
      }
    }
    updateParticles(delta) {
      let offset = 50;
      let left = -offset;
      let right = this.parent.screenWidth + offset;
      let bottom = this.parent.screenHeight + offset;
      this.particles.forEach((p) => {
        if (!p.visible) {
          return;
        }
        p.update(delta);
        if (p.x < left || p.x > right || p.y > bottom) {
          p.kill();
        }
      });
    }
    destroy() {
      this.particles.forEach((p) => p.destroy());
      this.particles.length = 0;
    }
    hideInstant() {
      this.isPaused = true;
      this.particles.forEach((particle) => particle.kill());
    }
    hide(fadeOutDuration) {
      this.scene.tweens.add({
        targets: this.particles,
        duration: fadeOutDuration,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.isPaused = true;
        }
      });
    }
  };

  // src/robowhale/phaser3/particles/ParticleUtil.ts
  var ParticleUtil = class {
    static getEmitCircle(x, y, radius) {
    }
    static onEmitRandom(from, to) {
      return {onEmit: () => Phaser.Math.RND.realInRange(from, to)};
    }
    static getTextureEmitZone(scene, image) {
      let origin = image.getTopLeft();
      let x, y, pixel;
      let getRandomPoint = (vec) => {
        do {
          x = Phaser.Math.Between(0, image.width);
          y = Phaser.Math.Between(0, image.height);
          pixel = scene.textures.getPixel(x, y, image.texture.key);
        } while (pixel.alpha < 255);
        return vec.setTo(x + origin.x, y + origin.y);
      };
      return {
        getRandomPoint
      };
    }
    static getCircleEdgeEmitZone(radius, quantity = 360, randomize2 = true) {
      let circle = new Phaser.Geom.Circle(0, 0, radius);
      let emitZone = {source: circle, type: "edge", quantity};
      let getRotation = (particle) => {
        let emitter = particle.emitter;
        let emitterX = emitter.follow ? emitter.follow.x : emitter.x.propertyValue;
        let emitterY = emitter.follow ? emitter.follow.y : emitter.y.propertyValue;
        return Math.atan2(particle.y - emitterY, particle.x - emitterX);
      };
      let randomizeProperties = randomize2 ? {
        emitCallback: (particle, emitter) => {
          let emitZone2 = emitter.emitZone;
          emitZone2.counter = Phaser.Math.RND.between(0, emitZone2.points.length);
        }
      } : {};
      return __spreadProps(__spreadValues({}, randomizeProperties), {
        emitZone,
        angle: {
          onEmit: (particle) => {
            return getRotation(particle) * Phaser.Math.RAD_TO_DEG;
          }
        },
        rotate: {
          onEmit: (particle) => {
            return (getRotation(particle) + Math.PI / 2) * Phaser.Math.RAD_TO_DEG;
          }
        }
      });
    }
  };

  // src/scenes/gameplayGui/levelComplete/LevelCompleteStar.ts
  var LevelCompleteStar = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.name = "star";
      this.addExplodeParticles();
      this.addGlow();
      this.addStar();
      this.addIdleParticles();
      this.setSize(this.star.displayWidth, this.star.displayHeight);
    }
    addExplodeParticles() {
      this.explodeParticles = this.scene.add.particles("gameplay_gui");
      this.add(this.explodeParticles);
      this.explodeSparks = this.explodeParticles.createEmitter(__spreadProps(__spreadValues({}, ParticleUtil.getCircleEdgeEmitZone(90, 100)), {
        frame: "particles/particle_star_4",
        lifespan: 3e3,
        speed: {min: 80, max: 1200},
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        scale: {start: 1.33, end: 0},
        on: false
      }));
    }
    addIdleParticles() {
      this.idleParticles = this.scene.add.particles("gameplay_gui");
      this.add(this.idleParticles);
      this.idleSparks = this.idleParticles.createEmitter(__spreadProps(__spreadValues({}, ParticleUtil.getCircleEdgeEmitZone(80, 100)), {
        frame: "particles/particle_star_4",
        lifespan: 1400,
        speed: {min: 50, max: 100},
        alpha: {start: 0, end: 1, ease: Ease.ExpoOut},
        scale: {start: 1.33, end: 0},
        on: false
      }));
    }
    addGlow() {
      this.glow = this.scene.add.image(0, 0, "gameplay_gui", "level_complete/star_glow");
      this.glow.x = 2;
      this.glow.y = 2;
      this.glow.kill();
      this.add(this.glow);
    }
    addStar() {
      this.star = this.scene.add.image(0, 0, "gameplay_gui", "level_complete/Star");
      this.add(this.star);
    }
    show(delay) {
      this.showStar(delay);
      this.showCirleFx(delay);
      this.showGlow(delay + 800);
      this.scene.time.delayedCall(delay + 33, () => {
        this.explodeSparks.explode(80, 0, 0);
      });
      this.scene.time.delayedCall(delay + 1e3, () => {
        this.idleSparks.flow(66);
      });
    }
    showStar(delay) {
      this.star.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.star,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.star.scale = 1.5;
      this.scene.tweens.add({
        delay,
        targets: this.star,
        duration: 900,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.55],
        scale: 1
      });
      this.scene.tweens.add({
        delay,
        targets: this,
        duration: 800,
        ease: Phaser.Math.Easing.Sine.InOut,
        y: "-=10",
        yoyo: true,
        repeat: -1
      });
    }
    showCirleFx(delay) {
      let circle = this.scene.add.image(0, 0, "gameplay_gui", "level_complete/star_circle_fx");
      circle.scale = 0;
      this.addAt(circle, 0);
      this.scene.tweens.add({
        targets: circle,
        duration: 1600,
        ease: Phaser.Math.Easing.Quartic.Out,
        alpha: 0,
        onComplete: () => {
          circle.destroy();
        }
      });
      this.scene.tweens.add({
        delay,
        targets: circle,
        duration: 1600,
        ease: Phaser.Math.Easing.Expo.Out,
        scale: 2.33
      });
    }
    showGlow(delay) {
      this.glow.revive();
      this.glow.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.glow,
        duration: 1200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1,
        onComplete: () => {
          this.scene.tweens.add({
            targets: this.glow,
            duration: 1e3,
            ease: Phaser.Math.Easing.Sine.InOut,
            alpha: 0.5,
            yoyo: true,
            repeat: -1
          });
        }
      });
    }
    onCollect() {
      this.scene.tweens.killTweensOf(this);
      this.idleSparks.on = false;
      this.idleSparks.killAll();
      this.hideGlow();
    }
    hideGlow() {
      this.scene.tweens.killTweensOf(this.glow);
      this.scene.tweens.add({
        targets: this.glow,
        duration: 200,
        ease: Phaser.Math.Easing.Linear,
        alpha: 0,
        onComplete: () => {
          this.glow.kill();
        }
      });
    }
  };

  // src/scenes/gameplayGui/levelComplete/LevelEarnedCoins.ts
  var LevelEarnedCoins = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.totalCoinsNum = 0;
      this.name = "earned_coins";
      this.addCoin();
      this.addBaseCoinsText();
      this.addBonusCoinsText();
    }
    addCoin() {
      this.coin = this.scene.add.image(0, 0, "gameplay_gui", "level_complete/coin_big");
      this.add(this.coin);
    }
    addBaseCoinsText() {
      let content = "100";
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "44px",
        color: "#FCE916",
        align: "center"
      };
      this.baseCoinsText = this.scene.add.text(0, 0, content, style);
      this.baseCoinsText.setShadow(0, 4, "#AC4717");
      this.baseCoinsText.setOrigin(0.5, 0.5);
      this.baseCoinsText.y = this.coin.y + 76;
      this.add(this.baseCoinsText);
    }
    addBonusCoinsText() {
      let content = "+0";
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "28px",
        color: "#FCE916",
        align: "center"
      };
      this.bonusCoinsText = this.scene.add.text(0, 0, content, style);
      this.bonusCoinsText.setShadow(0, 2, "#AC4717");
      this.bonusCoinsText.setOrigin(0.5, 0.5);
      this.bonusCoinsText.x = this.baseCoinsText.x - 3;
      this.bonusCoinsText.y = this.baseCoinsText.y + 38;
      this.add(this.bonusCoinsText);
    }
    updateCoinsNum(baseCoins, bonusCoins) {
      this.baseCoinsText.text = baseCoins.toLocaleString();
      this.bonusCoinsText.text = "+" + bonusCoins;
      this.bonusCoinsText.visible = bonusCoins > 0;
      this.totalCoinsNum = baseCoins + bonusCoins;
    }
  };

  // src/scenes/gameplayGui/levelComplete/LevelCompletePopover.ts
  var LevelCompletePopover = class extends Phaser.GameObjects.Container {
    constructor(scene, backTexture, backFrame, textContent) {
      super(scene);
      this.name = "popover";
      this.addBack(backTexture, backFrame);
      this.addText(textContent);
      this.setSize(this.back.displayWidth, this.back.displayHeight);
    }
    addBack(backTexture, backFrame) {
      this.back = this.scene.add.image(0, 0, backTexture, backFrame);
      this.add(this.back);
    }
    addText(textContent) {
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "26px",
        color: "#B35F44",
        align: "center"
      };
      this.text = this.scene.add.text(0, 0, textContent, style);
      this.text.setOrigin(0.5, 0.5);
      this.text.setWordWrapWidth(300, true);
      this.text.scale = Math.min(1, 110 / this.text.height);
      this.text.y = this.back.top + 83;
      this.add(this.text);
    }
    updateText(content) {
      this.text.setText(content);
      this.text.scale = Math.min(1, 110 / this.text.height);
    }
    show() {
      this.scene.tweens.killTweensOf(this);
      this.revive();
      this.alpha = 0;
      this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.scale = 0.66;
      this.scene.tweens.add({
        targets: this,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1,
        onComplete: () => {
          this.hide(1600);
        }
      });
    }
    hide(delay) {
      this.scene.tweens.killTweensOf(this);
      this.scene.tweens.add({
        delay,
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.kill();
        }
      });
    }
  };

  // src/scenes/gameplayGui/levelComplete/Gift.ts
  var LevelCompleteGiftEvent;
  (function(LevelCompleteGiftEvent2) {
    LevelCompleteGiftEvent2["EXPLODE_COMPLETE"] = "__EXPLODE_COMPLETE";
  })(LevelCompleteGiftEvent || (LevelCompleteGiftEvent = {}));
  var Gift = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.name = "big_gift";
      this.addBackRays();
      this.addGift();
      this.addGiftWhite();
      this.addIdleParticles();
      this.addShrinkParticles();
      this.addExplodeParticles();
      this.addTapHand();
      this.bringToTop(this.gift);
      this.bringToTop(this.giftWhite);
      this.bringToTop(this.idleParticles);
      this.bringToTop(this.tapHand);
      this.setSize(this.gift.displayWidth, this.gift.displayHeight);
      this.scene.sys.updateList.add(this);
    }
    addBackRays() {
      let baseScale = 1.1;
      let y = -80;
      this.backRays_1 = this.scene.add.image(0, 0, "rewards", "rewards/reward_rays.png");
      this.backRays_1.alpha = 0.5;
      this.backRays_1.scale = 1.33 * baseScale;
      this.backRays_1.angle = 22.5;
      this.backRays_1.y = y;
      this.backRays_1.kill();
      this.add(this.backRays_1);
      this.backRays_2 = this.scene.add.image(0, 0, "rewards", "rewards/reward_rays.png");
      this.backRays_2.scale = baseScale;
      this.backRays_2.y = y;
      this.backRays_2.kill();
      this.add(this.backRays_2);
    }
    addIdleParticles() {
      this.idleParticles = this.scene.add.particles("rewards");
      this.idleParticles.setPosition(0, -50);
      this.add(this.idleParticles);
      this.idleSparks = this.idleParticles.createEmitter({
        speed: 50,
        frame: "rewards/particles/star_1.png",
        lifespan: {min: 800, max: 1400},
        rotate: {start: 0, end: 180, random: true},
        angle: -90,
        scale: {start: 1.33, end: 0, ease: Ease.ExpoIn},
        alpha: {start: 0, end: 1, ease: Ease.ExpoOut},
        frequency: 250,
        on: false
      });
      this.idleSparks.setEmitZone({
        source: new Phaser.Geom.Circle(0, 0, this.gift.displayWidth * 0.42),
        type: "random",
        quantity: 360
      });
    }
    addShrinkParticles() {
      this.shrinkParticles = this.scene.add.particles("rewards");
      this.shrinkParticles.setPosition(0, -60);
      this.add(this.shrinkParticles);
      this.shrinkGravityWell = this.shrinkParticles.createGravityWell({
        power: 10,
        epsilon: 250,
        gravity: 200
      });
      this.shrinkCircles = this.shrinkParticles.createEmitter({
        frame: "rewards/particles/gift_circle_fx.png",
        alpha: {start: 0, end: 0.33, ease: Ease.ExpoOut},
        scale: {start: 6, end: 0.45, ease: Ease.Linear},
        lifespan: 500,
        frequency: 333,
        on: false
      });
      let emitCircle = new Phaser.Geom.Circle(0, 0, this.giftWhite.displayWidth);
      this.shrinkSparks = this.shrinkParticles.createEmitter({
        frame: "rewards/particles/wheel_reward_spark.png",
        lifespan: 800,
        alpha: {start: 0, end: 1, ease: Ease.ExpoOut},
        scale: {start: 1.33, end: 0.33},
        quantity: 2,
        on: false
      }).setDeathZone({
        source: new Phaser.Geom.Circle(0, 0, emitCircle.radius * 0.25),
        type: "onEnter"
      }).setEmitZone({
        source: emitCircle,
        type: "random"
      });
    }
    addExplodeParticles() {
      this.explodeParticles = this.scene.add.particles("rewards");
      this.explodeParticles.setPosition(0, -80);
      this.add(this.explodeParticles);
      this.explodeCircles = this.explodeParticles.createEmitter({
        frame: "rewards/particles/gift_circle_fx.png",
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        scale: {start: 0.45, end: 8, ease: Ease.ExpoOut},
        lifespan: 900,
        on: false
      });
      this.explodeSparks = this.explodeParticles.createEmitter({
        frame: "rewards/particles/wheel_reward_spark.png",
        lifespan: 3e3,
        speed: {min: 10, max: 1200},
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        scale: {start: 1.33, end: 0},
        emitZone: {
          source: new Phaser.Geom.Circle(0, 0, 100),
          type: "random"
        },
        on: false
      });
      this.explodeSparks.reserve(100);
    }
    addGift() {
      this.gift = this.scene.add.image(0, 0, "rewards", "rewards/gift.png");
      this.add(this.gift);
    }
    addGiftWhite() {
      this.giftWhite = this.scene.add.image(0, 0, "rewards", "rewards/gift_white.png");
      this.giftWhite.setOrigin(this.gift.originX, this.gift.originY);
      this.giftWhite.kill();
      this.add(this.giftWhite);
    }
    addTapHand() {
      this.tapHand = new TapTutorialHand(this.scene, "rewards", "rewards/hand.png");
      this.tapHand.kill();
      this.tapHand.x = 70;
      this.tapHand.y = 70;
      this.add(this.tapHand);
    }
    show() {
      this.scene.audio.play(GameSoundKey.GIFT_REVEAL);
      this.showRays(0);
      this.showIdleSparks(0);
      this.showHand(400);
      this.scene.tweens.add({
        targets: this.gift,
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        scaleX: 1.1,
        scaleY: 0.9,
        yoyo: true,
        repeat: -1
      });
    }
    showRays(delay) {
      let originalAlpha_1 = this.backRays_1.alpha;
      this.backRays_1.revive();
      this.backRays_1.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.backRays_1,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: originalAlpha_1
      });
      let originalAlpha_2 = this.backRays_2.alpha;
      this.backRays_2.revive();
      this.backRays_2.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.backRays_2,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: originalAlpha_2
      });
    }
    showIdleSparks(delay) {
      this.idleSparks.on = true;
    }
    showHand(delay) {
      this.tapHand.revive();
      this.tapHand.playAnimation(delay);
    }
    explode() {
      this.idleSparks.on = false;
      this.idleSparks.killAll();
      this.idleParticles.kill();
      this.shrinkSparks.on = true;
      this.shrinkCircles.on = true;
      this.hideRays();
      this.hideHand();
      this.shrinkGift();
      this.shakeGift();
    }
    hideRays() {
      let rays = [this.backRays_2, this.backRays_1];
      this.scene.tweens.killTweensOf(rays);
      this.scene.tweens.add({
        targets: rays,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.backRays_1.kill();
          this.backRays_2.kill();
        }
      });
    }
    hideHand() {
      this.tapHand.stopAnimation();
      this.scene.tweens.add({
        targets: this.tapHand,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0
      });
    }
    shrinkGift() {
      var _a;
      let duration = 1333;
      this.scene.tweens.killTweensOf(this.gift);
      (_a = this.scene.audio.play(GameSoundKey.DOUBLE_SPHERES_CHARGE)) == null ? void 0 : _a.fade(0, 1, duration);
      this.scene.tweens.add({
        targets: this.gift,
        duration: 100,
        ease: Phaser.Math.Easing.Linear,
        scaleX: 1,
        scaleY: 1,
        onComplete: () => {
          this.scene.tweens.add({
            targets: [this.gift, this.giftWhite],
            duration,
            ease: Phaser.Math.Easing.Linear,
            scale: this.gift.scale * 0.6,
            onComplete: () => {
              this.onShrinkComplete();
            }
          });
          this.giftWhite.revive();
          this.giftWhite.scaleX = this.gift.scaleX;
          this.giftWhite.scaleY = this.gift.scaleY;
          this.giftWhite.alpha = 0;
          this.scene.tweens.add({
            targets: this.giftWhite,
            duration,
            ease: Phaser.Math.Easing.Quadratic.Out,
            alpha: 1
          });
        }
      });
    }
    shakeGift() {
      let targets = [this.giftWhite, this.gift];
      let duration = 33;
      let dx = 7;
      this.giftShakeTween = this.scene.tweens.add({
        targets,
        duration,
        ease: Phaser.Math.Easing.Linear,
        x: `+=${dx}`,
        onComplete: () => {
          this.giftShakeTween = this.scene.tweens.add({
            targets,
            duration,
            ease: Phaser.Math.Easing.Sine.InOut,
            x: `-=${dx * 2}`,
            repeat: -1,
            yoyo: true
          });
        }
      });
    }
    onShrinkComplete() {
      var _a;
      (_a = this.giftShakeTween) == null ? void 0 : _a.remove();
      this.gift.kill();
      this.emit(LevelCompleteGiftEvent.EXPLODE_COMPLETE, this);
      this.scene.audio.play(GameSoundKey.GIFT_EXPLODE);
      this.shrinkParticles.kill();
      this.shrinkSparks.on = false;
      this.shrinkCircles.on = false;
      this.explodeCircles.emitParticle(1);
      this.explodeSparks.emitParticle(100);
      this.scene.tweens.add({
        targets: [this.gift, this.giftWhite],
        duration: 600,
        ease: Phaser.Math.Easing.Expo.Out,
        scale: 3,
        alpha: 0,
        y: "+=100",
        onComplete: () => {
          this.gift.kill();
          this.giftWhite.kill();
        }
      });
    }
    preUpdate(time, delta) {
      if (this.backRays_1.visible) {
        this.backRays_2.angle += delta * 0.01;
        this.backRays_1.angle += delta * 0.01;
      }
    }
    preDestroy() {
      super.preDestroy();
      this.scene.sys.updateList.remove(this);
    }
  };

  // src/scenes/levelMap/wheelReward/WheelReward.ts
  var WheelReward = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this._rewardNum = 0;
      this.name = "wheel_reward";
      this.addRays();
      this.addItem();
      this.addText();
      this.setSize(this.item.width, this.item.height);
      this.scene.sys.updateList.add(this);
    }
    get rewardNum() {
      return this._rewardNum;
    }
    get rewardType() {
      return this._rewardType;
    }
    addRays() {
      this.backRays_1 = this.scene.add.image(0, 0, "rewards", "rewards/reward_rays.png");
      this.backRays_1.alpha = 0.5;
      this.backRays_1.scale = 1.33;
      this.backRays_1.angle = 22.5;
      this.add(this.backRays_1);
      this.backRays_2 = this.scene.add.image(0, 0, "rewards", "rewards/reward_rays.png");
      this.add(this.backRays_2);
    }
    addItem() {
      this.item = this.scene.add.image(0, 0, "rewards", WheelReward.getFrameByType(WheelRewardType.BOMB));
      this.add(this.item);
    }
    addText() {
      let content = "+1";
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "55px",
        color: "#ffffff",
        align: "center",
        stroke: "rgba(0,0,0,0.33)",
        strokeThickness: 10
      };
      this.text = this.scene.add.text(0, 0, content, style);
      this.text.setOrigin(0.5, 0.5);
      this.text.y = this.getTextPositionY();
      this.add(this.text);
    }
    getTextPositionY() {
      return 114;
    }
    updateView(type, num) {
      this._rewardType = type;
      this._rewardNum = num;
      this.item.setFrame(WheelReward.getFrameByType(type));
      this.text.text = `+${num}`;
    }
    static getFrameByType(itemType) {
      let map = {
        [WheelRewardType.SUPER_SPHERE]: "rewards/rewards/super_sphere.png",
        [WheelRewardType.LOLLIPOP]: "rewards/rewards/lollipop.png",
        [WheelRewardType.COINS]: "rewards/rewards/coin.png",
        [WheelRewardType.UNDO]: "rewards/rewards/undo.png",
        [WheelRewardType.GLOVE]: "rewards/rewards/glove.png",
        [WheelRewardType.STRIPES]: "rewards/rewards/stripes.png",
        [WheelRewardType.ROLLING_PIN]: "rewards/rewards/rolling_pin.png",
        [WheelRewardType.BOMB]: "rewards/rewards/bomb.png"
      };
      return map[itemType];
    }
    startFloat(initialDelay = 0) {
      let deltaScale = 0.06;
      this.floatTween = this.scene.tweens.add({
        targets: this,
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        scaleX: this.scaleX + deltaScale,
        scaleY: this.scaleY - deltaScale,
        yoyo: true,
        repeat: -1
      });
    }
    stopFloat() {
      var _a;
      (_a = this.floatTween) == null ? void 0 : _a.remove();
      this.floatTween = null;
      this.scene.tweens.add({
        targets: this,
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.Out,
        scaleX: 1,
        scaleY: 1
      });
    }
    hideTextAndRays() {
      this.scene.tweens.add({
        targets: [this.text, this.backRays_1, this.backRays_2],
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0
      });
    }
    preUpdate(time, delta) {
      if (this.visible) {
        this.backRays_2.angle += delta * 0.01;
        this.backRays_1.angle += delta * 0.01;
      }
    }
    showText(delay) {
      this.text.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.text,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.text.scale = 3;
      this.scene.tweens.add({
        delay,
        targets: this.text,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.4],
        scale: 1
      });
    }
    showTextDoubled(delay) {
      this.text.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.text,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.text.angle = -33;
      this.scene.tweens.add({
        delay,
        targets: this.text,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        angle: 0
      });
      this.text.scale = 4;
      this.scene.tweens.add({
        delay,
        targets: this.text,
        duration: 600,
        ease: Phaser.Math.Easing.Bounce.Out,
        easeParams: [1.4],
        scale: 1
      });
    }
    setRewardNum(num) {
      this._rewardNum = num;
      this.text.setText("+" + this._rewardNum);
    }
    moveToPoint(target, delay) {
      let curve = this.createMoveCurve(target);
      let duration = 666;
      this.scene.tweens.add({
        delay,
        targets: this,
        duration,
        ease: Phaser.Math.Easing.Back.In,
        scale: 0.4
      });
      this.scene.tweens.add({
        targets: this,
        duration: 300,
        ease: Phaser.Math.Easing.Sine.InOut,
        angle: 33 * Phaser.Math.Sign(this.x - target.x),
        yoyo: true
      });
      return this.scene.tweens.addCurveTween({
        delay,
        curve,
        duration,
        ease: Phaser.Math.Easing.Quadratic.InOut,
        target: this
      });
    }
    createMoveCurve(target) {
      let dx = Math.abs(target.x - this.x);
      let offsetX = dx * 0.33;
      let midPointX = target.x > this.x ? this.x + offsetX : this.x - offsetX;
      let curvePoints = [
        this.x,
        this.y,
        midPointX,
        this.y + 250,
        target.x,
        target.y
      ];
      return new Phaser.Curves.Spline(curvePoints);
    }
    preDestroy() {
      super.preDestroy();
      this.scene.sys.updateList.remove(this);
    }
  };

  // src/scenes/levelMap/gift/GiftReward.ts
  var Spline = Phaser.Curves.Spline;
  var GiftReward = class extends Phaser.GameObjects.Container {
    constructor(scene, rewardType, rewardNum) {
      super(scene);
      this.name = "gift_reward_" + rewardType;
      this.rewardType = rewardType;
      this.rewardNum = rewardNum;
      this.addItem();
      this.addText();
      this.addParticles();
      this.setSize(this.item.width, this.item.height);
    }
    addItem() {
      let frame = WheelReward.getFrameByType(this.rewardType);
      this.item = this.scene.add.image(0, 0, "rewards", frame);
      this.item.originalY = this.item.y;
      this.add(this.item);
    }
    addText() {
      let content = `+${this.rewardNum}`;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "48px",
        color: "#ffffff",
        align: "center",
        stroke: "rgba(0,0,0,0.33)",
        strokeThickness: 10
      };
      this.text = this.scene.add.text(0, 0, content, style);
      this.text.setOrigin(0.5, 0.5);
      this.text.y = 114;
      this.text.originalY = this.text.y;
      this.add(this.text);
    }
    addParticles() {
      this.idleParticles = this.scene.add.particles("rewards");
      this.idleParticles.setPosition(0, 0);
      this.add(this.idleParticles);
      let particlesNum = 10;
      this.idleSparks = this.idleParticles.createEmitter({
        angle: -90,
        speed: 20,
        delay: {min: 0, max: 800, steps: particlesNum},
        frame: "rewards/particles/star_1.png",
        lifespan: 500,
        scale: {start: 0, end: 1.25, ease: CustomEase.Bell},
        on: false
      });
      this.idleSparks.setEmitZone({
        source: this.getSparksEmitZone(),
        type: "random",
        quantity: 360
      });
    }
    getSparksEmitZone() {
      let width = this.item.displayWidth;
      let height = this.item.displayHeight;
      return new Phaser.Geom.Rectangle(-width / 2, -height / 2, width, height);
    }
    showParticles() {
      this.idleSparks.explode(10, 0, 0);
    }
    startFloat(initialDelay) {
      this.scene.tweens.add({
        delay: this.scene.tweens.stagger(100, {start: initialDelay}),
        targets: [this.item, this.text],
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        y: "-=18",
        yoyo: true,
        repeat: -1
      });
    }
    stopFloat() {
      this.scene.tweens.killTweensOf(this.item);
      this.scene.tweens.killTweensOf(this.text);
      this.scene.tweens.add({
        targets: [this.item, this.text],
        duration: 200,
        ease: Phaser.Math.Easing.Linear,
        y: (target) => target.originalY
      });
    }
    hideText() {
      this.scene.tweens.add({
        targets: this.text,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        y: "+=10",
        onComplete: () => {
          this.text.kill();
        }
      });
    }
    moveToPoint(target, delay) {
      let curve = this.createMoveCurve(target);
      let duration = 566;
      this.scene.tweens.add({
        delay,
        targets: this,
        duration,
        ease: Phaser.Math.Easing.Back.In,
        scale: 0.4
      });
      this.scene.tweens.add({
        delay,
        targets: this,
        duration,
        ease: Phaser.Math.Easing.Expo.In,
        alpha: 0
      });
      this.scene.tweens.add({
        targets: this,
        duration: 300,
        ease: Phaser.Math.Easing.Sine.InOut,
        angle: 33 * Phaser.Math.Sign(this.x - target.x),
        yoyo: true
      });
      return this.scene.tweens.addCurveTween({
        delay,
        curve,
        duration,
        ease: Phaser.Math.Easing.Quadratic.InOut,
        target: this
      });
    }
    createMoveCurve(target) {
      let dx = Math.abs(target.x - this.x);
      let offsetX = dx * 0.33;
      let midPointX = target.x > this.x ? this.x + offsetX : this.x - offsetX;
      let curvePoints = [
        this.x,
        this.y,
        midPointX,
        this.y + 250,
        target.x,
        target.y
      ];
      return new Spline(curvePoints);
    }
  };

  // src/scenes/gameplayGui/levelComplete/labels/LevelCompleteStarsLabel.ts
  var LevelCompleteStarsLabel = class extends LevelCompleteLabel {
    constructor(scene, options) {
      super(scene, options);
      this.currentStars = 0;
      this.targetStars = 0;
    }
    isGiftReady() {
      return this.currentStars >= this.targetStars;
    }
    updateCurrentStars(value) {
      this.currentStars = value;
      this.onStarsUpdate();
    }
    updateStarsNum(currentStars, targetStars) {
      this.currentStars = currentStars;
      this.targetStars = targetStars;
      this.onStarsUpdate();
    }
    onStarsUpdate() {
      let textContent = this.currentStars >= this.targetStars ? this.scene.texts.stars_gift.ready : `${this.currentStars}/${this.targetStars}`;
      this.updateTextContent(textContent);
    }
  };

  // src/scenes/gameplayGui/levelComplete/RewardButtons.ts
  var RewardButtons = class extends Phaser.Events.EventEmitter {
    constructor(parent, options) {
      super();
      this.parent = parent;
      this.scene = parent.scene;
      this.addBonusRewardButton(options.extraButtonText);
      this.addClaimRewardButton(options.claimButtonText);
    }
    addBonusRewardButton(content) {
      let style = this.getButtonTextStyle();
      this.extraRewardButton = this.scene.add.complexButton("rewards", "rewards/button_double.png", this.parent);
      this.extraRewardButton.addIcon("rewards", "rewards/watch ad.png", 135, -60).setScale(0.9);
      this.extraRewardButton.addText(content, style, 0, -3);
      this.extraRewardButton.text.setLineSpacing(-4);
      this.extraRewardButton.text.setWordWrapWidth(210, true);
      this.extraRewardButton.kill();
      this.extraRewardButton.originalY = this.extraRewardButton.y;
      this.parent.add(this.extraRewardButton);
      this.parent.pin(this.extraRewardButton, 0.5, 0.7);
    }
    addClaimRewardButton(content) {
      let style = __spreadProps(__spreadValues({}, this.getButtonTextStyle()), {
        fontSize: "31px"
      });
      this.claimButton = this.scene.add.complexButton("rewards", "rewards/button_no.png", this.parent);
      this.claimButton.addText(content, style, 0, -3);
      this.claimButton.text.setLineSpacing(-4);
      this.claimButton.text.setWordWrapWidth(160, true);
      this.claimButton.kill();
      this.claimButton.originalY = this.claimButton.y;
      this.parent.add(this.claimButton);
      this.parent.pin(this.claimButton, 0.5, 0.7, 0, 156);
    }
    getButtonTextStyle() {
      return {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "32px",
        color: "#ffffff",
        align: "center",
        padding: {x: 0, y: 6},
        shadow: {
          offsetX: 0,
          offsetY: 3,
          fill: true,
          color: "rgba(0,0,0,0.2)",
          blur: 0
        }
      };
    }
    show(initialDelay) {
      let buttons = [this.extraRewardButton, this.claimButton];
      buttons.forEach((button, index) => {
        let delay = initialDelay + index * 100;
        button.revive();
        button.alpha = 0;
        this.scene.tweens.add({
          delay,
          targets: button,
          duration: 150,
          ease: Phaser.Math.Easing.Cubic.Out,
          alpha: 1
        });
        button.scale = 0.75;
        this.scene.tweens.add({
          delay,
          targets: button,
          duration: 400,
          ease: Phaser.Math.Easing.Back.Out,
          scale: 1
        });
        let deltaY = 50;
        button.y = button.originalY + deltaY;
        this.scene.tweens.add({
          delay,
          targets: button,
          duration: 500,
          ease: Phaser.Math.Easing.Back.Out,
          y: button.originalY
        });
      });
    }
    hide() {
      let buttons = [this.extraRewardButton, this.claimButton];
      buttons.forEach((button) => button.disableInput());
      this.scene.tweens.add({
        targets: buttons,
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        y: "+=30",
        onComplete: () => {
          this.extraRewardButton.kill();
          this.claimButton.kill();
        }
      });
    }
    reset() {
      this.extraRewardButton.revive();
      this.extraRewardButton.enableInput();
      this.extraRewardButton.y = this.extraRewardButton.originalY;
      this.claimButton.revive();
      this.claimButton.enableInput();
      this.claimButton.y = this.claimButton.originalY;
    }
    align() {
      this.parent.pinner.align(this.extraRewardButton, this.parent.screenWidth, this.parent.screenHeight, 1);
      this.parent.pinner.align(this.claimButton, this.parent.screenWidth, this.parent.screenHeight, 1);
    }
  };

  // src/scenes/gameplayGui/levelComplete/labels/PiggyBankLabel.ts
  var PiggyBankLabel = class extends LevelCompleteLabel {
    constructor(scene, options) {
      super(scene, options);
      this.isFull = false;
      this.coinsNum = 0;
      this.coinsNum = this.getPiggyCoinsAmount();
    }
    hideCoinsText() {
      this.text.kill();
    }
    showFullText() {
      this.fullText = this.createCanvasText(this.scene.texts.piggy_bank.full);
      this.fullText.setOrigin(0.5, 0.5);
      this.fullText.x = 106;
      this.fullText.originalX = this.fullText.x;
      this.fullText.scale = Math.min(1, 124 / this.text.width);
      this.add(this.fullText);
    }
    getPiggyCoinsAmount() {
      return this.scene.game.store.getNumber(GameStoreKey.PIGGY_BANK_COINS);
    }
    syncWithGameStore(instant) {
      let value = this.getPiggyCoinsAmount();
      if (instant) {
        this.updateTextContent(value.toString());
      } else {
        this.updateCoinsNum(value);
      }
    }
    updateCoinsNum(value) {
      let currentValue = this.coinsNum;
      this.coinsNum = value;
      this.scene.tweens.addCounter({
        from: currentValue,
        to: value,
        onUpdate: (tween) => {
          let content = Math.round(tween.getValue()).toLocaleString();
          this.updateTextContent(content);
        }
      });
    }
    rejectCoins() {
      this.shakeFullText();
      this.animatePiggy();
    }
    shakeFullText() {
      this.fullText.x = this.fullText.originalX;
      this.scene.tweens.killTweensOf(this.fullText);
      this.scene.tweens.add({
        targets: this.fullText,
        duration: 44,
        ease: Phaser.Math.Easing.Sine.InOut,
        x: "-=10",
        yoyo: true,
        repeat: 3
      });
    }
    animatePiggy() {
      this.scene.tweens.add({
        angle: -10,
        targets: this.icon,
        duration: 300,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.25,
        yoyo: true,
        repeat: 0
      });
    }
  };

  // src/scenes/gameplayGui/levelComplete/LevelCompleteScreen.ts
  var Spline2 = Phaser.Curves.Spline;
  var DegToRad2 = Phaser.Math.DegToRad;
  var LevelCompleteScreenEvent;
  (function(LevelCompleteScreenEvent2) {
    LevelCompleteScreenEvent2["GOTO_NEXT_LEVEL"] = "__GOTO_NEXT_LEVEL";
  })(LevelCompleteScreenEvent || (LevelCompleteScreenEvent = {}));
  var LevelCompleteScreen = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "level_complete_screen",
        backgroundKey: "gameplay_gui",
        backgroundFrame: "black_rect",
        backgroundAlpha: 0.85
      });
      this.starPinY = 0.42;
      this.backgroundClicksNum = 0;
      this.isNextLevelScheduled = false;
      this.store = this.scene.game.store;
      this.giftsManager = this.scene.game.gifts;
      this.addTopLeftLabel();
      this.addStarsLabel();
      this.addLabelPopover();
      this.addTitle();
      this.addStarParticles();
      this.addStar();
      this.addEarnedCoins();
      this.addChef();
      this.addContinueText();
      this.bringToTop(this.topLeftLabel);
      this.bringToTop(this.starsLabel);
      this.bringToTop(this.earnedCoinsLabel);
      this.bringToTop(this.titleText);
      this.bringToTop(this.continueText);
      this.bringToTop(this.labelPopover);
    }
    addTopLeftLabel() {
      var _a;
      if (this.scene.game.piggyBank) {
        this.addPiggyBankLabel();
      } else {
        this.addCoinsLabel();
      }
      this.topLeftLabel = (_a = this.coinsLabel) != null ? _a : this.piggyBankLabel;
    }
    addCoinsLabel() {
      let options = {
        atlas: "gameplay_gui",
        backFrame: "level_complete/labels/label_back",
        iconOffset: {x: 0, y: 0},
        iconFrame: "level_complete/labels/Coin_2",
        text: {
          type: "bitmap",
          font: BitmapFont.LABELS_GAMEPLAY_GUI
        }
      };
      let coinsNum = this.scene.game.store.getNumber(GameStoreKey.COINS);
      this.coinsLabel = new LevelCompleteCoinsLabel(this.scene, options);
      this.coinsLabel.updateCoinsNumInstant(coinsNum);
      this.pin(this.coinsLabel, 0, 0, 70, 66);
      this.add(this.coinsLabel);
    }
    addPiggyBankLabel() {
      let options = {
        atlas: "gameplay_gui",
        backFrame: "level_complete/labels/label_back",
        iconOffset: {x: 0, y: -2},
        iconFrame: "level_complete/labels/piggy_icon",
        text: {
          type: "bitmap",
          font: BitmapFont.LABELS_GAMEPLAY_GUI
        }
      };
      this.piggyBankLabel = new PiggyBankLabel(this.scene, options);
      this.piggyBankLabel.syncWithGameStore(true);
      this.pin(this.piggyBankLabel, 0, 0, 70, 66);
      this.add(this.piggyBankLabel);
      if (this.scene.game.piggyBank.isFull()) {
        this.piggyBankLabel.isFull = true;
        this.piggyBankLabel.hideCoinsText();
        this.piggyBankLabel.showFullText();
        this.piggyBankLabel.setInteractive();
        this.piggyBankLabel.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onPiggyBankLabelClick, this);
      }
    }
    onPiggyBankLabelClick() {
      let content = this.scene.texts.piggy_bank.warning;
      this.labelPopover.x = this.piggyBankLabel.x + 120;
      this.labelPopover.y = this.piggyBankLabel.y + 18;
      this.labelPopover.updateText(content);
      this.labelPopover.show();
      this.scene.audio.play(GameSoundKey.TAP);
    }
    addStarsLabel() {
      let options = {
        atlas: "gameplay_gui",
        backFrame: "level_complete/labels/label_back",
        iconOffset: {x: 0, y: -4},
        iconFrame: "level_complete/labels/Pink-Gift-Icon",
        text: {
          type: "text"
        }
      };
      let currentStars = this.giftsManager.getCurrentStars();
      let targetStars = this.giftsManager.getTargetStars();
      this.starsLabel = new LevelCompleteStarsLabel(this.scene, options);
      this.starsLabel.updateStarsNum(currentStars, targetStars);
      this.pin(this.starsLabel, 1, 0, -220, 66);
      this.add(this.starsLabel);
      this.starsLabel.setInteractive();
      this.starsLabel.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onStarsLabelClick, this);
    }
    onStarsLabelClick() {
      let content = this.scene.texts.stars_gift.collect_popover.replace("#", this.starsLabel.targetStars.toString());
      this.labelPopover.x = this.starsLabel.x;
      this.labelPopover.y = this.starsLabel.y + 24;
      this.labelPopover.updateText(content);
      this.labelPopover.show();
      this.scene.audio.play(GameSoundKey.TAP);
    }
    addLabelPopover() {
      let content = "Popover Content";
      this.labelPopover = new LevelCompletePopover(this.scene, "gameplay_gui", "level_complete/popover", content);
      this.labelPopover.kill();
      this.add(this.labelPopover);
    }
    addTitle() {
      let content = this.scene.texts.victory;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "68px",
        color: "#FCE916",
        align: "center",
        padding: {x: 0, y: 10}
      };
      this.titleText = this.scene.add.text(0, 0, content, style);
      this.titleText.setOrigin(0.5, 0.5);
      this.titleText.setShadow(0, 4, "#AC4717", 2);
      this.pin(this.titleText, 0.5, this.starPinY, 0, -200);
      this.add(this.titleText);
    }
    addStarParticles() {
      this.starParticles = this.scene.add.particles("gameplay_gui");
      this.add(this.starParticles);
      this.starEmitter = this.starParticles.createEmitter({
        frame: "particles/particle_star_4",
        frequency: 16,
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        scale: {start: 2, end: 0.1, ease: Ease.ExpoOut},
        lifespan: 2666,
        speed: 30,
        on: false
      });
    }
    addStar() {
      this.star = new LevelCompleteStar(this.scene);
      this.star.originalY = 0;
      this.pin(this.star, 0.5, this.starPinY);
      this.add(this.star);
    }
    addEarnedCoins() {
      this.earnedCoinsLabel = new LevelEarnedCoins(this.scene);
      this.earnedCoinsLabel.originalY = 0;
      this.pin(this.earnedCoinsLabel, 0.5, this.starPinY, 0, 210);
      this.add(this.earnedCoinsLabel);
    }
    addChef() {
      this.chef = this.scene.add.image(0, 0, "gameplay_gui", "level_complete/Chef Cherry");
      this.pin(this.chef, 0.28, 1, 0, 6);
      this.add(this.chef);
    }
    addContinueText() {
      let content = this.scene.texts.tap_to_continue;
      let style = this.getTextStyle();
      this.continueText = this.scene.add.text(0, 0, content, style);
      this.continueText.setOrigin(0.5, 0.5);
      this.continueText.setWordWrapWidth(350, true);
      this.continueText.setLineSpacing(-5);
      this.pin(this.continueText, 0.7, 1, 0, -80);
      this.add(this.continueText);
    }
    getTextStyle() {
      return {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "36px",
        color: "#FFCFB2",
        align: "center"
      };
    }
    resize() {
      super.resize();
    }
    updateData(data) {
      this.completeData = data;
      this.earnedCoinsLabel.updateCoinsNum(data.baseCoins, data.bonusCoins);
    }
    show() {
      this.revive();
      let starDelay = 300;
      let afterStarDelay = 800 + starDelay;
      this.scene.time.delayedCall(starDelay, () => {
        var _a;
        (_a = this.scene.audio.play(GameSoundKey.VICTORY)) == null ? void 0 : _a.fade(0, 0.66, 300);
      });
      this.scene.time.delayedCall(starDelay + 400, () => {
        this.scene.audio.fadeInMusicLoop(1e3);
      });
      this.showBackground({duration: 300});
      this.star.show(starDelay);
      this.showTitle(afterStarDelay + 200);
      this.showEarnedCoins(afterStarDelay + 200);
      this.showTopLabels(afterStarDelay + 350);
      this.showChef(afterStarDelay + 350);
      this.showContinueText(afterStarDelay + 550);
      this.showConfetti();
      this.background.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
        if (this.backgroundClicksNum++ === 0) {
          this.applyFastForward();
        }
      });
    }
    applyFastForward() {
      this.scene.fastForward.start(2);
    }
    collectLevelRewards() {
      this.saveLevelRewards();
      this.collectStar();
      this.collectCoins();
      this.hideTitle();
      this.hideChef();
      this.hideContinueText();
    }
    saveLevelRewards() {
      this.saveLevelCoins();
      this.scene.game.store.changeNumber(GameStoreKey.GIFT_STARS_NUM, 1);
      this.scene.analytics.addResource(ResourceCurrency.COINS, this.getEarnedCoinsNum(), ResourceItemType.COIN, `Level_${this.scene.levelConfig.levelNumber}.Complete`);
    }
    saveLevelCoins() {
      let coins = this.getEarnedCoinsNum();
      if (this.scene.game.piggyBank) {
        this.scene.game.piggyBank.changeCoinsNum(coins);
      } else {
        this.scene.game.store.changeNumber(GameStoreKey.COINS, coins);
      }
    }
    getEarnedCoinsNum() {
      return this.completeData.baseCoins + this.completeData.bonusCoins;
    }
    collectStar() {
      this.star.onCollect();
      this.scene.time.delayedCall(300, () => {
        var _a;
        (_a = this.scene.audio.play(GameSoundKey.POWERUP_FROM_CHEF)) == null ? void 0 : _a.fade(0, 0.75, 100);
      });
      let start = {x: this.star.x, y: this.star.y};
      let end = {x: this.starsLabel.x, y: this.starsLabel.y};
      let curve = new Spline2([
        start.x,
        start.y,
        start.x + 150,
        start.y - 70,
        end.x,
        end.y
      ]);
      let duration = 800;
      let delay = 200;
      this.scene.tweens.addCurveTween({
        delay,
        curve,
        target: this.star,
        duration,
        ease: Ease.QuadInOut,
        onUpdate: () => {
          let radius = 16;
          let particlesNum = Phaser.Math.RND.between(1, 2);
          for (let i = 0; i < particlesNum; i++) {
            let x = this.star.x + Phaser.Math.RND.between(-radius, radius);
            let y = this.star.y + Phaser.Math.RND.between(-radius, radius);
            this.starEmitter.emitParticle(particlesNum, x, y);
          }
        },
        onComplete: () => {
          this.onStarCollectComplete();
        }
      });
      this.scene.tweens.add({
        targets: this.star,
        duration: duration + delay,
        ease: Phaser.Math.Easing.Back.In,
        scale: 0.2,
        angle: 360
      });
      this.scene.tweens.add({
        delay: duration + delay - 100,
        targets: this.star,
        duration: 100,
        ease: Phaser.Math.Easing.Expo.In,
        alpha: 0
      });
    }
    onStarCollectComplete() {
      this.scene.audio.play(GameSoundKey.TWINKLE_4, {volume: 0.25});
      this.star.kill();
      let starsNum = this.starsLabel.currentStars + 1;
      this.starsLabel.updateCurrentStars(starsNum);
      this.starsLabel.playTextTween();
      this.starsLabel.playAnimation();
      let isGiftReady = this.starsLabel.isGiftReady();
      if (isGiftReady) {
        let giftRewardsData = this.giftsManager.getGiftRewards(3);
        this.giftsManager.saveRewards(...giftRewardsData);
        this.giftsManager.onGiftOpen();
        this.scene.time.delayedCall(800, () => {
          this.hideStarsLabel();
          this.showGift(giftRewardsData);
          this.addRewardButtons();
          this.addClaimRewardsText();
        });
      }
    }
    collectCoins() {
      this.hideEarnedCoins();
      this.doCollectCoins();
    }
    hideEarnedCoins() {
      this.earnedCoinsLabel.alpha = 1;
      this.earnedCoinsLabel.y = this.earnedCoinsLabel.originalY;
      this.scene.tweens.killTweensOf(this.earnedCoinsLabel);
      this.scene.tweens.add({
        delay: 200,
        targets: this.earnedCoinsLabel,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.earnedCoinsLabel.kill();
        }
      });
    }
    doCollectCoins() {
      let coinsNum = 10;
      let onFirstCoinArrive = once_default(() => {
        if (this.piggyBankLabel && this.piggyBankLabel.isFull) {
          this.piggyBankLabel.rejectCoins();
          return;
        }
        this.topLeftLabel.syncWithGameStore(false);
        this.topLeftLabel.playTextTween();
        this.topLeftLabel.playAnimation();
      });
      let onLastCoinArrive = after_default(coinsNum, () => {
        this.scene.time.delayedCall(800, () => {
          this.onLevelRewardsCollected();
        });
      });
      let callback = this.piggyBankLabel && this.piggyBankLabel.isFull ? () => this.collectSingleCoinWithReject(onFirstCoinArrive, onLastCoinArrive) : () => this.collectSingleCoin(onFirstCoinArrive, onLastCoinArrive);
      this.scene.time.addEvent({
        startAt: 66,
        delay: 66,
        repeat: coinsNum - 1,
        callback
      });
    }
    collectSingleCoinWithReject(onFirstCoinArrive, onLastCoinArrive) {
      let coin = this.scene.add.image(0, 0, "gameplay_gui", "level_complete/coin_big");
      coin.x = this.earnedCoinsLabel.x;
      coin.y = this.earnedCoinsLabel.y;
      coin.kill();
      this.add(coin);
      let start = {x: coin.x, y: coin.y};
      let end = {x: this.piggyBankLabel.x, y: this.piggyBankLabel.y + 30};
      let curve = new Spline2([
        start.x,
        start.y,
        start.x - 150,
        start.y - 70,
        end.x,
        end.y
      ]);
      let duration = 800;
      let delay = 200;
      this.scene.tweens.addCurveTween({
        delay,
        curve,
        target: coin,
        duration,
        ease: Ease.QuadInOut,
        onStart: () => {
          coin.revive();
        },
        onComplete: () => {
          this.rejectCoin(coin);
          onFirstCoinArrive();
          onLastCoinArrive();
        }
      });
      this.scene.tweens.add({
        targets: coin,
        duration: duration + delay,
        ease: Phaser.Math.Easing.Back.In,
        scale: 0.66,
        angle: 360
      });
    }
    rejectCoin(coin) {
      let angle = Phaser.Math.RND.between(23, 100);
      let angleRad = DegToRad2(angle);
      let distance = Phaser.Math.RND.between(70, 150);
      let dx = Math.cos(angleRad) * distance;
      let dy = Math.sin(angleRad) * distance;
      this.scene.tweens.add({
        targets: coin,
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.Out,
        scale: 0.5,
        x: coin.x + dx,
        y: coin.y + dy
      });
      this.scene.tweens.add({
        targets: coin,
        delay: 400,
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.In,
        alpha: 0,
        onComplete: () => {
          coin.destroy();
        }
      });
    }
    collectSingleCoin(onFirstCoinArrive, onLastCoinArrive) {
      let coin = this.scene.add.image(0, 0, "gameplay_gui", "level_complete/coin_big");
      coin.x = this.earnedCoinsLabel.x;
      coin.y = this.earnedCoinsLabel.y;
      coin.kill();
      this.addAt(coin, 1);
      let start = {x: coin.x, y: coin.y};
      let end = {x: this.topLeftLabel.x, y: this.topLeftLabel.y};
      let curve = new Spline2([
        start.x,
        start.y,
        start.x - 150,
        start.y - 70,
        end.x,
        end.y
      ]);
      let duration = 800;
      let delay = 200;
      this.scene.tweens.addCurveTween({
        delay,
        curve,
        target: coin,
        duration,
        ease: Ease.QuadInOut,
        onStart: () => {
          coin.revive();
        },
        onComplete: () => {
          coin.destroy();
          onFirstCoinArrive();
          onLastCoinArrive();
          this.scene.gameplay.sounds.coinAdd();
        }
      });
      this.scene.tweens.add({
        targets: coin,
        duration: duration + delay,
        ease: Phaser.Math.Easing.Back.In,
        scale: 0.66,
        angle: 360
      });
      this.scene.tweens.add({
        delay: duration + delay - 100,
        targets: coin,
        duration: 100,
        ease: Phaser.Math.Easing.Expo.In,
        alpha: 0
      });
    }
    hideTitle() {
      this.scene.tweens.add({
        targets: this.titleText,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        y: "-=20",
        onComplete: () => {
          this.titleText.kill();
        }
      });
    }
    hideChef() {
      this.scene.tweens.killTweensOf(this.chef);
      this.scene.tweens.add({
        targets: this.chef,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        x: "-=20",
        onComplete: () => {
          this.chef.kill();
        }
      });
    }
    hideContinueText() {
      this.scene.tweens.killTweensOf(this.continueText);
      this.scene.tweens.add({
        targets: this.continueText,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        y: "+=20",
        onComplete: () => {
          this.continueText.kill();
        }
      });
    }
    gotoNextLevel() {
      if (this.isNextLevelScheduled) {
        return;
      }
      this.isNextLevelScheduled = true;
      this.scene.game.gdSdk.showInterstitialAd("Gameplay:LevelCompleteScreen").finally(() => {
        this.emit(LevelCompleteScreenEvent.GOTO_NEXT_LEVEL, this);
      });
    }
    showTitle(delay) {
      this.titleText.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.titleText,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      let originalY = this.titleText.y;
      this.titleText.y = originalY - 50;
      this.scene.tweens.add({
        delay,
        targets: this.titleText,
        duration: 800,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        y: originalY
      });
    }
    showEarnedCoins(delay) {
      this.earnedCoinsLabel.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.earnedCoinsLabel,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      let originalY = this.earnedCoinsLabel.y;
      this.earnedCoinsLabel.y = originalY + 50;
      this.scene.tweens.add({
        delay,
        targets: this.earnedCoinsLabel,
        duration: 800,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        y: originalY
      });
    }
    showTopLabels(initialDelay) {
      let labels = [this.topLeftLabel, this.starsLabel];
      labels.forEach((label) => {
        label.alpha = 0;
        this.scene.tweens.add({
          delay: initialDelay,
          targets: label,
          duration: 150,
          ease: Phaser.Math.Easing.Cubic.Out,
          alpha: 1
        });
        let originalY = label.y;
        label.y = originalY - 50;
        this.scene.tweens.add({
          delay: initialDelay,
          targets: label,
          duration: 800,
          ease: Phaser.Math.Easing.Elastic.Out,
          easeParams: [0.1, 0.45],
          y: originalY
        });
      });
    }
    showChef(delay) {
      this.chef.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.chef,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.chef.scale = 0.75;
      this.scene.tweens.add({
        delay,
        targets: this.chef,
        duration: 800,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
      this.chef.angle = -1;
      this.scene.tweens.add({
        targets: this.chef,
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        angle: this.chef.angle * -1,
        yoyo: true,
        repeat: -1
      });
    }
    showConfetti() {
      this.confetti = new LevelCompleteConfetti(this.scene, this, 100);
      this.scene.time.delayedCall(6e3, () => {
        this.confetti.hide(600);
      });
    }
    showContinueText(delay) {
      this.continueText.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.continueText,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      let originalY = this.continueText.y;
      this.continueText.y = originalY + 50;
      this.scene.tweens.add({
        delay,
        targets: this.continueText,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        y: originalY,
        onComplete: () => {
          this.onShowAnimationComplete();
        }
      });
      this.scene.tweens.add({
        delay,
        targets: this.continueText,
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.1,
        yoyo: true,
        repeat: -1
      });
    }
    onShowAnimationComplete() {
      this.scene.fastForward.stop();
      this.background.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN);
      if (this.backgroundClicksNum >= 2) {
        this.playCollectAnimations();
      } else {
        this.background.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
          this.scene.audio.playClick();
          this.playCollectAnimations();
        });
      }
    }
    playCollectAnimations() {
      this.starsLabel.disableInteractive();
      this.labelPopover.hide(0);
      this.confetti.hideInstant();
      if (this.completeData.isCompleteFirstTime) {
        this.collectLevelRewards();
        this.background.once(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.onBackgroundClick, this);
      } else {
        this.gotoNextLevel();
      }
    }
    onBackgroundClick() {
      let isGiftScheduled = this.isGiftScheduled();
      if (isGiftScheduled) {
        this.applyFastForward();
      } else {
        this.gotoNextLevel();
      }
    }
    isGiftScheduled() {
      let {gifts} = this.scene.game;
      let currentStars = gifts.getCurrentStars();
      let targetStars = gifts.getTargetStars();
      return currentStars >= targetStars;
    }
    onLevelRewardsCollected() {
      let hasGift = this.starsLabel.isGiftReady();
      if (hasGift === false) {
        this.gotoNextLevel();
      }
    }
    hideLabelPopover() {
      this.scene.tweens.killTweensOf(this.labelPopover);
      this.scene.tweens.add({
        targets: this.labelPopover,
        duration: 200,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 0,
        y: "-=10",
        onComplete: () => {
          this.labelPopover.kill();
        }
      });
    }
    hideTopLeftLabel() {
      this.scene.tweens.add({
        targets: this.topLeftLabel,
        duration: 200,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 0,
        y: "-=10",
        onComplete: () => {
          this.topLeftLabel.kill();
        }
      });
    }
    hideStarsLabel() {
      this.scene.tweens.add({
        targets: this.starsLabel,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.starsLabel.kill();
        }
      });
    }
    showGift(giftRewards) {
      this.gift = new Gift(this.scene);
      this.gift.x = this.starsLabel.x;
      this.gift.y = this.starsLabel.y + 22;
      this.gift.rewards = giftRewards;
      this.add(this.gift);
      this.gift.alpha = 0;
      this.scene.tweens.add({
        targets: this.gift,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.gift.scale = 0.27;
      this.scene.tweens.add({
        targets: this.gift,
        delay: 200,
        duration: 600,
        ease: Phaser.Math.Easing.Linear,
        scale: 1
      });
      this.scene.tweens.add({
        targets: this.gift,
        duration: 700,
        ease: Phaser.Math.Easing.Quadratic.InOut,
        angle: -20,
        onComplete: () => {
          this.scene.tweens.add({
            targets: this.gift,
            duration: 800,
            ease: Phaser.Math.Easing.Elastic.Out,
            easeParams: [0.1, 0.55],
            angle: 0
          });
        }
      });
      this.scene.tweens.addCurveTween({
        curve: this.createGiftMoveCurve(this.gift),
        target: this.gift,
        ease: Ease.QuadInOut,
        duration: 800,
        onComplete: () => {
          this.onGiftShowComplete(this.gift);
        }
      });
      this.scene.time.delayedCall(700, () => {
        this.scene.audio.play(GameSoundKey.GIFT_DROP, {volume: 0.5});
      });
    }
    addRewardButtons() {
      let options = {
        extraButtonText: this.scene.texts.rewards.bonus,
        claimButtonText: this.scene.texts.rewards.decline
      };
      this.rewardButtons = new RewardButtons(this, options);
      this.rewardButtons.align();
    }
    addClaimRewardsText() {
      let content = this.scene.texts.tap_to_continue;
      let style = this.getTextStyle();
      this.claimRewardsText = this.scene.add.text(0, 0, content, style);
      this.claimRewardsText.setOrigin(0.5, 0.5);
      this.claimRewardsText.setWordWrapWidth(Config.SOURCE_GAME_WIDTH * 0.8, true);
      this.claimRewardsText.setLineSpacing(-12);
      this.claimRewardsText.kill();
      this.claimRewardsText.originalY = 0;
      this.pin(this.claimRewardsText, 0.5, 0.87);
      this.add(this.claimRewardsText);
      this.pinner.align(this.claimRewardsText, this.screenWidth, this.screenHeight, 1);
    }
    createGiftMoveCurve(gift) {
      let start = {x: gift.x, y: gift.y};
      let end = {x: this.screenWidth / 2, y: this.screenHeight * 0.6};
      return new Spline2([
        start.x,
        start.y,
        start.x + 100,
        start.y + 150,
        end.x,
        end.y
      ]);
    }
    onGiftShowComplete(gift) {
      this.scene.fastForward.stop();
      gift.show();
      this.background.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN);
      this.background.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
        this.hideTopLeftLabel();
        this.hideLabelPopover();
        gift.once(LevelCompleteGiftEvent.EXPLODE_COMPLETE, this.showGiftRewards, this);
        gift.explode();
        this.scene.audio.play(GameSoundKey.FANCY_TAP);
        this.background.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.applyFastForward, this);
      });
    }
    showGiftRewards(gift) {
      this.scene.fastForward.stop();
      this.background.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN);
      this.giftRewards = this.addGiftRewards(gift);
      if (window.game.config.ads.rewarded) {
        this.rewardButtons.show(400);
        this.rewardButtons.extraRewardButton.once(ButtonEvent.RELEASE, this.showBonusRewardVideo, this);
        this.rewardButtons.claimButton.once(ButtonEvent.PRESS, this.claimGiftRewards, this);
      } else {
        this.showClaimRewardText(0);
        this.background.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.claimGiftRewards, this);
      }
    }
    addGiftRewards(gift) {
      let positions = this.getRewardPositions(gift);
      let rewards = gift.rewards.map((rewardData, index) => {
        let position = positions[index];
        let reward = new GiftReward(this.scene, rewardData.type, rewardData.num);
        reward.startFloat(index * 100);
        reward.alpha = 0;
        this.scene.tweens.add({
          targets: reward,
          duration: 150,
          ease: Phaser.Math.Easing.Cubic.Out,
          alpha: 1,
          onComplete: () => {
            reward.showParticles();
          }
        });
        reward.scale = 0.66;
        this.scene.tweens.add({
          targets: reward,
          duration: 800,
          ease: Phaser.Math.Easing.Elastic.Out,
          easeParams: [0.1, 0.45],
          scale: 1
        });
        reward.x = gift.x;
        reward.y = gift.y - 100;
        this.scene.tweens.add({
          targets: reward,
          duration: 1e3,
          ease: Phaser.Math.Easing.Elastic.Out,
          easeParams: [0.1, 0.55],
          x: position.x,
          y: position.y
        });
        this.add(reward);
        return reward;
      });
      this.bringToTop(gift);
      return rewards;
    }
    getRewardPositions(gift) {
      let center = {x: gift.x, y: gift.y - 260};
      let sideMargin = 210;
      return [
        {x: center.x - sideMargin, y: center.y + 30},
        center,
        {x: center.x + sideMargin, y: center.y + 30}
      ];
    }
    showBonusRewardVideo() {
      this.scene.game.gdSdk.showRewardedAd("Gameplay:LevelCompleteScreen:GiftBonusButton").then((success) => {
        if (!success) {
          return;
        }
        this.rewardButtons.hide();
        this.addBonusReward(200);
        this.showClaimRewardText(500);
        this.background.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.claimGiftRewards, this);
        this.scene.audio.play(GameSoundKey.WHEEL_REWARD, {volume: 0.5});
      });
    }
    addBonusReward(delay) {
      let rewardType = this.getBonusRewardType();
      let rewardNum = this.getBonusRewardsNum(rewardType);
      this.giftsManager.saveReward(rewardType, rewardNum);
      let bonusReward = new GiftReward(this.scene, rewardType, rewardNum);
      bonusReward.x = this.screenWidth / 2;
      bonusReward.y = this.giftRewards[1].y + 270;
      this.add(bonusReward);
      this.giftRewards.push(bonusReward);
      bonusReward.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: bonusReward,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1,
        onComplete: () => {
          bonusReward.startFloat(0);
          bonusReward.showParticles();
        }
      });
      bonusReward.scale = 0.5;
      this.scene.tweens.add({
        delay,
        targets: bonusReward,
        duration: 800,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
      let originalY = bonusReward.y;
      bonusReward.y = originalY + 50;
      this.scene.tweens.add({
        delay,
        targets: bonusReward,
        duration: 900,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.55],
        y: originalY
      });
    }
    getBonusRewardType() {
      let allTypes = WheelRewardUtils.getAllTypes();
      let existingTypes = this.giftRewards.map((reward) => reward.rewardType);
      let remainingTypes = without_default(allTypes, ...existingTypes);
      return Phaser.Math.RND.pick(remainingTypes);
    }
    getBonusRewardsNum(rewardType) {
      var _a;
      return (_a = window.game.config.video_rewards[rewardType]) != null ? _a : 1;
    }
    showClaimRewardText(delay) {
      this.claimRewardsText.revive();
      this.claimRewardsText.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.claimRewardsText,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.claimRewardsText.y = this.claimRewardsText.originalY + 30;
      this.scene.tweens.add({
        delay,
        targets: this.claimRewardsText,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        y: this.claimRewardsText.originalY
      });
      this.scene.tweens.add({
        delay,
        targets: this.claimRewardsText,
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.1,
        yoyo: true,
        repeat: -1
      });
    }
    claimGiftRewards() {
      this.rewardButtons.hide();
      this.hideClaimRewardsText();
      this.collectGiftRewards();
      this.scene.game.toasts.dismissAll();
      this.scene.audio.play(GameSoundKey.FANCY_TAP);
      this.scene.time.delayedCall(300, () => {
        this.gotoNextLevel();
      });
    }
    hideClaimRewardsText() {
      this.scene.tweens.killTweensOf(this.claimRewardsText);
      this.scene.tweens.add({
        targets: this.claimRewardsText,
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        y: "+=30",
        onComplete: () => {
          this.claimRewardsText.kill();
        }
      });
    }
    collectGiftRewards() {
      this.scene.tweens.add({
        targets: this.giftRewards,
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        y: "-=30"
      });
    }
    preUpdate(time, delta) {
      var _a;
      (_a = this.confetti) == null ? void 0 : _a.update(delta);
    }
    preDestroy() {
      this.scene.fastForward.stop();
      super.preDestroy();
    }
    destroy() {
      var _a;
      (_a = this.confetti) == null ? void 0 : _a.destroy();
      super.destroy();
    }
  };

  // src/scenes/gameplayGui/goalItems/GoalItem.ts
  var _GoalItem = class extends Phaser.GameObjects.Image {
    constructor(scene) {
      super(scene, 0, 0, "gameplay_gui", _GoalItem.FRAMES_MAP[GoalItemType.COOKIE_RED]);
    }
    setItemType(type, mod) {
      this.itemType = type;
      this.setFrame(this.getFrame(this.itemType, mod));
    }
    getFrame(itemType, itemMod) {
      let isCookie2 = _GoalItem.COOKIE_TYPES.includes(itemType);
      if (isCookie2) {
        return this.getCookieFrame(itemType, itemMod);
      }
      return _GoalItem.FRAMES_MAP[itemType];
    }
    getCookieFrame(itemType, itemMod) {
      let base = _GoalItem.FRAMES_MAP[itemType];
      switch (itemMod) {
        case CookiePowerup.VERTICAL_STRIPES:
          return base + "-Stripes-Vertical";
        case CookiePowerup.HORIZONTAL_STRIPES:
          return base + "-Stripes-Horizontal";
        case CookiePowerup.BOMB:
          return base + "-Bomb";
        default:
          return base;
      }
    }
  };
  var GoalItem = _GoalItem;
  GoalItem.COOKIE_TYPES = [
    GoalItemType.COOKIE_BLUE,
    GoalItemType.COOKIE_RED,
    GoalItemType.COOKIE_YELLOW,
    GoalItemType.COOKIE_PINK,
    GoalItemType.COOKIE_ORANGE,
    GoalItemType.COOKIE_PURPLE
  ];
  GoalItem.FRAMES_MAP = {
    [GoalItemType.LICORICE]: "goal_items/licorice/Cream-Choco",
    [GoalItemType.BISCUIT]: "goal_items/biscuits/biscuit",
    [GoalItemType.CANDY]: "goal_items/candy_bottle/candy",
    [GoalItemType.APPLE]: "goal_items/apples_platter/apple",
    [GoalItemType.DONUT]: "goal_items/donut_box/donut",
    [GoalItemType.DROP_ITEM]: "goal_items/drop_items/cookie",
    [GoalItemType.CHICK]: "goal_items/chick/chick",
    [GoalItemType.MARSHMALLOW_BLUE]: "goal_items/marshmallows/marshmallow_blue",
    [GoalItemType.MARSHMALLOW_RED]: "goal_items/marshmallows/marshmallow_red",
    [GoalItemType.MARSHMALLOW_PURPLE]: "goal_items/marshmallows/marshmallow_purple",
    [GoalItemType.MARSHMALLOW_PINK]: "goal_items/marshmallows/marshmallow_pink",
    [GoalItemType.MARSHMALLOW_YELLOW]: "goal_items/marshmallows/marshmallow_yellow",
    [GoalItemType.MARSHMALLOW_ORANGE]: "goal_items/marshmallows/marshmallow_orange",
    [GoalItemType.MARSHMALLOW_COMMON]: "goal_items/marshmallows/marshmallow_common",
    [GoalItemType.MARSHMALLOW_DOUBLE]: "goal_items/marshmallows/marshmallow_common",
    [GoalItemType.CHOCOLATE_BLUE]: "goal_items/chocolate/chocolate-blue",
    [GoalItemType.CHOCOLATE_RED]: "goal_items/chocolate/chocolate-red",
    [GoalItemType.CHOCOLATE_PURPLE]: "goal_items/chocolate/chocolate-purple",
    [GoalItemType.CHOCOLATE_PINK]: "goal_items/chocolate/chocolate-pink",
    [GoalItemType.CHOCOLATE_YELLOW]: "goal_items/chocolate/chocolate-yellow",
    [GoalItemType.CHOCOLATE_ORANGE]: "goal_items/chocolate/chocolate-orange",
    [GoalItemType.CHOCOLATE_COMMON]: "goal_items/chocolate/chocolate",
    [GoalItemType.CHOCOLATE_DOUBLE]: "goal_items/chocolate/chocolate",
    [GoalItemType.CHOCOLATE_TRIPLE]: "goal_items/chocolate/chocolate",
    [GoalItemType.COOKIE_BLUE]: "goal_items/cookies/Cube-Cookie-Blue",
    [GoalItemType.COOKIE_RED]: "goal_items/cookies/Circle-Cookie-Red",
    [GoalItemType.COOKIE_YELLOW]: "goal_items/cookies/Heart-Cookie-Yellow",
    [GoalItemType.COOKIE_PINK]: "goal_items/cookies/Moon-Cookie-Pink",
    [GoalItemType.COOKIE_ORANGE]: "goal_items/cookies/Polygon-Cookie-Orange",
    [GoalItemType.COOKIE_PURPLE]: "goal_items/cookies/Donut-Cookie-Purple",
    [GoalItemType.GUMMY_VERTICAL]: "goal_items/gummies/gummy_vertical",
    [GoalItemType.GUMMY_VERTICAL_LARGE]: "goal_items/gummies/gummy_vertical_large",
    [GoalItemType.GUMMY_HORIZONTAL]: "goal_items/gummies/gummy_horizontal",
    [GoalItemType.GUMMY_HORIZONTAL_LARGE]: "goal_items/gummies/gummy_horizontal_large"
  };

  // src/scenes/gameplay/items/common/GameItem.ts
  function isCookie(item) {
    return item.itemSuperType === ItemSuperType.COOKIE;
  }
  function isBiscuit(item) {
    return item.itemSuperType === ItemSuperType.BISCUIT;
  }
  function isGummy(item) {
    return item.itemSuperType === ItemSuperType.GUMMY;
  }
  function isSuperSphere(item) {
    return isCookie(item) && item.powerup === CookiePowerup.SUPER_SPHERE;
  }
  function isDropItem(item) {
    return item.itemSuperType === ItemSuperType.DROP_ITEM;
  }
  function isMarshmallow(item) {
    return item.itemSuperType === ItemSuperType.MARSHMALLOW;
  }
  var GameItemUtils = class {
    static toString(item) {
      return `${item.itemType} [${item.column}, ${item.row}]`;
    }
  };

  // src/scenes/gameplayGui/goalItems/GoalItemsFactory.ts
  var _GoalItemsFactory = class extends Phaser.Events.EventEmitter {
    constructor(scene) {
      super();
      this.scene = scene;
      this.gameplay = this.scene.gameplay;
      this.gameplayCamera = this.gameplay.camera;
      this.createPool();
    }
    createPool() {
      let config2 = {
        name: "goal_items",
        classType: GoalItem,
        createCallback: (item) => {
          item.setDepth(GameplayGuiDepth.GOAL_ITEMS);
          item.kill();
        }
      };
      this.pool = this.scene.add.group(config2);
      this.pool.createItems(20);
    }
    create(itemType, mod) {
      let goalItemType = findKey_default(_GoalItemsFactory.TYPES_MAP, (value) => value === itemType);
      let goalItem = this.pool.getFirstDead(true);
      goalItem.setItemType(goalItemType, mod);
      goalItem.angle = 0;
      goalItem.alpha = 1;
      goalItem.scale = 1;
      goalItem.revive();
      return goalItem;
    }
    createFrom(originalItem) {
      let originalPosition = this.getPosition(originalItem);
      let itemMod = isCookie(originalItem) ? originalItem.powerup : void 0;
      let goalItem = this.create(originalItem.itemType, itemMod);
      goalItem.x = originalPosition.x;
      goalItem.y = originalPosition.y;
      goalItem.angle = originalItem.angle;
      goalItem.scale = originalItem.scale * this.gameplayCamera.zoom;
      return goalItem;
    }
    getPosition(originalPosition) {
      return this.gameplayCamera.getWorldPositionXY(originalPosition.x, originalPosition.y);
    }
  };
  var GoalItemsFactory = _GoalItemsFactory;
  GoalItemsFactory.TYPES_MAP = {
    [GoalItemType.BISCUIT]: ItemType.BISCUIT,
    [GoalItemType.LICORICE]: ItemType.LICORICE_CHOCO,
    [GoalItemType.CANDY]: ItemType.CANDY_BOTTLE,
    [GoalItemType.APPLE]: ItemType.APPLES_PLATTER,
    [GoalItemType.DONUT]: ItemType.DONUT_BOX,
    [GoalItemType.DROP_ITEM]: ItemType.DROP_ITEM,
    [GoalItemType.CHICK]: ItemType.CHICK,
    [GoalItemType.MARSHMALLOW_BLUE]: ItemType.MARSHMALLOW_BLUE,
    [GoalItemType.MARSHMALLOW_RED]: ItemType.MARSHMALLOW_RED,
    [GoalItemType.MARSHMALLOW_PURPLE]: ItemType.MARSHMALLOW_PURPLE,
    [GoalItemType.MARSHMALLOW_PINK]: ItemType.MARSHMALLOW_PINK,
    [GoalItemType.MARSHMALLOW_YELLOW]: ItemType.MARSHMALLOW_YELLOW,
    [GoalItemType.MARSHMALLOW_ORANGE]: ItemType.MARSHMALLOW_ORANGE,
    [GoalItemType.MARSHMALLOW_COMMON]: ItemType.MARSHMALLOW_COMMON,
    [GoalItemType.MARSHMALLOW_DOUBLE]: ItemType.MARSHMALLOW_DOUBLE,
    [GoalItemType.CHOCOLATE_BLUE]: ItemType.CHOCOLATE_BLUE,
    [GoalItemType.CHOCOLATE_RED]: ItemType.CHOCOLATE_RED,
    [GoalItemType.CHOCOLATE_PURPLE]: ItemType.CHOCOLATE_PURPLE,
    [GoalItemType.CHOCOLATE_PINK]: ItemType.CHOCOLATE_PINK,
    [GoalItemType.CHOCOLATE_YELLOW]: ItemType.CHOCOLATE_YELLOW,
    [GoalItemType.CHOCOLATE_ORANGE]: ItemType.CHOCOLATE_ORANGE,
    [GoalItemType.CHOCOLATE_COMMON]: ItemType.CHOCOLATE_COMMON,
    [GoalItemType.CHOCOLATE_DOUBLE]: ItemType.CHOCOLATE_DOUBLE,
    [GoalItemType.CHOCOLATE_TRIPLE]: ItemType.CHOCOLATE_TRIPLE,
    [GoalItemType.COOKIE_BLUE]: ItemType.COOKIE_BLUE,
    [GoalItemType.COOKIE_RED]: ItemType.COOKIE_RED,
    [GoalItemType.COOKIE_YELLOW]: ItemType.COOKIE_YELLOW,
    [GoalItemType.COOKIE_PINK]: ItemType.COOKIE_PINK,
    [GoalItemType.COOKIE_ORANGE]: ItemType.COOKIE_ORANGE,
    [GoalItemType.COOKIE_PURPLE]: ItemType.COOKIE_PURPLE,
    [GoalItemType.GUMMY_HORIZONTAL]: ItemType.GUMMY_HORIZONTAL,
    [GoalItemType.GUMMY_HORIZONTAL_LARGE]: ItemType.GUMMY_HORIZONTAL_LARGE,
    [GoalItemType.GUMMY_VERTICAL]: ItemType.GUMMY_VERTICAL,
    [GoalItemType.GUMMY_VERTICAL_LARGE]: ItemType.GUMMY_VERTICAL_LARGE
  };

  // src/scenes/gameplayGui/goalItems/GoalItemsManager.ts
  var Spline3 = Phaser.Curves.Spline;
  var GoalItemsManagerEvent;
  (function(GoalItemsManagerEvent2) {
    GoalItemsManagerEvent2["GOAL_ITEM_ARRIVED"] = "__GOAL_ITEM_ARRIVED";
  })(GoalItemsManagerEvent || (GoalItemsManagerEvent = {}));
  var GoalItemsManager = class extends Phaser.Events.EventEmitter {
    constructor(scene) {
      super();
      this.scene = scene;
      this.activeItems = [];
      this.factory = new GoalItemsFactory(this.scene);
      this.goalsPanel = this.scene.topPanel.goalsPanel;
    }
    onItemRelease(item) {
      this.activeItems.push(item);
    }
    onItemArrive(item) {
      pull_default(this.activeItems, item);
      this.emit(GoalItemsManagerEvent.GOAL_ITEM_ARRIVED, item);
    }
    getActiveItemsNum() {
      return this.activeItems.length;
    }
    collectItem(originalItem) {
      let goalItem = this.factory.createFrom(originalItem);
      this.onItemRelease(goalItem);
      this.moveItemToPanel(goalItem);
      if (goalItem.itemType === GoalItemType.DROP_ITEM) {
        this.emitParticles(goalItem.x, goalItem.y);
      }
    }
    emitParticles(x, y) {
      this.scene.emitters.goalItemSparks.setPosition(x, y);
      this.scene.emitters.goalItemSparks.explode(8, x, y);
      this.scene.emitters.goalItemCircles.explode(1, x, y);
    }
    collectCandy(bottle) {
      let bottlePosition = this.factory.getPosition(bottle);
      let candy = this.factory.create(ItemType.CANDY_BOTTLE);
      candy.x = bottlePosition.x;
      candy.y = bottlePosition.y - 66 * this.scene.gameplay.camera.zoom;
      this.onItemRelease(candy);
      candy.alpha = 0;
      this.scene.tweens.add({
        targets: candy,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      candy.scale = 0;
      this.scene.tweens.add({
        targets: candy,
        duration: 800,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.4],
        scale: 1
      });
      let targetY = candy.y - Phaser.Math.RND.between(60, 80);
      this.scene.tweens.add({
        targets: candy,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        y: targetY,
        onStart: () => {
          this.emitParticles(candy.x, targetY);
        },
        onComplete: () => {
          this.moveItemToPanel(candy);
        }
      });
    }
    collectApple(platter, originalApple) {
      let position = this.factory.getPosition(originalApple.getWorldPosition());
      let apple = this.factory.create(ItemType.APPLES_PLATTER);
      apple.x = position.x;
      apple.y = position.y;
      this.onItemRelease(apple);
      this.scene.tweens.add({
        targets: apple,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1.25
      });
      this.scene.tweens.add({
        targets: apple,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        x: apple.x + Phaser.Math.RND.between(0, 10) * Phaser.Math.RND.sign(),
        y: apple.y + Phaser.Math.RND.between(25, 35),
        onComplete: () => {
          this.moveItemToPanel(apple);
        }
      });
    }
    collectDonut(originalDonut) {
      let position = this.factory.getPosition(originalDonut.getWorldPosition());
      let donut = this.factory.create(ItemType.DONUT_BOX);
      donut.x = position.x;
      donut.y = position.y;
      this.onItemRelease(donut);
      this.scene.tweens.add({
        targets: donut,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1.25
      });
      this.scene.tweens.add({
        targets: donut,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        y: donut.y - Phaser.Math.RND.between(25, 35),
        onComplete: () => {
          this.moveItemToPanel(donut);
        }
      });
    }
    collectGummy(originalGummy) {
      let position = this.factory.getPosition(originalGummy.getWorldPosition());
      let gummy = this.factory.createFrom(originalGummy);
      gummy.x = position.x;
      gummy.y = position.y;
      this.onItemRelease(gummy);
      if (originalGummy.isHorizontal()) {
        this.scene.tweens.add({
          targets: gummy,
          duration: 400,
          ease: Phaser.Math.Easing.Quadratic.Out,
          angle: 90
        });
      }
      this.scene.tweens.add({
        targets: gummy,
        duration: 500,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.5],
        scale: gummy.scale * 1.15,
        y: "-=24",
        onComplete: () => {
          this.moveItemToPanel(gummy);
        }
      });
    }
    moveItemToPanel(item) {
      let targetGoalType = GoalUtils.getGoalType(item.itemType);
      let targetView = this.goalsPanel.getViewByGoalType(targetGoalType);
      let targetViewWorldPosition = targetView.getWorldPosition();
      let curve = this.createMoveCurve(item, targetViewWorldPosition);
      let duration = Phaser.Math.Clamp(curve.getLength() * 1.25, 600, 900);
      let fadeOutDuration = 166;
      let fadeOutDelay = duration - fadeOutDuration;
      this.scene.tweens.add({
        targets: item,
        delay: fadeOutDelay,
        duration: fadeOutDuration,
        ease: Phaser.Math.Easing.Linear,
        alpha: 0,
        scale: 0.66
      });
      this.scene.tweens.add({
        targets: item,
        duration: 333,
        ease: Phaser.Math.Easing.Sine.InOut,
        angle: item.angle + Phaser.Math.RND.between(-22, 22),
        hold: 100,
        yoyo: true
      });
      this.scene.tweens.addCurveTween({
        curve,
        duration,
        target: item,
        onComplete: () => {
          targetView.decrementNum();
          item.kill();
          this.onItemArrive(item);
        }
      });
    }
    createMoveCurve(item, target) {
      let curvePoints = [
        item.x,
        item.y,
        item.x + Phaser.Math.RND.between(25, 50),
        item.y - Phaser.Math.RND.between(20, 40),
        target.x,
        target.y
      ];
      return new Spline3(curvePoints);
    }
  };

  // src/scenes/gameplayGui/GameplayGuiEmitters.ts
  var GameplayGuiEmitters = class {
    constructor(scene) {
      this.scene = scene;
      this.manager = this.scene.add.particles("gameplay_gui");
      this.manager.setDepth(GameplayGuiDepth.PARTICLES);
      this.isCanvasRenderer = this.scene.game.renderer.type === Phaser.CANVAS;
      this.createEmitters();
      this.addGoalItemEmitters();
      this.addChargeEmitters();
    }
    createEmitters() {
      this.powerupSparks = this.manager.createEmitter({
        speed: 200,
        frame: "particles/particle_star_01",
        lifespan: {min: 500, max: 800},
        rotate: {min: 0, max: 180},
        scale: {start: 1, end: 0.5},
        alpha: {start: 1, end: 0},
        on: false
      });
      this.powerupCircles = this.manager.createEmitter({
        frame: "particles/circle_fx_2",
        scale: {start: 0, end: 1.75, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        lifespan: 1800,
        on: false
      });
    }
    addGoalItemEmitters() {
      this.goalItemCircles = this.manager.createEmitter({
        frame: "particles/circle_fx_3",
        scale: {start: 0.6, end: 1.75, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        lifespan: 1800,
        on: false
      });
      this.goalItemSparks = this.manager.createEmitter(__spreadProps(__spreadValues({}, ParticleUtil.getCircleEdgeEmitZone(35)), {
        speed: 50,
        frame: "particles/particle_star_01",
        lifespan: {min: 500, max: 900},
        scale: {start: 1, end: 0.5},
        alpha: {start: 1, end: 0, ease: Ease.ExpoIn},
        on: false
      }));
    }
    createDummyEmitter() {
      return this.manager.createEmitter({
        maxParticles: 0,
        on: false,
        active: false,
        visible: false
      });
    }
    addChargeEmitters() {
      this.chargeEmitter = this.manager.createEmitter({
        frame: "particles/double_spheres_particle",
        frequency: 16,
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        scale: {start: 2, end: 0.1, ease: Ease.ExpoOut},
        lifespan: 2666,
        speed: 30,
        on: false
      });
    }
  };

  // src/scenes/gameplayGui/goalsScreen/GoalsPopup.ts
  var GoalsPopup = class extends Phaser.GameObjects.Container {
    constructor(scene, goals) {
      super(scene);
      this.name = "goals_popup";
      this.addBack();
      this.addGoals(goals);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "popups", "popups/goals_popup/Small Popup Background.png");
      this.add(this.back);
    }
    addGoals(goals) {
      let cellSize = 120;
      this.goals = this.scene.add.container(0, 0, this.createGoalViews(goals));
      this.goals.gridAlign({
        width: this.goals.length,
        cellWidth: cellSize,
        cellHeight: cellSize,
        position: Phaser.Display.Align.CENTER,
        x: cellSize / 2,
        y: cellSize / 2
      });
      this.goals.setSize(this.goals.length * cellSize, cellSize);
      this.goals.x = -this.goals.width / 2;
      this.goals.y = -this.goals.height / 2 - 6;
      this.add(this.goals);
    }
    createGoalViews(goals) {
      return goals.map((goal) => {
        return new GoalView2(this.scene, goal.type, goal.targetNum);
      });
    }
  };

  // src/scenes/gameplayGui/goalsScreen/GoalsScreen.ts
  var GoalsScreen = class extends PhaserScreen {
    constructor(scene, goalsConfig) {
      super(scene, {
        name: "goals_screen",
        backgroundKey: "popups",
        backgroundFrame: "popups/black_rect.png",
        backgroundAlpha: 0.85
      });
      this.addPopup(goalsConfig);
      this.addTitle();
    }
    addPopup(goalsConfig) {
      let goals = GoalUtils.createGoalsArray(goalsConfig);
      this.popup = new GoalsPopup(this.scene, goals);
      this.pin(this.popup, 0.5, 0.52);
      this.add(this.popup);
    }
    addTitle() {
      let titleBack = this.scene.add.image(0, 0, "popups", "popups/goals_popup/Headline Flag.png");
      let titleText = this.createTitleText();
      this.title = this.scene.add.container(0, 0, [titleBack, titleText]);
      this.add(this.title);
    }
    createTitleText() {
      let content = this.scene.texts.collect;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "40px",
        color: "#ffffff",
        align: "center",
        strokeThickness: 6,
        stroke: "#F66986"
      };
      let title = this.scene.add.text(0, 0, content, style);
      title.setOrigin(0.5, 0.5);
      title.scale = Math.min(1, 190 / title.width);
      title.y = -4;
      return title;
    }
    resize() {
      super.resize();
      this.alignTitle();
    }
    alignTitle() {
      this.title.x = this.screenWidth / 2;
      this.title.y = this.popup.y - this.popup.displayHeight / 2 - 130;
    }
    show() {
      this.emit(PhaserScreenEvent.SHOW, this);
      this.revive();
      this.showItems();
      this.scene.time.delayedCall(170, () => {
        this.scene.audio.play(GameSoundKey.WHOOSH_1, {volume: 0.44});
      });
      this.background.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.forceHide, this);
      this.hideTimerEvent = this.scene.time.delayedCall(2e3, () => {
        this.background.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.forceHide, this);
        this.hide();
      });
    }
    showItems() {
      let items = [this.title, this.popup];
      items.forEach((item, index) => {
        let delay = index * 100;
        item.alpha = 0;
        this.scene.tweens.add({
          delay,
          targets: item,
          duration: 150,
          ease: Phaser.Math.Easing.Cubic.Out,
          alpha: 1
        });
        item.scale = 0.75;
        this.scene.tweens.add({
          delay,
          targets: item,
          duration: 400,
          ease: Phaser.Math.Easing.Back.Out,
          scale: 1
        });
        let deltaY = 100;
        item.y += deltaY;
        this.scene.tweens.add({
          delay,
          targets: item,
          duration: 500,
          ease: Phaser.Math.Easing.Back.Out,
          y: item.y - deltaY
        });
      });
    }
    forceHide() {
      this.hideTimerEvent.remove();
      this.hide();
    }
    hide() {
      let items = [this.title, this.popup];
      this.scene.tweens.add({
        targets: items,
        duration: 300,
        ease: Phaser.Math.Easing.Expo.Out,
        y: "-=30",
        alpha: 0
      });
      this.scene.tweens.add({
        delay: 200,
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.emit(PhaserScreenEvent.HIDE_COMPLETE, this);
          this.destroy();
        }
      });
    }
  };

  // src/scenes/levelMap/settings/GraphicsQualityButton.ts
  var GraphicsQualityButton = class extends Phaser.GameObjects.Container {
    constructor(scene, props, parent) {
      super(scene);
      if (parent) {
        parent.add(this);
      } else {
        this.scene.add.existing(this);
      }
      this.props = props;
      this.addBack();
      this.addArrows();
      this.addTitle();
      this.addText();
      this.addArrowsClickCallbacks();
      this.setSize(this.back.displayWidth, this.back.displayHeight);
    }
    addBack() {
      let {key, frame} = this.props.back;
      this.back = this.scene.add.image(0, 0, key, frame);
      this.back.setInteractive();
      this.add(this.back);
    }
    addArrows() {
      let dx = 160;
      let y = 2;
      this.leftArrow = this.scene.add.button(this.props.leftArrow.key, this.props.leftArrow.frame, this);
      this.leftArrow.x = -dx;
      this.leftArrow.y = y;
      this.rightArrow = this.scene.add.button(this.props.rightArrow.key, this.props.rightArrow.frame, this);
      this.rightArrow.x = dx;
      this.rightArrow.y = y;
    }
    addTitle() {
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "30px",
        color: "#ffffff",
        align: "center",
        padding: {x: 0, y: 4}
      };
      this.title = this.scene.add.text(0, 0, this.props.title, style);
      this.title.setOrigin(0.5, 0.5);
      this.title.setStroke("#B52D43", 8);
      this.title.setShadow(0, 4, "rgba(0,0,0,0.15)", 0, true, false);
      this.title.y = this.back.top + 4;
      this.add(this.title);
    }
    addText() {
      let quality = this.scene.game.scaler.quality;
      let content = this.getGraphicsQualityName(quality);
      this.text = this.scene.add.text(0, 0, content, this.getTextStyle());
      this.text.setOrigin(0.5, 0.5);
      this.text.x = 6;
      this.text.y = -2;
      this.add(this.text);
    }
    getTextStyle() {
      return {
        color: "#FFFFFF",
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "45px",
        align: "center",
        padding: {
          x: 2,
          y: 6
        },
        shadow: {
          fill: true,
          blur: 0,
          offsetY: 3,
          color: "rgba(0,0,0,0.2)"
        }
      };
    }
    updateText(content) {
      this.scene.tweens.killTweensOf(this.text);
      this.scene.tweens.add({
        targets: this.text,
        duration: 66,
        ease: Phaser.Math.Easing.Linear,
        alpha: 0,
        onComplete: () => {
          this.text.setText(content);
          this.adjustTextSize();
          this.scene.tweens.add({
            targets: this.text,
            duration: 150,
            ease: Phaser.Math.Easing.Cubic.Out,
            alpha: 1
          });
        }
      });
    }
    adjustTextSize() {
      let left = this.leftArrow.right;
      let right = this.rightArrow.left;
      let width = right - left;
      let maxWidth = width * 0.9;
      this.text.scale = Math.min(1, maxWidth / this.text.width);
    }
    updateTitle(content) {
      this.title.setText(content);
    }
    disableArrowButtons() {
      this.leftArrow.disableInput();
      this.rightArrow.disableInput();
    }
    enableArrowButtons() {
      this.leftArrow.enableInput();
      this.rightArrow.enableInput();
    }
    addArrowsClickCallbacks() {
      this.leftArrow.on(ButtonEvent.PRESS, this.onArrowClick.bind(this, -1));
      this.rightArrow.on(ButtonEvent.PRESS, this.onArrowClick.bind(this, 1));
    }
    onArrowClick(direction) {
      let scaler = this.scene.game.scaler;
      let qualityOptions = GRAPHICS_QUALITY_OPTIONS;
      let currentIndex = qualityOptions.indexOf(scaler.quality);
      let newIndex = Phaser.Math.Wrap(currentIndex + direction, 0, qualityOptions.length);
      let newQuality = qualityOptions[newIndex];
      this.scene.game.store.saveValue(GameStoreKey.GRAPHICS_QUALITY, newQuality);
      this.scene.game.store.saveValue(GameStoreKey.GRAPHICS_QUALITY_MANUALLY, true);
      this.scene.game.scaler.setQuality(newQuality);
      this.updateText(this.getGraphicsQualityName(newQuality));
      this.disableArrowButtons();
      this.scene.time.delayedCall(300, () => {
        this.enableArrowButtons();
      });
    }
    getGraphicsQualityName(quality) {
      return this.scene.texts.graphics_quality[quality];
    }
    onLanguageChange() {
      let title = this.scene.texts.graphics_quality.title;
      let option = this.getGraphicsQualityName(this.scene.game.scaler.quality);
      this.updateTitle(title);
      this.updateText(option);
    }
  };

  // src/robowhale/phaser3/gameObjects/container/SwitchButton.ts
  var SwitchButtonEvent;
  (function(SwitchButtonEvent2) {
    SwitchButtonEvent2["ARROW_PRESS"] = "__ARROW_PRESS";
  })(SwitchButtonEvent || (SwitchButtonEvent = {}));
  var SwitchButton = class extends Phaser.GameObjects.Container {
    constructor(scene, parent) {
      super(scene);
      this.disableArrows = false;
      this.disableArrowsDuration = 0;
      if (parent) {
        parent.add(this);
      } else {
        this.scene.add.existing(this);
      }
    }
    addBack(options) {
      this.back = this.scene.add.image(0, 0, options.key, options.frame);
      this.add(this.back);
      if (options.interactive) {
        this.back.setInteractive();
      }
    }
    addArrows(options) {
      var _a, _b;
      if (typeof options.timeoutMs === "number") {
        this.disableArrows = true;
        this.disableArrowsDuration = options.timeoutMs;
      }
      this.leftArrow = this.scene.add.button(options.leftArrow.key, options.leftArrow.frame, this);
      this.leftArrow.x = -options.dx;
      this.leftArrow.y = (_a = options.dy) != null ? _a : 0;
      this.leftArrow.on(ButtonEvent.PRESS, this.onArrowClick, this);
      this.rightArrow = this.scene.add.button(options.rightArrow.key, options.rightArrow.frame, this);
      this.rightArrow.x = options.dx;
      this.rightArrow.y = (_b = options.dy) != null ? _b : 0;
      this.rightArrow.on(ButtonEvent.PRESS, this.onArrowClick, this);
    }
    onArrowClick(button) {
      let direction = button === this.leftArrow ? -1 : 1;
      this.emit(SwitchButtonEvent.ARROW_PRESS, this, direction);
      if (this.disableArrows) {
        this.disableArrowButtons();
        this.scene.time.delayedCall(this.disableArrowsDuration, () => {
          this.enableArrowButtons();
        });
      }
    }
    addTitle(options) {
      var _a, _b;
      this.title = this.scene.add.text(0, 0, options.content, options.style);
      this.title.setOrigin(0.5, 0.5);
      this.title.x = (_a = options.dx) != null ? _a : 0;
      this.title.y = this.back.top + ((_b = options.dy) != null ? _b : 0);
      this.add(this.title);
    }
    addText(options) {
      var _a, _b;
      this.text = this.scene.add.text(0, 0, options.content, options.style);
      this.text.setOrigin(0.5, 0.5);
      this.text.x = (_a = options.dx) != null ? _a : 0;
      this.text.y = (_b = options.dy) != null ? _b : 0;
      this.add(this.text);
    }
    updateText(content) {
      this.scene.tweens.killTweensOf(this.text);
      this.scene.tweens.add({
        targets: this.text,
        duration: 66,
        ease: Phaser.Math.Easing.Linear,
        alpha: 0,
        onComplete: () => {
          this.text.setText(content);
          this.adjustTextSize();
          this.scene.tweens.add({
            targets: this.text,
            duration: 150,
            ease: Phaser.Math.Easing.Cubic.Out,
            alpha: 1
          });
        }
      });
    }
    adjustTextSize() {
      let left = this.leftArrow.right;
      let right = this.rightArrow.left;
      let width = right - left;
      let maxWidth = width * 0.9;
      this.text.scale = Math.min(1, maxWidth / this.text.width);
    }
    autoSetSize() {
      this.setSize(this.back.displayWidth, this.back.displayHeight);
    }
    disableArrowButtons() {
      var _a, _b;
      (_a = this.leftArrow) == null ? void 0 : _a.disableInput();
      (_b = this.rightArrow) == null ? void 0 : _b.disableInput();
    }
    enableArrowButtons() {
      var _a, _b;
      (_a = this.leftArrow) == null ? void 0 : _a.enableInput();
      (_b = this.rightArrow) == null ? void 0 : _b.enableInput();
    }
  };

  // src/scenes/gameplayGui/pauseScreen/HintsButton.ts
  var HintsButton = class extends SwitchButton {
    constructor(scene, parent) {
      super(scene, parent);
      this.addBack({
        key: "gameplay_gui",
        frame: "pause_screen/button_graphics_quality",
        interactive: true
      });
      this.addArrows({
        leftArrow: {key: "gameplay_gui", frame: "pause_screen/arrow_left"},
        rightArrow: {key: "gameplay_gui", frame: "pause_screen/arrow_right"},
        timeoutMs: 200,
        dx: 160,
        dy: 2
      });
      this.addTitle({
        content: this.scene.game.texts.texts.hint_delay.title,
        dy: 4,
        style: {
          fontFamily: WebFonts.DEFAULT_FAMILY,
          fontStyle: WebFonts.DEFAULT_WEIGHT,
          fontSize: "30px",
          color: "#ffffff",
          align: "center",
          padding: {x: 0, y: 4},
          strokeThickness: 8,
          stroke: "#9C1A2B",
          shadow: {
            color: "rgba(0,0,0,0.15)",
            blur: 0,
            offsetY: 4,
            fill: false,
            stroke: true
          }
        }
      });
      this.addText({
        content: "2s",
        style: {
          fontFamily: WebFonts.DEFAULT_FAMILY,
          fontStyle: WebFonts.DEFAULT_WEIGHT,
          fontSize: "45px",
          color: "#FFFFFF",
          align: "center",
          padding: {x: 2, y: 6},
          shadow: {
            fill: true,
            blur: 0,
            offsetY: 3,
            color: "rgba(0,0,0,0.2)"
          }
        }
      });
      this.autoSetSize();
    }
  };

  // src/scenes/gameplayGui/pauseScreen/PauseScreen.ts
  var PauseScreenEvent;
  (function(PauseScreenEvent2) {
    PauseScreenEvent2["CLOSE"] = "__CLOSE";
  })(PauseScreenEvent || (PauseScreenEvent = {}));
  var PauseScreen = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "pause_screen",
        backgroundAlpha: 0.9,
        backgroundKey: "gameplay_gui",
        backgroundFrame: "black_rect"
      });
      this.ignoreBackgroundClicks = false;
      this.addCentralButtons();
      this.addFeebackButton();
      this.addWidgetButton();
      this.addResumeText();
    }
    addCentralButtons() {
      let dx = 180;
      let dy = 180;
      this.graphicsQualityButton = this.createGraphicsQualityButton();
      this.graphicsQualityButton.title.setStroke("#9C1A2B", 8);
      this.graphicsQualityButton.title.y -= 2;
      this.graphicsQualityButton.y = -dy;
      this.hintsButton = new HintsButton(this.scene, this);
      this.hintsButton.y = this.graphicsQualityButton.y + dy;
      this.soundButton = this.scene.add.soundButton("gameplay_gui", "pause_screen/button_sound_on", "pause_screen/button_sound_off");
      this.soundButton.x = -dx;
      this.soundButton.y = dy;
      this.musicButton = this.scene.add.musicButton("gameplay_gui", "pause_screen/button_music_on", "pause_screen/button_music_off");
      this.musicButton.y = dy;
      this.quitButton = new ComplexButton(this.scene, "gameplay_gui", "pause_screen/button_quit");
      this.quitButton.addIcon("gameplay_gui", "pause_screen/broken_heart_icon", 50, -50);
      this.quitButton.x = dx;
      this.quitButton.y = dy;
      this.buttons = [this.graphicsQualityButton, this.hintsButton, this.soundButton, this.musicButton, this.quitButton];
      this.buttonsContainer = this.scene.add.container(0, 0, this.buttons);
      this.add(this.buttonsContainer);
      this.pin(this.buttonsContainer, 0.5, 0.5);
    }
    createGraphicsQualityButton() {
      let props = {
        back: {key: "gameplay_gui", frame: "pause_screen/button_graphics_quality"},
        leftArrow: {key: "gameplay_gui", frame: "pause_screen/arrow_left"},
        rightArrow: {key: "gameplay_gui", frame: "pause_screen/arrow_right"},
        title: this.scene.texts.graphics_quality.title
      };
      return new GraphicsQualityButton(this.scene, props);
    }
    addFeebackButton() {
      if (window.game.config.feedback_enabled === false) {
        return;
      }
      let completeLevelsNum = this.scene.game.store.getCompletedLevelNumbers().length;
      if (completeLevelsNum < 3) {
        return;
      }
      this.feedbackButton = this.scene.add.button("gameplay_gui", "pause_screen/button_feedback", this);
      this.feedbackButton.on(ButtonEvent.RELEASE, this.onFeedbackButtonClick, this);
      this.add(this.feedbackButton);
      this.pin(this.feedbackButton, 1, 1, -75, -75);
    }
    onFeedbackButtonClick() {
      this.scene.game.feedbackWidget.show();
    }
    addWidgetButton() {
      let config2 = window.game.config.widget_button.pause_screen;
      if (config2.enabled === false) {
        return;
      }
      this.widgetButton = this.scene.add.button("gameplay_gui", config2.frame, this);
      this.widgetButton.on(ButtonEvent.RELEASE, this.onWidgetButtonClick, this);
      this.add(this.widgetButton);
      this.pin(this.widgetButton, 1, 1);
    }
    onWidgetButtonClick() {
    }
    addResumeText() {
      let content = this.scene.texts.tap_to_continue;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "36px",
        color: "#ffffff",
        align: "center",
        padding: {x: 30, y: 10}
      };
      this.resumeText = this.scene.add.text(0, 0, content, style);
      this.resumeText.setOrigin(0.5, 0.5);
      this.resumeText.setWordWrapWidth(350, true);
      this.resumeText.setLineSpacing(-5);
      this.resumeText.setInteractive();
      this.resumeText.input.cursor = "pointer";
      this.resumeText.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onResumeTextClick, this);
      this.pin(this.resumeText, 0.5, 1, 0, -75);
      this.add(this.resumeText);
    }
    onResumeTextClick() {
      this.scene.audio.playClick();
    }
    resize() {
      super.resize();
    }
    show() {
      this.emit(PhaserScreenEvent.SHOW, this);
      this.alpha = 1;
      this.revive();
      this.showBackground();
      this.showCentralButtons();
      this.showResumeText(100);
      this.showFeedbackButton(200);
      this.showWidgetButton(200);
      this.resumeText.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.close, this);
      this.background.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onBackgroundClick, this);
    }
    showCentralButtons() {
      this.scene.tweens.killTweensOf(this.buttonsContainer);
      this.buttonsContainer.alpha = 0;
      this.scene.tweens.add({
        targets: this.buttonsContainer,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.buttonsContainer.scale = 0.8;
      this.scene.tweens.add({
        targets: this.buttonsContainer,
        duration: 1e3,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
    }
    showResumeText(delay) {
      this.resumeText.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.resumeText,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.resumeText.scale = 0.8;
      this.scene.tweens.add({
        delay,
        targets: this.resumeText,
        duration: 1e3,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
    }
    showFeedbackButton(delay) {
      if (!this.feedbackButton) {
        return;
      }
      this.feedbackButton.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.feedbackButton,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.feedbackButton.scale = 0.8;
      this.scene.tweens.add({
        delay,
        targets: this.feedbackButton,
        duration: 1e3,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
    }
    showWidgetButton(delay) {
      if (!this.widgetButton) {
        return;
      }
      this.widgetButton.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.widgetButton,
        alpha: {value: 1, ease: Phaser.Math.Easing.Cubic.Out, duration: 200}
      });
      this.widgetButton.scale = 0.85;
      this.scene.tweens.add({
        delay,
        targets: this.widgetButton,
        duration: 1e3,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
    }
    close() {
      this.emit(PauseScreenEvent.CLOSE, this);
      this.background.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.close, this);
      this.resumeText.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.close, this);
    }
    hide() {
      this.emitHideStartEvent();
      this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.kill();
          this.emitHideCompleteEvent();
        }
      });
    }
    onBackgroundClick() {
      if (this.ignoreBackgroundClicks) {
        return;
      }
      this.background.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onBackgroundClick, this);
      this.close();
    }
    activate() {
      var _a, _b;
      this.buttonsContainer.revive();
      this.resumeText.revive();
      (_a = this.feedbackButton) == null ? void 0 : _a.revive();
      (_b = this.widgetButton) == null ? void 0 : _b.revive();
    }
    deactivate() {
      var _a, _b;
      this.buttonsContainer.kill();
      this.resumeText.kill();
      (_a = this.feedbackButton) == null ? void 0 : _a.kill();
      (_b = this.widgetButton) == null ? void 0 : _b.kill();
    }
  };

  // src/scenes/gameplayGui/levelPreComplete/BonusCoinsPopover.ts
  var BonusCoinsPopover = class extends Phaser.GameObjects.Container {
    constructor(scene, backTexture, backFrame) {
      super(scene);
      this.coinsNum = 0;
      this.name = "popover";
      this.addBack(backTexture, backFrame);
      this.addCoin();
      this.addText();
      this.addParticles();
      this.setSize(this.back.displayWidth, this.back.displayHeight);
    }
    addBack(backTexture, backFrame) {
      this.back = this.scene.add.image(0, 0, backTexture, backFrame);
      this.add(this.back);
    }
    addCoin() {
      this.coin = this.scene.add.image(0, 0, "gameplay_gui", "top_panel/bonus_coin");
      this.coin.x = -30;
      this.coin.y = this.back.top + 56;
      this.add(this.coin);
    }
    addText() {
      let content = "0";
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "32px",
        color: "#B35F44",
        align: "center"
      };
      this.text = this.scene.add.text(0, 0, content, style);
      this.text.setOrigin(1, 0.5);
      this.text.y = this.coin.y;
      this.add(this.text);
    }
    addParticles() {
      this.particles = this.scene.add.particles("gameplay_gui");
      this.add(this.particles);
      this.circles = this.particles.createEmitter({
        frame: "particles/circle_fx_3",
        scale: {start: 0.6, end: 1.33, ease: Ease.ExpoOut},
        alpha: {start: 0.66, end: 0, ease: Ease.ExpoOut},
        lifespan: 1500,
        on: false
      });
    }
    alignContent(coinsNum) {
      let oldValue = this.text.text;
      this.text.text = coinsNum.toString();
      let gap = 13;
      let contentWidth = this.coin.width + this.text.width + gap;
      let offset = (this.back.displayWidth - contentWidth) / 2;
      this.coin.x = this.back.left + offset + this.coin.displayWidth / 2;
      this.text.x = this.back.right - offset;
      this.text.originalX = this.text.x;
      this.text.text = oldValue;
    }
    onCoinArrive(coinValue) {
      this.coinsNum += coinValue;
      this.text.text = this.coinsNum.toFixed(0);
      this.scene.gameplay.sounds.coinAdd();
      this.circles.emitParticle(1, this.coin.x, this.coin.y);
    }
    playBulgeAnimation(delay) {
      this.scene.tweens.add({
        delay,
        targets: this,
        duration: 233,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.2,
        yoyo: true
      });
      this.scene.tweens.add({
        delay: delay + 100,
        targets: this.coin,
        duration: 233,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.15,
        yoyo: true
      });
      this.scene.tweens.add({
        delay: delay + 100,
        targets: this.text,
        duration: 233,
        ease: Phaser.Math.Easing.Sine.InOut,
        x: this.text.originalX + 8,
        yoyo: true
      });
    }
  };

  // src/scenes/gameplayGui/levelPreComplete/PowerupCoinsCollector.ts
  var Spline4 = Phaser.Curves.Spline;
  var PowerupCoinsCollectorEvent;
  (function(PowerupCoinsCollectorEvent2) {
    PowerupCoinsCollectorEvent2["COMPLETE"] = "__COMPLETE";
  })(PowerupCoinsCollectorEvent || (PowerupCoinsCollectorEvent = {}));
  var PowerupCoinsCollector = class extends Phaser.Events.EventEmitter {
    constructor(scene, screen2, bonusCoinsPopover) {
      super();
      this.coinsNum = 0;
      this.coinValue = 0;
      this.isHidden = false;
      this.scene = scene;
      this.screen = screen2;
      this.bonusCoinsPopover = bonusCoinsPopover;
      this.addParticles();
      this.coins = [];
    }
    addParticles() {
      this.particles = this.scene.add.particles("gameplay_gui");
      this.screen.add(this.particles);
      this.circlesEmitter = this.particles.createEmitter({
        frame: "particles/circle_fx_3",
        scale: {start: 0.6, end: 1.75, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        lifespan: 1600,
        on: false
      });
    }
    collect(totalValue) {
      let powerups = this.scene.gameplay.items.mainItems.filter((item) => isCookie(item) && item.hasPowerup());
      if (powerups.length === 0) {
        this.onAllCoinsCollected();
        return;
      }
      this.coinsNum = powerups.length;
      this.coinValue = totalValue / this.coinsNum;
      let completeCallback = after_default(powerups.length, () => {
        this.onAllCoinsCollected();
      });
      powerups.forEach((cookie, index) => {
        let delay = index * 66;
        this.scene.time.delayedCall(delay, () => {
          this.convertPowerupToCoin(cookie, completeCallback);
        });
      });
    }
    convertPowerupToCoin(cookie, completeCallback) {
      if (this.isHidden) {
        return;
      }
      this.scene.tweens.add({
        targets: cookie,
        duration: 300,
        ease: Phaser.Math.Easing.Back.In,
        alpha: 0,
        scale: 0,
        onComplete: () => {
          if (this.isHidden) {
            return;
          }
          cookie.kill();
          let {column, row, itemType} = cookie;
          let gameplay = this.scene.gameplay;
          let newCookie = gameplay.itemsFactory.cookiesPool.getCookie(null);
          newCookie.setItemType(itemType);
          newCookie.column = column;
          newCookie.row = row;
          newCookie.alignToGrid();
          newCookie.revive();
          newCookie.alpha = 0;
          this.scene.tweens.add({
            targets: newCookie,
            duration: 150,
            ease: Phaser.Math.Easing.Cubic.Out,
            alpha: 1
          });
          newCookie.scale = 0.66;
          this.scene.tweens.add({
            targets: newCookie,
            duration: 300,
            ease: Phaser.Math.Easing.Back.Out,
            scale: 1
          });
          let globalPosition = this.scene.gameplay.camera.getWorldPositionXY(cookie.x, cookie.y);
          let position = this.screen.pointToContainer(globalPosition);
          let coin = this.scene.add.image(0, 0, "gameplay_gui", "top_panel/bonus_coin_big");
          coin.x = position.x;
          coin.y = position.y;
          this.coins.push(coin);
          this.screen.add(coin);
          this.circlesEmitter.emitParticle(2, coin.x, coin.y);
          coin.alpha = 0;
          this.scene.tweens.add({
            targets: coin,
            duration: 150,
            ease: Phaser.Math.Easing.Cubic.Out,
            alpha: 1
          });
          coin.scale = 0.66;
          this.scene.tweens.add({
            targets: coin,
            duration: 400,
            ease: Phaser.Math.Easing.Back.Out,
            scale: 1
          });
          this.scene.tweens.add({
            targets: coin,
            duration: 400,
            ease: Phaser.Math.Easing.Back.Out,
            y: "-=60",
            onComplete: () => {
              this.moveCoinToPopover(coin, completeCallback);
            }
          });
          this.scene.audio.play(GameSoundKey.TWINKLE_1, {volume: 0.4});
        }
      });
    }
    moveCoinToPopover(coin, completeCallback) {
      let curve = this.createPowerupCoinCurve(coin, this.bonusCoinsPopover);
      let duration = Math.max(600, curve.getLength() * 1.1);
      this.scene.tweens.add({
        targets: coin,
        duration,
        ease: Phaser.Math.Easing.Cubic.In,
        scale: 0.71
      });
      this.scene.tweens.addCurveTween({
        curve,
        duration,
        target: coin,
        onComplete: () => {
          this.bonusCoinsPopover.onCoinArrive(this.coinValue);
          pull_default(this.coins, coin);
          coin.destroy();
          completeCallback();
        }
      });
    }
    createPowerupCoinCurve(coin, bonusCoinsPopover) {
      let start = {x: coin.x, y: coin.y};
      let end = {
        x: bonusCoinsPopover.x + bonusCoinsPopover.coin.x,
        y: bonusCoinsPopover.y + bonusCoinsPopover.coin.y
      };
      let dx = Math.abs(end.x - start.x);
      let midX = start.x + dx * 0.5;
      return new Spline4([
        start.x,
        start.y,
        midX,
        start.y + 50,
        end.x,
        end.y
      ]);
    }
    onAllCoinsCollected() {
      if (this.coinsNum === 0) {
        this.emitCompleteEvent({delay: 300});
      } else {
        this.bonusCoinsPopover.playBulgeAnimation(0);
        this.emitCompleteEvent({delay: 850});
      }
    }
    emitCompleteEvent(options) {
      this.scene.time.delayedCall(options.delay, () => {
        this.emit(PowerupCoinsCollectorEvent.COMPLETE, this);
      });
    }
    hide() {
      this.isHidden = true;
      this.circlesEmitter.killAll();
      this.coins.forEach((coin) => {
        this.scene.tweens.killTweensOf(coin);
        this.scene.tweens.add({
          targets: coin,
          duration: 150,
          ease: Phaser.Math.Easing.Cubic.Out,
          alpha: 0,
          onComplete: () => {
            coin.destroy();
          }
        });
      });
    }
  };

  // src/scenes/gameplayGui/levelPreComplete/MoveCoinsCollector.ts
  var MoveCoinsCollectorEvent;
  (function(MoveCoinsCollectorEvent2) {
    MoveCoinsCollectorEvent2["COMPLETE"] = "__COMPLETE";
  })(MoveCoinsCollectorEvent || (MoveCoinsCollectorEvent = {}));
  var MoveCoinsCollector = class extends Phaser.Events.EventEmitter {
    constructor(scene, screen2, bonusCoinsPopover) {
      super();
      this.coinsNum = 0;
      this.coinValue = 0;
      this.scene = scene;
      this.screen = screen2;
      this.bonusCoinsPopover = bonusCoinsPopover;
      this.addParticles();
    }
    addParticles() {
      this.particles = this.scene.add.particles("gameplay_gui");
      this.screen.add(this.particles);
      this.coinsEmitter = this.particles.createEmitter({
        moveToX: 1,
        moveToY: 1,
        frame: "top_panel/bonus_coin",
        lifespan: 300,
        alpha: {start: 0, end: 1, ease: Ease.ExpoOut},
        scale: {start: 0, end: 1, ease: Ease.CubicOut},
        on: false
      });
    }
    collect(totalValue) {
      this.coinsNum = Math.round(totalValue / 10);
      this.coinValue = totalValue / this.coinsNum;
      this.emitCoinParticles(this.coinsNum);
    }
    emitCoinParticles(particlesNum) {
      let {x, y} = this.getCollectPosition();
      let onComplete = after_default(particlesNum, this.onAllCoinsCollected.bind(this));
      this.coinsEmitter.moveToX.propertyValue = x;
      this.coinsEmitter.moveToY.propertyValue = y;
      this.coinsEmitter.onParticleDeath(() => {
        this.bonusCoinsPopover.onCoinArrive(this.coinValue);
        onComplete();
      });
      this.timerEvent = this.scene.time.addEvent({
        delay: 66,
        startAt: 66,
        repeat: particlesNum - 1,
        callback: () => {
          this.coinsEmitter.emitParticle(1, this.bonusCoinsPopover.x, y - 90);
        }
      });
    }
    getCollectPosition() {
      let {x, y} = this.bonusCoinsPopover;
      x += this.bonusCoinsPopover.coin.x;
      y += this.bonusCoinsPopover.coin.y;
      return {x, y};
    }
    onAllCoinsCollected() {
      if (this.coinsNum === 0) {
        this.emitCompleteEvent({delay: 300});
      } else {
        this.bonusCoinsPopover.playBulgeAnimation(0);
        this.emitCompleteEvent({delay: 500});
      }
    }
    emitCompleteEvent(options) {
      this.scene.time.delayedCall(options.delay, () => {
        this.emit(MoveCoinsCollectorEvent.COMPLETE, this);
      });
    }
    hide() {
      var _a;
      this.coinsEmitter.killAll();
      (_a = this.timerEvent) == null ? void 0 : _a.remove();
    }
  };

  // src/scenes/gameplayGui/levelPreComplete/LevelPreCompleteScreen.ts
  var LevelPreCompleteScreen = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "precomplete_screen",
        backgroundKey: "gameplay_gui",
        backgroundFrame: "black_rect",
        backgroundAlpha: 1e-3
      });
      this.forceHide = false;
      this.addParticles();
      this.addCompleteText();
      this.addContinueText();
      this.addBonusCoinsPopover();
      this.moveCoinsCollector = new MoveCoinsCollector(this.scene, this, this.coinsPopover);
      this.powerupCoinsCollector = new PowerupCoinsCollector(this.scene, this, this.coinsPopover);
    }
    addParticles() {
      this.particles = this.scene.add.particles("gameplay_gui");
      this.pin(this.particles, 0.5, 0.5);
      this.add(this.particles);
      this.circlesEmitter = this.particles.createEmitter({
        frame: "particles/circle_fx_2",
        scale: {start: 0.4, end: 3, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.CubicOut},
        lifespan: 2e3,
        on: false
      });
      this.sparksEmitter = this.particles.createEmitter({
        frame: "particles/double_spheres_particle",
        lifespan: 3e3,
        speed: {min: 10, max: 1200},
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        scale: {start: 1.33, end: 0},
        emitZone: {
          source: new Phaser.Geom.Circle(0, 0, 100),
          type: "random"
        },
        on: false
      });
    }
    addCompleteText() {
      let content = this.scene.texts.level_complete.toUpperCase();
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "74px",
        color: "#FFDFAD",
        align: "center",
        stroke: "#8C463B",
        strokeThickness: 14
      };
      this.completeText = this.scene.add.text(0, 0, content, style);
      this.completeText.setOrigin(0.5, 0.5);
      this.completeText.setShadow(0, 6, "rgba(0,0,0,0.25)", 0, true, false);
      this.completeText.setWordWrapWidth(400);
      this.completeText.setLineSpacing(-12);
      this.add(this.completeText);
      this.pin(this.completeText, 0.5, 0.5);
    }
    addContinueText() {
      let content = this.scene.texts.tap_to_skip;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "36px",
        color: "#FFDFAD",
        align: "center",
        stroke: "#8C463B",
        strokeThickness: 5,
        padding: {x: 4, y: 10}
      };
      this.continueText = this.scene.add.text(0, 0, content, style);
      this.continueText.setOrigin(0.5, 0.5);
      this.continueText.setShadow(0, 2, "#703A35", 0, true, false);
      this.continueText.originalY = 0;
      this.continueText.kill();
      this.add(this.continueText);
      this.pin(this.continueText, 0.5, 0.9);
    }
    addBonusCoinsPopover() {
      this.coinsPopover = new BonusCoinsPopover(this.scene, "gameplay_gui", "top_panel/bonus_coins_popover");
      this.add(this.coinsPopover);
    }
    resize() {
      super.resize();
      this.alignBonusCoinsPopover();
    }
    alignBonusCoinsPopover() {
      let topPanel = this.scene.topPanel;
      let movesLabel = topPanel.movesLabel;
      let globalPosition = movesLabel.getWorldPosition();
      let localPosition = this.pointToContainer(globalPosition);
      this.coinsPopover.x = localPosition.x;
      this.coinsPopover.y = 124;
    }
    updateData(data) {
      this._data = data;
    }
    show() {
      var _a, _b;
      (_a = this.scene.audio.play(GameSoundKey.LEVEL_PRE_COMPLETE)) == null ? void 0 : _a.fade(0, 1, 500);
      (_b = this.scene.audio.play(GameSoundKey.LEVEL_PRE_COMPLETE_MUSIC)) == null ? void 0 : _b.fade(0, 1, 1200);
      this.scene.audio.fadeOutMusicLoop(100);
      this.revive();
      this.showCompleteText(100);
      this.showParticles(100);
      this.coinsPopover.kill();
      this.hideTimerEvent = this.scene.time.delayedCall(1400, () => {
        this.hideCompleteText(() => {
          this.onCompleteTextHideComplete();
        });
      });
      this.scene.time.delayedCall(600, () => {
        this.showContinueText();
        this.background.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
          var _a2;
          (_a2 = this.hideTimerEvent) == null ? void 0 : _a2.remove();
          this.forceHide = true;
          this.hide();
        });
      });
    }
    showCompleteText(delay) {
      this.completeText.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.completeText,
        duration: 350,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 1
      });
      this.completeText.scale = 0.66;
      this.scene.tweens.add({
        delay,
        targets: this.completeText,
        duration: 900,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.6],
        scale: 1
      });
      this.scene.tweens.add({
        delay,
        targets: this.completeText,
        duration: 800,
        ease: Phaser.Math.Easing.Sine.InOut,
        y: "-=10",
        yoyo: true,
        repeat: -1
      });
    }
    showParticles(delay) {
      this.scene.time.delayedCall(delay, () => {
        this.circlesEmitter.explode(1, 0, 0);
        this.sparksEmitter.explode(100, 0, 0);
      });
    }
    showContinueText() {
      this.continueText.revive();
      this.continueText.alpha = 0;
      this.continueText.y = this.continueText.originalY + 10;
      this.scene.tweens.add({
        targets: this.continueText,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1,
        y: this.continueText.originalY
      });
      this.scene.tweens.add({
        targets: this.continueText,
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.1,
        yoyo: true,
        repeat: -1
      });
    }
    hideCompleteText(onComplete) {
      this.scene.tweens.killTweensOf(this.completeText);
      this.scene.tweens.add({
        targets: this.completeText,
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        y: "-=30",
        onComplete: () => {
          this.completeText.kill();
          if (onComplete) {
            onComplete();
          }
        }
      });
    }
    onCompleteTextHideComplete() {
      if (this.forceHide) {
        return;
      }
      if (this._data.powerupCoins === 0 && this._data.moveCoins === 0) {
        this.hide();
        return;
      }
      this.showCoinsPopover(0);
    }
    showCoinsPopover(delay) {
      this.coinsPopover.revive();
      this.coinsPopover.alignContent(this._data.moveCoins + this._data.powerupCoins);
      this.coinsPopover.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.coinsPopover,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.coinsPopover.scale = 0.66;
      this.scene.tweens.add({
        delay,
        targets: this.coinsPopover,
        duration: 800,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.5],
        scale: 1
      });
      if (this._data.moveCoins > 0) {
        this.collectMoveCoins(delay + 100);
      } else {
        this.collectPowerupCoins(delay + 100);
      }
    }
    collectMoveCoins(delay) {
      this.scene.time.delayedCall(delay, () => {
        this.moveCoinsCollector.once(MoveCoinsCollectorEvent.COMPLETE, this.collectPowerupCoins.bind(this, 0));
        this.moveCoinsCollector.collect(this._data.moveCoins);
      });
    }
    collectPowerupCoins(delay) {
      this.scene.time.delayedCall(delay, () => {
        this.powerupCoinsCollector.once(PowerupCoinsCollectorEvent.COMPLETE, this.onPowerupCoinsCollected, this);
        this.powerupCoinsCollector.collect(this._data.powerupCoins);
      });
    }
    onPowerupCoinsCollected() {
      this.hide();
    }
    hide() {
      var _a;
      this.emitHideStartEvent();
      (_a = this.scene.audio.get(GameSoundKey.LEVEL_PRE_COMPLETE_MUSIC)) == null ? void 0 : _a.fade(1, 0, 1e3);
      this.background.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN);
      this.moveCoinsCollector.off(MoveCoinsCollectorEvent.COMPLETE);
      this.moveCoinsCollector.hide();
      this.powerupCoinsCollector.off(PowerupCoinsCollectorEvent.COMPLETE);
      this.powerupCoinsCollector.hide();
      if (this.completeText.visible) {
        this.hideCompleteText();
      }
      this.hideContinueText();
      this.hideBonusCoinsPopover();
      this.scene.time.delayedCall(300, () => {
        this.kill();
        this.emitHideCompleteEvent();
      });
    }
    hideContinueText() {
      this.scene.tweens.killTweensOf(this.continueText);
      this.scene.tweens.add({
        targets: this.continueText,
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        y: "+=30",
        onComplete: () => {
          this.continueText.kill();
        }
      });
    }
    hideBonusCoinsPopover() {
      this.scene.tweens.killTweensOf(this.coinsPopover);
      this.scene.tweens.add({
        targets: this.coinsPopover,
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        y: "+=30",
        onComplete: () => {
          this.coinsPopover.kill();
        }
      });
    }
    preDestroy() {
      this.scene.audio.stop(GameSoundKey.LEVEL_PRE_COMPLETE_MUSIC);
      super.preDestroy();
    }
  };

  // src/scenes/gameplayGui/MovesWarning.ts
  var MovesWarning = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.movesNum = 5;
      this.showTimestamp = 0;
      this.name = "moves_warning";
      this.addMovesNumText();
      this.addSubtitle();
      this.setSize(this.movesNumText.width, this.movesNumText.height);
    }
    addMovesNumText() {
      let content = this.movesNum.toString();
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "130px",
        color: "#FFDFAD",
        align: "center",
        stroke: "#8C463B",
        strokeThickness: 14
      };
      this.movesNumText = this.scene.add.text(0, 0, content, style);
      this.movesNumText.setOrigin(0.5, 0.5);
      this.movesNumText.setShadow(0, 6, "rgba(0,0,0,0.25)", 0, true, false);
      this.movesNumText.originalY = this.movesNumText.y;
      this.add(this.movesNumText);
    }
    addSubtitle() {
      let content = this.scene.texts.moves;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "60px",
        color: "#FFDFAD",
        align: "center",
        stroke: "#8C463B",
        strokeThickness: 14
      };
      this.subtitle = this.scene.add.text(0, 0, content, style);
      this.subtitle.setOrigin(0.5, 0.5);
      this.subtitle.setShadow(0, 6, "rgba(0,0,0,0.25)", 0, true, false);
      this.subtitle.y = this.movesNumText.y + 90;
      this.subtitle.originalY = this.subtitle.y;
      this.add(this.subtitle);
    }
    show() {
      this.revive();
      this.showItems();
      this.showTimestamp = Date.now();
      this.scene.input.on(Phaser.Input.Events.POINTER_DOWN, this.hide, this);
      this.hideTimerEvent = this.scene.time.delayedCall(2e3, () => {
        this.hide();
      });
    }
    showItems() {
      let items = [this.movesNumText, this.subtitle];
      items.forEach((item, index) => {
        let delay = index * 100;
        item.alpha = 0;
        this.scene.tweens.add({
          delay,
          targets: item,
          duration: 150,
          ease: Phaser.Math.Easing.Cubic.Out,
          alpha: 1
        });
        let deltaY = 30;
        item.y = item.originalY + deltaY;
        this.scene.tweens.add({
          delay,
          targets: item,
          duration: 400,
          ease: Phaser.Math.Easing.Back.Out,
          y: item.originalY
        });
      });
    }
    hide() {
      var _a;
      let timePassed = Date.now() - this.showTimestamp;
      if (timePassed < 500) {
        return;
      }
      (_a = this.hideTimerEvent) == null ? void 0 : _a.remove();
      this.scene.input.off(Phaser.Input.Events.POINTER_DOWN, this.hide, this);
      this.scene.tweens.add({
        targets: this,
        duration: 233,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 0,
        y: "-=20",
        onComplete: () => {
          this.kill();
        }
      });
    }
    preDestroy() {
      this.scene.input.off(Phaser.Input.Events.POINTER_DOWN, this.hide, this);
      super.preDestroy();
    }
  };

  // src/scenes/levelEditor/levelConfig/TutorialConfig.ts
  var TutorialStepType;
  (function(TutorialStepType2) {
    TutorialStepType2["MATCH"] = "MATCH";
    TutorialStepType2["GOALS"] = "GOALS";
    TutorialStepType2["MOVES"] = "MOVES";
    TutorialStepType2["CHEF"] = "CHEF";
    TutorialStepType2["UNDO"] = "UNDO";
    TutorialStepType2["BOOSTER"] = "BOOSTER";
  })(TutorialStepType || (TutorialStepType = {}));

  // src/scenes/gameplayGui/tutorial/TutorialTextPanel.ts
  var TutorialTextPanel = class extends Phaser.GameObjects.Container {
    constructor(scene, textContent) {
      super(scene);
      this.name = "tutorial_text";
      this.addTip();
      this.addBack();
      this.addText(textContent);
      this.adjustBackSize();
      this.setSize(this.back.displayWidth, this.back.displayHeight);
    }
    addTip() {
      this.backTip = this.scene.add.image(0, 0, "gameplay_gui", "tutorial/tutorial_text_tip");
      this.add(this.backTip);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "gameplay_gui", "tutorial/tutorial_text_back");
      this.back.setOrigin(0, 0.5);
      this.back.x = this.backTip.right - 4;
      this.add(this.back);
    }
    addText(content) {
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "26px",
        color: "#B35F44",
        align: "center"
      };
      this.text = this.scene.add.text(0, 0, content, style);
      this.text.setOrigin(0.5, 0.5);
      this.text.setLineSpacing(-3);
      this.text.setWordWrapWidth(this.back.width * 0.9, true);
      this.text.x = this.back.x + this.back.displayWidth / 2 + 2;
      this.text.y = this.back.y - 2;
      this.add(this.text);
    }
    adjustBackSize() {
      this.back.displayHeight = this.text.height + 30;
    }
  };

  // src/scenes/gameplayGui/tutorial/TutorialChef.ts
  var TutorialChef = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.name = "chef";
      this.addBack();
      this.addBorder();
      this.addChef();
      this.addBottomBorder();
      this.setSize(this.border.displayWidth, this.border.displayHeight);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "gameplay_gui", "tutorial/tutorial_chef_fill");
      this.add(this.back);
    }
    addBorder() {
      this.border = this.scene.add.image(0, 0, "gameplay_gui", "tutorial/tutorial_chef_border");
      this.add(this.border);
    }
    addChef() {
      this.chef = this.scene.add.image(0, 0, "gameplay_gui", "tutorial/chef");
      this.chef.x = 5;
      this.chef.y = this.back.bottom - 10;
      this.add(this.chef);
    }
    addBottomBorder() {
      this.bottomBorder = this.scene.add.image(0, 0, "gameplay_gui", "tutorial/tutorial_chef_border_bottom");
      this.bottomBorder.setOrigin(0.5, 1);
      this.bottomBorder.y = this.border.bottom;
      this.add(this.bottomBorder);
    }
    onShow() {
      this.chefTween = this.scene.tweens.add({
        targets: this.chef,
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        scaleX: 0.97,
        scaleY: 1.05,
        yoyo: true,
        repeat: -1
      });
    }
    preDestroy() {
      var _a;
      (_a = this.chefTween) == null ? void 0 : _a.remove();
      this.chefTween = null;
    }
  };

  // src/scenes/gameplayGui/tutorial/screens/TutorialScreen.ts
  var TutorialScreen = class extends PhaserScreen {
    constructor(scene, step) {
      super(scene, {
        name: "tutorial_screen",
        backgroundKey: "gameplay_gui",
        backgroundFrame: "black_rect",
        backgroundAlpha: 0.85,
        backgroundInteractive: false
      });
      this.step = step;
      this.tutorialType = this.step.type;
      this.addMask();
      this.addChef();
      this.addText();
      this.isCanvasRenderer = this.scene.game.rendererType === RendererType.CANVAS;
      if (this.isCanvasRenderer) {
        this.background.kill();
        this.initRenderTextureSource();
        this.addRenderTexture();
      } else {
        this.background.mask = this.maskGraphics.createGeometryMask();
        this.background.mask.invertAlpha = true;
      }
    }
    initRenderTextureSource() {
      var _a;
      let globalScene = this.scene.scene.get(SceneKey.GLOBAL);
      this.renderTextureSource = (_a = globalScene.blackRect) != null ? _a : globalScene.addBlackRect();
    }
    addRenderTexture() {
      this.renderTexture = this.scene.add.renderTexture(0, 0, this.renderTextureSource.width, this.renderTextureSource.height);
      this.addAt(this.renderTexture, 0);
    }
    addMask() {
      this.maskGraphics = this.createMaskGraphics();
    }
    createMaskGraphics() {
      switch (this.step.type) {
        case TutorialStepType.MATCH:
          return this.createCellsMask(this.step.cells);
        case TutorialStepType.GOALS:
          return this.createBasicMask(TutorialStepType.GOALS, 200, 144, 30);
        case TutorialStepType.MOVES:
          return this.createBasicMask(TutorialStepType.MOVES, 154, 82, 30);
        case TutorialStepType.CHEF:
          return this.createCircleMask(TutorialStepType.CHEF, 106);
        case TutorialStepType.UNDO:
          return this.createCircleMask(TutorialStepType.UNDO, 95);
        case TutorialStepType.BOOSTER:
          return this.createBasicMask(TutorialStepType.BOOSTER, 160, 200, 30);
      }
    }
    createCellsMask(cells) {
      let bounds = getGridBounds(cells);
      let width = bounds.width * CELL_SIZE;
      let height = bounds.height * CELL_SIZE;
      let graphics = this.scene.make.graphics({
        fillStyle: {color: 16711680, alpha: 1}
      });
      graphics.fillRoundedRect(-CELL_SIZE / 2, -CELL_SIZE / 2, width, height, 20);
      graphics.column = bounds.left;
      graphics.row = bounds.top;
      graphics.width = width;
      graphics.height = height;
      graphics.maskType = TutorialStepType.MATCH;
      return graphics;
    }
    createBasicMask(tutorialType, width, height, borderRadius = 20) {
      let graphics = this.scene.make.graphics({
        fillStyle: {color: 16711680, alpha: 1}
      });
      graphics.fillRoundedRect(-width / 2, -height / 2, width, height, borderRadius);
      graphics.width = width;
      graphics.height = height;
      graphics.maskType = tutorialType;
      return graphics;
    }
    createCircleMask(tutorialType, radius) {
      let graphics = this.scene.make.graphics({
        fillStyle: {color: 16711680, alpha: 1}
      });
      graphics.fillCircle(0, 0, radius);
      graphics.width = radius * 2;
      graphics.height = radius * 2;
      graphics.maskType = tutorialType;
      return graphics;
    }
    addChef() {
      this.chef = new TutorialChef(this.scene);
      this.pin(this.chef, 0.25, this.getChefPositionY(this.maskGraphics.maskType));
      this.add(this.chef);
    }
    getChefPositionY(maskType) {
      switch (maskType) {
        case TutorialStepType.MATCH:
          return 0.75;
        case TutorialStepType.BOOSTER:
        case TutorialStepType.UNDO:
          return 0.66;
        default:
          return 0.33;
      }
    }
    addText() {
      let content = this.scene.texts.tutorial[this.step.textKey];
      this.text = new TutorialTextPanel(this.scene, content);
      this.add(this.text);
    }
    resize() {
      super.resize();
      this.updateRenderTexture();
      this.alignMask();
      this.eraseMask();
      this.alignText();
    }
    updateRenderTexture() {
      if (!this.renderTexture) {
        return;
      }
      this.renderTexture.envelop(this.screenWidth, this.screenHeight);
      this.renderTexture.x = this.screenCenter.x - this.renderTexture.displayWidth / 2;
      this.renderTexture.y = this.screenCenter.y - this.renderTexture.displayHeight / 2;
      this.renderTexture.clear();
      this.renderTexture.draw(this.renderTextureSource, this.renderTexture.width / 2, this.renderTexture.height / 2);
    }
    alignMask() {
      switch (this.maskGraphics.maskType) {
        case TutorialStepType.MATCH:
          this.alignCellsMask();
          break;
        case TutorialStepType.GOALS:
          this.alignGoalsMask();
          break;
        case TutorialStepType.MOVES:
          this.alignMovesMask();
          break;
        case TutorialStepType.CHEF:
          this.alignChefMask();
          break;
        case TutorialStepType.UNDO:
          this.alignUndoMask();
          break;
        case TutorialStepType.BOOSTER:
          this.alignBoosterMask();
          break;
        default:
          break;
      }
    }
    alignCellsMask() {
      let {column, row} = this.maskGraphics;
      let {x, y} = gridToPixels(column, row);
      let position = this.scene.gameplay.camera.getWorldPositionXY(x, y);
      this.maskGraphics.x = position.x;
      this.maskGraphics.y = position.y;
      this.maskGraphics.scale = this.scene.gameplay.camera.zoom;
    }
    alignGoalsMask() {
      let goalsPanel = this.scene.topPanel.goalsPanel;
      let offsetX = goalsPanel.displayWidth / 2 + 2;
      let offsetY = goalsPanel.displayHeight / 2 + 11;
      this.doAlignMask(goalsPanel, offsetX, offsetY);
    }
    alignMovesMask() {
      let movesPanel = this.scene.topPanel.movesLabel;
      let offsetX = movesPanel.displayWidth / 2 - 14;
      let offsetY = movesPanel.displayHeight / 2 - 6;
      this.doAlignMask(movesPanel, offsetX, offsetY);
    }
    alignChefMask() {
      let chef = this.scene.topPanel.chef;
      this.doAlignMask(chef);
    }
    alignUndoMask() {
      let undoButton = this.scene.undoButton;
      this.doAlignMask(undoButton);
    }
    alignBoosterMask() {
      let boosterType = this.step.boosterType;
      let boosterIcon = this.scene.boostersPanel.getIconByType(boosterType);
      this.doAlignMask(boosterIcon, 0, 20);
    }
    doAlignMask(anchor, offsetX = 0, offsetY = 0) {
      let position = anchor.getWorldPosition();
      let scale = this.scale;
      this.maskGraphics.x = position.x + offsetX * scale;
      this.maskGraphics.y = position.y + offsetY * scale;
      this.maskGraphics.scale = scale;
    }
    eraseMask() {
      if (!this.renderTexture) {
        return;
      }
      let position = {x: this.maskGraphics.x, y: this.maskGraphics.y};
      let localPosition = this.pointToContainer(position);
      let textureScale = this.renderTexture.scale;
      let x = (localPosition.x - this.renderTexture.x) / textureScale;
      let y = (localPosition.y - this.renderTexture.y) / textureScale;
      let saveScale = this.maskGraphics.scale;
      this.maskGraphics.scale = this.getMaskEraseScale(textureScale);
      this.renderTexture.erase(this.maskGraphics, x, y);
      this.maskGraphics.scale = saveScale;
    }
    getMaskEraseScale(textureScale) {
      return this.maskGraphics.maskType === TutorialStepType.MATCH ? this.scene.gameplay.camera.zoom / this.scale / textureScale : 1 / textureScale;
    }
    alignText() {
      this.text.x = this.chef.x + 90;
      this.text.y = this.chef.y;
    }
    show() {
      let delay = this.step.showDelay;
      if (delay === 0) {
        this.doShow();
      } else {
        this.scene.time.delayedCall(delay, () => this.doShow());
      }
    }
    doShow() {
      this.emitShowEvent();
      this.revive();
      this.showBackground();
      this.showChef();
      this.showText(100);
    }
    showChef() {
      this.chef.alpha = 0;
      this.scene.tweens.add({
        targets: this.chef,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.chef.scale = 0.66;
      this.scene.tweens.add({
        targets: this.chef,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1
      });
      this.chef.onShow();
    }
    showText(delay) {
      this.text.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.text,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.text.scale = 0.66;
      this.scene.tweens.add({
        delay,
        targets: this.text,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1,
        onStart: () => {
          this.scene.audio.play(GameSoundKey.WHOOSH_2, {volume: 0.25});
        }
      });
    }
    hide() {
      this.emitHideStartEvent();
      this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.kill();
          this.emitHideCompleteEvent();
        }
      });
    }
    preDestroy() {
      this.maskGraphics.destroy();
      super.preDestroy();
    }
  };

  // src/scenes/gameplayGui/tutorial/SwapTutorialHand.ts
  var SwapTutorialHand = class extends Phaser.GameObjects.Container {
    constructor(scene, start, end) {
      super(scene);
      this.name = "hand";
      this.start = start;
      this.end = end;
      this.addHand();
    }
    addHand() {
      this.hand = this.scene.add.image(0, 0, "gameplay_gui", "tutorial/hand");
      this.add(this.hand);
    }
    playAnimation() {
      var _a, _b, _c;
      this.hand.alpha = 0;
      (_a = this.scene) == null ? void 0 : _a.tweens.add({
        targets: this.hand,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.hand.scale = 1.5;
      (_b = this.scene) == null ? void 0 : _b.tweens.add({
        targets: this.hand,
        duration: 400,
        ease: Phaser.Math.Easing.Cubic.Out,
        scale: 1
      });
      this.hand.angle = 30;
      (_c = this.scene) == null ? void 0 : _c.tweens.add({
        targets: this.hand,
        duration: 400,
        ease: Phaser.Math.Easing.Cubic.Out,
        angle: 0,
        completeDelay: 200,
        onComplete: () => {
          this.moveToEnd();
        }
      });
    }
    moveToEnd() {
      var _a;
      let targetX = (this.end.x - this.start.x) * 0.85;
      let targetY = (this.end.y - this.start.y) * 0.85;
      (_a = this.scene) == null ? void 0 : _a.tweens.add({
        targets: this.hand,
        duration: 500,
        ease: Phaser.Math.Easing.Quadratic.InOut,
        x: targetX,
        y: targetY,
        completeDelay: 200,
        onComplete: () => {
          var _a2;
          (_a2 = this.scene) == null ? void 0 : _a2.tweens.add({
            targets: this.hand,
            duration: 200,
            ease: Phaser.Math.Easing.Cubic.Out,
            alpha: 0,
            completeDelay: 800,
            onComplete: () => {
              this.hand.x = 0;
              this.hand.y = 0;
              this.playAnimation();
            }
          });
        }
      });
    }
    preDestroy() {
      this.scene.tweens.killTweensOf(this.hand);
    }
  };

  // src/scenes/gameplayGui/tutorial/screens/MatchTutorialScreen.ts
  var MatchTutorialScreen = class extends TutorialScreen {
    constructor(scene, step) {
      super(scene, step);
      this.addHand();
    }
    addHand() {
      let {swapCell_1, swapCell_2} = this.step;
      let start = gridToPixels(swapCell_1.x, swapCell_1.y);
      let end = gridToPixels(swapCell_2.x, swapCell_2.y);
      this.hand = new SwapTutorialHand(this.scene, start, end);
      this.hand.kill();
      this.add(this.hand);
    }
    resize() {
      super.resize();
      this.alignHand();
      this.alignChef();
      this.alignText();
    }
    alignHand() {
      let position = this.scene.gameplay.camera.getWorldPosition(this.hand.start);
      let localPos = this.pointToContainer(position);
      this.hand.x = localPos.x + 70;
      this.hand.y = localPos.y + 80;
    }
    alignChef() {
      let position = this.pointToContainer({x: this.maskGraphics.x, y: this.maskGraphics.y});
      this.chef.x = this.screenWidth * 0.25;
      this.chef.y = position.y - this.text.height / 2 - 80;
    }
    doShow() {
      super.doShow();
      this.scene.time.delayedCall(300, () => {
        this.hand.revive();
        this.hand.playAnimation();
      });
    }
  };

  // src/scenes/gameplayGui/tutorial/screens/BoosterTutorialScreen.ts
  var BoosterTutorialScreen = class extends TutorialScreen {
    constructor(scene, step) {
      super(scene, step);
      this.addInteractiveZone();
      this.addHand();
    }
    addInteractiveZone() {
      this.interactiveZone = this.scene.add.image(0, 0, "gameplay_gui", "black_rect");
      this.interactiveZone.setInteractive();
      this.interactiveZone.input.cursor = "pointer";
      this.interactiveZone.alpha = 1e-3;
      this.add(this.interactiveZone);
    }
    addHand() {
      this.hand = new TapTutorialHand(this.scene, "gameplay_gui", "tutorial/hand");
      this.hand.kill();
      this.add(this.hand);
    }
    resize() {
      super.resize();
      this.alignHitArea();
      this.alignChef();
      this.alignText();
      this.alignHand();
    }
    alignHitArea() {
      let boosterIcon = this.getBoosterIcon();
      let position = boosterIcon.getWorldPosition();
      let localPosition = this.pointToContainer(position);
      this.interactiveZone.displayWidth = boosterIcon.displayWidth;
      this.interactiveZone.displayHeight = boosterIcon.displayHeight;
      this.interactiveZone.x = localPosition.x;
      this.interactiveZone.y = localPosition.y;
    }
    alignChef() {
      let position = this.pointToContainer({x: this.maskGraphics.x, y: this.maskGraphics.y});
      this.chef.x = this.screenWidth * 0.25;
      this.chef.y = position.y - this.text.height / 2 - 140;
    }
    alignHand() {
      let boosterIcon = this.getBoosterIcon();
      let position = boosterIcon.getWorldPosition();
      let localPosition = this.pointToContainer(position);
      this.hand.x = localPosition.x + 70;
      this.hand.y = localPosition.y + 80;
    }
    getBoosterIcon() {
      let boosterType = this.step.boosterType;
      let boosterIcon = this.scene.boostersPanel.getIconByType(boosterType);
      return boosterIcon;
    }
    doShow() {
      super.doShow();
      this.scene.time.delayedCall(300, () => {
        this.hand.revive();
        this.hand.playAnimation();
      });
    }
  };

  // src/scenes/gameplayGui/tutorial/screens/UndoTutorialScreen.ts
  var UndoTutorialScreen = class extends TutorialScreen {
    constructor(scene, step) {
      super(scene, step);
      this.addInteractiveZone();
      this.addHand();
    }
    addInteractiveZone() {
      this.interactiveZone = this.scene.add.image(0, 0, "gameplay_gui", "black_rect");
      this.interactiveZone.setInteractive();
      this.interactiveZone.input.cursor = "pointer";
      this.interactiveZone.alpha = 1e-3;
      this.add(this.interactiveZone);
    }
    addHand() {
      this.hand = new TapTutorialHand(this.scene, "gameplay_gui", "tutorial/hand");
      this.hand.kill();
      this.add(this.hand);
    }
    resize() {
      super.resize();
      this.alignHitArea();
      this.alignChef();
      this.alignText();
      this.alignHand();
    }
    alignHitArea() {
      let undoButton = this.scene.undoButton;
      let position = undoButton.getWorldPosition();
      let localPosition = this.pointToContainer(position);
      this.interactiveZone.displayWidth = undoButton.displayWidth;
      this.interactiveZone.displayHeight = undoButton.displayHeight;
      this.interactiveZone.x = localPosition.x;
      this.interactiveZone.y = localPosition.y;
    }
    alignChef() {
      let position = this.pointToContainer({x: this.maskGraphics.x, y: this.maskGraphics.y});
      this.chef.x = this.screenWidth * 0.25;
      this.chef.y = position.y - this.text.height / 2 - 140;
    }
    alignHand() {
      let undoButton = this.scene.undoButton;
      let position = undoButton.getWorldPosition();
      let localPosition = this.pointToContainer(position);
      this.hand.x = localPosition.x + 70;
      this.hand.y = localPosition.y + 80;
    }
    doShow() {
      super.doShow();
      this.scene.time.delayedCall(300, () => {
        this.hand.revive();
        this.hand.playAnimation();
      });
    }
  };

  // src/robowhale/utils/Direction.ts
  var Direction;
  (function(Direction2) {
    Direction2["UP_LEFT"] = "UP_LEFT";
    Direction2["UP"] = "UP";
    Direction2["UP_RIGHT"] = "UP_RIGHT";
    Direction2["RIGHT"] = "RIGHT";
    Direction2["DOWN_RIGHT"] = "DOWN_RIGHT";
    Direction2["DOWN"] = "DOWN";
    Direction2["DOWN_LEFT"] = "DOWNM_LEFT";
    Direction2["LEFT"] = "LEFT";
  })(Direction || (Direction = {}));
  function getOrthoDirection(angleDeg) {
    if (angleDeg > -135 && angleDeg <= -45) {
      return Direction.UP;
    } else if (angleDeg > -45 && angleDeg <= 45) {
      return Direction.RIGHT;
    } else if (angleDeg > 45 && angleDeg <= 135) {
      return Direction.DOWN;
    } else {
      return Direction.LEFT;
    }
  }

  // src/robowhale/grid/GridArray.ts
  var GridArray = class {
    constructor(rows, columns) {
      this.rows = rows;
      this.columns = columns;
      this.items = [];
      for (let i = 0; i < rows; i++) {
        this.items[i] = new Array(columns);
      }
    }
    addRow() {
      this.items.push(new Array(this.columns));
      this.rows++;
    }
    removeRow(rowIndex) {
      this.rows--;
      this.items.splice(rowIndex, 1);
      this.items.forEach((row) => {
        row.forEach((item) => {
          if (item.row > rowIndex) {
            item.row--;
          }
        });
      });
    }
    addColumn() {
      this.items.forEach((row) => row.length++);
      this.columns++;
    }
    removeColumn(columnIndex) {
      this.columns--;
      this.items.forEach((row) => {
        row.splice(columnIndex, 1);
        row.forEach((item) => {
          if (item.column > columnIndex) {
            item.column--;
          }
        });
      });
    }
    checkAt(column, row) {
      return !!this.getAt(column, row);
    }
    getAt(column, row) {
      var _a;
      return (_a = this.items[row]) == null ? void 0 : _a[column];
    }
    removeAt(column, row) {
      var _a;
      (_a = this.items[row]) == null ? true : delete _a[column];
    }
    removeAll() {
      this.items.forEach((row) => {
        for (let i = 0; i < row.length; i++) {
          delete row[i];
        }
      });
    }
    add(item) {
      return this.addAt(item.column, item.row, item);
    }
    addMultiple(...items) {
      return items.map((item) => this.addAt(item.column, item.row, item));
    }
    addAt(column, row, item) {
      if (this.checkAt(column, row)) {
        console.warn(`Slot [${column}, ${row}] is taken!`);
        return false;
      }
      this.items[row][column] = item;
      return true;
    }
    remove(item) {
      this.removeAt(item.column, item.row);
    }
    toArray() {
      return this.items.flat();
    }
    toArrayUniq() {
      return uniq_default(this.items.flat());
    }
    getNeighborAtDirection(column, row, direction) {
      switch (direction) {
        case Direction.UP_LEFT:
          return this.getAt(column - 1, row - 1);
        case Direction.UP:
          return this.getAt(column, row - 1);
        case Direction.UP_RIGHT:
          return this.getAt(column + 1, row - 1);
        case Direction.RIGHT:
          return this.getAt(column + 1, row);
        case Direction.DOWN_RIGHT:
          return this.getAt(column + 1, row + 1);
        case Direction.DOWN:
          return this.getAt(column, row + 1);
        case Direction.DOWN_LEFT:
          return this.getAt(column - 1, row + 1);
        case Direction.LEFT:
          return this.getAt(column - 1, row);
        default:
          console.warn("Unknown direction!", direction);
          return null;
      }
    }
    getNeighborsAt(column, row) {
      return {
        topLeft: this.getAt(column - 1, row - 1),
        top: this.getAt(column, row - 1),
        topRight: this.getAt(column + 1, row - 1),
        right: this.getAt(column + 1, row),
        bottomRight: this.getAt(column + 1, row + 1),
        bottom: this.getAt(column, row + 1),
        bottomLeft: this.getAt(column - 1, row + 1),
        left: this.getAt(column - 1, row)
      };
    }
    getOrthoNeighborsAt(column, row) {
      return {
        top: this.getAt(column, row - 1),
        right: this.getAt(column + 1, row),
        bottom: this.getAt(column, row + 1),
        left: this.getAt(column - 1, row)
      };
    }
    getNeighborsArrayAt(column, row) {
      return Object.values(this.getNeighborsAt(column, row));
    }
    getOrthoNeighborsArrayAt(column, row) {
      return [
        this.getAt(column, row - 1),
        this.getAt(column + 1, row),
        this.getAt(column, row + 1),
        this.getAt(column - 1, row)
      ];
    }
    forEach(callbackfn, thisArg) {
      this.items.forEach((row) => {
        row.forEach(callbackfn, thisArg);
      });
    }
    filter(callbackfn, thisArg) {
      return this.items.flatMap((row) => {
        return row.filter(callbackfn, thisArg);
      });
    }
    map(callbackfn, thisArg) {
      return this.items.flatMap((row) => {
        return row.map(callbackfn, thisArg);
      });
    }
    find(predicate) {
      let result;
      this.items.some((row) => {
        return row.some((item) => {
          if (predicate(item)) {
            result = item;
            return true;
          }
        });
      });
      return result;
    }
    getItemsByColumn(column) {
      let items = [];
      for (let row = 0; row < this.rows; row++) {
        let item = this.getAt(column, row);
        if (item && items.includes(item) === false) {
          items.push(item);
        }
      }
      return items;
    }
    getItemsByRow(row) {
      let items = [];
      for (let column = 0; column < this.columns; column++) {
        let item = this.getAt(column, row);
        if (item && items.includes(item) === false) {
          items.push(item);
        }
      }
      return items;
    }
  };

  // src/scenes/gameplay/items/common/GameItemMultiCell.ts
  var MultiCellItemTypes = [
    ItemType.APPLES_PLATTER,
    ItemType.COLOR_CAKE,
    ItemType.GUMMY_HORIZONTAL,
    ItemType.GUMMY_HORIZONTAL_LARGE,
    ItemType.GUMMY_VERTICAL,
    ItemType.GUMMY_VERTICAL_LARGE
  ];
  var MultiCellItemSizes = {
    [ItemType.APPLES_PLATTER]: {width: 2, height: 2},
    [ItemType.COLOR_CAKE]: {width: 2, height: 2},
    [ItemType.GUMMY_HORIZONTAL]: {width: 2, height: 1},
    [ItemType.GUMMY_HORIZONTAL_LARGE]: {width: 3, height: 2},
    [ItemType.GUMMY_VERTICAL]: {width: 1, height: 2},
    [ItemType.GUMMY_VERTICAL_LARGE]: {width: 2, height: 3}
  };
  var MultiCellUtils = class {
    static addToArray(array, item) {
      this.getPositions(item.column, item.row, {width: item.itemWidth, height: item.itemHeight}).forEach((position) => {
        array.addAt(position.column, position.row, item);
      });
    }
    static removeFromArray(array, item) {
      this.getPositions(item.column, item.row, {width: item.itemWidth, height: item.itemHeight}).forEach((position) => {
        array.removeAt(position.column, position.row);
      });
    }
    static isMulticell(type) {
      return MultiCellItemTypes.includes(type);
    }
    static getSize(type) {
      return MultiCellItemSizes[type];
    }
    static getItemPositions(item) {
      return this.getPositions(item.column, item.row, {width: item.itemWidth, height: item.itemHeight});
    }
    static getPositions(leftColumn, topRow, size) {
      let positions = [];
      for (let row = topRow; row < topRow + size.height; row++) {
        for (let column = leftColumn; column < leftColumn + size.width; column++) {
          positions.push({column, row});
        }
      }
      return positions;
    }
    static getPositionsUnderItem(item) {
      let leftColumn = item.column;
      let rowUnder = item.row + item.itemHeight;
      let positionsUnder = [];
      for (let column = leftColumn; column < leftColumn + item.itemWidth; column++) {
        positionsUnder.push({column, row: rowUnder});
      }
      return positionsUnder;
    }
    static getOrthoNeighborPositions(item) {
      let leftColumn = item.column - 1;
      let rightColumn = item.column + item.itemWidth;
      let topRow = item.row - 1;
      let bottomRow = item.row + item.itemHeight;
      let neighbors = [];
      for (let column = leftColumn + 1; column < rightColumn; column++) {
        neighbors.push({column, row: topRow});
      }
      for (let row = topRow + 1; row < bottomRow; row++) {
        neighbors.push({column: rightColumn, row});
      }
      for (let column = rightColumn - 1; column > leftColumn; column--) {
        neighbors.push({column, row: bottomRow});
      }
      for (let row = bottomRow - 1; row > topRow; row--) {
        neighbors.push({column: leftColumn, row});
      }
      return neighbors;
    }
  };

  // src/scenes/gameplay/ItemsManager.ts
  var ItemsManager = class {
    constructor(columns, rows) {
      this.bottomItems = new GridArray(rows, columns);
      this.mainItems = new GridArray(rows, columns);
      this.topItems = new GridArray(rows, columns);
      this.generators = new GridArray(rows, columns);
    }
    addItemsFromConfig(factory, config2) {
      config2.forEach((itemConfig) => {
        factory.create(itemConfig);
      });
    }
    add(item) {
      let array = this.getArrayByItemSuperType(item.itemSuperType);
      if (item.isMultiCell) {
        MultiCellUtils.addToArray(array, item);
      } else {
        array.add(item);
      }
    }
    remove(item) {
      let array = this.getArrayByItemSuperType(item.itemSuperType);
      if (item.isMultiCell) {
        MultiCellUtils.removeFromArray(array, item);
      } else {
        array.remove(item);
      }
    }
    getArrayByItemSuperType(superType) {
      switch (superType) {
        case ItemSuperType.BISCUIT:
          return this.bottomItems;
        case ItemSuperType.LICORICE:
        case ItemSuperType.GUMMY_BLOCKER:
          return this.topItems;
        case ItemSuperType.GENERATOR:
          return this.generators;
        default:
          return this.mainItems;
      }
    }
    swapItems(item_1, item_2) {
      let {column: column_1, row: row_1} = item_1;
      let {column: column_2, row: row_2} = item_2;
      item_1.column = column_2;
      item_1.row = row_2;
      this.mainItems.removeAt(column_2, row_2);
      this.mainItems.add(item_1);
      item_2.column = column_1;
      item_2.row = row_1;
      this.mainItems.removeAt(column_1, row_1);
      this.mainItems.add(item_2);
    }
    getItemsToDrop() {
      let hasLicoriceAbove = (item) => {
        return this.topItems.checkAt(item.column, item.row);
      };
      return this.mainItems.filter((item) => {
        return item.isDroppable && hasLicoriceAbove(item) === false;
      });
    }
    save() {
      let biscuits = this.bottomItems.toArray().map((item) => item.createSave());
      let items = this.mainItems.toArrayUniq().map((item) => item.createSave());
      let topItems = this.topItems.toArray().map((item) => item.createSave());
      let generators = this.generators.toArray().map((item) => item.createSave());
      return [...biscuits, ...items, ...topItems, ...generators];
    }
    restore(factory, data) {
      this.clear();
      this.doRestore(factory, data);
    }
    clear() {
      let gridArrays = [this.bottomItems, this.mainItems, this.topItems, this.generators];
      gridArrays.forEach((array) => {
        array.forEach((item) => {
          if (isCookie(item)) {
            item.kill();
          } else {
            item.destroy();
          }
        });
        array.removeAll();
      });
    }
    doRestore(factory, data) {
      data.forEach((save) => {
        let {column, row, itemType} = save;
        switch (save.itemSuperType) {
          case ItemSuperType.BISCUIT:
            factory.createBiscuit(column, row);
            break;
          case ItemSuperType.COOKIE:
            factory.createCookie(column, row, itemType, save.powerup);
            break;
          case ItemSuperType.DROP_ITEM:
            factory.createDropItem(column, row, itemType);
            break;
          case ItemSuperType.MARSHMALLOW:
            factory.createMarshmallow(column, row, itemType, save.health);
            break;
          case ItemSuperType.CHOCOLATE:
            factory.createChocolate(column, row, itemType, save.health);
            break;
          case ItemSuperType.DONUT_BOX:
            let box = factory.createDonutBox(column, row, save.donutBoxState);
            box.wasJustOpened = save.wasJustOpened;
            break;
          case ItemSuperType.CANDY_BOTTLE:
            factory.createCandyBottle(column, row);
            break;
          case ItemSuperType.APPLE_PLATTER:
            factory.createApplePlatter(column, row, save.apples);
            break;
          case ItemSuperType.COLOR_CAKE:
            factory.createColorCake(column, row, save.colorCakeContent);
            break;
          case ItemSuperType.LICORICE:
            factory.createLicorice(column, row, itemType);
            break;
          case ItemSuperType.MYSTERY_BOX:
            factory.createMysteryBox(column, row, itemType, save.content);
            break;
          case ItemSuperType.GENERATOR:
            factory.createGenerator(column, row, save.options);
            break;
          case ItemSuperType.CHICK:
            factory.createChick(column, row, itemType);
            break;
          case ItemSuperType.GUMMY:
            factory.createGummy(column, row, itemType);
            break;
          case ItemSuperType.GUMMY_BLOCKER:
            factory.createGummyBlocker(column, row, itemType);
            break;
          default:
            console.warn(`Unknown save type!`, save);
            break;
        }
      });
    }
    hasLicoriceOver(item) {
      return this.hasLicoriceAt(item.column, item.row);
    }
    hasLicoriceAt(column, row) {
      return this.topItems.checkAt(column, row);
    }
    getApplePlatters() {
      return uniq_default(this.mainItems.filter((item) => item.itemSuperType === ItemSuperType.APPLE_PLATTER));
    }
    getColorCakes() {
      return uniq_default(this.mainItems.filter((item) => item.itemSuperType === ItemSuperType.COLOR_CAKE));
    }
    getDonutBoxes() {
      return this.mainItems.filter((item) => item.itemSuperType === ItemSuperType.DONUT_BOX);
    }
    getGummies() {
      return uniq_default(this.mainItems.filter((item) => item.itemSuperType === ItemSuperType.GUMMY));
    }
    getCookiesWithoutPowerups() {
      return this.mainItems.filter((item) => isCookie(item) && !item.powerup);
    }
    getCookiesWithPowerups() {
      return this.mainItems.filter((item) => isCookie(item) && !!item.powerup);
    }
    getRandomExistingCookieType() {
      let allCookies = this.mainItems.filter((item) => isCookie(item) && item.powerup !== CookiePowerup.SUPER_SPHERE);
      let cookieTypes = uniq_default(allCookies.map((cookie) => cookie.itemType));
      return Phaser.Math.RND.pick(cookieTypes);
    }
    getMostPopularExistingCookieType() {
      let allCookies = this.mainItems.filter((item) => isCookie(item) && item.powerup !== CookiePowerup.SUPER_SPHERE);
      let counts = countBy_default(allCookies, "itemType");
      let maxValue = Math.max(...Object.values(counts));
      let maxKey = findKey_default(counts, (value) => value === maxValue);
      return maxKey;
    }
    getLeastPopularExistingCookieType() {
      let allCookies = this.mainItems.filter((item) => isCookie(item) && item.powerup !== CookiePowerup.SUPER_SPHERE);
      let counts = countBy_default(allCookies, "itemType");
      let minValue = Math.min(...Object.values(counts));
      let minKey = findKey_default(counts, (value) => value === minValue);
      return minKey;
    }
  };

  // src/scenes/gameplay/matches/Match.ts
  var MatchType;
  (function(MatchType2) {
    MatchType2["VERTICAL_LINE"] = "VERTICAL_LINE";
    MatchType2["HORIZONTAL_LINE"] = "HORIZONTAL_LINE";
    MatchType2["NON_LINE"] = "NON_LINE";
  })(MatchType || (MatchType = {}));
  var MatchResult;
  (function(MatchResult2) {
    MatchResult2[MatchResult2["STRIPES"] = 3] = "STRIPES";
    MatchResult2[MatchResult2["BOMB"] = 4] = "BOMB";
    MatchResult2[MatchResult2["SUPER_SPHERE"] = 5] = "SUPER_SPHERE";
  })(MatchResult || (MatchResult = {}));

  // src/scenes/gameplay/matches/MatchUtils.ts
  var _MatchUtils = class {
    static createMatch(type, ...items) {
      let size = items.length;
      return {
        type,
        items,
        size,
        itemsType: items[0].itemType,
        result: this.getMatchResult(type, size),
        id: _MatchUtils.MATCH_ID_COUNTER++
      };
    }
    static getMatchResult(type, size) {
      if (type === MatchType.NON_LINE) {
        if (size === 5 || size === 6) {
          return MatchResult.BOMB;
        } else {
          return MatchResult.SUPER_SPHERE;
        }
      } else {
        if (size === 4) {
          return MatchResult.STRIPES;
        } else if (size > 4) {
          return MatchResult.SUPER_SPHERE;
        }
      }
      return null;
    }
    static getDimensions(match) {
      let left = Number.MAX_VALUE;
      let right = Number.MIN_VALUE;
      let top = Number.MAX_VALUE;
      let bottom = Number.MIN_VALUE;
      match.items.forEach((item) => {
        if (item.column > right) {
          right = item.column;
        }
        if (item.column < left) {
          left = item.column;
        }
        if (item.row < top) {
          top = item.row;
        }
        if (item.row > bottom) {
          bottom = item.row;
        }
      });
      return {
        width: right - left + 1,
        height: bottom - top + 1
      };
    }
    static sortMatchesBySize(match_1, match_2) {
      if (match_1.size === match_2.size) {
        let cell_1 = match_1.items[0];
        let cell_2 = match_2.items[0];
        if (cell_1.row === cell_2.row) {
          return cell_1.column - cell_2.column;
        }
        return cell_1.row - cell_2.row;
      }
      return match_2.size - match_1.size;
    }
    static sortMatchesByResult(match_1, match_2) {
      return match_1.result - match_2.result;
    }
    static getCollectPosition(match, rnd) {
      let centralItem;
      match.items.sort(sortUpBottom);
      if (match.size === 3) {
        centralItem = match.items[1];
      } else if (match.size === 4) {
        centralItem = rnd.bool() ? match.items[1] : match.items[2];
      } else {
        if (match.type === MatchType.NON_LINE) {
          centralItem = this.getCentralItem(match);
        } else {
          centralItem = match.items[Math.floor(match.size / 2)];
        }
      }
      return {column: centralItem.column, row: centralItem.row};
    }
    static getCentralItem(match) {
      let {items} = match;
      let {column: medianColumn, row: medianRow} = gridMedianPosition(items);
      let closestItem;
      let minDistance = Number.MAX_VALUE;
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        let distance = Phaser.Math.Distance.Squared(item.column, item.row, medianColumn, medianRow);
        if (distance < minDistance) {
          closestItem = item;
          minDistance = distance;
        }
      }
      return closestItem;
    }
    static toString(match) {
      return `[${match.type}, size = ${match.size}, ${match.itemsType}, origin: {${match.items[0].column}, ${match.items[0].row}} ]`;
    }
  };
  var MatchUtils = _MatchUtils;
  MatchUtils.MATCH_ID_COUNTER = 0;

  // src/scenes/gameplay/matches/MatchFinder.ts
  var MatchFinder = class {
    static findBestMatchOf(allItems, currentItem) {
      let {column, row, itemType: type} = currentItem;
      let itemsToCheck = allItems.filter((item) => {
        return item.itemType === type && item.column >= column - 4 && item.column <= column && item.row >= row - 4 && item.row <= row;
      });
      let matches = this.findAll(allItems, itemsToCheck).filter((match) => match.items.includes(currentItem)).sort(MatchUtils.sortMatchesByResult);
      return matches[matches.length - 1];
    }
    static hasAny(items) {
      return items.some((item) => {
        let {column, row, itemType: type} = item;
        let right1 = this.getItemAt(items, column + 1, row, type);
        let right2 = right1 && this.getItemAt(items, column + 2, row, type);
        if (right1 && right2) {
          return true;
        }
        let bottom1 = this.getItemAt(items, column, row - 1, type);
        let bottom2 = bottom1 && this.getItemAt(items, column, row - 2, type);
        if (bottom1 && bottom2) {
          return true;
        }
      });
    }
    static getItemAt(items, column, row, type) {
      return items.find((item) => item.column === column && item.row === row && item.itemType === type);
    }
    static findAll(allItems, itemsToCheck) {
      let matches = [];
      itemsToCheck = itemsToCheck != null ? itemsToCheck : allItems;
      itemsToCheck.forEach((item) => {
        let {column, row, itemType: type} = item;
        let right1 = this.getItemAt(allItems, column + 1, row, type);
        let right2 = right1 && this.getItemAt(allItems, column + 2, row, type);
        if (right1 && right2) {
          matches.push(MatchUtils.createMatch(MatchType.HORIZONTAL_LINE, item, right1, right2));
        }
        let bottom1 = this.getItemAt(allItems, column, row + 1, type);
        let bottom2 = bottom1 && this.getItemAt(allItems, column, row + 2, type);
        if (bottom1 && bottom2) {
          matches.push(MatchUtils.createMatch(MatchType.VERTICAL_LINE, item, bottom1, bottom2));
        }
      });
      this.combineOverlappingMatches(matches);
      return matches;
    }
    static combineOverlappingMatches(matches) {
      let hasOverlaps = false;
      for (let i = matches.length - 1; i >= 0; i--) {
        let currentMatch = matches[i];
        let overlap = matches.find((match) => {
          return match !== currentMatch && match.itemsType === currentMatch.itemsType && this.hasCommonItems(match, currentMatch);
        });
        if (overlap) {
          hasOverlaps = true;
          matches.splice(i, 1);
          this.combineMatches(overlap, currentMatch);
        }
      }
      if (hasOverlaps) {
        this.combineOverlappingMatches(matches);
      }
    }
    static hasCommonItems(match_1, match_2) {
      return match_1.items.some((item) => match_2.items.includes(item));
    }
    static combineMatches(target, source) {
      Phaser.Utils.Array.Add(target.items, source.items);
      target.size = target.items.length;
      target.type = target.type === source.type ? target.type : MatchType.NON_LINE;
      target.result = MatchUtils.getMatchResult(target.type, target.size);
    }
  };

  // src/scenes/gameplay/CookiesSpecialCombo.ts
  var CookiesSpecialCombo;
  (function(CookiesSpecialCombo2) {
    CookiesSpecialCombo2["SUPER_SPHERE_x2"] = "SUPER_SPHERE_x2";
    CookiesSpecialCombo2["SUPER_SPHERE_BOMB"] = "SUPER_SPHERE_BOMB";
    CookiesSpecialCombo2["SUPER_SPHERE_STRIPED"] = "SUPER_SPHERE_STRIPED";
    CookiesSpecialCombo2["SUPER_SPHERE"] = "SUPER_SPHERE";
    CookiesSpecialCombo2["BOMB_x2"] = "BOMB_x2";
    CookiesSpecialCombo2["BOMB_STRIPED"] = "BOMB_STRIPED";
    CookiesSpecialCombo2["STRIPED_x2"] = "STRIPED_x2";
  })(CookiesSpecialCombo || (CookiesSpecialCombo = {}));
  var COMBOS_MAP = {
    [CookiesSpecialCombo.SUPER_SPHERE_x2]: ["SUPER_SPHERE", "SUPER_SPHERE"],
    [CookiesSpecialCombo.SUPER_SPHERE_BOMB]: ["SUPER_SPHERE", "BOMB"],
    [CookiesSpecialCombo.SUPER_SPHERE_STRIPED]: ["SUPER_SPHERE", "STRIPES"],
    [CookiesSpecialCombo.SUPER_SPHERE]: ["SUPER_SPHERE", "NONE"],
    [CookiesSpecialCombo.BOMB_x2]: ["BOMB", "BOMB"],
    [CookiesSpecialCombo.BOMB_STRIPED]: ["BOMB", "STRIPES"],
    [CookiesSpecialCombo.STRIPED_x2]: ["STRIPES", "STRIPES"]
  };
  function getCookiesSpecialCombo(item_1, item_2) {
    if (!isCookie(item_1) || !isCookie(item_2)) {
      return;
    }
    let powerup_1 = getPowerupSuperType(item_1.powerup);
    let powerup_2 = getPowerupSuperType(item_2.powerup);
    let combo = findKey_default(COMBOS_MAP, (pair) => {
      return pair[0] === powerup_1 && pair[1] === powerup_2 || pair[0] === powerup_2 && pair[1] === powerup_1;
    });
    return combo;
  }
  function getPowerupSuperType(powerup) {
    if (powerup === CookiePowerup.VERTICAL_STRIPES || powerup === CookiePowerup.HORIZONTAL_STRIPES) {
      return "STRIPES";
    } else if (powerup === CookiePowerup.BOMB) {
      return "BOMB";
    } else if (powerup === CookiePowerup.SUPER_SPHERE) {
      return "SUPER_SPHERE";
    }
    return "NONE";
  }

  // src/scenes/gameplay/matches/MatchHinter.ts
  var MatchHinter = class {
    static findBestMove(items, goalItemTypes) {
      let swappableItems = this.getSwappableItems(items);
      if (goalItemTypes && goalItemTypes.length > 0) {
        let matchMoves = this.getAllMatchMoves(swappableItems, items).filter((move) => goalItemTypes.includes(move.match.itemsType));
        let bestMatchMove = this.getBestMatchMove(matchMoves);
        if (bestMatchMove) {
          return bestMatchMove;
        }
      }
      return this.findBestComboMove(swappableItems, items) || this.findBestMatchMove(swappableItems, items);
    }
    static getSwappableItems(items) {
      return items.mainItems.filter((item) => {
        return item.isSwappable && items.topItems.checkAt(item.column, item.row) === false;
      });
    }
    static findBestMatchMove(swappableItems, items) {
      let moves = this.getAllMatchMoves(swappableItems, items);
      let bestMove = this.getBestMatchMove(moves);
      return bestMove != null ? bestMove : null;
    }
    static getAllMatchMoves(swappableItems, items) {
      let swaps = this.getPossibleMatchSwaps(swappableItems, items);
      let matchableItems = items.mainItems.filter((item) => item.isMatchable);
      let moves = [];
      swaps.forEach((swap) => {
        items.swapItems(swap.item_1, swap.item_2);
        let match_1 = MatchFinder.findBestMatchOf(matchableItems, swap.item_1);
        if (match_1) {
          moves.push({swap, match: match_1, type: "match"});
        }
        let match_2 = MatchFinder.findBestMatchOf(matchableItems, swap.item_2);
        if (match_2) {
          moves.push({swap, match: match_2, type: "match"});
        }
        items.swapItems(swap.item_1, swap.item_2);
      });
      return moves;
    }
    static getPossibleMatchSwaps(swappableItems, items) {
      let swaps = [];
      swappableItems.forEach((item) => {
        let {column, row, itemType} = item;
        let bottomItem = items.mainItems.getAt(column, row + 1);
        if (bottomItem && swappableItems.includes(bottomItem) && bottomItem.itemType !== itemType) {
          swaps.push({item_1: item, item_2: bottomItem});
        }
        let rightItem = items.mainItems.getAt(column + 1, row);
        if (rightItem && swappableItems.includes(rightItem) && rightItem.itemType !== itemType) {
          swaps.push({item_1: item, item_2: rightItem});
        }
      });
      return swaps;
    }
    static getBestMatchMove(moves) {
      return maxBy_default(moves, (move) => {
        return this.getMatchScore(move.match);
      });
    }
    static getMatchScore(match) {
      let basePoints = 0;
      if (match.result === MatchResult.STRIPES) {
        basePoints = 1;
      } else if (match.result === MatchResult.BOMB) {
        basePoints = 2;
      } else if (match.result === MatchResult.SUPER_SPHERE) {
        basePoints = 3;
      }
      let cookies = match.items;
      let powerupPoints = cookies.reduce((acc, cookie) => {
        if (cookie.powerup === CookiePowerup.HORIZONTAL_STRIPES || cookie.powerup === CookiePowerup.VERTICAL_STRIPES) {
          acc += 1.5;
        } else if (cookie.powerup === CookiePowerup.BOMB) {
          acc += 2;
        }
        return acc;
      }, 0);
      return basePoints + powerupPoints;
    }
    static findBestComboMove(swappableItems, items) {
      let poweredUpCookies = swappableItems.filter((item) => isCookie(item) && item.hasPowerup()).sort(sortUpBottom);
      let swappableGridArray = this.convertToGridArray(swappableItems, items.mainItems.rows, items.mainItems.columns);
      let moves = this.findPossibleComboMoves(poweredUpCookies, swappableGridArray);
      let bestMove = this.pickBestCombo(moves);
      return bestMove != null ? bestMove : null;
    }
    static convertToGridArray(array, rows, columns) {
      let gridArray = new GridArray(rows, columns);
      gridArray.addMultiple(...array);
      return gridArray;
    }
    static findPossibleComboMoves(poweredUpCookies, items) {
      let moves = [];
      poweredUpCookies.forEach((cookie) => {
        let {column, row} = cookie;
        let bottomItem = items.getAt(column, row + 1);
        if (bottomItem && isCookie(bottomItem)) {
          if (bottomItem.hasPowerup() || cookie.powerup === CookiePowerup.SUPER_SPHERE) {
            moves.push({item_1: cookie, item_2: bottomItem, type: "combo"});
          }
        }
        let rightItem = items.getAt(column + 1, row);
        if (rightItem && isCookie(rightItem) && rightItem.hasPowerup()) {
          if (rightItem.hasPowerup() || cookie.powerup === CookiePowerup.SUPER_SPHERE) {
            moves.push({item_1: cookie, item_2: rightItem, type: "combo"});
          }
        }
      });
      return moves;
    }
    static pickBestCombo(moves) {
      return maxBy_default(moves, (move) => {
        let comboType = getCookiesSpecialCombo(move.item_1, move.item_2);
        let score = this.COOKIES_SPECIAL_COMBO_SCORE_MAP[comboType];
        return score;
      });
    }
    static isDeadlock(items) {
      return this.hasAnySwap(items) === false;
    }
    static hasAnySwap(items) {
      let swappableItems = this.getSwappableItems(items);
      return this.hasAnyMatchMove(swappableItems, items) || this.hasAnySpecialComboMove(swappableItems, items.mainItems);
    }
    static hasAnyMatchMove(swappableItems, items) {
      let matchableItems = items.mainItems.filter((item) => item.isMatchable);
      for (let i = 0; i < swappableItems.length; i++) {
        let item = swappableItems[i];
        let {column, row, itemType} = item;
        let bottomItem = items.mainItems.getAt(column, row + 1);
        if (bottomItem && swappableItems.includes(bottomItem) && bottomItem.itemType !== itemType) {
          let hasMatches = this.willSwapHaveMatches(items, item, bottomItem, matchableItems);
          if (hasMatches) {
            return true;
          }
        }
        let rightItem = items.mainItems.getAt(column + 1, row);
        if (rightItem && swappableItems.includes(rightItem) && rightItem.itemType !== itemType) {
          let hasMatches = this.willSwapHaveMatches(items, item, rightItem, matchableItems);
          if (hasMatches) {
            return true;
          }
        }
      }
      return false;
    }
    static willSwapHaveMatches(items, item_1, item_2, matchableItems) {
      items.swapItems(item_1, item_2);
      let hasMatches = MatchFinder.hasAny(matchableItems);
      items.swapItems(item_1, item_2);
      return hasMatches;
    }
    static hasAnySpecialComboMove(swappableItems, items) {
      let poweredUpCookies = swappableItems.filter((item) => isCookie(item) && item.hasPowerup());
      return poweredUpCookies.some((cookie) => {
        let {column, row} = cookie;
        let bottomItem = items.getAt(column, row + 1);
        if (bottomItem && isCookie(bottomItem)) {
          if (bottomItem.hasPowerup() || cookie.powerup === CookiePowerup.SUPER_SPHERE) {
            return true;
          }
        }
        let rightItem = items.getAt(column + 1, row);
        if (rightItem && isCookie(rightItem)) {
          if (rightItem.hasPowerup() || cookie.powerup === CookiePowerup.SUPER_SPHERE) {
            return true;
          }
        }
      });
    }
  };
  MatchHinter.COOKIES_SPECIAL_COMBO_SCORE_MAP = {
    [CookiesSpecialCombo.SUPER_SPHERE_x2]: 7,
    [CookiesSpecialCombo.SUPER_SPHERE_BOMB]: 6,
    [CookiesSpecialCombo.SUPER_SPHERE_STRIPED]: 5,
    [CookiesSpecialCombo.BOMB_x2]: 4,
    [CookiesSpecialCombo.BOMB_STRIPED]: 3,
    [CookiesSpecialCombo.STRIPED_x2]: 2,
    [CookiesSpecialCombo.SUPER_SPHERE]: 1
  };

  // src/scenes/gameplayGui/tutorial/TutorialManager.ts
  var TutorialManagerEvent;
  (function(TutorialManagerEvent2) {
    TutorialManagerEvent2["COMPLETE"] = "__COMPLETE";
  })(TutorialManagerEvent || (TutorialManagerEvent = {}));
  var TutorialManager = class extends Phaser.Events.EventEmitter {
    constructor(scene, config2) {
      super();
      this.scene = scene;
      this.scene.input.enabled = false;
      this.gameplay = this.scene.gameplay;
      this.config = config2;
      this.addScreens();
    }
    addScreens() {
      this.screens = this.config.steps.map((step) => {
        let screen2 = this.createScreen(step);
        screen2.setDepth(GameplayGuiDepth.TUTORIAL);
        screen2.kill();
        this.scene.add.existing(screen2);
        return screen2;
      });
    }
    createScreen(step) {
      switch (step.type) {
        case TutorialStepType.MATCH:
          return new MatchTutorialScreen(this.scene, step);
        case TutorialStepType.UNDO:
          return new UndoTutorialScreen(this.scene, step);
        case TutorialStepType.BOOSTER:
          return new BoosterTutorialScreen(this.scene, step);
        default:
          return new TutorialScreen(this.scene, step);
      }
    }
    resize() {
      var _a;
      (_a = this.currentScreen) == null ? void 0 : _a.resize();
    }
    showNextScreen() {
      let hasMoreScreens = this.screens.length > 0;
      if (hasMoreScreens === false) {
        this.onTutorialsComplete();
        return;
      }
      let newScreen = this.screens[0];
      if (newScreen.tutorialType === TutorialStepType.MATCH) {
        let hasMatch = this.checkMatchForTutorial(newScreen.step);
        if (hasMatch === false) {
          this.scene.analytics.sendDesignEvent(`Tutorial:${this.gameplay.levelNumber}:NoMatches`);
          this.screens.shift().destroy();
          this.showNextScreen();
          return;
        }
      }
      this.currentScreen = this.screens.shift();
      this.currentScreen.resize();
      this.currentScreen.once(PhaserScreenEvent.SHOW, this.onScreenShow, this);
      this.currentScreen.show();
    }
    onTutorialsComplete() {
      this.scene.input.enabled = true;
      this.emit(TutorialManagerEvent.COMPLETE, this);
    }
    checkMatchForTutorial(step) {
      let {columns, rows} = this.gameplay.levelConfig.grid;
      let items = new ItemsManager(columns, rows);
      step.cells.forEach((cell) => {
        let item = this.gameplay.items.mainItems.getAt(cell.column, cell.row);
        if (item) {
          items.add(item);
        }
      });
      return !!MatchHinter.findBestMove(items);
    }
    onScreenShow(screen2) {
      switch (screen2.step.type) {
        case TutorialStepType.MATCH:
          this.onMatchTutorialShow(screen2);
          break;
        case TutorialStepType.BOOSTER:
          this.onBoosterTutorialShow(screen2);
          break;
        case TutorialStepType.UNDO:
          this.onUndoTutorialShow(screen2);
          break;
        case TutorialStepType.GOALS:
        case TutorialStepType.MOVES:
        case TutorialStepType.CHEF:
          this.gameplay.input.once(Phaser.Input.Events.POINTER_DOWN, this.hideCurrentScreenAndShowNext, this);
          break;
        default:
          break;
      }
    }
    hideCurrentScreenAndShowNext() {
      this.hideCurrentScreen({showNextScreen: true});
    }
    onMatchTutorialShow(screen2) {
      let {swapCell_1, swapCell_2} = screen2.step;
      let cells = [
        {column: swapCell_1.x, row: swapCell_1.y},
        {column: swapCell_2.x, row: swapCell_2.y}
      ];
      this.restrictSwaps(cells);
      this.gameplay.isLocked = false;
      if (screen2.step.showHint) {
        this.gameplay.hint.start();
      }
      this.gameplay.events.once(GameplayEvent.SWAP_COMPLETE, () => {
        this.restoreSwaps();
        this.hideCurrentScreen({showNextScreen: false});
      });
      this.gameplay.events.once(GameplayEvent.TURN_COMPLETE, () => {
        this.showNextScreen();
      });
    }
    onBoosterTutorialShow(screen2) {
      let boosterScreen = screen2;
      let step = screen2.step;
      this.scene.input.enabled = true;
      this.scene.pauseButton.disableInput();
      this.gameplay.gui.boostersPanel.killIconsExcept(step.boosterType);
      let booster = this.gameplay.boosters.getBooster(step.boosterType);
      if (booster.num < 2) {
        booster.num = 2;
      }
      boosterScreen.interactiveZone.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
        let handCell = {column: step.boosterCell.x, row: step.boosterCell.y};
        this.gameplay.boosters.setTutorialMode(step.boosterType, handCell);
        this.gameplay.gui.boostersPanel.reviveAllIcons();
        this.hideCurrentScreen({showNextScreen: true});
        this.scene.pauseButton.enableInput();
        this.scene.audio.playClick();
      });
    }
    onUndoTutorialShow(screen2) {
      this.scene.input.enabled = true;
      this.scene.pauseButton.disableInput();
      let undo = this.scene.game.boosters.getByType(BoosterType.UNDO);
      if (undo.num < 2) {
        undo.num = 2;
      }
      screen2.interactiveZone.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
        this.gameplay.applyUndo();
        this.hideCurrentScreen({showNextScreen: true});
        this.scene.pauseButton.enableInput();
        this.scene.audio.playClick();
      });
    }
    hideCurrentScreen(options) {
      this.currentScreen.once(PhaserScreenEvent.HIDE_COMPLETE, () => {
        this.currentScreen.destroy();
        this.currentScreen = null;
        if (options.showNextScreen) {
          this.showNextScreen();
        }
      });
      this.currentScreen.hide();
    }
    restrictSwaps(allowedCells) {
      this.gameplay.items.mainItems.forEach((item) => {
        let allowSwap = allowedCells.some((cell) => cell.row === item.row && cell.column === item.column);
        item.setData("wasSwappable", item.isSwappable);
        item.isSwappable = allowSwap;
      });
    }
    restoreSwaps() {
      this.gameplay.items.mainItems.forEach((item) => {
        item.isSwappable = item.getData("wasSwappable");
      });
    }
    skip() {
      var _a;
      this.cancelTutorialChanges();
      (_a = this.currentScreen) == null ? void 0 : _a.destroy();
      this.screens.forEach((screen2) => screen2.destroy());
      this.screens = null;
      this.onTutorialsComplete();
    }
    cancelTutorialChanges() {
      switch (this.currentScreen.step.type) {
        case TutorialStepType.MATCH:
          this.restoreSwaps();
          this.gameplay.isLocked = true;
          this.gameplay.hint.cancelSmooth();
          break;
        case TutorialStepType.BOOSTER:
          this.scene.pauseButton.enableInput();
          this.gameplay.gui.boostersPanel.reviveAllIcons();
          this.gameplay.boosters.cancelTutorialMode();
          this.gameplay.onTutorialSkip();
          break;
        case TutorialStepType.UNDO:
          this.scene.pauseButton.enableInput();
          break;
        case TutorialStepType.CHEF:
        case TutorialStepType.GOALS:
        case TutorialStepType.MOVES:
          this.gameplay.input.off(Phaser.Input.Events.POINTER_DOWN, this.hideCurrentScreenAndShowNext, this);
          break;
        default:
          break;
      }
    }
    hasMatchTutorial() {
      return this.config.steps.some((step) => step.type === TutorialStepType.MATCH);
    }
    getCurrentTutorialType() {
      var _a;
      return (_a = this.currentScreen) == null ? void 0 : _a.tutorialType;
    }
    destroy() {
      this.gameplay.events.off(GameplayEvent.SWAP_COMPLETE);
      this.gameplay.events.off(GameplayEvent.TURN_COMPLETE);
      this.gameplay.input.off(Phaser.Input.Events.POINTER_DOWN, this.hideCurrentScreenAndShowNext, this);
      if (this.currentScreen) {
        this.currentScreen.off(PhaserScreenEvent.HIDE_COMPLETE);
        this.currentScreen.off(PhaserScreenEvent.SHOW, this.onScreenShow, this);
      }
    }
  };

  // src/scenes/gameplayGui/BoosterHintWarning.ts
  var BoosterHintWarning = class extends Phaser.GameObjects.Text {
    constructor(scene, content, style) {
      super(scene, 0, 0, content, style);
    }
    show() {
      this.scene.tweens.killTweensOf(this);
      this.revive();
      this.alpha = 0;
      this.scene.tweens.add({
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1,
        onComplete: () => {
          this.fadeOut({delay: 700});
        }
      });
      this.scale = 0.66;
      this.scene.tweens.add({
        targets: this,
        duration: 800,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.4],
        scale: 1
      });
      this.scene.tweens.add({
        targets: this,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        y: this.y - this.height * 0.5
      });
    }
    fadeOut(options) {
      this.scene.tweens.add({
        delay: options.delay,
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        y: "-=10",
        onComplete: () => {
          this.kill();
        }
      });
    }
  };

  // src/scenes/levelMap/startLevelPopup/goalsPanel/GoalView.ts
  var GoalView3 = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.name = "goal";
      this.addBack();
      this.addIcon();
      this.addNumLabel();
      this.setSize(this.back.width, this.back.height);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "popups", "popups/start_level/Cookie Background Box.png");
      this.add(this.back);
    }
    addIcon() {
      this.icon = this.scene.add.image(0, 0, "popups", "popups/start_level/goals/apple.png");
      this.add(this.icon);
    }
    addNumLabel() {
      let content = "0";
      this.numLabel = this.scene.add.bitmapText(0, 0, BitmapFont.POPUP_GOAL_LABELS, content, 29);
      this.numLabel.setOrigin(0.5, 0.5);
      this.numLabel.x = 32;
      this.numLabel.y = this.back.bottom - 3;
      this.add(this.numLabel);
    }
    updateData(goalType, goalNum) {
      this.icon.setFrame(`popups/start_level/goals/${goalType.toLowerCase()}.png`);
      this.numLabel.text = goalNum.toString();
    }
    setEmpty() {
      this.icon.kill();
      this.numLabel.kill();
      this.back.alpha = 0.4;
    }
    resetEmpty() {
      this.icon.revive();
      this.numLabel.revive();
      this.back.alpha = 1;
    }
  };

  // src/scenes/levelMap/startLevelPopup/goalsPanel/GoalsPanel.ts
  var GoalsPanel2 = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.name = "goals_panel";
      this.addBack();
      this.addTitle();
      this.addSubtitle();
      this.addGoalViews();
      this.addChef();
      this.alignSubtitle();
      this.bringToTop(this.title);
      this.bringToTop(this.subtitle);
      this.setSize(this.back.width, this.back.height);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "popups", "popups/start_level/goal_panel_back.png");
      this.add(this.back);
    }
    addTitle() {
      let content = this.scene.texts.start_level_popup.goal;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "36px",
        color: "#5F3331",
        align: "center"
      };
      this.title = this.scene.add.text(0, 0, content, style);
      this.title.setOrigin(0.5, 0.5);
      this.title.x = 85;
      this.title.y = -70;
      this.add(this.title);
    }
    addSubtitle() {
      let content = this.scene.texts.start_level_popup.collect;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "28px",
        color: "#A23D2C",
        align: "center"
      };
      this.subtitle = this.scene.add.text(0, 0, content, style);
      this.subtitle.setOrigin(0.5, 0.5);
      this.subtitle.x = this.title.x;
      this.subtitle.y = this.title.y + 36;
      this.add(this.subtitle);
      this.adjustSubtitleSize();
    }
    adjustSubtitleSize() {
      let maxWidth = 286;
      this.subtitle.scale = Math.min(1, maxWidth / this.subtitle.width);
    }
    addGoalViews() {
      let startX = this.back.right - 80;
      let dx = 100;
      this.goalViews = times_default(3, (index) => {
        let view = new GoalView3(this.scene);
        view.x = startX - dx * index;
        view.y = 40;
        view.setEmpty();
        this.add(view);
        return view;
      });
    }
    addChef() {
      this.chef = this.scene.add.image(0, 0, "popups", "popups/Chef Cherry.png");
      this.chef.x = -146;
      this.chef.y = this.back.bottom - 7;
      this.add(this.chef);
    }
    updateGoals(goals) {
      this.goalViews.forEach((view, index) => {
        let goal = goals[index];
        if (goal) {
          view.resetEmpty();
          view.updateData(goal.type, goal.targetNum);
        } else {
          view.setEmpty();
        }
      });
    }
    onLanguageChange() {
      this.title.text = this.scene.texts.start_level_popup.goal;
      this.subtitle.text = this.scene.texts.start_level_popup.collect;
      this.adjustSubtitleSize();
      this.alignSubtitle();
    }
    alignSubtitle() {
      let top = this.title.bottom;
      let bottom = this.goalViews[0].top;
      let height = bottom - top;
      this.subtitle.y = top + height / 2 - 4;
    }
  };

  // src/scenes/levelMap/startLevelPopup/pregameBoostersPanel/PregameBoosterHint.ts
  var PregameBoosterHint = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene, 0, 0);
      this.addBack();
      this.addText();
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "popups", "popups/start_level/boosters/booster_hint_popover.png");
      this.add(this.back);
    }
    addText() {
      let content = this.scene.texts.start_level_popup.booster_hint;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "22px",
        color: "#ffffff",
        align: "center",
        padding: {x: 0, y: 3}
      };
      this.text = this.scene.add.text(0, 0, content, style);
      this.text.setOrigin(0.5, 0.5);
      this.text.setShadow(0, 2, "rgba(0,0,0,0.2)");
      this.text.y = -1;
      this.add(this.text);
      this.updateText(content);
    }
    updateText(content) {
      this.text.text = content;
      this.text.scale = Math.min(1, this.back.width * 0.85 / this.text.width);
    }
  };

  // src/scenes/levelMap/startLevelPopup/pregameBoostersPanel/PregameBoosterIcon.ts
  var PregameBoosterIconState;
  (function(PregameBoosterIconState2) {
    PregameBoosterIconState2["SELECTED"] = "SELECTED";
    PregameBoosterIconState2["UNSELECTED"] = "UNSELECTED";
    PregameBoosterIconState2["EMPTY"] = "EMPTY";
  })(PregameBoosterIconState || (PregameBoosterIconState = {}));
  var PregameBoosterIcon = class extends ComplexButton {
    constructor(scene, booster) {
      super(scene, "popups", "popups/start_level/boosters/booster_bubble.png");
      this.isLocked = false;
      this.scene.sys.updateList.add(this);
      this.name = `pregame_booster_${booster.type}`;
      this.booster = booster;
      this.booster.on(PregameBoosterEvent.NUM_CHANGED, this.onBoosterNumChange, this);
      this.addIcon("popups", this.getIconFrameName(booster.type), 0, -3);
      this.moveDown(this.icon);
      this.addSparks();
      this.addNumLabel();
      this.addPlusButton();
      this.addCheck();
      this.addHint();
      this.addRewardText();
      this.setInitialState();
    }
    onBoosterNumChange() {
      let num = this.booster.num;
      if (num > 0) {
        this.setIconState(PregameBoosterIconState.UNSELECTED);
      } else {
        this.setIconState(PregameBoosterIconState.EMPTY);
      }
      this.numLabel.text = num.toString();
    }
    getIconFrameName(type) {
      let map = {
        [PregameBoosterType.STRIPES]: "popups/start_level/boosters/stripes.png",
        [PregameBoosterType.BOMB]: "popups/start_level/boosters/bomb.png",
        [PregameBoosterType.SUPER_SPHERE]: "popups/start_level/boosters/super_sphere.png"
      };
      return map[type];
    }
    addSparks() {
      this.sparks = this.scene.add.image(0, 0, "popups", "popups/start_level/boosters/bubble_sparks.png");
      this.add(this.sparks);
    }
    addNumLabel() {
      let content = this.booster.num.toString();
      this.numLabel = this.scene.add.bitmapText(0, 0, BitmapFont.PREGAME_BOOSTERS_LABELS, content, 40);
      this.numLabel.setOrigin(0.5, 0.5);
      this.numLabel.x = 50;
      this.numLabel.y = 48;
      this.numLabel.originalX = this.numLabel.x;
      this.add(this.numLabel);
    }
    addRewardText() {
      let content = `+1`;
      this.rewardText = this.scene.add.bitmapText(0, 0, BitmapFont.PREGAME_BOOSTERS_LABELS, content, 38);
      this.rewardText.setOrigin(0.5);
      this.rewardText.kill();
      this.rewardText.x = -5;
      this.add(this.rewardText);
    }
    addPlusButton() {
      this.plus = this.scene.add.image(0, 0, "popups", "popups/start_level/boosters/plus_button.png");
      this.plus.x = 54;
      this.plus.y = 46;
      this.add(this.plus);
    }
    addCheck() {
      this.check = this.scene.add.image(0, 0, "popups", "popups/start_level/boosters/check_button.png");
      this.check.x = this.plus.x;
      this.check.y = this.plus.y;
      this.add(this.check);
    }
    addHint() {
      this.hint = new PregameBoosterHint(this.scene);
      this.hint.y = -70;
      this.hint.originalY = this.hint.y;
      this.hint.kill();
      this.add(this.hint);
    }
    setLocked(value) {
      this.isLocked = value;
      if (value) {
        this.plus.kill();
        this.numLabel.kill();
        this.icon.setFrame("popups/start_level/boosters/locked.png");
      } else {
        this.icon.setFrame(this.getIconFrameName(this.booster.type));
        this.setInitialState();
      }
    }
    setInitialState() {
      if (this.booster.num === 0) {
        this.setIconState(PregameBoosterIconState.EMPTY);
      } else {
        this.setIconState(PregameBoosterIconState.UNSELECTED);
      }
    }
    setIconState(state) {
      this.state = state;
      switch (this.state) {
        case PregameBoosterIconState.EMPTY:
          this.setEmptyState();
          break;
        case PregameBoosterIconState.SELECTED:
          this.numLabel.visible = false;
          this.showItem(this.check);
          this.sparks.revive();
          this.plus.visible = false;
          break;
        case PregameBoosterIconState.UNSELECTED:
          this.check.visible = false;
          this.showItem(this.numLabel);
          this.sparks.kill();
          this.plus.visible = false;
          break;
        default:
          break;
      }
    }
    setEmptyState() {
      this.plus.visible = true;
      this.check.visible = false;
      this.sparks.kill();
    }
    showItem(item) {
      item.visible = true;
      item.alpha = 0;
      item.scale = 0.66;
      this.scene.tweens.add({
        targets: item,
        alpha: {value: 1, ease: Phaser.Math.Easing.Cubic.Out, duration: 150},
        scale: {value: 1, ease: Phaser.Math.Easing.Back.Out, duration: 400}
      });
    }
    onRewardArrive(rewardNum) {
      this.setIconState(PregameBoosterIconState.SELECTED);
      this.scene.time.delayedCall(300, () => {
        this.scene.audio.play(GameSoundKey.TWINKLE_3, {volume: 0.45});
        this.showRewardText(rewardNum);
      });
    }
    showRewardText(rewardNum) {
      this.rewardText.text = `+${rewardNum}`;
      this.rewardText.y = -20;
      this.rewardText.revive();
      this.scene.tweens.killTweensOf(this.rewardText);
      this.rewardText.alpha = 0;
      this.scene.tweens.add({
        targets: this.rewardText,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1,
        onComplete: () => {
          this.scene.tweens.add({
            delay: 1200,
            targets: this.rewardText,
            duration: 300,
            ease: Phaser.Math.Easing.Cubic.Out,
            alpha: 0,
            onComplete: () => {
              this.rewardText.kill();
            }
          });
        }
      });
      this.rewardText.scale = 0.5;
      this.scene.tweens.add({
        targets: this.rewardText,
        duration: 900,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.5],
        scale: 1
      });
      this.scene.tweens.add({
        targets: this.rewardText,
        duration: 1500,
        ease: Phaser.Math.Easing.Linear,
        y: "-=40"
      });
    }
    preUpdate(time, delta) {
      if (this.sparks.visible) {
        this.sparks.angle += 0.24 * delta;
      }
    }
    shakeNumLabel() {
      this.numLabel.x = this.numLabel.originalX;
      this.scene.tweens.killTweensByProperty(this.numLabel, "x");
      this.scene.tweens.add({
        targets: this.numLabel,
        duration: 44,
        ease: Phaser.Math.Easing.Sine.InOut,
        x: "+=7",
        repeat: 3,
        yoyo: true
      });
    }
    onLanguageChange() {
      this.hint.updateText(this.scene.texts.start_level_popup.booster_hint);
    }
    preDestroy() {
      this.scene.sys.updateList.remove(this);
      this.booster.off(PregameBoosterEvent.NUM_CHANGED, this.onBoosterNumChange, this);
      super.preDestroy();
    }
  };

  // src/scenes/levelMap/startLevelPopup/pregameBoostersPanel/PregameBoostersPanel.ts
  var PregameBoostersPanelEvent;
  (function(PregameBoostersPanelEvent2) {
    PregameBoostersPanelEvent2["LOCKED_BOOSTER_CLICK"] = "__LOCKED_BOOSTER_CLICK";
    PregameBoostersPanelEvent2["ADD_BOOSTER_CLICK"] = "__ADD_BOOSTER_CLICK";
    PregameBoostersPanelEvent2["BOOSTER_SELECTED"] = "__BOOSTER_SELECTED";
  })(PregameBoostersPanelEvent || (PregameBoostersPanelEvent = {}));
  var PregameBoostersPanel = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.slotSize = 160;
      this.name = "pregame_boosters";
      this.addIcons();
      this.alignIcons();
      this.setSize(this.icons.length * this.slotSize, this.slotSize);
    }
    addIcons() {
      this.icons = this.scene.game.pregameBoosters.items.map((booster) => {
        let icon = new PregameBoosterIcon(this.scene, booster);
        icon.on(ButtonEvent.RELEASE, this.onIconClick, this);
        this.add(icon);
        return icon;
      });
    }
    onIconClick(icon) {
      if (icon.isLocked) {
        this.emit(PregameBoostersPanelEvent.LOCKED_BOOSTER_CLICK, icon);
        return;
      }
      if (icon.state === PregameBoosterIconState.EMPTY) {
        this.emit(PregameBoostersPanelEvent.ADD_BOOSTER_CLICK, icon.booster);
      } else if (icon.state === PregameBoosterIconState.UNSELECTED) {
        icon.setIconState(PregameBoosterIconState.SELECTED);
        this.emit(PregameBoostersPanelEvent.BOOSTER_SELECTED, icon);
      } else {
        icon.setIconState(PregameBoosterIconState.UNSELECTED);
      }
    }
    alignIcons() {
      this.gridAlign({
        cellWidth: this.slotSize,
        position: Phaser.Display.Align.CENTER,
        x: this.slotSize / 2,
        y: this.slotSize / 2
      });
    }
    getSelectedBoosters() {
      return this.icons.filter((icon) => icon.state === PregameBoosterIconState.SELECTED).map((icon) => icon.booster.type);
    }
    getByType(boosterType) {
      return this.icons.find((icon) => icon.booster.type === boosterType);
    }
    updateData(boostersData, boosterHintsData) {
      Object.keys(boostersData).forEach((boosterType) => {
        let isLocked = !boostersData[boosterType];
        let icon = this.getByType(boosterType);
        icon.setLocked(isLocked);
        if (boosterHintsData.show && boosterHintsData[boosterType]) {
          icon.hint.revive();
        } else {
          icon.hint.kill();
        }
      });
    }
    unselectAll() {
      this.icons.forEach((icon) => {
        if (icon.state === PregameBoosterIconState.SELECTED) {
          icon.setIconState(PregameBoosterIconState.UNSELECTED);
        }
      });
    }
    onLanguageChange() {
      this.icons.forEach((icon) => icon.onLanguageChange());
    }
    playHintsAnimation() {
      this.getActiveHints().forEach((hint) => {
        hint.angle = -3;
        hint.scale = 1;
        this.scene.tweens.add({
          targets: hint,
          duration: 600,
          ease: Phaser.Math.Easing.Sine.InOut,
          angle: hint.angle * -1,
          scale: 1.03,
          yoyo: true,
          repeat: -1
        });
      });
    }
    stopHintsAnimation() {
      this.getActiveHints().forEach((hint) => {
        this.scene.tweens.killTweensOf(hint);
      });
    }
    getActiveHints() {
      return this.icons.filter((icon) => icon.hint.visible).map((icon) => icon.hint);
    }
  };

  // src/scenes/gameplayGui/boosters/PregameBoosterLockedPopover.ts
  var PregameBoosterLockedPopover = class extends Phaser.GameObjects.Container {
    constructor(scene, backTexture, backFrame, textContent) {
      super(scene);
      this.name = "booster_locked_popover";
      this.addBack(backTexture, backFrame);
      this.addText(textContent);
      this.setSize(this.back.displayWidth, this.back.displayHeight);
    }
    addBack(backTexture, backFrame) {
      this.back = this.scene.add.image(0, 0, backTexture, backFrame);
      this.add(this.back);
    }
    addText(textContent) {
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "26px",
        color: "#B35F44",
        align: "center"
      };
      this.text = this.scene.add.text(0, 0, textContent, style);
      this.text.setOrigin(0.5, 0.5);
      this.text.setWordWrapWidth(300, true);
      this.text.scale = Math.min(1, 110 / this.text.height);
      this.text.y = this.back.top + 66;
      this.add(this.text);
    }
    show(options) {
      this.scene.tweens.killTweensOf(this);
      this.revive();
      this.alpha = 0;
      this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.scale = 0.66;
      this.scene.tweens.add({
        targets: this,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1,
        onComplete: () => {
          this.hide(options.duration);
        }
      });
    }
    hide(delay) {
      this.scene.tweens.add({
        delay,
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.kill();
        }
      });
    }
    forceHide() {
      this.scene.tweens.killTweensOf(this);
      this.kill();
    }
    updateContent(content) {
      this.text.text = content;
    }
  };

  // src/scenes/levelMap/startLevelPopup/StartLevelPopup.ts
  var StartLevelPopup = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.name = "start_level_popup";
      this.addBack();
      this.addTitleBack();
      this.addLevelTypeText();
      this.addLevelNumberText();
      this.addCloseButton();
      this.addGoalsPanel();
      this.addPregameBoosters();
      this.addBoosterLockedPopover();
      this.addPlayButton();
      this.addSkull();
      this.addTutorialHand();
      this.alignItems();
      this.bringToTop(this.goalsPanel);
      this.bringToTop(this.levelNumberText);
      this.bringToTop(this.boosterLockedPopover);
      this.setSize(this.back.width, this.back.height);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "popups", "popups/popup_back.png");
      this.add(this.back);
    }
    addTitleBack() {
      this.titleBack = this.scene.add.image(0, 0, "popups", "popups/headline_flag_pink.png");
      this.titleBack.y = this.back.top + 30;
      this.add(this.titleBack);
    }
    addLevelTypeText() {
      let content = this.scene.texts.start_level_popup.classic_level;
      let style = this.getTitleTextStyle();
      this.levelTypeText = this.scene.add.text(0, 0, content, style);
      this.levelTypeText.setOrigin(0.5, 0.5);
      this.levelTypeText.scale = Math.min(1, 210 / this.levelTypeText.width);
      this.levelTypeText.x = this.titleBack.x;
      this.levelTypeText.y = this.titleBack.y - 20;
      this.add(this.levelTypeText);
    }
    addLevelNumberText() {
      let content = "1";
      let style = __spreadProps(__spreadValues({}, this.getTitleTextStyle()), {
        fontSize: "38px"
      });
      this.levelNumberText = this.scene.add.text(0, 0, content, style);
      this.levelNumberText.setOrigin(0.5, 0.5);
      this.levelNumberText.x = this.titleBack.x;
      this.levelNumberText.y = this.levelTypeText.y + 32;
      this.add(this.levelNumberText);
    }
    getTitleTextStyle() {
      return {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "28px",
        color: "#ffffff",
        align: "center",
        strokeThickness: 6,
        stroke: "#F66986"
      };
    }
    addCloseButton() {
      this.closeButton = this.scene.add.button("popups", "popups/Close Button.png", this);
      this.closeButton.x = this.back.right - 60;
      this.closeButton.y = this.back.top + 46;
    }
    addGoalsPanel() {
      this.goalsPanel = new GoalsPanel2(this.scene);
      this.goalsPanel.y = -120;
      this.add(this.goalsPanel);
    }
    addPregameBoosters() {
      this.pregameBoosters = new PregameBoostersPanel(this.scene);
      this.pregameBoosters.x = -this.pregameBoosters.width / 2;
      this.pregameBoosters.y = 5;
      this.pregameBoosters.on(PregameBoostersPanelEvent.LOCKED_BOOSTER_CLICK, this.onLockedBoosterIconClick, this);
      this.add(this.pregameBoosters);
    }
    onLockedBoosterIconClick(icon) {
      this.boosterLockedPopover.x = this.pregameBoosters.x + icon.x;
      this.boosterLockedPopover.updateContent(this.getPopoverContent(icon.booster.type));
      this.boosterLockedPopover.show({duration: 1500});
    }
    addBoosterLockedPopover() {
      let textContent = this.getPopoverContent();
      this.boosterLockedPopover = new PregameBoosterLockedPopover(this.scene, "popups", "popups/start_level/boosters/booster_locked_popover.png", textContent);
      this.boosterLockedPopover.x = this.pregameBoosters.x + this.pregameBoosters.displayWidth / 2;
      this.boosterLockedPopover.y = this.pregameBoosters.y + 14;
      this.boosterLockedPopover.kill();
      this.add(this.boosterLockedPopover);
    }
    getPopoverContent(boosterType = PregameBoosterType.STRIPES) {
      let unlockLevel = window.game.config.pregame_boosters_unlock[boosterType];
      return this.scene.texts.booster_lock.replace("#", unlockLevel.toString());
    }
    addPlayButton() {
      this.playButton = this.scene.add.complexButton("popups", "popups/Pink-Button-Long.png", this);
      this.playButton.back.scale = 0.9;
      this.playButton.addIcon("popups", "popups/play_icon.png");
      this.playButton.y = 234;
    }
    addSkull() {
      this.skull = this.scene.add.image(0, 0, "popups", "popups/start_level/skull_button.png");
      this.skull.x = this.playButton.x + 106;
      this.skull.y = this.playButton.y - 40;
      this.skull.kill();
      this.add(this.skull);
    }
    addTutorialHand() {
      this.tutorialHand = new TapTutorialHand(this.scene, "popups", "popups/start_level/hand.png");
      this.tutorialHand.kill();
      this.add(this.tutorialHand);
    }
    alignItems() {
      this.alignPregameBoosters();
    }
    alignPregameBoosters() {
      let top = this.goalsPanel.y + this.goalsPanel.height / 2;
      let bottom = this.playButton.top;
      let height = bottom - top;
      this.pregameBoosters.y = top + (height - this.pregameBoosters.height) / 2 + 4;
    }
    updateData(data) {
      this.levelTypeText.text = data.isHard ? this.scene.texts.start_level_popup.hard_level : this.scene.texts.start_level_popup.classic_level;
      this.levelNumberText.text = data.levelNumber.toString();
      this.goalsPanel.updateGoals(data.goals);
      this.pregameBoosters.updateData(data.pregameBoosters, data.pregameBoostersHints);
      this.updateHardData(data);
      this.updateTutorialData(data);
    }
    updateHardData(data) {
      if (data.isHard) {
        this.levelTypeText.text = this.scene.texts.start_level_popup.hard_level;
        this.skull.revive();
      } else {
        this.levelTypeText.text = this.scene.texts.start_level_popup.classic_level;
        this.skull.kill();
      }
    }
    updateTutorialData(data) {
      if (data.levelNumber === 1 && data.levelComplete === false) {
        this.tutorialHand.revive();
        this.tutorialHand.x = this.playButton.x + 76;
        this.tutorialHand.y = this.playButton.y + 80;
      } else if (data.levelNumber === window.game.config.pregame_boosters_unlock.stripes) {
        let hasBooster = this.scene.game.pregameBoosters.getByType(PregameBoosterType.STRIPES).num > 0;
        if (data.levelComplete || hasBooster === false) {
          this.tutorialHand.kill();
          return;
        }
        this.tutorialHand.revive();
        this.tutorialHand.x = this.pregameBoosters.x + 150;
        this.tutorialHand.y = this.pregameBoosters.y + 160;
        this.pregameBoosters.once(PregameBoostersPanelEvent.BOOSTER_SELECTED, () => {
          this.tutorialHand.stopAnimation();
          this.scene.tweens.add({
            targets: this.tutorialHand,
            duration: 200,
            ease: Phaser.Math.Easing.Sine.InOut,
            alpha: 0,
            yoyo: true,
            onYoyo: () => {
              this.tutorialHand.x = this.playButton.x + 76;
              this.tutorialHand.y = this.playButton.y + 80;
              this.tutorialHand.playAnimation();
            }
          });
        });
      } else {
        this.tutorialHand.kill();
      }
    }
    onShow() {
      this.showChef(200);
      this.showPregameBoosters(150);
      this.showPlayButton(100);
      this.showSkull(200);
      this.showTutorialHand(500);
    }
    onHide() {
      this.scene.tweens.killTweensOf(this.goalsPanel.chef);
      this.pregameBoosters.off(PregameBoostersPanelEvent.BOOSTER_SELECTED);
      this.pregameBoosters.unselectAll();
      this.pregameBoosters.stopHintsAnimation();
      this.boosterLockedPopover.forceHide();
      this.tutorialHand.stopAnimation();
      this.tutorialHand.kill();
    }
    showChef(delay) {
      let chef = this.goalsPanel.chef;
      chef.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: chef,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      chef.scale = 0.75;
      this.scene.tweens.add({
        delay,
        targets: chef,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1,
        onComplete: () => {
          this.scene.tweens.add({
            targets: chef,
            duration: 600,
            ease: Phaser.Math.Easing.Sine.InOut,
            scaleX: 1.03,
            scaleY: 0.97,
            yoyo: true,
            repeat: -1
          });
        }
      });
    }
    showPregameBoosters(initialDelay) {
      this.pregameBoosters.icons.forEach((icon) => {
        let delay = initialDelay;
        icon.alpha = 0;
        this.scene.tweens.add({
          delay,
          targets: icon,
          duration: 150,
          ease: Phaser.Math.Easing.Cubic.Out,
          alpha: 1
        });
        icon.scale = 0.75;
        this.scene.tweens.add({
          delay,
          targets: icon,
          duration: 800,
          ease: Phaser.Math.Easing.Elastic.Out,
          easeParams: [0.1, 0.45],
          scale: 1
        });
      });
      this.pregameBoosters.playHintsAnimation();
    }
    showPlayButton(delay) {
      this.playButton.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.playButton,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.playButton.scale = 0.66;
      this.scene.tweens.add({
        delay,
        targets: this.playButton,
        duration: 800,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
    }
    showSkull(delay) {
      if (this.skull.visible === false) {
        return;
      }
      this.skull.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.skull,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.skull.scale = 0.66;
      this.scene.tweens.add({
        delay,
        targets: this.skull,
        duration: 800,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
    }
    showTutorialHand(delay) {
      if (this.tutorialHand.visible === false) {
        return;
      }
      this.tutorialHand.playAnimation(delay);
    }
    onLanguageChange() {
      this.goalsPanel.onLanguageChange();
      this.pregameBoosters.onLanguageChange();
      this.boosterLockedPopover.updateContent(this.getPopoverContent());
    }
  };

  // src/scenes/levelMap/startLevelPopup/SimplePiggyBankButton.ts
  var SimplePiggyBankButton = class extends ComplexButton {
    constructor(scene, atlas, frame, parent) {
      super(scene, atlas, frame, parent);
      this.input.hitArea.y -= this.back.displayHeight * Math.abs(this.back.originY - 0.5);
      this.addPopover();
      this.addParticles();
    }
    addPopover() {
      let back = this.scene.add.image(0, 0, "popups", "popups/start_level/piggy_bank/piggy_bank_popover.png");
      let text = this.createPopoverText(back.width * 0.8);
      text.y = -32;
      this.popover = this.scene.add.container(0, 0, [back, text]);
      this.popover.text = text;
      this.popover.x = -26;
      this.popover.y = -124;
      this.popover.originalY = this.popover.y;
      this.add(this.popover);
    }
    createPopoverText(maxWidth) {
      let content = this.scene.texts.piggy_bank.full;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "24px",
        color: "#ffffff",
        align: "center",
        padding: {x: 0, y: 2}
      };
      let text = this.scene.add.text(0, 0, content, style);
      text.setOrigin(0.5, 0.5);
      text.setShadow(0, 2, "rgba(0,0,0,0.2)");
      text.scale = Math.min(1, maxWidth / text.width);
      return text;
    }
    addParticles() {
      this.circlesManager = this.scene.add.particles("popups");
      this.circlesManager.setPosition(0, -50);
      this.addAt(this.circlesManager, 0);
      this.circles = this.circlesManager.createEmitter({
        frame: "popups/particles/circle_fx_2.png",
        scale: {start: 0.4, end: 2, ease: Ease.ExpoOut},
        alpha: {start: 0.2, end: 0, ease: Ease.CubicOut},
        lifespan: 1600,
        on: false
      });
      this.sparksManager = this.scene.add.particles("popups");
      this.add(this.sparksManager);
      this.sparks = this.sparksManager.createEmitter({
        speed: 30,
        frame: "popups/particles/star_1.png",
        lifespan: {min: 800, max: 1400},
        rotate: {start: 0, end: 180, random: true},
        angle: -90,
        scale: {start: 0.8, end: 0, ease: Ease.ExpoIn},
        alpha: {start: 0, end: 1, ease: Ease.ExpoOut},
        frequency: 300,
        on: false
      });
      this.sparks.setEmitZone({
        source: new Phaser.Geom.Circle(0, -50, this.back.displayWidth * 0.4),
        type: "random",
        quantity: 360
      });
    }
    startPopoverAnimation() {
      let deltaAngle = 5;
      this.popover.angle = -deltaAngle;
      this.scene.tweens.killTweensOf(this.popover);
      this.scene.tweens.add({
        targets: this.popover,
        duration: 900,
        ease: Phaser.Math.Easing.Sine.InOut,
        angle: deltaAngle,
        yoyo: true,
        repeat: -1
      });
    }
    stopPopoverAnimation() {
      this.scene.tweens.killTweensOf(this.popover);
    }
    showFullPopover(delay) {
      this.popover.alpha = 0;
      this.popover.y = this.popover.originalY - 50;
      this.scene.tweens.add({
        delay,
        targets: this.popover,
        duration: 150,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 1,
        y: this.popover.originalY
      });
      this.popover.scale = 0.75;
      this.scene.tweens.add({
        delay,
        targets: this.popover,
        duration: 1e3,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.4],
        scale: 1
      });
    }
    hideFullPopover() {
      if (this.popover.visible === false) {
        return;
      }
      this.scene.tweens.killTweensOf(this.popover);
      this.scene.tweens.add({
        targets: this.popover,
        y: "-=10",
        duration: 150,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 0,
        onComplete: () => {
          this.popover.kill();
        }
      });
    }
    onLanguageChange() {
      this.popover.text.text = this.scene.texts.piggy_bank.full;
    }
    onShow() {
      this.sparks.on = true;
      this.startPopoverAnimation();
      this.back.scaleX = 1;
      this.back.scaleY = 1;
      this.scene.tweens.add({
        targets: this.back,
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        scaleX: 1.05,
        scaleY: 0.95,
        yoyo: true,
        repeat: -1,
        onRepeat: () => {
        }
      });
    }
    onHide() {
      this.sparks.on = false;
      this.stopPopoverAnimation();
      this.scene.tweens.killTweensOf(this.back);
    }
    showCircleFx() {
      this.circles.explode(1, 0, 0);
    }
    updatePopoverContent(content) {
      this.popover.text.setText(content);
    }
  };

  // src/scenes/levelMap/startLevelPopup/StartLevelScreen.ts
  var StartLevelScreenEvent;
  (function(StartLevelScreenEvent2) {
    StartLevelScreenEvent2["SHOW_PIGGY_BANK_SCREEN"] = "__SHOW_PIGGY_BANK_SCREEN";
  })(StartLevelScreenEvent || (StartLevelScreenEvent = {}));
  var StartLevelScreen = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "start_level_screen",
        backgroundKey: "popups",
        backgroundFrame: "popups/black_rect.png",
        backgroundAlpha: 0.85
      });
      this.isDeactivated = false;
      this.addParticles();
      this.addWidgetButton();
      this.addPopup();
      this.addPiggyBankButton();
    }
    addParticles() {
      this.particles = this.scene.add.particles("popups");
      this.add(this.particles);
      this.skulls = this.particles.createEmitter({
        frame: "popups/start_level/skull_icon.png",
        angle: -90,
        speed: 50,
        lifespan: {min: 2e3, max: 2500},
        alpha: {start: 0, end: 0.5, ease: CustomEase.BellCubic},
        scale: {start: 0.25, end: 1},
        rotate: {min: -20, max: 20},
        frequency: 300,
        on: false
      });
    }
    addWidgetButton() {
      let config2 = window.game.config.widget_button.start_level_screen;
      if (config2.enabled === false) {
        return;
      }
      this.widgetButton = this.scene.add.button("popups", config2.frame, this);
      this.widgetButton.on(ButtonEvent.RELEASE, this.onWidgetButtonClick, this);
      this.add(this.widgetButton);
      this.pin(this.widgetButton, 0.5, 1);
    }
    onWidgetButtonClick() {
    }
    addPopup() {
      this.popup = new StartLevelPopup(this.scene);
      this.popup.closeButton.on(ButtonEvent.PRESS, this.hide, this);
      this.popup.originalScale = 1;
      this.pin(this.popup, 0.5, 0.51);
      this.add(this.popup);
    }
    addPiggyBankButton() {
      if (!this.scene.game.piggyBank) {
        return;
      }
      this.piggyBankButton = new SimplePiggyBankButton(this.scene, "popups", "popups/start_level/piggy_bank/button_piggy_2.png");
      this.piggyBankButton.on(ButtonEvent.PRESS, this.onPiggyBankClick, this);
      this.add(this.piggyBankButton);
      this.pin(this.piggyBankButton, 1, 1, -85, -30);
    }
    onPiggyBankClick() {
      this.emit(StartLevelScreenEvent.SHOW_PIGGY_BANK_SCREEN, this);
    }
    resize() {
      super.resize();
      this.resizePopup();
      this.resizeSkullsEmitZone();
      if (this.piggyBankButton) {
        this.piggyBankButton.originalY = this.piggyBankButton.y;
      }
    }
    resizePopup() {
      let maxHeight = this.screenHeight * 0.8;
      this.popup.scale = Math.min(1, maxHeight / this.popup.height);
      this.popup.originalScale = this.popup.scale;
      this.popup.originalY = this.popup.y;
    }
    resizeSkullsEmitZone() {
      let width = 500;
      let x = this.screenCenter.x - width / 2;
      this.skulls.setEmitZone({
        source: new Phaser.Geom.Rectangle(x, this.popup.y - this.popup.height / 2, width, 80),
        type: "random"
      });
    }
    updateData(levelNumber) {
      this.levelNumber = levelNumber;
      let data = this.getScreenData(levelNumber);
      if (data) {
        this.doUpdateData(data);
      } else {
        console.warn(`Config for level ${levelNumber} doesn't exist!`);
      }
      this.updatePiggyBankButton();
    }
    getScreenData(levelNumber) {
      let levelConfig = this.scene.game.levelConfigs.get(levelNumber);
      if (!levelConfig) {
        return null;
      }
      let data = {
        levelNumber,
        isHard: levelConfig.hard,
        levelComplete: false,
        goals: GoalUtils.createGoalsArray(levelConfig.goals),
        pregameBoosters: levelConfig.preGameBoosters,
        pregameBoostersHints: __spreadValues({
          show: false
        }, levelConfig.preGameBoostersHints)
      };
      let levelResult = this.scene.game.store.getLevelResult(levelNumber);
      if (levelResult) {
        data.levelComplete = true;
        data.pregameBoostersHints.show = levelResult.timesFailedNum > 0;
      }
      return data;
    }
    doUpdateData(data) {
      this.popup.updateData(data);
      if (data.isHard) {
        this.particles.revive();
      } else {
        this.particles.kill();
      }
    }
    updatePiggyBankButton() {
      if (!this.piggyBankButton || !this.scene.game.piggyBank) {
        return;
      }
      let shouldDisplay = this.shouldDisplayPiggyBank();
      if (shouldDisplay) {
        this.piggyBankButton.revive();
        this.piggyBankButton.updatePopoverContent(this.getPiggyBankPopoverContent());
      } else {
        this.piggyBankButton.kill();
      }
    }
    shouldDisplayPiggyBank() {
      let piggyBank = this.scene.game.piggyBank;
      return piggyBank.isFull() || piggyBank.isAlmostFull();
    }
    getPiggyBankPopoverContent() {
      let piggyBank = this.scene.game.piggyBank;
      return piggyBank.isFull() ? this.scene.texts.piggy_bank.full : Math.floor(piggyBank.getFullnessPercent() * 100) + "%";
    }
    show(options) {
      this.emitShowEvent();
      this.alpha = 1;
      this.revive();
      if (options.fadeInBackground) {
        this.showBackground();
      }
      this.showPopup();
      this.showPiggyBankButton(200);
      this.showWidgetButton(300);
      if (this.particles.visible) {
        this.skulls.on = true;
      }
    }
    showPopup() {
      this.popup.alpha = 0;
      this.scene.tweens.add({
        delay: 0,
        targets: this.popup,
        alpha: {value: 1, ease: Phaser.Math.Easing.Cubic.Out, duration: 200}
      });
      this.popup.scale = this.popup.originalScale * 0.85;
      this.scene.tweens.add({
        delay: 0,
        targets: this.popup,
        duration: 1e3,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: this.popup.originalScale
      });
      this.popup.y = this.popup.originalY + 100;
      this.scene.tweens.add({
        targets: this.popup,
        duration: 500,
        ease: Phaser.Math.Easing.Back.Out,
        y: this.popup.originalY
      });
      this.popup.onShow();
    }
    showPiggyBankButton(delay) {
      if (!this.piggyBankButton || this.piggyBankButton.visible === false) {
        return;
      }
      this.piggyBankButton.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.piggyBankButton,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1,
        onComplete: () => {
          this.piggyBankButton.showCircleFx();
          this.scene.audio.play(GameSoundKey.COIN_SPEND, {volume: 0.33});
        }
      });
      this.piggyBankButton.scale = 0.75;
      this.scene.tweens.add({
        delay,
        targets: this.piggyBankButton,
        duration: 1e3,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
      this.piggyBankButton.y = this.piggyBankButton.originalY + 100;
      this.scene.tweens.add({
        targets: this.piggyBankButton,
        duration: 500,
        ease: Phaser.Math.Easing.Back.Out,
        y: this.piggyBankButton.originalY
      });
      this.piggyBankButton.onShow();
      this.piggyBankButton.showFullPopover(delay + 100);
    }
    showWidgetButton(delay) {
      if (!this.widgetButton) {
        return;
      }
      this.widgetButton.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.widgetButton,
        alpha: {value: 1, ease: Phaser.Math.Easing.Cubic.Out, duration: 200}
      });
      this.widgetButton.scale = 0.85;
      this.scene.tweens.add({
        delay,
        targets: this.widgetButton,
        duration: 1e3,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
    }
    hide() {
      var _a;
      this.skulls.on = false;
      this.skulls.killAll();
      this.popup.onHide();
      (_a = this.piggyBankButton) == null ? void 0 : _a.onHide();
      this.scene.tweens.add({
        targets: this,
        duration: 100,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.kill();
          this.emit(PhaserScreenEvent.HIDE_COMPLETE, this);
        }
      });
    }
    activate() {
      if (this.isDeactivated === false) {
        return;
      }
      this.isDeactivated = false;
      this.particles.revive();
      this.activatePopup();
      this.activatePiggyBackButton();
      this.activateWidgetButton();
    }
    activatePopup() {
      this.popup.revive();
      this.popup.alpha = 0;
      this.scene.tweens.add({
        targets: this.popup,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.popup.y = this.popup.originalY + 50;
      this.scene.tweens.add({
        targets: this.popup,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        y: this.popup.originalY
      });
    }
    activatePiggyBackButton() {
      if (!this.piggyBankButton || !this.scene.game.piggyBank) {
        return;
      }
      if (this.shouldDisplayPiggyBank() === false) {
        this.piggyBankButton.kill();
        return;
      }
      this.piggyBankButton.revive();
      this.piggyBankButton.alpha = 0;
      this.scene.tweens.add({
        targets: this.piggyBankButton,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.piggyBankButton.y = this.piggyBankButton.originalY - 50;
      this.scene.tweens.add({
        targets: this.piggyBankButton,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        y: this.piggyBankButton.originalY
      });
    }
    activateWidgetButton() {
      if (!this.widgetButton) {
        return;
      }
      this.widgetButton.revive();
      this.widgetButton.alpha = 0;
      this.scene.tweens.add({
        targets: this.widgetButton,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.widgetButton.scale = 0.85;
      this.scene.tweens.add({
        targets: this.widgetButton,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1
      });
    }
    deactivate() {
      var _a, _b;
      if (this.isDeactivated) {
        return;
      }
      this.isDeactivated = true;
      this.popup.kill();
      this.particles.kill();
      this.skulls.killAll();
      (_a = this.piggyBankButton) == null ? void 0 : _a.kill();
      (_b = this.widgetButton) == null ? void 0 : _b.kill();
    }
    onLanguageChange() {
      this.popup.onLanguageChange();
      this.piggyBankButton.onLanguageChange();
    }
  };

  // src/scenes/levelMap/livesPopup/offers/LivesOffer.ts
  var LivesOffer = class extends Phaser.GameObjects.Container {
    constructor(scene, options) {
      super(scene);
      this.options = options;
      this.name = this.options.offerId;
      this.addBack();
      this.addLifeIcon();
      this.addLivesText();
      this.addButton();
      this.addSeparator();
      this.bringToTop(this.button);
      this.bringToTop(this.livesText);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "popups", "popups/black_rect.png");
      this.back.alpha = 0.1;
      this.back.displayWidth = 470;
      this.back.displayHeight = 154;
      this.add(this.back);
      this.back.kill();
    }
    addLifeIcon() {
      let backLeft = this.back.x - this.back.displayWidth / 2;
      this.lifeIcon = this.scene.add.image(0, 0, "popups", "popups/lives/life_icon.png");
      this.lifeIcon.x = backLeft + 115;
      this.lifeIcon.y = -4;
      this.add(this.lifeIcon);
    }
    addLivesText() {
      let content = "+" + this.options.lives.toString();
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "32px",
        color: "#ffffff",
        align: "center",
        stroke: "#E63C7B",
        strokeThickness: 6
      };
      this.livesText = this.scene.add.text(0, 0, content, style);
      this.livesText.setOrigin(0.5, 0.5);
      this.livesText.x = this.lifeIcon.x - 2;
      this.livesText.y = this.lifeIcon.y - 3;
      this.add(this.livesText);
    }
    addButton() {
      let backRight = this.back.x + this.back.displayWidth / 2;
      this.button = this.scene.add.complexButton("popups", "popups/lives/button_pink.png", this);
      this.button.name = `button_get_lives__${this.options.offerId}`;
      this.button.x = backRight - 138;
      this.button.y = this.lifeIcon.y;
      this.button.inflateHitArea(15, 15);
      if (this.options.type === "video") {
        this.button.addIcon("popups", "popups/lives/watch ad.png", 0, -16);
        this.button.icon.scale = 0.65;
      } else {
        let style = {
          fontFamily: WebFonts.DEFAULT_FAMILY,
          fontStyle: WebFonts.DEFAULT_WEIGHT,
          fontSize: "26px",
          color: "#ffffff",
          align: "center",
          stroke: "#F06B5C",
          strokeThickness: 6
        };
        this.button.addIcon("popups", "popups/lives/coin.png", -42, 0);
        this.button.icon.scale = 0.75;
        this.button.addText(this.options.priceInCoins.toString(), style);
        this.button.text.setOrigin(1, 0.5);
        this.button.text.x = 64;
        this.button.text.y = -4;
      }
    }
    addSeparator() {
      if (!this.options.useSeparator) {
        return;
      }
      this.separator = this.scene.add.image(0, 0, "popups", "popups/lives/separator.png");
      this.separator.y = this.back.bottom;
      this.add(this.separator);
    }
    hideSeparator() {
      var _a;
      (_a = this.separator) == null ? void 0 : _a.kill();
    }
    onLanguageChange() {
    }
  };

  // src/scenes/levelMap/livesPopup/LivesIcon.ts
  var LivesIcon = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.name = "lives_icon";
      this.addIcon();
      this.addText();
      this.setSize(this.icon.width, this.icon.height);
    }
    addIcon() {
      this.icon = this.scene.add.image(0, 0, "popups", "popups/lives/life_icon_big.png");
      this.add(this.icon);
    }
    addText() {
      let content = "0";
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "56px",
        color: "#ffffff",
        align: "center",
        stroke: "#E63C7B",
        strokeThickness: 8
      };
      this.textDefaultStyle = style;
      this.text = this.scene.add.text(0, 0, content, this.textDefaultStyle);
      this.text.setOrigin(0.5, 0.5);
      this.text.y = -4;
      this.add(this.text);
    }
    setLivesNum(value) {
      if (value === Infinity) {
        this.text.setFontFamily("Arial");
        this.text.setFontSize(96);
        this.text.setFontStyle(FontWeight.BOLD);
        this.text.text = INFINITY_SIGN;
      } else {
        this.text.setStyle(this.textDefaultStyle);
        this.text.text = value.toString();
      }
    }
    syncLivesNum() {
      let livesNum = this.scene.game.lives.getLivesNum();
      this.setLivesNum(livesNum);
    }
    onLifeRefilled() {
      this.scene.tweens.killTweensOf(this);
      this.scene.tweens.add({
        targets: this,
        duration: 233,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.15,
        yoyo: true
      });
    }
    onLifeRewarded(baseDelay) {
      this.scene.tweens.killTweensOf(this);
      let delay = this.scene.tweens.stagger(100, {start: baseDelay});
      this.icon.alpha = 0;
      this.text.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.list,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.icon.scale = 0.5;
      this.text.scale = 0.5;
      this.scene.tweens.add({
        delay,
        targets: this.list,
        duration: 900,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
    }
  };

  // src/scenes/levelMap/livesPopup/LivesPopup.ts
  var LivesPopupEvent;
  (function(LivesPopupEvent2) {
    LivesPopupEvent2["GET_LIVES_BUTTON_CLICK"] = "__GET_LIVES_BUTTON_CLICK";
  })(LivesPopupEvent || (LivesPopupEvent = {}));
  var LivesPopup = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.autoCloseAfterAd = false;
      this.lives = scene.game.lives;
      this.lives.on(LivesManagerEvent.REFILL_TIMER_START, this.onRefillTimerStart, this);
      this.lives.on(LivesManagerEvent.REFILL_TIMER_COMPLETE, this.onRefillTimerComplete, this);
      this.lives.on(LivesManagerEvent.UNLIMITED_TIMER_START, this.onUnlimitedTimerStart, this);
      this.lives.on(LivesManagerEvent.UNLIMITED_TIMER_COMPLETE, this.onUnlimitedTimerComplete, this);
      this.lives.on(LivesManagerEvent.LIVES_ADDED, this.onLivesAdded, this);
      this.lives.on(LivesManagerEvent.PAGE_VISIBLE, this.onPageVisible, this);
      this.scene.sys.updateList.add(this);
      this.name = "lives_popup";
      this.addBack();
      this.addCloseButton();
      this.addTitle();
      this.addPanelBack();
      this.addParticles();
      this.addLivesIcon();
      this.addTimerTitleText();
      this.addTimerText();
      this.addFullText();
      this.addOffers();
      this.bringToTop(this.livesIcon);
      this.bringToTop(this.fullText);
      this.bringToTop(this.timerTitleText);
      this.bringToTop(this.timerText);
      this.bringToTop(this.title);
      this.setSize(this.back.width, this.back.height);
      if (this.lives.isUnlimited()) {
        this.onUnlimitedTimerStart();
        return;
      }
      if (this.lives.isFull()) {
        this.timerTitleText.kill();
        this.timerText.kill();
        this.fullText.revive();
      }
    }
    onRefillTimerStart() {
      this.livesIcon.syncLivesNum();
      this.fullText.kill();
      this.timerTitleText.setText(this.scene.texts.lives.next_life);
      this.timerTitleText.revive();
      this.timerText.revive();
      this.updateTimerText();
    }
    onRefillTimerComplete() {
      this.livesIcon.syncLivesNum();
      this.livesIcon.onLifeRefilled();
      if (this.lives.isFull()) {
        this.showFullText();
        this.timerTitleText.kill();
        this.timerText.kill();
      }
    }
    onUnlimitedTimerStart() {
      this.livesIcon.setLivesNum(Infinity);
      this.fullText.kill();
      this.timerTitleText.setText(this.scene.texts.lives.unlimited);
      this.timerTitleText.revive();
      this.timerText.revive();
      this.updateTimerText();
    }
    onUnlimitedTimerComplete() {
      this.livesIcon.syncLivesNum();
      if (this.lives.isFull()) {
        this.showFullText();
        this.timerTitleText.kill();
        this.timerText.kill();
      }
    }
    onLivesAdded() {
      this.livesIcon.syncLivesNum();
      this.livesIcon.onLifeRewarded(0);
      this.circlesEmitter.emitParticle(1);
      this.sparksEmitter.emitParticle(30);
    }
    onPageVisible(livesManager, livesGained) {
      if (livesGained <= 0) {
        return;
      }
      this.livesIcon.syncLivesNum();
      this.livesIcon.onLifeRewarded(0);
      if (this.lives.isFull()) {
        this.showFullText();
        this.timerTitleText.kill();
        this.timerText.kill();
      }
    }
    showFullText() {
      this.fullText.revive();
      this.fullText.alpha = 0;
      this.scene.tweens.add({
        targets: this.fullText,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.fullText.scale = 0.75;
      this.scene.tweens.add({
        targets: this.fullText,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1
      });
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "popups", "popups/lives/popup.png");
      this.add(this.back);
    }
    addCloseButton() {
      this.closeButton = this.scene.add.button("popups", "popups/Close Button.png", this);
      this.closeButton.x = this.back.right - 60;
      this.closeButton.y = this.back.top + 46;
      this.closeButton.inflateHitArea(15, 15);
      this.closeButton.on(ButtonEvent.PRESS, this.onCloseButtonClick, this);
    }
    onCloseButtonClick() {
      var _a;
      (_a = this.autoCloseTimerEvent) == null ? void 0 : _a.remove();
    }
    addTitle() {
      let content = this.scene.texts.lives.title;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "46px",
        color: "#FFE0AD",
        align: "center",
        stroke: "#522923",
        strokeThickness: 12
      };
      this.title = this.scene.add.text(0, 0, content, style);
      this.title.setOrigin(0.5, 0.5);
      this.title.y = this.back.top + 56;
      this.add(this.title);
    }
    addPanelBack() {
      this.panelBack = this.scene.add.image(0, 0, "popups", "popups/lives/panel_back.png");
      this.panelBack.x = 2;
      this.panelBack.y = -175;
      this.add(this.panelBack);
    }
    addParticles() {
      this.particles = this.scene.add.particles("popups");
      this.add(this.particles);
      this.circlesEmitter = this.particles.createEmitter({
        frame: "popups/particles/circle_fx_2.png",
        scale: {start: 0.4, end: 2, ease: Ease.ExpoOut},
        alpha: {start: 0.8, end: 0, ease: Ease.CubicOut},
        lifespan: 2e3,
        on: false
      });
      this.sparksEmitter = this.particles.createEmitter({
        frame: "popups/particles/circle_white_1.png",
        lifespan: 3e3,
        speed: {min: 10, max: 600},
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        scale: {start: 1.33, end: 0},
        emitZone: {
          source: new Phaser.Geom.Circle(0, 0, 100),
          type: "random"
        },
        on: false
      });
    }
    addLivesIcon() {
      let livesNum = this.scene.game.lives.getLivesNum();
      this.livesIcon = new LivesIcon(this.scene);
      this.livesIcon.setLivesNum(livesNum);
      this.livesIcon.x = -120;
      this.livesIcon.y = this.panelBack.y + 4;
      this.add(this.livesIcon);
      this.particles.setPosition(this.livesIcon.x, this.livesIcon.y);
    }
    addTimerTitleText() {
      let content = this.scene.texts.lives.next_life;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "27px",
        color: "#A23E2C",
        align: "center"
      };
      this.timerTitleText = this.scene.add.text(0, 0, content, style);
      this.timerTitleText.setOrigin(0.5, 0.5);
      this.timerTitleText.x = 96;
      this.timerTitleText.y = this.panelBack.y - 18;
      this.timerTitleText.originalX = this.timerTitleText.x;
      this.add(this.timerTitleText);
    }
    addTimerText() {
      let content = "00:00";
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "42px",
        color: "#804442",
        align: "center"
      };
      this.timerText = this.scene.add.text(0, 0, content, style);
      this.timerText.setOrigin(0.5, 0.5);
      this.timerText.x = this.timerTitleText.x;
      this.timerText.y = this.timerTitleText.y + 34;
      this.timerText.originalX = this.timerText.x;
      this.add(this.timerText);
    }
    addFullText() {
      let content = this.scene.texts.lives.full;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "50px",
        color: "#804442",
        align: "center"
      };
      this.fullText = this.scene.add.text(0, 0, content, style);
      this.fullText.setOrigin(0.5, 0.5);
      this.fullText.x = this.timerTitleText.x;
      this.fullText.y = this.panelBack.y;
      this.fullText.originalX = this.fullText.x;
      this.fullText.kill();
      this.add(this.fullText);
    }
    addOffers() {
      let lastOfferOptions = window.game.config.ads.rewarded ? {lives: 1, type: "video", offerId: "lives_video_x1"} : {lives: 5, type: "coins", offerId: "lives_x5", priceInCoins: 5e3};
      let options = [
        {
          offerId: "lives_x1",
          lives: 1,
          type: "coins",
          useSeparator: true,
          priceInCoins: 1e3
        },
        {
          offerId: "lives_x3",
          lives: 3,
          type: "coins",
          useSeparator: true,
          priceInCoins: 3e3
        },
        lastOfferOptions
      ];
      this.offers = options.map((options2) => new LivesOffer(this.scene, options2));
      this.offers.forEach((offer, index) => {
        let {type, lives, priceInCoins} = offer.options;
        offer.button.on(ButtonEvent.RELEASE, this.onGetLivesButtonClick.bind(this, offer.button, type, lives, priceInCoins));
        offer.y = 5 + index * 140;
        this.add(offer);
      });
    }
    onGetLivesButtonClick(button, type, livesNum, priceInCoins) {
      var _a;
      (_a = this.autoCloseTimerEvent) == null ? void 0 : _a.remove();
      if (this.lives.isFull() || this.lives.isUnlimited()) {
        if (this.fullText.visible) {
          this.shakeText(this.fullText);
        }
        if (this.timerTitleText.visible) {
          this.shakeText(this.timerTitleText);
          this.shakeText(this.timerText);
        }
        this.scene.audio.play(GameSoundKey.BOOSTER_CANT_USE);
        return;
      }
      this.emit(LivesPopupEvent.GET_LIVES_BUTTON_CLICK, type, livesNum, priceInCoins);
    }
    shakeText(text) {
      text.x = text.originalX;
      this.scene.tweens.killTweensByProperty(text, "x");
      this.scene.tweens.add({
        targets: text,
        duration: 44,
        ease: Phaser.Math.Easing.Sine.InOut,
        x: text.originalX + 12,
        repeat: 3,
        yoyo: true
      });
    }
    onLivesPurchaseComplete() {
      this.scene.time.delayedCall(300, () => {
        this.scene.audio.play(GameSoundKey.LIFE_GRANTED, {volume: 0.5});
      });
      if (this.autoCloseAfterAd) {
        this.autoCloseTimerEvent = this.scene.time.delayedCall(1300, () => {
          this.closeButton.emulatePressEvent();
        });
      }
    }
    onShow(autoCloseAfterAd) {
      this.autoCloseAfterAd = autoCloseAfterAd;
    }
    showOffers() {
      this.offers.forEach((offer, index) => {
        let button = offer;
        let delay = index * 66;
        button.alpha = 0;
        this.scene.tweens.add({
          delay,
          targets: button,
          duration: 200,
          ease: Phaser.Math.Easing.Quadratic.Out,
          alpha: 1
        });
        button.scale = 0.8;
        this.scene.tweens.add({
          delay,
          targets: button,
          duration: 400,
          ease: Phaser.Math.Easing.Back.Out,
          scale: 1
        });
      });
    }
    onHide() {
    }
    preUpdate(time, delta) {
      this.updateTimerText();
    }
    updateTimerText() {
      var _a, _b;
      if (this.timerText.visible === false) {
        return;
      }
      if ((_a = this.lives.unlimitedTimer) == null ? void 0 : _a.isRunning) {
        this.timerText.text = this.lives.unlimitedTimer.getFormattedTime();
        return;
      }
      if ((_b = this.lives.refillTimer) == null ? void 0 : _b.isRunning) {
        this.timerText.text = this.lives.refillTimer.getFormattedTime();
      }
    }
    onLanguageChange() {
      this.title.text = this.scene.texts.lives.title;
      this.timerTitleText.text = this.scene.texts.lives.next_life;
      this.fullText.text = this.scene.texts.lives.full;
      this.offers.forEach((offer) => offer.onLanguageChange());
    }
    preDestroy() {
      super.preDestroy();
      this.scene.sys.updateList.remove(this);
      this.lives.off(LivesManagerEvent.REFILL_TIMER_START, this.onRefillTimerStart, this);
      this.lives.off(LivesManagerEvent.REFILL_TIMER_COMPLETE, this.onRefillTimerComplete, this);
      this.lives.off(LivesManagerEvent.UNLIMITED_TIMER_START, this.onUnlimitedTimerStart, this);
      this.lives.off(LivesManagerEvent.UNLIMITED_TIMER_COMPLETE, this.onUnlimitedTimerComplete, this);
      this.lives.off(LivesManagerEvent.LIVES_ADDED, this.onLivesAdded, this);
      this.lives.off(LivesManagerEvent.PAGE_VISIBLE, this.onPageVisible, this);
    }
  };

  // src/scenes/levelMap/livesPopup/LivesScreen.ts
  var LivesScreenEvent;
  (function(LivesScreenEvent2) {
    LivesScreenEvent2["LIVES_PURCHASE_COMPLETE"] = "__LIVES_PURCHASE_COMPLETE";
    LivesScreenEvent2["SHOW_COINS_SHOP"] = "__SHOW_COINS_SHOP";
  })(LivesScreenEvent || (LivesScreenEvent = {}));
  var LivesScreen = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "lives_screen",
        backgroundKey: "popups",
        backgroundFrame: "popups/black_rect.png",
        backgroundAlpha: 0.85
      });
      this.isDeactivated = false;
      this.addCoinsLabel();
      this.addPopup();
      this.addHintText();
    }
    addCoinsLabel() {
      let options = {
        atlas: "popups",
        backFrame: "popups/labels/label_back.png",
        iconFrame: "popups/labels/Coin_2.png",
        iconOffset: {x: 0, y: 0},
        text: {
          type: "bitmap",
          font: BitmapFont.LABELS_POPUPS
        }
      };
      let coinsNum = this.scene.game.store.getNumber(GameStoreKey.COINS);
      this.coinsLabel = new LevelCompleteCoinsLabel(this.scene, options);
      this.coinsLabel.updateCoinsNumInstant(coinsNum);
      this.coinsLabel.circlesEmitter.setFrame("popups/particles/circle_fx_3.png");
      this.coinsLabel.sparksEmitter.setFrame("popups/particles/star_particle.png");
      this.pin(this.coinsLabel, 0, 0, 70, 66);
      this.add(this.coinsLabel);
    }
    addPopup() {
      this.popup = new LivesPopup(this.scene);
      this.popup.closeButton.on(ButtonEvent.PRESS, this.hide, this);
      this.popup.on(LivesPopupEvent.GET_LIVES_BUTTON_CLICK, this.onGetLivesButtonClick, this);
      this.add(this.popup);
      this.pin(this.popup, 0.5, 0.5);
    }
    onGetLivesButtonClick(type, livesNum, priceInCoins) {
      if (type === "video") {
        this.getLivesForVideo(livesNum);
      } else {
        this.getLivesForCoins(livesNum, priceInCoins);
      }
    }
    getLivesForVideo(livesNum) {
      this.scene.game.gdSdk.showRewardedAd(`LivesPopup`).then((success) => {
        if (success) {
          this.onLivesPurchaseComplete(livesNum);
        }
      });
    }
    getLivesForCoins(livesNum, priceInCoins) {
      let coins = this.scene.game.store.getNumber(GameStoreKey.COINS);
      if (coins < priceInCoins) {
        this.onNotEnoughCoins();
        return;
      }
      this.scene.game.store.changeNumber(GameStoreKey.COINS, -priceInCoins, 0);
      this.coinsLabel.updateCoinsNum(coins - priceInCoins);
      this.onLivesPurchaseComplete(livesNum);
    }
    onNotEnoughCoins() {
      if (this.scene.game.purchases) {
        this.emit(LivesScreenEvent.SHOW_COINS_SHOP, this);
        return;
      }
      this.coinsLabel.shakeText();
      this.scene.audio.play(GameSoundKey.BOOSTER_CANT_USE);
    }
    onLivesPurchaseComplete(livesNum) {
      this.scene.game.lives.addLives(livesNum);
      this.popup.onLivesPurchaseComplete();
      this.hideHintText(200);
      this.emit(LivesScreenEvent.LIVES_PURCHASE_COMPLETE, this);
    }
    addHintText() {
      let content = this.scene.texts.lives.hint;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "30px",
        color: "#FFE0AD",
        align: "center"
      };
      this.hintText = this.scene.add.text(0, 0, content, style);
      this.hintText.setOrigin(0.5, 0.5);
      this.hintText.setWordWrapWidth(this.popup.width * 0.85);
      this.hintText.setLineSpacing(-2);
      this.hintText.alpha = 0.85;
      this.hintText.originalAlpha = this.hintText.alpha;
      this.hintText.originalScale = 1;
      this.add(this.hintText);
    }
    hideHintText(delay) {
      if (this.hintText.visible === false) {
        return;
      }
      this.scene.tweens.add({
        targets: this.hintText,
        duration: 200,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 0,
        onComplete: () => {
          this.hintText.kill();
        }
      });
    }
    resize() {
      super.resize();
      this.coinsLabel.originalY = this.coinsLabel.y;
      this.resizePopup();
      this.alignHintText();
    }
    resizePopup() {
      let maxHeight = this.screenHeight * 0.8;
      this.popup.scale = Math.min(1, maxHeight / this.popup.height);
      this.popup.originalScale = this.popup.scale;
      this.popup.originalY = this.popup.y;
    }
    alignHintText() {
      let top = this.popup.y + this.popup.displayHeight / 2 - 40;
      let bottom = this.screenHeight;
      let height = bottom - top;
      this.hintText.x = this.screenWidth / 2;
      this.hintText.y = top + height / 2;
      this.hintText.originalY = this.hintText.y;
    }
    show(options = {}) {
      options = __spreadValues({
        autoCloseAfterAd: false
      }, options);
      this.updateData();
      this.alpha = 1;
      this.popup.closeButton.enableInput();
      this.revive();
      this.showBackground({targetAlpha: options.backgroundAlpha});
      this.showCoinsLabel();
      this.showPopup(options.autoCloseAfterAd);
      this.showHintText(66);
      this.emitShowEvent();
    }
    updateData() {
      let livesNum = this.scene.game.lives.getLivesNum();
      if (livesNum === 0) {
        this.hintText.revive();
      } else {
        this.hintText.kill();
      }
    }
    showCoinsLabel() {
      this.scene.tweens.add({
        targets: this.coinsLabel,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.coinsLabel.y = this.coinsLabel.originalY - 60;
      this.scene.tweens.add({
        targets: this.coinsLabel,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.5],
        y: this.coinsLabel.originalY
      });
    }
    showPopup(autoCloseAfterAd) {
      this.popup.alpha = 0;
      this.scene.tweens.add({
        delay: 0,
        targets: this.popup,
        alpha: {value: 1, ease: Phaser.Math.Easing.Cubic.Out, duration: 200}
      });
      this.popup.y += 60;
      this.scene.tweens.add({
        targets: this.popup,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.5],
        y: "-=60"
      });
      this.popup.onShow(autoCloseAfterAd);
    }
    showHintText(delay) {
      this.hintText.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.hintText,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: this.hintText.originalAlpha
      });
      this.hintText.y += 60;
      this.scene.tweens.add({
        delay,
        targets: this.hintText,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.5],
        y: "-=60"
      });
    }
    hide() {
      this.emit(PhaserScreenEvent.HIDE_START, this);
      this.popup.closeButton.disableInput();
      this.scene.tweens.add({
        targets: this,
        duration: 100,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.popup.onHide();
          this.kill();
          this.emit(PhaserScreenEvent.HIDE_COMPLETE, this);
        }
      });
    }
    hideBackground() {
      this.scene.tweens.killTweensOf(this.background);
      this.background.alpha = 1e-3;
    }
    onLanguageChange() {
      this.hintText.setText(this.scene.texts.lives.hint);
      this.popup.onLanguageChange();
    }
    activate() {
      if (this.isDeactivated === false) {
        return;
      }
      this.isDeactivated = false;
      this.coinsLabel.revive();
      this.popup.revive();
      this.hintText.revive();
    }
    deactivate() {
      if (this.isDeactivated) {
        return;
      }
      this.isDeactivated = true;
      this.coinsLabel.kill();
      this.popup.kill();
      this.hintText.kill();
    }
  };

  // src/scenes/gameplayGui/quitScreen/ConfirmPopup.ts
  var ConfirmPopup = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.name = "confirm_popup";
      this.addBack();
      this.addTitle();
      this.addText();
      this.addButtons();
      this.addCloseButton();
      this.bringToTop(this.noButton);
      this.bringToTop(this.yesButton);
      this.bringToTop(this.title);
      this.bringToTop(this.text);
      this.setSize(this.back.displayWidth, this.back.displayHeight);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "popups", "popups/popup_small_back.png");
      this.add(this.back);
    }
    addTitle() {
      let content = "Title";
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "46px",
        color: "#FFE0AD",
        align: "center",
        stroke: "#522923",
        strokeThickness: 12
      };
      this.title = this.scene.add.text(0, 0, content, style);
      this.title.setOrigin(0.5, 0.5);
      this.title.y = -214;
      this.add(this.title);
      this.adjustTitleTextSize();
    }
    adjustTitleTextSize() {
      let maxWidth = 350;
      this.title.scale = Math.min(1, maxWidth / this.title.width);
    }
    addText() {
      let content = "Are you sure?";
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "44px",
        color: "#5F3331",
        align: "center"
      };
      this.text = this.scene.add.text(0, 0, content, style);
      this.text.setOrigin(0.5, 0.5);
      this.text.setWordWrapWidth(this.back.width * 0.75, true);
      this.text.setLineSpacing(-6);
      this.text.y = -45;
      this.add(this.text);
    }
    addButtons() {
      let offsetX = 120;
      let buttonsY = 100;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "36px",
        color: "#ffffff",
        align: "center",
        padding: {x: 0, y: 4},
        shadow: {
          color: "rgba(0,0,0,0.2)",
          offsetY: 3,
          fill: true
        }
      };
      let noText = this.scene.texts.confirm_popup.decline;
      this.noButton = new ComplexButton(this.scene, "popups", "popups/quit/Green-Button-Long.png", this);
      this.noButton.addText(noText, style, 0, -2);
      this.noButton.x = -offsetX;
      this.noButton.y = buttonsY;
      let yesText = this.scene.texts.confirm_popup.accept;
      this.yesButton = new ComplexButton(this.scene, "popups", "popups/quit/Pink-Button-Long.png", this);
      this.yesButton.addText(yesText, style, 0, -2);
      this.yesButton.x = offsetX;
      this.yesButton.y = buttonsY;
    }
    addCloseButton() {
      this.closeButton = this.scene.add.button("popups", "popups/Close Button.png", this);
      this.closeButton.x = this.back.right - 54;
      this.closeButton.y = this.back.top + 46;
    }
    updateData(data) {
      this.title.text = data.title;
      this.adjustTitleTextSize();
      this.text.text = data.text;
    }
    onShow() {
    }
    onHide() {
    }
    onLanguageChange() {
      this.noButton.text.text = this.scene.texts.confirm_popup.decline;
      this.yesButton.text.text = this.scene.texts.confirm_popup.accept;
    }
  };

  // src/scenes/gameplayGui/quitScreen/QuitPopup.ts
  var QuitPopup = class extends ConfirmPopup {
    constructor(scene) {
      super(scene);
      this.text.y -= 20;
      this.addSubtitle();
      this.addBrokenHeartPopover();
    }
    addSubtitle() {
      let content = this.scene.texts.quit_subtitle;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "32px",
        color: "#875A51",
        align: "center"
      };
      this.subtitle = this.scene.add.text(0, 0, content, style);
      this.subtitle.setOrigin(0.5, 0.5);
      this.subtitle.y = this.text.y + 50;
      this.add(this.subtitle);
    }
    addBrokenHeartPopover() {
      this.popover = this.scene.add.image(0, 0, "popups", "popups/quit/broken_heart_popover.png");
      this.popover.x = this.yesButton.x + 70;
      this.popover.y = this.yesButton.y - 10;
      this.add(this.popover);
    }
    onShow() {
      super.onShow();
      this.showPopover(250);
    }
    showPopover(delay) {
      this.popover.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.popover,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.popover.scale = 0.66;
      this.scene.tweens.add({
        delay,
        targets: this.popover,
        duration: 800,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
      this.popover.angle = -6;
      this.scene.tweens.add({
        targets: this.popover,
        duration: 800,
        ease: Phaser.Math.Easing.Sine.InOut,
        angle: this.popover.angle * -1,
        yoyo: true,
        repeat: -1
      });
    }
    onHide() {
      super.onHide();
      this.scene.tweens.killTweensOf(this.popover);
    }
  };

  // src/scenes/gameplayGui/levelComplete/labels/LevelCompleteLivesLabel.ts
  var LevelCompleteLivesLabel = class extends LevelCompleteLabel {
    constructor(scene, options) {
      super(scene, options);
      this.livesNum = 0;
      this.livesManager = this.scene.game.lives;
      this.livesManager.on(LivesManagerEvent.REFILL_TIMER_COMPLETE, this.onLifeAdded, this);
      this.livesManager.on(LivesManagerEvent.PAGE_VISIBLE, this.onPageVisible, this);
    }
    onLifeAdded() {
      this.updateLivesNum(this.livesManager.getLivesNum());
    }
    onPageVisible(livesManager, livesGained) {
      this.updateLivesNumInstant(livesManager.getLivesNum());
    }
    updateLivesNumInstant(value) {
      this.livesNum = value;
      this.text.text = this.livesNum.toString();
    }
    updateLivesNum(value) {
      this.livesNum = value;
      this.text.text = this.livesNum.toString();
      this.text.alpha = 0;
      this.scene.tweens.add({
        targets: this.text,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.text.scale = 3;
      this.scene.tweens.add({
        targets: this.text,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1
      });
    }
    showBrokenHeart() {
      let heart = this.scene.add.image(0, 0, this.icon.texture.key, this.icon.frame.name);
      heart.x = this.icon.x;
      heart.y = this.icon.y;
      this.add(heart);
      this.scene.tweens.add({
        targets: heart,
        duration: 1e3,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          heart.kill();
        }
      });
      this.scene.tweens.add({
        targets: heart,
        duration: 1e3,
        ease: Phaser.Math.Easing.Cubic.Out,
        scale: 2.5
      });
    }
    preDestroy() {
      this.livesManager.off(LivesManagerEvent.REFILL_TIMER_COMPLETE, this.onLifeAdded, this);
      this.livesManager.off(LivesManagerEvent.PAGE_VISIBLE, this.onPageVisible, this);
      super.preDestroy();
    }
  };

  // src/scenes/gameplayGui/quitScreen/ConfirmScreen.ts
  var ConfirmScreen = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "quit_screen",
        backgroundKey: "popups",
        backgroundFrame: "popups/black_rect.png",
        backgroundAlpha: 1e-3,
        backgroundInteractive: false
      });
      this.addLivesLabel();
      this.addPopup();
    }
    addLivesLabel() {
      let options = {
        atlas: "gameplay_gui",
        backFrame: "level_complete/labels/label_back",
        iconOffset: {x: -2, y: -2},
        iconFrame: "level_complete/labels/life_icon",
        text: {
          type: "bitmap",
          font: BitmapFont.LABELS_GAMEPLAY_GUI
        }
      };
      this.livesLabel = new LevelCompleteLivesLabel(this.scene, options);
      this.livesLabel.updateLivesNumInstant(this.scene.game.lives.getLivesNum());
      this.add(this.livesLabel);
      this.pin(this.livesLabel, 0, 0, 70, 66);
    }
    addPopup() {
      let title = this.scene.texts.quit;
      let text = this.scene.texts.confirm_popup.question;
      let data = {title, text};
      this.popup = new QuitPopup(this.scene);
      this.popup.updateData(data);
      this.popup.closeButton.on(ButtonEvent.PRESS, this.hide, this);
      this.popup.noButton.on(ButtonEvent.PRESS, this.hide, this);
      this.add(this.popup);
      this.pin(this.popup, 0.5, 0.5);
    }
    resize() {
      super.resize();
      this.livesLabel.originalY = this.livesLabel.y;
    }
    show() {
      this.alpha = 1;
      this.emitShowEvent();
      this.revive();
      this.showPopup();
      this.showLivesLabel();
    }
    showPopup() {
      this.popup.alpha = 0;
      this.scene.tweens.add({
        delay: 0,
        targets: this.popup,
        alpha: {value: 1, ease: Phaser.Math.Easing.Cubic.Out, duration: 200}
      });
      this.popup.scale = 0.85;
      this.scene.tweens.add({
        delay: 0,
        targets: this.popup,
        duration: 1e3,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
      this.popup.y += 100;
      this.scene.tweens.add({
        targets: this.popup,
        duration: 500,
        ease: Phaser.Math.Easing.Back.Out,
        y: "-=100"
      });
      this.popup.closeButton.enableInput();
      this.popup.noButton.enableInput();
      this.popup.yesButton.enableInput();
      this.popup.onShow();
    }
    showLivesLabel() {
      this.scene.tweens.add({
        targets: this.livesLabel,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.livesLabel.y = this.livesLabel.originalY - 100;
      this.scene.tweens.add({
        targets: this.livesLabel,
        duration: 500,
        ease: Phaser.Math.Easing.Back.Out,
        y: this.livesLabel.originalY
      });
    }
    hide() {
      this.emitHideStartEvent();
      this.popup.closeButton.disableInput();
      this.popup.noButton.disableInput();
      this.popup.yesButton.disableInput();
      this.scene.tweens.add({
        targets: this,
        duration: 100,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.popup.onHide();
          this.kill();
          this.emitHideCompleteEvent();
        }
      });
    }
  };

  // src/scenes/gameplayGui/topPanel/powerupChef/PowerupChefManager.ts
  var Spline5 = Phaser.Curves.Spline;
  var PowerupChefManagerEvent;
  (function(PowerupChefManagerEvent2) {
    PowerupChefManagerEvent2["CHARGE_ARRIVED"] = "__CHARGE_ARRIVED";
    PowerupChefManagerEvent2["ALL_CHARGES_ARRIVED"] = "__ALL_CHARGES_ARRIVED";
  })(PowerupChefManagerEvent || (PowerupChefManagerEvent = {}));
  var PowerupChefManager = class extends Phaser.Events.EventEmitter {
    constructor(scene, chef) {
      super();
      this.scene = scene;
      this.gameplay = this.scene.gameplay;
      this.isEnabled = this.scene.levelConfig.chefPowerups.isEnabled;
      this.chef = chef;
      this.charges = [];
    }
    getChargesInMotionNum() {
      return this.charges.length;
    }
    createCharge() {
      let charge = this.scene.add.image(0, 0, "gameplay_gui", "powerup_chef/charge_fx");
      charge.once(Phaser.GameObjects.Events.DESTROY, this.onChargeDestroy, this);
      charge.setDepth(GameplayGuiDepth.PARTICLES);
      this.charges.push(charge);
      return charge;
    }
    onChargeDestroy(charge) {
      this.emit(PowerupChefManagerEvent.CHARGE_ARRIVED, this);
      let index = this.charges.indexOf(charge);
      if (index > -1) {
        this.charges.splice(index, 1);
        if (this.charges.length === 0) {
          this.emit(PowerupChefManagerEvent.ALL_CHARGES_ARRIVED, this);
        }
      }
    }
    sendChargeToChef(cookie) {
      if (this.isEnabled === false) {
        return;
      }
      let position = this.gameplay.camera.getWorldPositionXY(cookie.x, cookie.y);
      let charge = this.createCharge();
      charge.x = position.x;
      charge.y = position.y;
      let curve = this.createCurveToChef(charge);
      let duration = Math.max(700, curve.getLength() * 1.33);
      this.gameplay.sounds.powerupToChef();
      charge.alpha = 0;
      this.scene.tweens.add({
        targets: charge,
        duration: duration / 2,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1,
        onComplete: () => {
          this.scene.tweens.add({
            targets: charge,
            duration: duration / 2,
            ease: Phaser.Math.Easing.Expo.In,
            alpha: 0
          });
        }
      });
      charge.scale = 0;
      this.scene.tweens.add({
        targets: charge,
        duration: duration / 2,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1,
        onComplete: () => {
          this.scene.tweens.add({
            targets: charge,
            duration: duration / 2,
            ease: Phaser.Math.Easing.Expo.In,
            scale: 0
          });
        }
      });
      this.scene.tweens.addCurveTween({
        curve,
        duration,
        target: charge,
        onUpdate: () => {
          this.scene.emitters.chargeEmitter.emitParticle(1, charge.x, charge.y);
        },
        onComplete: () => {
          this.scene.emitters.powerupSparks.explode(6, charge.x, charge.y);
          this.chef.incrementCurrent();
          charge.destroy();
        }
      });
    }
    createCurveToChef(charge) {
      let start = {x: charge.x, y: charge.y};
      let end = this.chef.label.getWorldPosition();
      let dx = Math.abs(end.x - start.x);
      let midX = dx < CELL_SIZE ? start.x + CELL_SIZE * Phaser.Math.RND.sign() : start.x + (end.x - start.x) * Phaser.Math.RND.realInRange(0.5, 1);
      return new Spline5([
        start.x,
        start.y,
        midX,
        start.y + 50,
        end.x,
        end.y
      ]);
    }
    sendChargeFromChef(target) {
      let powerup = this.chef.emitPowerup();
      let position = this.chef.getWorldPosition();
      let charge = this.createCharge();
      charge.x = position.x;
      charge.y = position.y + 40 * this.scene.topPanel.scaleY;
      let curve = this.createCurveFromChef(charge, target);
      let delay = 33;
      let duration = Math.max(600, curve.getLength() * 1.25);
      this.scene.audio.play(GameSoundKey.POWERUP_FROM_CHEF, {volume: 0.66});
      charge.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: charge,
        duration: duration / 2,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1,
        onComplete: () => {
          this.scene.tweens.add({
            targets: charge,
            duration: duration / 2,
            ease: Phaser.Math.Easing.Expo.In,
            alpha: 0
          });
        }
      });
      charge.scale = 0;
      this.scene.tweens.add({
        delay,
        targets: charge,
        duration: duration / 2,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1,
        onComplete: () => {
          this.scene.tweens.add({
            targets: charge,
            duration: duration / 2,
            ease: Phaser.Math.Easing.Expo.In,
            scale: 0
          });
        }
      });
      return new Promise((resolve) => {
        this.scene.tweens.addCurveTween({
          delay,
          curve,
          duration,
          target: charge,
          onUpdate: () => {
            this.scene.emitters.chargeEmitter.emitParticle(2, charge.x, charge.y);
          },
          onComplete: () => {
            this.scene.audio.play(GameSoundKey.TWINKLE_1, {volume: 0.5});
            this.scene.emitters.powerupCircles.explode(1, charge.x, charge.y);
            this.applyPowerupToCookie(target, powerup);
            this.gameplay.sys.queueDepthSort();
            charge.destroy();
            resolve();
          }
        });
      });
    }
    createCurveFromChef(charge, target) {
      let start = {x: charge.x, y: charge.y};
      let end = this.gameplay.camera.getWorldPositionXY(target.x, target.y);
      return new Spline5([
        start.x,
        start.y,
        start.x + (end.x - start.x) / 2,
        start.y + 200,
        end.x,
        end.y
      ]);
    }
    applyPowerupToCookie(cookie, powerup) {
      let newCookie = this.gameplay.applyPowerupToCookie(cookie, powerup);
      this.scene.tweens.add({
        targets: newCookie,
        duration: 200,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.25,
        yoyo: true
      });
    }
    isPowerupReady() {
      return this.chef.isPowerupReady();
    }
    reset() {
      this.chef.resetProgress();
    }
    save() {
      return {
        current: this.chef.current,
        total: this.chef.total,
        generator: this.chef.powerupTypesGenerator.getState()
      };
    }
    restore(state) {
      this.chef.current = state.current;
      this.chef.total = state.total;
      this.chef.powerupTypesGenerator.setState(state.generator);
      this.chef.updateProgress();
    }
  };

  // src/scenes/gameplayGui/boosterBuyScreen/BoosterBuyPopup.ts
  var BoosterBuyPopup = class extends VideoRewardPopup {
    constructor(scene) {
      super(scene);
      this.playButton.kill();
      this.addCoinsButton();
      this.addVideoButton();
    }
    addCoinsButton() {
      let textContent = "0";
      let textStyle = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "35px",
        color: "#ffffff",
        align: "center"
      };
      this.coinsButton = new ComplexButton(this.scene, "popups", "popups/second_chance/button_coins.png", this);
      this.coinsButton.addIcon("popups", "popups/second_chance/coin.png", -44, -7);
      this.coinsButton.addText(textContent, textStyle, 36, this.coinsButton.icon.y - 6);
      this.coinsButton.text.setShadow(0, 3, "rgba(0,0,0,0.2)", 0);
      this.coinsButton.x = -126;
      this.coinsButton.y = this.playButton.y + 4;
      this.coinsButton.originalY = this.coinsButton.y;
    }
    addVideoButton() {
      this.videoButton = new ComplexButton(this.scene, "popups", "popups/second_chance/button_video.png", this);
      this.videoButton.addIcon("popups", "popups/reward/watch ad.png", 0, -26).setScale(0.85);
      this.videoButton.x = 126;
      this.videoButton.y = this.playButton.y + 4;
      this.videoButton.originalY = this.videoButton.y;
    }
    enableButtons() {
      this.videoButton.enableInput();
      this.coinsButton.enableInput();
    }
    disableButtons() {
      this.videoButton.disableInput();
      this.coinsButton.disableInput();
    }
    onShow() {
      this.showButtons({delay: 100});
    }
    showButtons(options) {
      ;
      [this.coinsButton, this.videoButton].forEach((button) => {
        button.alpha = 0;
        this.scene.tweens.add({
          delay: options.delay,
          targets: button,
          duration: 150,
          ease: Phaser.Math.Easing.Cubic.Out,
          alpha: 1
        });
        let originalScale = button.scale;
        button.scale = originalScale * 0.75;
        this.scene.tweens.add({
          delay: options.delay,
          targets: button,
          duration: 900,
          ease: Phaser.Math.Easing.Elastic.Out,
          easeParams: [0.1, 0.45],
          scale: originalScale
        });
      });
    }
    onHide() {
    }
    updateData(data) {
      super.updateData(data);
      this.coinsButton.text.text = data.boosterPriceInCoins.toString();
      if (data.disableVideoButton) {
        this.videoButton.kill();
        this.coinsButton.x = 0;
      } else {
        this.videoButton.revive();
        this.videoButton.x = this.getButtonsCenterOffsetX();
        this.coinsButton.x = -this.getButtonsCenterOffsetX();
      }
    }
    getButtonsCenterOffsetX() {
      return 126;
    }
  };

  // src/scenes/gameplayGui/boosterBuyScreen/BoosterBuyScreen.ts
  var BoosterBuyScreenEvent;
  (function(BoosterBuyScreenEvent2) {
    BoosterBuyScreenEvent2["BOOSTER_BUY_COMPLETE"] = "__BOOSTER_BUY_COMPLETE";
    BoosterBuyScreenEvent2["SHOW_SHOP"] = "__SHOW_SHOP";
  })(BoosterBuyScreenEvent || (BoosterBuyScreenEvent = {}));
  var BoosterBuyScreen = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "get_booster_screen",
        backgroundAlpha: 0.85,
        backgroundKey: "popups",
        backgroundFrame: "popups/black_rect.png"
      });
      this.isDeactivated = false;
      this.addCoinsLabel();
      this.addPopup();
    }
    addCoinsLabel() {
      let options = {
        atlas: "popups",
        backFrame: "popups/labels/label_back.png",
        iconFrame: "popups/labels/Coin_2.png",
        iconOffset: {x: 0, y: 0},
        text: {
          type: "bitmap",
          font: BitmapFont.LABELS_POPUPS
        }
      };
      this.coinsLabel = new LevelCompleteCoinsLabel(this.scene, options);
      this.coinsLabel.syncWithGameStore(true);
      this.pin(this.coinsLabel, 0, 0, 70, 66);
      this.add(this.coinsLabel);
      if (this.scene.game.purchases) {
        this.coinsLabel.setInteractive();
        this.coinsLabel.input.cursor = "pointer";
        this.coinsLabel.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onCoinsLabelClick, this);
      }
    }
    onCoinsLabelClick() {
      this.emit(BoosterBuyScreenEvent.SHOW_SHOP, this);
    }
    addPopup() {
      this.popup = new BoosterBuyPopup(this.scene);
      this.popup.closeButton.on(ButtonEvent.PRESS, this.onCloseButtonClick, this);
      this.popup.coinsButton.on(ButtonEvent.PRESS, this.onCoinsButtonClick, this);
      this.popup.videoButton.on(ButtonEvent.RELEASE, this.onVideoButtonClick, this);
      this.add(this.popup);
      this.pin(this.popup, 0.5, 0.55);
    }
    onCloseButtonClick() {
      this.hide();
    }
    onCoinsButtonClick(button) {
      let coins = this.scene.game.store.getNumber(GameStoreKey.COINS);
      let price = this.screenData.boosterPriceInCoins;
      if (price > coins) {
        this.onNotEnoughCoins();
        return;
      }
      let newCoinsNum = this.scene.game.store.changeNumber(GameStoreKey.COINS, -price);
      this.coinsLabel.updateCoinsNum(newCoinsNum);
      this.scene.analytics.subtractResource(ResourceCurrency.COINS, price, ResourceItemType.COIN, `Booster_${this.screenData.rewardType}`);
      this.giveBooster("coins");
    }
    onNotEnoughCoins() {
      if (this.scene.game.purchases) {
        this.emit(BoosterBuyScreenEvent.SHOW_SHOP, this);
        return;
      }
      this.scene.audio.play(GameSoundKey.BOOSTER_CANT_USE);
      this.coinsLabel.shakeText();
    }
    onVideoButtonClick() {
      this.scene.game.gdSdk.showRewardedAd("Gameplay:BoosterBuyScreen").then((success) => {
        if (success) {
          this.giveBooster("video");
        }
      });
    }
    giveBooster(source) {
      this.emit(BoosterBuyScreenEvent.BOOSTER_BUY_COMPLETE, this.screenData, source);
    }
    resize() {
      super.resize();
      this.coinsLabel.originalY = this.coinsLabel.y;
      this.popup.originalY = this.popup.y;
      this.resizePopup();
    }
    resizePopup() {
      let maxHeight = this.screenHeight * 0.75;
      this.popup.scale = Math.min(1, maxHeight / this.popup.height);
      this.popup.originalScale = this.popup.scale;
    }
    updateData(data) {
      this.screenData = data;
      this.popup.updateData(data);
      this.coinsLabel.updateCoinsNumInstant(data.coinsTotal);
    }
    show(options) {
      this.emitShowEvent();
      this.revive();
      this.alpha = 1;
      this.showCoinsLabel();
      this.showPopup();
      if (options.showBackground) {
        this.background.revive();
        this.showBackground();
      } else {
        this.background.kill();
      }
    }
    showCoinsLabel() {
      this.coinsLabel.alpha = 0;
      this.scene.tweens.add({
        targets: this.coinsLabel,
        duration: 200,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 1
      });
      this.coinsLabel.y = this.coinsLabel.originalY - 50;
      this.scene.tweens.add({
        targets: this.coinsLabel,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        y: this.coinsLabel.originalY
      });
    }
    showPopup(delay = 0) {
      this.popup.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.popup,
        duration: 200,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 1
      });
      this.popup.y = this.popup.originalY + 50;
      this.scene.tweens.add({
        delay,
        targets: this.popup,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        y: this.popup.originalY
      });
      this.popup.onShow();
      this.popup.enableButtons();
    }
    hide() {
      this.emitHideStartEvent();
      this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.popup.onHide();
          this.kill();
          this.emitHideCompleteEvent();
        }
      });
    }
    hideInstant() {
      this.emitHideStartEvent();
      this.popup.onHide();
      this.kill();
      this.emitHideCompleteEvent();
    }
    activate() {
      if (this.isDeactivated === false) {
        return;
      }
      this.isDeactivated = false;
      this.coinsLabel.revive();
      this.popup.revive();
    }
    deactivate() {
      if (this.isDeactivated) {
        return;
      }
      this.isDeactivated = true;
      this.coinsLabel.kill();
      this.popup.kill();
    }
  };

  // src/scenes/levelMap/shopScreen/offers/LifeIcon.ts
  var LifeIcon = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.addHeart();
      this.addText();
      this.setSize(this.heart.width, this.heart.height);
    }
    addHeart() {
      this.heart = this.scene.add.image(0, 0, "popups", "popups/shop/heart.png");
      this.add(this.heart);
    }
    addText() {
      let content = "1h";
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "25px",
        color: "#ffffff",
        align: "center",
        stroke: "#A72830",
        strokeThickness: 6
      };
      this.text = this.scene.add.text(0, 0, content, style);
      this.text.setOrigin(0.5, 0.5);
      this.text.y = this.heart.bottom - 10;
      this.add(this.text);
    }
    updateTime(time) {
      let content = this.scene.texts.shop.time.replace("#", time.toString());
      this.text.setText(content);
    }
    updateTextContent(content) {
      this.text.setText(content);
    }
  };

  // src/scenes/levelMap/shopScreen/offers/SpecialOfferSubtitle.ts
  var SpecialOfferSubtitle = class extends Phaser.GameObjects.Container {
    constructor(scene, options) {
      super(scene);
      this.options = options;
      this.addPlusText();
      this.addCoinsText();
      this.addLifeIcon();
      this.bringToTop(this.coinsText);
      this.bringToTop(this.plusText);
    }
    addPlusText() {
      let content = "+";
      let style = this.options.textStyle;
      this.plusText = this.scene.add.text(0, 0, content, style);
      this.plusText.setOrigin(0.5, 0.5);
      this.add(this.plusText);
    }
    addCoinsText() {
      let content = "0";
      let style = this.options.textStyle;
      this.coinsText = this.scene.add.text(0, 0, content, style);
      this.coinsText.setOrigin(1, 0.5);
      this.coinsText.x = this.plusText.x - this.options.plusMargin;
      this.add(this.coinsText);
    }
    addLifeIcon() {
      this.lifeIcon = new LifeIcon(this.scene);
      this.lifeIcon.scale = 0.75;
      this.lifeIcon.x = this.plusText.x + this.lifeIcon.displayWidth / 2 + this.options.plusMargin;
      this.add(this.lifeIcon);
    }
    doSetSize() {
      let left = this.coinsText.left;
      let right = this.lifeIcon.x + this.lifeIcon.displayWidth / 2;
      let width = right - left;
      let height = Math.max(this.coinsText.displayHeight, this.lifeIcon.displayHeight);
      this.setSize(width, height);
    }
    updateContent(coinsNum, lifeTimer) {
      this.coinsText.setText(coinsNum.toLocaleString());
      this.lifeIcon.updateTime(lifeTimer);
    }
  };

  // src/scenes/levelMap/shopScreen/offers/OfferButton.ts
  var OfferButton = class extends ComplexButton {
    constructor(scene, options) {
      super(scene, "popups", options.type === "common" ? "popups/shop/button_pink.png" : "popups/shop/button_purple.png");
      this.options = options;
      this.name = `offer_button__${this.options.offerId}`;
      this.doAddText();
      this.inflateHitArea(20, 20);
    }
    doAddText() {
      let content = this.getTextContent(this.options.price);
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "24px",
        color: "#ffffff",
        align: "center",
        stroke: this.options.type === "common" ? "#F06B5C" : "#8E5481",
        strokeThickness: 5
      };
      this.addText(content, style);
      this.text.y -= 4;
      this.text.setWordWrapWidth(this.width * 0.55);
      this.text.setLineSpacing(-12);
    }
    getTextContent(value) {
      var _a;
      if (typeof value === "string") {
        return value;
      }
      let templates = window.game.config.purchases.currency.template;
      let template = (_a = templates[this.scene.game.texts.language]) != null ? _a : templates.en;
      return template.replace("#", value.toString());
    }
    onLanguageChange() {
      this.text.setText(this.getTextContent(this.options.price));
    }
  };

  // src/scenes/levelMap/shopScreen/offers/SpecialOffer.ts
  var SpecialOffer = class extends Phaser.GameObjects.Container {
    constructor(scene, options) {
      super(scene);
      this.options = options;
      this.name = `offer_${this.options.offerId}`;
      this.addBack();
      this.addChest();
      this.addTitle();
      this.addSubtitle();
      this.addButton();
      this.setSize(this.back.width, this.back.height);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "popups", "popups/shop/special_offer_bg.png");
      this.add(this.back);
    }
    addChest() {
      this.chest = this.scene.add.image(0, 0, "popups", "popups/shop/coins_chest.png");
      this.chest.x = this.back.left + 85;
      this.chest.y = this.back.bottom - 30;
      this.add(this.chest);
    }
    addTitle() {
      let content = this.scene.texts.shop.special_offer;
      let style = this.getTitleTextStyle();
      this.title = this.scene.add.text(0, 0, content, style);
      this.title.setOrigin(0.5, 0.5);
      this.title.x = 90;
      this.title.y = this.back.top + 35;
      this.add(this.title);
    }
    getTitleTextStyle() {
      return {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "34px",
        color: "#ffffff",
        align: "center",
        stroke: "#E98A49",
        strokeThickness: 8
      };
    }
    addSubtitle() {
      let options = {
        textStyle: this.getTitleTextStyle(),
        plusMargin: 20
      };
      this.subtitle = new SpecialOfferSubtitle(this.scene, options);
      this.subtitle.x = this.title.x + 30;
      this.subtitle.y = this.title.y + 48;
      this.subtitle.updateContent(this.options.coinsNum, this.options.livesNum);
      this.add(this.subtitle);
    }
    addButton() {
      let options = {
        type: "special",
        offerId: this.options.offerId,
        price: this.options.price
      };
      this.button = new OfferButton(this.scene, options);
      this.button.x = this.title.x;
      this.button.y = 50;
      this.add(this.button);
    }
    onLanguageChange() {
      this.title.setText(this.scene.texts.shop.special_offer);
      this.subtitle.updateContent(this.options.coinsNum, this.options.livesNum);
      this.button.onLanguageChange();
    }
  };

  // src/scenes/levelMap/shopScreen/offers/OfferPopover.ts
  var OfferPopoverType;
  (function(OfferPopoverType2) {
    OfferPopoverType2["BEST_VALUE"] = "BEST_VALUE";
    OfferPopoverType2["MOST_POPULAR"] = "MOST_POPULAR";
  })(OfferPopoverType || (OfferPopoverType = {}));
  var OfferPopover = class extends Phaser.GameObjects.Container {
    constructor(scene, popoverType) {
      super(scene);
      this.popoverType = popoverType;
      this.addBack();
      this.addText();
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "popups", "popups/shop/popover.png");
      this.add(this.back);
    }
    addText() {
      let content = this.getContentByType(this.popoverType);
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "18px",
        color: "#ffffff",
        align: "center"
      };
      this.text = this.scene.add.text(0, 0, content, style);
      this.text.setOrigin(0.5, 0.5);
      this.text.y = -22;
      this.text.setShadow(0, 2, "rgba(0,0,0,0.2)", 0);
      this.add(this.text);
      this.adjustTextSize();
    }
    getContentByType(popoverType) {
      switch (popoverType) {
        case OfferPopoverType.BEST_VALUE:
          return this.scene.texts.shop.best_value;
        case OfferPopoverType.MOST_POPULAR:
          return this.scene.texts.shop.most_popular;
        default:
          let x = popoverType;
          break;
      }
    }
    adjustTextSize() {
      let maxWidth = this.back.width * 0.8;
      this.text.scale = Math.min(1, maxWidth / this.text.width);
    }
    onLanguageChange() {
      this.text.setText(this.getContentByType(this.popoverType));
      this.adjustTextSize();
    }
  };

  // src/scenes/levelMap/shopScreen/offers/CommonOffer.ts
  var CommonOffer = class extends Phaser.GameObjects.Container {
    constructor(scene, options) {
      super(scene);
      this.plusSignMargin = 75;
      this.options = options;
      this.name = `offer_${this.options.offerId}`;
      this.addBack();
      this.addIcon();
      this.addCoinsText();
      this.addPopover();
      this.addPlus();
      this.addLifeIcon();
      this.addButton();
      this.addSeparator();
      this.bringToTop(this.button);
      this.setSize(this.back.width, this.back.height);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "popups", "popups/black_rect.png");
      this.back.alpha = 0.1;
      this.back.displayWidth = 470;
      this.back.displayHeight = this.options.height;
      this.add(this.back);
      this.back.kill();
    }
    addIcon() {
      let backLeft = this.back.x - this.back.displayWidth / 2;
      this.icon = this.scene.add.image(0, 0, "popups", this.options.iconFrame);
      this.icon.x = backLeft + 67;
      this.icon.y = 0;
      this.add(this.icon);
    }
    addCoinsText() {
      let content = this.options.coinsNum.toLocaleString();
      this.coinsText = this.scene.add.bitmapText(0, 0, BitmapFont.SHOP_COINS, content, 28);
      this.coinsText.setLetterSpacing(1.5);
      this.coinsText.setOrigin(0.5, 0.5);
      this.coinsText.x = this.icon.x;
      this.coinsText.y = this.icon.y + 44;
      this.add(this.coinsText);
    }
    addPopover() {
      if (this.options.popoverType === void 0) {
        return;
      }
      this.popover = new OfferPopover(this.scene, this.options.popoverType);
      this.popover.x = this.icon.x;
      this.popover.y = this.icon.y - 30;
      this.add(this.popover);
    }
    addPlus() {
      this.plusSign = this.scene.add.image(0, 0, "popups", "popups/shop/plus.png");
      this.plusSign.x = this.icon.x + this.plusSignMargin;
      this.add(this.plusSign);
    }
    addLifeIcon() {
      this.lifeIcon = new LifeIcon(this.scene);
      this.lifeIcon.x = this.plusSign.x + this.plusSignMargin - 12;
      this.lifeIcon.updateTime(this.options.livesNum);
      this.add(this.lifeIcon);
    }
    addButton() {
      let options = {
        type: "common",
        offerId: this.options.offerId,
        price: this.options.price
      };
      let backRight = this.back.x + this.back.displayWidth / 2;
      this.button = new OfferButton(this.scene, options);
      this.button.x = backRight - this.button.displayWidth / 2 - 15;
      this.button.y = 10;
      this.add(this.button);
    }
    onLanguageChange() {
      var _a;
      (_a = this.popover) == null ? void 0 : _a.onLanguageChange();
      this.button.onLanguageChange();
      this.lifeIcon.updateTime(this.options.livesNum);
    }
    addSeparator() {
      if (this.options.useSeparator === false) {
        return;
      }
      this.separator = this.scene.add.image(0, 0, "popups", "popups/shop/separator.png");
      this.separator.y = this.back.y + this.back.displayHeight / 2;
      this.add(this.separator);
    }
  };

  // src/scenes/levelMap/shopScreen/ShopPopupContent.ts
  var ShopPopupContent = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.contentType = "common";
      this.offers = [];
    }
    createShopOfferData(offerId) {
      let offerData = this.scene.game.purchases.getOfferById(offerId);
      if (offerData === void 0) {
        console.warn(`Offer ${offerId} doesn't exist!`);
        return;
      }
      return {
        offerId: offerData.id,
        price: offerData.price,
        coinsNum: offerData.content.coins,
        livesNum: offerData.content.lives,
        isSpecial: offerData.isSpecial
      };
    }
    createShopOfferOptions(options) {
      let data = this.createShopOfferData(options.offerId);
      if (data === void 0) {
        return;
      }
      return __spreadValues(__spreadValues({}, data), options);
    }
    createOffer(options) {
      let data = this.createShopOfferData(options.offerId);
      if (data === void 0) {
        return;
      }
      let fullOptions = __spreadValues(__spreadValues({}, data), options);
      if (fullOptions.isSpecial) {
        return this.createSpecialOffer(fullOptions);
      } else {
        return this.createCommonOffer(fullOptions);
      }
    }
    createCommonOffer(options) {
      let offer = new CommonOffer(this.scene, options);
      this.offers.push(offer);
      this.addButtonReleaseListener(offer);
      return offer;
    }
    createSpecialOffer(options) {
      let offer = new SpecialOffer(this.scene, options);
      this.offers.push(offer);
      this.addButtonReleaseListener(offer);
      return offer;
    }
    addButtonReleaseListener(offer) {
      offer.button.on(ButtonEvent.RELEASE, this.onButtonClick.bind(this, offer.options.offerId));
    }
    onButtonClick(offerId, button) {
      this.emit(ShopPopupEvent.PURCHASE_CLICK, button, offerId);
    }
    animateOnSwitch() {
    }
    onLanguageChange() {
      this.offers.forEach((offer) => offer.onLanguageChange());
    }
    onShow() {
    }
    onHide() {
    }
  };

  // src/scenes/levelMap/shopScreen/ShopPopupSpecialContent.ts
  var ShopPopupSpecialContent = class extends ShopPopupContent {
    constructor(scene) {
      super(scene);
      this.contentType = "special";
      this.addSpecialOffer();
      this.addCommonOffers();
    }
    addSpecialOffer() {
      let options = {
        offerId: "special_30000",
        iconFrame: "popups/shop/coins_chest.png",
        useSeparator: false,
        height: 0
      };
      this.specialOffer = this.createOffer(options);
      if (this.specialOffer) {
        this.add(this.specialOffer);
      }
    }
    addCommonOffers() {
      let height = 146;
      let offersData = [
        {
          offerId: "coins_20000",
          iconFrame: "popups/shop/coins_2.png",
          useSeparator: true,
          height
        },
        {
          offerId: "coins_50000",
          iconFrame: "popups/shop/coins_3.png",
          useSeparator: true,
          height
        },
        {
          offerId: "coins_100000",
          iconFrame: "popups/shop/coins_4.png",
          useSeparator: false,
          height
        }
      ];
      this.commonOffers = offersData.map((options) => this.createOffer(options)).filter(Boolean);
      this.commonOffers.forEach((offer, index) => {
        offer.y = 164 + index * height;
        this.add(offer);
      });
    }
    onShow() {
      super.onShow();
      this.startSpecialOfferAnimation();
    }
    startSpecialOfferAnimation() {
      if (!this.specialOffer) {
        return;
      }
      this.killSpecialOfferTweens();
      this.specialOfferTimerEvent = this.scene.time.addEvent({
        loop: true,
        delay: 4e3,
        startAt: 3e3,
        callback: () => {
          this.scene.tweens.add({
            targets: this.specialOffer,
            duration: 333,
            ease: Phaser.Math.Easing.Sine.InOut,
            scale: 1.03,
            yoyo: true,
            repeat: 2
          });
        }
      });
    }
    killSpecialOfferTweens() {
      if (this.specialOffer) {
        this.specialOffer.scale = 1;
        this.scene.tweens.killTweensOf(this.specialOffer);
      }
    }
    onHide() {
      var _a;
      super.onHide();
      (_a = this.specialOfferTimerEvent) == null ? void 0 : _a.remove();
      this.specialOfferTimerEvent = null;
    }
    preDestroy() {
      var _a;
      (_a = this.specialOfferTimerEvent) == null ? void 0 : _a.remove();
      this.specialOfferTimerEvent = null;
      this.killSpecialOfferTweens();
      super.preDestroy();
    }
  };

  // src/scenes/levelMap/shopScreen/ShopPopupCommonContent.ts
  var ShopPopupCommonContent = class extends ShopPopupContent {
    constructor(scene) {
      super(scene);
      this.contentType = "common";
      this.addOffers();
    }
    addOffers() {
      let height = 136;
      let options = [
        {
          offerId: "coins_10000",
          iconFrame: "popups/shop/coins_1.png",
          useSeparator: true,
          height
        },
        {
          offerId: "coins_20000",
          iconFrame: "popups/shop/coins_2.png",
          useSeparator: true,
          height
        },
        {
          offerId: "coins_50000",
          iconFrame: "popups/shop/coins_3.png",
          useSeparator: true,
          height
        },
        {
          offerId: "coins_100000",
          iconFrame: "popups/shop/coins_4.png",
          useSeparator: true,
          height
        },
        {
          offerId: "coins_200000",
          iconFrame: "popups/shop/coins_5.png",
          useSeparator: false,
          height
        }
      ];
      this.offers = options.map((options2) => this.createOffer(options2)).filter(Boolean);
      this.offers.forEach((offer, index) => {
        offer.y = -80 + index * height;
        this.add(offer);
      });
    }
    animateOnSwitch() {
      this.offers.forEach((offer, index) => {
        let dy = 20;
        offer.alpha = 0;
        offer.y += dy;
        this.scene.tweens.add({
          delay: index * 80,
          targets: offer,
          duration: 250,
          ease: Phaser.Math.Easing.Quadratic.Out,
          alpha: 1,
          y: offer.y - dy
        });
      });
    }
  };

  // src/scenes/levelMap/shopScreen/ShopPopup.ts
  var ShopPopupEvent;
  (function(ShopPopupEvent2) {
    ShopPopupEvent2["PURCHASE_CLICK"] = "__PURCHASE_CLICK";
  })(ShopPopupEvent || (ShopPopupEvent = {}));
  var ShopPopup = class extends Phaser.GameObjects.Container {
    constructor(scene, contentType) {
      super(scene);
      this.addBack();
      this.addCloseButton();
      this.addTitle();
      this.addContent(contentType);
      this.setSize(this.back.width, this.back.height);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "popups", "popups/shop/popup.png");
      this.add(this.back);
    }
    addCloseButton() {
      this.closeButton = this.scene.add.button("popups", "popups/Close Button.png", this);
      this.closeButton.x = this.back.right - 60;
      this.closeButton.y = this.back.top + 46;
    }
    addTitle() {
      let content = this.scene.texts.shop.title;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "46px",
        color: "#FFE0AD",
        align: "center",
        stroke: "#522923",
        strokeThickness: 12
      };
      this.title = this.scene.add.text(0, 0, content, style);
      this.title.setOrigin(0.5, 0.5);
      this.title.y = this.back.top + 56;
      this.add(this.title);
    }
    addContent(type) {
      this.content = type === "special" ? new ShopPopupSpecialContent(this.scene) : new ShopPopupCommonContent(this.scene);
      this.content.y = -175;
      this.content.on(ShopPopupEvent.PURCHASE_CLICK, this.onBuyButtonClick, this);
      this.add(this.content);
      return this.content;
    }
    onBuyButtonClick(button, offerId) {
      this.emit(ShopPopupEvent.PURCHASE_CLICK, offerId);
    }
    onSpecialOfferBought() {
      let shouldChangeContent = this.content.contentType === "special";
      if (shouldChangeContent === false) {
        return;
      }
      this.switchToCommonContent();
    }
    switchToCommonContent() {
      this.scene.tweens.add({
        targets: this.content,
        duration: 200,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 0,
        onComplete: () => {
          this.content.destroy();
          this.content = this.addContent("common");
          this.content.animateOnSwitch();
        }
      });
    }
    onShow() {
      this.content.onShow();
    }
    onHide() {
      this.content.onHide();
    }
    onLanguageChange() {
      this.title.text = this.scene.texts.shop.title;
      this.content.onLanguageChange();
    }
  };

  // src/scenes/levelMap/shopScreen/ShopScreen.ts
  var ShopScreenEvent;
  (function(ShopScreenEvent2) {
    ShopScreenEvent2["PURCHASE_COMPLETE"] = "__PURCHASE_COMPLETE";
  })(ShopScreenEvent || (ShopScreenEvent = {}));
  var ShopScreen = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "shop_screen",
        backgroundKey: "popups",
        backgroundFrame: "popups/black_rect.png",
        backgroundAlpha: 0.85
      });
      this.purchases = this.scene.game.purchases;
      this.addCoinsLabel();
      this.addPopup();
      this.addAdsText();
    }
    addCoinsLabel() {
      let options = {
        atlas: "popups",
        backFrame: "popups/labels/label_back.png",
        iconFrame: "popups/labels/Coin_2.png",
        iconOffset: {x: 0, y: 0},
        text: {
          type: "bitmap",
          font: BitmapFont.LABELS_POPUPS
        }
      };
      let coinsNum = this.scene.game.store.getNumber(GameStoreKey.COINS);
      this.coinsLabel = new LevelCompleteCoinsLabel(this.scene, options);
      this.coinsLabel.updateCoinsNumInstant(coinsNum);
      this.coinsLabel.circlesEmitter.setFrame("popups/particles/circle_fx_3.png");
      this.coinsLabel.sparksEmitter.setFrame("popups/particles/star_particle.png");
      this.pin(this.coinsLabel, 0, 0, 70, 66);
      this.add(this.coinsLabel);
    }
    addPopup() {
      let wasSpecialOfferBought = this.scene.game.store.getBoolean(GameStoreKey.SHOP_SPECIAL_OFFER_BOUGHT);
      let contentType = wasSpecialOfferBought ? "common" : "special";
      this.popup = new ShopPopup(this.scene, contentType);
      this.popup.on(ShopPopupEvent.PURCHASE_CLICK, this.onBuyButtonClick, this);
      this.popup.closeButton.on(ButtonEvent.PRESS, this.hide, this);
      this.add(this.popup);
      this.pin(this.popup, 0.5, 0.5);
    }
    onBuyButtonClick(offerId) {
      this.purchases.make(offerId, this.referrer).then(() => {
        this.onPurchaseComplete(offerId);
      });
    }
    onPurchaseComplete(offerId) {
      this.scene.audio.play(GameSoundKey.COIN_SPEND, {volume: 0.5});
      this.purchases.savePurchase(offerId);
      this.coinsLabel.playAnimation();
      this.coinsLabel.updateCoinsNum(this.scene.game.store.getNumber(GameStoreKey.COINS));
      if (this.purchases.isSpecialOffer(offerId)) {
        this.popup.onSpecialOfferBought();
      }
      this.emit(ShopScreenEvent.PURCHASE_COMPLETE, this, offerId);
    }
    addAdsText() {
      let content = this.scene.texts.shop.ads_hint;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "30px",
        color: "#FFE0AD",
        align: "center",
        stroke: "#41211F",
        strokeThickness: 6
      };
      this.adsText = this.scene.add.text(0, 0, content, style);
      this.adsText.setOrigin(0.5, 0.5);
      this.adsText.setWordWrapWidth(this.popup.width * 0.85);
      this.adsText.setLineSpacing(-6);
      this.adsText.alpha = 0.85;
      this.adsText.originalAlpha = this.adsText.alpha;
      this.adsText.originalScale = 1;
      this.add(this.adsText);
    }
    resize() {
      super.resize();
      this.resizePopup();
      this.alignAdsText();
      this.coinsLabel.originalY = this.coinsLabel.y;
    }
    resizePopup() {
      let maxHeight = this.screenHeight * 0.8;
      this.popup.scale = Math.min(1, maxHeight / this.popup.height);
      this.popup.originalScale = this.popup.scale;
      this.popup.originalY = this.popup.y;
    }
    alignAdsText() {
      let top = this.popup.y + this.popup.displayHeight / 2 - 40;
      let bottom = this.screenHeight;
      let height = bottom - top;
      this.adsText.x = this.screenWidth / 2;
      this.adsText.y = top + height / 2;
      this.adsText.originalY = this.adsText.y;
    }
    show(options) {
      this.alpha = 1;
      this.emitShowEvent();
      this.revive();
      this.showPopup();
      this.showAdsText(66);
      this.showCoinsLabel();
      if (options.showBackground) {
        this.background.revive();
        this.showBackground({duration: 200, ease: Phaser.Math.Easing.Quadratic.Out});
      } else {
        this.background.kill();
      }
      this.scene.audio.play(GameSoundKey.SHOP_OPEN, {volume: 0.25, seek: 0.3});
    }
    showPopup() {
      this.popup.alpha = 0;
      this.scene.tweens.add({
        delay: 0,
        targets: this.popup,
        alpha: {value: 1, ease: Phaser.Math.Easing.Cubic.Out, duration: 200}
      });
      this.popup.y += 60;
      this.scene.tweens.add({
        targets: this.popup,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.5],
        y: "-=60"
      });
      this.popup.onShow();
    }
    showAdsText(delay) {
      this.adsText.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.adsText,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: this.adsText.originalAlpha
      });
      this.adsText.y += 60;
      this.scene.tweens.add({
        delay,
        targets: this.adsText,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.5],
        y: "-=60"
      });
    }
    showCoinsLabel() {
      this.scene.tweens.add({
        targets: this.coinsLabel,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.coinsLabel.y = this.coinsLabel.originalY - 60;
      this.scene.tweens.add({
        targets: this.coinsLabel,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.5],
        y: this.coinsLabel.originalY
      });
    }
    hide() {
      this.emitHideStartEvent();
      this.scene.audio.stop(GameSoundKey.SHOP_OPEN);
      this.popup.onHide();
      this.scene.tweens.add({
        targets: this,
        duration: 100,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 0,
        onComplete: () => {
          this.kill();
          this.emitHideCompleteEvent();
        }
      });
    }
    onLanguageChange() {
      this.adsText.text = this.scene.texts.shop.ads_hint;
      this.popup.onLanguageChange();
    }
    preDestroy() {
      this.scene.audio.stop(GameSoundKey.SHOP_OPEN);
      super.preDestroy();
    }
  };

  // src/scenes/levelMap/piggyBackScreen/LargePiggyBank.ts
  var LargePiggyBankEvent;
  (function(LargePiggyBankEvent2) {
    LargePiggyBankEvent2["EXPLODE_COMPLETE"] = "__EXPLODE_COMPLETE";
  })(LargePiggyBankEvent || (LargePiggyBankEvent = {}));
  var LargePiggyBank = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.name = "piggy_bank_large";
      this.addPiggy();
      this.addPiggyWhite();
      this.addShrinkParticles();
      this.addExplodeParticles();
      this.bringToTop(this.piggyBank);
      this.bringToTop(this.piggyBankWhite);
      this.setSize(this.piggyBank.displayWidth, this.piggyBank.displayHeight);
    }
    addShrinkParticles() {
      this.shrinkParticles = this.scene.add.particles("rewards");
      this.shrinkParticles.setPosition(-10, -100);
      this.add(this.shrinkParticles);
      this.shrinkGravityWell = this.shrinkParticles.createGravityWell({
        power: 10,
        epsilon: 250,
        gravity: 200
      });
      this.shrinkCircles = this.shrinkParticles.createEmitter({
        frame: "rewards/particles/gift_circle_fx.png",
        alpha: {start: 0, end: 0.33, ease: Ease.ExpoOut},
        scale: {start: 6, end: 0.45, ease: Ease.Linear},
        lifespan: 500,
        frequency: 333,
        on: false
      });
      let emitCircle = new Phaser.Geom.Circle(0, 0, this.piggyBankWhite.displayWidth);
      this.shrinkSparks = this.shrinkParticles.createEmitter({
        frame: "rewards/particles/wheel_reward_spark.png",
        lifespan: 800,
        alpha: {start: 0, end: 1, ease: Ease.ExpoOut},
        scale: {start: 1.33, end: 0.33},
        quantity: 2,
        on: false
      }).setDeathZone({
        source: new Phaser.Geom.Circle(0, 0, emitCircle.radius * 0.25),
        type: "onEnter"
      }).setEmitZone({
        source: emitCircle,
        type: "random"
      });
    }
    addExplodeParticles() {
      this.explodeParticles = this.scene.add.particles("rewards");
      this.explodeParticles.setPosition(0, -80);
      this.add(this.explodeParticles);
      this.explodeCircles = this.explodeParticles.createEmitter({
        frame: "rewards/particles/gift_circle_fx.png",
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        scale: {start: 0.45, end: 8, ease: Ease.ExpoOut},
        lifespan: 900,
        on: false
      });
      this.explodeSparks = this.explodeParticles.createEmitter({
        frame: "rewards/particles/wheel_reward_spark.png",
        lifespan: 3e3,
        speed: {min: 10, max: 1200},
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        scale: {start: 1.33, end: 0},
        emitZone: {
          source: new Phaser.Geom.Circle(0, 0, 100),
          type: "random"
        },
        on: false
      });
      this.explodeSparks.reserve(100);
    }
    addPiggy() {
      this.piggyBank = this.scene.add.image(0, 0, "popups", "popups/piggy_bank/piggy_bank_large.png");
      this.add(this.piggyBank);
    }
    addPiggyWhite() {
      this.piggyBankWhite = this.scene.add.image(0, 0, "popups", "popups/piggy_bank/piggy_bank_large.png");
      this.piggyBankWhite.setOrigin(this.piggyBank.originX, this.piggyBank.originY);
      this.piggyBankWhite.kill();
      this.add(this.piggyBankWhite);
    }
    explode() {
      this.shrinkSparks.on = true;
      this.shrinkCircles.on = true;
      this.stopIdleTween();
      this.shrinkPiggy();
      this.shakePiggy();
    }
    shrinkPiggy() {
      var _a;
      let duration = 1333;
      this.scene.tweens.killTweensOf(this.piggyBank);
      (_a = this.scene.audio.play(GameSoundKey.DOUBLE_SPHERES_CHARGE)) == null ? void 0 : _a.fade(0, 1, duration);
      this.scene.tweens.add({
        targets: this.piggyBank,
        duration: 100,
        ease: Phaser.Math.Easing.Linear,
        scaleX: 1,
        scaleY: 1,
        onComplete: () => {
          this.scene.tweens.add({
            targets: [this.piggyBank, this.piggyBankWhite],
            duration,
            ease: Phaser.Math.Easing.Linear,
            scale: this.piggyBank.scale * 0.6,
            onComplete: () => {
              this.onShrinkComplete();
            }
          });
          this.piggyBankWhite.scaleX = this.piggyBank.scaleX;
          this.piggyBankWhite.scaleY = this.piggyBank.scaleY;
          this.piggyBankWhite.alpha = 0;
          this.scene.tweens.add({
            targets: this.piggyBankWhite,
            duration,
            ease: Phaser.Math.Easing.Quadratic.Out,
            alpha: 1
          });
        }
      });
    }
    shakePiggy() {
      let targets = [this.piggyBankWhite, this.piggyBank];
      let duration = 33;
      let dx = 7;
      this.shakeTween = this.scene.tweens.add({
        targets,
        duration,
        ease: Phaser.Math.Easing.Linear,
        x: `+=${dx}`,
        onComplete: () => {
          this.shakeTween = this.scene.tweens.add({
            targets,
            duration,
            ease: Phaser.Math.Easing.Sine.InOut,
            x: `-=${dx * 2}`,
            repeat: -1,
            yoyo: true
          });
        }
      });
    }
    onShrinkComplete() {
      var _a;
      (_a = this.shakeTween) == null ? void 0 : _a.remove();
      this.piggyBank.kill();
      this.emit(LargePiggyBankEvent.EXPLODE_COMPLETE, this);
      this.scene.audio.play(GameSoundKey.GIFT_EXPLODE);
      this.shrinkParticles.kill();
      this.shrinkSparks.on = false;
      this.shrinkCircles.on = false;
      this.explodeCircles.emitParticle(1);
      this.explodeSparks.emitParticle(100);
      this.scene.tweens.add({
        targets: [this.piggyBank, this.piggyBankWhite],
        duration: 600,
        ease: Phaser.Math.Easing.Expo.Out,
        scale: 3,
        alpha: 0,
        y: "+=100",
        onComplete: () => {
          this.piggyBank.kill();
          this.piggyBankWhite.kill();
        }
      });
    }
    playIdleTween() {
      var _a;
      (_a = this.idleTween) == null ? void 0 : _a.remove();
      this.idleTween = this.scene.tweens.add({
        targets: this,
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        scaleX: 1.04,
        scaleY: 0.97,
        yoyo: true,
        repeat: -1
      });
    }
    stopIdleTween() {
      var _a;
      (_a = this.idleTween) == null ? void 0 : _a.remove();
      this.idleTween = null;
    }
    reset() {
      this.piggyBank.scale = 1;
      this.piggyBank.alpha = 1;
      this.piggyBank.x = 0;
      this.piggyBank.y = 0;
      this.piggyBank.revive();
    }
  };

  // src/scenes/levelMap/piggyBackScreen/PiggyBackScreen.ts
  var PiggyBankScreenEvent;
  (function(PiggyBankScreenEvent2) {
    PiggyBankScreenEvent2["BREAK"] = "__BREAK";
  })(PiggyBankScreenEvent || (PiggyBankScreenEvent = {}));
  var PiggyBankScreen = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "PiggyBankScreen",
        backgroundKey: "popups",
        backgroundFrame: "popups/black_rect.png",
        backgroundAlpha: 0.85
      });
      this.piggyBankPinY = 0.6;
      this.piggyBankService = this.scene.game.piggyBank;
      this.createAddCoinThrottledSound();
      this.addTopLeftCoinsLabel();
      this.addCloseButton();
      this.addTitle();
      this.addHint();
      this.addPiggyBank();
      this.addCoinsLabel();
      this.addBreakButton();
      this.bringToTop(this.breakButton);
      this.bringToTop(this.title);
      this.bringToTop(this.hint);
    }
    createAddCoinThrottledSound() {
      this.addCoinSound = throttle_default(() => {
        this.scene.audio.play(GameSoundKey.COIN_ADD, {volume: 0.5});
      }, 50, {trailing: false});
    }
    addTopLeftCoinsLabel() {
      let options = {
        atlas: "popups",
        backFrame: "popups/labels/label_back.png",
        iconFrame: "popups/labels/Coin_2.png",
        iconOffset: {x: 0, y: 0},
        text: {
          type: "bitmap",
          font: BitmapFont.LABELS_POPUPS
        }
      };
      this.topLeftCoinsLabel = new LevelCompleteCoinsLabel(this.scene, options);
      this.topLeftCoinsLabel.syncWithGameStore(true);
      this.topLeftCoinsLabel.circlesEmitter.setFrame("popups/particles/circle_fx_3.png");
      this.topLeftCoinsLabel.sparksEmitter.setFrame("popups/particles/star_particle.png");
      this.topLeftCoinsLabel.kill();
      this.pin(this.topLeftCoinsLabel, 0, 0, 70, 66);
      this.add(this.topLeftCoinsLabel);
    }
    addCloseButton() {
      this.closeButton = this.scene.add.button("popups", "popups/piggy_bank/button_close_2.png", this);
      this.closeButton.on(ButtonEvent.PRESS, this.onCloseButtonClick, this);
      this.closeButton.inflateHitArea(15, 15);
      this.pin(this.closeButton, 1, 0, -80, 80);
    }
    addTitle() {
      let content = this.scene.texts.piggy_bank.title;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "68px",
        color: "#FFA48E",
        align: "center",
        padding: {x: 0, y: 10}
      };
      this.title = this.scene.add.text(0, 0, content, style);
      this.title.setOrigin(0.5, 0.5);
      this.title.setShadow(0, 4, "#AC4717", 2);
      this.add(this.title);
      this.pin(this.title, 0.5, this.piggyBankPinY, 0, -450);
    }
    addHint() {
      let content = this.scene.texts.piggy_bank.warning;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "28px",
        color: "#FE8C82",
        align: "center",
        padding: {x: 0, y: 2}
      };
      this.hint = this.scene.add.text(0, 0, content, style);
      this.hint.setOrigin(0.5, 0.5);
      this.hint.setShadow(0, 3, "rgba(0,0,0,0.2)");
      this.hint.setWordWrapWidth(Config.SOURCE_GAME_WIDTH * 0.7);
      this.add(this.hint);
      this.pin(this.hint, 0.5, this.piggyBankPinY, 0, -350);
    }
    addPiggyBank() {
      this.piggyBank = new LargePiggyBank(this.scene);
      this.pin(this.piggyBank, 0.5, this.piggyBankPinY, 12);
      this.add(this.piggyBank);
    }
    addCoinsLabel() {
      let back = this.scene.add.image(-5, 0, "popups", "popups/piggy_bank/coins_label.png");
      this.coinsLabelText = this.createCoinsText();
      this.coinsLabelText.x = 17;
      this.coinsLabelText.y = -2;
      this.coinsLabelText.originalX = this.coinsLabelText.x;
      this.coinsLabel = this.scene.add.container(0, 0, [back, this.coinsLabelText]);
      this.pin(this.coinsLabel, 0.5, this.piggyBankPinY, 4, 50);
      this.add(this.coinsLabel);
    }
    createCoinsText() {
      let content = `0 / 0`;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "24px",
        color: "#ffffff",
        align: "center",
        padding: {x: 0, y: 2}
      };
      let text = this.scene.add.text(0, 0, content, style);
      text.setOrigin(0.5, 0.5);
      text.setShadow(0, 2, "rgba(0,0,0,0.2)", 0);
      return text;
    }
    addBreakButton() {
      var _a;
      if (this.scene.game.piggyBank.getBreakMethod() === "purchase") {
        this.addPurchaseButton();
      } else {
        this.addVideoButton();
      }
      this.breakButton = (_a = this.videoButton) != null ? _a : this.purchaseButton;
      this.breakButton.name = "break_button";
    }
    addVideoButton() {
      let content = this.scene.texts.piggy_bank.break_it;
      let style = this.getBreakButtonTextStyle();
      this.videoButton = this.scene.add.complexButton("popups", "popups/piggy_bank/button_double.png");
      this.videoButton.addIcon("popups", "popups/piggy_bank/watch ad.png", 135, -60).setScale(0.9);
      this.videoButton.addText(content, style, 0, -3);
      this.videoButton.text.setLineSpacing(-4);
      this.videoButton.text.setWordWrapWidth(210, true);
      this.videoButton.on(ButtonEvent.RELEASE, this.onVideoButtonClick, this);
      this.add(this.videoButton);
      this.pin(this.videoButton, 0.5, 0.7);
    }
    onVideoButtonClick(button) {
      let canBreak = this.canBreak();
      if (canBreak === false) {
        this.showCantBreakWarning();
        return;
      }
      this.scene.game.gdSdk.showRewardedAd("LevelMap:PiggyBank").then((success) => {
        if (success) {
          button.disableInput();
          this.onPiggyBankBreak();
        }
      });
    }
    addPurchaseButton() {
      let content = this.scene.texts.piggy_bank.break_it;
      let style = __spreadProps(__spreadValues({}, this.getBreakButtonTextStyle()), {
        fontSize: "34px"
      });
      this.purchaseButton = this.scene.add.complexButton("popups", "popups/piggy_bank/button_double.png");
      this.purchaseButton.addText(content, style, 0, -16);
      this.purchaseButton.text.setLineSpacing(-4);
      this.purchaseButton.text.setWordWrapWidth(210, true);
      this.purchaseButton.on(ButtonEvent.RELEASE, this.onPurchaseButtonClick, this);
      this.add(this.purchaseButton);
      this.pin(this.purchaseButton, 0.5, 0.7);
      this.addPriceText();
    }
    addPriceText() {
      let offer = this.scene.game.purchases.getOfferById("piggy_bank");
      let content = `${offer.price} \u0433\u043E\u043B\u043E\u0441\u043E\u0432`;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "24px",
        color: "#ffffff",
        align: "center"
      };
      let text = this.scene.add.text(0, 0, content, style);
      text.setShadow(0, 3, "rgba(0,0,0,0.2)", 0);
      text.setOrigin(0.5, 0.5);
      text.y = 16;
      this.purchaseButton.add(text);
    }
    onPurchaseButtonClick() {
      let canBreak = this.canBreak();
      if (canBreak === false) {
        this.showCantBreakWarning();
        return;
      }
      this.scene.game.purchases.make("piggy_bank", "PiggyBank_Screen").then(() => this.onPiggyBankBreak());
    }
    getBreakButtonTextStyle() {
      return {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "32px",
        color: "#ffffff",
        align: "center",
        padding: {x: 0, y: 6},
        shadow: {
          offsetX: 0,
          offsetY: 3,
          fill: true,
          color: "rgba(0,0,0,0.2)",
          blur: 0
        }
      };
    }
    canBreak() {
      return this.scene.game.piggyBank.getCurrentCoins() >= window.game.config.piggy_bank.min_amount_to_open;
    }
    showCantBreakWarning() {
      this.shakeCoinsText();
      this.scene.audio.play(GameSoundKey.BOOSTER_CANT_USE, {volume: 0.75});
      this.scene.game.toasts.show({
        message: this.scene.texts.piggy_bank.not_enough.replace("#", window.game.config.piggy_bank.min_amount_to_open.toString()),
        lifespan: 3e3
      });
    }
    onPiggyBankBreak() {
      this.scene.input.once(Phaser.Input.Events.POINTER_DOWN, this.startFastForward, this);
      let coinsToAdd = this.scene.game.store.getNumber(GameStoreKey.PIGGY_BANK_COINS);
      this.getItemsToHide().forEach((item) => item.kill());
      this.showTopLeftCoinsLabel();
      this.updateGameStore(coinsToAdd);
      this.piggyBank.once(LargePiggyBankEvent.EXPLODE_COMPLETE, this.onExplodeComplete.bind(this, coinsToAdd));
      this.piggyBank.explode();
      this.emit(PiggyBankScreenEvent.BREAK, this, coinsToAdd);
    }
    startFastForward() {
      this.scene.fastForward.start(1.5);
    }
    getItemsToHide() {
      return [this.title, this.hint, this.coinsLabel, this.coinsLabelText, this.breakButton, this.closeButton];
    }
    showTopLeftCoinsLabel() {
      this.topLeftCoinsLabel.syncWithGameStore(true);
      this.topLeftCoinsLabel.revive();
    }
    updateGameStore(coinsToAdd) {
      this.scene.game.store.saveValue(GameStoreKey.PIGGY_BANK_COINS, 0);
      this.scene.game.store.changeNumber(GameStoreKey.COINS, coinsToAdd);
      this.scene.game.analytics.addResource(ResourceCurrency.COINS, coinsToAdd, ResourceItemType.COIN, "PiggyBank");
    }
    onExplodeComplete(coinsToAdd) {
      let coinsNum = 10;
      let onFirstCoinArrive = once_default(() => {
        this.topLeftCoinsLabel.syncWithGameStore(false);
        this.topLeftCoinsLabel.playTextTween();
        this.topLeftCoinsLabel.playAnimation();
        this.topLeftCoinsLabel.showTextFx(`+${coinsToAdd}`);
      });
      let onLastCoinArrive = after_default(coinsNum, () => {
        this.scene.time.delayedCall(1100, () => {
          this.hide();
        });
      });
      times_default(coinsNum, () => this.collectCoin(onFirstCoinArrive, onLastCoinArrive));
      this.scene.audio.play(GameSoundKey.COIN_SPEND, {volume: 1});
    }
    collectCoin(onFirstCoinArrive, onLastCoinArrive) {
      let coin = this.scene.add.image(0, 0, "popups", "popups/labels/Coin_2.png");
      coin.x = this.piggyBank.x;
      coin.y = this.piggyBank.y - 60;
      this.addAt(coin, 1);
      let start = {
        x: coin.x + Phaser.Math.RND.between(30, 60) * Phaser.Math.RND.sign(),
        y: coin.y + Phaser.Math.RND.between(30, 60) * Phaser.Math.RND.sign()
      };
      let end = {x: this.topLeftCoinsLabel.x, y: this.topLeftCoinsLabel.y};
      let curve = new Phaser.Curves.Spline([
        start.x,
        start.y,
        start.x - Phaser.Math.RND.between(-50, 150),
        start.y - Phaser.Math.RND.between(-70, 0),
        end.x,
        end.y
      ]);
      let duration = Phaser.Math.RND.between(700, 1100);
      let delay = 0;
      this.scene.tweens.addCurveTween({
        delay,
        curve,
        target: coin,
        duration,
        ease: Ease.QuadInOut,
        onComplete: () => {
          coin.destroy();
          onFirstCoinArrive();
          onLastCoinArrive();
          this.addCoinSound();
        }
      });
      this.scene.tweens.add({
        targets: coin,
        duration: duration + delay,
        ease: Phaser.Math.Easing.Back.In,
        angle: 360
      });
      coin.scale = 0;
      this.scene.tweens.add({
        delay,
        targets: coin,
        duration: 800,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1
      });
    }
    shakeCoinsText() {
      this.coinsLabelText.x = this.coinsLabelText.originalX;
      this.scene.tweens.killTweensOf(this.coinsLabelText);
      this.scene.tweens.add({
        targets: this.coinsLabelText,
        duration: 44,
        ease: Phaser.Math.Easing.Sine.InOut,
        x: "+=10",
        repeat: 3,
        yoyo: true
      });
    }
    onCloseButtonClick() {
      this.hide();
    }
    resize() {
      super.resize();
      this.hint.originalY = this.hint.y;
      this.title.originalY = this.title.y;
      this.alignBreakButton();
    }
    alignBreakButton() {
      this.breakButton.y = this.coinsLabel.y + 150;
      this.breakButton.originalY = this.breakButton.y;
    }
    updateData(data) {
      this.reset();
      this.hint.text = this.getHintTextContent();
      this.updateCoinsLabel(data.currentCoins, data.maxCoins);
      this.resize();
    }
    reset() {
      this.getItemsToHide().forEach((item) => item.revive());
      this.topLeftCoinsLabel.kill();
      this.piggyBank.reset();
      this.breakButton.enableInput();
    }
    getHintTextContent() {
      return this.scene.game.piggyBank.isFull() ? this.scene.texts.piggy_bank.warning : this.scene.texts.piggy_bank.hint;
    }
    updateCoinsLabel(currentCoins, maxCoins) {
      this.coinsLabelText.text = `${currentCoins} / ${maxCoins}`;
    }
    show(options) {
      this.emitShowEvent();
      this.revive();
      this.alpha = 1;
      if (options.showBackground) {
        this.background.revive();
        this.showBackground();
      } else {
        this.background.kill();
      }
      this.showPiggyBank();
      this.showTopTexts(0);
      this.showBreakButton(0);
    }
    showPiggyBank() {
      this.piggyBank.setScale(1, 1);
      let items = [this.piggyBank, this.coinsLabel];
      items.forEach((item) => {
        item.alpha = 0;
        this.scene.tweens.add({
          targets: item,
          duration: 150,
          ease: Phaser.Math.Easing.Cubic.Out,
          alpha: 1
        });
        item.scale = 0.8;
        this.scene.tweens.add({
          targets: item,
          duration: 400,
          ease: Phaser.Math.Easing.Back.Out,
          scale: 1,
          onComplete: () => {
            if (item === this.piggyBank) {
              this.piggyBank.playIdleTween();
            }
          }
        });
      });
    }
    showTopTexts(initialDelay) {
      this.hint.scale = 1;
      let texts = [this.hint, this.title];
      texts.forEach((text, index) => {
        let delay = initialDelay + index * 100;
        text.alpha = 0;
        this.scene.tweens.add({
          delay,
          targets: text,
          duration: 150,
          ease: Phaser.Math.Easing.Cubic.Out,
          alpha: 1
        });
        text.scale = 0.75;
        this.scene.tweens.add({
          delay,
          targets: text,
          duration: 400,
          ease: Phaser.Math.Easing.Back.Out,
          scale: 1
        });
        let deltaY = -50;
        text.y = text.originalY + deltaY;
        this.scene.tweens.add({
          delay,
          targets: text,
          duration: 500,
          ease: Phaser.Math.Easing.Back.Out,
          y: text.originalY,
          onComplete: () => {
            if (text === this.hint && this.piggyBankService.isFull()) {
              this.animateHint();
            }
          }
        });
      });
    }
    animateHint() {
      this.scene.tweens.add({
        targets: this.hint,
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.1,
        yoyo: true,
        repeat: -1
      });
    }
    showBreakButton(delay) {
      this.breakButton.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.breakButton,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.breakButton.scale = 0.75;
      this.scene.tweens.add({
        delay,
        targets: this.breakButton,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1
      });
      let deltaY = 50;
      this.breakButton.y = this.breakButton.originalY + deltaY;
      this.scene.tweens.add({
        delay,
        targets: this.breakButton,
        duration: 500,
        ease: Phaser.Math.Easing.Back.Out,
        y: this.breakButton.originalY
      });
    }
    hide() {
      this.emit(PhaserScreenEvent.HIDE_START);
      this.scene.input.off(Phaser.Input.Events.POINTER_DOWN, this.startFastForward, this);
      this.scene.fastForward.stop();
      this.scene.tweens.killTweensOf(this.piggyBank);
      this.scene.tweens.killTweensOf(this.hint);
      this.scene.game.toasts.dismissAll();
      this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.kill();
          this.emit(PhaserScreenEvent.HIDE_COMPLETE, this);
        }
      });
    }
    onLanguageChange() {
      this.title.text = this.scene.texts.piggy_bank.title;
      this.hint.text = this.getHintTextContent();
      this.breakButton.text.text = this.scene.texts.piggy_bank.break_it;
    }
    preDestroy() {
      this.scene.input.off(Phaser.Input.Events.POINTER_DOWN, this.startFastForward, this);
      super.preDestroy();
    }
  };

  // src/scenes/gameplayGui/GameplayGui.ts
  var GameplayGuiEvent;
  (function(GameplayGuiEvent2) {
    GameplayGuiEvent2["GOTO_NEXT_LEVEL"] = "__GOTO_NEXT_LEVEL";
    GameplayGuiEvent2["GOTO_PREV_LEVEL"] = "__GOTO_PREV_LEVEL";
    GameplayGuiEvent2["GOTO_LEVEL_MAP"] = "__GOTO_LEVEL_MAP";
    GameplayGuiEvent2["LEVEL_MAP_ON_FAIL"] = "__LEVEL_MAP_ON_FAIL";
    GameplayGuiEvent2["LEVEL_MAP_ON_COMPLETE"] = "__LEVEL_MAP_ON_COMPLETE";
    GameplayGuiEvent2["RESTART_LEVEL_FROM_POPUP"] = "__START_LEVEL_FROM_POPUP";
    GameplayGuiEvent2["RESTART"] = "__RESTART";
    GameplayGuiEvent2["SEND_GAMEPLAY_SESSION"] = "__SEND_GAMEPLAY_SESSION";
  })(GameplayGuiEvent || (GameplayGuiEvent = {}));
  var GameplayGui2 = class extends BaseScene {
    init(data) {
      super.init();
      this.gameplay = data.gameplay;
      this.levelConfig = this.gameplay.levelConfig;
      this.goalsScreen = null;
      this.secondChanceScreen = null;
      this.failedScreen = null;
      this.pregameBoosterBuyScreen = null;
      this.preCompleteScreen = null;
      this.completeScreen = null;
      this.startLevelScreen = null;
      this.livesScreen = null;
      this.tutorial = null;
      this.quitScreen = null;
      this.shopScreen = null;
      this.piggyBankScreen = null;
    }
    create() {
      this.addTopPanel();
      this.addPowerupChefManager();
      this.addPauseButton();
      this.addUndoButton();
      this.addBoostersPanel();
      this.addMovesWarning();
      this.addGoalsScreen();
      this.addBoosterBuyScreen();
      this.addBoosterHintScreen();
      this.addBoosterWarning();
      this.addPauseScreen();
      this.addEmitters();
      this.addUndoOverlay();
      this.addGuides();
      this.addKeyboardCallbacks();
      this.goalItems = new GoalItemsManager(this);
      let hideGui = UrlParams.getBool("hideGui");
      if (hideGui) {
        this.scene.setVisible(false);
      }
    }
    addTopPanel() {
      this.topPanel = new TopPanel(this, this.levelConfig);
      this.topPanel.setDepth(GameplayGuiDepth.TOP_PANEL);
      this.size(this.topPanel);
      this.pin(this.topPanel, 0.5, 0);
      this.add.existing(this.topPanel);
    }
    addPowerupChefManager() {
      this.powerupChef = new PowerupChefManager(this, this.topPanel.chef);
    }
    addPauseButton() {
      this.pauseButton = new ComplexButton(this, "gameplay_gui", "Red-RectangleButton");
      this.pauseButton.addIcon("gameplay_gui", "pause_icon");
      this.pauseButton.setName("pause_button");
      this.pin(this.pauseButton, 0, 1, 57, -55);
      this.size(this.pauseButton);
      this.add.existing(this.pauseButton);
    }
    addUndoButton() {
      let undoBooster = this.game.boosters.getByType(BoosterType.UNDO);
      this.undoButton = new UndoButton(this, undoBooster);
      this.pin(this.undoButton, 1, 1, -57, -55);
      this.size(this.undoButton);
      this.add.existing(this.undoButton);
    }
    addBoostersPanel() {
      let boosters = this.game.boosters.boosters.filter((booster) => booster.type !== BoosterType.UNDO);
      let boostersConfig = this.levelConfig.boosters;
      this.boostersPanel = new BoostersPanel(this, boosters, boostersConfig);
      this.boostersPanel.setDepth(GameplayGuiDepth.BOOSTERS_PANEL);
      this.boostersPanel.on(BoostersPanelEvent.BUY_BOOSTER, this.onBuyBoosterClick, this);
      this.size(this.boostersPanel);
      this.add.existing(this.boostersPanel);
    }
    onBuyBoosterClick(booster) {
      let data = this.getBoosterBuyScreenData(booster.type);
      this.boosterBuyScreen.updateData(data);
      this.boosterBuyScreen.show({showBackground: true});
    }
    addMovesWarning() {
      this.movesWarning = new MovesWarning(this);
      this.movesWarning.setDepth(GameplayGuiDepth.MOVES_WARNING);
      this.movesWarning.kill();
      this.size(this.movesWarning);
      this.pin(this.movesWarning, 0.5, 0.5);
      this.add.existing(this.movesWarning);
    }
    addGoalsScreen() {
      let skipGoalsScreen = UrlParams.getBool("skipGoals") || this.levelConfig.levelNumber === 1;
      if (skipGoalsScreen) {
        return;
      }
      this.goalsScreen = new GoalsScreen(this, this.levelConfig.goals);
      this.goalsScreen.setDepth(GameplayGuiDepth.GOALS_SCREEN);
      this.goalsScreen.kill();
      this.add.existing(this.goalsScreen);
    }
    addBoosterBuyScreen() {
      this.boosterBuyScreen = new BoosterBuyScreen(this);
      this.boosterBuyScreen.setDepth(GameplayGuiDepth.VIDEO_REWARDS_SCREEN);
      this.boosterBuyScreen.kill();
      this.boosterBuyScreen.on(BoosterBuyScreenEvent.SHOW_SHOP, () => this.showShopScreen("Gameplay:BoosterBuyScreen"));
      this.boosterBuyScreen.on(BoosterBuyScreenEvent.BOOSTER_BUY_COMPLETE, this.onBoosterBuyComplete, this);
      this.boosterBuyScreen.on(PhaserScreenEvent.HIDE_START, this.dismissAllToasts, this);
      this.add.existing(this.boosterBuyScreen);
    }
    getBoosterBuyScreenData(boosterType) {
      let rewardType = VideoRewardUtils.getRewardByBooster(boosterType);
      let screenData = VideoRewardUtils.getVideoRewardScreenData(rewardType, this.texts);
      let disableVideoButton = boosterType !== BoosterType.UNDO;
      return __spreadProps(__spreadValues({}, screenData), {
        coinsTotal: this.game.store.getNumber(GameStoreKey.COINS),
        boosterPriceInCoins: 1e3,
        disableVideoButton
      });
    }
    onBoosterBuyComplete(data, source) {
      this.boosterBuyScreen.hideInstant();
      let boosterType = VideoRewardUtils.getBoosterByReward(data.rewardType);
      this.game.boosters.getByType(boosterType).num += data.rewardNum;
      this.game.analytics.addResource(ResourceCurrency.BOOSTERS, data.rewardNum, boosterType, `Level_${this.levelConfig.levelNumber}`);
      if (boosterType === BoosterType.UNDO) {
        this.time.delayedCall(200, () => {
          this.undoButton.onRewardGranted();
        });
      } else {
        this.time.delayedCall(200, () => {
          var _a;
          (_a = this.boostersPanel.getIconByType(boosterType)) == null ? void 0 : _a.onBoosterIncrease();
          this.boostersPanel.emulateClickOnIcon(boosterType);
        });
      }
    }
    showShopScreen(referrer) {
      if (!this.shopScreen) {
        this.addShopScreen();
      }
      this.shopScreen.referrer = referrer;
      this.shopScreen.show({showBackground: false});
    }
    addShopScreen() {
      this.shopScreen = new ShopScreen(this);
      this.shopScreen.setDepth(GameplayGuiDepth.SHOP_SCREEN);
      this.shopScreen.on(PhaserScreenEvent.SHOW, this.onShopScreenShow, this);
      this.shopScreen.on(PhaserScreenEvent.HIDE_START, this.onShopScreenHideStart, this);
      this.shopScreen.on(ShopScreenEvent.PURCHASE_COMPLETE, this.onShopPurchaseComplete, this);
      this.shopScreen.resize();
      this.shopScreen.kill();
      this.add.existing(this.shopScreen);
    }
    onShopScreenShow() {
      var _a, _b, _c, _d, _e, _f;
      if ((_a = this.boosterBuyScreen) == null ? void 0 : _a.visible) {
        (_b = this.boosterBuyScreen) == null ? void 0 : _b.deactivate();
      }
      if ((_c = this.secondChanceScreen) == null ? void 0 : _c.visible) {
        (_d = this.secondChanceScreen) == null ? void 0 : _d.deactivate();
      }
      if ((_e = this.pregameBoosterBuyScreen) == null ? void 0 : _e.visible) {
        (_f = this.pregameBoosterBuyScreen) == null ? void 0 : _f.deactivate();
      }
    }
    onShopScreenHideStart() {
      var _a, _b, _c;
      (_a = this.boosterBuyScreen) == null ? void 0 : _a.activate();
      (_b = this.secondChanceScreen) == null ? void 0 : _b.activate();
      (_c = this.pregameBoosterBuyScreen) == null ? void 0 : _c.activate();
    }
    onShopPurchaseComplete() {
      var _a, _b, _c;
      let coins = this.game.store.getNumber(GameStoreKey.COINS);
      (_a = this.boosterBuyScreen) == null ? void 0 : _a.coinsLabel.updateCoinsNumInstant(coins);
      (_b = this.secondChanceScreen) == null ? void 0 : _b.coinsLabel.updateCoinsNumInstant(coins);
      (_c = this.pregameBoosterBuyScreen) == null ? void 0 : _c.coinsLabel.updateCoinsNumInstant(coins);
    }
    addBoosterHintScreen() {
      this.boosterHintScreen = new BoosterHintScreen(this, this.gameplay);
      this.boosterHintScreen.setDepth(GameplayGuiDepth.BOOSTER_HINT_SCREEN);
      this.boosterHintScreen.kill();
      this.add.existing(this.boosterHintScreen);
    }
    addBoosterWarning() {
      let content = this.texts.booster_hint_cookie;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "30px",
        color: "#ffffff",
        align: "center",
        stroke: "rgba(0,0,0,0.5)",
        strokeThickness: 8
      };
      this.boosterWarning = new BoosterHintWarning(this, content, style);
      this.boosterWarning.setLineSpacing(-12);
      this.boosterWarning.setWordWrapWidth(210, true);
      this.boosterWarning.setOrigin(0.5, 0.5);
      this.boosterWarning.setDepth(GameplayGuiDepth.BOOSTER_HINT_WARNING);
      this.boosterWarning.kill();
      this.add.existing(this.boosterWarning);
    }
    addSecondChanceScreen() {
      this.secondChanceScreen = new SecondChanceScreen(this);
      this.secondChanceScreen.setDepth(GameplayGuiDepth.SECOND_CHANCE_SCREEN);
      this.secondChanceScreen.on(SecondChanceScreenEvent.SHOW_SHOP, () => this.showShopScreen("Gameplay:SecondChangeScreen"));
      this.secondChanceScreen.kill();
      this.add.existing(this.secondChanceScreen);
      this.secondChanceScreen.resize();
    }
    addFailedScreen() {
      this.failedScreen = new LevelFailedScreen(this);
      this.failedScreen.once(PhaserScreenEvent.SHOW, this.onFailedScreenShow, this);
      this.failedScreen.restartText.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onFailedScreenContinue, this);
      this.failedScreen.popup.closeButton.once(ButtonEvent.RELEASE, this.onFailedScreenClose, this);
      this.failedScreen.setDepth(GameplayGuiDepth.LEVEL_FAILED_SCREEN);
      this.failedScreen.kill();
      this.add.existing(this.failedScreen);
      this.failedScreen.resize();
    }
    onFailedScreenShow() {
      this.tweens.add({
        targets: this.gameplay.camera.camera,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.gameplay.scene.setActive(false);
          this.gameplay.scene.setVisible(false);
        }
      });
      this.hideGuiOnLevelEnd();
    }
    onFailedScreenContinue() {
      this.failedScreen.hide();
      this.showStartLevelScreen();
    }
    onFailedScreenClose() {
      this.game.gdSdk.showInterstitialAd("Gameplay:FailedScreen:Close").finally(() => {
        this.restartFromLevelMap();
      });
    }
    showStartLevelScreen() {
      this.startLevelScreen = new StartLevelScreen(this);
      this.startLevelScreen.setDepth(GameplayGuiDepth.START_LEVEL_SCREEN);
      this.startLevelScreen.resize();
      this.startLevelScreen.updateData(this.levelConfig.levelNumber);
      this.startLevelScreen.on(StartLevelScreenEvent.SHOW_PIGGY_BANK_SCREEN, () => this.showPiggyBankScreen({showBackground: false}));
      this.startLevelScreen.popup.pregameBoosters.on(PregameBoostersPanelEvent.ADD_BOOSTER_CLICK, this.onPregameBoosterClick, this);
      this.startLevelScreen.popup.closeButton.once(ButtonEvent.RELEASE, this.onStartLevelClose, this);
      this.startLevelScreen.popup.playButton.on(ButtonEvent.RELEASE, this.onPlayButtonClick, this);
      this.add.existing(this.startLevelScreen);
      this.startLevelScreen.show({fadeInBackground: false});
    }
    showPiggyBankScreen(options) {
      if (!this.piggyBankScreen) {
        this.addPiggyBankScreen();
      }
      let data = {
        currentCoins: this.game.store.getNumber(GameStoreKey.PIGGY_BANK_COINS),
        maxCoins: window.game.config.piggy_bank.max_capacity
      };
      this.piggyBankScreen.resize();
      this.piggyBankScreen.updateData(data);
      this.piggyBankScreen.show(options);
    }
    addPiggyBankScreen() {
      this.piggyBankScreen = new PiggyBankScreen(this);
      this.piggyBankScreen.setDepth(GameplayGuiDepth.PIGGY_BANK_SCREEN);
      this.piggyBankScreen.on(PhaserScreenEvent.SHOW, this.onPiggyBankScreenShow, this);
      this.piggyBankScreen.on(PhaserScreenEvent.HIDE_START, this.onPiggyBankScreenHideStart, this);
      this.piggyBankScreen.on(PiggyBankScreenEvent.BREAK, this.onPiggyBankBreak, this);
      this.piggyBankScreen.kill();
      this.add.existing(this.piggyBankScreen);
    }
    onPiggyBankScreenShow() {
      this.startLevelScreen.deactivate();
    }
    onPiggyBankScreenHideStart() {
      this.startLevelScreen.activate();
    }
    onPiggyBankBreak(screen2, coins) {
      var _a;
      (_a = this.pregameBoosterBuyScreen) == null ? void 0 : _a.coinsLabel.syncWithGameStore(true);
    }
    onPregameBoosterClick(booster) {
      this.startLevelScreen.deactivate();
      if (!this.pregameBoosterBuyScreen) {
        this.addPregameBoosterBuyScreen();
        this.pregameBoosterBuyScreen.resize();
      }
      let data = this.getPregameBoosterBuyScreenData(booster);
      this.pregameBoosterBuyScreen.once(PhaserScreenEvent.HIDE_COMPLETE, this.activateStartLevelScreen, this);
      this.pregameBoosterBuyScreen.updateData(data);
      this.pregameBoosterBuyScreen.show({showBackground: false});
    }
    addPregameBoosterBuyScreen() {
      this.pregameBoosterBuyScreen = new BoosterBuyScreen(this);
      this.pregameBoosterBuyScreen.setDepth(GameplayGuiDepth.VIDEO_REWARDS_SCREEN);
      this.pregameBoosterBuyScreen.kill();
      this.pregameBoosterBuyScreen.on(BoosterBuyScreenEvent.SHOW_SHOP, () => this.showShopScreen("Gameplay:PregameBoosterBuyScreen"));
      this.pregameBoosterBuyScreen.on(BoosterBuyScreenEvent.BOOSTER_BUY_COMPLETE, this.onPregameBoosterBuyComplete, this);
      this.pregameBoosterBuyScreen.on(PhaserScreenEvent.HIDE_START, this.dismissAllToasts, this);
      this.add.existing(this.pregameBoosterBuyScreen);
    }
    dismissAllToasts() {
      this.game.toasts.dismissAll();
    }
    onPregameBoosterBuyComplete(screenData, source) {
      var _a, _b;
      if (source === "coins") {
        (_a = this.shopScreen) == null ? void 0 : _a.coinsLabel.syncWithGameStore(true);
        (_b = this.livesScreen) == null ? void 0 : _b.coinsLabel.syncWithGameStore(true);
      }
      this.saveVideoReward(screenData.rewardType, screenData.rewardNum);
      this.pregameBoosterBuyScreen.hide();
    }
    saveVideoReward(rewardType, rewardNum) {
      var _a;
      if (VideoRewardUtils.isPregameBooster(rewardType)) {
        let boosterType = VideoRewardUtils.getPregameBoosterByReward(rewardType);
        if (boosterType) {
          this.game.pregameBoosters.getByType(boosterType).num += rewardNum;
          this.game.analytics.addResource(ResourceCurrency.PREGAME_BOOSTERS, rewardNum, boosterType, "StartLevelPopup");
          (_a = this.startLevelScreen) == null ? void 0 : _a.popup.pregameBoosters.getByType(boosterType).onRewardArrive(rewardNum);
        }
      }
    }
    getPregameBoosterBuyScreenData(booster) {
      let rewardType = VideoRewardUtils.getRewardByPregameBooster(booster.type);
      let rewardNum = VideoRewardUtils.getRewardNum(rewardType);
      let {title, description} = this.getRewardTitleAndDescription(rewardType);
      return {
        rewardType,
        rewardNum,
        title,
        description,
        boosterPriceInCoins: 1e3,
        coinsTotal: this.game.store.getNumber(GameStoreKey.COINS),
        disableVideoButton: false
      };
    }
    getRewardTitleAndDescription(rewardType) {
      let rewardTexts = this.texts.video_rewards[rewardType];
      let title = rewardTexts.title;
      let description = rewardTexts.description;
      return {title, description};
    }
    onStartLevelClose() {
      this.game.gdSdk.showInterstitialAd("Gameplay:StartLevelScreen:Close").finally(() => {
        this.events.emit(GameplayGuiEvent.GOTO_LEVEL_MAP);
      });
    }
    onPlayButtonClick() {
      let noLives = this.game.lives.getLivesNum() <= 0;
      if (noLives) {
        this.startLevelScreen.deactivate();
        this.showLivesScreen();
        return;
      }
      this.startLevelScreen.popup.playButton.disableInput();
      this.game.gdSdk.showInterstitialAd("Gameplay:StartLevelScreen:Play").finally(() => {
        let pregameBoosters = this.startLevelScreen.popup.pregameBoosters.getSelectedBoosters();
        this.events.emit(GameplayGuiEvent.RESTART_LEVEL_FROM_POPUP, pregameBoosters);
      });
    }
    showLivesScreen() {
      this.livesScreen = new LivesScreen(this);
      this.livesScreen.resize();
      this.livesScreen.setDepth(GameplayGuiDepth.LIVES_SCREEN);
      this.add.existing(this.livesScreen);
      this.livesScreen.once(PhaserScreenEvent.HIDE_START, this.dismissAllToasts, this);
      this.livesScreen.once(PhaserScreenEvent.HIDE_COMPLETE, this.activateStartLevelScreen, this);
      this.livesScreen.show({backgroundAlpha: 1e-3, autoCloseAfterAd: true});
    }
    activateStartLevelScreen() {
      this.startLevelScreen.activate();
    }
    restartFromLevelMap() {
      this.audio.fadeInMusicLoop(1e3);
      this.events.emit(GameplayGuiEvent.LEVEL_MAP_ON_FAIL);
    }
    addPreCompleteScreen() {
      this.preCompleteScreen = new LevelPreCompleteScreen(this);
      this.preCompleteScreen.setDepth(GameplayGuiDepth.LEVEL_PRE_COMPLETE_SCREEN);
      this.preCompleteScreen.kill();
      this.preCompleteScreen.resize();
      this.add.existing(this.preCompleteScreen);
    }
    addCompleteScreen() {
      this.completeScreen = new LevelCompleteScreen(this);
      this.completeScreen.once(LevelCompleteScreenEvent.GOTO_NEXT_LEVEL, this.gotoNextLevel, this);
      this.completeScreen.setDepth(GameplayGuiDepth.LEVEL_COMPLETE_SCREEN);
      this.completeScreen.kill();
      this.completeScreen.resize();
      this.add.existing(this.completeScreen);
    }
    gotoNextLevel() {
      if (this.levelConfig.levelNumber < 3) {
        this.events.emit(GameplayGuiEvent.GOTO_NEXT_LEVEL);
      } else {
        this.events.emit(GameplayGuiEvent.LEVEL_MAP_ON_COMPLETE);
      }
    }
    addPauseScreen() {
      this.pauseScreen = new PauseScreen(this);
      this.pauseScreen.setDepth(GameplayGuiDepth.PAUSE_SCREEN);
      this.pauseScreen.hintsButton.text.setText(this.getHintDelayTitle(this.gameplay.hint.getInitialDelay()));
      this.pauseScreen.hintsButton.on(SwitchButtonEvent.ARROW_PRESS, this.onHintsButtonClick, this);
      this.pauseScreen.quitButton.on(ButtonEvent.PRESS, this.onQuitButtonClick, this);
      this.pauseScreen.kill();
      this.add.existing(this.pauseScreen);
    }
    onHintsButtonClick(hintsButton, direction) {
      let currentValue = this.game.store.getValue(GameStoreKey.HINT_DELAY);
      let options = HINT_DELAY_OPTIONS;
      let currentIndex = options.indexOf(currentValue);
      let newIndex = Phaser.Math.Wrap(currentIndex + direction, 0, options.length);
      let newValue = options[newIndex];
      this.game.store.saveValue(GameStoreKey.HINT_DELAY, newValue);
      this.gameplay.hint.setInitialDelay(newValue);
      hintsButton.updateText(this.getHintDelayTitle(newValue));
    }
    getHintDelayTitle(value) {
      let seconds = Phaser.Math.RoundTo(convertHintDelayToMs(value) / 1e3, -1);
      let texts = this.game.texts.texts.hint_delay;
      let template = texts.value;
      let title = template.replace("#", seconds.toString());
      switch (value) {
        case HintDelay.SHORT:
        case HintDelay.LONG:
          return title;
        case HintDelay.OFF:
          return texts.off;
        default:
          let x = value;
      }
    }
    onQuitButtonClick() {
      if (!this.quitScreen) {
        this.addQuitScreen();
      }
      this.quitScreen.show();
    }
    addQuitScreen() {
      this.quitScreen = new ConfirmScreen(this);
      this.quitScreen.on(PhaserScreenEvent.SHOW, this.onQuitScreenShow, this);
      this.quitScreen.on(PhaserScreenEvent.HIDE_START, this.onQuitScreenHideStart, this);
      this.quitScreen.popup.yesButton.once(ButtonEvent.PRESS, this.onConfirmQuitButtonClick, this);
      this.quitScreen.setDepth(GameplayGuiDepth.QUIT_SCREEN);
      this.quitScreen.kill();
      this.quitScreen.resize();
      this.add.existing(this.quitScreen);
    }
    onQuitScreenShow() {
      this.pauseScreen.ignoreBackgroundClicks = true;
      this.pauseScreen.deactivate();
    }
    onQuitScreenHideStart() {
      this.pauseScreen.ignoreBackgroundClicks = false;
      this.pauseScreen.activate();
    }
    onConfirmQuitButtonClick() {
      this.game.lives.removeLife();
      this.events.emit(GameplayGuiEvent.LEVEL_MAP_ON_FAIL);
    }
    addEmitters() {
      this.emitters = new GameplayGuiEmitters(this);
    }
    addUndoOverlay() {
      this.undoOverlay = this.add.image(0, 0, "gameplay_gui", "white_rect");
      this.undoOverlay.setDepth(GameplayGuiDepth.UNDO_OVERLAY);
      this.undoOverlay.kill();
      this.size(this.undoOverlay, ScaleType.FILL);
      this.pin(this.undoOverlay, 0.5, 0.5);
    }
    addGuides() {
      if (Main.development === false) {
        return;
      }
      this.guides = this.add.graphics({
        lineStyle: {
          color: 16711680,
          alpha: 1,
          width: 1
        }
      });
      this.guides.setDepth(GameplayGuiDepth.DEBUG_GUIDES);
      this.guides.kill();
    }
    customResize() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
      super.resize();
      this.alignBoostersPanel();
      this.drawGuides();
      this.pauseButton.originalScale = this.pauseButton.scale;
      this.undoButton.originalScale = this.undoButton.scale;
      this.pauseScreen.resize();
      (_a = this.quitScreen) == null ? void 0 : _a.resize();
      (_b = this.goalsScreen) == null ? void 0 : _b.resize();
      (_c = this.secondChanceScreen) == null ? void 0 : _c.resize();
      (_d = this.failedScreen) == null ? void 0 : _d.resize();
      (_e = this.preCompleteScreen) == null ? void 0 : _e.resize();
      (_f = this.completeScreen) == null ? void 0 : _f.resize();
      (_g = this.startLevelScreen) == null ? void 0 : _g.resize();
      (_h = this.pregameBoosterBuyScreen) == null ? void 0 : _h.resize();
      this.boosterBuyScreen.resize();
      (_i = this.livesScreen) == null ? void 0 : _i.resize();
      (_j = this.shopScreen) == null ? void 0 : _j.resize();
      (_k = this.piggyBankScreen) == null ? void 0 : _k.resize();
    }
    alignBoostersPanel() {
      this.boostersPanel.x = (Config.GAME_WIDTH - this.boostersPanel.displayWidth) / 2;
      this.boostersPanel.y = Config.GAME_HEIGHT - this.boostersPanel.displayHeight - 20 * Config.ASSETS_SCALE;
    }
    drawGuides() {
      if (!this.guides) {
        return;
      }
      this.guides.clear();
      this.guides.beginPath();
      this.drawVerticalGuide(this.topPanel.x - this.topPanel.displayWidth / 2);
      this.drawVerticalGuide(this.topPanel.x);
      this.drawVerticalGuide(this.topPanel.x + this.topPanel.displayWidth / 2);
      this.drawVerticalGuide(Config.GAME_WIDTH * 0.235);
      this.drawVerticalGuide(Config.GAME_WIDTH - Config.GAME_WIDTH * 0.235);
      this.drawHorizontalGuide(80 * Config.ASSETS_SCALE);
      this.drawHorizontalGuide(Config.GAME_HEIGHT * 0.25);
      this.drawHorizontalGuide(Config.HALF_GAME_HEIGHT);
      this.drawHorizontalGuide(Config.GAME_HEIGHT * 0.75);
      this.guides.closePath();
      this.guides.strokePath();
    }
    drawVerticalGuide(x) {
      this.guides.moveTo(x, 0);
      this.guides.lineTo(x, Config.GAME_HEIGHT);
    }
    drawHorizontalGuide(y) {
      this.guides.moveTo(0, y);
      this.guides.lineTo(Config.GAME_WIDTH, y);
    }
    postGameplayResize() {
      var _a;
      this.boosterHintScreen.resize();
      (_a = this.tutorial) == null ? void 0 : _a.resize();
    }
    addKeyboardCallbacks() {
      if (Main.development) {
        this.onKeyDown("G", this.toggleGuides, this);
        this.onceKeyDown("SPACE", this.skipTutorial, this);
      }
    }
    toggleGuides() {
      if (this.guides.visible) {
        this.guides.kill();
      } else {
        this.guides.revive();
      }
    }
    skipTutorial() {
      var _a;
      (_a = this.tutorial) == null ? void 0 : _a.skip();
      if (this.gameplay.boosters.isTutorialMode) {
        this.gameplay.boosters.cancelTutorialMode();
        this.boostersPanel.enableInput();
        this.undoButton.enableInput();
      }
    }
    showTapOnCookieWarning(worldX, worldY) {
      this.boosterWarning.x = worldX;
      this.boosterWarning.y = worldY;
      this.boosterWarning.show();
    }
    onLevelPreComplete() {
      this.hideBottomGui();
      this.showPrecompleteScreen();
    }
    hideBottomGui() {
      let items = [this.pauseButton, this.boostersPanel, this.undoButton];
      this.tweens.add({
        targets: items,
        duration: 250,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        y: "+=15",
        onComplete: () => {
          items.forEach((item) => item.kill());
        }
      });
    }
    showPrecompleteScreen() {
      let {moveCoins, powerupCoins} = this.getLevelCoins();
      let data = {
        moveCoins,
        powerupCoins
      };
      this.addPreCompleteScreen();
      this.preCompleteScreen.once(PhaserScreenEvent.HIDE_START, this.onPreCompleteAnimationComplete, this);
      this.preCompleteScreen.updateData(data);
      this.preCompleteScreen.show();
    }
    onPreCompleteAnimationComplete() {
      this.gameplay.onLevelComplete();
    }
    hideGuiOnLevelEnd() {
      this.topPanel.kill();
      this.boostersPanel.kill();
      this.undoButton.kill();
      this.pauseButton.kill();
    }
    showCompleteScreen() {
      let levelResult = this.game.store.getLevelResult(this.levelConfig.levelNumber);
      let {baseCoins, moveCoins, powerupCoins} = this.getLevelCoins();
      let data = {
        levelNumber: this.levelConfig.levelNumber,
        isCompleteFirstTime: levelResult.timesCompleteNum === 1,
        baseCoins,
        bonusCoins: moveCoins + powerupCoins
      };
      this.addCompleteScreen();
      this.completeScreen.updateData(data);
      this.completeScreen.show();
    }
    getLevelCoins() {
      let rewardedAds = window.game.config.ads.rewarded;
      let baseCoins = this.levelConfig.hard ? 150 : 100;
      let moveCoins = this.gameplay.moves;
      let powerupCoins = this.gameplay.items.getCookiesWithPowerups().length;
      let piggyBank = this.game.piggyBank;
      if (piggyBank === void 0) {
        if (rewardedAds) {
          return {
            baseCoins,
            moveCoins: moveCoins * 5,
            powerupCoins: powerupCoins * 5
          };
        } else {
          return {
            baseCoins: baseCoins * 2,
            moveCoins: moveCoins * 10,
            powerupCoins: powerupCoins * 10
          };
        }
      }
      let breakMethod = piggyBank.getBreakMethod();
      if (breakMethod === "purchase") {
        return {
          baseCoins: baseCoins * 5,
          moveCoins: moveCoins * 10,
          powerupCoins: powerupCoins * 10
        };
      } else {
        return {
          baseCoins: baseCoins * 3,
          moveCoins: moveCoins * 10,
          powerupCoins: powerupCoins * 10
        };
      }
    }
    addTutorial(tutorialConfig) {
      this.tutorial = new TutorialManager(this, tutorialConfig);
      this.tutorial.once(TutorialManagerEvent.COMPLETE, this.onTutorialComplete, this);
      return this.tutorial;
    }
    onTutorialComplete() {
      this.tutorial.destroy();
      this.tutorial = null;
    }
    showUndoOverlay() {
      this.tweens.killTweensOf(this.undoOverlay);
      this.undoOverlay.revive();
      this.undoOverlay.alpha = 0;
      this.tweens.add({
        targets: this.undoOverlay,
        duration: 33,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1,
        onComplete: () => {
          this.tweens.add({
            targets: this.undoOverlay,
            duration: 600,
            ease: Phaser.Math.Easing.Quadratic.In,
            alpha: 0,
            onComplete: () => {
              this.undoOverlay.kill();
            }
          });
        }
      });
    }
    onShutdown() {
      if (this.tutorial) {
        this.tutorial.destroy();
        this.tutorial = null;
      }
      super.onShutdown();
    }
  };

  // src/scenes/gameplay/field/CellPointer.ts
  var CellPointer = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.name = "cell_pointer";
      this.addPointer();
      this.animatePointer();
    }
    addPointer() {
      this.pointer = this.scene.add.image(0, 0, "gameplay", "bottom_cell_pointer_2");
      this.add(this.pointer);
    }
    animatePointer() {
      let duration = 800;
      let deltaY = 8;
      this.pointer.y = -deltaY;
      this.pointer.scale = 0.5;
      this.scene.tweens.add({
        targets: this.pointer,
        duration,
        ease: Phaser.Math.Easing.Sine.InOut,
        y: deltaY,
        scale: 1,
        repeat: -1,
        hold: 500
      });
      this.pointer.alpha = 0;
      this.scene.tweens.add({
        targets: this.pointer,
        duration: duration / 2,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1,
        yoyo: true,
        repeat: -1,
        hold: 500
      });
    }
    hideAndDestroy() {
      this.scene.tweens.killTweensOf(this.pointer);
      this.scene.tweens.add({
        targets: this.pointer,
        duration: 300,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 0,
        onComplete: () => {
          this.destroy();
        }
      });
    }
  };

  // src/scenes/gameplay/field/BorderFramesCreator.ts
  var BorderFrame;
  (function(BorderFrame2) {
    BorderFrame2["TOP"] = "TOP";
    BorderFrame2["RIGHT"] = "RIGHT";
    BorderFrame2["BOTTOM"] = "BOTTOM";
    BorderFrame2["LEFT"] = "LEFT";
    BorderFrame2["TOP_LEFT_OUTER"] = "TOP_LEFT_OUTER";
    BorderFrame2["TOP_RIGHT_OUTER"] = "TOP_RIGHT_OUTER";
    BorderFrame2["BOTTOM_RIGHT_OUTER"] = "BOTTOM_RIGHT_OUTER";
    BorderFrame2["BOTTOM_LEFT_OUTER"] = "BOTTOM_LEFT_OUTER";
    BorderFrame2["TOP_LEFT_INNER"] = "TOP_LEFT_INNER";
    BorderFrame2["TOP_RIGHT_INNER"] = "TOP_RIGHT_INNER";
    BorderFrame2["BOTTOM_RIGHT_INNER"] = "BOTTOM_RIGHT_INNER";
    BorderFrame2["BOTTOM_LEFT_INNER"] = "BOTTOM_LEFT_INNER";
    BorderFrame2["TOP_LONG"] = "TOP_LONG";
    BorderFrame2["RIGHT_LONG"] = "RIGHT_LONG";
    BorderFrame2["BOTTOM_LONG"] = "BOTTOM_LONG";
    BorderFrame2["LEFT_LONG"] = "LEFT_LONG";
  })(BorderFrame || (BorderFrame = {}));
  var _BorderFramesCreator = class {
    constructor(scene, borderImage) {
      this.scene = scene;
      this.borderImage = borderImage;
      this.textures = [];
    }
    createFrames() {
      let borderImage = this.borderImage;
      this.createLines(borderImage);
      this.createConnectors(borderImage);
      this.createOuterCorners(borderImage);
      this.createInnerCorners(borderImage);
      this.textures.forEach((texture) => {
        let frame = texture.frame;
        frame.setUVs(frame.width, frame.height, frame.u0, frame.v1, frame.u1, frame.v0);
      });
      _BorderFramesCreator.FRAMES_READY = true;
    }
    createBorderTexture(options) {
      var _a;
      let source = this.borderImage;
      let crop = options.crop;
      let drawOffset = (_a = options.drawOffset) != null ? _a : {x: 0, y: 0};
      let renderTexture = this.scene.make.renderTexture({width: source.width, height: source.height}, false);
      source.setCrop(crop.x, crop.y, crop.width, crop.height);
      renderTexture.draw(source, source.width / 2 + drawOffset.x, source.height / 2 + drawOffset.y);
      renderTexture.saveTexture(options.key);
      source.setCrop();
      this.textures.push(renderTexture);
      return renderTexture;
    }
    createLines(borderImage) {
      let width = borderImage.width * 0.38;
      let x = (borderImage.width - width) / 2;
      this.createBorderTexture({
        key: BorderFrame.TOP,
        crop: {
          x,
          y: 0,
          width,
          height: borderImage.height * 0.5
        }
      });
      this.createBorderTexture({
        key: BorderFrame.BOTTOM,
        crop: {
          x,
          y: borderImage.height * 0.5,
          width,
          height: borderImage.height * 0.5
        }
      });
      let height = borderImage.height * 0.38;
      let y = (borderImage.height - height) / 2;
      this.createBorderTexture({
        key: BorderFrame.RIGHT,
        crop: {
          x: borderImage.width * 0.5,
          y,
          width: borderImage.height * 0.5,
          height
        }
      });
      this.createBorderTexture({
        key: BorderFrame.LEFT,
        crop: {
          x: 0,
          y,
          width: borderImage.width * 0.5,
          height
        }
      });
    }
    createConnectors(borderImage) {
      let width = borderImage.width * 0.47;
      let x = (borderImage.width - width) / 2;
      this.createBorderTexture({
        key: BorderFrame.TOP_LONG,
        crop: {
          x,
          y: 0,
          width,
          height: borderImage.height * 0.5
        }
      });
      this.createBorderTexture({
        key: BorderFrame.BOTTOM_LONG,
        crop: {
          x,
          y: borderImage.height / 2,
          width,
          height: borderImage.height * 0.5
        }
      });
      let height = borderImage.height * 0.47;
      let y = (borderImage.height - height) / 2;
      this.createBorderTexture({
        key: BorderFrame.RIGHT_LONG,
        crop: {
          x: borderImage.width / 2,
          y,
          width: borderImage.width / 2,
          height
        }
      });
      this.createBorderTexture({
        key: BorderFrame.LEFT_LONG,
        crop: {
          x: 0,
          y,
          width: borderImage.width / 2,
          height
        }
      });
    }
    createOuterCorners(borderImage) {
      let width = borderImage.width * 0.33;
      let height = borderImage.height * 0.33;
      this.createBorderTexture({
        key: BorderFrame.TOP_LEFT_OUTER,
        crop: {
          x: 0,
          y: 0,
          width,
          height
        }
      });
      this.createBorderTexture({
        key: BorderFrame.TOP_RIGHT_OUTER,
        crop: {
          x: borderImage.width - width,
          y: 0,
          width,
          height
        }
      });
      this.createBorderTexture({
        key: BorderFrame.BOTTOM_RIGHT_OUTER,
        crop: {
          x: borderImage.width - width,
          y: borderImage.height - height,
          width,
          height
        }
      });
      this.createBorderTexture({
        key: BorderFrame.BOTTOM_LEFT_OUTER,
        crop: {
          x: 0,
          y: borderImage.height - height,
          width,
          height
        }
      });
    }
    createInnerCorners(borderImage) {
      let offset = 4;
      let width = borderImage.width * 0.33;
      let height = borderImage.height * 0.33;
      this.createBorderTexture({
        key: BorderFrame.TOP_LEFT_INNER,
        drawOffset: {x: offset, y: offset},
        crop: {
          x: 0,
          y: 0,
          width,
          height
        }
      });
      this.createBorderTexture({
        key: BorderFrame.TOP_RIGHT_INNER,
        drawOffset: {x: -offset, y: offset},
        crop: {
          x: borderImage.width - width,
          y: 0,
          width,
          height
        }
      });
      this.createBorderTexture({
        key: BorderFrame.BOTTOM_RIGHT_INNER,
        drawOffset: {x: -offset, y: -offset},
        crop: {
          x: borderImage.width - width,
          y: borderImage.height - height,
          width,
          height
        }
      });
      this.createBorderTexture({
        key: BorderFrame.BOTTOM_LEFT_INNER,
        drawOffset: {x: offset, y: -offset},
        crop: {
          x: 0,
          y: borderImage.height - height,
          width,
          height
        }
      });
    }
    destroy() {
      this.scene = null;
      this.textures.forEach((texture) => texture.destroy());
      this.textures = null;
    }
  };
  var BorderFramesCreator = _BorderFramesCreator;
  BorderFramesCreator.FRAMES_READY = false;

  // src/scenes/gameplay/field/GameFieldTexture.ts
  var GameFieldTexture = class extends Phaser.GameObjects.RenderTexture {
    constructor(scene, field, width, height, offset, debugDraw = false) {
      super(scene, -offset, -offset, width, height);
      this.scene = scene;
      this.field = field;
      this.drawOffset = offset;
      this.borderImage = this.scene.make.image({key: "gameplay", frame: "border"}, false);
      this.createBorderFrames();
      if (debugDraw) {
        this.fill(16711680, 1);
      }
      this.beginDraw();
      this.drawCells();
      this.drawCorners();
      this.drawDarkTiles();
      this.drawBorder();
      this.endDraw();
    }
    createBorderFrames() {
      if (BorderFramesCreator.FRAMES_READY) {
        return;
      }
      let factory = new BorderFramesCreator(this.scene, this.borderImage);
      factory.createFrames();
      factory.destroy();
    }
    drawCells() {
      let offsetX = CELL_SIZE / 2 - this.drawOffset;
      let offsetY = CELL_SIZE / 2 - this.drawOffset;
      this.field.cells.forEach((cell) => {
        let neighbors = this.field.cells.getOrthoNeighborsAt(cell.column, cell.row);
        let neighborsNum = Object.values(neighbors).filter(Boolean).length;
        let frame = "field_cell_center";
        if (neighborsNum === 0) {
          frame = "field_cell_alone";
        } else if (neighborsNum === 1) {
          if (neighbors.top) {
            frame = "field_cell_bottom";
          } else if (neighbors.right) {
            frame = "field_cell_left";
          } else if (neighbors.bottom) {
            frame = "field_cell_top";
          } else {
            frame = "field_cell_right";
          }
        } else if (neighborsNum === 2) {
          if (neighbors.right && neighbors.bottom) {
            frame = "field_cell_top_left";
          } else if (neighbors.left && neighbors.bottom) {
            frame = "field_cell_top_right";
          } else if (neighbors.top && neighbors.left) {
            frame = "field_cell_bottom_right";
          } else if (neighbors.top && neighbors.right) {
            frame = "field_cell_bottom_left";
          }
        }
        let x = cell.x - offsetX;
        let y = cell.y - offsetY;
        this.customBatchDrawFrame(x, y, "gameplay", frame);
      });
    }
    drawCorners() {
      let offsetX = CELL_SIZE / 2 - this.drawOffset;
      let offsetY = CELL_SIZE / 2 - this.drawOffset;
      this.field.cells.forEach((cell) => {
        let {column, row} = cell;
        let neighbors = this.field.cells.getNeighborsAt(column, row);
        if (neighbors.bottom && neighbors.right && !neighbors.bottomRight) {
          this.drawCornerAt("corner_top_left", column + 1, row + 1, -offsetX, -offsetY);
        }
        if (neighbors.bottom && neighbors.left && !neighbors.bottomLeft) {
          this.drawCornerAt("corner_top_right", column - 1, row + 1, offsetX - 8, -offsetY);
        }
        if (neighbors.top && neighbors.right && !neighbors.topRight) {
          this.drawCornerAt("corner_bottom_left", column + 1, row - 1, -offsetX, offsetY - 6);
        }
        if (neighbors.top && neighbors.left && !neighbors.topLeft) {
          this.drawCornerAt("corner_bottom_right", column - 1, row - 1, offsetX - 4, offsetY - 6);
        }
      });
    }
    drawCornerAt(frame, column, row, dx = 0, dy = 0) {
      let {x, y} = gridToPixels(column, row);
      this.customBatchDrawFrame(x + dx, y + dy, "gameplay", frame);
    }
    drawDarkTiles() {
      let frame = this.scene.textures.getFrame("gameplay", "field_cell_dark_2");
      let offsetX = frame.halfWidth - this.drawOffset;
      let offsetY = frame.halfHeight - this.drawOffset;
      let alpha = 1;
      this.field.cells.forEach((cell) => {
        let {column, row} = cell;
        if (row % 2 === 0 && column % 2 !== 0 || row % 2 !== 0 && column % 2 === 0) {
          let {x, y} = gridToPixels(column, row);
          this.customBatchDrawFrame(x - offsetX, y - offsetY, frame.texture.key, frame.name, alpha);
        }
      });
    }
    drawBorder() {
      let hideBorder = UrlParams.getBool("hideBorder");
      if (hideBorder) {
        return;
      }
      this.field.cells.forEach((cell) => {
        let {column, row} = cell;
        let neighbors = this.field.cells.getNeighborsAt(column, row);
        this.addLines(neighbors, column, row);
        this.addOuterCorners(neighbors, column, row);
        this.addInnerCorners(neighbors, column, row);
        this.addConnectors(neighbors, column, row);
      });
    }
    addLines(neighbors, column, row) {
      if (!neighbors.top) {
        this.drawBorderFrameAt(BorderFrame.TOP, column, row);
      }
      if (!neighbors.right) {
        this.drawBorderFrameAt(BorderFrame.RIGHT, column, row);
      }
      if (!neighbors.bottom) {
        this.drawBorderFrameAt(BorderFrame.BOTTOM, column, row);
      }
      if (!neighbors.left) {
        this.drawBorderFrameAt(BorderFrame.LEFT, column, row);
      }
    }
    addOuterCorners(neighbors, column, row) {
      if (!neighbors.top && !neighbors.left) {
        this.drawBorderFrameAt(BorderFrame.TOP_LEFT_OUTER, column, row);
      }
      if (!neighbors.top && !neighbors.right) {
        this.drawBorderFrameAt(BorderFrame.TOP_RIGHT_OUTER, column, row);
      }
      if (!neighbors.bottom && !neighbors.right) {
        this.drawBorderFrameAt(BorderFrame.BOTTOM_RIGHT_OUTER, column, row);
      }
      if (!neighbors.bottom && !neighbors.left) {
        this.drawBorderFrameAt(BorderFrame.BOTTOM_LEFT_OUTER, column, row);
      }
    }
    addInnerCorners(neighbors, column, row) {
      if (!neighbors.topLeft && neighbors.top && neighbors.left) {
        this.drawBorderFrameAt(BorderFrame.BOTTOM_RIGHT_INNER, column - 1, row - 1);
      }
      if (!neighbors.topRight && neighbors.top && neighbors.right) {
        this.drawBorderFrameAt(BorderFrame.BOTTOM_LEFT_INNER, column + 1, row - 1);
      }
      if (!neighbors.bottomRight && neighbors.bottom && neighbors.right) {
        this.drawBorderFrameAt(BorderFrame.TOP_LEFT_INNER, column + 1, row + 1);
      }
      if (!neighbors.bottomLeft && neighbors.bottom && neighbors.left) {
        this.drawBorderFrameAt(BorderFrame.TOP_RIGHT_INNER, column - 1, row + 1);
      }
    }
    addConnectors(neighbors, column, row) {
      if (!neighbors.top && !neighbors.topRight && neighbors.right) {
        this.drawBorderFrameAt(BorderFrame.TOP_LONG, column, row, -CELL_SIZE / 2);
      }
      if (!neighbors.bottom && !neighbors.bottomRight && neighbors.right) {
        this.drawBorderFrameAt(BorderFrame.BOTTOM_LONG, column, row, -CELL_SIZE / 2);
      }
      if (!neighbors.right && !neighbors.bottomRight && neighbors.bottom) {
        this.drawBorderFrameAt(BorderFrame.RIGHT_LONG, column, row, 0, -CELL_SIZE / 2);
      }
      if (!neighbors.left && !neighbors.bottomLeft && neighbors.bottom) {
        this.drawBorderFrameAt(BorderFrame.LEFT_LONG, column, row, 0, -CELL_SIZE / 2);
      }
    }
    drawBorderFrameAt(frame, column, row, dx = 0, dy = 0) {
      let offsetX = this.borderImage.width / 2 - this.drawOffset + dx;
      let offsetY = this.borderImage.height / 2 - this.drawOffset + dy;
      let {x, y} = gridToPixels(column, row);
      this.customBatchDrawFrame(x - offsetX, y - offsetY, frame, null);
    }
    customBatchDrawFrame(x, y, key, frame, alpha) {
      x = x - this.field.dimensions.left * CELL_SIZE;
      y = y - this.field.dimensions.top * CELL_SIZE;
      this.batchDrawFrame(key, frame, x, y, alpha);
    }
    preDestroy() {
      this.borderImage.destroy();
      super.preDestroy();
    }
  };

  // src/scenes/gameplay/items/common/GameItemSave.ts
  function createGameItemSave(item) {
    return {
      column: item.column,
      row: item.row,
      itemType: item.itemType
    };
  }

  // src/scenes/gameplay/items/generators/GeneratorUtilts.ts
  var GeneratorUtilts = class {
    static getContentFrame(type, mod, rnd = Phaser.Math.RND) {
      let isCookie2 = this.isCookie(type);
      if (isCookie2) {
        if (type === GeneratorContent.RANDOM_COOKIE) {
          return this.getRandomCookieFrame(mod);
        }
        return this.getCookieFrame(type, mod);
      }
      switch (type) {
        case GeneratorContent.DROP_ITEM:
          return "generator/content/cookie_2";
        case GeneratorContent.CHICK:
          return "generator/content/chick";
        case GeneratorContent.MARSHMALLOW:
          return "generator/content/marshmallow_common";
        default:
          console.warn("Unknown generator content type!", type, mod);
          return null;
      }
    }
    static isCookie(type) {
      return type.includes("_COOKIE");
    }
    static getRandomCookieFrame(mod) {
      switch (mod) {
        case GeneratorContentMod.RANDOM_STRIPES:
        case GeneratorContentMod.VERTICAL_STRIPES:
        case GeneratorContentMod.HORIZONTAL_STRIPES:
          return "generator/content/stripes";
        case GeneratorContentMod.BOMB:
          return "generator/content/bombs";
        case GeneratorContentMod.SUPER_SPHERE:
          return "generator/content/super_sphere";
        default:
          console.warn("RANDOM_COOKIE should be used with some mod!");
          return null;
      }
    }
    static getCookieFrame(type, mod) {
      let cookieType = this.convertContentToCookieType(type);
      let cookiePowerup = this.convertContentModToCookiePowerup(mod);
      let base = this.getBaseCookieFrame(cookieType);
      switch (cookiePowerup) {
        case CookiePowerup.VERTICAL_STRIPES:
          return base + "-Stripes-Vertical";
        case CookiePowerup.HORIZONTAL_STRIPES:
          return base + "-Stripes-Horizontal";
        case CookiePowerup.BOMB:
          return base + "-Bomb";
        case CookiePowerup.SUPER_SPHERE:
          return "generator/content/super_sphere";
        default:
          return base;
      }
    }
    static getBaseCookieFrame(cookieType) {
      switch (cookieType) {
        case ItemType.COOKIE_RED:
          return "generator/content/Circle-Cookie-Red";
        case ItemType.COOKIE_BLUE:
          return "generator/content/Cube-Cookie-Blue";
        case ItemType.COOKIE_ORANGE:
          return "generator/content/Polygon-Cookie-Orange";
        case ItemType.COOKIE_PURPLE:
          return "generator/content/Donut-Cookie-Purple";
        case ItemType.COOKIE_PINK:
          return "generator/content/Moon-Cookie-Pink";
        case ItemType.COOKIE_YELLOW:
          return "generator/content/Heart-Cookie-Yellow";
        default:
          console.warn("Unknow cookie type!", cookieType);
          return null;
      }
    }
    static convertContentToCookieType(type) {
      switch (type) {
        case GeneratorContent.ORANGE_COOKIE:
          return ItemType.COOKIE_ORANGE;
        case GeneratorContent.BLUE_COOKIE:
          return ItemType.COOKIE_BLUE;
        case GeneratorContent.YELLOW_COOKIE:
          return ItemType.COOKIE_YELLOW;
        case GeneratorContent.PINK_COOKIE:
          return ItemType.COOKIE_PINK;
        case GeneratorContent.RED_COOKIE:
          return ItemType.COOKIE_RED;
        case GeneratorContent.PURPLE_COOKIE:
          return ItemType.COOKIE_PURPLE;
        default:
          return null;
      }
    }
    static convertContentModToCookiePowerup(mod, rnd = Phaser.Math.RND) {
      switch (mod) {
        case GeneratorContentMod.RANDOM_STRIPES:
          return rnd.bool() ? CookiePowerup.VERTICAL_STRIPES : CookiePowerup.HORIZONTAL_STRIPES;
        case GeneratorContentMod.VERTICAL_STRIPES:
          return CookiePowerup.VERTICAL_STRIPES;
        case GeneratorContentMod.HORIZONTAL_STRIPES:
          return CookiePowerup.HORIZONTAL_STRIPES;
        case GeneratorContentMod.BOMB:
          return CookiePowerup.BOMB;
        case GeneratorContentMod.SUPER_SPHERE:
          return CookiePowerup.SUPER_SPHERE;
        default:
          return null;
      }
    }
  };

  // src/scenes/gameplay/items/generators/Generator.ts
  var GeneratorContent;
  (function(GeneratorContent2) {
    GeneratorContent2["DROP_ITEM"] = "DROP_ITEM";
    GeneratorContent2["MARSHMALLOW"] = "MARSHMALLOW";
    GeneratorContent2["CHICK"] = "CHICK";
    GeneratorContent2["RANDOM_COOKIE"] = "RANDOM_COOKIE";
    GeneratorContent2["PURPLE_COOKIE"] = "PURPLE_COOKIE";
    GeneratorContent2["ORANGE_COOKIE"] = "ORANGE_COOKIE";
    GeneratorContent2["BLUE_COOKIE"] = "BLUE_COOKIE";
    GeneratorContent2["RED_COOKIE"] = "RED_COOKIE";
    GeneratorContent2["PINK_COOKIE"] = "PINK_COOKIE";
    GeneratorContent2["YELLOW_COOKIE"] = "YELLOW_COOKIE";
  })(GeneratorContent || (GeneratorContent = {}));
  var GeneratorContentMod;
  (function(GeneratorContentMod2) {
    GeneratorContentMod2["RANDOM_STRIPES"] = "RANDOM_STRIPES";
    GeneratorContentMod2["HORIZONTAL_STRIPES"] = "HORIZONTAL_STRIPES";
    GeneratorContentMod2["VERTICAL_STRIPES"] = "VERTICAL_STRIPES";
    GeneratorContentMod2["BOMB"] = "BOMB";
    GeneratorContentMod2["SUPER_SPHERE"] = "SUPER_SPHERE";
    GeneratorContentMod2["NONE"] = "NONE";
  })(GeneratorContentMod || (GeneratorContentMod = {}));
  var Generator = class extends Phaser.GameObjects.Container {
    constructor(scene, column, row, options) {
      super(scene, 0, 0);
      this.isDroppable = false;
      this.isMatchable = false;
      this.isSwappable = false;
      var _a, _b;
      this.column = column;
      this.row = row;
      this.itemType = ItemType.GENERATOR;
      this.itemSuperType = ItemSuperType.GENERATOR;
      this.options = options;
      (_b = (_a = this.options).turnsLeft) != null ? _b : _a.turnsLeft = this.options.turnsTotal;
      this.addItem();
      this.addBubble();
      this.addPropeller();
      this.addTurnsLabelBack();
      this.addTurnsLabelText();
      if (options.invisible) {
        this.kill();
      }
      this.setSize(this.bubble.width, this.bubble.height);
      this.playDropAnimationThrottled = throttle_default(this.doPlayDropAnimation.bind(this), 300, {
        leading: true,
        trailing: false
      });
    }
    addItem() {
      let frame = GeneratorUtilts.getContentFrame(this.options.content, this.options.contentMod);
      this.item = this.scene.add.image(0, 0, "gameplay", frame);
      this.item.y = 6;
      this.item.originalY = this.item.y;
      this.add(this.item);
    }
    addBubble() {
      this.bubble = this.scene.add.image(0, 0, "gameplay", "generator/base");
      this.bubble.y = 3;
      this.add(this.bubble);
    }
    addPropeller() {
      this.propeller = this.scene.add.image(0, 0, "gameplay", "generator/propeller");
      this.propeller.y = this.bubble.bottom;
      this.add(this.propeller);
    }
    addTurnsLabelBack() {
      this.turnLabelBack = this.scene.add.image(0, 0, "gameplay", "generator/label_back");
      this.turnLabelBack.y = this.propeller.y;
      this.add(this.turnLabelBack);
    }
    addTurnsLabelText() {
      let content = this.options.turnsLeft.toString();
      this.turnLabel = this.scene.add.bitmapText(0, 0, BitmapFont.GENERATOR_TURNS, content, 20);
      this.turnLabel.setOrigin(0.5, 0.5);
      this.turnLabel.x = this.turnLabelBack.x;
      this.turnLabel.y = this.turnLabelBack.y + 4;
      this.add(this.turnLabel);
    }
    alignToGrid() {
      alignToGrid(this);
      this.y -= 8;
    }
    createSave() {
      return __spreadProps(__spreadValues({}, createGameItemSave(this)), {
        itemSuperType: ItemSuperType.GENERATOR,
        options: __spreadValues({}, this.options)
      });
    }
    playDropAnimation() {
      if (this.options.invisible) {
        return;
      }
      this.playDropAnimationThrottled();
      this.scene.sounds.generator();
    }
    doPlayDropAnimation() {
      this.playPropellerTween();
      this.playItemTween();
    }
    playPropellerTween() {
      this.propeller.angle = 0;
      this.scene.tweens.killTweensOf(this.propeller);
      this.scene.tweens.add({
        targets: this.propeller,
        duration: 1e3,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.33],
        angle: 360 * 3
      });
    }
    playItemTween() {
      this.scene.tweens.killTweensOf(this.item);
      this.item.alpha = 0;
      this.scene.tweens.add({
        targets: this.item,
        duration: 200,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 1
      });
      this.item.scale = 0.75;
      this.scene.tweens.add({
        targets: this.item,
        duration: 450,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.5],
        scale: 1
      });
    }
    updateTurnsLabel() {
      this.turnLabel.text = this.options.turnsLeft.toString();
    }
    destroy() {
      super.destroy();
    }
    toString() {
      return GameItemUtils.toString(this) + ` [${this.options.content}, ${this.options.turnsLeft}/${this.options.turnsTotal}]`;
    }
  };

  // src/scenes/gameplay/field/GameField.ts
  var GameField = class extends Phaser.GameObjects.Container {
    constructor(scene, config2) {
      super(scene);
      this.name = "field";
      this.columns = config2.grid.columns;
      this.rows = config2.grid.rows;
      this.addCells(config2);
      this.addTexture();
      this.addShadow();
      this.addBottomCellPointers(config2);
      this.setSize(this.cells.columns * CELL_SIZE, this.cells.rows * CELL_SIZE);
    }
    addCells(config2) {
      let cells = config2.field.map((cellConfig) => {
        let {column, row} = cellConfig;
        let {x, y} = gridToPixels(column, row);
        return {column, row, x, y};
      });
      this.cells = new GridArray(config2.grid.rows, config2.grid.columns);
      this.cells.addMultiple(...cells);
      this.columnsOfCells = groupBy_default(this.cells.toArray(), "column");
      this.topCells = Object.values(this.columnsOfCells).map((column) => column[0]);
      this.bottomCells = Object.values(this.columnsOfCells).map((column) => last_default(column));
      this.dimensions = calculateDimensions(this.cells.toArray());
    }
    addTexture() {
      let offset = 6;
      let width = this.dimensions.width * CELL_SIZE + 16;
      let height = this.dimensions.height * CELL_SIZE + 16;
      this.texture = new GameFieldTexture(this.scene, this, width, height, offset);
      this.texture.x = this.dimensions.left * CELL_SIZE - offset;
      this.texture.y = this.dimensions.top * CELL_SIZE - offset;
      this.add(this.texture);
    }
    addShadow() {
      if (this.scene.game.rendererType === RendererType.CANVAS) {
        this.shadow = this.scene.add.renderTexture(0, 0, this.texture.width, this.texture.height);
        this.shadow.draw(this.texture, 0, 0);
        this.paintCanvasTextureBlack(this.shadow.texture);
      } else {
        this.shadow = this.scene.add.image(0, 0, this.texture.texture);
        this.shadow.setOrigin(0);
        this.shadow.tint = 0;
      }
      this.shadow.x = this.texture.x;
      this.shadow.y = this.texture.y + 10;
      this.shadow.alpha = 0.15;
      this.addAt(this.shadow, 0);
    }
    paintCanvasTextureBlack(texture) {
      let data = texture.getData(0, 0, texture.width, texture.height);
      let dataArr = data.data;
      for (let i = 0; i < dataArr.length; i += 4) {
        if (dataArr[i + 3] > 0) {
          dataArr[i] = 0;
          dataArr[i + 1] = 0;
          dataArr[i + 2] = 0;
        }
      }
      texture.putData(data, 0, 0);
    }
    addBottomCellPointers(config2) {
      let hasDropItems = config2.items.some((item) => item.itemType === ItemType.DROP_ITEM);
      let hasDropItemsInGenerators = config2.items.some((item) => {
        if (item.itemType === ItemType.GENERATOR) {
          return item.params.content === GeneratorContent.DROP_ITEM;
        }
      });
      if (hasDropItems || hasDropItemsInGenerators) {
        this.doAddBottomCellPointers();
      }
    }
    doAddBottomCellPointers() {
      this.bottomCellPointers = this.bottomCells.map((cell) => {
        let position = gridToPixels(cell.column, cell.row);
        let pointer = new CellPointer(this.scene);
        pointer.x = position.x;
        pointer.y = position.y + CELL_SIZE / 2 + 4;
        this.add(pointer);
        return pointer;
      });
    }
    isEmpty(column, row) {
      return this.cells.checkAt(column, row) === false;
    }
    getCellAt(column, row) {
      return this.cells.getAt(column, row);
    }
    getTopCells() {
      return this.topCells;
    }
    getBottomCell(column) {
      let columnOfCells = this.columnsOfCells[column];
      if (columnOfCells) {
        return columnOfCells[columnOfCells.length - 1];
      }
      return null;
    }
    getNonEmptyCellsNum() {
      return this.cells.toArray().length;
    }
    hideBottomCellPointers() {
      var _a;
      (_a = this.bottomCellPointers) == null ? void 0 : _a.forEach((pointer) => pointer.hideAndDestroy());
      this.bottomCellPointers.length = 0;
    }
  };

  // src/scenes/gameplay/GameplayDepth.ts
  var GameplayDepth;
  (function(GameplayDepth2) {
    GameplayDepth2[GameplayDepth2["FIELD"] = 0] = "FIELD";
    GameplayDepth2[GameplayDepth2["BISCUITS"] = 1] = "BISCUITS";
    GameplayDepth2[GameplayDepth2["GUMMIES"] = 2] = "GUMMIES";
    GameplayDepth2[GameplayDepth2["HIGHLIGHTS"] = 3] = "HIGHLIGHTS";
    GameplayDepth2[GameplayDepth2["BELOW_ITEMS_FX"] = 4] = "BELOW_ITEMS_FX";
    GameplayDepth2[GameplayDepth2["COOKIES"] = 5] = "COOKIES";
    GameplayDepth2[GameplayDepth2["COOKIE_PARTICLES"] = 6] = "COOKIE_PARTICLES";
    GameplayDepth2[GameplayDepth2["NEW_COOKIE"] = 7] = "NEW_COOKIE";
    GameplayDepth2[GameplayDepth2["MERGING_COOKIE"] = 8] = "MERGING_COOKIE";
    GameplayDepth2[GameplayDepth2["POWERUPED_COOKIE"] = 9] = "POWERUPED_COOKIE";
    GameplayDepth2[GameplayDepth2["TOP_ITEMS"] = 10] = "TOP_ITEMS";
    GameplayDepth2[GameplayDepth2["GENERATOR"] = 11] = "GENERATOR";
    GameplayDepth2[GameplayDepth2["POWERUP_FX"] = 12] = "POWERUP_FX";
    GameplayDepth2[GameplayDepth2["BOOSTER_FX"] = 13] = "BOOSTER_FX";
    GameplayDepth2[GameplayDepth2["DEBUG"] = 14] = "DEBUG";
  })(GameplayDepth || (GameplayDepth = {}));

  // src/scenes/gameplay/items/Marshmallow.ts
  var MARSHMALLOW_COOKIES_MAP = {
    [ItemType.MARSHMALLOW_COMMON]: ItemTypeUtil.getSubtypes(ItemSuperType.COOKIE),
    [ItemType.MARSHMALLOW_DOUBLE]: ItemTypeUtil.getSubtypes(ItemSuperType.COOKIE),
    [ItemType.MARSHMALLOW_BLUE]: [ItemType.COOKIE_BLUE],
    [ItemType.MARSHMALLOW_RED]: [ItemType.COOKIE_RED],
    [ItemType.MARSHMALLOW_ORANGE]: [ItemType.COOKIE_ORANGE],
    [ItemType.MARSHMALLOW_PURPLE]: [ItemType.COOKIE_PURPLE],
    [ItemType.MARSHMALLOW_YELLOW]: [ItemType.COOKIE_YELLOW],
    [ItemType.MARSHMALLOW_YELLOW]: [ItemType.COOKIE_YELLOW],
    [ItemType.MARSHMALLOW_PINK]: [ItemType.COOKIE_PINK]
  };
  var MarshmallowEvent;
  (function(MarshmallowEvent2) {
    MarshmallowEvent2["DAMAGE"] = "__DAMAGE";
  })(MarshmallowEvent || (MarshmallowEvent = {}));
  var Marshmallow = class extends Phaser.GameObjects.Image {
    constructor(scene, column, row, itemType) {
      super(scene, 0, 0, "gameplay", ItemTypeUtil.getFrameByItemType(itemType));
      this.isSwappable = true;
      this.isMatchable = false;
      this.isDroppable = true;
      this.matchIds = [];
      this.powerupIds = [];
      this.column = column;
      this.row = row;
      this.itemType = itemType;
      this.itemSuperType = ItemSuperType.MARSHMALLOW;
      this.maxHealth = this.itemType === ItemType.MARSHMALLOW_DOUBLE ? 2 : 1;
      this.currentHealth = this.maxHealth;
    }
    alignToGrid() {
      alignToGrid(this, this.column, this.row);
      this.y -= 4;
    }
    createSave() {
      return __spreadProps(__spreadValues({}, createGameItemSave(this)), {
        health: this.currentHealth,
        itemSuperType: ItemSuperType.MARSHMALLOW
      });
    }
    setHealth(value) {
      this.currentHealth = Phaser.Math.Clamp(value, 0, this.maxHealth);
      this.updateFrameByHealth(this.currentHealth);
    }
    updateFrameByHealth(health) {
      let frame;
      if (health === 2) {
        frame = ItemTypeUtil.getFrameByItemType(ItemType.MARSHMALLOW_DOUBLE);
      } else {
        if (this.itemType === ItemType.MARSHMALLOW_DOUBLE) {
          frame = ItemTypeUtil.getFrameByItemType(ItemType.MARSHMALLOW_COMMON);
        } else {
          frame = ItemTypeUtil.getFrameByItemType(this.itemType);
        }
      }
      this.setFrame(frame);
    }
    damage() {
      this.currentHealth = Math.max(0, this.currentHealth - 1);
      this.updateFrameByHealth(this.currentHealth);
      this.emit(MarshmallowEvent.DAMAGE, this, this.currentHealth);
    }
    isDead() {
      return this.currentHealth === 0;
    }
    canBeDamagedBy(cookie) {
      if (cookie.powerup === CookiePowerup.SUPER_SPHERE) {
        return false;
      }
      return MARSHMALLOW_COOKIES_MAP[this.itemType].includes(cookie.itemType);
    }
    destroy() {
      super.destroy();
    }
    toString() {
      if (this.maxHealth > 1) {
        return GameItemUtils.toString(this) + ` health: ${this.currentHealth}/${this.maxHealth}`;
      } else {
        return GameItemUtils.toString(this);
      }
    }
  };

  // src/scenes/gameplay/items/Licorice.ts
  var Licorice = class extends Phaser.GameObjects.Image {
    constructor(scene, column, row, itemType) {
      super(scene, 0, 0, "gameplay", ItemTypeUtil.getFrameByItemType(itemType));
      this.isDroppable = false;
      this.isMatchable = false;
      this.isSwappable = false;
      this.column = column;
      this.row = row;
      this.itemType = itemType;
      this.itemSuperType = ItemSuperType.LICORICE;
    }
    alignToGrid() {
      alignToGrid(this);
    }
    createSave() {
      return __spreadProps(__spreadValues({}, createGameItemSave(this)), {
        itemSuperType: ItemSuperType.LICORICE
      });
    }
    destroy() {
      super.destroy();
    }
    toString() {
      return `${this.itemType} [${this.column}, ${this.row}]`;
    }
  };

  // src/scenes/gameplay/items/Biscuit.ts
  var Biscuit = class extends Phaser.GameObjects.Image {
    constructor(scene, column, row) {
      super(scene, 0, 0, "gameplay", ItemTypeUtil.getFrameByItemType(ItemType.BISCUIT));
      this.isMultiCell = false;
      this.itemWidth = 1;
      this.itemHeight = 1;
      this.isSwappable = false;
      this.isMatchable = false;
      this.isDroppable = false;
      this.column = column;
      this.row = row;
      this.itemType = ItemType.BISCUIT;
      this.itemSuperType = ItemSuperType.BISCUIT;
    }
    alignToGrid() {
      alignToGrid(this, this.column, this.row);
    }
    createSave() {
      return __spreadProps(__spreadValues({}, createGameItemSave(this)), {
        itemSuperType: ItemSuperType.BISCUIT
      });
    }
    destroy() {
      super.destroy();
    }
  };

  // src/scenes/gameplay/items/Chocolate.ts
  var CHOCOLATE_COOKIES_MAP = {
    [ItemType.CHOCOLATE_COMMON]: ItemTypeUtil.getSubtypes(ItemSuperType.COOKIE),
    [ItemType.CHOCOLATE_DOUBLE]: ItemTypeUtil.getSubtypes(ItemSuperType.COOKIE),
    [ItemType.CHOCOLATE_TRIPLE]: ItemTypeUtil.getSubtypes(ItemSuperType.COOKIE),
    [ItemType.CHOCOLATE_BLUE]: [ItemType.COOKIE_BLUE],
    [ItemType.CHOCOLATE_RED]: [ItemType.COOKIE_RED],
    [ItemType.CHOCOLATE_ORANGE]: [ItemType.COOKIE_ORANGE],
    [ItemType.CHOCOLATE_PURPLE]: [ItemType.COOKIE_PURPLE],
    [ItemType.CHOCOLATE_YELLOW]: [ItemType.COOKIE_YELLOW],
    [ItemType.CHOCOLATE_YELLOW]: [ItemType.COOKIE_YELLOW],
    [ItemType.CHOCOLATE_PINK]: [ItemType.COOKIE_PINK]
  };
  var ChocolateEvent;
  (function(ChocolateEvent2) {
    ChocolateEvent2["DAMAGE"] = "Chocolate_DAMAGE";
  })(ChocolateEvent || (ChocolateEvent = {}));
  var Chocolate = class extends Phaser.GameObjects.Image {
    constructor(scene, column, row, itemType) {
      super(scene, 0, 0, "gameplay", ItemTypeUtil.getFrameByItemType(itemType));
      this.isSwappable = false;
      this.isMatchable = false;
      this.isDroppable = false;
      this.matchIds = [];
      this.powerupIds = [];
      this.maxHealth = 1;
      this.currentHealth = 1;
      this.column = column;
      this.row = row;
      this.itemType = itemType;
      this.itemSuperType = ItemSuperType.CHOCOLATE;
      this.maxHealth = this.getMaxHealth(this.itemType);
      this.currentHealth = this.maxHealth;
    }
    getMaxHealth(itemType) {
      if (itemType === ItemType.CHOCOLATE_TRIPLE) {
        return 3;
      } else if (itemType === ItemType.CHOCOLATE_DOUBLE) {
        return 2;
      }
      return 1;
    }
    setHealth(value) {
      this.currentHealth = Phaser.Math.Clamp(value, 0, this.maxHealth);
      this.updateFrameByHealth(this.currentHealth);
    }
    updateFrameByHealth(health) {
      let frame;
      if (health === 3) {
        frame = ItemTypeUtil.getFrameByItemType(ItemType.CHOCOLATE_TRIPLE);
      } else if (health === 2) {
        frame = ItemTypeUtil.getFrameByItemType(ItemType.CHOCOLATE_DOUBLE);
      } else {
        if (this.itemType === ItemType.CHOCOLATE_TRIPLE || this.itemType === ItemType.CHOCOLATE_DOUBLE) {
          frame = ItemTypeUtil.getFrameByItemType(ItemType.CHOCOLATE_COMMON);
        } else {
          frame = ItemTypeUtil.getFrameByItemType(this.itemType);
        }
      }
      this.setFrame(frame);
    }
    damage() {
      this.currentHealth = Math.max(0, this.currentHealth - 1);
      this.updateFrameByHealth(this.currentHealth);
      this.emit(ChocolateEvent.DAMAGE, this, this.currentHealth);
      if (this.isDead() === false) {
        this.playDamageTween();
      }
    }
    playDamageTween() {
      var _a;
      this.scale = 1;
      (_a = this.damageTween) == null ? void 0 : _a.remove();
      this.damageTween = this.scene.tweens.add({
        targets: this,
        duration: 233,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.15,
        yoyo: true
      });
    }
    isDead() {
      return this.currentHealth === 0;
    }
    alignToGrid() {
      alignToGrid(this);
      this.y -= 4;
    }
    createSave() {
      return __spreadProps(__spreadValues({}, createGameItemSave(this)), {
        itemSuperType: ItemSuperType.CHOCOLATE,
        health: this.currentHealth
      });
    }
    canBeDamagedBy(cookie) {
      if (cookie.powerup === CookiePowerup.SUPER_SPHERE) {
        return false;
      }
      return CHOCOLATE_COOKIES_MAP[this.itemType].includes(cookie.itemType);
    }
    destroy() {
      super.destroy();
    }
    toString() {
      if (this.maxHealth > 1) {
        return GameItemUtils.toString(this) + ` health: ${this.currentHealth}/${this.maxHealth}`;
      } else {
        return GameItemUtils.toString(this);
      }
    }
  };

  // src/scenes/gameplay/items/CandyBottle.ts
  var CandyBottleEvent;
  (function(CandyBottleEvent2) {
    CandyBottleEvent2["EMIT_CANDY"] = "__EMIT_CANDY";
    CandyBottleEvent2["EMIT_PARTICLES"] = "__EMIT_PARTICLES";
  })(CandyBottleEvent || (CandyBottleEvent = {}));
  var CandyBottle = class extends Phaser.GameObjects.Image {
    constructor(scene, column, row, itemType = ItemType.CANDY_BOTTLE) {
      super(scene, 0, 0, "gameplay", ItemTypeUtil.getFrameByItemType(itemType));
      this.isMatchable = false;
      this.isDroppable = false;
      this.isSwappable = false;
      this.matchIds = [];
      this.powerupIds = [];
      this.setOrigin(0.5, 0.95);
      this.column = column;
      this.row = row;
      this.itemType = itemType;
      this.itemSuperType = ItemTypeUtil.getItemSuperType(this.itemType);
    }
    emitCandy(delay) {
      var _a, _b;
      this.y = this.originalY;
      (_a = this.yTween) == null ? void 0 : _a.remove();
      this.yTween = this.scene.tweens.add({
        delay: delay + 200,
        targets: this,
        duration: 233,
        ease: Phaser.Math.Easing.Sine.InOut,
        y: this.originalY - 25,
        yoyo: true
      });
      this.scaleX = 1;
      this.scaleY = 1;
      (_b = this.scaleTween) == null ? void 0 : _b.remove();
      this.scaleTween = this.scene.tweens.add({
        delay,
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Quadratic.Out,
        scaleX: 1.2,
        scaleY: 0.8,
        onStart: () => {
          this.emit(CandyBottleEvent.EMIT_PARTICLES, this);
        },
        onComplete: () => {
          this.emit(CandyBottleEvent.EMIT_CANDY, this);
          this.scaleTween = this.scene.tweens.add({
            targets: this,
            duration: 800,
            ease: Phaser.Math.Easing.Elastic.Out,
            easeParams: [0.1, 0.4],
            scaleX: 1,
            scaleY: 1
          });
        }
      });
    }
    alignToGrid() {
      alignToGrid(this);
      this.y += 36;
    }
    createSave() {
      return __spreadProps(__spreadValues({}, createGameItemSave(this)), {
        itemSuperType: ItemSuperType.CANDY_BOTTLE
      });
    }
    destroy() {
      super.destroy();
    }
    toString() {
      return GameItemUtils.toString(this);
    }
  };

  // src/scenes/gameplay/items/DropItem.ts
  var DropItem = class extends Phaser.GameObjects.Container {
    constructor(scene, column, row, itemType) {
      super(scene);
      this.itemType = ItemType.DROP_ITEM;
      this.itemSuperType = ItemSuperType.DROP_ITEM;
      this.isMatchable = false;
      this.isDroppable = true;
      this.isSwappable = true;
      this.dropPath = [];
      this.appearDelay = 0;
      this.column = column;
      this.row = row;
      this.itemType = itemType;
      this.addItem();
      this.playIdleTweens();
    }
    addItem() {
      let frame = ItemTypeUtil.getFrameByItemType(this.itemType);
      this.item = this.scene.add.image(0, 0, "gameplay", frame);
      this.add(this.item);
    }
    playIdleTweens() {
      this.item.y = Phaser.Math.RND.sign() * 2;
      this.scene.tweens.add({
        targets: this.item,
        duration: 1200,
        ease: Phaser.Math.Easing.Sine.InOut,
        y: -this.item.y,
        yoyo: true,
        repeat: -1
      });
      this.item.angle = Phaser.Math.RND.sign() * 5;
      this.scene.tweens.add({
        targets: this.item,
        duration: 900,
        ease: Phaser.Math.Easing.Sine.InOut,
        angle: -this.item.angle,
        yoyo: true,
        repeat: -1
      });
    }
    stopIdleTweens(delay, onComplete) {
      this.scene.tweens.killTweensOf(this.item);
      this.scene.tweens.add({
        delay,
        targets: this.item,
        duration: 66,
        ease: Phaser.Math.Easing.Linear,
        angle: 0,
        y: 0,
        onComplete
      });
    }
    alignToGrid() {
      alignToGrid(this);
    }
    createSave() {
      return __spreadProps(__spreadValues({}, createGameItemSave(this)), {
        itemSuperType: ItemSuperType.DROP_ITEM
      });
    }
    toString() {
      return GameItemUtils.toString(this);
    }
  };

  // src/scenes/gameplay/items/ApplePlatter.ts
  var ApplesPlatterEvent;
  (function(ApplesPlatterEvent2) {
    ApplesPlatterEvent2["APPLE_REMOVE"] = "ApplesPlatter_APPLE_REMOVE";
  })(ApplesPlatterEvent || (ApplesPlatterEvent = {}));
  var ApplePlatter = class extends Phaser.GameObjects.Container {
    constructor(scene, column, row, applesNum = 9) {
      super(scene, 0, 0);
      this.isMultiCell = true;
      this.itemWidth = 1;
      this.itemHeight = 1;
      this.isDroppable = false;
      this.isMatchable = false;
      this.isSwappable = false;
      this.column = column;
      this.row = row;
      this.itemType = ItemType.APPLES_PLATTER;
      this.itemSuperType = ItemSuperType.APPLE_PLATTER;
      this.matchIds = [];
      this.powerupIds = [];
      this.addPlatterBack();
      this.addApples(applesNum);
      this.alignApples();
      this.addPlatterFrontEdge();
      this.setMulticell();
      this.setSize(this.platterBack.width, this.platterBack.height);
    }
    addPlatterBack() {
      this.platterBack = this.scene.add.image(0, 0, "gameplay", ItemTypeUtil.getFrameByItemType(this.itemType));
      this.add(this.platterBack);
    }
    addApples(applesNum) {
      this.apples = times_default(applesNum, () => {
        return this.scene.make.image({
          key: "gameplay",
          frame: "apples_platter/apple"
        });
      });
      this.add(this.apples);
    }
    alignApples() {
      let positions = this.getPositions();
      this.apples.forEach((apple, index) => {
        let position = positions[index];
        apple.x = position.x;
        apple.y = position.y;
        this.bringToTop(apple);
      });
      this.apples = this.apples.reverse();
      this.apples.forEach((apple) => this.bringToTop(apple));
    }
    getPositions() {
      let columns = 3;
      let rows = 3;
      let cellWidth = 39;
      let cellHeight = 38;
      let totalWidth = cellWidth * columns;
      let totalHeight = cellHeight * rows;
      let startX = cellWidth / 2 - totalWidth / 2;
      let startY = cellHeight / 2 - totalHeight / 2 - 8;
      let positions = [];
      for (let row = 0; row < columns; row++) {
        for (let column = 0; column < rows; column++) {
          positions.push({
            x: startX + column * cellWidth,
            y: startY + row * cellHeight
          });
        }
      }
      return positions.reverse();
    }
    addPlatterFrontEdge() {
      this.platterFrontEdge = this.scene.add.image(0, 0, "gameplay", "apples_platter/Tray_01");
      this.platterFrontEdge.setOrigin(0.5, 1);
      this.platterFrontEdge.y = this.platterBack.bottom;
      this.add(this.platterFrontEdge);
    }
    setMulticell() {
      let size = MultiCellUtils.getSize(this.itemType);
      this.isMultiCell = true;
      this.itemWidth = size.width;
      this.itemHeight = size.height;
    }
    removeApple() {
      if (this.isEmpty()) {
        return;
      }
      let apple = this.apples.shift();
      if (apple) {
        this.emit(ApplesPlatterEvent.APPLE_REMOVE, this, apple);
        apple.destroy();
      }
    }
    isEmpty() {
      return this.apples.length === 0;
    }
    getApplesNum() {
      return this.apples.length;
    }
    alignToGrid() {
      alignMulticellItemToGrid(this);
      this.x += 3;
    }
    createSave() {
      return __spreadProps(__spreadValues({}, createGameItemSave(this)), {
        itemSuperType: ItemSuperType.APPLE_PLATTER,
        apples: this.apples.length
      });
    }
    toString() {
      return GameItemUtils.toString(this) + ` ${this.apples.length} apples`;
    }
  };

  // src/scenes/gameplay/items/ColorCake.ts
  var ColorCakeEvent;
  (function(ColorCakeEvent2) {
    ColorCakeEvent2["EXPLODE"] = "__EXPLODE";
  })(ColorCakeEvent || (ColorCakeEvent = {}));
  var ColorCakePieceType;
  (function(ColorCakePieceType4) {
    ColorCakePieceType4["RED"] = "Cake_color_01";
    ColorCakePieceType4["BLUE"] = "Cake_color_02";
    ColorCakePieceType4["PURPLE"] = "Cake_color_03";
    ColorCakePieceType4["YELLOW"] = "Cake_color_04";
    ColorCakePieceType4["PINK"] = "Cake_color_05";
    ColorCakePieceType4["ORANGE"] = "Cake_color_06";
  })(ColorCakePieceType || (ColorCakePieceType = {}));
  var COLOR_CAKE_COOKIES_MAP = {
    [ItemType.COOKIE_RED]: ColorCakePieceType.RED,
    [ItemType.COOKIE_BLUE]: ColorCakePieceType.BLUE,
    [ItemType.COOKIE_PURPLE]: ColorCakePieceType.PURPLE,
    [ItemType.COOKIE_YELLOW]: ColorCakePieceType.YELLOW,
    [ItemType.COOKIE_PINK]: ColorCakePieceType.PINK,
    [ItemType.COOKIE_ORANGE]: ColorCakePieceType.ORANGE
  };
  var ColorCake = class extends Phaser.GameObjects.Container {
    constructor(scene, column, row, content) {
      super(scene, 0, 0);
      this.isMultiCell = true;
      this.itemWidth = 1;
      this.itemHeight = 1;
      this.isDroppable = false;
      this.isMatchable = false;
      this.isSwappable = false;
      this.column = column;
      this.row = row;
      this.itemType = ItemType.COLOR_CAKE;
      this.itemSuperType = ItemSuperType.COLOR_CAKE;
      this.matchIds = [];
      this.powerupIds = [];
      this.addBase();
      this.addPieces(content);
      this.sortPiecesByDepth();
      this.addBombShadow();
      this.addBomb();
      this.addBombSparks();
      if (this.getActivePiecesNum() < 6) {
        this.bombSparks.on = true;
      }
      this.setMulticell();
      this.setSize(this.base.width, this.base.height);
    }
    static getDefaultContent() {
      return [
        ColorCakePieceType.PURPLE,
        ColorCakePieceType.YELLOW,
        ColorCakePieceType.PINK,
        ColorCakePieceType.ORANGE,
        ColorCakePieceType.RED,
        ColorCakePieceType.BLUE
      ];
    }
    addBase() {
      this.base = this.scene.add.image(0, 0, "gameplay", "color_cake/Cake_01");
      this.add(this.base);
    }
    addPieces(content) {
      this.pieces = content.map((pieceType, index) => {
        if (!pieceType) {
          return null;
        }
        let frame = this.getPieceFrame(pieceType, index);
        let piece = this.scene.make.image({key: "gameplay", frame});
        piece.pieceType = pieceType;
        return piece;
      });
      this.add(this.pieces.filter(Boolean));
    }
    getPieceFrame(type, position) {
      return `color_cake/${type}_0${position + 1}`;
    }
    sortPiecesByDepth() {
      this.bringPieceToTop(0);
      this.bringPieceToTop(5);
    }
    bringPieceToTop(index) {
      let piece = this.pieces[index];
      if (piece) {
        this.bringToTop(piece);
      }
    }
    addBombShadow() {
      this.bombShadow = this.scene.add.image(0, 0, "gameplay", "color_cake/Cake_02");
      this.bombShadow.alpha = 0.66;
      this.add(this.bombShadow);
    }
    addBomb() {
      this.bomb = this.scene.add.image(0, 0, "gameplay", "color_cake/Cake_03");
      this.add(this.bomb);
    }
    addBombSparks() {
      this.particles = this.scene.add.particles("gameplay");
      this.updateBombSparksPosition();
      this.add(this.particles);
      this.bombSparks = this.particles.createEmitter({
        frame: "bomb_spark_2",
        lifespan: 466,
        scale: {start: 1.85, end: 0, ease: Ease.Linear},
        alpha: {start: 1, end: 0, ease: Ease.ExpoIn},
        quantity: 1,
        frequency: 66,
        speed: 50,
        gravityY: -200,
        on: false
      });
    }
    setMulticell() {
      let size = MultiCellUtils.getSize(this.itemType);
      this.isMultiCell = true;
      this.itemWidth = size.width;
      this.itemHeight = size.height;
    }
    removePiece(pieceType) {
      if (this.isEmpty()) {
        return;
      }
      let pieceIndex = this.pieces.findIndex((piece) => piece && piece.pieceType === pieceType);
      if (pieceIndex < 0) {
        return false;
      }
      this.doRemovePiece(pieceIndex);
      this.animateBomb();
      if (this.getActivePiecesNum() === 5) {
        this.bombSparks.on = true;
        this.scene.sounds.bombIgnite();
      }
      return true;
    }
    doRemovePiece(pieceIndex) {
      let piece = this.pieces[pieceIndex];
      delete this.pieces[pieceIndex];
      this.scene.tweens.add({
        targets: piece,
        duration: 400,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          piece.destroy();
        }
      });
    }
    animateBomb() {
      if (this.isEmpty()) {
        return;
      }
      this.bomb.scaleX = 1;
      this.bomb.scaleY = 1;
      this.bomb.y = 0;
      this.scene.tweens.killTweensByProperty(this.bomb, "scaleX", "scaleY");
      this.scene.tweens.add({
        targets: this.bomb,
        duration: 233,
        ease: Phaser.Math.Easing.Sine.InOut,
        scaleX: 0.85,
        scaleY: 1.15,
        y: "-=13",
        yoyo: true
      });
    }
    getActivePiecesNum() {
      return this.pieces.filter(Boolean).length;
    }
    isEmpty() {
      return this.getActivePiecesNum() === 0;
    }
    alignToGrid() {
      alignMulticellItemToGrid(this);
      this.y -= 10;
    }
    createSave() {
      return __spreadProps(__spreadValues({}, createGameItemSave(this)), {
        itemSuperType: ItemSuperType.COLOR_CAKE,
        colorCakeContent: this.pieces.map((cookie) => {
          var _a;
          return (_a = cookie == null ? void 0 : cookie.pieceType) != null ? _a : null;
        })
      });
    }
    explode(preExplosionDuraton) {
      let duration = preExplosionDuraton;
      this.scene.tweens.add({
        targets: this,
        duration,
        ease: Phaser.Math.Easing.Cubic.In,
        scale: 1.15
      });
      this.scene.tweens.add({
        targets: this.bomb,
        duration,
        ease: Phaser.Math.Easing.Cubic.In,
        scale: 1.5,
        onUpdate: () => {
          this.bombSparks.setScale({start: 1.85 * this.bomb.scale, end: 0, ease: Ease.Linear});
          this.updateBombSparksPosition();
        }
      });
      this.scene.tweens.addYoyoTween({
        target: this,
        property: "x",
        base: this.x,
        delta: 4,
        repeat: -1,
        duration: 24
      });
      this.scene.time.delayedCall(duration, () => {
        this.emit(ColorCakeEvent.EXPLODE, this);
        this.destroy();
      });
    }
    updateBombSparksPosition() {
      let x = this.bomb.x + 20 * this.bomb.scale;
      let y = this.bomb.y - 55 * this.bomb.scale;
      this.particles.setPosition(x, y);
    }
    getRandomActivePieceType() {
      let activePieces = this.pieces.filter(Boolean);
      let types = activePieces.map((piece) => piece.pieceType);
      return Phaser.Math.RND.pick(types);
    }
    destroy() {
      super.destroy();
    }
    toString() {
      let content = this.pieces.map((piece) => {
        let key = findKey_default(COLOR_CAKE_COOKIES_MAP, (value) => value === (piece == null ? void 0 : piece.pieceType));
        if (key) {
          return key.split("_")[1];
        }
        return "EMPTY";
      });
      return GameItemUtils.toString(this) + ` [${content.join(", ")}]`;
    }
  };

  // src/scenes/gameplay/items/DonutBox.ts
  var DonutBoxState;
  (function(DonutBoxState2) {
    DonutBoxState2["OPENED"] = "OPENED";
    DonutBoxState2["CLOSED"] = "CLOSED";
  })(DonutBoxState || (DonutBoxState = {}));
  var DonutBox = class extends Phaser.GameObjects.Container {
    constructor(scene, column, row, initialState = DonutBoxState.CLOSED) {
      super(scene, 0, 0);
      this.isDroppable = false;
      this.isMatchable = false;
      this.isSwappable = false;
      this.wasJustOpened = false;
      this._boxState = DonutBoxState.CLOSED;
      this.column = column;
      this.row = row;
      this.itemType = ItemType.DONUT_BOX;
      this.itemSuperType = ItemSuperType.DONUT_BOX;
      this.matchIds = [];
      this.powerupIds = [];
      this.addBoxBack();
      this.addDonut();
      this.addBoxFrontEdge();
      this.addBoxCover();
      this.setBoxState(initialState);
      this.setSize(this.boxCover.width, this.boxCover.height);
    }
    get boxState() {
      return this._boxState;
    }
    addBoxBack() {
      this.boxBack = this.scene.add.image(0, 0, "gameplay", "donut_box/box_01");
      this.add(this.boxBack);
    }
    addDonut() {
      this.donut = this.scene.add.image(0, 0, "gameplay", "donut_box/donut");
      this.donut.y = -5;
      this.donut.originalY = this.donut.y;
      this.add(this.donut);
    }
    addBoxFrontEdge() {
      this.boxFrontEdge = this.scene.add.image(0, 0, "gameplay", "donut_box/box_02");
      this.boxFrontEdge.y = -4;
      this.add(this.boxFrontEdge);
    }
    addBoxCover() {
      this.boxCover = this.scene.add.image(0, 0, "gameplay", "donut_box/box_03");
      this.boxCover.y = -8;
      this.boxCover.originalY = this.boxCover.y;
      this.add(this.boxCover);
    }
    alignToGrid() {
      alignToGrid(this);
      this.y -= 3;
    }
    setBoxState(state) {
      if (this._boxState === state) {
        return;
      }
      this._boxState = state;
      if (this._boxState === DonutBoxState.CLOSED) {
        this.onClose();
      } else {
        this.onOpen();
      }
    }
    onOpen() {
      this.hideCover();
      this.donut.y = this.donut.originalY - 12;
      this.scene.tweens.killTweensOf(this.donut);
      this.scene.tweens.add({
        targets: this.donut,
        duration: 600,
        ease: Phaser.Math.Easing.Bounce.Out,
        y: this.donut.originalY
      });
    }
    onClose() {
      this.showCover();
    }
    showCover() {
      this.boxCover.revive();
      this.boxCover.scale = 1;
      this.scene.tweens.killTweensOf(this.boxCover);
      this.boxCover.alpha = 0;
      this.scene.tweens.add({
        targets: this.boxCover,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.boxCover.y = this.boxCover.originalY - 14;
      this.scene.tweens.add({
        targets: this.boxCover,
        duration: 600,
        ease: Phaser.Math.Easing.Bounce.Out,
        y: this.boxCover.originalY
      });
    }
    hideCover() {
      this.scene.tweens.killTweensOf(this.boxCover);
      this.scene.tweens.add({
        targets: this.boxCover,
        duration: 400,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.boxCover.kill();
        }
      });
    }
    createSave() {
      return __spreadProps(__spreadValues({}, createGameItemSave(this)), {
        itemSuperType: ItemSuperType.DONUT_BOX,
        donutBoxState: this._boxState,
        wasJustOpened: this.wasJustOpened
      });
    }
    hideInstant() {
      this.destroy();
    }
    hide() {
      this.scene.tweens.add({
        targets: this,
        duration: 400,
        ease: Phaser.Math.Easing.Back.In,
        scale: 0.33,
        alpha: 0,
        angle: 270,
        onComplete: () => {
          this.destroy();
        }
      });
    }
    destroy() {
      super.destroy();
    }
    toString() {
      return GameItemUtils.toString(this) + ` ${this._boxState} ${this.wasJustOpened ? "*just opened" : ""}`;
    }
  };

  // src/scenes/gameplay/items/cookies/common/CookieUtils.ts
  var CookieUtils = class {
    static reset(cookie) {
      var _a;
      cookie.dropSqueezeDisabled = false;
      (_a = cookie.budgeTween) == null ? void 0 : _a.remove();
      cookie.budgeTween = null;
      cookie.alignToGrid();
      cookie.revive();
      cookie.alpha = 1;
      cookie.scale = 1;
      cookie.sendPowerupToChef = true;
      cookie.wasPoweruped = false;
      cookie.wasMatched = false;
      cookie.powerupId = void 0;
      cookie.matchId = void 0;
      if (cookie.dropPath) {
        cookie.dropPath.length = 0;
      }
      if (cookie.depth !== GameplayDepth.COOKIES) {
        cookie.setDepth(GameplayDepth.COOKIES);
      }
    }
    static setItemType(cookie, itemType) {
      if (cookie.itemType === itemType) {
        return;
      }
      cookie.itemType = itemType;
      cookie.itemSuperType = ItemTypeUtil.getItemSuperType(itemType);
      cookie.setFrame(CookieUtils.getFrame(itemType, cookie.powerup));
    }
    static getFrame(itemType, powerup) {
      let base = ItemTypeUtil.getFrameByItemType(itemType);
      switch (powerup) {
        case CookiePowerup.VERTICAL_STRIPES:
          return base + "-Stripes-Vertical";
        case CookiePowerup.HORIZONTAL_STRIPES:
          return base + "-Stripes-Horizontal";
        case CookiePowerup.BOMB:
          return base + "-Bomb";
        case CookiePowerup.SUPER_SPHERE:
          return "cookies/super_sphere";
        default:
          return base;
      }
    }
    static createSave(cookie) {
      return __spreadProps(__spreadValues({}, createGameItemSave(cookie)), {
        itemSuperType: ItemSuperType.COOKIE,
        powerup: cookie.powerup
      });
    }
    static toString(cookie) {
      let powerup = cookie.powerup ? "*" + cookie.powerup : "";
      return `${cookie.itemType} [${cookie.column}, ${cookie.row}] ${powerup}`;
    }
    static markAsMatched(cookie, matchId) {
      cookie.wasMatched = true;
      cookie.matchId = matchId;
    }
    static markAsPoweruped(cookie, powerupId) {
      cookie.wasPoweruped = true;
      cookie.powerupId = powerupId;
    }
    static popOut(cookie) {
      if (!cookie.scene) {
        return;
      }
      cookie.dropSqueezeDisabled = true;
      this.fadeIn(cookie);
      this.playSqueezeTweens(cookie);
    }
    static fadeIn(cookie) {
      cookie.alpha = 0;
      cookie.scene.tweens.add({
        targets: cookie,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
    }
    static playSqueezeTweens(cookie) {
      cookie.item.scale = 0;
      cookie.scene.tweens.add({
        targets: cookie.item,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1.25,
        onComplete: () => {
          cookie.scene.tweens.add({
            targets: cookie.item,
            duration: 800,
            ease: Phaser.Math.Easing.Elastic.Out,
            easeParams: [0.1, 0.4],
            scale: 1,
            onComplete: () => {
              cookie.dropSqueezeDisabled = false;
            }
          });
        }
      });
    }
  };

  // src/scenes/gameplay/items/cookies/BasicCookie.ts
  var BasicCookie = class extends Phaser.GameObjects.Image {
    constructor(scene) {
      super(scene, 0, 0, "gameplay", ItemTypeUtil.getFrameByItemType(ItemType.COOKIE_RED));
      this.wasMatched = false;
      this.wasPoweruped = false;
      this.wasJustCreated = false;
      this.isSwappable = true;
      this.isMatchable = true;
      this.isDroppable = true;
      this.appearDelay = 0;
      this.dropDelay = 0;
      this.dropSqueezeDisabled = false;
      this.sendPowerupToChef = true;
      this.name = "cookie";
    }
    setItemType(itemType) {
      CookieUtils.setItemType(this, itemType);
    }
    alignToGrid() {
      alignToGrid(this);
    }
    createSave() {
      return CookieUtils.createSave(this);
    }
    toString() {
      return CookieUtils.toString(this);
    }
    markAsMatched(matchId) {
      CookieUtils.markAsMatched(this, matchId);
    }
    markAsPoweruped(powerupId) {
      CookieUtils.markAsPoweruped(this, powerupId);
    }
    popOut() {
    }
    reset() {
      CookieUtils.reset(this);
    }
    hasPowerup() {
      return false;
    }
    get powerup() {
      return null;
    }
  };

  // src/scenes/gameplay/items/cookies/StripedCookie.ts
  var StripedCookie = class extends Phaser.GameObjects.Container {
    constructor(scene, stripesType) {
      super(scene);
      this.wasMatched = false;
      this.wasPoweruped = false;
      this.wasJustCreated = false;
      this.isSwappable = true;
      this.isMatchable = true;
      this.isDroppable = true;
      this.appearDelay = 0;
      this.dropDelay = 0;
      this.dropSqueezeDisabled = false;
      this.sendPowerupToChef = true;
      this.name = "cookie_stripes";
      this._powerup = stripesType;
      this.addItem();
      this.setSize(this.item.width, this.item.height);
    }
    addItem() {
      let frame = CookieUtils.getFrame(ItemType.COOKIE_RED, CookiePowerup.HORIZONTAL_STRIPES);
      this.item = this.scene.add.image(0, 0, "gameplay", frame);
      this.add(this.item);
    }
    setItemType(itemType) {
      CookieUtils.setItemType(this, itemType);
    }
    reset() {
      CookieUtils.reset(this);
      this.item.scale = 1;
    }
    markAsMatched(matchId) {
      CookieUtils.markAsMatched(this, matchId);
    }
    markAsPoweruped(powerupId) {
      CookieUtils.markAsPoweruped(this, powerupId);
    }
    popOut() {
      CookieUtils.popOut(this);
    }
    createSave() {
      return CookieUtils.createSave(this);
    }
    alignToGrid() {
      alignToGrid(this);
    }
    setFrame(frame) {
      this.item.setFrame(frame);
    }
    hasPowerup() {
      return true;
    }
    get powerup() {
      return this._powerup;
    }
    toString() {
      return CookieUtils.toString(this);
    }
  };

  // src/scenes/gameplay/items/cookies/BombCookie.ts
  var BombCookie = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.wasMatched = false;
      this.wasPoweruped = false;
      this.wasJustCreated = false;
      this.isSwappable = true;
      this.isMatchable = true;
      this.isDroppable = true;
      this.appearDelay = 0;
      this.dropDelay = 0;
      this.dropSqueezeDisabled = false;
      this.sendPowerupToChef = true;
      this.sparksPosition = {x: 23, y: -27};
      this.name = "cookie_bomb";
      this._powerup = CookiePowerup.BOMB;
      this.addItem();
      this.addSparks();
      this.setSize(this.item.width, this.item.height);
    }
    addItem() {
      let frame = CookieUtils.getFrame(ItemType.COOKIE_RED, CookiePowerup.BOMB);
      this.item = this.scene.add.image(0, 0, "gameplay", frame);
      this.add(this.item);
    }
    addSparks() {
      this.sparksManager = this.scene.add.particles("gameplay");
      this.sparksManager.setPosition(this.sparksPosition.x, this.sparksPosition.y);
      this.add(this.sparksManager);
      this.sparksEmitter = this.sparksManager.createEmitter({
        frame: "bomb_spark_2",
        lifespan: 466,
        scale: {start: 1.85, end: 0, ease: Ease.Linear},
        alpha: {start: 1, end: 0, ease: Ease.ExpoIn},
        quantity: 1,
        frequency: 66,
        speed: 50,
        gravityY: -200,
        on: false
      });
    }
    setItemType(itemType) {
      CookieUtils.setItemType(this, itemType);
    }
    reset() {
      CookieUtils.reset(this);
      this.item.scale = 1;
    }
    markAsMatched(matchId) {
      CookieUtils.markAsMatched(this, matchId);
    }
    markAsPoweruped(powerupId) {
      CookieUtils.markAsPoweruped(this, powerupId);
    }
    popOut() {
      CookieUtils.popOut(this);
    }
    createSave() {
      return CookieUtils.createSave(this);
    }
    alignToGrid() {
      alignToGrid(this);
    }
    setFrame(frame) {
      this.item.setFrame(frame);
    }
    hasPowerup() {
      return true;
    }
    get powerup() {
      return this._powerup;
    }
    kill() {
      this.sparksEmitter.killAll();
      this.sparksEmitter.on = false;
      return super.kill();
    }
    revive() {
      super.revive();
      this.sparksEmitter.on = true;
    }
    toString() {
      return CookieUtils.toString(this);
    }
  };

  // src/scenes/gameplay/items/cookies/SuperSphereCookie.ts
  var SuperSphereCookie = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.wasMatched = false;
      this.wasPoweruped = false;
      this.wasJustCreated = false;
      this.isSwappable = true;
      this.isMatchable = false;
      this.isDroppable = true;
      this.appearDelay = 0;
      this.dropDelay = 0;
      this.dropSqueezeDisabled = false;
      this.sendPowerupToChef = true;
      this.name = "super_sphere";
      this._powerup = CookiePowerup.SUPER_SPHERE;
      this.addItem();
      this.addSparks();
      this.setSize(this.item.width, this.item.height);
    }
    addItem() {
      let frame = CookieUtils.getFrame(ItemType.COOKIE_RED, CookiePowerup.BOMB);
      this.item = this.scene.add.image(0, 0, "gameplay", frame);
      this.add(this.item);
    }
    addSparks() {
      this.sparksManager = this.scene.add.particles("gameplay");
      this.add(this.sparksManager);
      this.sparksEmitter = this.sparksManager.createEmitter({
        frame: "star_particle",
        speed: 20,
        lifespan: 800,
        rotate: ParticleUtil.onEmitRandom(0, 360),
        angle: -90,
        scale: {start: 0.8, end: 0, ease: Ease.ExpoIn},
        alpha: {start: 0, end: 1, ease: Ease.ExpoOut},
        frequency: 300,
        on: false
      });
      this.sparksEmitter.setEmitZone({
        source: new Phaser.Geom.Circle(0, 5, 32),
        type: "random",
        quantity: 360
      });
    }
    playIdleTweens() {
      let duration = 800;
      this.item.angle = Phaser.Math.RND.sign() * 5;
      this.scene.tweens.add({
        targets: this.item,
        duration: duration * 1.5,
        ease: Phaser.Math.Easing.Sine.InOut,
        angle: -this.item.angle,
        yoyo: true,
        repeat: -1
      });
      this.item.y = Phaser.Math.RND.sign() * 3;
      this.scene.tweens.add({
        targets: this.item,
        duration,
        ease: Phaser.Math.Easing.Sine.InOut,
        y: -this.item.y,
        yoyo: true,
        repeat: -1
      });
    }
    stopIdleTweens() {
      this.scene.tweens.killTweensOf(this.item);
      this.scene.tweens.add({
        targets: this.item,
        duration: 300,
        ease: Phaser.Math.Easing.Linear,
        angle: 0,
        y: 0
      });
    }
    stopIdleTweensInstant() {
      this.scene.tweens.killTweensOf(this.item);
      this.item.angle = 0;
      this.item.y = 0;
    }
    revive() {
      super.revive();
      this.sparksManager.revive();
      this.sparksEmitter.on = true;
      this.playIdleTweens();
    }
    kill() {
      this.sparksManager.kill();
      this.sparksEmitter.on = false;
      this.stopIdleTweensInstant();
      return super.kill();
    }
    setItemType(itemType) {
      CookieUtils.setItemType(this, itemType);
    }
    reset() {
      CookieUtils.reset(this);
      this.item.scale = 1;
      this.item.angle = 0;
      this.item.y = 0;
    }
    markAsMatched(matchId) {
      CookieUtils.markAsMatched(this, matchId);
    }
    markAsPoweruped(powerupId) {
      CookieUtils.markAsPoweruped(this, powerupId);
    }
    popOut() {
      CookieUtils.popOut(this);
    }
    createSave() {
      return CookieUtils.createSave(this);
    }
    alignToGrid() {
      alignToGrid(this);
    }
    setFrame(frame) {
      this.item.setFrame(frame);
    }
    resetFrame() {
      this.setFrame(CookieUtils.getFrame(this.itemType, this.powerup));
    }
    hasPowerup() {
      return true;
    }
    get powerup() {
      return this._powerup;
    }
    toString() {
      return CookieUtils.toString(this);
    }
  };

  // src/scenes/gameplay/items/cookies/common/CookiesPool.ts
  var Pool = class {
    constructor(options) {
      this.createCallback = options.createCallback;
      this.items = times_default(options.initialSize, () => {
        return options.createCallback();
      });
    }
    getFirstInactive() {
      let inactive = this.items.find((item) => item.active === false);
      if (inactive) {
        return inactive;
      }
      let newCookie = this.createCallback();
      this.items.push(newCookie);
      return newCookie;
    }
    destroy() {
      this.items = null;
    }
  };
  var CookiesPool = class extends Phaser.Events.EventEmitter {
    constructor(scene) {
      super();
      this.scene = scene;
      this.createPools();
    }
    createPools() {
      this.common = new Pool({
        initialSize: this.scene.field.getNonEmptyCellsNum(),
        createCallback: () => {
          let cookie = new BasicCookie(this.scene);
          cookie.kill();
          this.scene.add.existing(cookie);
          return cookie;
        }
      });
      this.horStripes = new Pool({
        initialSize: 10,
        createCallback: () => {
          let cookie = new StripedCookie(this.scene, CookiePowerup.HORIZONTAL_STRIPES);
          cookie.kill();
          this.scene.add.existing(cookie);
          return cookie;
        }
      });
      this.vertStripes = new Pool({
        initialSize: 10,
        createCallback: () => {
          let cookie = new StripedCookie(this.scene, CookiePowerup.VERTICAL_STRIPES);
          cookie.kill();
          this.scene.add.existing(cookie);
          return cookie;
        }
      });
      this.bombs = new Pool({
        initialSize: 12,
        createCallback: () => {
          let cookie = new BombCookie(this.scene);
          cookie.kill();
          this.scene.add.existing(cookie);
          return cookie;
        }
      });
      this.superSpheres = new Pool({
        initialSize: 5,
        createCallback: () => {
          let cookie = new SuperSphereCookie(this.scene);
          cookie.kill();
          this.scene.add.existing(cookie);
          return cookie;
        }
      });
    }
    getCookie(powerup) {
      return this.getPoolByPowerupType(powerup).getFirstInactive();
    }
    getPoolByPowerupType(powerup) {
      switch (powerup) {
        case CookiePowerup.VERTICAL_STRIPES:
          return this.vertStripes;
        case CookiePowerup.HORIZONTAL_STRIPES:
          return this.horStripes;
        case CookiePowerup.BOMB:
          return this.bombs;
        case CookiePowerup.SUPER_SPHERE:
          return this.superSpheres;
        default:
          return this.common;
      }
    }
    destroy() {
      let pools = [
        this.common,
        this.horStripes,
        this.vertStripes,
        this.bombs,
        this.superSpheres
      ];
      pools.forEach((pool) => pool.destroy());
      pools = null;
    }
  };

  // src/scenes/gameplay/items/Gummy.ts
  var Gummy = class extends Phaser.GameObjects.Image {
    constructor(scene, column, row, itemType) {
      super(scene, 0, 0, "gameplay", ItemTypeUtil.getFrameByItemType(itemType));
      this.isMultiCell = true;
      this.itemWidth = 1;
      this.itemHeight = 1;
      this.isDroppable = false;
      this.isMatchable = false;
      this.isSwappable = false;
      this.column = column;
      this.row = row;
      this.itemType = itemType;
      this.itemSuperType = ItemSuperType.GUMMY;
      this.setMulticell();
      this.setSize(this.itemWidth * CELL_SIZE, this.itemHeight * CELL_SIZE);
    }
    setMulticell() {
      let size = MultiCellUtils.getSize(this.itemType);
      if (size) {
        this.isMultiCell = true;
        this.itemWidth = size.width;
        this.itemHeight = size.height;
      }
    }
    alignToGrid() {
      let topLeft = gridToPixels(this.column, this.row);
      let top = topLeft.y - CELL_SIZE / 2;
      let left = topLeft.x - CELL_SIZE / 2;
      this.x = left + this.width / 2;
      this.y = top + this.height / 2;
    }
    createSave() {
      return __spreadProps(__spreadValues({}, createGameItemSave(this)), {
        itemSuperType: ItemSuperType.GUMMY
      });
    }
    isLarge() {
      return this.itemType.includes("LARGE");
    }
    isHorizontal() {
      return this.itemType.includes("HORIZONTAL");
    }
    toString() {
      return GameItemUtils.toString(this);
    }
  };

  // src/scenes/gameplay/items/MysteryBox.ts
  var MysteryBoxEvent;
  (function(MysteryBoxEvent2) {
    MysteryBoxEvent2["OPEN"] = "__OPEN";
  })(MysteryBoxEvent || (MysteryBoxEvent = {}));
  var MysteryBox = class extends Phaser.GameObjects.Image {
    constructor(scene, column, row, itemType, content) {
      super(scene, 0, 0, "gameplay", ItemTypeUtil.getFrameByItemType(itemType));
      this.isSwappable = true;
      this.isMatchable = false;
      this.isDroppable = true;
      this.matchIds = [];
      this.powerupIds = [];
      this.appearDelay = 0;
      this.dropDelay = 0;
      this.dropSqueezeDisabled = false;
      this.wasJustCreated = true;
      this.isOpened = false;
      this.column = column;
      this.row = row;
      this.itemType = itemType;
      this.itemSuperType = ItemSuperType.MYSTERY_BOX;
      this.content = content;
    }
    open(delay = 0) {
      if (this.isOpened) {
        return;
      }
      this.isOpened = true;
      this.scene.time.delayedCall(delay, () => {
        this.emit(MysteryBoxEvent.OPEN, this);
      });
    }
    alignToGrid() {
      alignToGrid(this, this.column, this.row);
    }
    createSave() {
      return __spreadProps(__spreadValues({}, createGameItemSave(this)), {
        itemSuperType: ItemSuperType.MYSTERY_BOX,
        content: this.content
      });
    }
    destroy() {
      super.destroy();
    }
    toString() {
      return GameItemUtils.toString(this) + ` content: ${this.content.type}`;
    }
    convertContentToGameItemConfig() {
      let containsCookie = ItemTypeUtil.getSubtypes(ItemSuperType.COOKIE).includes(this.content.type);
      if (containsCookie) {
        return {
          column: this.column,
          row: this.row,
          itemType: this.content.type,
          params: {
            type: "cookie",
            powerup: this.content.powerup
          }
        };
      } else {
        return {
          column: this.column,
          row: this.row,
          itemType: this.content.type,
          params: {
            type: "basic"
          }
        };
      }
    }
  };

  // src/scenes/gameplay/items/Chick.ts
  var Chick = class extends Phaser.GameObjects.Image {
    constructor(scene, column, row, itemType) {
      super(scene, 0, 0, "gameplay", ItemTypeUtil.getFrameByItemType(itemType));
      this.isSwappable = true;
      this.isMatchable = false;
      this.isDroppable = true;
      this.matchIds = [];
      this.powerupIds = [];
      this.column = column;
      this.row = row;
      this.itemType = itemType;
      this.itemSuperType = ItemSuperType.CHICK;
    }
    alignToGrid() {
      alignToGrid(this, this.column, this.row);
      this.y -= 4;
    }
    createSave() {
      return __spreadProps(__spreadValues({}, createGameItemSave(this)), {
        itemSuperType: ItemSuperType.CHICK
      });
    }
    destroy() {
      super.destroy();
    }
    toString() {
      return GameItemUtils.toString(this);
    }
  };

  // src/scenes/gameplay/items/GummyBlocker.ts
  var GummyBlocker = class extends Phaser.GameObjects.Image {
    constructor(scene, column, row, itemType) {
      super(scene, 0, 0, "gameplay", ItemTypeUtil.getFrameByItemType(itemType));
      this.isDroppable = false;
      this.isMatchable = false;
      this.isSwappable = false;
      this.column = column;
      this.row = row;
      this.itemType = itemType;
      this.itemSuperType = ItemSuperType.GUMMY_BLOCKER;
    }
    alignToGrid() {
      alignToGrid(this);
    }
    createSave() {
      return __spreadProps(__spreadValues({}, createGameItemSave(this)), {
        itemSuperType: ItemSuperType.GUMMY_BLOCKER
      });
    }
    destroy() {
      super.destroy();
    }
    toString() {
      return GameItemUtils.toString(this);
    }
  };

  // src/scenes/gameplay/ItemsFactory.ts
  var ItemsFactory = class {
    constructor(scene) {
      this.scene = scene;
      this.mysteryBoxGenerator = this.scene.mysteryBoxContentGenerator;
      this.cookiesPool = new CookiesPool(this.scene);
    }
    create(config2) {
      let superType = ItemTypeUtil.getItemSuperType(config2.itemType);
      switch (superType) {
        case ItemSuperType.BISCUIT:
          return this.createBiscuit(config2.column, config2.row);
        case ItemSuperType.COOKIE:
          return this.createCookie(config2.column, config2.row, config2.itemType, config2.params.powerup);
        case ItemSuperType.MARSHMALLOW:
          return this.createMarshmallow(config2.column, config2.row, config2.itemType);
        case ItemSuperType.DROP_ITEM:
          return this.createDropItem(config2.column, config2.row, config2.itemType);
        case ItemSuperType.CHOCOLATE:
          return this.createChocolate(config2.column, config2.row, config2.itemType);
        case ItemSuperType.CANDY_BOTTLE:
          return this.createCandyBottle(config2.column, config2.row);
        case ItemSuperType.DONUT_BOX:
          return this.createDonutBox(config2.column, config2.row);
        case ItemSuperType.APPLE_PLATTER:
          return this.createApplePlatter(config2.column, config2.row, config2.params.applesNum);
        case ItemSuperType.COLOR_CAKE:
          return this.createColorCake(config2.column, config2.row, config2.params.content);
        case ItemSuperType.LICORICE:
          return this.createLicorice(config2.column, config2.row, config2.itemType);
        case ItemSuperType.GUMMY:
          return this.createGummy(config2.column, config2.row, config2.itemType);
        case ItemSuperType.GUMMY_BLOCKER:
          return this.createGummyBlocker(config2.column, config2.row, config2.itemType);
        case ItemSuperType.MYSTERY_BOX:
          return this.createMysteryBox(config2.column, config2.row, config2.itemType, this.mysteryBoxGenerator.getMysteryBoxContent());
        case ItemSuperType.GENERATOR:
          let {turnsNum: turnsTotal, content, contentMod, invisible} = config2.params;
          return this.createGenerator(config2.column, config2.row, {content, contentMod, turnsTotal, invisible});
        case ItemSuperType.CHICK:
          return this.createChick(config2.column, config2.row, config2.itemType);
        default:
          console.warn("Unknown item type!", config2);
          return null;
      }
    }
    createBiscuit(column, row) {
      let biscuit = new Biscuit(this.scene, column, row);
      biscuit.alignToGrid();
      biscuit.setDepth(GameplayDepth.BISCUITS);
      this.scene.items.add(biscuit);
      this.scene.add.existing(biscuit);
      return biscuit;
    }
    createCookie(column, row, itemType, powerup) {
      let cookie = this.cookiesPool.getCookie(powerup);
      cookie.column = column;
      cookie.row = row;
      cookie.setItemType(itemType);
      cookie.reset();
      this.scene.items.add(cookie);
      return cookie;
    }
    createDropItem(column, row, itemType) {
      let dropItem = new DropItem(this.scene, column, row, itemType);
      dropItem.alignToGrid();
      dropItem.setDepth(GameplayDepth.COOKIES);
      this.scene.items.add(dropItem);
      this.scene.add.existing(dropItem);
      return dropItem;
    }
    createMarshmallow(column, row, itemType, currentHealth) {
      let marshmallow = new Marshmallow(this.scene, column, row, itemType);
      marshmallow.alignToGrid();
      marshmallow.setDepth(GameplayDepth.COOKIES);
      marshmallow.on(MarshmallowEvent.DAMAGE, this.scene.onMarshmallowDamage, this.scene);
      if (typeof currentHealth !== "undefined") {
        marshmallow.setHealth(currentHealth);
      }
      this.scene.items.add(marshmallow);
      this.scene.add.existing(marshmallow);
      return marshmallow;
    }
    createChocolate(column, row, itemType, currentHealth) {
      let chocolate = new Chocolate(this.scene, column, row, itemType);
      chocolate.alignToGrid();
      chocolate.setDepth(GameplayDepth.COOKIES);
      chocolate.on(ChocolateEvent.DAMAGE, this.scene.onChocolateDamage, this.scene);
      if (typeof currentHealth !== "undefined") {
        chocolate.setHealth(currentHealth);
      }
      this.scene.items.add(chocolate);
      this.scene.add.existing(chocolate);
      return chocolate;
    }
    createDonutBox(column, row, initialState = DonutBoxState.CLOSED) {
      let donutBox = new DonutBox(this.scene, column, row, initialState);
      donutBox.alignToGrid();
      donutBox.setDepth(GameplayDepth.COOKIES);
      this.scene.items.add(donutBox);
      this.scene.add.existing(donutBox);
      return donutBox;
    }
    createCandyBottle(column, row) {
      let candyBottle = new CandyBottle(this.scene, column, row);
      candyBottle.alignToGrid();
      candyBottle.setDepth(GameplayDepth.COOKIES);
      candyBottle.on(CandyBottleEvent.EMIT_PARTICLES, this.scene.onCandyBottleLanded, this.scene);
      candyBottle.on(CandyBottleEvent.EMIT_CANDY, this.scene.onCandyCollect, this.scene);
      candyBottle.originalY = candyBottle.y;
      this.scene.items.add(candyBottle);
      this.scene.add.existing(candyBottle);
      return candyBottle;
    }
    createApplePlatter(column, row, applesNum) {
      let applePlatter = new ApplePlatter(this.scene, column, row, applesNum);
      applePlatter.alignToGrid();
      applePlatter.setDepth(GameplayDepth.COOKIES);
      applePlatter.on(ApplesPlatterEvent.APPLE_REMOVE, this.scene.onAppleCollect, this.scene);
      this.scene.items.add(applePlatter);
      this.scene.add.existing(applePlatter);
      return applePlatter;
    }
    createColorCake(column, row, content) {
      let cake = new ColorCake(this.scene, column, row, content != null ? content : ColorCake.getDefaultContent());
      cake.alignToGrid();
      cake.setDepth(GameplayDepth.COOKIES);
      this.scene.items.add(cake);
      this.scene.add.existing(cake);
      return cake;
    }
    createLicorice(column, row, itemType) {
      let licorice = new Licorice(this.scene, column, row, itemType);
      licorice.alignToGrid();
      licorice.setDepth(GameplayDepth.COOKIES);
      this.scene.items.add(licorice);
      this.scene.add.existing(licorice);
      return licorice;
    }
    createGummy(column, row, itemType) {
      let gummy = new Gummy(this.scene, column, row, itemType);
      gummy.alignToGrid();
      gummy.setDepth(GameplayDepth.GUMMIES);
      this.scene.items.add(gummy);
      this.scene.add.existing(gummy);
      return gummy;
    }
    createGummyBlocker(column, row, itemType) {
      let gummyBlocker = new GummyBlocker(this.scene, column, row, itemType);
      gummyBlocker.alignToGrid();
      gummyBlocker.setDepth(GameplayDepth.COOKIES);
      this.scene.items.add(gummyBlocker);
      this.scene.add.existing(gummyBlocker);
      return gummyBlocker;
    }
    createMysteryBox(column, row, itemType, content) {
      let box = new MysteryBox(this.scene, column, row, itemType, content);
      box.alignToGrid();
      box.setDepth(GameplayDepth.COOKIES);
      box.once(MysteryBoxEvent.OPEN, this.scene.onMysteryBoxOpen, this.scene);
      this.scene.items.add(box);
      this.scene.add.existing(box);
      return box;
    }
    createGenerator(column, row, options) {
      let generator = new Generator(this.scene, column, row, options);
      generator.alignToGrid();
      generator.setDepth(GameplayDepth.GENERATOR);
      this.scene.items.add(generator);
      this.scene.add.existing(generator);
      return generator;
    }
    createChick(column, row, itemType) {
      let chick = new Chick(this.scene, column, row, itemType);
      chick.alignToGrid();
      chick.setDepth(GameplayDepth.COOKIES);
      this.scene.items.add(chick);
      this.scene.add.existing(chick);
      return chick;
    }
    destroy() {
      this.cookiesPool.destroy();
    }
  };

  // src/scenes/gameplay/ItemsSwapper.ts
  var ItemsSwapperEvent;
  (function(ItemsSwapperEvent2) {
    ItemsSwapperEvent2["SWAP_START"] = "__SWAP_START";
    ItemsSwapperEvent2["SWAP_COMPLETE"] = "__SWAP_COMPLETE";
    ItemsSwapperEvent2["SWAP_BACK_COMPLETE"] = "__SWAP_BACK_COMPLETE";
  })(ItemsSwapperEvent || (ItemsSwapperEvent = {}));
  var SwapDirection;
  (function(SwapDirection2) {
    SwapDirection2["HORIZONTAL"] = "HORIZONTAL";
    SwapDirection2["VERTICAL"] = "VERTICAL";
  })(SwapDirection || (SwapDirection = {}));
  var ItemsSwapper = class extends Phaser.Events.EventEmitter {
    constructor(scene) {
      super();
      this.trackSwapping = false;
      this.scene = scene;
      this.scene.input.on(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
    }
    onPointerDown(pointer, objects) {
      if (this.scene.isLocked) {
        return;
      }
      if (objects.length > 0) {
        return;
      }
      let pointerPosition = this.getPointerCameraPosition(pointer);
      let item = this.getItemAtXY(pointerPosition.x, pointerPosition.y);
      if (!item || !this.canBeSwapped(item)) {
        return;
      }
      this.pointerDownItem = item;
      this.pointerDownPosition = pointerPosition;
      this.pointer = pointer;
      this.scene.input.off(Phaser.Input.Events.POINTER_UP, this.onPointerUp, this);
      this.scene.input.once(Phaser.Input.Events.POINTER_UP, this.onPointerUp, this);
      this.startTrackSwapping();
    }
    getPointerCameraPosition(pointer) {
      return pointer.positionToCamera(this.scene.cameras.main);
    }
    getItemAtXY(x, y) {
      let {column, row} = pixelsToGridXY(x, y);
      return this.scene.items.mainItems.getAt(column, row);
    }
    canBeSwapped(item) {
      return item.isSwappable && this.scene.items.hasLicoriceOver(item) === false;
    }
    onPointerUp() {
      this.stopTrackSwapping();
    }
    startTrackSwapping() {
      this.trackSwapping = true;
    }
    stopTrackSwapping() {
      this.trackSwapping = false;
    }
    tryToSwap(pointerPosition) {
      if (!this.pointerDownItem) {
        this.sendExceptionToSentry(pointerPosition);
        return;
      }
      let angleRad = Phaser.Math.Angle.BetweenPoints(this.pointerDownPosition, pointerPosition);
      let angleDeg = Phaser.Math.RadToDeg(angleRad);
      let direction = getOrthoDirection(angleDeg);
      let secondItem = this.scene.items.mainItems.getNeighborAtDirection(this.pointerDownItem.column, this.pointerDownItem.row, direction);
      if (secondItem && this.canBeSwapped(secondItem)) {
        this.swapItems(this.pointerDownItem, secondItem);
      } else {
        this.playCantSwapTween(this.pointerDownItem, angleRad);
      }
    }
    sendExceptionToSentry(pointerPosition) {
      let pointerDownPosition = pixelsToGridXY(this.pointerDownPosition.x, this.pointerDownPosition.y);
      let angleRad = Phaser.Math.Angle.BetweenPoints(this.pointerDownPosition, pointerPosition);
      let angleDeg = Phaser.Math.RadToDeg(angleRad);
      let direction = getOrthoDirection(angleDeg);
      this.scene.sentry.captureException(new Error("No pointerDownItem!"), (scope) => {
        scope.setContext("Swapping error", {
          cell: `[${pointerDownPosition.column}, ${pointerDownPosition.row}]`,
          angle: Math.round(angleDeg).toString(),
          direction,
          level: this.scene.levelNumber,
          movesDone: this.scene.levelConfig.moves - this.scene.moves,
          moveListenersNum: this.scene.input.listenerCount(Phaser.Input.Events.POINTER_MOVE),
          upListenersNum: this.scene.input.listenerCount(Phaser.Input.Events.POINTER_UP),
          isPointerOverGame: this.scene.input.isOver,
          scene: this.scene.scene.key
        });
        return scope;
      });
    }
    swapItems(item_1, item_2) {
      this.emit(ItemsSwapperEvent.SWAP_START, item_1, item_2);
      this.lastSwap = {
        item_1,
        item_2,
        swappedItems: [item_1, item_2],
        direction: this.getSwapDirection(item_1, item_2)
      };
      this.scene.items.swapItems(item_1, item_2);
      this.scene.audio.play(GameSoundKey.SWAP, {volume: 0.66});
      this.playSwapTweens(item_1, item_2, () => {
        this.emit(ItemsSwapperEvent.SWAP_COMPLETE, item_1, item_2);
      });
    }
    playSwapTweens(item_1, item_2, onComplete) {
      let swapDuration = 200;
      let ease = Phaser.Math.Easing.Cubic.Out;
      this.scene.tweens.add({
        targets: item_1,
        duration: swapDuration,
        ease,
        x: item_2.x,
        y: item_2.y,
        onStart: () => {
          item_1.setDepth(GameplayDepth.NEW_COOKIE);
        },
        onComplete: () => {
          item_1.setDepth(GameplayDepth.COOKIES);
          onComplete();
        }
      });
      this.scene.tweens.add({
        targets: item_1,
        duration: swapDuration / 2,
        ease: Phaser.Math.Easing.Sine.Out,
        scale: 1.33,
        yoyo: true
      });
      this.scene.tweens.add({
        targets: item_2,
        duration: swapDuration,
        ease,
        x: item_1.x,
        y: item_1.y
      });
      this.scene.tweens.add({
        targets: item_2,
        duration: swapDuration / 2,
        ease: Phaser.Math.Easing.Sine.Out,
        scale: 0.8,
        yoyo: true
      });
    }
    getSwapDirection(item_1, item_2) {
      let angle = Phaser.Math.Angle.Between(item_1.column, item_1.row, item_2.column, item_2.row) * Phaser.Math.RAD_TO_DEG;
      if (angle === 180 || angle === 0) {
        return SwapDirection.HORIZONTAL;
      } else {
        return SwapDirection.VERTICAL;
      }
    }
    swapItemsBack(item_1, item_2) {
      this.scene.items.swapItems(item_1, item_2);
      this.scene.audio.play(GameSoundKey.SWAP_BACK, {volume: 0.75});
      this.playSwapTweens(item_2, item_1, () => {
        this.emit(ItemsSwapperEvent.SWAP_BACK_COMPLETE, item_1, item_2);
      });
    }
    playCantSwapTween(item, angleRad) {
      let angle = Phaser.Math.Snap.To(angleRad, Math.PI / 2);
      let distance = CELL_SIZE * 0.2;
      let targetX = item.x + Math.cos(angle) * distance;
      let targetY = item.y + Math.sin(angle) * distance;
      let duration = 120;
      this.onCantSwapTweenStart(item);
      this.scene.tweens.add({
        targets: item,
        duration,
        ease: Phaser.Math.Easing.Sine.InOut,
        x: targetX,
        y: targetY,
        yoyo: true
      });
      this.scene.tweens.addYoyoTween({
        target: item,
        property: "angle",
        base: 0,
        delta: 13,
        duration: duration / 2,
        repeat: 1,
        ease: Ease.SineInOut,
        onComplete: () => {
          this.onCantSwapTweenComplete();
        }
      });
    }
    onCantSwapTweenStart(item) {
      var _a, _b;
      this.scene.isLocked = true;
      this.scene.audio.play(GameSoundKey.CANT_SWAP, {volume: 0.33});
      let hintedItems = (_b = (_a = this.scene.hint.hint) == null ? void 0 : _a.getItems()) != null ? _b : [];
      if (hintedItems.includes(item)) {
        this.scene.hint.cancel();
      }
    }
    onCantSwapTweenComplete() {
      this.scene.isLocked = false;
      if (!this.scene.hint.hint) {
        this.scene.hint.start();
      }
    }
    update(delta) {
      if (this.trackSwapping === false) {
        return;
      }
      this.doTrackSwapping();
    }
    doTrackSwapping() {
      let pointerPosition = this.getPointerCameraPosition(this.pointer);
      let distance = Phaser.Math.Distance.BetweenPoints(this.pointerDownPosition, pointerPosition);
      if (distance > CELL_SIZE / 3) {
        this.stopTrackSwapping();
        this.tryToSwap(pointerPosition);
        this.pointerDownItem = null;
      }
    }
    destroy() {
      this.scene.input.off(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
      this.scene.input.off(Phaser.Input.Events.POINTER_UP, this.onPointerUp, this);
      this.stopTrackSwapping();
    }
  };

  // src/scenes/gameplay/drop/ItemDropper.ts
  var ItemDropper = class {
    constructor(scene, item) {
      this.isComplete = false;
      this.speed = 1.22;
      this.scene = scene;
      this.item = item;
      this.dropDelay = item.dropDelay;
      this.path = this.item.dropPath.map((cell) => gridToPixels(cell.column, cell.row));
      this.path = this.path.reverse();
      if (this.path.length === 1) {
        this.playLastTween(this.dropDelay);
      } else {
        this.destination = this.path.pop();
      }
    }
    update(delta) {
      if (!this.destination) {
        return;
      }
      let timescaledDelta = delta * this.scene.fastForward.timeScale;
      this.dropDelay -= timescaledDelta;
      if (this.dropDelay > 0) {
        return;
      }
      let dx = this.destination.x - this.item.x;
      let dy = this.destination.y - this.item.y;
      let angle = Math.atan2(dy, dx);
      let moveDistance = this.speed * timescaledDelta;
      this.item.x += Math.cos(angle) * moveDistance;
      this.item.y += Math.sin(angle) * moveDistance;
      let distance = Math.sqrt(dx * dx + dy * dy);
      if (distance <= moveDistance) {
        if (this.path.length === 1) {
          this.destination = null;
          this.playLastTween(0);
        } else {
          this.destination = this.path.pop();
        }
      }
    }
    playLastTween(delay) {
      let isDiagonal = this.isLastDropDiagonal();
      let normalDuration = 350;
      let duration = isDiagonal ? normalDuration * 1.5 : normalDuration;
      let target = this.path[0];
      if (!this.item.dropSqueezeDisabled) {
        this.scene.tweens.add({
          delay: delay + duration / 2,
          targets: this.item,
          duration: normalDuration / 2,
          ease: Phaser.Math.Easing.Linear,
          scaleX: 1,
          scaleY: 1,
          onStart: () => {
            var _a;
            (_a = this.item.dropSqueezeTween) == null ? void 0 : _a.remove();
            this.item.dropSqueezeTween = null;
          }
        });
      }
      this.scene.tweens.add({
        delay,
        duration,
        targets: this.item,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.33],
        x: target.x,
        y: target.y,
        onComplete: () => {
          this.isComplete = true;
        }
      });
    }
    isLastDropDiagonal() {
      let dropPath = this.item.dropPath;
      let lastCell = dropPath[dropPath.length - 1];
      let preLastCell = dropPath[dropPath.length - 2];
      return preLastCell && preLastCell.column !== lastCell.column;
    }
  };

  // src/scenes/gameplay/drop/AutoMatchesHandler.ts
  var AutoMatchesHandler = class extends Phaser.Events.EventEmitter {
    constructor(scene) {
      super();
      this.fixMatchesChance = 0.8;
      this.extraMatchChance = 0.15;
      this.increaseExtraMatchesOnFail = false;
      this.extraMatchScheduled = false;
      this.fixMatchScheduled = false;
      this.scene = scene;
      this.items = this.scene.items;
      this.itemTypes = this.scene.cookieTypesGenerator.getItemTypes();
      this.rnd = new Phaser.Math.RandomDataGenerator(scene.initData.rndSeed);
      this.setChances();
    }
    setChances() {
      if (this.increaseExtraMatchesOnFail) {
        this.doIncreaseExtraMatchesOnFail();
      }
      let fixMatchesChance = UrlParams.getNumber("fixMatches", -1);
      if (fixMatchesChance > -1) {
        this.fixMatchesChance = Phaser.Math.Clamp(fixMatchesChance / 100, 0, 1);
      }
      let extraMatchChance = UrlParams.getNumber("extraMatches", -1);
      if (extraMatchChance > -1) {
        this.extraMatchChance = Phaser.Math.Clamp(extraMatchChance / 100, 0, 1);
      }
    }
    doIncreaseExtraMatchesOnFail() {
      let baseChance = this.extraMatchChance;
      let increment = 0.05;
      let maxChance = 0.3;
      let levelResult = this.scene.game.store.getLevelResult(this.scene.levelNumber);
      if (levelResult) {
        this.extraMatchChance = Math.min(maxChance, baseChance + levelResult.timesFailedNum * increment);
      } else {
        this.extraMatchChance = baseChance;
      }
    }
    process() {
      let tutorial = this.scene.gui.tutorial;
      let preventAutoMatches = tutorial && tutorial.hasMatchTutorial();
      if (preventAutoMatches) {
        this.fixAutoMatches();
        return;
      }
      let addMatches = this.extraMatchScheduled || this.extraMatchChance > this.rnd.frac();
      if (addMatches) {
        this.extraMatchScheduled = true;
        this.addAutoMatches();
      } else {
        let doFix = this.fixMatchScheduled || this.fixMatchesChance > this.rnd.frac();
        if (doFix) {
          this.fixMatchScheduled = true;
          this.fixAutoMatches();
        }
      }
    }
    fixAutoMatches() {
      let matchableItems = this.items.mainItems.filter((item) => item.isMatchable);
      let newItems = this.items.mainItems.filter((item) => item.wasJustCreated && !item.isFromGenerator && !item.isPredefined && isCookie(item));
      let safetyCounter = 10;
      let matches;
      do {
        matches = MatchFinder.findAll(matchableItems, newItems);
        matches.forEach((match) => {
          match.items.some((item) => {
            if (item.wasJustCreated) {
              item.setItemType(this.scene.cookieTypesGenerator.getItem());
              return true;
            }
          });
        });
      } while (matches.length > 0 && --safetyCounter);
      if (matches.length === 0) {
        this.fixMatchScheduled = false;
      }
    }
    addAutoMatches() {
      let matchableItems = this.items.mainItems.filter((item) => item.isMatchable);
      let newItems = this.items.mainItems.filter((item) => item.wasJustCreated && !item.isFromGenerator && !item.isPredefined && isCookie(item));
      let itemsTypes = this.rnd.shuffle(this.itemTypes.slice(0));
      for (let i = 0; i < itemsTypes.length; i++) {
        let itemType = itemsTypes[i];
        let itemsNum = Phaser.Math.Clamp(Math.ceil(newItems.length * 0.5), 1, 4);
        let items = this.rnd.shuffle(newItems.slice(0)).slice(0, itemsNum);
        items.forEach((item) => item.setItemType(itemType));
        let matches = MatchFinder.findAll(matchableItems, newItems);
        let hasPowerups = matches.some((match) => match.result !== null);
        if (hasPowerups) {
          this.extraMatchScheduled = false;
          return;
        }
      }
    }
    getState() {
      return {
        fixMatchesChance: this.fixMatchesChance,
        extraMatchChance: this.extraMatchChance,
        fixMatchScheduled: this.fixMatchScheduled,
        extraMatchScheduled: this.extraMatchScheduled,
        rnd: this.rnd.state()
      };
    }
    setState(state) {
      this.fixMatchesChance = state.fixMatchesChance;
      this.extraMatchChance = state.extraMatchChance;
      this.fixMatchScheduled = state.fixMatchScheduled;
      this.extraMatchScheduled = state.extraMatchScheduled;
      this.rnd.state(state.rnd);
    }
  };

  // src/scenes/gameplay/drop/GeneratorItemsFactory.ts
  var GeneratorItemsFactory = class {
    constructor(scene) {
      this.scene = scene;
      this.factory = scene.itemsFactory;
      this.cookieTypesGenerator = scene.cookieTypesGenerator;
    }
    createItem(generator) {
      let {options} = generator;
      let column = generator.column;
      let row = generator.row + 1;
      switch (options.content) {
        case GeneratorContent.DROP_ITEM:
          return this.factory.createDropItem(column, row, ItemType.DROP_ITEM);
        case GeneratorContent.MARSHMALLOW:
          return this.factory.createMarshmallow(column, row, ItemType.MARSHMALLOW_COMMON);
        case GeneratorContent.CHICK:
          return this.factory.createChick(column, row, ItemType.CHICK);
        case GeneratorContent.RANDOM_COOKIE:
          let cookieType = this.cookieTypesGenerator.getItem();
          let cookiePowerup = GeneratorUtilts.convertContentModToCookiePowerup(options.contentMod, this.scene.rnd);
          return this.factory.createCookie(column, row, cookieType, cookiePowerup);
        case GeneratorContent.PURPLE_COOKIE:
        case GeneratorContent.ORANGE_COOKIE:
        case GeneratorContent.BLUE_COOKIE:
        case GeneratorContent.RED_COOKIE:
        case GeneratorContent.PINK_COOKIE:
        case GeneratorContent.YELLOW_COOKIE:
          return this.createCookie(generator);
        default:
          console.warn("Unknown generator content type!", options.content);
          return null;
      }
    }
    createCookie(generator) {
      let cookieType = GeneratorUtilts.convertContentToCookieType(generator.options.content);
      let cookiePowerup = GeneratorUtilts.convertContentModToCookiePowerup(generator.options.contentMod, this.scene.rnd);
      return this.factory.createCookie(generator.column, generator.row, cookieType, cookiePowerup);
    }
  };

  // src/scenes/gameplay/drop/DropManager.ts
  var EventEmitter4 = Phaser.Events.EventEmitter;
  var DropManagerState;
  (function(DropManagerState2) {
    DropManagerState2["IDLE"] = "IDLE";
    DropManagerState2["DROP_ANIMATION"] = "DROP_ANIMATION";
    DropManagerState2["WAITING_TO_DROP"] = "WAITING_TO_DROP";
    DropManagerState2["CALCULATING_DROP"] = "CALCULATING_DROP";
  })(DropManagerState || (DropManagerState = {}));
  var DropManagerEvent;
  (function(DropManagerEvent2) {
    DropManagerEvent2["DROP_START"] = "__DROP_START";
    DropManagerEvent2["DROP_COMPLETE"] = "__DROP_COMPLETE";
  })(DropManagerEvent || (DropManagerEvent = {}));
  var DropManager = class extends EventEmitter4 {
    constructor(scene) {
      super();
      this.state = DropManagerState.IDLE;
      this.preDropTimer = 0;
      this.preDropLocks = [];
      this.preDropLockCounter = 0;
      this.newItemsCounter = 0;
      this.scene = scene;
      this.field = this.scene.field;
      this.items = this.scene.items;
      this.autoMatches = new AutoMatchesHandler(this.scene);
      this.generatorItemsFactory = new GeneratorItemsFactory(this.scene);
      this.newItemsTypes = this.getNewItemsTypes();
    }
    getNewItemsTypes() {
      let rawValue = this.scene.levelConfig.newItemsTypes;
      if (rawValue === "") {
        return {};
      }
      try {
        return JSON.parse(this.scene.levelConfig.newItemsTypes);
      } catch (error) {
        console.log(error);
      }
      return {};
    }
    lockPreDrop(idPrefix = "") {
      this.preDropLockCounter++;
      let id = idPrefix ? `${idPrefix}__${this.preDropLockCounter}` : this.preDropLockCounter.toString();
      this.preDropLocks.push(id);
      return id;
    }
    unlockPreDrop(id) {
      let index = this.preDropLocks.indexOf(id);
      if (index > -1) {
        this.preDropLocks.splice(index, 1);
      }
    }
    startPreDropTimer(duration = 150) {
      if (this.state === DropManagerState.CALCULATING_DROP || this.state === DropManagerState.DROP_ANIMATION) {
        return;
      }
      this.state = DropManagerState.WAITING_TO_DROP;
      this.preDropTimer = Math.max(this.preDropTimer, duration);
    }
    update(delta) {
      switch (this.state) {
        case DropManagerState.WAITING_TO_DROP:
          this.preDropTimer -= delta;
          if (this.preDropTimer < 0 && this.preDropLocks.length === 0) {
            this.state = DropManagerState.CALCULATING_DROP;
            this.itemsToDrop = this.items.getItemsToDrop().sort(sortBottomUp);
            this.dropIteration = 0;
            this.resetItemsDrop();
          }
          break;
        case DropManagerState.CALCULATING_DROP:
          let timeSpent = 0;
          while (timeSpent < 10) {
            let startTime = performance.now();
            let isCalculationComplete = this.calculateItemsDrop(this.dropIteration++, this.itemsToDrop);
            if (isCalculationComplete) {
              this.state = DropManagerState.DROP_ANIMATION;
              this.autoMatches.process();
              this.itemDroppers = this.createItemDroppers(this.itemsToDrop);
              this.itemsToDrop = null;
              break;
            }
            timeSpent += performance.now() - startTime;
          }
          break;
        case DropManagerState.DROP_ANIMATION:
          this.itemDroppers.forEach((dropper) => dropper.update(delta));
          let isComplete = this.itemDroppers.every((dropper) => dropper.isComplete);
          if (isComplete) {
            this.itemDroppers.length = 0;
            this.completeDrop();
          }
          break;
        default:
          break;
      }
    }
    resetItemsDrop() {
      this.items.mainItems.forEach((item) => {
        if (item.isDroppable === false) {
          return;
        }
        if (!item.dropPath) {
          item.dropPath = [];
        }
        item.appearDelay = 0;
        item.dropPath.length = 0;
        item.dropDelay = 0;
        item.wasJustCreated = false;
        item.isFromGenerator = false;
        item.isPredefined = false;
      });
    }
    calculateItemsDrop(dropIteration = 0, items) {
      let dropScheduled = false;
      items.forEach((item) => {
        let cellBelow = this.field.getCellAt(item.column, item.row + 1);
        if (cellBelow && this.isCellFree(cellBelow)) {
          dropScheduled = true;
          this.dropItemToCell(item, cellBelow);
        }
      });
      let newItems = this.createNewItemsDuringTheDrop();
      if (newItems.length > 0) {
        newItems.forEach((item) => {
          item.appearDelay = dropIteration * 100;
          item.alpha = 0;
          item.wasJustCreated = true;
        });
        items.push(...newItems);
        items = items.sort(sortBottomUp);
        dropScheduled = true;
      }
      items.forEach((item) => {
        let {column, row} = item;
        let dropCell;
        let bottomCell = this.field.getCellAt(column, row + 1);
        if (bottomCell && this.isCellFree(bottomCell)) {
          return;
        }
        let bottomLeftCell = this.field.getCellAt(column - 1, row + 1);
        if (bottomLeftCell && this.isCellFree(bottomLeftCell)) {
          dropCell = bottomLeftCell;
        }
        if (!dropCell) {
          let bottomRightCell = this.field.getCellAt(column + 1, row + 1);
          if (bottomRightCell && this.isCellFree(bottomRightCell)) {
            dropCell = bottomRightCell;
          }
        }
        if (!dropCell) {
          return;
        }
        let dropColumn = dropCell.column;
        let willDrop = items.some((item2) => {
          if (item2.column !== dropColumn || item2.row >= dropCell.row) {
            return false;
          }
          for (let row2 = item2.row + 1; row2 < dropCell.row; row2++) {
            let hasCell = this.field.cells.checkAt(dropColumn, row2);
            let blocked = this.items.topItems.checkAt(dropColumn, row2) || this.items.mainItems.checkAt(dropColumn, row2);
            if (hasCell === false || blocked) {
              return false;
            }
          }
          return true;
        });
        if (willDrop === false) {
          this.dropItemToCell(item, dropCell);
          dropScheduled = true;
        }
      });
      return !dropScheduled;
    }
    createNewItemsDuringTheDrop() {
      let topEmptyCells = this.getTopEmptyCells();
      let topEmptyCellsItems = topEmptyCells.filter((cell) => this.hasGeneratorAbove(cell) === false).map((cell) => this.createNewItemAboveTheCell(cell));
      let generators = this.items.generators.filter(({column, row}) => this.isCellFree({column, row: row + 1}));
      let generatorItems = generators.map((generator) => {
        if (--generator.options.turnsLeft === 0) {
          generator.options.turnsLeft = generator.options.turnsTotal;
          generator.updateTurnsLabel();
          generator.playDropAnimation();
          return this.createItemFromGenerator(generator);
        } else {
          generator.updateTurnsLabel();
          return this.createNewItemAboveTheCell({
            column: generator.column,
            row: generator.row + 1
          });
        }
      });
      return [...topEmptyCellsItems, ...generatorItems];
    }
    hasGeneratorAbove(position) {
      return this.items.generators.checkAt(position.column, position.row - 1);
    }
    isCellFree(position) {
      return this.items.mainItems.checkAt(position.column, position.row) === false;
    }
    dropItemToCell(item, cell) {
      this.items.mainItems.remove(item);
      item.column = cell.column;
      item.row = cell.row;
      this.items.mainItems.add(item);
      item.dropPath.push(cell);
    }
    createNewItemAboveTheCell(position) {
      let startPosition = gridToPixels(position.column, position.row - 1);
      let item = this.createNewItem(position.column, position.row);
      item.x = startPosition.x;
      item.y = startPosition.y;
      item.dropPath = [position];
      return item;
    }
    createItemFromGenerator(generator) {
      let column = generator.column;
      let row = generator.row + 1;
      let startPosition = gridToPixels(column, row - 1);
      let item = this.generatorItemsFactory.createItem(generator);
      item.x = startPosition.x;
      item.y = startPosition.y;
      item.dropPath = [{column, row}];
      item.isFromGenerator = true;
      return item;
    }
    getTopEmptyCells() {
      let {mainItems, topItems} = this.items;
      return this.field.getTopCells().filter((cell) => {
        let {column, row} = cell;
        let hasItem = mainItems.checkAt(column, row);
        let hasCream = topItems.checkAt(column, row);
        let isCellFree = hasItem === false && hasCream === false;
        return isCellFree;
      });
    }
    createNewItem(column, row) {
      this.newItemsCounter++;
      let type = this.newItemsTypes[this.newItemsCounter] ? this.newItemsTypes[this.newItemsCounter] : this.scene.itemTypesGenerator.getItem();
      if (type === ItemType.MYSTERY_BOX) {
        return this.scene.itemsFactory.createMysteryBox(column, row, type, this.scene.mysteryBoxContentGenerator.getMysteryBoxContent());
      } else {
        let newItem = this.scene.itemsFactory.createCookie(column, row, type);
        newItem["newItemId"] = this.newItemsCounter;
        newItem["isPredefined"] = this.newItemsTypes.hasOwnProperty(this.newItemsCounter);
        return newItem;
      }
    }
    createItemDroppers(_itemsToDrop) {
      let itemsToDrop = _itemsToDrop.filter((item) => {
        var _a;
        return ((_a = item.dropPath) == null ? void 0 : _a.length) > 0;
      });
      if (itemsToDrop.length === 0) {
        this.completeDrop();
        return null;
      }
      let deltaDropDelay = 16 / this.scene.fastForward.timeScale;
      let bottomDropRow = maxBy_default(itemsToDrop, "row").row;
      return itemsToDrop.map((item) => {
        var _a;
        (_a = item.budgeTween) == null ? void 0 : _a.remove();
        item.dropDelay = (bottomDropRow - item.row) * deltaDropDelay + item.appearDelay;
        if (item.dropDelay > 0) {
          this.scene.tweens.add({
            delay: item.dropDelay,
            targets: item,
            duration: 100,
            ease: Phaser.Math.Easing.Cubic.Out,
            alpha: 1
          });
        } else {
          item.alpha = 1;
        }
        if (!item.dropSqueezeDisabled) {
          item.dropSqueezeTween = this.scene.tweens.add({
            delay: item.dropDelay,
            targets: item,
            duration: 200,
            ease: Phaser.Math.Easing.Linear,
            scaleX: 0.75,
            scaleY: 1.2
          });
        }
        return new ItemDropper(this.scene, item);
      });
    }
    completeDrop() {
      this.state = DropManagerState.IDLE;
      this.emit(DropManagerEvent.DROP_COMPLETE, this);
    }
    destroy() {
      super.destroy();
      this.itemsToDrop = null;
      this.itemDroppers = null;
    }
  };

  // src/scenes/gameplay/ItemsShuffler.ts
  var import_types2 = __toModule(require("@sentry/types"));
  var ItemsShufflerEvent;
  (function(ItemsShufflerEvent2) {
    ItemsShufflerEvent2["SHUFFLE_START"] = "ItemsShuffler_SHUFFLE_START";
    ItemsShufflerEvent2["SHUFFLE_COMPLETE"] = "ItemsShuffler_SHUFFLE_COMPLETE";
  })(ItemsShufflerEvent || (ItemsShufflerEvent = {}));
  var ItemsShuffler = class extends Phaser.Events.EventEmitter {
    constructor(scene) {
      super();
      this.shufflesInRow = 0;
      this.scene = scene;
    }
    shuffleItems(itemsManager, cookieTypesGenerator) {
      if (++this.shufflesInRow === 5) {
        this.sendTooManyShufflesEventToSentry();
      }
      let cookies = this.getCookiesToShuffle(itemsManager);
      let targetPositions = this.getGridAlignedPositions(cookies);
      let start = performance.now();
      let timeBudget = 33;
      let timePassed = 0;
      let isDeadlock = false;
      do {
        this.scene.rnd.shuffle(targetPositions);
        cookies.forEach((item) => {
          itemsManager.mainItems.remove(item);
        });
        cookies.forEach((item, index) => {
          let newPosition = targetPositions[index];
          let {column, row} = pixelsToGrid(newPosition);
          item.column = column;
          item.row = row;
          itemsManager.mainItems.add(item);
        });
        timePassed = performance.now() - start;
        isDeadlock = MatchHinter.isDeadlock(itemsManager);
      } while (isDeadlock && timePassed < timeBudget);
      let targetTypes = isDeadlock ? this.getCookieTypesToPreventDeadlock(cookies, itemsManager, cookieTypesGenerator) : cookies.map((cookie) => cookie.itemType);
      this.playShuffleAnimation(cookies, targetPositions, targetTypes);
    }
    sendTooManyShufflesEventToSentry() {
      return __async(this, null, function* () {
        var _a;
        (_a = this.scene.sentry) == null ? void 0 : _a.captureMessage("Too many shuffles", {
          level: import_types2.Severity.Warning,
          extra: {
            level: this.scene.levelNumber,
            snapshot: yield this.scene.sentry.getGameSnapshotAsBlob(),
            json: JSON.stringify(this.scene.session, null, 4),
            fps: this.scene.game.fpsTracker.getMedianFps()
          }
        });
      });
    }
    getCookiesToShuffle(itemsManager) {
      return itemsManager.mainItems.filter((item) => {
        return isCookie(item) && item.hasPowerup() === false && itemsManager.topItems.checkAt(item.column, item.row) === false;
      });
    }
    getGridAlignedPositions(items) {
      return items.map((item) => {
        return gridToPixels(item.column, item.row);
      });
    }
    playShuffleAnimation(cookies, targetPositions, targetTypes) {
      let completeCallback = once_default(() => {
        this.emit(ItemsShufflerEvent.SHUFFLE_COMPLETE);
      });
      cookies.forEach((cookie, index) => {
        let targetPosition = targetPositions[index];
        let targetType = targetTypes[index];
        let updateCallback = targetType === cookie.itemType ? noop_default : once_default((cookie2, targetType2) => this.updateCookieType(cookie2, targetType2));
        this.scene.tweens.add({
          targets: cookie,
          duration: 1e3,
          ease: Phaser.Math.Easing.Back.InOut,
          easeParams: [1.2],
          x: targetPosition.x,
          y: targetPosition.y,
          onComplete: completeCallback,
          onUpdate: (tween) => {
            if (tween.progress > 0.5) {
              updateCallback(cookie, targetType);
            }
          }
        });
      });
    }
    getCookieTypesToPreventDeadlock(cookies, itemsManager, cookieTypesGenerator) {
      let originalTypes = cookies.map((cookie) => cookie.itemType);
      let newTypes = [];
      let cookieTypes = cookieTypesGenerator.getItemTypes();
      let safetyCounter = 100;
      while (MatchHinter.isDeadlock(itemsManager) && --safetyCounter > 0) {
        cookies.forEach((cookie, index) => {
          let types = without_default(cookieTypes, cookie.itemType);
          let newType = this.scene.rnd.pick(types);
          cookie.itemType = newType;
          newTypes[index] = newType;
        });
      }
      cookies.forEach((cookie, index) => {
        cookie.itemType = originalTypes[index];
      });
      return newTypes;
    }
    updateCookieType(cookie, targetType) {
      this.scene.tweens.add({
        targets: cookie,
        duration: 100,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 0.33,
        alpah: 0,
        yoyo: true,
        onYoyo: () => {
          cookie.setItemType(targetType);
        }
      });
    }
    resetShufflesInRow() {
      this.shufflesInRow = 0;
    }
  };

  // src/scenes/gameplay/GameplayCamera.ts
  var GameplayCamera = class {
    constructor(scene) {
      this.scene = scene;
      this.camera = this.scene.cameras.main;
    }
    resize() {
      let maxWidth = Config.GAME_WIDTH * 0.9;
      let maxHeight = this.getMaxHeight();
      let zoomX = maxWidth / this.getWidth();
      let zoomY = maxHeight / this.getHeight();
      let zoom = Math.min(zoomX, zoomY);
      let viewportX = this.getViewportX() * zoom;
      let viewportY = this.getViewportY() * zoom + this.getTopOffset();
      this.camera.setViewport(viewportX, viewportY, Config.GAME_WIDTH, Config.GAME_HEIGHT);
      this.camera.setZoom(zoom);
      this.camera.originalZoom = this.camera.zoom;
      this.camera.scrollX = -(Config.GAME_WIDTH - this.getWidth()) / 2;
      this.camera.scrollY = -(Config.GAME_HEIGHT - this.getHeight()) / 2;
    }
    getTopOffset() {
      return 20 * Config.ASSETS_SCALE;
    }
    getMaxHeight() {
      let verticalPadding = 180 * Config.ASSETS_SCALE;
      return Config.GAME_HEIGHT - verticalPadding * 2;
    }
    get zoom() {
      return this.camera.zoom;
    }
    get displayWidth() {
      return this.camera.displayWidth;
    }
    get displayHeight() {
      return this.camera.displayHeight;
    }
    getWidth() {
      return this.scene.field.width;
    }
    getHeight() {
      return this.scene.field.height;
    }
    getPadding() {
      let x = (Config.GAME_WIDTH - this.getWidth() * this.camera.zoom) / 2;
      let y = (Config.GAME_HEIGHT - this.getHeight() * this.camera.zoom) / 2;
      return {x, y};
    }
    getViewportX() {
      let maxWidth = 9;
      let dimensions = this.scene.gridDimensions;
      let deltaWidth = maxWidth - dimensions.width;
      let leftOffset = dimensions.left;
      return (deltaWidth / 2 - leftOffset) * CELL_SIZE;
    }
    getViewportY() {
      let maxHeight = 10;
      let dimensions = this.scene.gridDimensions;
      let deltaHeight = maxHeight - dimensions.height;
      let topOffset = dimensions.top;
      return (deltaHeight / 2 - topOffset) * CELL_SIZE;
    }
    getWorldPosition(position) {
      return this.getWorldPositionXY(position.x, position.y);
    }
    getWorldPositionXY(originalX, originalY) {
      let camera = this.camera;
      let padding = this.getPadding();
      let zoom = camera.zoom;
      let x = camera.x + padding.x + originalX * zoom;
      let y = camera.y + padding.y + originalY * zoom;
      return {x, y};
    }
    playZoomTween(targetZoom, duration = 233) {
      this.camera.zoom = this.camera.originalZoom;
      this.scene.tweens.killTweensByProperty(this.camera, "zoom");
      this.scene.tweens.add({
        targets: this.camera,
        duration,
        ease: Phaser.Math.Easing.Sine.InOut,
        zoom: targetZoom,
        yoyo: true
      });
    }
  };

  // src/scenes/gameplay/undo/UndoHandler.ts
  var EventEmitter5 = Phaser.Events.EventEmitter;
  var UndoHandlerEvent;
  (function(UndoHandlerEvent2) {
    UndoHandlerEvent2["SAVE"] = "UndoHandler_SAVE";
    UndoHandlerEvent2["RESTORE"] = "UndoHandler_RESTORE";
  })(UndoHandlerEvent || (UndoHandlerEvent = {}));
  var UndoHandler = class extends EventEmitter5 {
    constructor(scene) {
      super();
      this.savedStatesMax = 10;
      this.scene = scene;
      this.savedStates = [];
    }
    save() {
      let newSavedState = {
        items: this.scene.items.save(),
        goals: this.scene.goals.save(),
        moves: this.scene.moves,
        autoMatches: this.scene.itemsDropper.autoMatches.getState(),
        itemTypesGenerator: this.scene.itemTypesGenerator.getState(),
        cookiesTypesGenerator: this.scene.cookieTypesGenerator.getState(),
        mysteryBoxesGenerator: this.scene.mysteryBoxContentGenerator.getState(),
        powerupChef: this.scene.gui.powerupChef.save(),
        boosters: this.scene.game.boosters.save(),
        gameplayRnd: this.scene.rnd.state(),
        rnd: Phaser.Math.RND.state()
      };
      this.savedStates.push(newSavedState);
      if (this.savedStates.length > this.savedStatesMax) {
        this.savedStates.shift();
      }
      this.emit(UndoHandlerEvent.SAVE, this, newSavedState);
    }
    canRestore() {
      return this.savedStates.length > 0;
    }
    restore() {
      let savedState = this.savedStates.pop();
      if (!savedState) {
        return;
      }
      this.scene.items.restore(this.scene.itemsFactory, savedState.items);
      this.scene.goals.restore(savedState.goals);
      this.scene.moves = savedState.moves;
      this.scene.itemsDropper.autoMatches.setState(savedState.autoMatches);
      this.scene.itemTypesGenerator.setState(savedState.itemTypesGenerator);
      this.scene.cookieTypesGenerator.setState(savedState.cookiesTypesGenerator);
      this.scene.mysteryBoxContentGenerator.setState(savedState.mysteryBoxesGenerator);
      this.scene.gui.powerupChef.restore(savedState.powerupChef);
      this.scene.game.boosters.restore(savedState.boosters);
      this.scene.rnd.state(savedState.gameplayRnd);
      Phaser.Math.RND.state(savedState.rnd);
      this.emit(UndoHandlerEvent.RESTORE, this, savedState);
    }
    removeLastSavedState() {
      if (this.savedStates.length > 0) {
        this.savedStates.pop();
      }
    }
    adjustMovesAfterSecondChance(movesNum) {
      this.savedStates.forEach((state, index) => {
        if (index >= this.savedStates.length - movesNum) {
          state.moves += movesNum;
        }
      });
    }
  };

  // src/scenes/gameplay/DoubleSpheresFx.ts
  var DoubleSpheresFxEvent;
  (function(DoubleSpheresFxEvent2) {
    DoubleSpheresFxEvent2["COMPLETE"] = "DoubleSpheresFx_COMPLETE";
  })(DoubleSpheresFxEvent || (DoubleSpheresFxEvent = {}));
  var DoubleSpheresFx = class extends Phaser.Events.EventEmitter {
    constructor(scene, sphere_1, sphere_2) {
      super();
      this.scene = scene;
      this.sphere_1 = sphere_1;
      this.sphere_2 = sphere_2;
      this.addWhiteSphere();
      this.addParticles();
    }
    addWhiteSphere() {
      this.whiteSphere = this.scene.add.image(0, 0, "gameplay", "cookies/super_sphere_x2_white");
      this.whiteSphere.setDepth(GameplayDepth.POWERUP_FX);
      this.whiteSphere.kill();
    }
    addParticles() {
      this.particleManager = this.scene.add.particles("gameplay");
      this.particleManager.setPosition(this.sphere_1.x, this.sphere_1.y);
      this.particleManager.setDepth(GameplayDepth.POWERUP_FX);
      this.gravityWell = this.particleManager.createGravityWell({
        power: 10,
        epsilon: 250,
        gravity: 200
      });
      let emitCircle = new Phaser.Geom.Circle(0, 0, this.sphere_1.displayWidth * 2);
      this.attractEmitter = this.particleManager.createEmitter({
        frame: "double_spheres_particle",
        lifespan: 800,
        alpha: {start: 0, end: 1, ease: Ease.ExpoOut},
        scale: {start: 1.33, end: 0.33},
        quantity: 2,
        on: false
      }).setDeathZone({
        source: new Phaser.Geom.Circle(0, 0, emitCircle.radius * 0.25),
        type: "onEnter"
      }).setEmitZone({
        source: emitCircle,
        type: "random"
      });
    }
    start() {
      this.mergeSpheresIntoOneBigSphere().then(() => this.shrinkBigSphere()).then(() => {
        this.sphere_1.kill();
        this.sphere_1.resetFrame();
        this.whiteSphere.kill();
        this.scene.emitters.doubleSpheresExplosion.explode(100, this.sphere_1.x, this.sphere_1.y);
        this.disableAttractEmitter();
        this.emit(DoubleSpheresFxEvent.COMPLETE, this.sphere_1);
        this.destroy();
        this.scene.camera.camera.shakeEffect.start(400, 0.015, true);
        this.scene.camera.playZoomTween(0.85, 400);
        this.scene.audio.play(GameSoundKey.DOUBLE_SPHERES_EXPLODE);
      });
    }
    mergeSpheresIntoOneBigSphere() {
      let p1 = {x: this.sphere_1.x, y: this.sphere_1.y};
      let p2 = {x: this.sphere_2.x, y: this.sphere_2.y};
      let mergePosition = Phaser.Geom.Point.Interpolate(p1, p2, 0.5);
      let spheres = [this.sphere_1, this.sphere_2];
      let tweens = spheres.map((sphere) => {
        sphere.setDepth(GameplayDepth.MERGING_COOKIE);
        sphere.stopIdleTweens();
        sphere.sparksEmitter.on = false;
        sphere.sparksEmitter.killAll();
        return this.scene.tweens.add({
          targets: sphere,
          duration: 300,
          ease: Phaser.Math.Easing.Back.In,
          x: mergePosition.x,
          y: mergePosition.y,
          onComplete: () => {
            this.scene.camera.camera.shake(200, 0.01);
          }
        });
      });
      return new Promise((resolve, reject) => {
        tweens[0].once(Phaser.Tweens.Events.TWEEN_COMPLETE, () => {
          this.sphere_2.kill();
          this.sphere_1.setFrame("cookies/super_sphere_x2");
          this.sphere_1.scale = 0.5;
          this.scene.emitters.doubleSpheresMergeCircles.explode(1, this.sphere_1.x, this.sphere_1.y);
          this.scene.emitters.doubleSpheresMergeParticles.setPosition(this.sphere_1.x, this.sphere_1.y);
          this.scene.emitters.doubleSpheresMergeParticles.explode(12, this.sphere_1.x, this.sphere_1.y);
          this.scene.tweens.add({
            targets: this.sphere_1,
            duration: 233,
            ease: Phaser.Math.Easing.Sine.InOut,
            angle: 10,
            yoyo: true
          });
          this.scene.tweens.add({
            targets: this.sphere_1,
            duration: 400,
            ease: Phaser.Math.Easing.Back.Out,
            scale: 1,
            onComplete: () => {
              resolve();
            }
          });
        });
      });
    }
    shrinkBigSphere() {
      var _a;
      this.particleManager.setPosition(this.sphere_1.x, this.sphere_1.y);
      this.attractEmitter.on = true;
      this.whiteSphere.revive();
      this.whiteSphere.scale = this.sphere_1.scale * 2;
      this.whiteSphere.x = this.sphere_1.x;
      this.whiteSphere.y = this.sphere_1.y;
      this.whiteSphere.alpha = 0;
      let duration = 1333;
      this.scene.tweens.add({
        targets: this.whiteSphere,
        duration,
        ease: Phaser.Math.Easing.Cubic.In,
        alpha: 1
      });
      this.scene.tweens.add({
        targets: this.sphere_1,
        duration,
        ease: Phaser.Math.Easing.Expo.In,
        alpha: 0
      });
      let shakeTween = this.scene.tweens.add({
        targets: [this.sphere_1, this.whiteSphere],
        duration: 44,
        ease: Phaser.Math.Easing.Sine.InOut,
        x: "-=6",
        repeat: -1,
        yoyo: true
      });
      this.scene.camera.camera.shakeEffect.start(duration, 66e-4, true);
      (_a = this.scene.audio.play(GameSoundKey.DOUBLE_SPHERES_CHARGE)) == null ? void 0 : _a.fade(0, 1, duration * 0.5);
      return new Promise((resolve) => {
        this.scene.tweens.add({
          targets: this.sphere_1,
          duration,
          ease: Phaser.Math.Easing.Linear,
          scale: this.sphere_1.scale * 0.4,
          onUpdate: () => {
            this.whiteSphere.scale = this.sphere_1.scale * 2;
          }
        }).once(Phaser.Tweens.Events.TIMELINE_COMPLETE, () => {
          shakeTween.remove();
          resolve();
        });
      });
    }
    disableAttractEmitter() {
      this.gravityWell.active = false;
      this.attractEmitter.active = false;
      this.attractEmitter.on = false;
      this.attractEmitter.killAll();
    }
    destroy() {
      super.destroy();
      this.particleManager.destroy();
      this.whiteSphere.destroy();
      this.sphere_1.kill();
      this.sphere_2.kill();
    }
  };

  // src/scenes/gameplay/CookiesSpecialComboHandler.ts
  var CookiesSpecialComboHandler = class extends Phaser.Events.EventEmitter {
    constructor(scene, items) {
      super();
      this.scene = scene;
      this.items = items;
    }
    processSpecialCombo(cookie_1, cookie_2, combo) {
      switch (combo) {
        case CookiesSpecialCombo.SUPER_SPHERE_x2:
          this.processDoubleSuperSpheres(cookie_1, cookie_2);
          break;
        case CookiesSpecialCombo.SUPER_SPHERE_BOMB:
          this.processSuperSphereBomb(cookie_1, cookie_2);
          break;
        case CookiesSpecialCombo.SUPER_SPHERE_STRIPED:
          this.processSuperSphereStripes(cookie_1, cookie_2);
          break;
        case CookiesSpecialCombo.SUPER_SPHERE:
          this.processSingleSuperSphere(cookie_1, cookie_2);
          break;
        case CookiesSpecialCombo.BOMB_x2:
          this.processDoubleBombs(cookie_1, cookie_2);
          break;
        case CookiesSpecialCombo.BOMB_STRIPED:
          this.processBombStripes(cookie_1, cookie_2);
          break;
        case CookiesSpecialCombo.STRIPED_x2:
          this.processDoubleStripes(cookie_1, cookie_2);
          break;
        default:
          console.warn("There is no handler for this special combo!", combo);
          break;
      }
    }
    processDoubleSuperSpheres(sphere_1, sphere_2) {
      let fx = new DoubleSpheresFx(this.scene, sphere_1, sphere_2);
      fx.once(DoubleSpheresFxEvent.COMPLETE, (sphere) => {
        this.onSpecialComboMergeComplete(sphere_1, sphere_2);
        this.onDoubleSpheresFxComplete(sphere);
      });
      fx.start();
    }
    onDoubleSpheresFxComplete(sphere) {
      let radius = this.scene.getMaxExplosionRadius(sphere);
      this.scene.powerupsHandler.applyBomb(sphere.column, sphere.row, radius, sphere.itemType);
      this.scene.powerupsHandler.showBombFxAt(sphere.x, sphere.y, 7);
      this.scene.camera.camera.shake(400, 0.02, true);
    }
    processSuperSphereBomb(cookie_1, cookie_2) {
      let {superSphere, cookie: bomb} = this.sortCookies(cookie_1, cookie_2);
      let dropLockId = this.scene.itemsDropper.lockPreDrop();
      this.mergeCookies(superSphere, bomb, () => {
        this.showSuperSphereMergeFx(superSphere);
        this.onSpecialComboMergeComplete(superSphere, bomb);
        this.onSuperSphereBombMergeComplete(superSphere, bomb, dropLockId);
      });
    }
    onSuperSphereBombMergeComplete(superSphere, bomb, dropLockId) {
      let affectedCookies = this.items.mainItems.filter((item) => item.itemType === bomb.itemType).filter((cookie) => cookie.powerup !== CookiePowerup.SUPER_SPHERE);
      let shakeCameraOnce = once_default(() => {
        this.scene.camera.camera.shake(400, 0.02, true);
      });
      if (affectedCookies.length > 0) {
        this.scene.sounds.superSphere();
      } else {
        this.scene.itemsDropper.unlockPreDrop(dropLockId);
        this.scene.itemsDropper.startPreDropTimer();
      }
      affectedCookies.forEach((cookie) => {
        this.scene.powerupsHandler.sendSuperSphereCharge(superSphere, cookie, () => {
          if (cookie.hasPowerup() === false) {
            this.scene.removeItemFromGrid(cookie);
            cookie.kill();
            cookie = this.scene.itemsFactory.createCookie(cookie.column, cookie.row, cookie.itemType, CookiePowerup.BOMB);
            cookie.sendPowerupToChef = false;
          }
          this.scene.removeItemFromGrid(cookie);
          let shakeTween = this.scene.tweens.add({
            targets: cookie,
            duration: 66,
            ease: Phaser.Math.Easing.Sine.InOut,
            angle: 8 * Phaser.Math.RND.sign(),
            yoyo: true,
            repeat: -1
          });
          this.scene.tweens.add({
            targets: cookie,
            duration: 800,
            ease: Phaser.Math.Easing.Elastic.Out,
            easeParams: [0.1, 0.4],
            scale: 1.2,
            onComplete: () => {
              shakeTween.remove();
              shakeCameraOnce();
              cookie.kill();
              this.scene.onCookieRemove(cookie);
              this.scene.itemsDropper.unlockPreDrop(dropLockId);
              this.scene.itemsDropper.startPreDropTimer();
            }
          });
        });
      });
    }
    processSuperSphereStripes(cookie_1, cookie_2) {
      let {superSphere, cookie: striped} = this.sortCookies(cookie_1, cookie_2);
      let dropLockId = this.scene.itemsDropper.lockPreDrop();
      this.mergeCookies(superSphere, striped, () => {
        this.showSuperSphereMergeFx(superSphere);
        this.onSpecialComboMergeComplete(superSphere, striped);
        this.onSuperSphereStripesMergeComplete(superSphere, striped, dropLockId);
      });
    }
    sortCookies(cookie_1, cookie_2) {
      let superSphere;
      let otherCookie;
      if (cookie_1.powerup === CookiePowerup.SUPER_SPHERE) {
        superSphere = cookie_1;
        otherCookie = cookie_2;
      } else {
        superSphere = cookie_2;
        otherCookie = cookie_1;
      }
      return {superSphere, cookie: otherCookie};
    }
    onSuperSphereStripesMergeComplete(superSphere, striped, dropLockId) {
      let getRandomStripes = () => {
        return this.scene.rnd.bool() ? CookiePowerup.VERTICAL_STRIPES : CookiePowerup.HORIZONTAL_STRIPES;
      };
      let affectedCookies = this.items.mainItems.filter((item) => item.itemType === striped.itemType).filter((cookie) => cookie.powerup !== CookiePowerup.SUPER_SPHERE);
      if (affectedCookies.length > 0) {
        this.scene.sounds.superSphere();
      } else {
        this.scene.itemsDropper.unlockPreDrop(dropLockId);
        this.scene.itemsDropper.startPreDropTimer();
      }
      affectedCookies.forEach((cookie) => {
        this.scene.powerupsHandler.sendSuperSphereCharge(superSphere, cookie, () => {
          if (cookie.hasPowerup() === false) {
            this.scene.removeItemFromGrid(cookie);
            cookie.kill();
            cookie = this.scene.itemsFactory.createCookie(cookie.column, cookie.row, cookie.itemType, getRandomStripes());
            cookie.sendPowerupToChef = false;
          }
          this.scene.removeItemFromGrid(cookie);
          this.scene.tweens.add({
            targets: cookie,
            duration: 400,
            ease: Phaser.Math.Easing.Back.Out,
            scale: 1.2,
            onComplete: () => {
              this.scene.tweens.add({
                targets: cookie,
                duration: 300,
                ease: Phaser.Math.Easing.Expo.In,
                scale: 1,
                onComplete: () => {
                  cookie.kill();
                  this.scene.onCookieRemove(cookie);
                  this.scene.itemsDropper.unlockPreDrop(dropLockId);
                  this.scene.itemsDropper.startPreDropTimer();
                }
              });
            }
          });
        });
      });
    }
    processSingleSuperSphere(cookie_1, cookie_2) {
      let {superSphere, cookie: otherCookie} = this.sortCookies(cookie_1, cookie_2);
      superSphere.itemsTypeToClear = otherCookie.itemType;
      this.mergeCookies(superSphere, otherCookie, () => {
        this.showSuperSphereMergeFx(superSphere);
        this.onSpecialComboMergeComplete(superSphere, otherCookie);
        this.scene.powerupsHandler.applySuperSphere(superSphere);
      });
    }
    processDoubleBombs(primaryBomb, secondaryBomb) {
      this.mergeCookies(primaryBomb, secondaryBomb, () => {
        this.onSpecialComboMergeComplete(primaryBomb, secondaryBomb);
        let radius = 2;
        this.scene.powerupsHandler.applyBomb(primaryBomb.column, primaryBomb.row, radius, primaryBomb.itemType);
        this.scene.powerupsHandler.showBombFx(primaryBomb.column, primaryBomb.row, radius);
        this.scene.powerupsHandler.budger.budgeItemsAround(primaryBomb.column, primaryBomb.row, radius + 1.8);
        this.scene.camera.camera.shake(400, 0.016, true);
      });
    }
    processBombStripes(bomb, striped) {
      this.mergeCookies(bomb, striped, () => {
        this.onSpecialComboMergeComplete(bomb, striped);
        let {column: centralColumn, row: centralRow, itemType} = bomb;
        this.scene.powerupsHandler.applyCross(centralColumn, centralRow, itemType, 3);
        this.scene.sounds.bomb();
      });
    }
    processDoubleStripes(primaryCookie, secondaryCookie) {
      this.mergeCookies(primaryCookie, secondaryCookie, () => {
        this.onSpecialComboMergeComplete(primaryCookie, secondaryCookie);
        this.scene.powerupsHandler.applyCross(primaryCookie.column, primaryCookie.row, primaryCookie.itemType, 1);
      });
    }
    mergeCookies(primaryCookie, secondaryCookie, onComplete) {
      secondaryCookie.setDepth(GameplayDepth.MERGING_COOKIE);
      let duration = 266;
      this.scene.tweens.add({
        targets: secondaryCookie,
        duration,
        ease: Phaser.Math.Easing.Back.In,
        scale: 0.5
      });
      let scaleTweenDuration = duration * 0.75;
      this.scene.tweens.add({
        targets: primaryCookie,
        delay: duration - scaleTweenDuration,
        duration: scaleTweenDuration,
        ease: Phaser.Math.Easing.Back.In,
        scale: 1.66
      });
      let alphaTweenDuration = duration * 0.5;
      this.scene.tweens.add({
        targets: [primaryCookie, secondaryCookie],
        delay: duration - alphaTweenDuration,
        duration: alphaTweenDuration,
        ease: Phaser.Math.Easing.Expo.In,
        alpha: 0
      });
      this.scene.tweens.add({
        targets: [primaryCookie, secondaryCookie],
        duration,
        ease: Phaser.Math.Easing.Back.In,
        easeParams: [1.6],
        x: primaryCookie.x,
        y: primaryCookie.y,
        onComplete: () => {
          secondaryCookie.scale = 1;
          secondaryCookie.kill();
          primaryCookie.kill();
          onComplete(primaryCookie, secondaryCookie);
        }
      });
    }
    showSuperSphereMergeFx(superSphere) {
      this.scene.emitters.doubleSpheresMergeCircles.explode(1, superSphere.x, superSphere.y);
      this.scene.emitters.doubleSpheresMergeParticles.setPosition(superSphere.x, superSphere.y);
      this.scene.emitters.doubleSpheresMergeParticles.explode(12, superSphere.x, superSphere.y);
    }
    onSpecialComboMergeComplete(cookie_1, cookie_2) {
      cookie_1.wasPoweruped = true;
      this.scene.onCookieRemove(cookie_1, false);
      cookie_2.wasPoweruped = true;
      this.scene.onCookieRemove(cookie_2, false);
    }
  };

  // src/scenes/gameplay/ItemsBudger.ts
  var ItemsBudger = class extends Phaser.Events.EventEmitter {
    constructor(scene, itemsManager) {
      super();
      this.scene = scene;
      this.items = itemsManager;
    }
    budgeItemsInColumn(centralColumn, centralRow) {
      this.items.mainItems.forEach((item) => {
        if (this.isBudgeable(item) === false) {
          return;
        }
        if (item.column !== centralColumn - 1 && item.column !== centralColumn + 1) {
          return;
        }
        if (item.budgeTween) {
          return;
        }
        let distance = gridDistanceXY(centralColumn, centralRow, item.column, item.row);
        let delay = distance * 50;
        let dySign = item.row > centralRow ? 1 : -1;
        let dy = dySign * 20;
        this.playBudgeTween(item, delay, {y: dy});
      });
    }
    budgeItemsInRow(centralColumn, centralRow) {
      this.items.mainItems.forEach((item) => {
        if (this.isBudgeable(item) === false) {
          return;
        }
        if (item.row !== centralRow - 1 && item.row !== centralRow + 1) {
          return;
        }
        if (item.budgeTween) {
          return;
        }
        let distance = gridDistanceXY(centralColumn, centralRow, item.column, item.row);
        let delay = distance * 50;
        let dxSign = item.column > centralColumn ? 1 : -1;
        let dx = dxSign * 20;
        this.playBudgeTween(item, delay, {x: dx});
      });
    }
    budgeItemsAround(column, row, radius) {
      this.items.mainItems.forEach((item) => {
        if (this.isBudgeable(item) === false) {
          return;
        }
        let distance = gridDistanceXY(column, row, item.column, item.row);
        if (distance > radius) {
          return;
        }
        if (item.budgeTween) {
          return;
        }
        let delay = distance * 66;
        let angle = Phaser.Math.Angle.Between(column, row, item.column, item.row);
        let budgeDistance = 24;
        let dx = Math.cos(angle) * budgeDistance;
        let dy = Math.sin(angle) * budgeDistance;
        this.playBudgeTween(item, delay, {x: dx, y: dy});
      });
    }
    playBudgeTween(item, delay, budgeAmount) {
      let tweenData = {};
      if (budgeAmount.x) {
        tweenData.x = item.x + budgeAmount.x;
      }
      if (budgeAmount.y) {
        tweenData.y = item.y + budgeAmount.y;
      }
      item.budgeTween = this.scene.tweens.add(__spreadProps(__spreadValues({
        delay
      }, tweenData), {
        targets: item,
        duration: 200,
        ease: Phaser.Math.Easing.Sine.InOut,
        yoyo: true,
        onComplete: () => {
          this.onBudgeTweenComplete(item);
        }
      }));
    }
    onBudgeTweenComplete(item) {
      item.budgeTween = null;
      let position = gridToPixels(item.column, item.row);
      let distance = Phaser.Math.Distance.Between(position.x, position.y, item.x, item.y);
      if (distance > 2) {
        this.scene.tweens.add({
          targets: item,
          duration: 100,
          ease: Phaser.Math.Easing.Linear,
          x: position.x,
          y: position.y
        });
      }
    }
    isBudgeable(item) {
      return item.itemSuperType === ItemSuperType.MARSHMALLOW || item.itemSuperType === ItemSuperType.COOKIE || item.itemSuperType === ItemSuperType.DROP_ITEM || item.itemSuperType === ItemSuperType.CHICK;
    }
  };

  // src/scenes/gameplay/CookiesPowerupsHandler.ts
  var CookiesPowerupsHandler = class {
    constructor(scene) {
      this.powerupIdCounter = 0;
      this.scene = scene;
      this.items = scene.items;
      this.itemsDropper = scene.itemsDropper;
      this.budger = new ItemsBudger(this.scene, this.items);
      this.itemSuperTypesAffectedByStripes = this.getSuperTypesAffectedByStripes();
      this.itemSuperTypesAffectedByBomb = this.getSuperTypesAffectedByBombs();
      this.addSuperSphereChargesPool();
      console.assert(!!this.items, "");
      console.assert(!!this.itemsDropper, "");
    }
    getSuperTypesAffectedByStripes() {
      return [
        ItemSuperType.COOKIE,
        ItemSuperType.MARSHMALLOW,
        ItemSuperType.CHOCOLATE,
        ItemSuperType.CANDY_BOTTLE,
        ItemSuperType.DONUT_BOX,
        ItemSuperType.APPLE_PLATTER,
        ItemSuperType.MYSTERY_BOX,
        ItemSuperType.CHICK,
        ItemSuperType.GUMMY_BLOCKER
      ];
    }
    getSuperTypesAffectedByBombs() {
      return [
        ItemSuperType.COOKIE,
        ItemSuperType.MARSHMALLOW,
        ItemSuperType.CHOCOLATE,
        ItemSuperType.CANDY_BOTTLE,
        ItemSuperType.DONUT_BOX,
        ItemSuperType.MYSTERY_BOX,
        ItemSuperType.CHICK,
        ItemSuperType.GUMMY_BLOCKER
      ];
    }
    addSuperSphereChargesPool() {
      let config2 = {
        classType: Phaser.GameObjects.Image,
        defaultKey: "gameplay",
        defaultFrame: "cracker_hit_particle",
        createCallback: (item) => {
          item.scale = 2;
          item.setDepth(GameplayDepth.POWERUP_FX);
          item.kill();
        }
      };
      this.superSphereCharges = this.scene.add.group(config2);
      this.superSphereCharges.createItems(15);
    }
    createPowerupId(powerupType) {
      return `${powerupType}_${this.powerupIdCounter++}`;
    }
    processCookiePowerup(cookie) {
      if (cookie.powerup && cookie.sendPowerupToChef) {
        this.scene.gui.powerupChef.sendChargeToChef(cookie);
      }
      switch (cookie.powerup) {
        case CookiePowerup.HORIZONTAL_STRIPES:
          this.applyHorizontalStripes(cookie.column, cookie.row, cookie.itemType, this.createPowerupId("horiz_stripes"));
          break;
        case CookiePowerup.VERTICAL_STRIPES:
          this.applyVerticalStripes(cookie.column, cookie.row, cookie.itemType, this.createPowerupId("vert_stripes"));
          break;
        case CookiePowerup.BOMB:
          let radius = 1;
          this.applyBomb(cookie.column, cookie.row, radius, cookie.itemType);
          this.showBombFx(cookie.column, cookie.row, radius);
          this.budger.budgeItemsAround(cookie.column, cookie.row, radius + 1.8);
          break;
        case CookiePowerup.SUPER_SPHERE:
          this.applySuperSphere(cookie);
          break;
        default:
          break;
      }
    }
    applyHorizontalStripes(column, row, itemType, powerupId) {
      let itemSuperTypes = this.itemSuperTypesAffectedByStripes;
      let middleItems = this.items.mainItems.getItemsByRow(row).filter((item) => itemSuperTypes.includes(item.itemSuperType) && this.items.hasLicoriceOver(item) === false);
      let topItems = this.items.topItems.filter((item) => item.row === row);
      let allItems = [...middleItems, ...topItems];
      this.budger.budgeItemsInRow(column, row);
      this.applyStripes(allItems, column, row, itemType, powerupId);
      this.showStripesFx(column, row, "horizontal");
      this.scene.sounds.stripes();
    }
    applyVerticalStripes(column, row, itemType, powerupId) {
      let itemSuperTypes = this.itemSuperTypesAffectedByStripes;
      let middleItems = this.items.mainItems.getItemsByColumn(column).filter((item) => itemSuperTypes.includes(item.itemSuperType) && this.items.hasLicoriceOver(item) === false);
      let topItems = this.items.topItems.filter((item) => item.column === column);
      let allItems = [...middleItems, ...topItems];
      this.budger.budgeItemsInColumn(column, row);
      this.applyStripes(allItems, column, row, itemType, powerupId);
      this.showStripesFx(column, row, "vertical");
      this.scene.sounds.stripes();
    }
    showStripesFx(column, row, type) {
      let position = gridToPixels(column, row);
      let emitters = this.scene.emitters;
      let stripe = type === "horizontal" ? emitters.horizontalStripesFx : emitters.verticalStripesFx;
      stripe.explode(1, position.x, position.y);
      emitters.stripesParticles.setPosition(position.x, position.y);
      emitters.stripesParticles.explode(10, position.x, position.y);
      emitters.stripesFxCircles.explode(1, position.x, position.y);
    }
    applyStripes(allItems, column, row, itemType, powerupId) {
      let dropLockId = this.itemsDropper.lockPreDrop("stripes");
      let unlockDropDelay = 0;
      allItems.forEach((item) => {
        this.preProcessPowerupedItem(item, powerupId);
      });
      allItems.forEach((item) => {
        let distance = gridDistanceXY(column, row, item.column, item.row);
        let delay = distance * 50;
        this.processPowerupedItem(item, itemType, delay, powerupId);
        unlockDropDelay = Math.max(unlockDropDelay, delay);
        if (item.itemSuperType === ItemSuperType.APPLE_PLATTER || item.itemSuperType === ItemSuperType.CANDY_BOTTLE) {
          return;
        }
        if (isSuperSphere(item)) {
          return;
        }
        this.scene.time.delayedCall(delay, () => {
          this.scene.emitters.stripedItemParticles.explode(3, item.x, item.y);
          this.scene.emitters.stripedItemCircles.explode(1, item.x, item.y);
        });
      });
      this.scene.time.delayedCall(unlockDropDelay, () => {
        this.itemsDropper.unlockPreDrop(dropLockId);
      });
    }
    preProcessPowerupedItem(item, powerupId) {
      switch (item.itemSuperType) {
        case ItemSuperType.COOKIE:
          let cookie = item;
          cookie.markAsPoweruped(powerupId);
          this.scene.removeItemFromGrid(cookie);
          break;
        case ItemSuperType.MARSHMALLOW:
          let marshmallow = item;
          if (marshmallow.currentHealth === 1) {
            this.scene.removeItemFromGrid(marshmallow);
          }
          break;
        case ItemSuperType.CHOCOLATE:
          let chocolate = item;
          if (chocolate.currentHealth === 1) {
            this.scene.removeItemFromGrid(chocolate);
          }
          break;
        case ItemSuperType.APPLE_PLATTER:
          let applePlatter = item;
          if (applePlatter.getApplesNum() === 1) {
            this.scene.removeItemFromGrid(applePlatter);
          }
          break;
        case ItemSuperType.LICORICE:
          this.scene.removeItemFromGrid(item);
          break;
        case ItemSuperType.MYSTERY_BOX:
          this.scene.removeItemFromGrid(item);
          break;
        case ItemSuperType.CHICK:
          this.scene.removeItemFromGrid(item);
          break;
        case ItemSuperType.GUMMY_BLOCKER:
          this.scene.removeItemFromGrid(item);
          break;
        default:
          break;
      }
    }
    processPowerupedItem(item, itemType, delay, powerupId) {
      switch (item.itemSuperType) {
        case ItemSuperType.COOKIE:
          this.processPowerupedCookie(item, delay, itemType);
          break;
        case ItemSuperType.LICORICE:
          this.scene.time.delayedCall(delay, () => {
            this.scene.destroyLicorice(item);
          });
          break;
        case ItemSuperType.MARSHMALLOW:
          let mashmallow = item;
          if (mashmallow.powerupIds.includes(powerupId) === false) {
            mashmallow.powerupIds.push(powerupId);
            this.processPowerupedMarshmallow(mashmallow, delay);
          }
          break;
        case ItemSuperType.CHOCOLATE:
          let chocolate = item;
          if (chocolate.powerupIds.includes(powerupId) === false) {
            chocolate.powerupIds.push(powerupId);
            this.processPowerupedChocolate(chocolate, delay);
          }
          break;
        case ItemSuperType.CANDY_BOTTLE:
          let candyBottle = item;
          if (candyBottle.powerupIds.includes(powerupId) === false) {
            candyBottle.powerupIds.push(powerupId);
            candyBottle.emitCandy(delay);
          }
          break;
        case ItemSuperType.DONUT_BOX:
          let donutBox = item;
          if (donutBox.powerupIds.includes(powerupId) === false) {
            donutBox.powerupIds.push(powerupId);
            this.processPoweredupDonutBox(donutBox, delay);
          }
          break;
        case ItemSuperType.APPLE_PLATTER:
          let applePlatter = item;
          if (applePlatter.powerupIds.includes(powerupId) === false) {
            applePlatter.powerupIds.push(powerupId);
            this.processPoweredupApplePlatter(applePlatter, delay);
          }
          break;
        case ItemSuperType.MYSTERY_BOX:
          let mysteryBox = item;
          mysteryBox.open(delay);
          break;
        case ItemSuperType.CHICK:
          this.itemsDropper.startPreDropTimer(delay + 50);
          this.scene.time.delayedCall(delay, () => {
            this.scene.destroyChick(item);
          });
          break;
        case ItemSuperType.GUMMY_BLOCKER:
          this.itemsDropper.startPreDropTimer(delay + 50);
          this.scene.time.delayedCall(delay, () => {
            this.scene.destroyGummyBlocker(item);
          });
          break;
        default:
          break;
      }
    }
    processPowerupedCookie(cookie, delay, powerUpItemType) {
      if (cookie instanceof SuperSphereCookie) {
        cookie.itemsTypeToClear = this.items.getMostPopularExistingCookieType();
        this.processSuperSpheredCookie(cookie, delay);
        return;
      }
      let duration = 200;
      this.scene.tweens.add({
        delay,
        targets: cookie,
        duration,
        ease: Phaser.Math.Easing.Cubic.Out,
        scale: 1.33,
        alpha: 0,
        onStart: () => {
          this.scene.onCookieRemove(cookie);
        },
        onComplete: () => {
          cookie.kill();
        }
      });
      this.scene.itemsDropper.startPreDropTimer(delay + duration + 100);
    }
    processSuperSpheredCookie(superSphere, delay) {
      let duration = 300;
      this.scene.removeItemFromGrid(superSphere);
      let dropLockId = this.scene.itemsDropper.lockPreDrop();
      let angleTween = this.scene.tweens.add({
        delay,
        targets: superSphere,
        duration: 66,
        ease: Phaser.Math.Easing.Sine.InOut,
        angle: -6,
        yoyo: true,
        repeat: -1
      });
      this.scene.tweens.add({
        delay,
        targets: superSphere,
        duration,
        ease: Phaser.Math.Easing.Back.In,
        scale: 1.66,
        onStart: () => {
          superSphere.sparksEmitter.on = false;
          superSphere.sparksEmitter.killAll();
        },
        onComplete: () => {
          this.scene.emitters.superSphereCircles.explode(1, superSphere.x, superSphere.y);
          this.scene.emitters.superSphereSparks.setPosition(superSphere.x, superSphere.y);
          this.scene.emitters.superSphereSparks.explode(15, superSphere.x, superSphere.y);
          this.scene.itemsDropper.unlockPreDrop(dropLockId);
          this.scene.itemsDropper.startPreDropTimer();
          this.applySuperSphere(superSphere);
          angleTween.remove();
          superSphere.kill();
        }
      });
      this.scene.tweens.add({
        delay: delay + 300,
        targets: superSphere,
        duration: 100,
        ease: Phaser.Math.Easing.Expo.In,
        alpha: 0
      });
    }
    processPowerupedMarshmallow(marshmallow, delay) {
      if (marshmallow.currentHealth > 1) {
        this.scene.time.delayedCall(delay, () => {
          marshmallow.damage();
        });
        return;
      }
      this.scene.itemsDropper.startPreDropTimer(delay + 300);
      this.scene.time.delayedCall(delay, () => {
        this.scene.destroyMarshmallow(marshmallow);
      });
    }
    processPowerupedChocolate(chocolate, delay) {
      if (chocolate.currentHealth > 1) {
        this.scene.time.delayedCall(delay, () => {
          chocolate.damage();
        });
        return;
      }
      this.scene.itemsDropper.startPreDropTimer(delay + 300);
      this.scene.time.delayedCall(delay, () => {
        this.scene.destroyChocolate(chocolate);
      });
    }
    processPoweredupDonutBox(donutBox, delay) {
      this.scene.time.delayedCall(delay, () => {
        this.scene.updateDonutBox(donutBox);
      });
    }
    processPoweredupApplePlatter(applePlatter, delay) {
      this.scene.time.delayedCall(delay, () => {
        this.scene.removeApple(applePlatter);
      });
    }
    applyCross(centralColumn, centalRow, itemType, crossThickness) {
      let powerupId = this.createPowerupId("cross");
      let adjustedThickness = Math.floor(crossThickness / 2);
      let startColumn = centralColumn - adjustedThickness;
      for (let column = startColumn; column <= centralColumn + adjustedThickness; column++) {
        this.applyVerticalStripes(column, centalRow, itemType, powerupId);
      }
      let startRow = centalRow - adjustedThickness;
      for (let row = startRow; row <= centalRow + adjustedThickness; row++) {
        this.applyHorizontalStripes(centralColumn, row, itemType, powerupId);
      }
    }
    applyBomb(column, row, radius = 1, originBombItemType) {
      let itemSuperTypes = this.itemSuperTypesAffectedByBomb;
      let middleItems = this.getItemsAffectedByBomb(this.items.mainItems, column, row, radius).filter((item) => itemSuperTypes.includes(item.itemSuperType) && this.items.hasLicoriceOver(item) === false);
      let topItems = this.getItemsAffectedByBomb(this.items.topItems, column, row, radius);
      let allItems = [...middleItems, ...topItems];
      let powerupId = this.createPowerupId("bomb");
      let dropLockId = this.itemsDropper.lockPreDrop("bomb_x" + radius);
      let unlockDropDelay = 0;
      allItems.forEach((item) => {
        this.preProcessPowerupedItem(item, powerupId);
      });
      allItems.forEach((item) => {
        let distance = gridDistanceXY(column, row, item.column, item.row);
        let delay = distance * 50;
        this.processPowerupedItem(item, originBombItemType, delay, powerupId);
        unlockDropDelay = Math.max(unlockDropDelay, delay);
      });
      this.scene.time.delayedCall(unlockDropDelay, () => {
        this.itemsDropper.unlockPreDrop(dropLockId);
      });
      this.scene.sounds.bomb();
    }
    getItemsAffectedByBomb(itemsArray, column, row, radius) {
      let explosionWidth = radius * 2 + 1;
      let explosionHeight = radius * 2 + 1;
      let left = column - radius;
      let top = row - radius;
      let items = [];
      for (let row2 = top; row2 < top + explosionHeight; row2++) {
        for (let column2 = left; column2 < left + explosionWidth; column2++) {
          let item = itemsArray.getAt(column2, row2);
          if (item && items.includes(item) === false) {
            items.push(item);
          }
        }
      }
      return items;
    }
    applySuperSphere(superSphere) {
      let powerupId = this.createPowerupId("sphere");
      let dropLockId = this.itemsDropper.lockPreDrop("super-sphere");
      let allItems = this.getItemsAffectedBySuperSphere(superSphere);
      if (allItems.length === 0) {
        this.itemsDropper.unlockPreDrop(dropLockId);
        this.itemsDropper.startPreDropTimer(300);
      }
      let unlock = after_default(allItems.length, () => {
        this.itemsDropper.unlockPreDrop(dropLockId);
      });
      allItems.forEach((item) => {
        this.preProcessPowerupedItem(item, powerupId);
      });
      allItems.forEach((item) => {
        this.sendSuperSphereCharge(superSphere, item, () => {
          this.processPowerupedItem(item, superSphere.itemType, 0, powerupId);
          unlock();
        });
      });
      this.scene.sounds.superSphere();
    }
    getItemsAffectedBySuperSphere(superSphere) {
      let affectedCookies = this.items.mainItems.filter((item) => item.itemSuperType === ItemSuperType.COOKIE && item.itemType === superSphere.itemsTypeToClear).filter((cookie) => cookie.powerup !== CookiePowerup.SUPER_SPHERE);
      return affectedCookies.map((cookie) => {
        return this.items.hasLicoriceOver(cookie) ? this.items.topItems.getAt(cookie.column, cookie.row) : cookie;
      });
    }
    sendSuperSphereCharge(startPosition, targetItem, onComplete) {
      let charge = this.superSphereCharges.getFirstDead(true);
      charge.revive();
      charge.setPosition(startPosition.x, startPosition.y);
      charge.angle = Phaser.Math.Angle.Between(charge.x, charge.y, targetItem.x, targetItem.y) * Phaser.Math.RAD_TO_DEG + 90;
      charge.alpha = 0;
      this.scene.tweens.add({
        targets: charge,
        duration: 100,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.scene.tweens.add({
        targets: charge,
        duration: 250,
        ease: Phaser.Math.Easing.Linear,
        x: targetItem.x,
        y: targetItem.y,
        onComplete: () => {
          this.scene.emitters.stripedItemCircles.explode(1, charge.x, charge.y);
          this.scene.emitters.superSphereChargeSparks.explode(10, charge.x, charge.y);
          charge.kill();
          onComplete();
        }
      });
    }
    showBombFx(column, row, radius) {
      let position = gridToPixels(column, row);
      this.showBombFxAt(position.x, position.y, radius);
    }
    showBombFxAt(x, y, radius) {
      let bombExplosion = this.scene.emitters.bombExplosion;
      bombExplosion.setScale({start: 0, end: 3 + radius, ease: Ease.ExpoOut});
      bombExplosion.explode(1, x, y);
      let bombParticles = this.scene.emitters.bombParticles;
      bombParticles.setPosition(x, y);
      bombParticles.explode(12, x, y);
    }
  };

  // src/scenes/gameplay/field/CellLabels.ts
  var CellLabels = class extends Phaser.GameObjects.Container {
    constructor(scene, field) {
      super(scene);
      this.name = "field_labels";
      this.field = field;
      this.addLabels();
    }
    addLabels() {
      this.labels = [];
      for (let row = 0; row < this.field.rows; row++) {
        for (let column = 0; column < this.field.columns; column++) {
          let back = this.scene.add.image(0, 0, "gameplay", "cell_label_back");
          alignToGrid(back, column, row);
          back.y -= CELL_SIZE / 2 - 18;
          back.alpha = this.field.isEmpty(column, row) ? 0.33 : 0.75;
          back.scaleX = 0.8;
          back.scaleY = 0.9;
          this.add(back);
          let label = this.createLabel(column, row);
          label.x = back.x;
          label.y = back.y + 4;
          label.alpha = back.alpha;
          this.labels.push(label);
          this.add(label);
        }
      }
    }
    createLabel(column, row) {
      let content = `${column},${row}`;
      let label = this.scene.add.bitmapText(0, 0, BitmapFont.GAME_FIELD_LABELS, content, 22);
      label.setOrigin(0.5, 0.5);
      return label;
    }
  };

  // src/scenes/gameplay/goals/GoalsManager.ts
  var GoalsManagerEvent;
  (function(GoalsManagerEvent2) {
    GoalsManagerEvent2["GOAL_COMPLETE"] = "__GOAL_COMPLETE";
  })(GoalsManagerEvent || (GoalsManagerEvent = {}));
  var _GoalsManager = class extends Phaser.Events.EventEmitter {
    constructor(scene, goalsConfig) {
      super();
      this.scene = scene;
      this.goalsConfig = goalsConfig;
      this.goals = GoalUtils.createGoalsArray(goalsConfig);
      this.goalItemTypes = this.getGoalItemTypes(this.goals);
    }
    getIncompleteGoals() {
      return this.goals.filter((goal) => {
        return goal.targetNum - goal.collectedNum > 0;
      });
    }
    save() {
      return cloneDeep_default(this.goals);
    }
    restore(goals) {
      this.goals = goals;
    }
    isGoalItem(item) {
      return this.isGoalItemType(item.itemType);
    }
    isGoalItemType(itemType) {
      return this.goalItemTypes.includes(itemType);
    }
    getGoalItemTypes(goals) {
      let goalTypes = goals.map((goal) => goal.type);
      let itemTypes = goalTypes.flatMap((goalType) => _GoalsManager.GOALS_ITEM_TYPES_MAP[goalType]);
      return itemTypes;
    }
    getGoalCookieTypes() {
      let cookieTypes = ItemTypeUtil.getSubtypes(ItemSuperType.COOKIE);
      let remainingGoals = this.goals.filter((goal) => goal.collectedNum < goal.targetNum);
      let remainingCookieTypes = this.getGoalItemTypes(remainingGoals).filter((itemType) => cookieTypes.includes(itemType));
      return remainingCookieTypes;
    }
    update(item) {
      let goalType = this.getGoalTypeByItemType(item.itemType);
      let goal = this.goals.find((goal2) => goal2.type === goalType);
      if (goal && goal.collectedNum < goal.targetNum) {
        goal.collectedNum++;
        if (goal.collectedNum === goal.targetNum) {
          this.emit(GoalsManagerEvent.GOAL_COMPLETE, goal);
        }
        return true;
      }
      return false;
    }
    getGoalTypeByItemType(itemType) {
      return findKey_default(_GoalsManager.GOALS_ITEM_TYPES_MAP, (value) => value.includes(itemType));
    }
    areComplete() {
      return this.goals.every((goal) => goal.collectedNum >= goal.targetNum);
    }
    toString() {
      return this.goals.map((goal) => {
        let isComplete = goal.collectedNum >= goal.targetNum;
        return `${goal.type}: ${goal.collectedNum}/${goal.targetNum} ${isComplete ? "\u2714" : ""}`;
      }).join("\n");
    }
  };
  var GoalsManager = _GoalsManager;
  GoalsManager.GOALS_ITEM_TYPES_MAP = {
    [GoalType.COOKIE_BLUE]: [ItemType.COOKIE_BLUE],
    [GoalType.COOKIE_RED]: [ItemType.COOKIE_RED],
    [GoalType.COOKIE_ORANGE]: [ItemType.COOKIE_ORANGE],
    [GoalType.COOKIE_YELLOW]: [ItemType.COOKIE_YELLOW],
    [GoalType.COOKIE_PINK]: [ItemType.COOKIE_PINK],
    [GoalType.COOKIE_PURPLE]: [ItemType.COOKIE_PURPLE],
    [GoalType.APPLE]: [ItemType.APPLES_PLATTER],
    [GoalType.DROP_ITEM]: [ItemType.DROP_ITEM],
    [GoalType.MARSHMALLOW]: ItemTypeUtil.getSubtypes(ItemSuperType.MARSHMALLOW),
    [GoalType.CHOCOLATE]: ItemTypeUtil.getSubtypes(ItemSuperType.CHOCOLATE),
    [GoalType.LICORICE]: ItemTypeUtil.getSubtypes(ItemSuperType.LICORICE),
    [GoalType.BISCUIT]: [ItemType.BISCUIT],
    [GoalType.DONUT]: [ItemType.DONUT_BOX],
    [GoalType.CANDY]: [ItemType.CANDY_BOTTLE],
    [GoalType.GUMMY]: ItemTypeUtil.getSubtypes(ItemSuperType.GUMMY),
    [GoalType.CHICK]: ItemTypeUtil.getSubtypes(ItemSuperType.CHICK)
  };

  // src/scenes/gameplay/DropItemsManager.ts
  var DropItemsManager = class extends Phaser.Events.EventEmitter {
    constructor(scene) {
      super();
      this.scene = scene;
      this.items = this.scene.items;
    }
    process() {
      let dropItems = this.items.mainItems.filter((item) => isDropItem(item) && this.items.hasLicoriceOver(item) === false);
      if (dropItems.length === 0) {
        return false;
      }
      let wasDropped = false;
      dropItems.sort(sortBottomUp).forEach((item) => {
        let itemCell = this.scene.field.getCellAt(item.column, item.row);
        let bottomCell = this.scene.field.getBottomCell(item.column);
        let isBottomCell = itemCell === bottomCell;
        if (isBottomCell || this.canDropToBottomCell(item, bottomCell)) {
          this.scene.removeItemFromGrid(item);
          let delay = (bottomCell.row - itemCell.row) * 33;
          item.stopIdleTweens(delay, () => {
            this.processDroppedItem(item);
          });
          wasDropped = true;
        }
      });
      return wasDropped;
    }
    canDropToBottomCell(item, bottomCell) {
      let {column: itemColumn, row: itemRow} = item;
      for (let row = itemRow + 1; row <= bottomCell.row; row++) {
        let item2 = this.items.mainItems.getAt(itemColumn, row);
        if (item2) {
          return false;
        }
      }
      return true;
    }
    processDroppedItem(item) {
      this.scene.sounds.dropItemCollect();
      if (this.scene.goals.isGoalItem(item)) {
        this.scene.goals.update(item);
        this.scene.gui.goalItems.collectItem(item);
        item.destroy();
        return;
      }
      this.scene.tweens.add({
        targets: item,
        duration: 400,
        ease: Phaser.Math.Easing.Quartic.Out,
        scale: 1.6,
        alpha: 0,
        onComplete: () => {
          item.destroy();
        }
      });
    }
  };

  // src/scenes/gameplay/boosters/Glove.ts
  var Glove = class extends Phaser.GameObjects.Image {
    constructor(scene) {
      super(scene, 0, 0, "gameplay", "glove");
    }
    show() {
      this.alpha = 0;
      this.scene.tweens.add({
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.scale = 1.5;
      this.scene.tweens.add({
        targets: this,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1,
        onComplete: () => {
          this.scene.tweens.add({
            targets: this,
            duration: 100,
            ease: Phaser.Math.Easing.Cubic.Out,
            alpha: 0,
            onComplete: () => {
              this.destroy();
            }
          });
        }
      });
    }
    destroy() {
      super.destroy();
    }
  };

  // src/scenes/gameplay/boosters/PipingBag.ts
  var DegToRad3 = Phaser.Math.DegToRad;
  var RollingPin = class extends Phaser.GameObjects.Image {
    constructor(scene) {
      super(scene, 0, 0, "gameplay", "rolling_pin");
    }
    show() {
      this.alpha = 0;
      this.scene.tweens.add({
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      let initialPosition = {x: this.x, y: this.y};
      this.moveAway();
      this.scale = 1.5;
      this.scene.tweens.add({
        targets: this,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1,
        x: initialPosition.x,
        y: initialPosition.y,
        onComplete: () => {
          this.scene.tweens.add({
            targets: this,
            duration: 300,
            ease: Phaser.Math.Easing.Cubic.Out,
            alpha: 0,
            scale: this.scale * 1.33,
            onComplete: () => {
              this.destroy();
            }
          });
        }
      });
    }
    moveAway() {
      let angle = -55;
      let angleRad = DegToRad3(angle);
      let distance = 44;
      this.x = this.x + Math.cos(angleRad) * distance;
      this.y = this.y + Math.sin(angleRad) * distance;
    }
    destroy() {
      super.destroy();
    }
  };

  // src/scenes/gameplay/boosters/Lollipop.ts
  var Lollipop = class extends Phaser.GameObjects.Image {
    constructor(scene) {
      super(scene, 0, 0, "gameplay", "lollipop");
    }
    show() {
      this.alpha = 0;
      this.scene.tweens.add({
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.angle = 30;
      this.scene.tweens.add({
        targets: this,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        angle: 66,
        scale: 1.2,
        completeDelay: 200,
        onComplete: () => {
          this.scene.tweens.add({
            targets: this,
            duration: 400,
            ease: Phaser.Math.Easing.Back.In,
            scale: 1,
            angle: 0,
            onComplete: () => {
              this.scene.tweens.add({
                targets: this,
                duration: 300,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
                scale: this.scale * 1.33,
                onComplete: () => {
                  this.destroy();
                }
              });
            }
          });
        }
      });
    }
    destroy() {
      super.destroy();
    }
  };

  // src/scenes/gameplay/boosters/GameplayBoosters.ts
  var GameplayBoostersEvent;
  (function(GameplayBoostersEvent2) {
    GameplayBoostersEvent2["SELECT"] = "__SELECT";
    GameplayBoostersEvent2["CANCEL"] = "__CANCEL";
    GameplayBoostersEvent2["ACTIVATE"] = "__ACTIVATE";
    GameplayBoostersEvent2["COMPLETE"] = "__COMPLETE";
  })(GameplayBoostersEvent || (GameplayBoostersEvent = {}));
  var GameplayBoosters = class extends Phaser.Events.EventEmitter {
    constructor(scene, gui) {
      super();
      this.isTutorialMode = false;
      this.boostersUsedNum = 0;
      this.scene = scene;
      this.gui = gui;
      this.boostersPanel = this.gui.boostersPanel;
      this.boostersPanel.on(BoostersPanelEvent.SELECT, this.onBoosterSelect, this);
      this.boostersPanel.on(BoostersPanelEvent.CANCEL, this.onBoosterCancel, this);
      this.boosterHint = this.gui.boosterHintScreen;
    }
    testBoosterSelect(boosterType) {
      this.scene.time.delayedCall(100, () => {
        this.onBoosterSelect(this.getBooster(boosterType));
      });
    }
    testBooster(boosterType, gridPosition) {
      gridPosition = gridPosition != null ? gridPosition : {
        x: Phaser.Math.RND.between(0, this.scene.field.columns),
        y: Phaser.Math.RND.between(0, this.scene.field.rows)
      };
      let cell = this.scene.field.getCellAt(gridPosition.y, gridPosition.x);
      if (cell) {
        this.scene.time.delayedCall(100, () => {
          this.applyBooster(this.getBooster(boosterType), cell.x, cell.y);
        });
      }
    }
    testBoosterByClick(type) {
    }
    onBoosterSelect(booster, handCell) {
      this.emit(GameplayBoostersEvent.SELECT, booster);
      this.showBlackOverlay();
      this.selectedBooster = booster;
      this.boosterHint.updateData(booster, handCell);
      this.boosterHint.show();
      this.gui.topPanel.kill();
      this.gui.pauseButton.kill();
      this.gui.undoButton.kill();
      this.boostersPanel.highlight(booster.type);
      this.scene.sentry.addBreadcrumb({
        category: "boosters",
        message: "booster_select",
        data: {
          boosterType: booster.type
        }
      });
      this.addPointerDownCallback();
    }
    getRootScene() {
      return this.scene.scene.get(SceneKey.GAMEPLAY_ROOT);
    }
    showBlackOverlay() {
      this.getRootScene().showBlackOverlay();
    }
    hideBlackOverlay() {
      this.getRootScene().hideBlackOverlay();
    }
    getBoosterableCookies() {
      return this.scene.items.mainItems.filter((item) => isCookie(item));
    }
    addPointerDownCallback() {
      this.scene.input.on(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
    }
    removePointerDownCallback() {
      this.scene.input.off(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
    }
    onPointerDown(pointer) {
      let {column, row} = pixelsToGridXY(pointer.worldX, pointer.worldY);
      let canApply = this.canApplyBooster(this.selectedBooster.type, column, row);
      if (canApply) {
        this.removePointerDownCallback();
        this.applyBooster(this.selectedBooster, column, row);
        this.scene.audio.play(GameSoundKey.FANCY_TAP);
      } else {
        switch (this.selectedBooster.type) {
          case BoosterType.GLOVE:
          case BoosterType.ROLLING_PIN:
            this.gui.boosterWarning.text = this.scene.texts.booster_hint_field;
            this.showBoosterWarning(pointer.x, pointer.y);
            this.scene.audio.play(GameSoundKey.BOOSTER_CANT_USE);
            break;
          case BoosterType.LOLLIPOP:
            this.gui.boosterWarning.text = this.scene.texts.booster_hint_cookie;
            this.showBoosterWarning(pointer.x, pointer.y);
            this.hignlightCookies(this.getBoosterableCookies());
            this.scene.audio.play(GameSoundKey.BOOSTER_CANT_USE);
            break;
          default:
            break;
        }
      }
    }
    canApplyBooster(boosterType, column, row) {
      switch (boosterType) {
        case BoosterType.GLOVE:
          return this.canApplyGlove(column, row);
        case BoosterType.ROLLING_PIN:
          return this.canApplyRollingPin(column, row);
        case BoosterType.LOLLIPOP:
          return this.canApplyLollipop(column, row);
      }
    }
    canApplyGlove(column, row) {
      return typeof this.getItemForGlove(column, row) !== "undefined";
    }
    canApplyRollingPin(column, row) {
      let field = this.scene.field.dimensions;
      return column >= field.left && column <= field.right && row >= field.top && row <= field.bottom;
    }
    canApplyLollipop(column, row) {
      return this.scene.items.mainItems.filter((item) => isCookie(item)).some((item) => item.column === column && item.row === row);
    }
    getItemForGlove(column, row) {
      let biscuit = this.scene.items.bottomItems.getAt(column, row);
      let middleItem = this.scene.items.mainItems.getAt(column, row);
      let topItem = this.scene.items.topItems.getAt(column, row);
      let itemSuperTypes = without_default(ItemTypeUtil.getAllSuperTypes(), ItemSuperType.GUMMY, ItemSuperType.GENERATOR);
      let items = [biscuit, middleItem, topItem].filter((item) => item && itemSuperTypes.includes(item.itemSuperType));
      return items.pop();
    }
    hignlightCookies(cookies) {
      cookies.forEach((cookie) => {
        let {column, row} = cookie;
        this.scene.getHighlightAt(column, row).highlightTo({hold: 400});
      });
    }
    showBoosterWarning(worldX, worldY) {
      this.gui.showTapOnCookieWarning(worldX, worldY);
    }
    applyBooster(booster, column, row) {
      this.scene.analytics.subtractResource(ResourceCurrency.BOOSTERS, 1, booster.type, `Level_${this.scene.levelNumber}`);
      this.scene.sentry.addBreadcrumb({
        category: "boosters",
        message: "booster_activate",
        data: {
          boosterType: booster.type,
          column,
          row
        }
      });
      if (this.isTutorialMode === false) {
        this.boostersUsedNum++;
      }
      this.onBeforeBoosterApply(booster, column, row);
      switch (booster.type) {
        case BoosterType.GLOVE:
          this.applyGlove(booster, column, row);
          break;
        case BoosterType.ROLLING_PIN:
          this.applyRollingPin(booster, column, row);
          break;
        case BoosterType.LOLLIPOP:
          this.applyLollipop(booster, column, row);
          break;
        default:
          break;
      }
    }
    onBeforeBoosterApply(booster, column, row) {
      this.scene.undoHandler.save();
      booster.num -= 1;
      this.hideBlackOverlay();
      this.boosterHint.hide();
      this.gui.topPanel.revive();
      this.gui.pauseButton.revive();
      this.gui.undoButton.revive();
      this.gui.undoButton.disableInput();
      this.boostersPanel.resetHighlight();
      this.boostersPanel.disableInput();
      this.scene.lock();
      this.emit(GameplayBoostersEvent.ACTIVATE, booster, column, row);
    }
    applyGlove(booster, column, row) {
      let item = this.getItemForGlove(column, row);
      if (isSuperSphere(item)) {
        item.itemsTypeToClear = this.scene.items.getMostPopularExistingCookieType();
      }
      let {x, y} = this.getGlovePosition(item);
      let fx = new Glove(this.scene);
      fx.x = x;
      fx.y = y;
      fx.setDepth(GameplayDepth.BOOSTER_FX);
      fx.show();
      this.scene.add.existing(fx);
      this.scene.time.delayedCall(300, () => {
        this.scene.audio.play(GameSoundKey.BOOSTER_GLOVE);
        this.scene.emitters.gloveParticles.setPosition(fx.x, fx.y);
        this.scene.emitters.gloveParticles.explode(10, fx.x, fx.y);
        this.scene.emitters.gloveCircle.explode(2, fx.x, fx.y);
        this.doApplyGloveToItem(item);
        this.onBoosterComplete(booster);
      });
    }
    getGlovePosition(item) {
      if (item.itemSuperType === ItemSuperType.CANDY_BOTTLE) {
        return {x: item.x, y: item.y - 40};
      }
      return {x: item.x, y: item.y};
    }
    doApplyGloveToItem(item) {
      switch (item.itemSuperType) {
        case ItemSuperType.BISCUIT:
          this.scene.destroyBiscuit(item);
          this.scene.unlock();
          break;
        case ItemSuperType.COOKIE:
          let cookie = item;
          cookie.kill();
          this.scene.removeItemFromGrid(cookie);
          this.scene.onCookieRemove(cookie);
          this.scene.itemsDropper.startPreDropTimer(150);
          break;
        case ItemSuperType.DROP_ITEM:
          this.scene.dropItemsManager.processDroppedItem(item);
          this.scene.removeItemFromGrid(item);
          this.scene.itemsDropper.startPreDropTimer(250);
          break;
        case ItemSuperType.MARSHMALLOW:
          let marshmallow = item;
          marshmallow.damage();
          if (marshmallow.isDead()) {
            this.scene.destroyMarshmallow(marshmallow);
          } else {
            this.scene.unlock();
          }
          break;
        case ItemSuperType.CHOCOLATE:
          let chocolate = item;
          chocolate.damage();
          if (chocolate.isDead()) {
            this.scene.destroyChocolate(chocolate);
          } else {
            this.scene.unlock();
          }
          break;
        case ItemSuperType.APPLE_PLATTER:
          let platter = item;
          if (platter.getApplesNum() > 1) {
            this.scene.unlock();
          }
          this.scene.removeApple(platter);
          break;
        case ItemSuperType.DONUT_BOX:
          let donutBox = item;
          if (donutBox.boxState === DonutBoxState.CLOSED) {
            this.scene.unlock();
          }
          this.scene.updateDonutBox(donutBox);
          break;
        case ItemSuperType.CANDY_BOTTLE:
          item.emitCandy(0);
          this.scene.unlock();
          break;
        case ItemSuperType.COLOR_CAKE:
          let cake = item;
          if (cake.getActivePiecesNum() > 1) {
            this.scene.unlock();
          }
          this.scene.removePieceFromColorCake(cake, cake.getRandomActivePieceType());
          break;
        case ItemSuperType.MYSTERY_BOX:
          item.open(0);
          this.scene.unlock();
          break;
        case ItemSuperType.CHICK:
          this.scene.destroyChick(item);
          this.scene.unlock();
          break;
        case ItemSuperType.LICORICE:
          this.scene.destroyLicorice(item);
          this.scene.unlock();
          break;
        case ItemSuperType.GUMMY_BLOCKER:
          let wasGummyCollected = this.scene.destroyGummyBlocker(item);
          if (wasGummyCollected === false) {
            this.scene.unlock();
          }
          break;
        default:
          console.warn("Glove can't be applied to this item!", item);
          this.scene.unlock();
          break;
      }
    }
    applyRollingPin(booster, column, row) {
      let {x, y} = gridToPixels(column, row);
      let fx = new RollingPin(this.scene);
      fx.x = x;
      fx.y = y;
      fx.setDepth(GameplayDepth.BOOSTER_FX);
      fx.show();
      this.scene.add.existing(fx);
      this.scene.time.delayedCall(300, () => {
        this.scene.audio.play(GameSoundKey.BOOSTER_ROLLING_PIN, {volume: 0.5});
        let itemType = this.scene.items.getMostPopularExistingCookieType();
        this.scene.powerupsHandler.applyCross(column, row, itemType, 1);
        this.scene.itemsDropper.startPreDropTimer(200);
        this.onBoosterComplete(booster);
      });
    }
    applyLollipop(booster, column, row) {
      let boosteredItem = this.scene.items.mainItems.getAt(column, row);
      if (!boosteredItem) {
        return;
      }
      let fx = new Lollipop(this.scene);
      fx.x = boosteredItem.x + 28;
      fx.y = boosteredItem.y + 62;
      fx.setDepth(GameplayDepth.BOOSTER_FX);
      fx.show();
      this.scene.add.existing(fx);
      this.scene.time.delayedCall(1020, () => {
        this.scene.audio.play(GameSoundKey.BOOSTER_LOLLIPOP);
        this.doApplyLollipop(boosteredItem, booster);
      });
    }
    doApplyLollipop(boosteredItem, booster) {
      let itemType = boosteredItem.itemType;
      let allCookies = isSuperSphere(boosteredItem) ? this.scene.items.mainItems.filter((item) => isSuperSphere(item)) : this.scene.items.mainItems.filter((item) => isCookie(item) && item.itemType === itemType && item.powerup !== CookiePowerup.SUPER_SPHERE);
      let startDropTimer = after_default(allCookies.length, () => {
        this.scene.itemsDropper.startPreDropTimer(150);
      });
      let licorices = [];
      let nonBlockedCookies = [];
      allCookies.forEach((cookie) => {
        let {column, row} = cookie;
        let licorice = this.scene.items.topItems.getAt(column, row);
        if (licorice) {
          licorices.push(licorice);
        } else {
          nonBlockedCookies.push(cookie);
        }
      });
      licorices.forEach((licorice) => {
        this.scene.powerupsHandler.sendSuperSphereCharge(boosteredItem, licorice, () => {
          this.scene.destroyLicorice(licorice);
          startDropTimer();
        });
      });
      nonBlockedCookies.forEach((cookie) => {
        if (isSuperSphere(cookie)) {
          cookie.itemsTypeToClear = this.scene.items.getMostPopularExistingCookieType();
        }
        this.scene.removeItemFromGrid(cookie);
        this.scene.powerupsHandler.sendSuperSphereCharge(boosteredItem, cookie, () => {
          this.scene.onCookieRemove(cookie);
          cookie.kill();
          startDropTimer();
        });
      });
      this.scene.emitters.gloveCircle.explode(1, boosteredItem.x, boosteredItem.y);
      this.scene.camera.camera.shake(300, 0.01, true);
      this.onBoosterComplete(booster);
    }
    onBoosterComplete(booster) {
      this.isTutorialMode = false;
      this.emit(GameplayBoostersEvent.COMPLETE, booster);
    }
    onBoosterCancel(booster) {
      this.removePointerDownCallback();
      this.hideBlackOverlay();
      this.boostersPanel.resetHighlight();
      this.boosterHint.hide();
      this.gui.topPanel.revive();
      this.gui.pauseButton.revive();
      this.gui.undoButton.revive();
      this.isTutorialMode = false;
      this.emit(GameplayBoostersEvent.CANCEL, booster);
    }
    getBooster(type) {
      return this.scene.game.boosters.getByType(type);
    }
    setTutorialMode(boosterType, handCell) {
      let booster = this.getBooster(boosterType);
      this.onBoosterSelect(booster, handCell);
      this.isTutorialMode = true;
    }
    cancelTutorialMode() {
      if (this.selectedBooster) {
        this.onBoosterCancel(this.selectedBooster);
      }
    }
    destroy() {
      this.removePointerDownCallback();
      this.boostersPanel.off(BoostersPanelEvent.SELECT, this.onBoosterSelect, this);
      this.boostersPanel.off(BoostersPanelEvent.CANCEL, this.onBoosterCancel, this);
    }
  };

  // src/scenes/gameplay/GameplayEmitters.ts
  var GameplayEmitters = class {
    constructor(scene) {
      this.scene = scene;
      this.aboveItemsParticles = this.scene.add.particles("gameplay");
      this.aboveItemsParticles.setDepth(GameplayDepth.POWERUP_FX);
      this.belowItemsParticles = this.scene.add.particles("gameplay");
      this.belowItemsParticles.setDepth(GameplayDepth.BELOW_ITEMS_FX);
      this.createEmitters();
    }
    createEmitters() {
      this.addCollapseCookiesEmitters();
      this.addStripesEmitters();
      this.addBombEmitters();
      this.addSuperSphereEmitters();
      this.addDoubleSpheresEmtters();
      this.addPregameBoostersEmitters();
      this.addBoostersEmitters();
      this.addMatchedCookieEmitters();
      this.addFallingItemsEmitters();
    }
    addCollapseCookiesEmitters() {
      this.collapseCircles = this.aboveItemsParticles.createEmitter({
        frame: "circle_fx_3",
        scale: {start: 0.33, end: 3, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        lifespan: 1800,
        on: false
      });
      this.collapseSparks = this.aboveItemsParticles.createEmitter(__spreadProps(__spreadValues({}, ParticleUtil.getCircleEdgeEmitZone(35)), {
        speed: 60,
        frame: "double_spheres_particle",
        lifespan: {min: 500, max: 900},
        scale: {start: 1.33, end: 0.5},
        alpha: {start: 1, end: 0, ease: Ease.ExpoIn},
        on: false
      }));
    }
    addStripesEmitters() {
      let stripesEmitterProps = {
        frame: "stripes_fx",
        scaleX: {start: 1, end: 1.5, ease: Ease.ExpoIn},
        scaleY: {start: 0, end: 1.75, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.ExpoIn},
        lifespan: 700,
        on: false
      };
      this.verticalStripesFx = this.aboveItemsParticles.createEmitter(__spreadValues({}, stripesEmitterProps));
      this.horizontalStripesFx = this.aboveItemsParticles.createEmitter(__spreadProps(__spreadValues({}, stripesEmitterProps), {
        rotate: 90
      }));
      this.stripesFxCircles = this.aboveItemsParticles.createEmitter({
        frame: "stripes_fx_circle",
        scale: {start: 0.4, end: 2.5, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.CubicOut},
        lifespan: 2e3,
        on: false
      });
      this.stripesParticles = this.aboveItemsParticles.createEmitter(__spreadProps(__spreadValues({}, ParticleUtil.getCircleEdgeEmitZone(CELL_SIZE / 2)), {
        speed: 150,
        frame: "particle_star_01",
        lifespan: {min: 500, max: 900},
        scale: {start: 1, end: 0.5},
        alpha: {start: 1, end: 0, ease: Ease.ExpoIn},
        on: false
      }));
      this.stripedItemParticles = this.aboveItemsParticles.createEmitter({
        speed: 75,
        frame: "particle_star_01",
        lifespan: {min: 500, max: 900},
        scale: {start: 1, end: 0.5},
        alpha: {start: 1, end: 0, ease: Ease.ExpoIn},
        on: false
      });
      this.stripedItemCircles = this.aboveItemsParticles.createEmitter({
        frame: "circle_fx_3",
        scale: {start: 0.66, end: 1.66, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.CubicOut},
        lifespan: 1200,
        on: false
      });
    }
    addBombEmitters() {
      this.bombExplosion = this.aboveItemsParticles.createEmitter({
        frame: "bomb_explosion",
        scale: {start: 1, end: 4, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.CubicOut},
        lifespan: 1e3,
        on: false,
        blendMode: Phaser.BlendModes.ADD
      });
      this.bombParticles = this.aboveItemsParticles.createEmitter(__spreadProps(__spreadValues({}, ParticleUtil.getCircleEdgeEmitZone(CELL_SIZE)), {
        frame: "cracker_hit_particle",
        speed: {min: 350, max: 550},
        lifespan: {min: 200, max: 300},
        scale: {start: 1.5, end: 0.1, ease: Ease.QuintIn},
        on: false
      }));
    }
    addSuperSphereEmitters() {
      this.superSphereCircles = this.aboveItemsParticles.createEmitter({
        frame: "circle_fx_3",
        scale: {start: 1, end: 3, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.CubicOut},
        lifespan: 1e3,
        on: false
      });
      this.superSphereSparks = this.aboveItemsParticles.createEmitter(__spreadProps(__spreadValues({}, ParticleUtil.getCircleEdgeEmitZone(CELL_SIZE * 0.4)), {
        frame: "particle_star_01",
        speed: {min: 350, max: 550},
        lifespan: {min: 200, max: 300},
        scale: {start: 1.5, end: 0.1, ease: Ease.QuintIn},
        on: false
      }));
      this.superSphereChargeSparks = this.aboveItemsParticles.createEmitter({
        speed: 200,
        frame: "particle_star_01",
        lifespan: {min: 500, max: 800},
        rotate: {min: 0, max: 180},
        scale: {start: 1, end: 0.5},
        alpha: {start: 1, end: 0},
        on: false
      });
    }
    addDoubleSpheresEmtters() {
      this.doubleSpheresMergeCircles = this.aboveItemsParticles.createEmitter({
        frame: "bomb_explosion",
        scale: {start: 1, end: 3, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.CubicOut},
        lifespan: 1e3,
        on: false
      });
      this.doubleSpheresMergeParticles = this.aboveItemsParticles.createEmitter(__spreadProps(__spreadValues({}, ParticleUtil.getCircleEdgeEmitZone(CELL_SIZE / 2)), {
        frame: "cracker_hit_particle",
        speed: {min: 350, max: 550},
        lifespan: {min: 200, max: 300},
        scale: {start: 1.5, end: 0.1, ease: Ease.QuintIn},
        on: false
      }));
      this.doubleSpheresExplosion = this.aboveItemsParticles.createEmitter({
        frame: "double_spheres_particle",
        lifespan: 3e3,
        speed: {min: 10, max: 1200},
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        scale: {start: 1.33, end: 0},
        emitZone: {
          source: new Phaser.Geom.Circle(0, 0, 100),
          type: "random"
        },
        on: false
      });
    }
    addPregameBoostersEmitters() {
      this.pregameBoosterCircles = this.aboveItemsParticles.createEmitter({
        frame: "circle_fx_3",
        scale: {start: 0.5, end: 1.75, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        lifespan: 2e3,
        on: false
      });
      this.pregameBoosterSparks = this.aboveItemsParticles.createEmitter({
        speed: 50,
        angle: -90,
        frame: "double_spheres_particle",
        lifespan: {min: 800, max: 1400},
        scale: {start: 1, end: 0, ease: Ease.ExpoIn},
        alpha: {start: 0, end: 1, ease: CustomEase.BellSqrt},
        on: false
      });
      this.pregameBoosterSparks.setEmitZone({
        source: new Phaser.Geom.Circle(0, 22, CELL_SIZE * 0.5),
        type: "random"
      });
    }
    addBoostersEmitters() {
      this.gloveCircle = this.aboveItemsParticles.createEmitter({
        frame: "bomb_explosion",
        scale: {start: 0.8, end: 2.5, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.CubicOut},
        lifespan: 1e3,
        on: false
      });
      this.gloveParticles = this.aboveItemsParticles.createEmitter(__spreadProps(__spreadValues({}, ParticleUtil.getCircleEdgeEmitZone(CELL_SIZE / 2)), {
        speed: 200,
        frame: "star_particle",
        lifespan: {min: 300, max: 550},
        scale: {start: 1, end: 0.25},
        alpha: {start: 1, end: 0, ease: Ease.ExpoIn},
        on: false
      }));
    }
    addColorCakeEmitters() {
      this.colorCakeCircles = this.aboveItemsParticles.createEmitter({
        frame: "bomb_explosion",
        scale: {start: 2, end: 10, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        lifespan: 1e3,
        blendMode: Phaser.BlendModes.ADD,
        on: false
      });
      this.colorCakeSparks = this.aboveItemsParticles.createEmitter({
        frame: "double_spheres_particle",
        lifespan: 2e3,
        speed: {min: 10, max: 1200},
        alpha: {start: 1, end: 0, ease: Ease.ExpoIn},
        scale: {start: 1.33, end: 0},
        emitZone: {
          source: new Phaser.Geom.Circle(0, 0, 100),
          type: "random"
        },
        on: false
      }).reserve(100);
    }
    addCandyBottleEmitters() {
      this.candyBottleCircles = this.belowItemsParticles.createEmitter({
        frame: "bottle_circle_fx",
        scale: {start: 2.5, end: 0.7, ease: Ease.ExpoOut},
        alpha: {start: 0.33, end: 1, ease: Ease.ExpoOut},
        lifespan: 1200,
        on: false
      });
    }
    addMatchedCookieEmitters() {
      this.matchedCookieSparks = this.aboveItemsParticles.createEmitter(__spreadProps(__spreadValues({}, ParticleUtil.getCircleEdgeEmitZone(CELL_SIZE * 0.5)), {
        speed: {min: 20, max: 40},
        frame: "double_spheres_particle",
        lifespan: {min: 600, max: 900},
        scale: {start: 1, end: 0, ease: Ease.ExpoIn},
        alpha: {start: 0, end: 1, ease: CustomEase.Bell},
        on: false
      }));
      this.matchedCookieCircles = this.aboveItemsParticles.createEmitter({
        frame: "circle_fx_3",
        scale: {start: 0.8, end: 1.4, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.CubicOut},
        lifespan: 900,
        on: false
      });
    }
    addFallingItemsEmitters() {
      let config2 = {
        frame: ItemTypeUtil.getFrameByItemType(ItemType.CHOCOLATE_COMMON),
        gravityY: 2e3,
        speedY: -300,
        alpha: {start: 1, end: 0, ease: Ease.ExpoIn},
        lifespan: 1e3,
        on: false
      };
      this.fallingItemRight = this.aboveItemsParticles.createEmitter(__spreadProps(__spreadValues({}, config2), {
        speedX: {min: 50, max: 110},
        rotate: {start: 0, end: 45}
      }));
      this.fallingItemLeft = this.aboveItemsParticles.createEmitter(__spreadProps(__spreadValues({}, config2), {
        speedX: {min: -50, max: -110},
        rotate: {start: 0, end: -45}
      }));
    }
  };

  // src/scenes/gameplay/hints/MatchHint.ts
  var MatchHint = class extends Phaser.Events.EventEmitter {
    constructor(scene, move) {
      super();
      this.scene = scene;
      this.move = move;
      let [mainItem, otherItem] = this.sortByItemType(move.swap, move.match.itemsType);
      let point_1 = this.convertVectorToPoint(gridToPixels(mainItem.column, mainItem.row));
      let point_2 = this.convertVectorToPoint(gridToPixels(otherItem.column, otherItem.row));
      this.mainItem = mainItem;
      this.mainItemTargetPosition = Phaser.Geom.Point.Interpolate(point_1, point_2, 0.2);
      this.matchItems = move.match.items;
    }
    sortByItemType(swap, itemType) {
      let {item_1, item_2} = swap;
      if (item_2.itemType === itemType) {
        return [item_2, item_1];
      }
      return [item_1, item_2];
    }
    convertVectorToPoint(vector) {
      return new Phaser.Geom.Point(vector.x, vector.y);
    }
    show() {
      let duration = 333;
      this.matchItems.forEach((item) => {
        let {column, row} = item;
        this.scene.getHighlightAt(column, row).highlightTo({hold: duration * 3});
      });
      this.scaleTween = this.scene.tweens.add({
        targets: this.matchItems,
        duration,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.17,
        yoyo: true,
        repeat: 1
      });
      this.positionTween = this.scene.tweens.add({
        targets: this.mainItem,
        duration,
        ease: Phaser.Math.Easing.Sine.InOut,
        x: this.mainItemTargetPosition.x,
        y: this.mainItemTargetPosition.y,
        yoyo: true,
        repeat: 1,
        onComplete: () => {
          this.emit(HintEvent.COMPLETE, this);
        }
      });
    }
    getItems() {
      return this.matchItems;
    }
    destroy() {
      var _a;
      super.destroy();
      this.matchItems.forEach((item) => {
        let {column, row} = item;
        this.scene.getHighlightAt(column, row).resetHighlight();
      });
      if (this.scaleTween) {
        this.scaleTween.targets.forEach((item) => item["scale"] = 1);
        this.scaleTween.remove();
        this.scaleTween = null;
      }
      (_a = this.positionTween) == null ? void 0 : _a.remove();
      this.mainItem.alignToGrid();
    }
    smoothDestroy(duration) {
      var _a, _b;
      super.destroy();
      this.matchItems.forEach((item) => {
        let {column, row} = item;
        this.scene.getHighlightAt(column, row).resetHighlightSmooth(duration);
      });
      (_a = this.scaleTween) == null ? void 0 : _a.remove();
      this.scene.tweens.add({
        targets: this.matchItems,
        duration,
        ease: Phaser.Math.Easing.Quadratic.Out,
        scale: 1
      });
      let {x, y} = gridToPixels(this.mainItem.column, this.mainItem.row);
      (_b = this.positionTween) == null ? void 0 : _b.remove();
      this.scene.tweens.add({
        targets: this.mainItem,
        duration,
        ease: Phaser.Math.Easing.Quadratic.Out,
        x,
        y
      });
    }
  };

  // src/scenes/gameplay/hints/SpecialComboHint.ts
  var SpecialComboHint = class extends Phaser.Events.EventEmitter {
    constructor(scene, move) {
      super();
      this.scene = scene;
      this.move = move;
    }
    show() {
      let {item_1, item_2} = this.move;
      let point_1 = this.getAlignGridPosition(item_1);
      let point_2 = this.getAlignGridPosition(item_2);
      let alpha = 0.1;
      let target_1 = Phaser.Geom.Point.Interpolate(point_1, point_2, alpha);
      let target_2 = Phaser.Geom.Point.Interpolate(point_2, point_1, alpha);
      let duration = 333;
      this.tween = this.scene.tweens.add({
        targets: [item_1, item_2],
        duration,
        ease: Phaser.Math.Easing.Sine.InOut,
        x: (target) => {
          return target === item_1 ? target_1.x : target_2.x;
        },
        y: (target) => {
          return target === item_1 ? target_1.y : target_2.y;
        },
        scale: 1.17,
        yoyo: true,
        repeat: 1,
        onComplete: () => {
          this.emit(HintEvent.COMPLETE, this);
        }
      });
      let options = {hold: duration * 3};
      this.scene.getHighlightAt(item_1.column, item_1.row).highlightTo(options);
      this.scene.getHighlightAt(item_2.column, item_2.row).highlightTo(options);
    }
    getAlignGridPosition(item) {
      let pos = gridToPixels(item.column, item.row);
      return new Phaser.Geom.Point(pos.x, pos.y);
    }
    getItems() {
      return [this.move.item_1, this.move.item_2];
    }
    destroy() {
      var _a;
      super.destroy();
      (_a = this.tween) == null ? void 0 : _a.remove();
      this.tween = null;
      let {item_1, item_2} = this.move;
      item_1.alignToGrid();
      item_1.scale = 1;
      item_2.alignToGrid();
      item_2.scale = 1;
      this.scene.getHighlightAt(item_1.column, item_1.row).resetHighlight();
      this.scene.getHighlightAt(item_2.column, item_2.row).resetHighlight();
    }
    smoothDestroy(duration) {
      var _a;
      super.destroy();
      (_a = this.tween) == null ? void 0 : _a.remove();
      this.tween = null;
      let {item_1, item_2} = this.move;
      this.scene.getHighlightAt(item_1.column, item_1.row).resetHighlightSmooth(duration);
      this.scene.getHighlightAt(item_2.column, item_2.row).resetHighlightSmooth(duration);
      this.scene.tweens.add({
        targets: [item_1, item_2],
        duration,
        ease: Phaser.Math.Easing.Quadratic.Out,
        scale: 1
      });
      let {x: x1, y: y1} = gridToPixels(item_1.column, item_1.row);
      this.scene.tweens.add({
        targets: item_1,
        duration,
        ease: Phaser.Math.Easing.Quadratic.Out,
        x: x1,
        y: y1
      });
      let {x: x2, y: y2} = gridToPixels(item_2.column, item_2.row);
      this.scene.tweens.add({
        targets: item_2,
        duration,
        ease: Phaser.Math.Easing.Quadratic.Out,
        x: x2,
        y: y2
      });
    }
  };

  // src/scenes/gameplay/hints/HintsManager.ts
  var HintEvent;
  (function(HintEvent2) {
    HintEvent2["COMPLETE"] = "__COMPLETE";
  })(HintEvent || (HintEvent = {}));
  var HintsManager = class extends Phaser.Events.EventEmitter {
    constructor(scene, options) {
      super();
      this.isEnabled = true;
      this.isStarted = false;
      this.scene = scene;
      this.options = options;
    }
    start() {
      if (this.isEnabled === false) {
        return;
      }
      if (this.isStarted) {
        return;
      }
      this.bestMove = MatchHinter.findBestMove(this.scene.items, this.scene.goals.getGoalCookieTypes());
      if (!this.bestMove) {
        return;
      }
      this.isStarted = true;
      this.hint = this.createHint(this.bestMove);
      this.doStart();
    }
    doStart() {
      let {inbetweenDelayMs, inbetweenRepeats, initialDelayMs} = this.options;
      this.timerEvent = this.scene.time.delayedCall(initialDelayMs, () => {
        this.timerEvent = this.scene.time.addEvent({
          startAt: inbetweenDelayMs,
          delay: inbetweenDelayMs,
          repeat: inbetweenRepeats - 1,
          callback: () => {
            this.hint.show();
            let remaining = this.timerEvent.getRepeatCount();
            if (remaining === 0) {
              this.hint.once(HintEvent.COMPLETE, () => this.doStart());
            }
          }
        });
      });
    }
    createHint(move) {
      if (move.type === "match") {
        return new MatchHint(this.scene, move);
      } else {
        return new SpecialComboHint(this.scene, move);
      }
    }
    cancel() {
      var _a, _b;
      this.isStarted = false;
      (_a = this.timerEvent) == null ? void 0 : _a.remove();
      this.timerEvent = null;
      (_b = this.hint) == null ? void 0 : _b.destroy();
      this.hint = null;
    }
    cancelSmooth() {
      var _a, _b;
      this.isStarted = false;
      (_a = this.timerEvent) == null ? void 0 : _a.remove();
      this.timerEvent = null;
      (_b = this.hint) == null ? void 0 : _b.smoothDestroy(150);
      this.hint = null;
    }
    setInitialDelay(value) {
      if (this.options.initialDelay === value) {
        return;
      }
      this.options.initialDelay = value;
      this.options.initialDelayMs = convertHintDelayToMs(value);
      if (this.isStarted) {
        this.cancel();
        this.start();
      }
    }
    getInitialDelay() {
      return this.options.initialDelay;
    }
  };

  // src/scenes/levelEditor/levelConfig/ItemsLayoutUtil.ts
  function fixItemsLayout(items, cookieTypesGenerator, timeBudgetMs, rnd) {
    let allItems = cloneDeep_default(items);
    let cookies = getCookies(allItems);
    let nonSphereCookies = cookies.filter((cookie) => cookie.params.powerup !== CookiePowerup.SUPER_SPHERE);
    let nonLockedCookies = nonSphereCookies.filter((cookie) => !cookie.params.locked);
    let wasChanged = false;
    let start = performance.now();
    while ((MatchFinder.hasAny(nonSphereCookies) || hasDeadlock(allItems)) && performance.now() - start < timeBudgetMs) {
      randomize(nonLockedCookies, cookieTypesGenerator);
      breakAllMatches(nonSphereCookies, cookieTypesGenerator, rnd);
      wasChanged = true;
    }
    return {
      items: allItems,
      hasMatches: MatchFinder.hasAny(nonSphereCookies),
      hasDeadlock: hasDeadlock(allItems),
      wasChanged
    };
  }
  function randomizeItemsLayout(items, cookieTypesGenerator, timeBudgetMs, rnd) {
    let allLocked = items.every((item) => item.params.locked);
    if (allLocked) {
      return {
        items,
        hasMatches: MatchFinder.hasAny(items),
        hasDeadlock: hasDeadlock(items),
        wasChanged: false
      };
    }
    let allItems = cloneDeep_default(items);
    let cookies = getCookies(allItems);
    let nonSphereCookies = cookies.filter((cookie) => cookie.params.powerup !== CookiePowerup.SUPER_SPHERE);
    let nonLockedCookies = nonSphereCookies.filter((cookie) => !cookie.params.locked);
    let start = performance.now();
    do {
      randomize(nonLockedCookies, cookieTypesGenerator);
      breakAllMatches(nonSphereCookies, cookieTypesGenerator, rnd);
    } while ((MatchFinder.hasAny(nonSphereCookies) || hasDeadlock(allItems)) && performance.now() - start < timeBudgetMs);
    return {
      items: allItems,
      hasMatches: MatchFinder.hasAny(nonSphereCookies),
      hasDeadlock: hasDeadlock(allItems),
      wasChanged: true
    };
  }
  function randomize(cookies, cookiesGenerator) {
    cookies.forEach((cookie) => {
      cookie.itemType = cookiesGenerator.getItem();
    });
  }
  function breakAllMatches(nonSphereCookies, cookieTypesGenerator, rnd) {
    MatchFinder.findAll(nonSphereCookies).forEach((match) => {
      breakMatch(match, nonSphereCookies, cookieTypesGenerator, rnd);
    });
  }
  function breakMatch(match, nonSphereCookies, cookieTypesGenerator, rnd) {
    let nonLockedItems = match.items.filter((item) => !item.params.locked);
    if (nonLockedItems.length === 0) {
      return;
    }
    nonLockedItems = rnd.shuffle(nonLockedItems);
    let cookieTypes = without_default(cookieTypesGenerator.getItemTypes(), match.itemsType);
    if (nonLockedItems.length <= 3) {
      changeMatchedCookie(nonLockedItems[0], nonSphereCookies, cookieTypes, rnd);
    } else if (nonLockedItems.length > 3) {
      changeMatchedCookie(nonLockedItems[0], nonSphereCookies, cookieTypes, rnd);
      changeMatchedCookie(nonLockedItems[1], nonSphereCookies, cookieTypes, rnd);
    }
  }
  function changeMatchedCookie(cookie, nonSphereCookies, cookieTypes, rnd) {
    let {column, row} = cookie;
    let newItemType = rnd.pick(cookieTypes);
    let item = nonSphereCookies.find((item2) => item2.column === column && item2.row === row);
    item.itemType = newItemType;
  }
  function getCookies(items) {
    let allCookieTypes = ItemTypeUtil.getSubtypes(ItemSuperType.COOKIE);
    return items.filter((item) => allCookieTypes.includes(item.itemType));
  }
  function hasDeadlock(items) {
    let licorices = items.filter((item) => ItemTypeUtil.getItemSuperType(item.itemType) === ItemSuperType.LICORICE);
    let swappableItems = items.filter((item) => {
      let {column, row, itemType} = item;
      let superType = ItemTypeUtil.getItemSuperType(itemType);
      let isSwappableType = superType === ItemSuperType.COOKIE || superType === ItemSuperType.MARSHMALLOW || itemType === ItemType.DROP_ITEM;
      if (isSwappableType && licorices.some((item2) => item2.column === column && item2.row === row) === false) {
        return true;
      }
    });
    return !hasAnyComboMove(swappableItems) && !hasAnyMatchMove(swappableItems);
  }
  function hasAnyComboMove(swappableItems) {
    let cookies = swappableItems.filter((item) => ItemTypeUtil.getItemSuperType(item.itemType) === ItemSuperType.COOKIE);
    let poweredUpCookies = cookies.filter((item) => !!item.params.powerup);
    return poweredUpCookies.some((cookie) => {
      let {column, row} = cookie;
      let bottomCookie = cookies.find((item) => item.column === column && item.row === row + 1);
      if (bottomCookie) {
        if (bottomCookie.params.powerup || cookie.params.powerup === CookiePowerup.SUPER_SPHERE) {
          return true;
        }
      }
      let rightCookie = cookies.find((item) => item.column === column + 1 && item.row === row);
      if (rightCookie) {
        if (rightCookie.params.powerup || cookie.params.powerup === CookiePowerup.SUPER_SPHERE) {
          return true;
        }
      }
    });
  }
  function hasAnyMatchMove(swappableItems) {
    let cookies = swappableItems.filter((item) => {
      let isCookie2 = ItemTypeUtil.getItemSuperType(item.itemType) === ItemSuperType.COOKIE;
      return isCookie2 && item.params.powerup !== CookiePowerup.SUPER_SPHERE;
    });
    return swappableItems.some((item) => {
      let {column, row, itemType} = item;
      let bottomItem = swappableItems.find((item2) => item2.column === column && item2.row === row + 1 && item2.itemType !== itemType);
      if (bottomItem && willSwapHaveMatches(item, bottomItem, cookies)) {
        return true;
      }
      let rightItem = swappableItems.find((item2) => item2.column === column + 1 && item2.row === row && item2.itemType !== itemType);
      if (rightItem && willSwapHaveMatches(item, rightItem, cookies)) {
        return true;
      }
    });
  }
  function willSwapHaveMatches(item_1, item_2, matchableItems) {
    let {column: column_1, row: row_1} = item_1;
    let {column: column_2, row: row_2} = item_2;
    item_1.column = column_2;
    item_1.row = row_2;
    item_2.column = column_1;
    item_2.row = row_1;
    let hasMatches = MatchFinder.hasAny(matchableItems);
    item_1.column = column_1;
    item_1.row = row_1;
    item_2.column = column_2;
    item_2.row = row_2;
    return hasMatches;
  }

  // src/scenes/gameplay/GameplaySounds.ts
  var GameplaySounds = class {
    constructor(scene) {
      this.scene = scene;
      this.howler = this.scene.audio;
      this.isEnabled = this.scene.game.audioType === AudioType.WEB_AUDIO;
      this.initThrottledSounds();
    }
    initThrottledSounds() {
      let matchVolume = 0.8;
      this.match_1 = this.throttleSound(GameSoundKey.MATCH_1, {volume: 0.7});
      this.match_2 = this.throttleSound(GameSoundKey.MATCH_2, {volume: matchVolume});
      this.match_3 = this.throttleSound(GameSoundKey.MATCH_3, {volume: matchVolume});
      this.match_4 = this.throttleSound(GameSoundKey.MATCH_4, {volume: matchVolume});
      this.match_5 = this.throttleSound(GameSoundKey.MATCH_5, {volume: matchVolume});
      this.stripesCreated = this.throttleSound(GameSoundKey.STRIPES_CREATED, {volume: 0.5});
      this.bombCreated = this.throttleSound(GameSoundKey.BOMB_CREATED, {volume: 0.5});
      this.superSphereCreated = this.throttleSound(GameSoundKey.SPHERE_CREATED, {volume: 0.6});
      this.stripes = this.throttleSound(GameSoundKey.STRIPES);
      this.bomb = this.throttleSound(GameSoundKey.BOMB);
      this.bombIgnite = this.throttleSound(GameSoundKey.BOMB_IGNITE);
      this.superSphere = this.throttleSound(GameSoundKey.SUPER_SPHERE, {volume: 0.5});
      this.dropItemCollect = this.throttleSound(GameSoundKey.DROP_ITEM_COLLECT);
      this.appleCollect = this.throttleSound(GameSoundKey.APPLE_COLLECT);
      this.candyCollect = this.throttleSound(GameSoundKey.CANDY_BOTTLE_OPEN, {volume: 0.66});
      this.donutClose = this.throttleSound(GameSoundKey.DONUT_BOX_CLOSE, {volume: 0.66});
      this.donutBite = this.throttleSound(GameSoundKey.DONUT_BITE, {volume: 0.66});
      this.cookieUnlock = this.throttleSound(GameSoundKey.COOKIE_UNLOCK, {volume: 0.66});
      this.colorCakeBite = this.throttleSound(GameSoundKey.COLOR_CAKE_BITE);
      this.gummyCollect = this.throttleSound(GameSoundKey.GUMMY_COLLECT, {volume: 0.5});
      this.gummyBlockDrop = this.throttleSound(GameSoundKey.GUMMY_BLOCK_DROP, {volume: 0.4});
      this.mysteryBoxOpen = this.throttleSound(GameSoundKey.MYSTERY_BOX, {volume: 0.5});
      this.cupcake = this.throttleSound(GameSoundKey.CUPCAKE, {volume: 0.75});
      this.chick = this.throttleSound(GameSoundKey.CHICK, {volume: 0.75});
      this.generator = this.throttleSound(GameSoundKey.GENERATOR, {volume: 0.5});
      this.biscuitCollect = this.throttleSound(GameSoundKey.BISCUIT_COLLECT);
      this.goalUpdate = this.throttleSound(GameSoundKey.GOAL_UPDATE, {volume: 0.33}, {wait: 50});
      this.goalComplete = this.throttleSound(GameSoundKey.GOAL_COMPLETE, {volume: 0.66});
      this.coinAdd = this.throttleSound(GameSoundKey.COIN_ADD, {volume: 0.5}, {wait: 50});
      this.powerupToChef = this.throttleSound(GameSoundKey.TWINKLE_2, {volume: 0.66});
    }
    throttleSound(key, soundOptions, throttleOptions) {
      if (this.isEnabled === false) {
        return noop_default;
      }
      throttleOptions = __spreadValues({
        wait: 100,
        trailing: false
      }, throttleOptions);
      return throttle_default(() => {
        this.playSound(key, soundOptions);
      }, throttleOptions.wait, throttleOptions);
    }
    playSound(key, options) {
      this.howler.play(key, options);
    }
    destroy() {
    }
  };

  // src/scenes/gameplay/field/CellHighlight.ts
  var CellHighlight = class extends Phaser.GameObjects.Image {
    constructor(scene, column, row) {
      super(scene, 0, 0, "gameplay", "field_cell_highlight");
      this.column = 0;
      this.row = 0;
      this.column = column;
      this.row = row;
    }
    highlightTo(options) {
      var _a;
      this.revive();
      let targetAlpha;
      let targetScale;
      let hasBottomItemUnder = this.scene.items.bottomItems.checkAt(this.column, this.row);
      if (hasBottomItemUnder) {
        targetAlpha = 0.66;
        targetScale = 0.88;
      } else {
        targetAlpha = 1;
        targetScale = 1;
      }
      this.scale = targetScale;
      this.alpha = 0;
      (_a = this.alphaTween) == null ? void 0 : _a.remove();
      this.alphaTween = this.scene.tweens.add({
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Sine.InOut,
        alpha: targetAlpha,
        hold: options.hold,
        yoyo: true,
        onComplete: () => {
          this.kill();
        }
      });
    }
    resetHighlight() {
      var _a;
      (_a = this.alphaTween) == null ? void 0 : _a.remove();
      this.kill();
    }
    resetHighlightSmooth(duration) {
      var _a;
      (_a = this.alphaTween) == null ? void 0 : _a.remove();
      this.scene.tweens.add({
        targets: this,
        duration,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 0,
        onComplete: () => {
          this.kill();
        }
      });
    }
    destroy() {
      super.destroy();
    }
  };

  // src/scenes/gameplay/MysteryBoxContentGenerator.ts
  var MysteryBoxContentGenerator = class extends ItemsGenerator {
    constructor(config2, seed, cookiesTypesGenerator) {
      super(config2.mysteryBoxes, seed);
      this.config = config2;
      this.cookieTypesGenerator = cookiesTypesGenerator;
    }
    getMysteryBoxContent() {
      let superType = this.getItem();
      switch (superType) {
        case "COOKIE_BASIC":
          return {
            type: this.cookieTypesGenerator.getItem()
          };
        case "COOKIE_STRIPED":
          return {
            type: this.cookieTypesGenerator.getItem(),
            powerup: this.rnd.bool() ? CookiePowerup.HORIZONTAL_STRIPES : CookiePowerup.VERTICAL_STRIPES
          };
        case "COOKIE_BOMB":
          return {
            type: this.cookieTypesGenerator.getItem(),
            powerup: CookiePowerup.BOMB
          };
        case "COOKIE_SUPER_SPHERE":
          return {
            type: this.cookieTypesGenerator.getItem(),
            powerup: CookiePowerup.SUPER_SPHERE
          };
        case "MARSHMALLOW_COLORED":
          return {
            type: this.getColoredMarshmallowType()
          };
        default:
          return {
            type: superType
          };
      }
    }
    getColoredMarshmallowType() {
      let types = this.cookieTypesGenerator.getItemTypes().map((cookieType) => {
        switch (cookieType) {
          case ItemType.COOKIE_RED:
            return ItemType.MARSHMALLOW_RED;
          case ItemType.COOKIE_BLUE:
            return ItemType.MARSHMALLOW_BLUE;
          case ItemType.COOKIE_ORANGE:
            return ItemType.MARSHMALLOW_ORANGE;
          case ItemType.COOKIE_PURPLE:
            return ItemType.MARSHMALLOW_PURPLE;
          case ItemType.COOKIE_PINK:
            return ItemType.MARSHMALLOW_PINK;
          case ItemType.COOKIE_YELLOW:
            return ItemType.MARSHMALLOW_YELLOW;
          default:
            return ItemType.MARSHMALLOW_COMMON;
        }
      });
      return this.rnd.pick(types);
    }
  };

  // src/scenes/gameplay/activate-pregame-boosters.ts
  function activatePregameBoosters(scene) {
    let boosters = scene.initData.pregameBoosters;
    let cookies = getCookiesForPregameBoosters(scene, boosters.length);
    if (cookies.length === 0) {
      return Promise.resolve();
    }
    return new Promise((resolve) => {
      let staggerDelay = 100;
      let completeCallback = after_default(cookies.length, () => {
        scene.sys.queueDepthSort();
        resolve();
      });
      cookies.forEach((cookie, index) => {
        let booster = boosters[index];
        let powerUp = getCookiePowerupByPregameBooster(booster, scene.rnd);
        scene.game.pregameBoosters.getByType(booster).num--;
        scene.game.analytics.subtractResource(ResourceCurrency.PREGAME_BOOSTERS, 1, booster, `Level_${scene.levelNumber}`);
        scene.time.delayedCall(index * staggerDelay, () => {
          sendPregameBoosterCharge(scene, cookie, powerUp, completeCallback);
        });
      });
    });
  }
  function getCookiesForPregameBoosters(scene, cookiesNum) {
    let powerupLessCookies = scene.items.getCookiesWithoutPowerups();
    let [unblocked, blocked] = partition_default(powerupLessCookies, (cookie) => scene.items.hasLicoriceOver(cookie) === false);
    let unblockedShuffled = scene.rnd.shuffle(unblocked);
    let cookies = unblockedShuffled.slice(0, cookiesNum);
    if (cookies.length < cookiesNum) {
      let blockedShuffled = scene.rnd.shuffle(blocked);
      let remaining = blockedShuffled.slice(0, cookiesNum - cookies.length);
      cookies.push(...remaining);
    }
    return cookies;
  }
  function getCookiePowerupByPregameBooster(boosterType, rnd) {
    switch (boosterType) {
      case PregameBoosterType.STRIPES:
        return rnd.bool() ? CookiePowerup.HORIZONTAL_STRIPES : CookiePowerup.VERTICAL_STRIPES;
      case PregameBoosterType.BOMB:
        return CookiePowerup.BOMB;
      case PregameBoosterType.SUPER_SPHERE:
        return CookiePowerup.SUPER_SPHERE;
      default:
        let x = boosterType;
        break;
    }
  }
  function sendPregameBoosterCharge(scene, cookie, powerUp, onComplete) {
    let duration = 700;
    let deltaY = 700;
    let charge = scene.add.image(0, 0, "gameplay", "cracker_hit_particle");
    charge.x = cookie.x;
    charge.y = cookie.y - deltaY;
    charge.angle = 180;
    charge.scale = 9;
    charge.setDepth(GameplayDepth.POWERUP_FX);
    scene.time.delayedCall(duration / 2, () => {
      scene.audio.play(GameSoundKey.BOOSTER_WHOOSH, {volume: 0.5});
    });
    charge.alpha = 0;
    scene.tweens.add({
      targets: charge,
      duration: 150,
      ease: Phaser.Math.Easing.Cubic.Out,
      alpha: 1
    });
    scene.tweens.add({
      targets: charge,
      duration,
      ease: Phaser.Math.Easing.Linear,
      scale: 2.2
    });
    scene.tweens.add({
      targets: charge,
      duration,
      ease: Phaser.Math.Easing.Quadratic.In,
      x: cookie.x,
      y: cookie.y,
      onComplete: () => {
        onPregameBoosterLand(scene, cookie, powerUp, onComplete);
        charge.destroy();
      }
    });
  }
  function onPregameBoosterLand(scene, cookie, powerUp, onComplete) {
    scene.emitters.pregameBoosterCircles.emitParticle(1, cookie.x, cookie.y);
    scene.emitters.pregameBoosterSparks.emitParticle(20, cookie.x, cookie.y);
    let newCookie = scene.applyPowerupToCookie(cookie, powerUp);
    scene.tweens.add({
      targets: newCookie,
      duration: 166,
      ease: Phaser.Math.Easing.Sine.InOut,
      scale: 1.25,
      yoyo: true
    });
    scene.audio.play(GameSoundKey.BOOSTER_LAND);
    onComplete();
  }

  // src/scenes/gameplay/GameplayTests.ts
  var GameplayTests = class extends Phaser.Events.EventEmitter {
    constructor(scene) {
      super();
      this.scene = scene;
    }
    onCreate(delay = 0) {
      this.scene.time.delayedCall(delay, () => {
      });
    }
    onGuiCreate(delay = 0) {
      this.scene.time.delayedCall(delay, () => {
        this.doStartTestSwap();
      });
    }
    doStartTestSwap() {
      let swap = UrlParams.get("swap");
      if (swap && swap.includes("x")) {
        let [pos_1, pos_2] = swap.split("x");
        if (pos_1 && pos_2) {
          this.testSwapItems(pos_1, pos_2);
        }
      }
    }
    testSwapItems(position_1, position_2) {
      let [column_1, row_1] = position_1.split(",").map((num) => parseInt(num));
      let [column_2, row_2] = position_2.split(",").map((num) => parseInt(num));
      let item1 = this.scene.items.mainItems.getAt(column_1, row_1);
      let item2 = this.scene.items.mainItems.getAt(column_2, row_2);
      if (item1 && item2) {
        if (this.scene.itemsSwapper.canBeSwapped(item1) && this.scene.itemsSwapper.canBeSwapped(item2)) {
          this.scene.itemsSwapper.swapItems(item1, item2);
        }
      }
    }
    testPreCompleteScreen() {
      this.scene.hint.cancel();
      this.scene.lock();
      this.scene.onLevelPreComplete();
    }
    testLevelCompleteScreenClean() {
      this.scene.game.store.removeLevelResult(this.scene.levelNumber);
      this.scene.onLevelComplete();
    }
    testLevelCompleteScreen() {
      this.scene.onLevelComplete();
    }
    testLevelCompleteScreenWithGift() {
      this.scene.game.store.saveValue(GameStoreKey.GIFT_STARS_NUM, this.scene.game.gifts.getTargetStars());
      this.scene.onLevelComplete();
    }
    testLevelFailedScreen() {
      let data = {
        levelNumber: this.scene.levelNumber,
        goals: this.scene.goals.save()
      };
      this.scene.gui.addFailedScreen();
      this.scene.gui.failedScreen.updateData(data);
      this.scene.gui.failedScreen.show({smooth: true});
    }
    testBoosterRewardScreen(boosterType) {
      this.scene.boosters.testBoosterSelect(boosterType);
    }
  };

  // src/scenes/gameplay/Gameplay.ts
  var import_types3 = __toModule(require("@sentry/types"));

  // src/scenes/gameplay/session/GameplaySession.ts
  var GameplaySessionWrapper = class {
    constructor(gameplay) {
      this.session = {
        level: gameplay.levelNumber,
        pregameBoosters: gameplay.initData.pregameBoosters,
        rndSeed: gameplay.initData.rndSeed,
        actions: []
      };
    }
    pushAction(action) {
      this.session.actions.push(__spreadValues({step: this.session.actions.length + 1}, action));
    }
    toString(pretty = false) {
      return JSON.stringify(this.session, null, pretty ? 4 : 0);
    }
  };

  // src/scenes/gameplay/Gameplay.ts
  var ScaleModes2 = Phaser.Scale.ScaleModes;
  var GameplayEvent;
  (function(GameplayEvent2) {
    GameplayEvent2["SWAP_COMPLETE"] = "__SWAP_COMPLETE";
    GameplayEvent2["TURN_COMPLETE"] = "__TURN_COMPLETE";
    GameplayEvent2["UNDO_COMPLETE"] = "__UNDO_COMPLETE";
    GameplayEvent2["LEVEL_START"] = "__LEVEL_START";
  })(GameplayEvent || (GameplayEvent = {}));
  var Gameplay2 = class extends BaseScene {
    init(data) {
      var _a;
      super.init(data);
      this.levelNumber = data.levelConfig.levelNumber;
      this.levelConfig = data.levelConfig;
      this.initGoalsManager();
      this.boosters = null;
      this.moves = this.levelConfig.moves;
      this.isLocked = false;
      this.isLevelPreComplete = false;
      this.secondChancesUsedNum = 0;
      this.maxSecondChances = window.game.config.ads.rewarded ? 2 : 1;
      (_a = this.sounds) != null ? _a : this.sounds = new GameplaySounds(this);
      this.tester = null;
      this.session = new GameplaySessionWrapper(this);
      this.rnd = new Phaser.Math.RandomDataGenerator(this.initData.rndSeed);
    }
    initGoalsManager() {
      this.goals = new GoalsManager(this, this.levelConfig.goals);
      this.goals.on(GoalsManagerEvent.GOAL_COMPLETE, this.onGoalComplete, this);
    }
    onGoalComplete(goal) {
      var _a;
      if (goal.type === GoalType.DROP_ITEM) {
        (_a = this.field) == null ? void 0 : _a.hideBottomCellPointers();
      }
    }
    create() {
      this.sendAnalyticsOnStart();
      this.camera = new GameplayCamera(this);
      this.setCustomDepthSort();
      this.addField();
      this.addCellHightlights();
      this.addPointerHighlight();
      this.addGenerators();
      this.addFactory();
      this.addFieldLabels();
      this.addItems();
      this.addUndoHandler();
      this.addItemsSwapper();
      this.addItemsDropper();
      this.addGameplayEmitters();
      this.calculateGridDimensions();
      this.addHintsManager();
      this.itemsShuffler = new ItemsShuffler(this);
      this.specialCombosHandler = new CookiesSpecialComboHandler(this, this.items);
      this.powerupsHandler = new CookiesPowerupsHandler(this);
      this.dropItemsManager = new DropItemsManager(this);
      this.addPointerCallbacks();
      this.addKeyboardCallbacks();
      if (Main.development) {
        this.tester = new GameplayTests(this);
        this.tester.onCreate(100);
      }
    }
    sendAnalyticsOnStart() {
      let isLevelComplete = this.game.store.isLevelComplete(this.levelNumber);
      if (isLevelComplete) {
        return;
      }
      this.analytics.sendLevelStart(this.levelNumber);
    }
    setCustomDepthSort() {
      let sortMethod = this.sys.displayList.sortByDepth;
      let isOriginalSort = sortMethod.name === "sortByDepth";
      if (isOriginalSort === false) {
        return;
      }
      this.sys.displayList.sortByDepth = (childA, childB) => {
        if (this.isGameItem(childA) && this.isGameItem(childB)) {
          if (childA.depth === childB.depth) {
            return childA.row - childB.row;
          }
        }
        return sortMethod(childA, childB);
      };
    }
    isGameItem(gameObject) {
      return gameObject.hasOwnProperty("itemType");
    }
    addField() {
      this.field = new GameField(this, this.levelConfig);
      this.field.setDepth(GameplayDepth.FIELD);
      this.field.y = 1;
      this.add.existing(this.field);
    }
    addCellHightlights() {
      this.cellHighlights = new GridArray(this.levelConfig.grid.rows, this.levelConfig.grid.columns);
      this.field.cells.forEach((cell) => {
        let position = gridToPixels(cell.column, cell.row);
        let highlight = new CellHighlight(this, cell.column, cell.row);
        highlight.setPosition(position.x, position.y);
        highlight.setDepth(GameplayDepth.HIGHLIGHTS);
        highlight.kill();
        this.cellHighlights.add(highlight);
        this.add.existing(highlight);
      });
    }
    addPointerHighlight() {
      let isDesktop = this.game.scale.scaleMode === ScaleModes2.FIT;
      if (isDesktop === false) {
        return;
      }
      this.pointerHighlight = this.add.image(0, 0, "gameplay", "field_cell_highlight");
      this.pointerHighlight.setDepth(GameplayDepth.HIGHLIGHTS);
      this.pointerHighlight.kill();
    }
    getHighlightAt(column, row) {
      return this.cellHighlights.getAt(column, row);
    }
    addGenerators() {
      let weights = this.levelConfig.generator.weights;
      let _a = weights, {MYSTERY_BOX} = _a, cookieWeights = __objRest(_a, ["MYSTERY_BOX"]);
      let seed = this.initData.rndSeed;
      this.itemTypesGenerator = new ItemsGenerator(weights, seed);
      this.cookieTypesGenerator = new ItemsGenerator(cookieWeights, seed);
      this.mysteryBoxContentGenerator = new MysteryBoxContentGenerator(this.levelConfig, seed, this.cookieTypesGenerator);
    }
    addFactory() {
      this.itemsFactory = new ItemsFactory(this);
    }
    addFieldLabels() {
      if (Main.development === false) {
        return;
      }
      this.fieldLabels = new CellLabels(this, this.field);
      this.fieldLabels.kill();
      this.fieldLabels.setDepth(GameplayDepth.DEBUG);
      this.add.existing(this.fieldLabels);
    }
    addItems() {
      let {columns, rows} = this.levelConfig.grid;
      let itemsConfig = this.getStartItemsLayout();
      this.items = new ItemsManager(columns, rows);
      this.items.addItemsFromConfig(this.itemsFactory, itemsConfig);
      let hideItems = UrlParams.getBool("hideItems");
      if (hideItems) {
        this.items.bottomItems.forEach((item) => item.kill());
        this.items.mainItems.forEach((item) => item.kill());
        this.items.topItems.forEach((item) => item.kill());
      }
    }
    getStartItemsLayout() {
      let result = randomizeItemsLayout(this.levelConfig.items, this.cookieTypesGenerator, 100, this.rnd);
      return result.hasMatches || result.hasDeadlock ? this.levelConfig.items : result.items;
    }
    addUndoHandler() {
      this.undoHandler = new UndoHandler(this);
      this.undoHandler.on(UndoHandlerEvent.RESTORE, this.onRestore, this);
    }
    onRestore(undoHandler, restoredState) {
      this.gui.topPanel.goalsPanel.updateData(restoredState.goals);
      this.gui.topPanel.movesLabel.updateMovesNum(restoredState.moves, true);
    }
    addItemsSwapper() {
      this.itemsSwapper = new ItemsSwapper(this);
      this.itemsSwapper.on(ItemsSwapperEvent.SWAP_START, this.onItemsSwapStart, this);
      this.itemsSwapper.on(ItemsSwapperEvent.SWAP_COMPLETE, this.onItemsSwapComplete, this);
    }
    addItemsDropper() {
      this.itemsDropper = new DropManager(this);
      this.itemsDropper.on(DropManagerEvent.DROP_START, this.onDropStart, this);
      this.itemsDropper.on(DropManagerEvent.DROP_COMPLETE, this.onDropComplete, this);
    }
    onDropStart() {
    }
    onDropComplete() {
      this.sys.queueDepthSort();
      this.checkFieldForMatches();
    }
    addGameplayEmitters() {
      this.emitters = new GameplayEmitters(this);
      let hasColorCakes = this.levelConfig.items.some((item) => item.itemType === ItemType.COLOR_CAKE);
      if (hasColorCakes) {
        this.emitters.addColorCakeEmitters();
      }
      let hasCandyBottles = this.levelConfig.items.some((item) => item.itemType === ItemType.CANDY_BOTTLE);
      let hasCandyBottlesInMysteryBoxes = this.levelConfig.mysteryBoxes.CANDY_BOTTLE > 0;
      if (hasCandyBottles || hasCandyBottlesInMysteryBoxes) {
        this.emitters.addCandyBottleEmitters();
      }
    }
    calculateGridDimensions() {
      let cells = this.field.cells.toArray();
      let generators = this.items.generators.toArray();
      let items = [...cells, ...generators];
      this.gridDimensions = calculateDimensions(items);
    }
    addHintsManager() {
      let initialDelay = this.game.store.getValue(GameStoreKey.HINT_DELAY);
      let options = {
        initialDelay,
        initialDelayMs: convertHintDelayToMs(initialDelay),
        inbetweenDelayMs: 2200,
        inbetweenRepeats: 3
      };
      this.hint = new HintsManager(this, options);
    }
    checkFieldForMatches() {
      return __async(this, null, function* () {
        let dropItemsWereRemoved = this.dropItemsManager.process();
        if (dropItemsWereRemoved) {
          this.itemsDropper.startPreDropTimer(100);
          return;
        }
        let matchableItems = this.items.mainItems.filter((item) => item.isMatchable);
        let matches = MatchFinder.findAll(matchableItems);
        if (matches.length > 0) {
          this.matchesStep++;
          this.processMatches(matches);
          this.itemsShuffler.resetShufflesInRow();
          return;
        }
        yield this.waitForPowerupsToChef();
        yield this.waitForPowerupsFromChef();
        if (this.isLevelComplete()) {
          this.onGoalsComplete();
          return;
        }
        if (this.isLevelFailed()) {
          this.onLevelFailed();
          return;
        }
        let isDeadlock = MatchHinter.isDeadlock(this.items);
        if (isDeadlock) {
          this.shuffleItems();
          return;
        }
        if (isDeadlock === false) {
          this.itemsShuffler.resetShufflesInRow();
        }
        let showMovesWarning = this.gui.movesWarning.movesNum === this.moves && this.secondChancesUsedNum === 0;
        if (showMovesWarning) {
          this.gui.movesWarning.show();
          this.audio.play(GameSoundKey.MOVES_WARNING);
        }
        if (this.gui.tutorial) {
          this.events.emit(GameplayEvent.TURN_COMPLETE, this);
          return;
        }
        this.closeDonutBoxes();
        this.hint.start();
        this.unlock();
        this.events.emit(GameplayEvent.TURN_COMPLETE, this);
      });
    }
    waitForPowerupsToChef() {
      return new Promise((resolve, reject) => {
        let powerupChef = this.gui.powerupChef;
        let hasChargesInMotion = powerupChef.getChargesInMotionNum() > 0;
        if (hasChargesInMotion === false) {
          return resolve();
        }
        powerupChef.once(PowerupChefManagerEvent.ALL_CHARGES_ARRIVED, () => resolve());
      });
    }
    waitForPowerupsFromChef() {
      return new Promise((resolve, reject) => __async(this, null, function* () {
        let powerupChef = this.gui.powerupChef;
        if (powerupChef.isPowerupReady() === false) {
          return resolve();
        }
        let cookie = this.getCookieForChefPowerup();
        if (cookie === void 0) {
          console.error("Can't use chef charge!");
          this.sendCantUseChefChargeSentryMessage();
          return resolve();
        }
        yield powerupChef.sendChargeFromChef(cookie);
        yield this.waitForPowerupsFromChef();
        resolve();
      }));
    }
    isLevelComplete() {
      return this.goals.areComplete();
    }
    isLevelFailed() {
      return this.moves === 0;
    }
    sendCantUseChefChargeSentryMessage() {
      return __async(this, null, function* () {
        var _a;
        (_a = this.sentry) == null ? void 0 : _a.captureMessage("Can't use chef charge", {
          level: import_types3.Severity.Warning,
          extra: {
            snapshot: yield this.sentry.getGameSnapshotAsBlob(),
            json: this.session.toString(true),
            cellsNum: this.field.getNonEmptyCellsNum(),
            itemsNum: this.items.mainItems.toArrayUniq().length,
            cookiesNum: this.items.mainItems.filter((item) => isCookie(item)).length,
            cookiesWithPowerupsNum: this.items.getCookiesWithPowerups().length,
            cookiesWithoutPowerupsNum: this.items.getCookiesWithoutPowerups().length,
            move: `${this.moves} / ${this.levelConfig.moves}`
          }
        });
      });
    }
    sendEmptyMatchSentryMessage(match) {
      return __async(this, null, function* () {
        var _a;
        let lastSwap = {};
        if (this.itemsSwapper.lastSwap) {
          let {item_1, item_2} = this.itemsSwapper.lastSwap;
          lastSwap = {
            item_1: item_1 == null ? void 0 : item_1.toString(),
            item_2: item_2 == null ? void 0 : item_2.toString()
          };
        }
        (_a = this.sentry) == null ? void 0 : _a.captureMessage("Empty match", {
          level: import_types3.Severity.Warning,
          extra: {
            snapshot: yield this.sentry.getGameSnapshotAsBlob(),
            json: this.session.toString(true),
            match: {type: match.type, result: match.result, itemsType: match.itemsType},
            lastSwap
          }
        });
      });
    }
    getCookieForChefPowerup() {
      let cookies = this.items.getCookiesWithoutPowerups();
      let nonBlockedCookies = cookies.filter((cookie) => this.items.hasLicoriceOver(cookie) === false);
      if (nonBlockedCookies.length > 0) {
        return this.rnd.pick(nonBlockedCookies);
      }
      return this.rnd.pick(cookies);
    }
    onGoalsComplete() {
      if (this.isLevelPreComplete) {
        this.onLevelComplete();
        return;
      }
      let playLevelPreComplete = () => {
        this.time.delayedCall(400, () => {
          this.onLevelPreComplete();
        });
      };
      let activeGoalItemsNum = this.gui.goalItems.getActiveItemsNum();
      if (activeGoalItemsNum === 0) {
        playLevelPreComplete();
        return;
      }
      this.gui.goalItems.on(GoalItemsManagerEvent.GOAL_ITEM_ARRIVED, () => {
        if (--activeGoalItemsNum === 0) {
          this.gui.goalItems.off(GoalItemsManagerEvent.GOAL_ITEM_ARRIVED);
          playLevelPreComplete();
        }
      });
    }
    onLevelPreComplete() {
      this.isLevelPreComplete = true;
      this.gui.onLevelPreComplete();
    }
    onLevelComplete() {
      var _a;
      this.tweens.add({
        targets: this.camera.camera,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.scene.setActive(false);
          this.scene.setVisible(false);
        }
      });
      this.saveLevelResultOnComplete();
      this.addLevelCompleteBreadcrumb();
      this.sendAnalyticsOnComplete();
      this.sendAdsWatchedDataOnComplete();
      (_a = this.gui.preCompleteScreen) == null ? void 0 : _a.hide();
      this.gui.hideGuiOnLevelEnd();
      this.gui.showCompleteScreen();
    }
    saveLevelResultOnComplete() {
      let levelResult = this.game.store.getLevelResult(this.levelNumber);
      let timesFailedNum = levelResult ? levelResult.timesFailedNum : 0;
      let timesCompleteNum = levelResult ? levelResult.timesCompleteNum + 1 : 1;
      let timesAlmostCompleteNum = levelResult ? levelResult.timesAlmostCompleteNum : 0;
      let pregameBoostersUsedNum = levelResult ? levelResult.pregameBoostersUsedNum + this.getPregameBoostersUsedNum() : this.getPregameBoostersUsedNum();
      let boostersUsedNum = levelResult ? levelResult.boostersUsedNum + this.boosters.boostersUsedNum : this.boosters.boostersUsedNum;
      let secondChancesNum = levelResult ? levelResult.secondChancesNum + this.secondChancesUsedNum : this.secondChancesUsedNum;
      this.game.store.saveLevelResult(this.levelNumber, {
        complete: true,
        timesFailedNum,
        timesCompleteNum,
        timesAlmostCompleteNum,
        pregameBoostersUsedNum,
        boostersUsedNum,
        secondChancesNum
      });
    }
    addLevelCompleteBreadcrumb() {
      this.sentry.addBreadcrumb({
        category: "game.flow",
        message: `Level ${this.levelNumber} complete`
      });
    }
    sendAnalyticsOnComplete() {
      let levelResult = this.game.store.getLevelResult(this.levelNumber);
      let isCompleteFirstTime = levelResult.timesCompleteNum === 1;
      if (isCompleteFirstTime === false) {
        return;
      }
      let initialMoves = this.levelConfig.moves;
      let movesLeft = this.secondChancesUsedNum > 0 ? this.moves - this.getSecondChanceTotalExtraMovesNum() : this.moves;
      let movesSpent = initialMoves - movesLeft;
      this.analytics.sendLevelComplete(this.levelNumber, movesLeft);
      let levelStr = `Level_${this.levelNumber.toString().padStart(3, "0")}`;
      this.analytics.sendDesignEvent(`PregameBoostersUsed:${levelStr}`, levelResult.pregameBoostersUsedNum);
      this.analytics.sendDesignEvent(`BoostersUsed:${levelStr}`, levelResult.boostersUsedNum);
      this.analytics.sendDesignEvent(`SecondChance:${levelStr}`, levelResult.secondChancesNum);
      if (this.moves <= 1) {
        this.analytics.sendDesignEvent(`Wow:${levelStr}`);
      }
      this.analytics.sendDesignEvent(`Fuuu:${levelStr}`, this.calculateFuuuFactor(levelResult));
    }
    calculateFuuuFactor(levelResult) {
      let {timesFailedNum, timesAlmostCompleteNum} = levelResult;
      if (timesAlmostCompleteNum === 0) {
        return timesFailedNum;
      }
      return timesFailedNum / timesAlmostCompleteNum;
    }
    sendAdsWatchedDataOnComplete() {
      let shouldSend = this.levelNumber % 25 === 0;
      if (shouldSend === false) {
        return;
      }
      let levelResult = this.game.store.getLevelResult(this.levelNumber);
      let isCompleteFirstTime = levelResult.timesCompleteNum === 1;
      if (isCompleteFirstTime === false) {
        return;
      }
      let eventPrefix = `Ad:Watched:Level_${this.levelNumber.toString().padStart(3, "0")}`;
      this.analytics.sendDesignEvent(`${eventPrefix}:Interstitials`, this.game.store.getNumber(GameStoreKey.INTERSTITIAL_ADS_WATCHED));
      this.analytics.sendDesignEvent(`${eventPrefix}:Rewarded`, this.game.store.getNumber(GameStoreKey.REWARDED_ADS_WATCHED));
    }
    saveLevelResultOnFail() {
      let saveData;
      let levelResult = this.game.store.getLevelResult(this.levelNumber);
      let isLevelAlmostComplete = this.isLevelAlmostComplete();
      if (levelResult) {
        saveData = {
          complete: levelResult.complete,
          timesFailedNum: levelResult.timesFailedNum + 1,
          timesCompleteNum: levelResult.timesCompleteNum,
          timesAlmostCompleteNum: levelResult.timesAlmostCompleteNum + (isLevelAlmostComplete ? 1 : 0),
          pregameBoostersUsedNum: levelResult.pregameBoostersUsedNum + this.getPregameBoostersUsedNum(),
          boostersUsedNum: levelResult.boostersUsedNum + this.boosters.boostersUsedNum,
          secondChancesNum: levelResult.secondChancesNum + this.secondChancesUsedNum
        };
      } else {
        saveData = {
          complete: false,
          timesFailedNum: 1,
          timesCompleteNum: 0,
          timesAlmostCompleteNum: isLevelAlmostComplete ? 1 : 0,
          pregameBoostersUsedNum: this.getPregameBoostersUsedNum(),
          boostersUsedNum: this.boosters.boostersUsedNum,
          secondChancesNum: this.secondChancesUsedNum
        };
      }
      this.game.store.saveLevelResult(this.levelNumber, saveData);
    }
    isLevelAlmostComplete() {
      let incompleteGoals = this.goals.getIncompleteGoals();
      return incompleteGoals.every((goal) => {
        let itemsLeft = goal.targetNum - goal.collectedNum;
        switch (goal.type) {
          case GoalType.BISCUIT:
          case GoalType.MARSHMALLOW:
          case GoalType.CHOCOLATE:
          case GoalType.APPLE:
          case GoalType.LICORICE:
          case GoalType.CANDY:
          case GoalType.DONUT:
          case GoalType.DROP_ITEM:
          case GoalType.GUMMY:
            return itemsLeft === 1;
          case GoalType.CHICK:
            return itemsLeft <= 2;
          case GoalType.COOKIE_RED:
          case GoalType.COOKIE_BLUE:
          case GoalType.COOKIE_ORANGE:
          case GoalType.COOKIE_PURPLE:
          case GoalType.COOKIE_PINK:
          case GoalType.COOKIE_YELLOW:
            return itemsLeft <= 3;
          default:
            let x = goal.type;
            return false;
        }
      });
    }
    getPregameBoostersUsedNum() {
      return this.initData.pregameBoosters.filter(Boolean).length;
    }
    addLevelFailedBreadcrumb() {
      this.sentry.addBreadcrumb({
        category: "game.flow",
        message: `Level ${this.levelNumber} failed`
      });
    }
    sendAnalyticsOnFail() {
      let isLevelComplete = this.game.store.isLevelComplete(this.levelNumber);
      if (isLevelComplete) {
        return;
      }
      let incompleteGoals = this.goals.getIncompleteGoals();
      let itemsLeft = incompleteGoals.reduce((acc, goal) => {
        acc += goal.targetNum - goal.collectedNum;
        return acc;
      }, 0);
      this.analytics.sendLevelFail(this.levelNumber, itemsLeft);
    }
    onLevelFailed() {
      let completeCallback = () => {
        if (this.secondChancesUsedNum === this.maxSecondChances) {
          this.time.delayedCall(333, () => {
            this.showLevelFailedScreen({smooth: true});
          });
        } else {
          this.showSecondChanceScreen();
        }
      };
      let activeGoalItemsNum = this.gui.goalItems.getActiveItemsNum();
      if (activeGoalItemsNum === 0) {
        completeCallback();
        return;
      }
      this.gui.goalItems.on(GoalItemsManagerEvent.GOAL_ITEM_ARRIVED, () => {
        if (--activeGoalItemsNum === 0) {
          this.gui.goalItems.off(GoalItemsManagerEvent.GOAL_ITEM_ARRIVED);
          this.time.delayedCall(300, () => {
            completeCallback();
          });
        }
      });
    }
    showSecondChanceScreen() {
      this.scene.pause();
      if (!this.gui.secondChanceScreen) {
        this.gui.addSecondChanceScreen();
      }
      let secondChanceScreen = this.gui.secondChanceScreen;
      secondChanceScreen.outOfMovesPopup.updateData(this.goals.save());
      secondChanceScreen.secondChancePopup.closeButton.off(ButtonEvent.PRESS);
      secondChanceScreen.secondChancePopup.closeButton.once(ButtonEvent.PRESS, this.onSecondChanceClose, this);
      secondChanceScreen.once(SecondChanceScreenEvent.PROCEED, this.giveSecondChance, this);
      secondChanceScreen.show();
    }
    onSecondChanceClose() {
      this.gui.secondChanceScreen.kill();
      this.showLevelFailedScreen({smooth: false});
      this.game.toasts.dismissAll();
    }
    giveSecondChance() {
      let movesNum = this.getSecondChanceExtraMovesNum();
      this.session.pushAction({type: "second_chance_accept"});
      this.sentry.addBreadcrumb({
        category: "game.flow",
        message: `Second chance #${this.secondChancesUsedNum + 1} (+${movesNum} moves)`
      });
      this.gui.secondChanceScreen.once(PhaserScreenEvent.HIDE_COMPLETE, this.onSecondChanceScreenHide.bind(this, movesNum));
      this.gui.secondChanceScreen.hide();
      this.undoHandler.adjustMovesAfterSecondChance(movesNum);
      this.secondChancesUsedNum++;
      this.moves += movesNum;
      this.checkFieldForMatches();
      console.log(`Second chance #${this.secondChancesUsedNum} (+${movesNum} moves)`);
    }
    getSecondChanceExtraMovesNum() {
      return VideoRewardUtils.getRewardNum(VideoRewardType.EXTRA_MOVES);
    }
    getSecondChanceTotalExtraMovesNum() {
      return this.getSecondChanceExtraMovesNum() * this.secondChancesUsedNum;
    }
    onSecondChanceScreenHide(extraMovesNum) {
      let movesLabel = this.gui.topPanel.movesLabel;
      movesLabel.onExtraMovesGranted(extraMovesNum);
      let position = movesLabel.movesNumText.getWorldPosition();
      position.x += 3;
      position.y -= 7;
      this.gui.emitters.goalItemCircles.emitParticle(1, position.x, position.y);
      this.gui.emitters.goalItemSparks.setPosition(position.x, position.y);
      this.gui.emitters.goalItemSparks.explode(14, position.x, position.y);
      this.audio.play(GameSoundKey.EXTRA_MOVES);
    }
    showLevelFailedScreen(options) {
      this.game.lives.removeLife();
      this.saveLevelResultOnFail();
      this.addLevelFailedBreadcrumb();
      this.sendAnalyticsOnFail();
      let data = {
        levelNumber: this.levelNumber,
        goals: this.goals.save()
      };
      this.gui.addFailedScreen();
      this.gui.failedScreen.updateData(data);
      this.gui.failedScreen.show(options);
    }
    closeDonutBoxes() {
      this.items.getDonutBoxes().forEach((donutBox) => {
        if (donutBox.boxState === DonutBoxState.OPENED && donutBox.wasJustOpened === false) {
          donutBox.setBoxState(DonutBoxState.CLOSED);
          this.sounds.donutClose();
        }
        donutBox.wasJustOpened = false;
      });
    }
    onItemsSwapStart(item_1, item_2) {
      this.cancelHint(item_1, item_2);
      this.showSwapFx(item_1, item_2);
      this.undoHandler.save();
      this.lock();
    }
    cancelHint(item_1, item_2) {
      if (!this.hint.hint) {
        return;
      }
      let hintedItems = this.hint.hint.getItems();
      if (hintedItems.includes(item_1) || hintedItems.includes(item_2)) {
        this.hint.cancel();
      } else {
        this.hint.cancelSmooth();
      }
    }
    showSwapFx(item_1, item_2) {
      this.getHighlightAt(item_1.column, item_1.row).highlightTo({hold: 200});
      this.getHighlightAt(item_2.column, item_2.row).highlightTo({hold: 200});
    }
    onItemsSwapComplete(item_1, item_2) {
      var _a;
      this.matchesStep = 1;
      let specialComboType = getCookiesSpecialCombo(item_1, item_2);
      if (specialComboType) {
        (_a = this.sentry) == null ? void 0 : _a.addBreadcrumb({
          category: "game",
          message: `special combo ${specialComboType}`,
          data: {
            item_1: item_1.toString(),
            item_2: item_2.toString()
          }
        });
        if (isCookie(item_1) && item_1.powerup) {
          this.gui.powerupChef.sendChargeToChef(item_1);
        }
        if (isCookie(item_2) && item_2.powerup) {
          this.gui.powerupChef.sendChargeToChef(item_2);
        }
        this.events.emit(GameplayEvent.SWAP_COMPLETE);
        this.updateMovesNum();
        this.removeItemFromGrid(item_1);
        this.removeItemFromGrid(item_2);
        this.specialCombosHandler.processSpecialCombo(item_1, item_2, specialComboType);
        this.session.pushAction({
          type: "swap",
          cell_1: {column: item_1.column, row: item_1.row},
          cell_2: {column: item_2.column, row: item_2.row}
        });
        return;
      }
      let matches = this.findMatchesAfterSwap(item_1, item_2);
      let hasMatches = matches.length > 0;
      if (hasMatches) {
        this.events.emit(GameplayEvent.SWAP_COMPLETE);
        this.updateMovesNum();
        this.processMatches(matches);
        this.session.pushAction({
          type: "swap",
          cell_1: {column: item_1.column, row: item_1.row},
          cell_2: {column: item_2.column, row: item_2.row}
        });
        return;
      }
      this.itemsSwapper.once(ItemsSwapperEvent.SWAP_BACK_COMPLETE, this.onSwapItemsBackComplete, this);
      this.itemsSwapper.swapItemsBack(item_1, item_2);
    }
    onSwapItemsBackComplete() {
      this.hint.start();
      this.undoHandler.removeLastSavedState();
      this.unlock();
    }
    findMatchesAfterSwap(item_1, item_2) {
      let items = this.items.mainItems.filter((item) => item.isMatchable && (item.itemType === item_1.itemType || item.itemType === item_2.itemType));
      let match_1 = MatchFinder.findBestMatchOf(items, item_1);
      let match_2 = MatchFinder.findBestMatchOf(items, item_2);
      return [match_1, match_2].filter(Boolean);
    }
    updateMovesNum() {
      this.moves = Math.max(0, this.moves - 1);
      this.gui.topPanel.movesLabel.updateMovesNum(this.moves, false);
    }
    processMatches(matches) {
      matches.forEach((match) => {
        let [nonBlockedCookies, blockedCookies] = this.sortMatchedCookies(match);
        nonBlockedCookies.forEach((cookie) => {
          cookie.markAsMatched(match.id);
          this.removeItemFromGrid(cookie);
          this.destroyBiscuitUnder(cookie);
          this.damageChocolateAround(cookie);
          this.damageMarshmallowsAround(cookie);
          this.updateDonutBoxesAround(cookie);
          this.updateCandyBottlesAround(cookie);
          this.updateApplePlattersAround(cookie);
          this.updateColorCakesAround(cookie);
          this.updateMysteryBoxesAround(cookie);
          this.updateGummyBlockersAround(cookie);
          this.goals.update(cookie);
        });
        nonBlockedCookies.forEach((cookie) => {
          this.powerupsHandler.processCookiePowerup(cookie);
        });
        blockedCookies.forEach((cookie) => {
          let licorice = this.items.topItems.getAt(cookie.column, cookie.row);
          if (licorice) {
            this.items.remove(licorice);
            this.destroyLicorice(licorice);
          }
        });
        if (blockedCookies.length > 0) {
          match.result = null;
        }
        match.items = nonBlockedCookies;
      });
      matches = matches.filter((match) => {
        let isEmpty = match.items.length === 0;
        if (isEmpty) {
          this.sendEmptyMatchSentryMessage(match);
        }
        return isEmpty === false;
      });
      if (matches.length === 0) {
        this.itemsDropper.startPreDropTimer(150);
        return;
      }
      matches.forEach((match) => {
        let cookies = match.items;
        let newCookie = this.createCookieFromMatch(match);
        if (newCookie) {
          newCookie.visible = false;
          this.collapseMatchIntoNewCookie(cookies, newCookie);
          this.itemsDropper.startPreDropTimer(250);
        } else {
          this.processMatchedCookies(cookies);
          this.time.delayedCall(100, () => {
            cookies.forEach((cookie) => {
              this.emitters.matchedCookieSparks.setPosition(cookie.x, cookie.y);
              this.emitters.matchedCookieSparks.explode(4, cookie.x, cookie.y);
              this.emitters.matchedCookieCircles.explode(1, cookie.x, cookie.y);
            });
          });
          this.itemsDropper.startPreDropTimer(150);
          this.playMatchSound();
        }
      });
    }
    playMatchSound() {
      if (this.matchesStep === 1) {
        this.sounds.match_1();
      } else if (this.matchesStep === 2) {
        this.sounds.match_2();
      } else if (this.matchesStep === 3) {
        this.sounds.match_3();
      } else if (this.matchesStep === 4) {
        this.sounds.match_4();
      } else {
        this.sounds.match_5();
      }
    }
    sortMatchedCookies(match) {
      let nonBlocked = [];
      let blocked = [];
      match.items.forEach((item) => {
        if (this.items.hasLicoriceOver(item)) {
          blocked.push(item);
        } else {
          nonBlocked.push(item);
        }
      });
      return [nonBlocked, blocked];
    }
    onCookieRemove(cookie, processPowerup = true) {
      this.destroyBiscuitUnder(cookie);
      this.damageChocolateAround(cookie);
      this.damageMarshmallowsAround(cookie);
      this.updateDonutBoxesAround(cookie);
      this.updateCandyBottlesAround(cookie);
      this.updateApplePlattersAround(cookie);
      this.updateColorCakesAround(cookie);
      this.updateMysteryBoxesAround(cookie);
      this.updateGummyBlockersAround(cookie);
      if (processPowerup) {
        this.powerupsHandler.processCookiePowerup(cookie);
      }
      if (this.goals.isGoalItem(cookie) && cookie.powerup !== CookiePowerup.SUPER_SPHERE) {
        this.goals.update(cookie);
        this.gui.goalItems.collectItem(cookie);
      }
    }
    removeItemFromGrid(item) {
      this.items.remove(item);
    }
    collapseMatchIntoNewCookie(cookies, newCookie) {
      let isGoal = this.goals.isGoalItem(cookies[0]);
      if (isGoal) {
        this.onCollapseMatchComplete(cookies, newCookie);
        return;
      }
      this.tweens.add({
        targets: cookies,
        duration: 200,
        ease: Phaser.Math.Easing.Back.In,
        x: newCookie.x,
        y: newCookie.y,
        alpha: 0,
        onComplete: () => {
          this.onCollapseMatchComplete(cookies, newCookie);
        }
      });
    }
    onCollapseMatchComplete(cookies, newCookie) {
      this.emitters.collapseCircles.emitParticle(3, newCookie.x, newCookie.y);
      this.emitters.collapseSparks.setPosition(newCookie.x, newCookie.y);
      this.emitters.collapseSparks.explode(10, newCookie.x, newCookie.y);
      this.playCookiePowerupCreationSound(newCookie.powerup);
      this.processMatchedCookies(cookies);
      this.showNewCookie(newCookie);
    }
    playCookiePowerupCreationSound(powerup) {
      switch (powerup) {
        case CookiePowerup.VERTICAL_STRIPES:
        case CookiePowerup.HORIZONTAL_STRIPES:
          this.sounds.stripesCreated();
          break;
        case CookiePowerup.BOMB:
          this.sounds.bombCreated();
          break;
        case CookiePowerup.SUPER_SPHERE:
          this.sounds.superSphereCreated();
          break;
        default:
          break;
      }
    }
    processMatchedCookies(cookies) {
      let isGoal = this.goals.isGoalItem(cookies[0]);
      if (isGoal) {
        cookies.forEach((cookie, index) => {
          let delay = index * 50;
          this.time.delayedCall(delay, () => {
            this.gui.goalItems.collectItem(cookie);
            cookie.kill();
          });
        });
        return;
      }
      cookies.forEach((cookie) => {
        this.tweens.add({
          targets: cookie,
          duration: 100,
          ease: Phaser.Math.Easing.Quadratic.In,
          scale: 0,
          alpha: 0,
          onComplete: () => {
            cookie.kill();
          }
        });
      });
    }
    showNewCookie(cookie) {
      cookie.visible = true;
      cookie.popOut();
    }
    destroyBiscuitUnder(item) {
      let bottomItem = this.items.bottomItems.getAt(item.column, item.row);
      if (bottomItem && isBiscuit(bottomItem)) {
        this.destroyBiscuit(bottomItem);
      }
    }
    destroyBiscuit(biscuit) {
      if (this.goals.isGoalItemType(ItemType.BISCUIT)) {
        this.gui.goalItems.collectItem(biscuit);
        this.goals.update(biscuit);
      }
      this.items.bottomItems.remove(biscuit);
      this.sounds.biscuitCollect();
      biscuit.destroy();
    }
    damageChocolateAround(cookie) {
      let {column, row} = cookie;
      let affectedChocolates = this.items.mainItems.getOrthoNeighborsArrayAt(column, row).filter((item) => item && item.itemSuperType === ItemSuperType.CHOCOLATE).filter((chocolate) => chocolate.canBeDamagedBy(cookie));
      affectedChocolates.forEach((chocolate) => {
        let wasAffectedByThisMatch = cookie.wasMatched && chocolate.matchIds.includes(cookie.matchId);
        if (wasAffectedByThisMatch) {
          return;
        }
        let wasAffectedByPowerup = cookie.wasPoweruped && chocolate.powerupIds.includes(cookie.powerupId);
        if (wasAffectedByPowerup) {
          return;
        }
        chocolate.matchIds.push(cookie.matchId);
        chocolate.powerupIds.push(cookie.powerupId);
        chocolate.damage();
        if (chocolate.isDead()) {
          this.destroyChocolate(chocolate);
        }
      });
    }
    onChocolateDamage(chocolate, currentHealth) {
      if (chocolate.isDead()) {
        return;
      }
      this.emitters.pregameBoosterCircles.emitParticle(1, chocolate.x, chocolate.y - 14);
    }
    destroyChocolate(chocolate) {
      if (this.goals.isGoalItemType(chocolate.itemType)) {
        this.goals.update(chocolate);
        this.gui.goalItems.collectItem(chocolate);
      } else {
        let emitter = Phaser.Math.RND.bool() ? this.emitters.fallingItemRight : this.emitters.fallingItemLeft;
        emitter.setFrame(chocolate.frame.name);
        emitter.explode(1, chocolate.x, chocolate.y);
      }
      this.itemsDropper.startPreDropTimer(100);
      this.items.mainItems.remove(chocolate);
      chocolate.destroy();
    }
    damageMarshmallowsAround(cookie) {
      let {column, row} = cookie;
      let affectedMarshmallows = this.items.mainItems.getOrthoNeighborsArrayAt(column, row).filter((item) => item && isMarshmallow(item) && item.canBeDamagedBy(cookie) && this.items.hasLicoriceOver(item) === false);
      affectedMarshmallows.forEach((marshmallow) => {
        let wasAffectedByThisMatch = cookie.wasMatched && marshmallow.matchIds.includes(cookie.matchId);
        if (wasAffectedByThisMatch) {
          return;
        }
        let wasAffectedByPowerup = cookie.wasPoweruped && marshmallow.powerupIds.includes(cookie.powerupId);
        if (wasAffectedByPowerup) {
          return;
        }
        marshmallow.matchIds.push(cookie.matchId);
        marshmallow.powerupIds.push(cookie.powerupId);
        marshmallow.damage();
        if (marshmallow.isDead()) {
          this.destroyMarshmallow(marshmallow);
        }
      });
    }
    onMarshmallowDamage(marshmallow, currentHealth) {
      if (marshmallow.isDead()) {
        return;
      }
      this.emitters.pregameBoosterCircles.emitParticle(1, marshmallow.x, marshmallow.y - 14);
    }
    destroyMarshmallow(mashmallow) {
      if (this.goals.isGoalItem(mashmallow)) {
        this.goals.update(mashmallow);
        this.gui.goalItems.collectItem(mashmallow);
      } else {
        let emitter = Phaser.Math.RND.bool() ? this.emitters.fallingItemLeft : this.emitters.fallingItemRight;
        emitter.setFrame(mashmallow.frame.name);
        emitter.explode(1, mashmallow.x, mashmallow.y);
      }
      this.itemsDropper.startPreDropTimer(100);
      this.items.mainItems.remove(mashmallow);
      mashmallow.destroy();
    }
    updateDonutBoxesAround(cookie) {
      let {column, row} = cookie;
      let donutBoxes = this.items.mainItems.getOrthoNeighborsArrayAt(column, row).filter((item) => item && item.itemSuperType === ItemSuperType.DONUT_BOX);
      donutBoxes.forEach((donutBox) => {
        let wasAffectedByThisMatch = cookie.wasMatched && donutBox.matchIds.includes(cookie.matchId);
        if (wasAffectedByThisMatch) {
          return;
        }
        let wasAffectedByPowerup = cookie.wasPoweruped && donutBox.powerupIds.includes(cookie.powerupId);
        if (wasAffectedByPowerup) {
          return;
        }
        donutBox.matchIds.push(cookie.matchId);
        donutBox.powerupIds.push(cookie.powerupId);
        this.updateDonutBox(donutBox);
      });
    }
    updateDonutBox(donutBox) {
      if (donutBox.boxState === DonutBoxState.CLOSED) {
        this.emitters.pregameBoosterCircles.emitParticle(1, donutBox.x, donutBox.y - 14);
        donutBox.setBoxState(DonutBoxState.OPENED);
        donutBox.wasJustOpened = true;
        return;
      }
      let isActive = this.items.mainItems.getAt(donutBox.column, donutBox.row) === donutBox;
      if (isActive === false) {
        return;
      }
      this.sounds.donutBite();
      this.items.mainItems.remove(donutBox);
      this.itemsDropper.startPreDropTimer(400);
      if (this.goals.isGoalItemType(ItemType.DONUT_BOX)) {
        this.goals.update(donutBox);
        this.gui.goalItems.collectDonut(donutBox.donut);
        donutBox.hideInstant();
      } else {
        donutBox.hide();
      }
    }
    destroyLicorice(licorice) {
      let isGoalItem = this.goals.isGoalItem(licorice);
      if (isGoalItem) {
        this.goals.update(licorice);
        this.gui.goalItems.collectItem(licorice);
      } else {
        let emitter = Phaser.Math.RND.bool() ? this.emitters.fallingItemRight : this.emitters.fallingItemLeft;
        emitter.setFrame(licorice.frame.name);
        emitter.explode(1, licorice.x, licorice.y);
      }
      this.removeItemFromGrid(licorice);
      this.sounds.cookieUnlock();
      licorice.destroy();
    }
    destroyChick(chick) {
      let isGoalItem = this.goals.isGoalItem(chick);
      if (isGoalItem) {
        this.goals.update(chick);
        this.gui.goalItems.collectItem(chick);
      }
      this.itemsDropper.startPreDropTimer(150);
      this.removeItemFromGrid(chick);
      this.sounds.cupcake();
      chick.destroy();
    }
    updateCandyBottlesAround(cookie) {
      let {column, row} = cookie;
      let candyBottles = this.items.mainItems.getOrthoNeighborsArrayAt(column, row).filter((item) => item && item.itemSuperType === ItemSuperType.CANDY_BOTTLE);
      candyBottles.forEach((candyBottle) => {
        let wasAffectedByThisMatch = cookie.wasMatched && candyBottle.matchIds.includes(cookie.matchId);
        if (wasAffectedByThisMatch) {
          return;
        }
        let wasAffectedByPowerup = cookie.powerupId && candyBottle.powerupIds.includes(cookie.powerupId);
        if (wasAffectedByPowerup) {
          return;
        }
        candyBottle.matchIds.push(cookie.matchId);
        candyBottle.powerupIds.push(cookie.powerupId);
        candyBottle.emitCandy(0);
      });
    }
    onCandyCollect(candyBottle) {
      if (this.goals.isGoalItemType(ItemType.CANDY_BOTTLE)) {
        this.goals.update(candyBottle);
        this.gui.goalItems.collectCandy(candyBottle);
        this.sounds.candyCollect();
        this.itemsDropper.startPreDropTimer(150);
      }
    }
    onCandyBottleLanded(candyBottle) {
      this.emitters.candyBottleCircles.emitParticle(1, candyBottle.x, candyBottle.y - 24);
    }
    onAppleCollect(platter, apple) {
      if (this.goals.isGoalItemType(ItemType.APPLES_PLATTER)) {
        this.goals.update(platter);
        this.gui.goalItems.collectApple(platter, apple);
      }
    }
    updateApplePlattersAround(cookie) {
      let allPlatters = this.items.getApplePlatters().filter((platter) => platter.isEmpty() === false);
      let neighborPlatters = allPlatters.filter((platter) => {
        let neighborCells = MultiCellUtils.getOrthoNeighborPositions(platter);
        let isNeighbor = neighborCells.some((cell) => cell.column === cookie.column && cell.row === cookie.row);
        return isNeighbor;
      });
      neighborPlatters.forEach((platter) => {
        let wasAffectedByThisMatch = cookie.wasMatched && platter.matchIds.includes(cookie.matchId);
        if (wasAffectedByThisMatch) {
          return;
        }
        let wasAffectedByPowerup = cookie.wasPoweruped && platter.powerupIds.includes(cookie.powerupId);
        if (wasAffectedByPowerup) {
          return;
        }
        platter.matchIds.push(cookie.matchId);
        platter.powerupIds.push(cookie.powerupId);
        this.removeApple(platter);
      });
    }
    removeApple(platter) {
      this.sounds.appleCollect();
      platter.removeApple();
      if (platter.isEmpty()) {
        this.items.remove(platter);
        this.itemsDropper.startPreDropTimer(400);
        this.emitters.fallingItemRight.setFrame(ItemTypeUtil.getFrameByItemType(platter.itemType));
        this.emitters.fallingItemRight.emitParticle(1, platter.x, platter.y);
        platter.destroy();
      }
    }
    updateColorCakesAround(cookie) {
      if (cookie.powerup === CookiePowerup.SUPER_SPHERE) {
        return;
      }
      let allCakes = this.items.getColorCakes().filter((cake) => cake.isEmpty() === false);
      let neighborCakes = allCakes.filter((wheel) => {
        let neighborCells = MultiCellUtils.getOrthoNeighborPositions(wheel);
        let isNeighbor = neighborCells.some((cell) => cell.column === cookie.column && cell.row === cookie.row);
        return isNeighbor;
      });
      neighborCakes.forEach((cake) => {
        let wasAffectedByThisMatch = cookie.wasMatched && cake.matchIds.includes(cookie.matchId);
        if (wasAffectedByThisMatch) {
          return;
        }
        if (cookie.wasPoweruped && cookie.wasMatched === false) {
          return;
        }
        cake.matchIds.push(cookie.matchId);
        cake.powerupIds.push(cookie.powerupId);
        let pieceType = COLOR_CAKE_COOKIES_MAP[cookie.itemType];
        this.removePieceFromColorCake(cake, pieceType);
      });
    }
    removePieceFromColorCake(cake, pieceType) {
      this.sounds.colorCakeBite();
      cake.removePiece(pieceType);
      if (cake.isEmpty()) {
        this.audio.play(GameSoundKey.COLOR_CAKE_INFLATE);
        let preExplosionDuraton = 1300;
        cake.once(ColorCakeEvent.EXPLODE, this.onColorCakeExplode, this);
        cake.explode(preExplosionDuraton);
        this.itemsDropper.startPreDropTimer(preExplosionDuraton + 66);
      }
    }
    onColorCakeExplode(colorCake) {
      var _a;
      (_a = this.sentry) == null ? void 0 : _a.addBreadcrumb({
        message: "color cake explosion",
        category: "game",
        data: {
          cake: colorCake.toString()
        }
      });
      this.audio.play(GameSoundKey.COLOR_CAKE_EXPLODE);
      this.items.remove(colorCake);
      let radius = this.getMaxExplosionRadius(colorCake);
      this.powerupsHandler.applyBomb(colorCake.column, colorCake.row, radius);
      this.emitters.colorCakeSparks.emitParticle(100, colorCake.x, colorCake.y);
      this.emitters.colorCakeCircles.emitParticle(1, colorCake.x, colorCake.y);
      this.camera.playZoomTween(this.camera.camera.originalZoom * 1.15);
    }
    getMaxExplosionRadius(position) {
      let {column, row} = position;
      let fieldDimesions = this.field.dimensions;
      let dx = Math.max(column - fieldDimesions.left, fieldDimesions.right - column);
      let dy = Math.max(row - fieldDimesions.top, fieldDimesions.bottom - row);
      return Math.max(dx, dy);
    }
    updateMysteryBoxesAround(cookie) {
      let {column, row} = cookie;
      let affectedBoxes = this.items.mainItems.getOrthoNeighborsArrayAt(column, row).filter((item) => item && item.itemSuperType === ItemSuperType.MYSTERY_BOX);
      affectedBoxes.forEach((box) => {
        let wasAffectedByThisMatch = cookie.wasMatched && box.matchIds.includes(cookie.matchId);
        if (wasAffectedByThisMatch) {
          return;
        }
        let wasAffectedByPowerup = cookie.wasPoweruped && box.powerupIds.includes(cookie.powerupId);
        if (wasAffectedByPowerup) {
          return;
        }
        box.matchIds.push(cookie.matchId);
        box.powerupIds.push(cookie.powerupId);
        box.open();
      });
    }
    onMysteryBoxOpen(mysteryBox) {
      this.items.remove(mysteryBox);
      this.createItemFromMysteryBox(mysteryBox);
      this.emitters.pregameBoosterCircles.emitParticle(1, mysteryBox.x, mysteryBox.y - 20);
      this.sounds.mysteryBoxOpen();
      mysteryBox.destroy();
    }
    createItemFromMysteryBox(mysteryBox) {
      let newItemConfig = mysteryBox.convertContentToGameItemConfig();
      let newItem = this.itemsFactory.create(newItemConfig);
      if (!newItem) {
        return null;
      }
      this.itemsDropper.startPreDropTimer(300);
      newItem.alpha = 0;
      this.tweens.add({
        targets: newItem,
        duration: 150,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 1
      });
      newItem.scale = 0.66;
      this.tweens.add({
        targets: newItem,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1
      });
      this.tweens.add({
        targets: newItem,
        duration: 200,
        ease: Phaser.Math.Easing.Sine.InOut,
        y: "-=20",
        yoyo: true
      });
      return newItem;
    }
    updateGummyBlockersAround(cookie) {
      let {column, row} = cookie;
      let affectedBlockers = this.items.topItems.getOrthoNeighborsArrayAt(column, row).filter((item) => item && item.itemSuperType === ItemSuperType.GUMMY_BLOCKER);
      affectedBlockers.forEach((blocker) => {
        this.destroyGummyBlocker(blocker);
      });
    }
    destroyGummyBlocker(blocker) {
      let emitter = Phaser.Math.RND.bool() ? this.emitters.fallingItemRight : this.emitters.fallingItemLeft;
      emitter.setFrame(blocker.frame.name);
      emitter.explode(1, blocker.x, blocker.y);
      this.sounds.gummyBlockDrop();
      this.removeItemFromGrid(blocker);
      blocker.destroy();
      return this.updateGummiesUnder(blocker);
    }
    updateGummiesUnder(position) {
      let item = this.items.mainItems.getAt(position.column, position.row);
      if (!item || isGummy(item) === false) {
        return false;
      }
      let gummy = item;
      let positions = MultiCellUtils.getItemPositions(gummy);
      let hasBlockersAbove = positions.some((position2) => {
        var _a;
        return ((_a = this.items.topItems.getAt(position2.column, position2.row)) == null ? void 0 : _a.itemSuperType) === ItemSuperType.GUMMY_BLOCKER;
      });
      if (hasBlockersAbove) {
        return false;
      }
      if (this.goals.isGoalItem(gummy)) {
        this.goals.update(gummy);
        this.gui.goalItems.collectGummy(gummy);
      }
      this.sounds.gummyCollect();
      this.itemsDropper.startPreDropTimer(200);
      this.removeItemFromGrid(gummy);
      gummy.destroy();
      return true;
    }
    createCookieFromMatch(match) {
      if (!match.result) {
        return null;
      }
      let lastSwap = this.itemsSwapper.lastSwap;
      let {column, row} = this.getMatchCollectPosition(match, lastSwap);
      let powerup = this.getPowerupFromMatch(match, lastSwap);
      let cookie = this.itemsFactory.createCookie(column, row, match.itemsType, powerup);
      return cookie;
    }
    getMatchCollectPosition(match, lastSwap) {
      if (lastSwap) {
        let items = match.items;
        let swappedItem = items.find((item) => lastSwap.item_1 === item || lastSwap.item_2 === item);
        if (swappedItem) {
          return {column: swappedItem.column, row: swappedItem.row};
        }
      }
      return MatchUtils.getCollectPosition(match, this.rnd);
    }
    getPowerupFromMatch(match, lastSwap) {
      if (match.result === MatchResult.STRIPES) {
        return this.getStripesPowerup(match, lastSwap);
      } else if (match.result === MatchResult.BOMB) {
        return CookiePowerup.BOMB;
      } else if (match.result === MatchResult.SUPER_SPHERE) {
        return CookiePowerup.SUPER_SPHERE;
      }
    }
    getStripesPowerup(match, lastSwap) {
      if (lastSwap) {
        let swappedItem = match.items.find((item) => lastSwap.item_1 === item || lastSwap.item_2 === item);
        if (swappedItem) {
          return lastSwap.direction === SwapDirection.VERTICAL ? CookiePowerup.VERTICAL_STRIPES : CookiePowerup.HORIZONTAL_STRIPES;
        }
      }
      return this.rnd.frac() > this.levelConfig.verticalStripesChance ? CookiePowerup.HORIZONTAL_STRIPES : CookiePowerup.VERTICAL_STRIPES;
    }
    onGuiCreated() {
      var _a;
      this.lock();
      this.addBoostersManager();
      this.showGoals();
      this.gui.events.on(GameplayGuiEvent.SEND_GAMEPLAY_SESSION, this.sendSessionToSentry, this);
      this.gui.undoButton.on(ButtonEvent.PRESS, this.onUndoButtonClick, this);
      (_a = this.tester) == null ? void 0 : _a.onGuiCreate(100);
    }
    showGoals() {
      if (this.gui.goalsScreen) {
        this.gui.goalsScreen.once(PhaserScreenEvent.HIDE_COMPLETE, this.showTutorial, this);
        this.gui.goalsScreen.show();
      } else {
        this.showTutorial();
      }
    }
    showTutorial() {
      let skipTutorial = UrlParams.getBool("skipTutorial");
      let isComplete = this.game.store.getValue(GameStoreKey.COMPLETE_TUTORIALS).includes(this.levelNumber);
      if (skipTutorial || isComplete || this.levelConfig.tutorial.autoGenerated) {
        this.onTutorialSkip();
      } else {
        this.sentry.addBreadcrumb({
          category: "game.flow",
          message: `Tutorial start - Level ${this.levelNumber}`
        });
        let tutorial = this.gui.addTutorial(this.levelConfig.tutorial);
        tutorial.once(TutorialManagerEvent.COMPLETE, this.onTutorialComplete, this);
        tutorial.showNextScreen();
      }
    }
    onTutorialSkip() {
      activatePregameBoosters(this).then(() => this.startLevel());
    }
    onTutorialComplete() {
      this.updateCompleteTutorials();
      this.analytics.sendDesignEvent(`Tutorial:Level_${this.levelNumber}:Complete`);
      this.sentry.addBreadcrumb({
        category: "game.flow",
        message: `Tutorial complete - Level ${this.levelNumber}`
      });
      let tutorialConfig = this.levelConfig.tutorial;
      let wasBoosterTutorial = tutorialConfig.steps.some((step) => step.type === TutorialStepType.BOOSTER);
      if (wasBoosterTutorial) {
        return;
      }
      activatePregameBoosters(this).then(() => this.startLevel());
    }
    updateCompleteTutorials() {
      var _a;
      let completeTutorials = (_a = this.game.store.getValue(GameStoreKey.COMPLETE_TUTORIALS)) != null ? _a : [];
      if (completeTutorials.includes(this.levelNumber) === false) {
        completeTutorials.push(this.levelNumber);
        completeTutorials.sort((a, b) => a - b);
        this.game.store.saveValue(GameStoreKey.COMPLETE_TUTORIALS, completeTutorials);
      }
    }
    startLevel() {
      let isDeadlock = MatchHinter.isDeadlock(this.items);
      if (isDeadlock) {
        this.itemsShuffler.once(ItemsShufflerEvent.SHUFFLE_COMPLETE, this.startLevel, this);
        this.itemsShuffler.shuffleItems(this.items, this.cookieTypesGenerator);
        return;
      }
      let matchableItems = this.items.mainItems.filter((item) => item.isMatchable);
      let matches = MatchFinder.findAll(matchableItems);
      if (matches.length > 0) {
        this.processMatches(matches);
        return;
      }
      if (this.levelConfig.showHintOnStart) {
        this.hint.start();
      }
      this.unlock();
      this.events.emit(GameplayEvent.LEVEL_START, this);
    }
    addBoostersManager() {
      this.boosters = new GameplayBoosters(this, this.gui);
      this.boosters.on(GameplayBoostersEvent.SELECT, this.onBoosterSelect, this);
      this.boosters.on(GameplayBoostersEvent.CANCEL, this.onBoosterCancel, this);
      this.boosters.on(GameplayBoostersEvent.ACTIVATE, this.onBoosterActivate, this);
      this.boosters.on(GameplayBoostersEvent.COMPLETE, this.onBoosterComplete, this);
    }
    onBoosterSelect() {
      this.hint.cancelSmooth();
      this.isLocked = true;
    }
    onBoosterCancel() {
      this.hint.start();
      this.isLocked = false;
    }
    onBoosterActivate(booster, column, row) {
      this.matchesStep = 1;
      this.session.pushAction({
        type: "booster",
        boosterType: booster.type,
        cell: {column, row}
      });
    }
    onBoosterComplete(booster) {
    }
    onUndoButtonClick(button) {
      if (button.undoBooster.num > 0) {
        this.applyUndo();
        return;
      }
      if (window.game.config.ads.rewarded) {
        let data = this.gui.getBoosterBuyScreenData(BoosterType.UNDO);
        this.gui.boosterBuyScreen.updateData(data);
        this.gui.boosterBuyScreen.show({showBackground: true});
      } else {
        button.shakeNumLabel();
      }
    }
    applyUndo() {
      if (!this.undoHandler.canRestore()) {
        this.audio.play(GameSoundKey.BOOSTER_CANT_USE);
        return;
      }
      this.session.pushAction({type: "undo"});
      this.game.analytics.subtractResource(ResourceCurrency.BOOSTERS, 1, BoosterType.UNDO, `Level_${this.levelNumber}`);
      this.game.sentry.addBreadcrumb({
        category: "game.flow",
        message: "Undo"
      });
      this.gui.showUndoOverlay();
      this.audio.play(GameSoundKey.UNDO);
      this.game.boosters.getByType(BoosterType.UNDO).num--;
      this.hint.cancel();
      this.undoHandler.restore();
      this.hint.start();
      this.events.emit(GameplayEvent.UNDO_COMPLETE, this);
    }
    update(time, delta) {
      super.update(time, delta);
      this.itemsSwapper.update(delta);
      this.itemsDropper.update(delta);
    }
    customResize() {
      this.camera.resize();
    }
    addPointerCallbacks() {
      if (Main.development) {
        this.input.on(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
      }
      if (this.pointerHighlight) {
        this.input.on(Phaser.Input.Events.POINTER_MOVE, this.onPointerMove, this);
      }
    }
    onPointerDown(pointer) {
      if (pointer.event.shiftKey === false) {
        return;
      }
      let {column, row} = pixelsToGridXY(pointer.worldX, pointer.worldY);
      let biscuit = this.items.bottomItems.getAt(column, row);
      let item = this.items.mainItems.getAt(column, row);
      let licorice = this.items.topItems.getAt(column, row);
      let items = [biscuit, item, licorice].filter(Boolean);
      let cellContent = items.length > 0 ? items.map((item2) => item2.itemType).join(", ") : "EMPTY";
      console.log(`[${column}, ${row}]`, cellContent);
    }
    onPointerMove(pointer) {
      var _a;
      let tutorial = (_a = this.gui) == null ? void 0 : _a.tutorial;
      if (tutorial && tutorial.getCurrentTutorialType() !== TutorialStepType.MATCH) {
        this.pointerHighlight.kill();
        return;
      }
      let {column, row} = pixelsToGridXY(pointer.worldX, pointer.worldY);
      let item = this.items.mainItems.getAt(column, row);
      if (item && item.isSwappable && this.items.hasLicoriceOver(item) === false) {
        let {x, y} = gridToPixels(column, row);
        this.pointerHighlight.x = x;
        this.pointerHighlight.y = y;
        this.pointerHighlight.revive();
        this.pointerHighlight.alpha = this.items.bottomItems.checkAt(column, row) ? 0.66 : 1;
      } else {
        this.pointerHighlight.kill();
      }
    }
    addKeyboardCallbacks() {
      if (Main.development) {
        this.onKeyDown("S", this.forceShuffle, this);
        this.onKeyDown("L", this.toggleFieldCellLabels, this);
        this.onKeyDown("BACKSPACE", this.applyUndo, this);
        this.onKeyDown("F", () => {
          var _a;
          return (_a = this.tester) == null ? void 0 : _a.testLevelFailedScreen();
        });
        this.onKeyDown("X", () => this.tester.testPreCompleteScreen());
        this.onKeyDown("Z", this.onLevelFailed, this);
        this.onKeyDown("C", this.onLevelComplete, this);
        this.onKeyDown("G", this.logGoals, this);
        this.onKeyDown("U", this.giveUndo, this);
      }
    }
    giveUndo(event) {
      let num = event.shiftKey ? 5 : 1;
      this.gui.undoButton.undoBooster.num += num;
      this.gui.undoButton.onRewardGranted();
    }
    forceShuffle() {
      if (this.isLocked) {
        return;
      }
      this.hint.cancel();
      this.shuffleItems();
    }
    logGoals() {
      console.log(this.goals.toString());
    }
    toggleFieldCellLabels() {
      if (!this.fieldLabels) {
        return;
      }
      if (this.fieldLabels.visible) {
        this.fieldLabels.kill();
      } else {
        this.fieldLabels.revive();
      }
    }
    shuffleItems() {
      this.itemsShuffler.once(ItemsShufflerEvent.SHUFFLE_COMPLETE, this.onShuffleComplete, this);
      this.itemsShuffler.shuffleItems(this.items, this.cookieTypesGenerator);
      this.audio.play(GameSoundKey.SHUFFLE);
    }
    onShuffleComplete() {
      this.sentry.addBreadcrumb({
        category: "game.flow",
        message: "shuffle complete"
      });
      this.sys.displayList.queueDepthSort();
      this.checkFieldForMatches();
    }
    applyPowerupToCookie(cookie, powerUp) {
      let {column, row, itemType} = cookie;
      cookie.kill();
      this.removeItemFromGrid(cookie);
      return this.itemsFactory.createCookie(column, row, itemType, powerUp);
    }
    lock() {
      if (this.isLocked) {
        return;
      }
      this.isLocked = true;
      this.gui.boostersPanel.disableInput();
      this.gui.undoButton.disableInteractive();
    }
    unlock() {
      if (this.isLocked === false) {
        return;
      }
      this.isLocked = false;
      this.gui.boostersPanel.enableInput();
      this.gui.undoButton.setInteractive();
    }
    sendSessionToSentry() {
      return __async(this, null, function* () {
        var _a;
        (_a = this.sentry) == null ? void 0 : _a.captureMessage("Gameplay session", {
          level: import_types3.Severity.Warning,
          extra: {
            level: this.levelNumber,
            snapshot: yield this.sentry.getGameSnapshotAsBlob(),
            json: this.session.toString(true)
          }
        });
        this.game.toasts.show({
          message: `Report was sent
${Date.now()}`,
          lifespan: 3e3
        });
      });
    }
    onShutdown() {
      var _a, _b;
      super.onShutdown();
      (_a = this.gui) == null ? void 0 : _a.events.off(GameplayGuiEvent.SEND_GAMEPLAY_SESSION, this.sendSessionToSentry, this);
      this.itemsFactory.destroy();
      this.itemsFactory = null;
      (_b = this.boosters) == null ? void 0 : _b.destroy();
      this.boosters = null;
      this.itemsSwapper.destroy();
      this.itemsSwapper = null;
      this.itemsDropper.destroy();
      this.itemsDropper = null;
    }
  };

  // src/scenes/gameplay/session/GameplaySessionPlayer.ts
  var GameplaySessionPlayerEvent;
  (function(GameplaySessionPlayerEvent2) {
    GameplaySessionPlayerEvent2["REPLAY_COMPLETE"] = "__REPLAY_COMPLETE";
  })(GameplaySessionPlayerEvent || (GameplaySessionPlayerEvent = {}));
  var GameplaySessionPlayer = class extends Phaser.Events.EventEmitter {
    constructor(scene, session, options) {
      super();
      this.scene = scene;
      this.scene.events.once("shutdown", this.destroy, this);
      this.gameplay = this.scene.gameplay;
      this.gui = this.scene.gui;
      this.session = session;
      this.actionsCopy = cloneDeep_default(this.session.actions).reverse();
      this.options = options;
      this.gameplay.hint.isEnabled = false;
      this.gameplay.fastForward.start(this.options.timescale);
      this.gui.fastForward.start(this.options.timescale);
      console.group(`Replay [actions: ${this.actionsCopy.length}]`);
      this.playNextAction();
    }
    playNextAction() {
      if (this.actionsCopy.length === 0) {
        this.onComplete();
        return;
      }
      let callback = () => {
        this.playAction(this.actionsCopy.pop());
      };
      if (this.options.delayBetweenActions > 0) {
        this.scene.time.delayedCall(this.options.delayBetweenActions, callback);
      } else {
        callback();
      }
    }
    playAction(action) {
      let _a = action, {step, type} = _a, actionData = __objRest(_a, ["step", "type"]);
      console.log(step, type, actionData);
      switch (action.type) {
        case "swap":
          let {cell_1, cell_2} = action;
          let item_1 = this.gameplay.items.mainItems.getAt(cell_1.column, cell_1.row);
          let item_2 = this.gameplay.items.mainItems.getAt(cell_2.column, cell_2.row);
          this.gameplay.events.once(GameplayEvent.TURN_COMPLETE, this.playNextAction, this);
          this.gameplay.itemsSwapper.swapItems(item_1, item_2);
          break;
        case "booster":
          let {boosterType, cell} = action;
          this.gameplay.events.once(GameplayEvent.TURN_COMPLETE, this.playNextAction, this);
          this.gameplay.boosters.applyBooster(this.scene.game.boosters.getByType(boosterType), cell.column, cell.row);
          break;
        case "undo":
          this.gameplay.events.once(GameplayEvent.UNDO_COMPLETE, this.playNextAction, this);
          this.gameplay.applyUndo();
          break;
        case "second_chance_accept":
          this.gameplay.events.once(GameplayEvent.TURN_COMPLETE, this.playNextAction, this);
          this.gameplay.giveSecondChance();
          break;
        default:
          let x = action;
          break;
      }
    }
    onComplete() {
      console.log("Replay is complete");
      console.groupEnd();
      this.gameplay.hint.isEnabled = true;
      this.gameplay.hint.start();
      this.gameplay.fastForward.stop();
      this.gui.fastForward.stop();
      this.emit(GameplaySessionPlayerEvent.REPLAY_COMPLETE, this);
    }
    destroy() {
      this.gameplay.events.off(GameplayEvent.TURN_COMPLETE, this.playNextAction, this);
      this.gameplay.events.off(GameplayEvent.UNDO_COMPLETE, this.playNextAction, this);
      super.destroy();
    }
  };

  // src/scenes/gameplay/GameplayRoot.ts
  var GameplayRoot = class extends BaseScene {
    constructor() {
      super(...arguments);
      this.canResize = false;
    }
    init(data) {
      super.init(data);
      if (this.initData.type === "play") {
        this.levelNumber = this.initData.levelNumber;
        this.initData.rndSeed = (UrlParams.getNumber("levelSeed") || Date.now()).toString();
      } else {
        this.levelNumber = this.initData.session.level;
      }
      this.levelConfig = this.game.levelConfigs.get(this.levelNumber);
      this.gameplay = null;
      this.gui = null;
      this.canResize = false;
      console.group(`Level ${this.levelNumber} (ex ${this.levelConfig.originalLevelNumber})`);
      console.log(`Goals:`, this.stringifyGoals(this.levelConfig.goals));
      console.log(`Moves:`, this.levelConfig.moves);
    }
    stringifyGoals(goals) {
      return Object.entries(goals).filter(([key, value]) => value > 0).map(([key, value]) => `${key}: ${value}`).join(", ");
    }
    preload() {
      let loader = this.game.globalScene.delayedLoader;
      let areAssetsReady = loader.areGameplayAssetsReady;
      if (areAssetsReady === false) {
        this.analytics.sendLoadingEvent("gameplay", "start");
        this.waitForGameplayAssets(loader);
      }
    }
    waitForGameplayAssets(loader) {
      this.game.loadingScreen.hidePreloader();
      this.game.loadingScreen.fadeIn();
      this.load.rexAwait(Phaser.Math.RND.uuid(), {
        callback: (onSuccess) => {
          loader.once(DelayedLoaderEvent.GAMEPLAY_ASSETS_READY, () => {
            this.analytics.sendLoadingEvent("gameplay", "complete");
            onSuccess();
          });
        }
      });
    }
    create() {
      if (!this.levelConfig) {
        console.warn(`Level ${this.levelNumber} doesn't exist!`);
        this.gotoEditor();
        return;
      }
      this.addBackground();
      this.addBlackOverlay();
      this.launchGameplay();
      this.addKeyboardCallbacks();
    }
    addBackground() {
      this.background = this.add.image(0, 0, "gameplay_bg_1");
      this.pin(this.background, 0.5, 0.5);
      this.size(this.background, ScaleType.ENVELOP);
    }
    addBlackOverlay() {
      this.blackOverlay = this.add.image(0, 0, "gameplay", "black_rect");
      this.blackOverlay.alpha = 0.75;
      this.blackOverlay.originalAlpha = this.blackOverlay.alpha;
      this.blackOverlay.kill();
      this.pin(this.blackOverlay, 0.5, 0.5);
      this.size(this.blackOverlay, ScaleType.FILL);
    }
    showBlackOverlay() {
      this.blackOverlay.revive();
      this.tweens.add({
        targets: this.blackOverlay,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: this.blackOverlay.originalAlpha
      });
    }
    hideBlackOverlay() {
      this.tweens.killTweensOf(this.blackOverlay);
      this.tweens.add({
        targets: this.blackOverlay,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.blackOverlay.kill();
        }
      });
    }
    launchGameplay() {
      let initData = this.getGameplayInitData();
      this.gameplay = this.launchScene(SceneKey.GAMEPLAY, initData);
      this.gameplay.events.once(Phaser.Scenes.Events.CREATE, this.launchGUI, this);
      this.gameplay.events.once(GameplayEvent.LEVEL_START, this.onLevelStart, this);
      this.game.sentry.trackSceneInput(this.gameplay.scene.key);
    }
    getGameplayInitData() {
      let pregameBoosters = this.initData.type === "replay" ? this.initData.session.pregameBoosters : this.initData.pregameBoosters;
      let rndSeed = this.initData.type === "replay" ? this.initData.session.rndSeed : this.initData.rndSeed;
      return {
        levelConfig: this.levelConfig,
        pregameBoosters: pregameBoosters != null ? pregameBoosters : [],
        rndSeed
      };
    }
    launchGUI() {
      this.gui = this.launchScene(SceneKey.GAMEPLAY_GUI, {
        gameplay: this.gameplay
      });
      this.gui.events.once(Phaser.Scenes.Events.CREATE, this.onGuiCreated, this);
      this.gui.events.once(GameplayGuiEvent.LEVEL_MAP_ON_COMPLETE, this.gotoLevelMapOnComplete, this);
      this.gui.events.once(GameplayGuiEvent.LEVEL_MAP_ON_FAIL, this.gotoLevelMapOnFail, this);
      this.gui.events.once(GameplayGuiEvent.GOTO_LEVEL_MAP, this.gotoLevelMap, this);
      this.gui.events.once(GameplayGuiEvent.GOTO_PREV_LEVEL, this.gotoPrevLevel, this);
      this.gui.events.once(GameplayGuiEvent.GOTO_NEXT_LEVEL, this.gotoNextLevel, this);
      this.gui.events.once(GameplayGuiEvent.RESTART_LEVEL_FROM_POPUP, this.restartLevelFromPopup, this);
      this.gui.events.once(GameplayGuiEvent.RESTART, () => this.restart());
      this.game.sentry.trackSceneInput(this.gui.scene.key);
    }
    launchScene(key, data) {
      return this.scene.launch(key, data).get(key);
    }
    onGuiCreated() {
      this.canResize = true;
      this.resize();
      this.gameplay.gui = this.gui;
      this.gameplay.onGuiCreated();
      this.gui.pauseButton.on(ButtonEvent.PRESS, this.pause, this);
      if (this.game.loadingScreen.isVisible()) {
        this.game.loadingScreen.fadeOut();
      }
    }
    onLevelStart() {
      if (this.initData.type === "replay") {
        this.startReplay(this.initData.session);
      }
    }
    startReplay(session) {
      let player = new GameplaySessionPlayer(this, session, {
        timescale: UrlParams.getNumber("replaySpeed", 1),
        delayBetweenActions: 200
      });
    }
    togglePause() {
      var _a;
      if ((_a = this.gameplay) == null ? void 0 : _a.scene.isPaused()) {
        this.resume();
      } else {
        this.pause();
      }
    }
    pause() {
      var _a, _b, _c;
      (_a = this.gameplay) == null ? void 0 : _a.scene.pause();
      (_b = this.gameplay) == null ? void 0 : _b.scene.setVisible(false);
      this.gui.pauseScreen.once(PauseScreenEvent.CLOSE, this.resume, this);
      this.gui.pauseScreen.show();
      (_c = this.sentry) == null ? void 0 : _c.addBreadcrumb({
        category: "game.flow",
        message: "pause"
      });
    }
    resume() {
      var _a, _b, _c;
      (_a = this.gameplay) == null ? void 0 : _a.scene.resume();
      (_b = this.gameplay) == null ? void 0 : _b.scene.setVisible(true);
      this.gui.pauseScreen.hide();
      (_c = this.sentry) == null ? void 0 : _c.addBreadcrumb({
        category: "game.flow",
        message: "resume"
      });
    }
    addKeyboardCallbacks() {
      if (Main.development) {
        this.onceKeyDown("R", this.onKeydownR, this);
        this.onKeyDown("P", this.togglePause, this);
        this.onceKeyDown("ESC", this.gotoLevelMap, this);
        this.onceKeyDown("LEFT", this.gotoPrevLevel, this);
        this.onceKeyDown("RIGHT", this.gotoNextLevel, this);
      }
      if (Main.editorEnabled) {
        this.onceKeyDown("E", this.gotoEditor, this);
      }
    }
    onKeydownR(event) {
      this.restart(this.initData);
    }
    gotoPrevLevel() {
      let levels = this.game.levelConfigs.getLevelNumbers();
      let currentIndex = levels.indexOf(this.levelNumber);
      let prevLevel = levels[currentIndex - 1];
      if (prevLevel) {
        this.gotoLevel(prevLevel);
      }
    }
    gotoNextLevel() {
      let levels = this.game.levelConfigs.getLevelNumbers();
      let currentIndex = levels.indexOf(this.levelNumber);
      let nextLevel = levels[currentIndex + 1];
      if (nextLevel) {
        this.gotoLevel(nextLevel);
      }
    }
    gotoLevel(levelNumber) {
      let levelExists = this.game.levelConfigs.check(levelNumber);
      if (levelExists === false) {
        console.warn(`Level ${levelNumber} doesn't exist!`);
        return;
      }
      this.changeScene(SceneKey.GAMEPLAY_ROOT, {type: "play", levelNumber});
    }
    gotoEditor() {
      this.changeScene(SceneKey.LEVEL_EDITOR_ROOT, {levelNumber: this.levelNumber});
    }
    gotoLevelMapOnComplete() {
      let data = {
        type: "complete",
        levelNumber: this.levelNumber
      };
      this.changeScene(SceneKey.LEVEL_MAP, data);
    }
    gotoLevelMapOnFail() {
      let data = {
        type: "restart",
        failedLevel: this.levelNumber
      };
      this.changeScene(SceneKey.LEVEL_MAP, data);
    }
    gotoLevelMap() {
      let data = {
        type: "basic",
        levelNumber: this.levelNumber
      };
      this.changeScene(SceneKey.LEVEL_MAP, data);
    }
    restartLevelFromPopup(pregameBoosters) {
      this.changeScene(SceneKey.GAMEPLAY_ROOT, {type: "play", levelNumber: this.levelNumber, pregameBoosters});
    }
    resize() {
      var _a, _b, _c;
      super.resize();
      if (this.canResize === false) {
        return;
      }
      (_a = this.gui) == null ? void 0 : _a.customResize();
      (_b = this.gameplay) == null ? void 0 : _b.customResize();
      (_c = this.gui) == null ? void 0 : _c.postGameplayResize();
    }
    onShutdown() {
      super.onShutdown();
      this.stopChildScenes();
      console.groupEnd();
    }
    stopChildScenes() {
      this.getChildScenes().forEach((childScene) => {
        if (childScene) {
          childScene.scene.stop();
        }
      });
      if (this.gameplay) {
        this.gameplay.events.off(Phaser.Scenes.Events.CREATE, this.launchGUI, this);
        this.gameplay.events.off(GameplayEvent.LEVEL_START, this.onLevelStart, this);
      }
      if (this.gui) {
        this.gui.events.off(Phaser.Scenes.Events.CREATE, this.onGuiCreated, this);
        this.gui.events.off(GameplayGuiEvent.LEVEL_MAP_ON_COMPLETE, this.gotoLevelMapOnComplete, this);
        this.gui.events.off(GameplayGuiEvent.LEVEL_MAP_ON_FAIL, this.gotoLevelMapOnFail, this);
        this.gui.events.off(GameplayGuiEvent.GOTO_LEVEL_MAP, this.gotoLevelMap, this);
        this.gui.events.off(GameplayGuiEvent.GOTO_PREV_LEVEL, this.gotoPrevLevel, this);
        this.gui.events.off(GameplayGuiEvent.GOTO_NEXT_LEVEL, this.gotoNextLevel, this);
        this.gui.events.off(GameplayGuiEvent.RESTART);
        this.gui.events.off(GameplayGuiEvent.RESTART_LEVEL_FROM_POPUP);
      }
    }
    getChildScenes() {
      return [this.gameplay, this.gui];
    }
  };

  // src/scenes/levelEditor/panels/EditorPanel.ts
  var EventEmitter6 = Phaser.Events.EventEmitter;
  var EditorPanel = class extends EventEmitter6 {
    constructor(scene, container, title) {
      super();
      this.scene = scene;
      this.panel = new Tweakpane({title, container});
    }
    disableInput() {
      this.panel.element.classList.add("disable-panel-input");
    }
    enableInput() {
      this.panel.element.classList.remove("disable-panel-input");
    }
    refresh() {
      this.panel.refresh();
    }
    collapse() {
      this.panel.expanded = false;
    }
    expand() {
      this.panel.expanded = true;
    }
    show() {
      this.panel.element.style.display = "block";
    }
    hide() {
      this.panel.element.style.display = "none";
    }
    destroy() {
      this.panel.dispose();
    }
  };

  // src/scenes/levelEditor/levelConfig/NewElement.ts
  var NewElement;
  (function(NewElement2) {
    NewElement2["APPLE"] = "apple";
    NewElement2["BISCUIT"] = "biscuit";
    NewElement2["CANDY_BOTTLE"] = "candy_bottle";
    NewElement2["CHOCOLATE"] = "chocolate";
    NewElement2["COLOR_CAKE"] = "color_cake";
    NewElement2["COLOR_CHOCOLATE"] = "color_chocolate";
    NewElement2["COLOR_MARSHMALLOW"] = "color_marshmallow";
    NewElement2["DONUT"] = "donut";
    NewElement2["GINGERBREAD"] = "gingerbread";
    NewElement2["LICORICE"] = "licorice";
    NewElement2["MARSHMALLOW"] = "marshmallow";
  })(NewElement || (NewElement = {}));

  // src/scenes/levelEditor/panels/LevelConfigPanel.ts
  var LevelConfigPanel = class extends EditorPanel {
    constructor(scene, container, levelConfig) {
      super(scene, container, `Level ${levelConfig.levelNumber}`);
      this.levelConfig = levelConfig;
      this.panel.addInput(this.levelConfig, "originalLevelNumber", {step: 1});
      this.panel.addInput(this.levelConfig, "verticalStripesChance", {
        step: 0.01,
        min: 0,
        max: 1,
        label: "vertical stripes"
      });
      this.panel.addInput(this.levelConfig, "hard");
      this.panel.addInput(this.levelConfig, "showHintOnStart", {label: "hint on start"});
      this.bgInput = this.panel.addInput(this.levelConfig, "background", {options: this.getBackgrounds()});
      this.panel.addInput(this.levelConfig, "newElement", {options: this.getNewElementOptions()});
      this.panel.addInput(this.levelConfig, "newItemsTypes");
    }
    getBackgrounds() {
      return [
        {text: "green", value: "background_1"},
        {text: "pink", value: "background_2"},
        {text: "night", value: "background_3"}
      ];
    }
    getNewElementOptions() {
      let newElements = Object.values(NewElement).map((value) => {
        return {text: value, value};
      });
      newElements.unshift({text: "none", value: "none"});
      return newElements;
    }
  };

  // src/scenes/levelEditor/LevelEditorDepth.ts
  var LevelEditorDepth;
  (function(LevelEditorDepth2) {
    LevelEditorDepth2[LevelEditorDepth2["BASE_GRID"] = 0] = "BASE_GRID";
    LevelEditorDepth2[LevelEditorDepth2["FIELD"] = 1] = "FIELD";
    LevelEditorDepth2[LevelEditorDepth2["BOTTOM_ITEMS"] = 2] = "BOTTOM_ITEMS";
    LevelEditorDepth2[LevelEditorDepth2["MAIN_ITEMS"] = 3] = "MAIN_ITEMS";
    LevelEditorDepth2[LevelEditorDepth2["TOP_ITEMS"] = 4] = "TOP_ITEMS";
    LevelEditorDepth2[LevelEditorDepth2["GENERATORS"] = 5] = "GENERATORS";
    LevelEditorDepth2[LevelEditorDepth2["LOCKS"] = 6] = "LOCKS";
    LevelEditorDepth2[LevelEditorDepth2["TUTORIAL"] = 7] = "TUTORIAL";
    LevelEditorDepth2[LevelEditorDepth2["SELECT_FRAMES"] = 8] = "SELECT_FRAMES";
    LevelEditorDepth2[LevelEditorDepth2["FLOATING_BUTTONS"] = 9] = "FLOATING_BUTTONS";
    LevelEditorDepth2[LevelEditorDepth2["POPOVERS"] = 10] = "POPOVERS";
  })(LevelEditorDepth || (LevelEditorDepth = {}));

  // src/scenes/levelEditor/panels/LayersPanel.ts
  var LayersPanelEvent;
  (function(LayersPanelEvent2) {
    LayersPanelEvent2["LAYER_UPDATE"] = "LayersPanel_LAYER_UPDATE";
  })(LayersPanelEvent || (LayersPanelEvent = {}));
  var LayersPanel = class extends EditorPanel {
    constructor(scene, container, layers) {
      super(scene, container, "Layers");
      Object.keys(layers).filter((layer) => layer !== LevelEditorDepth.GENERATORS.toString()).forEach((key) => {
        let label = this.getLayerLabel(parseInt(key));
        let input = this.panel.addInput(layers, key, {label});
        input.on("change", this.onLayerChange.bind(this));
      });
    }
    getLayerLabel(depth) {
      let map = {
        [LevelEditorDepth.BASE_GRID]: "grid",
        [LevelEditorDepth.FIELD]: "field",
        [LevelEditorDepth.BOTTOM_ITEMS]: "bottom",
        [LevelEditorDepth.MAIN_ITEMS]: "middle",
        [LevelEditorDepth.TOP_ITEMS]: "top",
        [LevelEditorDepth.TUTORIAL]: "tutorial"
      };
      return map[depth] || `layers_${depth}`;
    }
    onLayerChange(event) {
      this.emit(LayersPanelEvent.LAYER_UPDATE, parseInt(event.presetKey), event.value);
    }
  };

  // src/scenes/levelEditor/panels/GeneratorPanel.ts
  var GeneratorPanelEvent;
  (function(GeneratorPanelEvent2) {
    GeneratorPanelEvent2["WEIGHT_CHANGE"] = "GeneratorPanel_WEIGHT_CHANGE";
  })(GeneratorPanelEvent || (GeneratorPanelEvent = {}));
  var GeneratorPanel = class extends EditorPanel {
    constructor(scene, container, generatorConfig) {
      super(scene, container, "Generator");
      this.config = generatorConfig;
      this.addWeightsFolder();
    }
    addWeightsFolder() {
      let weights = this.config.weights;
      let weightsFolder = this.panel.addFolder({title: "Weights"});
      Object.keys(weights).forEach((itemType) => {
        weightsFolder.addInput(weights, itemType, {
          step: 1,
          min: 0,
          max: 100
        }).on("change", this.onWeightChange.bind(this, itemType));
      });
      weightsFolder.addButton({title: "Reset"}).on("click", this.resetWeights.bind(this));
      weightsFolder.addButton({title: "Enable All"}).on("click", this.enableAll.bind(this));
    }
    onWeightChange(itemType, weight) {
      this.emit(GeneratorPanelEvent.WEIGHT_CHANGE, itemType, weight);
    }
    resetWeights() {
      let defaultWeights = LevelConfigsManager.getDefaultWeights();
      Object.assign(this.config.weights, defaultWeights);
      this.refresh();
    }
    enableAll() {
      let defaultWeight = 50;
      Object.keys(this.config.weights).forEach((key) => this.config.weights[key] = defaultWeight);
      this.refresh();
    }
  };

  // src/scenes/levelEditor/panels/GoalsPanel.ts
  var GoalsPanel3 = class extends EditorPanel {
    constructor(scene, container, levelConfig) {
      super(scene, container, "Goals");
      this.goalsConfig = levelConfig.goals;
      this.panel.addInput(levelConfig, "moves", {step: 1, min: 1, max: 50});
      this.panel.addSeparator();
      this.addGoalInputs();
      this.panel.addButton({title: "Reset"}).on("click", this.resetGoals.bind(this));
    }
    addGoalInputs() {
      Object.keys(this.goalsConfig).forEach((itemType) => {
        this.panel.addInput(this.goalsConfig, itemType, {step: 1, min: 0, max: 100});
      });
    }
    resetGoals() {
      Object.keys(this.goalsConfig).forEach((key) => {
        this.goalsConfig[key] = 0;
      });
      this.refresh();
    }
  };

  // src/scenes/levelEditor/panels/ChefPowerupsPanel.ts
  var ChefPowerupsPanel = class extends EditorPanel {
    constructor(scene, container, config2, defaultConfig) {
      super(scene, container, "Chef Powerups");
      this.config = config2;
      this.defaultConfig = defaultConfig;
      this.panel.addInput(this.config, "isEnabled");
      this.panel.addInput(this.config, "powerupsNum", {min: 1, max: 20, step: 1});
      this.panel.addSeparator();
      this.addWeights();
      this.resetButton = this.panel.addButton({title: "Reset"});
      this.resetButton.on("click", this.reset.bind(this));
    }
    addWeights() {
      let keys2 = Object.values(CookiePowerup);
      keys2.forEach((key) => {
        let label = key.toLowerCase().replace("_", " ");
        this.panel.addInput(this.config, key, {min: 0, max: 100, step: 1, label});
      });
    }
    reset() {
      Object.assign(this.config, this.defaultConfig);
      this.refresh();
    }
  };

  // src/scenes/levelEditor/panels/BoostersPanel.ts
  var BoostersPanel3 = class extends EditorPanel {
    constructor(scene, container, config2) {
      super(scene, container, "Boosters");
      this.config = config2;
      Object.keys(config2).forEach((key) => {
        this.panel.addInput(this.config, key);
      });
    }
  };

  // src/scenes/levelEditor/panels/PreGameBoostersPanel.ts
  var PreGameBoostersPanel = class extends EditorPanel {
    constructor(scene, container, config2) {
      super(scene, container, "Pregame Boosters");
      this.config = config2;
      Object.keys(config2).forEach((key) => {
        this.panel.addInput(this.config, key);
      });
    }
  };

  // src/scenes/levelEditor/panels/TutorialPanel.ts
  var TutorialPanelEvent;
  (function(TutorialPanelEvent2) {
    TutorialPanelEvent2["SHOW_TUTORIAL_AREA"] = "__SHOW_TUTORIAL_AREA";
    TutorialPanelEvent2["HIDE_TUTORIAL_AREA"] = "__HIDE_TUTORIAL_AREA";
  })(TutorialPanelEvent || (TutorialPanelEvent = {}));
  var TutorialPanel = class extends EditorPanel {
    constructor(scene, container, config2) {
      super(scene, container, "Tutorial");
      this.folders = [];
      this.config = config2;
      this.panel.addSeparator();
      this.panel.addSeparator();
      this.typeInput = this.panel.addInput({type: "type"}, "type", {options: this.getStepTypes()});
      this.panel.addButton({title: "+"}).on("click", this.onAddStepButtonClick.bind(this));
      config2.steps.forEach((step) => {
        this.addStepFolder(step);
      });
    }
    getStepTypes() {
      return Object.values(TutorialStepType).map((stepType) => {
        return {text: stepType, value: stepType};
      });
    }
    onAddStepButtonClick() {
      let stepType = this.typeInput.controller.controller.value.rawValue;
      let step = this.createTutorialStep(stepType);
      this.config.steps.push(step);
      this.addStepFolder(step);
    }
    createTutorialStep(stepType) {
      switch (stepType) {
        case TutorialStepType.MATCH:
          return {
            type: TutorialStepType.MATCH,
            textKey: "",
            showHint: true,
            showDelay: 0,
            swapCell_1: {x: 0, y: 0},
            swapCell_2: {x: 0, y: 0},
            cells: [],
            areaId: 0,
            areaVisible: true
          };
        case TutorialStepType.BOOSTER:
          return {
            type: TutorialStepType.BOOSTER,
            textKey: "",
            showDelay: 0,
            boosterType: BoosterType.GLOVE,
            boosterCell: {x: 0, y: 0}
          };
        case TutorialStepType.GOALS:
          return {
            type: TutorialStepType.GOALS,
            textKey: "",
            showDelay: 0
          };
        case TutorialStepType.MOVES:
          return {
            type: TutorialStepType.MOVES,
            textKey: "",
            showDelay: 0
          };
        case TutorialStepType.CHEF:
          return {
            type: TutorialStepType.CHEF,
            textKey: "",
            showDelay: 0
          };
        case TutorialStepType.UNDO:
          return {
            type: TutorialStepType.UNDO,
            textKey: "",
            showDelay: 0
          };
      }
    }
    addStepFolder(step) {
      let stepNum = this.folders.length + 1;
      let title = `Step ${stepNum} - ${step.type}`;
      let index = stepNum;
      let folder = this.panel.addFolder({title, index});
      if (step.type === TutorialStepType.BOOSTER) {
        let pointInputOptions = {
          x: {step: 1, min: 0, max: 8},
          y: {step: 1, min: 0, max: 8}
        };
        folder.addInput(step, "boosterCell", pointInputOptions);
        folder.addInput(step, "boosterType", {options: this.getBoosterOptions()});
      }
      if (step.type === TutorialStepType.MATCH) {
        let pointInputOptions = {
          x: {step: 1, min: 0, max: 8},
          y: {step: 1, min: 0, max: 8}
        };
        folder.addInput(step, "swapCell_1", pointInputOptions);
        folder.addInput(step, "swapCell_2", pointInputOptions);
        folder.addInput(step, "areaId", {step: 1, min: 0, max: 10});
        folder.addInput(step, "areaVisible").on("change", this.onAreaVisibleCheckboxChange.bind(this, step));
        folder.addInput(step, "showHint");
      }
      folder.addInput(step, "showDelay", {step: 50, min: 0, max: 2e3});
      folder.addInput(step, "textKey", {options: this.getTutorialKeys()});
      folder.addButton({title: "-"}).on("click", this.onRemoveStepButtonClick.bind(this, folder));
      this.folders.push(folder);
    }
    onAreaVisibleCheckboxChange(step, value) {
      if (value) {
        this.emit(TutorialPanelEvent.SHOW_TUTORIAL_AREA, step.areaId);
      } else {
        this.emit(TutorialPanelEvent.HIDE_TUTORIAL_AREA, step.areaId);
      }
    }
    onRemoveStepButtonClick(folder) {
      folder.dispose();
      this.onFolderRemove(folder);
    }
    onFolderRemove(removedFolder) {
      let folderIndex = this.folders.indexOf(removedFolder);
      if (folderIndex > -1) {
        this.config.steps.splice(folderIndex, 1);
        this.folders.splice(folderIndex, 1);
        this.updateStepFolderTitles();
      }
    }
    updateStepFolderTitles() {
      this.folders.forEach((folder, index) => {
        let step = this.config.steps[index];
        folder.controller.view.titleElement.childNodes.item(0).textContent = `Step ${index + 1} - ${step.type}`;
      });
    }
    getBoosterOptions() {
      return [
        {text: BoosterType.GLOVE, value: BoosterType.GLOVE},
        {text: BoosterType.ROLLING_PIN, value: BoosterType.ROLLING_PIN},
        {text: BoosterType.LOLLIPOP, value: BoosterType.LOLLIPOP}
      ];
    }
    getTutorialKeys() {
      let tutorial = this.scene.texts.tutorial;
      return Object.keys(tutorial).map((key) => {
        return {text: key, value: key};
      });
    }
  };

  // src/scenes/levelEditor/panels/PreGameBoostersHintsPanel.ts
  var PreGameBoostersHintsPanel = class extends EditorPanel {
    constructor(scene, container, config2) {
      super(scene, container, "Pregame Boosters Hints");
      this.config = config2;
      Object.keys(config2).forEach((key) => {
        this.panel.addInput(this.config, key);
      });
    }
  };

  // src/scenes/levelEditor/panels/itemPanels/EditorItemPanel.ts
  var EditorItemPanel = class extends EditorPanel {
    constructor(scene, container, title) {
      super(scene, container, title);
      this.ignoreConfigUpdates = false;
      this.config = this.getDefaultConfig();
      this.addInputs();
      this.addResetButton();
    }
    getDefaultConfig() {
      return null;
    }
    addInputs() {
    }
    addResetButton() {
      this.panel.addButton({title: "Reset"}).on("click", this.onResetButtonClick.bind(this));
    }
    onResetButtonClick() {
      Object.assign(this.config, this.getDefaultConfig());
      this.refresh();
    }
    setItem(item) {
      this.item = item;
      this.ignoreConfigUpdates = true;
      Object.assign(this.config, this.getConfigFromItem(this.item));
      this.refresh();
      this.ignoreConfigUpdates = false;
    }
    resetItem() {
      this.item = null;
    }
    getConfigFromItem(item) {
      return null;
    }
  };

  // src/scenes/levelEditor/selection/ISelectable.ts
  var SelectableEvent;
  (function(SelectableEvent2) {
    SelectableEvent2["SELECT"] = "ISelectable_SELECT";
    SelectableEvent2["UNSELECT"] = "ISelectable_UNSELECT";
  })(SelectableEvent || (SelectableEvent = {}));

  // src/scenes/levelEditor/items/EditorItemBasic.ts
  var EditorItemBasic = class extends Phaser.GameObjects.Image {
    constructor(scene, atlas, itemType) {
      super(scene, 0, 0, atlas, ItemTypeUtil.getFrameByItemType(itemType));
      this._isSelected = false;
      this.itemType = itemType;
      this.itemSuperType = ItemTypeUtil.getItemSuperType(this.itemType);
      this.id = Phaser.Math.RND.uuid();
      this.params = {type: "basic"};
      this.setData("itemType", this.itemType);
      this.setData("itemSuperType", this.itemSuperType);
      this.setInteractive();
      this.setMulticell();
    }
    get isSelected() {
      return this._isSelected;
    }
    setMulticell() {
      this.isMultiCell = MultiCellUtils.isMulticell(this.itemType);
      if (this.isMultiCell) {
        let size = MultiCellUtils.getSize(this.itemType);
        this.itemWidth = size.width;
        this.itemHeight = size.height;
      }
    }
    updateItemType(itemType) {
      let superType = ItemTypeUtil.getItemSuperType(this.itemType);
      if (superType !== this.itemSuperType) {
        console.warn(`Can't change super type! Item ${this.itemType} at [${this.column}, ${this.row}]`);
        return;
      }
      this.itemType = itemType;
      this.setData("itemType", this.itemType);
      this.setFrame(ItemTypeUtil.getFrameByItemType(itemType));
    }
    select() {
      if (this._isSelected) {
        return;
      }
      this._isSelected = true;
      this.emit(SelectableEvent.SELECT, this);
    }
    unselect() {
      if (this._isSelected === false) {
        return;
      }
      this._isSelected = false;
      this.emit(SelectableEvent.UNSELECT, this);
    }
    destroy() {
      super.destroy();
    }
  };

  // src/scenes/levelEditor/items/EditorCookie.ts
  var EditorCookieEvent;
  (function(EditorCookieEvent2) {
    EditorCookieEvent2["POWERUP_CHANGE"] = "__POWERUP_CHANGE";
  })(EditorCookieEvent || (EditorCookieEvent = {}));
  var EditorCookie = class extends EditorItemBasic {
    constructor(scene, atlas, itemType) {
      super(scene, atlas, itemType);
    }
    setPowerup(powerup = null) {
      if (powerup === null) {
        delete this.params.powerup;
      } else {
        this.params.powerup = powerup;
      }
      this.emit(EditorCookieEvent.POWERUP_CHANGE, this, this.params.powerup);
      this.updateFrame(this.itemType, this.params.powerup);
    }
    updateFrame(type, powerup) {
      this.setFrame(CookieUtils.getFrame(type, powerup));
    }
    destroy() {
      super.destroy();
      if (this.lock) {
        this.lock.destroy();
        this.lock = null;
      }
    }
  };

  // src/scenes/levelEditor/panels/itemPanels/CookiePanel.ts
  var CookiePanel = class extends EditorItemPanel {
    constructor(scene, container, title = "Cookie") {
      super(scene, container, title);
    }
    getDefaultConfig() {
      return {
        type: ItemType.COOKIE_RED,
        powerup: "NONE"
      };
    }
    addInputs() {
      this.panel.addInput(this.config, "type", {options: this.getCookieTypes()}).on("change", this.onTypeChange.bind(this));
      this.panel.addInput(this.config, "powerup", {options: this.getPowerupTypes()}).on("change", this.onPowerupChange.bind(this));
    }
    onTypeChange(event) {
      if (this.ignoreConfigUpdates) {
        return;
      }
      this.item.updateItemType(event.value);
      this.item.updateFrame(this.item.itemType, this.item.params.powerup);
    }
    onPowerupChange(event) {
      if (this.ignoreConfigUpdates) {
        return;
      }
      let newPowerup = event.value;
      let powerup = newPowerup === "NONE" ? null : newPowerup;
      this.item.setPowerup(powerup);
    }
    getCookieTypes() {
      return ItemTypeUtil.getSubtypes(ItemSuperType.COOKIE).map((cookieType) => {
        return {text: cookieType, value: cookieType};
      });
    }
    getPowerupTypes() {
      let powerups = ["NONE", ...COOKIE_POWERUPS];
      return powerups.map((powerup) => {
        return {text: powerup, value: powerup};
      });
    }
    getConfigFromItem(item) {
      var _a;
      return {
        type: item.itemType,
        powerup: (_a = item.params.powerup) != null ? _a : "NONE"
      };
    }
    setItem(item) {
      var _a;
      super.setItem(item);
      (_a = this.item) == null ? void 0 : _a.on(EditorCookieEvent.POWERUP_CHANGE, this.onCookiePowerupChange, this);
    }
    resetItem() {
      var _a;
      (_a = this.item) == null ? void 0 : _a.off(EditorCookieEvent.POWERUP_CHANGE, this.onCookiePowerupChange, this);
      super.resetItem();
    }
    onCookiePowerupChange(cookie, newPowerup) {
      this.config.powerup = newPowerup != null ? newPowerup : "NONE";
      this.refresh();
    }
  };

  // src/scenes/levelEditor/panels/MysteryBoxesPanel.ts
  var MysteryBoxesPanel = class extends EditorPanel {
    constructor(scene, container, config2, title = "Mystery Boxes") {
      super(scene, container, title);
      this.config = config2;
      this.addInputs();
      this.addResetButton();
    }
    addInputs() {
      Object.keys(this.config).forEach((key) => {
        this.panel.addInput(this.config, key, {step: 1, min: 0, max: 100});
      });
    }
    addResetButton() {
      this.panel.addButton({title: "Reset"}).on("click", this.onResetButtonClick.bind(this));
    }
    onResetButtonClick() {
      Object.assign(this.config, LevelConfigsManager.createDefaultMysteryBoxesConfig());
      this.refresh();
    }
  };

  // src/scenes/levelEditor/items/EditorGenerator.ts
  var EditorGeneratorEvent;
  (function(EditorGeneratorEvent2) {
    EditorGeneratorEvent2["TURNS_CHANGE"] = "__TURNS_CHANGE";
    EditorGeneratorEvent2["INVISIBILITY_CHANGE"] = "__INVISIBILITY_CHANGE";
  })(EditorGeneratorEvent || (EditorGeneratorEvent = {}));
  var EditorGenerator = class extends Phaser.GameObjects.Container {
    constructor(scene, turnsNum = 3, content = GeneratorContent.DROP_ITEM, contentMod = GeneratorContentMod.NONE, invisible = false) {
      super(scene);
      this.isMultiCell = false;
      this.itemWidth = 1;
      this.itemHeight = 1;
      this.itemType = ItemType.GENERATOR;
      this.itemSuperType = ItemSuperType.GENERATOR;
      this._isSelected = false;
      this.name = "color_cake";
      this.id = Phaser.Math.RND.uuid();
      this.params = {type: "generator", turnsNum, content, contentMod, invisible};
      this.setData("itemType", this.itemType);
      this.setData("itemSuperType", this.itemSuperType);
      this.addItem();
      this.addBubble();
      this.addInvisibleIcon();
      this.addPropeller();
      this.addTurnsLabel();
      this.setSize(this.bubble.width, this.bubble.height);
      this.setInteractive();
    }
    get isSelected() {
      return this._isSelected;
    }
    addItem() {
      let frame = GeneratorUtilts.getContentFrame(this.params.content, this.params.contentMod);
      this.item = this.scene.add.image(0, 0, "gameplay", frame);
      this.item.y = 3;
      this.add(this.item);
    }
    addBubble() {
      this.bubble = this.scene.add.image(0, 0, "gameplay", "generator/base");
      this.add(this.bubble);
    }
    addInvisibleIcon() {
      this.invisibleIcon = this.scene.add.image(0, 0, "editor", "invisible_icon");
      this.invisibleIcon.x = CELL_SIZE / 2 - 14;
      this.invisibleIcon.y = -CELL_SIZE / 2 + 14;
      this.add(this.invisibleIcon);
      if (this.params.invisible === false) {
        this.invisibleIcon.kill();
      }
    }
    addPropeller() {
      this.propeller = this.scene.add.image(0, 0, "gameplay", "generator/propeller");
      this.propeller.y = this.bubble.bottom;
      this.add(this.propeller);
    }
    addTurnsLabel() {
      this.turnLabelBack = this.scene.add.image(0, 0, "gameplay", "generator/label_back");
      this.turnLabelBack.y = this.propeller.y;
      this.add(this.turnLabelBack);
      let content = this.params.turnsNum.toString();
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "20px",
        color: "#7D473D",
        align: "center"
      };
      this.turnLabel = this.scene.add.text(0, 0, content, style);
      this.turnLabel.setOrigin(0.5, 0.5);
      this.turnLabel.x = this.turnLabelBack.x;
      this.turnLabel.y = this.turnLabelBack.y;
      this.add(this.turnLabel);
    }
    select() {
      if (this._isSelected) {
        return;
      }
      this._isSelected = true;
      this.emit(SelectableEvent.SELECT, this);
    }
    unselect() {
      if (this._isSelected === false) {
        return;
      }
      this._isSelected = false;
      this.emit(SelectableEvent.UNSELECT, this);
    }
    updateTurnsNum(value) {
      this.params.turnsNum = Phaser.Math.Clamp(value, 1, 10);
      this.turnLabel.text = this.params.turnsNum.toString();
      this.emit(EditorGeneratorEvent.TURNS_CHANGE, this, this.params.turnsNum);
    }
    updateContentType(type, mod) {
      this.params.content = type;
      this.params.contentMod = mod;
      this.item.setFrame(GeneratorUtilts.getContentFrame(type, mod));
    }
    updateInvisibility(value) {
      this.params.invisible = value;
      if (value) {
        this.invisibleIcon.revive();
      } else {
        this.invisibleIcon.kill();
      }
      this.emit(EditorGeneratorEvent.INVISIBILITY_CHANGE, this, this.params.invisible);
    }
    toggleInvisibility() {
      let newValue = !this.params.invisible;
      this.updateInvisibility(newValue);
    }
  };

  // src/scenes/levelEditor/panels/itemPanels/GeneratorItemPanel.ts
  var GeneratorItemPanel = class extends EditorItemPanel {
    constructor(scene, container, title = "Generator") {
      super(scene, container, title);
    }
    getDefaultConfig() {
      return {
        content: GeneratorContent.DROP_ITEM,
        contentMod: GeneratorContentMod.NONE,
        turns: 3,
        invisible: false
      };
    }
    addInputs() {
      this.panel.addInput(this.config, "content", {options: this.getContentTypes()}).on("change", this.onContentTypeChange.bind(this));
      this.panel.addInput(this.config, "contentMod", {options: this.getContentMods()}).on("change", this.onContentModChange.bind(this));
      this.panel.addInput(this.config, "turns", {
        step: 1,
        min: 1,
        max: 10
      }).on("change", this.onTurnsNumChange.bind(this));
      this.panel.addInput(this.config, "invisible").on("change", this.onInvisibilityChange.bind(this));
    }
    getContentTypes() {
      return Object.keys(GeneratorContent).map((type) => {
        return {text: GeneratorContent[type], value: GeneratorContent[type]};
      });
    }
    getContentMods() {
      return Object.keys(GeneratorContentMod).map((type) => {
        return {text: GeneratorContentMod[type], value: GeneratorContentMod[type]};
      });
    }
    onContentTypeChange(event) {
      if (this.ignoreConfigUpdates) {
        return;
      }
      this.fixContentMod();
      this.item.updateContentType(this.config.content, this.config.contentMod);
    }
    onContentModChange(event) {
      if (this.ignoreConfigUpdates) {
        return;
      }
      this.fixContentMod();
      this.item.updateContentType(this.config.content, this.config.contentMod);
    }
    fixContentMod() {
      let isCookie2 = GeneratorUtilts.isCookie(this.config.content);
      if (isCookie2 === false && this.config.contentMod !== GeneratorContentMod.NONE) {
        this.config.contentMod = GeneratorContentMod.NONE;
        this.refresh();
      }
      if (this.config.content === GeneratorContent.RANDOM_COOKIE && this.config.contentMod === GeneratorContentMod.NONE) {
        this.config.contentMod = GeneratorContentMod.RANDOM_STRIPES;
        this.refresh();
      }
    }
    onTurnsNumChange(event) {
      if (this.ignoreConfigUpdates) {
        return;
      }
      this.item.updateTurnsNum(event.value);
    }
    onInvisibilityChange(event) {
      if (this.ignoreConfigUpdates) {
        return;
      }
      this.item.updateInvisibility(event.value);
    }
    setItem(item) {
      var _a, _b;
      super.setItem(item);
      (_a = this.item) == null ? void 0 : _a.on(EditorGeneratorEvent.TURNS_CHANGE, this.onItemTurnChange, this);
      (_b = this.item) == null ? void 0 : _b.on(EditorGeneratorEvent.INVISIBILITY_CHANGE, this.onItemInvisibilityChange, this);
    }
    onItemTurnChange() {
      this.ignoreConfigUpdates = true;
      this.config.turns = this.item.params.turnsNum;
      this.refresh();
      this.ignoreConfigUpdates = false;
    }
    onItemInvisibilityChange(generator, invisible) {
      this.ignoreConfigUpdates = true;
      this.config.invisible = invisible;
      this.refresh();
      this.ignoreConfigUpdates = false;
    }
    resetItem() {
      var _a;
      (_a = this.item) == null ? void 0 : _a.off(EditorGeneratorEvent.TURNS_CHANGE, this.onItemTurnChange, this);
      super.resetItem();
    }
    getConfigFromItem(item) {
      return {
        turns: this.item.params.turnsNum,
        content: this.item.params.content,
        contentMod: this.item.params.contentMod,
        invisible: this.item.params.invisible
      };
    }
  };

  // src/scenes/levelEditor/items/EditorColorCake.ts
  var EditorColorCakeEvent;
  (function(EditorColorCakeEvent2) {
    EditorColorCakeEvent2["CONTENT_CHANGE"] = "__CONTENT_CHANGE";
  })(EditorColorCakeEvent || (EditorColorCakeEvent = {}));
  var _EditorColorCake = class extends Phaser.GameObjects.Container {
    constructor(scene, content) {
      super(scene);
      this.itemType = ItemType.COLOR_CAKE;
      this.itemSuperType = ItemSuperType.COLOR_CAKE;
      this._isSelected = false;
      this.name = "color_cake";
      this.id = Phaser.Math.RND.uuid();
      this.params = {type: "color_cake", content};
      this.setData("itemType", this.itemType);
      this.setData("itemSuperType", this.itemSuperType);
      this.setMulticell();
      this.pieces = [];
      this.addBase();
      this.addBombShadow();
      this.addBomb();
      this.setContent(content);
      this.setSize(this.base.width, this.base.height);
      this.setInteractive();
    }
    get isSelected() {
      return this._isSelected;
    }
    addBase() {
      this.base = this.scene.add.image(0, 0, "gameplay", "color_cake/Cake_01");
      this.add(this.base);
    }
    addPieces(content) {
      this.pieces = content.map((pieceType, index) => {
        if (!pieceType) {
          return null;
        }
        let frame = this.getPieceFrame(pieceType, index);
        let piece = this.scene.make.image({key: "gameplay", frame});
        piece.pieceType = pieceType;
        return piece;
      });
      this.add(this.pieces.filter(Boolean));
    }
    getPieceFrame(type, position) {
      return `color_cake/${type}_0${position + 1}`;
    }
    addBombShadow() {
      this.bombShadow = this.scene.add.image(0, 0, "gameplay", "color_cake/Cake_02");
      this.bombShadow.alpha = 0.66;
      this.add(this.bombShadow);
    }
    addBomb() {
      this.bomb = this.scene.add.image(0, 0, "gameplay", "color_cake/Cake_03");
      this.add(this.bomb);
    }
    setMulticell() {
      this.isMultiCell = MultiCellUtils.isMulticell(this.itemType);
      if (this.isMultiCell) {
        let size = MultiCellUtils.getSize(this.itemType);
        this.itemWidth = size.width;
        this.itemHeight = size.height;
      }
    }
    select() {
      if (this._isSelected) {
        return;
      }
      this._isSelected = true;
      this.emit(SelectableEvent.SELECT, this);
    }
    unselect() {
      if (this._isSelected === false) {
        return;
      }
      this._isSelected = false;
      this.emit(SelectableEvent.UNSELECT, this);
    }
    getContent() {
      return this.content;
    }
    setContent(content) {
      this.content = content;
      this.params.content = this.content;
      this.pieces.forEach((piece) => piece == null ? void 0 : piece.destroy());
      this.addPieces(this.content);
      this.bringToTop(this.bombShadow);
      this.bringToTop(this.bomb);
    }
    getLastActivePieceIndex() {
      for (let i = this.pieces.length - 1; i > -1; i--) {
        if (this.pieces[i] !== null) {
          return i + 1;
        }
      }
      return -1;
    }
    setActivePiecesNum(_piecesNum, enabledCookieTypes) {
      let piecesNum = Phaser.Math.Clamp(_piecesNum, 1, _EditorColorCake.PIECES_NUM);
      let activePiecesNum = this.getLastActivePieceIndex();
      if (activePiecesNum === piecesNum) {
        return;
      }
      let newContent;
      if (piecesNum > activePiecesNum) {
        let randomCookieType = Phaser.Math.RND.pick(enabledCookieTypes);
        newContent = this.content.slice(0);
        newContent[activePiecesNum] = COLOR_CAKE_COOKIES_MAP[randomCookieType];
      } else {
        newContent = this.content.slice(0);
        newContent[activePiecesNum - 1] = null;
      }
      this.setContent(newContent);
      this.emit(EditorColorCakeEvent.CONTENT_CHANGE, this, this.content);
    }
  };
  var EditorColorCake = _EditorColorCake;
  EditorColorCake.PIECES_NUM = 6;

  // src/scenes/levelEditor/panels/itemPanels/ColorCakePanel.ts
  var ColorCakePanel = class extends EditorItemPanel {
    constructor(scene, container) {
      super(scene, container, "Color Cake Editor");
      this.addRandomizeSection();
    }
    getDefaultConfig() {
      return this.contentToConfig(ColorCake.getDefaultContent());
    }
    addInputs() {
      super.addInputs();
      let options = this.getOptions();
      Object.keys(this.config).forEach((key, index) => {
        this.panel.addInput(this.config, key, {options}).on("change", this.onPieceTypeChange.bind(this, index));
      });
    }
    getOptions() {
      return [
        {text: "NONE", value: ""},
        ...this.getPieceTypes()
      ];
    }
    getPieceTypes() {
      return Object.values(ColorCakePieceType).map((pieceType) => {
        return {text: findKey_default(ColorCakePieceType, (value) => value === pieceType), value: pieceType};
      });
    }
    onPieceTypeChange(pieceType) {
      var _a;
      if (this.ignoreConfigUpdates) {
        return;
      }
      (_a = this.item) == null ? void 0 : _a.setContent(this.configToContent(this.config));
    }
    addRandomizeSection() {
      this.randomizeConfig = {
        colorsNum: 5
      };
      this.panel.addSeparator();
      this.panel.addInput(this.randomizeConfig, "colorsNum", {
        step: 1,
        min: 1,
        max: ColorCake.getDefaultContent().length
      });
      this.panel.addButton({title: "Randomize"}).on("click", this.onRandomizeButtonClick.bind(this));
    }
    onRandomizeButtonClick() {
      let newContent = this.getRandomContent();
      let newConfig = this.contentToConfig(newContent);
      Object.assign(this.config, newConfig);
      this.refresh();
    }
    getRandomContent() {
      let enabledCookieTypes = this.getEnabledCookieTypes();
      let colorsNum = Math.min(this.randomizeConfig.colorsNum, enabledCookieTypes.length);
      let cakeCookieTypes = Phaser.Math.RND.shuffle(enabledCookieTypes).slice(0, colorsNum);
      let cakeColors = cakeCookieTypes.map((type) => COLOR_CAKE_COOKIES_MAP[type]);
      let newContent = times_default(6, (index) => cakeColors[Phaser.Math.Wrap(index, 0, cakeColors.length)]);
      return Phaser.Math.RND.shuffle(newContent);
    }
    getEnabledCookieTypes() {
      let generatorConfig = this.scene.levelConfig.generator;
      return Object.keys(generatorConfig.weights).filter((key) => ItemTypeUtil.getItemSuperType(key) === ItemSuperType.COOKIE).filter((key) => generatorConfig.weights[key] > 0);
    }
    getEnabledCookieTypesNum() {
      return this.getEnabledCookieTypes().length;
    }
    setItem(item) {
      var _a;
      super.setItem(item);
      (_a = this.item) == null ? void 0 : _a.on(EditorColorCakeEvent.CONTENT_CHANGE, this.onCakeContentChange, this);
    }
    onCakeContentChange(cake, content) {
      this.ignoreConfigUpdates = true;
      Object.assign(this.config, this.contentToConfig(content));
      this.refresh();
      this.ignoreConfigUpdates = false;
    }
    resetItem() {
      var _a;
      (_a = this.item) == null ? void 0 : _a.off(EditorColorCakeEvent.CONTENT_CHANGE, this.onCakeContentChange, this);
      super.resetItem();
    }
    getConfigFromItem(item) {
      return this.contentToConfig(item.getContent());
    }
    contentToConfig(content) {
      return content.reduce((config2, pieceType, index) => {
        config2[index] = pieceType != null ? pieceType : "";
        return config2;
      }, {});
    }
    configToContent(config2) {
      return Object.entries(config2).map(([key, value]) => {
        return value === "" ? null : value;
      });
    }
  };

  // src/scenes/levelEditor/panels/EditorPanelsManager.ts
  var EditorPanelsManager = class extends Phaser.Events.EventEmitter {
    constructor(scene) {
      super();
      this.scene = scene;
      this.levelConfig = this.scene.levelConfig;
      this.addPanelContainers();
      this.addTutorialPanel();
      this.addBoostersPanel();
      this.addPregameBoostersPanel();
      this.addPregameBoostersHintsPanel();
      this.addMysteryBoxesPanel();
      this.addItemPanels();
      this.addConfigPanel();
      this.addLayersPanel();
      this.addGeneratorPanel();
      this.addGoalsPanel();
      this.addChefPowerupPanel();
    }
    addPanelContainers() {
      let zoom = this.scene.game.store.getNumber(GameStoreKey.EDITOR_ZOOM);
      this.leftPanels = this.getPanelsContainer("editor-panels-left");
      this.leftPanels.style.visibility = "visible";
      this.leftPanels.style.zoom = zoom.toString();
      this.rightPanels = this.getPanelsContainer("editor-panels-right");
      this.rightPanels.style.visibility = "visible";
      this.rightPanels.style.zoom = zoom.toString();
    }
    getPanelsContainer(elementId) {
      var _a;
      return (_a = document.getElementById(elementId)) != null ? _a : this.createPanelsContainer(elementId);
    }
    createPanelsContainer(elementId) {
      let container = document.createElement("div");
      container.id = elementId;
      container.classList.add("editor-panels");
      this.scene.game.canvas.parentNode.insertBefore(container, this.scene.game.canvas.nextSibling);
      return container;
    }
    addTutorialPanel() {
      this.tutorialPanel = new TutorialPanel(this.scene, this.leftPanels, this.levelConfig.tutorial);
      this.tutorialPanel.on(TutorialPanelEvent.SHOW_TUTORIAL_AREA, this.showTutorialArea, this);
      this.tutorialPanel.on(TutorialPanelEvent.HIDE_TUTORIAL_AREA, this.hideTutorialArea, this);
    }
    showTutorialArea(areaId) {
      var _a;
      (_a = this.scene.getTutorialById(areaId)) == null ? void 0 : _a.revive();
    }
    hideTutorialArea(areaId) {
      var _a;
      (_a = this.scene.getTutorialById(areaId)) == null ? void 0 : _a.kill();
    }
    addBoostersPanel() {
      this.boostersPanel = new BoostersPanel3(this.scene, this.leftPanels, this.levelConfig.boosters);
    }
    addPregameBoostersPanel() {
      this.pregameBoostersPanel = new PreGameBoostersPanel(this.scene, this.leftPanels, this.levelConfig.preGameBoosters);
    }
    addPregameBoostersHintsPanel() {
      this.pregameBoostersHintsPanel = new PreGameBoostersHintsPanel(this.scene, this.leftPanels, this.levelConfig.preGameBoostersHints);
    }
    addMysteryBoxesPanel() {
      this.mysteryBoxesPanel = new MysteryBoxesPanel(this.scene, this.leftPanels, this.levelConfig.mysteryBoxes);
    }
    addItemPanels() {
      let container = this.leftPanels;
      this.itemPanels = {
        [ItemSuperType.COLOR_CAKE]: new ColorCakePanel(this.scene, container),
        [ItemSuperType.COOKIE]: new CookiePanel(this.scene, container),
        [ItemSuperType.GENERATOR]: new GeneratorItemPanel(this.scene, container)
      };
      Object.values(this.itemPanels).forEach((panel) => panel.hide());
    }
    addConfigPanel() {
      this.configPanel = new LevelConfigPanel(this.scene, this.rightPanels, this.levelConfig);
      this.configPanel.bgInput.on("change", this.onBackgroundChange.bind(this));
    }
    onBackgroundChange(newBackground) {
      this.scene.events.emit(LevelEditorEvent.BACKGROUND_CHANGE, newBackground);
    }
    addLayersPanel() {
      this.layersPanel = new LayersPanel(this.scene, this.rightPanels, this.scene.layers);
      this.layersPanel.on(LayersPanelEvent.LAYER_UPDATE, this.onLayerVisibilityUpdate, this);
    }
    onLayerVisibilityUpdate(layerDepth, value) {
      switch (layerDepth) {
        case LevelEditorDepth.BASE_GRID:
          this.scene.grid.visible = value;
          break;
        case LevelEditorDepth.FIELD:
          this.scene.field.visible = value;
          break;
        case LevelEditorDepth.BOTTOM_ITEMS:
        case LevelEditorDepth.MAIN_ITEMS:
        case LevelEditorDepth.TOP_ITEMS:
          this.scene.items.setLayerVisibility(layerDepth, value);
          break;
        case LevelEditorDepth.TUTORIAL:
          this.scene.tutorialLayer.visible = value;
          break;
        default:
          break;
      }
    }
    addGeneratorPanel() {
      this.generatorPanel = new GeneratorPanel(this.scene, this.rightPanels, this.levelConfig.generator);
      this.generatorPanel.on(GeneratorPanelEvent.WEIGHT_CHANGE, this.onItemWeightChange, this);
    }
    onItemWeightChange(itemType, weight) {
      if (weight > 0) {
        return;
      }
      this.updateCookiesOnWeightsChange(itemType);
      this.updateCakesOnWeightsChange();
    }
    updateCookiesOnWeightsChange(itemType) {
      let allowedCookieTypes = this.getAllowedCookieTypes();
      this.scene.items.mainItems.filter((item) => item.itemSuperType === ItemSuperType.COOKIE && item.itemType === itemType && item.params.locked === false).forEach((item) => {
        let newItemType = Phaser.Math.RND.pick(allowedCookieTypes);
        item.updateItemType(newItemType);
      });
    }
    updateCakesOnWeightsChange() {
      let allowedPieceTypes = this.getAllowedCookieTypes().map((cookieType) => COLOR_CAKE_COOKIES_MAP[cookieType]);
      this.scene.items.getCakes().forEach((cake) => {
        let content = cake.getContent();
        let restrictedPieceTypes = uniq_default(without_default(content.filter(Boolean), ...allowedPieceTypes));
        let newContent = content.map((pieceType) => {
          if (pieceType && restrictedPieceTypes.includes(pieceType)) {
            return Phaser.Math.RND.pick(allowedPieceTypes);
          } else {
            return pieceType;
          }
        });
        cake.setContent(newContent);
      });
    }
    getAllowedCookieTypes() {
      return ItemTypeUtil.getSubtypes(ItemSuperType.COOKIE).filter((type) => this.levelConfig.generator.weights[type] > 0);
    }
    addGoalsPanel() {
      this.goalsPanel = new GoalsPanel3(this.scene, this.rightPanels, this.levelConfig);
    }
    addChefPowerupPanel() {
      let config2 = this.levelConfig.chefPowerups;
      let defaultConfig = this.scene.game.levelConfigs.createDefaultChefPowerupsConfig();
      this.chefPowerupsPanel = new ChefPowerupsPanel(this.scene, this.rightPanels, config2, defaultConfig);
    }
    enablePanels() {
      this.leftPanels.classList.remove("disable-panel-input");
      this.rightPanels.classList.remove("disable-panel-input");
    }
    disablePanels() {
      this.leftPanels.classList.add("disable-panel-input");
      this.rightPanels.classList.add("disable-panel-input");
    }
    changeZoom(sign = 1) {
      let zoom = parseFloat(this.rightPanels.style.zoom) || 1;
      let newZoom = zoom + Phaser.Math.Sign(sign) * 0.1;
      newZoom = Math.max(0.2, newZoom);
      this.leftPanels.style.zoom = newZoom.toString();
      this.rightPanels.style.zoom = newZoom.toString();
      this.scene.game.store.saveValue(GameStoreKey.EDITOR_ZOOM, newZoom);
    }
    resetZoom() {
      let zoom = 1;
      this.rightPanels.style.zoom = zoom.toString();
      this.scene.game.store.saveValue(GameStoreKey.EDITOR_ZOOM, zoom);
    }
    destroy() {
      super.destroy();
      this.leftPanels.style.visibility = "hidden";
      this.rightPanels.style.visibility = "hidden";
      this.tutorialPanel.destroy();
      this.boostersPanel.destroy();
      this.pregameBoostersPanel.destroy();
      this.pregameBoostersHintsPanel.destroy();
      this.mysteryBoxesPanel.destroy();
      this.configPanel.destroy();
      this.layersPanel.destroy();
      this.generatorPanel.destroy();
      this.goalsPanel.destroy();
      this.chefPowerupsPanel.destroy();
      this.destroyItemsPanels();
    }
    destroyItemsPanels() {
      Object.values(this.itemPanels).forEach((panel) => panel.destroy());
    }
  };

  // src/scenes/levelEditor/grid/BaseGridCell.ts
  var BaseGridCell = class extends Phaser.GameObjects.Image {
    constructor(scene, texture, frame, column, row) {
      super(scene, 0, 0, texture, frame);
      this._isSelected = false;
      this.name = "grid_cell";
      this._column = column;
      this._row = row;
      this.alpha = 0.25;
      this.setInteractive();
    }
    get isSelected() {
      return this._isSelected;
    }
    get row() {
      return this._row;
    }
    set row(value) {
      this._row = value;
    }
    get column() {
      return this._column;
    }
    select() {
      if (this._isSelected) {
        return;
      }
      this._isSelected = true;
      this.emit(SelectableEvent.SELECT, this);
    }
    unselect() {
      if (this._isSelected === false) {
        return;
      }
      this._isSelected = false;
      this.emit(SelectableEvent.UNSELECT, this);
    }
    destroy() {
      super.destroy();
    }
  };

  // src/scenes/levelEditor/LevelEditorObjectType.ts
  var LevelEditorObjectType;
  (function(LevelEditorObjectType2) {
    LevelEditorObjectType2["GRID_CELL"] = "GRID_CELL";
    LevelEditorObjectType2["FIELD_CELL"] = "FIELD_CELL";
    LevelEditorObjectType2["ITEM"] = "ITEM";
    LevelEditorObjectType2["TUTORIAL"] = "TUTORIAL";
  })(LevelEditorObjectType || (LevelEditorObjectType = {}));

  // src/scenes/levelEditor/grid/BaseGrid.ts
  var EditorGridEvent;
  (function(EditorGridEvent2) {
    EditorGridEvent2["ADD_ROW"] = "add_row";
    EditorGridEvent2["REMOVE_ROW"] = "remove_row";
    EditorGridEvent2["ADD_CELL"] = "add_cell";
    EditorGridEvent2["REMOVE_CELL"] = "remove_cell";
    EditorGridEvent2["HIGHLIGHT"] = "highlight";
    EditorGridEvent2["UNHIGHLIGHT"] = "unhighlight";
  })(EditorGridEvent || (EditorGridEvent = {}));
  var BaseGrid = class extends Phaser.GameObjects.Container {
    get columns() {
      return this._columns;
    }
    get rows() {
      return this._rows;
    }
    constructor(scene, columns, rows) {
      super(scene);
      this.name = "grid";
      this.editor = this.scene;
      this.rowLabels = [];
      this.removeRowButtons = [];
      this.initialColumns = columns;
      this.initialRows = rows;
      this._columns = columns;
      this._rows = 0;
      this.cells = new GridArray(this.initialRows, this.initialColumns);
      this.addInitialRows();
      this.addColumnLabels();
      this.addAddRowButton();
      this.updateSize();
    }
    updateSize() {
      this.setSize(this._columns * CELL_SIZE, this._rows * CELL_SIZE);
    }
    addInitialRows() {
      times_default(this.initialRows, this.addRow.bind(this));
    }
    addRow() {
      this.addRowOfCells(this._rows);
      this.addRowLabel(this._rows);
      this.addRemoveRowButton(this._rows);
      this._rows++;
      this.emit(EditorGridEvent.ADD_ROW, this, this._rows);
    }
    addRowOfCells(rowNumber) {
      times_default(this._columns, (index) => {
        this.addCell(index, rowNumber);
      });
    }
    addCell(column, row) {
      let cell = new BaseGridCell(this.scene, "editor", "grid_cell", column, row);
      alignToGrid(cell);
      cell.setData("type", LevelEditorObjectType.GRID_CELL);
      this.cells.add(cell);
      this.add(cell);
      this.emit(EditorGridEvent.ADD_CELL, cell);
      return cell;
    }
    addColumnLabels() {
      times_default(this._columns, (column) => {
        let content = column.toString();
        let label = this.createLabel(content);
        label.x = column * CELL_SIZE + CELL_SIZE / 2;
        label.y = this._rows * CELL_SIZE + CELL_SIZE / 2;
        label.setData("column", column);
        label.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, this.onLabelPointerOver.bind(this, "column", column, label));
        label.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, this.onLabelPointerOut.bind(this, "column", column, label));
        this.add(label);
        return label;
      });
    }
    addRowLabel(row) {
      let content = row.toString();
      let label = this.createLabel(content);
      label.x = -CELL_SIZE / 2;
      label.y = CELL_SIZE / 2 + row * CELL_SIZE;
      label.setData("row", row);
      label.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, this.onLabelPointerOver.bind(this, "row", row, label));
      label.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, this.onLabelPointerOut.bind(this, "row", row, label));
      this.rowLabels.push(label);
      return label;
    }
    createLabel(content) {
      let hitArea = new Phaser.Geom.Rectangle(-CELL_SIZE / 2 + 6, -CELL_SIZE / 2 + 17, CELL_SIZE, CELL_SIZE);
      let label = this.scene.add.bitmapText(0, 0, BitmapFont.LEVEL_EDITOR_GRID, content, 28);
      label.setOrigin(0.5, 0.5);
      label.setInteractive(hitArea, Phaser.Geom.Rectangle.Contains);
      label.input.customHitArea = true;
      this.add(label);
      return label;
    }
    onLabelPointerOver(type, value, label) {
      this.emit(EditorGridEvent.HIGHLIGHT, type, value);
    }
    onLabelPointerOut(type, value, label) {
      this.emit(EditorGridEvent.UNHIGHLIGHT, type, value);
    }
    addRemoveRowButton(rowNumber) {
      let button = this.scene.add.button("editor", "remove_row_button", this);
      button.on(ButtonEvent.RELEASE, this.onRemoveRowButtonClick, this);
      button.setData("row", rowNumber);
      button.x = this.getWidth() + button.displayWidth / 2 + 10;
      button.y = -rowNumber * CELL_SIZE - CELL_SIZE / 2;
      this.removeRowButtons.push(button);
      button.kill();
    }
    onRemoveRowButtonClick(button) {
      let minRowsNum = 3;
      if (this._rows <= minRowsNum) {
        console.warn(`Should be at least ${minRowsNum} rows!`);
        return;
      }
      let rowNumber = button.getData("row");
      this.removeRow(rowNumber);
    }
    removeRow(rowNumber) {
      this.removeCellsByRow(rowNumber);
      this.removeRowLabel(rowNumber);
      this.removeRemoveRowButton(rowNumber);
      this.updateRowsAbove(rowNumber);
      this._rows--;
      this.alignAddRowButton();
      this.emit(EditorGridEvent.REMOVE_ROW, rowNumber);
    }
    removeCellsByRow(rowNumber) {
      let cellsToRemove = this.cells.filter((cell) => cell.row === rowNumber);
      cellsToRemove.forEach((cell) => {
        cell.destroy();
        this.cells.remove(cell);
        this.emit(EditorGridEvent.REMOVE_CELL, cell);
      });
    }
    removeRowLabel(rowNumber) {
      let indexToRemove = this.rowLabels.findIndex((label) => label.getData("row") === rowNumber);
      if (indexToRemove === -1) {
        return;
      }
      this.rowLabels[indexToRemove].destroy();
      this.rowLabels.splice(indexToRemove, 1);
    }
    removeRemoveRowButton(rowNumber) {
      let indexToRemove = this.removeRowButtons.findIndex((button) => button.getData("row") === rowNumber);
      if (indexToRemove === -1) {
        return;
      }
      this.removeRowButtons[indexToRemove].destroy();
      this.removeRowButtons.splice(indexToRemove, 1);
    }
    addAddRowButton() {
      this.addRowButton = this.scene.add.button("editor", "add_row_button", this);
      this.addRowButton.on(ButtonEvent.RELEASE, this.onAddRowClick, this);
      this.alignAddRowButton();
      this.addRowButton.kill();
    }
    alignAddRowButton() {
      this.addRowButton.x = this.getWidth() / 2;
      this.addRowButton.y = -CELL_SIZE / 2 - this._rows * CELL_SIZE;
    }
    onAddRowClick(button, pointer) {
      let rowsToAdd = pointer.event.shiftKey ? 5 : 1;
      for (let i = 0; i < rowsToAdd; i++) {
        this.addRow();
        this.alignAddRowButton();
      }
    }
    getWidth() {
      return this._columns * CELL_SIZE;
    }
    getCellAt(column, row) {
      return this.cells.getAt(column, row);
    }
    updateRowsAbove(rowNumber) {
      this.cells.filter((cell) => cell.row > rowNumber).forEach((cell) => {
        cell.row--;
        cell.y = this.getYByRow(cell.row);
      });
      this.rowLabels.filter((label) => label.getData("row") > rowNumber).forEach((label) => {
        let newRow = label.getData("row") - 1;
        label.setData("row", newRow);
        label.y = this.getYByRow(newRow);
        label.text = newRow.toString();
      });
      this.removeRowButtons.filter((button) => button.getData("row") > rowNumber).forEach((button) => {
        let newRow = button.getData("row") - 1;
        button.setData("row", newRow);
        button.y = this.getYByRow(newRow);
      });
    }
    getYByRow(row) {
      return -CELL_SIZE / 2 - row * CELL_SIZE;
    }
  };

  // src/scenes/levelEditor/field/FieldCell.ts
  var FieldCell = class extends Phaser.GameObjects.Image {
    get isSelected() {
      return this._isSelected;
    }
    constructor(scene, column, row) {
      super(scene, 0, 0, "editor", "field_cell_center");
      this.name = `field_cell_${column}x${row}`;
      this.column = column;
      this.row = row;
      this.setInteractive();
    }
    select() {
      if (this._isSelected) {
        return;
      }
      this._isSelected = true;
      this.emit(SelectableEvent.SELECT, this);
    }
    unselect() {
      if (this._isSelected === false) {
        return;
      }
      this._isSelected = false;
      this.emit(SelectableEvent.UNSELECT, this);
    }
    destroy() {
      super.destroy();
    }
  };

  // src/scenes/levelEditor/field/Field.ts
  var FieldEvent;
  (function(FieldEvent2) {
    FieldEvent2["ADD_CELL"] = "Field_ADD_CELL";
    FieldEvent2["REMOVE_CELL"] = "Field_REMOVE_CELL";
  })(FieldEvent || (FieldEvent = {}));
  var Field = class extends Phaser.GameObjects.Container {
    constructor(scene, rows, columns) {
      super(scene);
      this.name = "field";
      this.cells = new GridArray(rows, columns);
      this.corners = [];
    }
    addCell(column, row) {
      if (this.cells.checkAt(column, row)) {
        return;
      }
      let cell = this.doAddCell(column, row);
      this.updateCells();
      this.updateCorners();
      return cell;
    }
    doAddCell(column, row) {
      let cell = new FieldCell(this.scene, column, row);
      alignToGrid(cell);
      cell.once(Phaser.GameObjects.Events.DESTROY, this.onCellDestroy, this);
      cell.setData("type", LevelEditorObjectType.FIELD_CELL);
      this.cells.add(cell);
      this.add(cell);
      this.emit(FieldEvent.ADD_CELL, cell);
      return cell;
    }
    onCellDestroy(cell) {
      this.cells.remove(cell);
      this.updateCells();
      this.updateCorners();
    }
    updateCells() {
      this.cells.forEach((cell) => {
        let neighbors = this.cells.getOrthoNeighborsAt(cell.column, cell.row);
        let neighborsNum = Object.values(neighbors).filter(Boolean).length;
        let frame = "field_cell_center";
        if (neighborsNum === 0) {
          frame = "field_cell_alone";
        } else if (neighborsNum === 1) {
          if (neighbors.top) {
            frame = "field_cell_bottom";
          } else if (neighbors.right) {
            frame = "field_cell_left";
          } else if (neighbors.bottom) {
            frame = "field_cell_top";
          } else {
            frame = "field_cell_right";
          }
        } else if (neighborsNum === 2) {
          if (neighbors.right && neighbors.bottom) {
            frame = "field_cell_top_left";
          } else if (neighbors.left && neighbors.bottom) {
            frame = "field_cell_top_right";
          } else if (neighbors.top && neighbors.left) {
            frame = "field_cell_bottom_right";
          } else if (neighbors.top && neighbors.right) {
            frame = "field_cell_bottom_left";
          }
        }
        cell.setFrame(frame);
      });
    }
    updateCorners() {
      this.corners.forEach((corner) => corner.destroy());
      this.cells.forEach((cell) => {
        let neighbors = this.cells.getNeighborsAt(cell.column, cell.row);
        let {column, row} = cell;
        if (neighbors.bottom && neighbors.right && !neighbors.bottomRight) {
          this.addCorner(column + 1, row + 1, "corner_top_left");
        }
        if (neighbors.bottom && neighbors.left && !neighbors.bottomLeft) {
          this.addCorner(column - 1, row + 1, "corner_top_right");
        }
        if (neighbors.top && neighbors.right && !neighbors.topRight) {
          this.addCorner(column + 1, row - 1, "corner_bottom_left");
        }
        if (neighbors.top && neighbors.left && !neighbors.topLeft) {
          this.addCorner(column - 1, row - 1, "corner_bottom_right");
        }
      });
    }
    addCorner(column, row, frame) {
      let corner = this.scene.add.image(0, 0, "editor", frame);
      corner.x = CELL_SIZE / 2 + column * CELL_SIZE;
      corner.y = CELL_SIZE / 2 + row * CELL_SIZE;
      this.corners.push(corner);
      this.add(corner);
    }
    getCellAt(column, row) {
      return this.cells.getAt(column, row);
    }
    fillFromConfig(fieldConfig) {
      fieldConfig.forEach((cellConfig) => {
        this.addCell(cellConfig.column, cellConfig.row);
      });
    }
  };

  // src/scenes/levelEditor/selection/SelectFrame.ts
  var SelectFrame = class extends Phaser.GameObjects.Image {
    constructor(scene, column, row, frame) {
      super(scene, 0, 0, "editor", frame != null ? frame : "grid_cell_select");
      this.column = column;
      this.row = row;
    }
    destroy() {
      super.destroy();
    }
  };

  // src/scenes/levelEditor/selection/SelectionManager.ts
  var SelectionManagerEvent;
  (function(SelectionManagerEvent2) {
    SelectionManagerEvent2["SELECT"] = "SelectionManager_SELECT";
    SelectionManagerEvent2["UNSELECT"] = "SelectionManager_UNSELECT";
    SelectionManagerEvent2["UNSELECT_ALL"] = "SelectionManager_UNSELECT_ALL";
  })(SelectionManagerEvent || (SelectionManagerEvent = {}));
  var SelectionManager = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.lastSelected = null;
      this.selectionType = null;
      this.name = "select_frames";
      this.selectables = [];
      this.selectableTypes = [
        LevelEditorObjectType.GRID_CELL,
        LevelEditorObjectType.FIELD_CELL,
        LevelEditorObjectType.ITEM,
        LevelEditorObjectType.TUTORIAL
      ];
    }
    addSelectable(item) {
      let items = Array.isArray(item) ? item : [item];
      items.forEach((item2) => {
        item2.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, this.onItemPointerOver.bind(this, item2));
        item2.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, this.onItemPointerOut.bind(this, item2));
        item2.on(SelectableEvent.SELECT, this.onItemSelect, this);
        item2.on(SelectableEvent.UNSELECT, this.onItemUnselect, this);
        item2.once(Phaser.GameObjects.Events.DESTROY, this.onItemDestroy, this);
        this.selectables.push(item2);
      });
    }
    onItemPointerOver(item, pointer) {
      var _a;
      let selectFrame = this.getSelectFrameAt(item.column, item.row);
      if (selectFrame == null ? void 0 : selectFrame.visible) {
        return;
      }
      (_a = this.getOverFrameAt(item.column, item.row)) == null ? void 0 : _a.revive();
      if (pointer.isDown) {
        let editorType = item.getData("type");
        if (this.selectionType === null) {
          this.selectionType = editorType;
        }
        if (editorType === this.selectionType) {
          item.select();
        }
      }
    }
    onItemPointerOut(item, pointer) {
      var _a;
      let selectFrame = this.getSelectFrameAt(item.column, item.row);
      if (selectFrame == null ? void 0 : selectFrame.visible) {
        return;
      }
      (_a = this.getOverFrameAt(item.column, item.row)) == null ? void 0 : _a.kill();
    }
    onItemSelect(item) {
      var _a, _b;
      (_a = this.getSelectFrameAt(item.column, item.row)) == null ? void 0 : _a.revive();
      (_b = this.getOverFrameAt(item.column, item.row)) == null ? void 0 : _b.kill();
      this.emit(SelectionManagerEvent.SELECT, item);
      this.lastSelected = item;
    }
    onItemUnselect(item) {
      var _a;
      (_a = this.getSelectFrameAt(item.column, item.row)) == null ? void 0 : _a.kill();
      this.emit(SelectionManagerEvent.UNSELECT, item);
      if (this.lastSelected === item) {
        this.lastSelected = null;
      }
    }
    onItemDestroy(item) {
      item.off(SelectableEvent.SELECT, this.onItemSelect, this);
      item.off(SelectableEvent.UNSELECT, this.onItemUnselect, this);
      this.onItemUnselect(item);
      pull_default(this.selectables, item);
    }
    removeSelectable(item) {
      pull_default(this.selectables, item);
    }
    getSelectedItems() {
      return this.selectables.filter((item) => item.isSelected);
    }
    unselectAll() {
      this.selectables.forEach((item) => {
        if (item.isSelected) {
          item.unselect();
        }
      });
      this.emit(SelectionManagerEvent.UNSELECT_ALL, this);
      this.lastSelected = null;
      this.selectionType = null;
    }
    getFrameAt(array, column, row) {
      return array.find((frame) => frame.column === column && frame.row === row);
    }
    getOverFrameAt(column, row) {
      return this.getFrameAt(this.overFrames, column, row);
    }
    getSelectFrameAt(column, row) {
      return this.selectFrames.find((frame) => frame.column === column && frame.row === row);
    }
    addFrames(grid) {
      this.addOverFrames(grid);
      this.addSelectFrames(grid);
    }
    addOverFrames(grid) {
      this.overFrames = grid.cells.toArray().map((cell) => {
        let frame = new SelectFrame(this.scene, cell.column, cell.row, "over_frame");
        frame.x = CELL_SIZE / 2 + cell.column * CELL_SIZE;
        frame.y = CELL_SIZE / 2 + cell.row * CELL_SIZE;
        frame.kill();
        return frame;
      });
      this.add(this.overFrames);
    }
    addSelectFrames(grid) {
      this.selectFrames = grid.cells.toArray().map((cell) => {
        let frame = new SelectFrame(this.scene, cell.column, cell.row);
        alignToGrid(frame);
        frame.kill();
        return frame;
      });
      this.add(this.selectFrames);
    }
    handleClick(pointer, objects) {
      let object = objects[0];
      if (!object) {
        this.unselectAll();
        return;
      }
      let objectType = object.getData("type");
      let isSelectable = this.selectableTypes.includes(objectType);
      if (!isSelectable) {
        return;
      }
      let selectable = object;
      if (this.selectionType !== null && objectType !== this.selectionType) {
        this.unselectAll();
      }
      let isCtrlDown = pointer.event.ctrlKey;
      if (isCtrlDown) {
        this.onCtrlSelect(selectable, objectType);
        return;
      }
      let isShiftDown = pointer.event.shiftKey;
      if (isShiftDown) {
        this.onShiftSelect(selectable, objectType);
        return;
      }
      this.unselectAll();
      this.selectionType = objectType;
      selectable.select();
    }
    onCtrlSelect(selectable, objectType) {
      if (selectable.isSelected) {
        selectable.unselect();
      } else {
        this.selectionType = objectType;
        selectable.select();
      }
    }
    onShiftSelect(lastSelectedItem, objectType) {
      var _a;
      let array = this.getArrayForSelectedItem(lastSelectedItem);
      if (!array) {
        return;
      }
      let selected = this.getSelectedItems();
      if (selected.length === 0) {
        this.selectionType = objectType;
        lastSelectedItem.select();
        return;
      }
      let dimensions = calculateDimensions(selected);
      if (dimensions.left > lastSelectedItem.column) {
        dimensions.right = dimensions.left;
        dimensions.left = lastSelectedItem.column;
      } else {
        dimensions.right = lastSelectedItem.column;
      }
      if (dimensions.top > lastSelectedItem.row) {
        dimensions.bottom = dimensions.top;
        dimensions.top = lastSelectedItem.row;
      } else {
        dimensions.bottom = lastSelectedItem.row;
      }
      array.forEach((item) => item.unselect());
      this.selectionType = objectType;
      for (let row = dimensions.top; row <= dimensions.bottom; row++) {
        for (let column = dimensions.left; column <= dimensions.right; column++) {
          (_a = array.getAt(column, row)) == null ? void 0 : _a.select();
        }
      }
    }
    getArrayForSelectedItem(item) {
      if (item instanceof BaseGridCell) {
        return this.scene.grid.cells;
      } else if (item instanceof FieldCell) {
        return this.scene.field.cells;
      } else {
        return this.scene.items.getArrayByItemSuperType(item.itemSuperType);
      }
    }
    highlightColumn(column) {
      this.overFrames.filter((frame) => frame.column === column).forEach((frame) => frame.revive());
    }
    unhighlightColumn(column) {
      this.overFrames.filter((frame) => frame.column === column).forEach((frame) => frame.kill());
    }
    highlightRow(row) {
      this.overFrames.filter((frame) => frame.row === row).forEach((frame) => frame.revive());
    }
    unhighlightRow(row) {
      this.overFrames.filter((frame) => frame.row === row).forEach((frame) => frame.kill());
    }
  };

  // src/scenes/levelEditor/popovers/EditorItemIcon.ts
  var EditorItemIcon = class extends Phaser.GameObjects.Container {
    constructor(scene, size, atlas, itemType) {
      super(scene);
      this.name = itemType;
      this.itemType = itemType;
      this.addBack(size);
      this.addIcon(atlas);
      this.setSize(this.back.width, this.back.height);
      this.setInteractive();
      this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, this.onPointerOver, this);
      this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, this.onPointerOut, this);
    }
    addBack(size) {
      let textureKey = "editor_item_back";
      if (this.scene.textures.exists(textureKey) === false) {
        this.createBackTexture(textureKey, size);
      }
      this.back = this.scene.add.image(0, 0, textureKey);
      this.back.alpha = 0.33;
      this.back.kill();
      this.add(this.back);
    }
    createBackTexture(textureKey, size) {
      let back = this.scene.make.graphics();
      back.fillStyle(16777215);
      back.fillRoundedRect(0, 0, size, size, 20);
      back.generateTexture(textureKey, size, size);
      back.destroy();
    }
    addIcon(atlas) {
      let maxWidth = this.back.width * 0.9;
      let maxHeight = this.back.height * 0.9;
      this.icon = this.scene.add.image(0, 0, atlas, ItemTypeUtil.getFrameByItemType(this.itemType));
      this.icon.scale = Math.min(1, maxWidth / this.icon.width, maxHeight / this.icon.height);
      this.add(this.icon);
    }
    onPointerOver() {
      this.back.revive();
    }
    onPointerOut() {
      this.back.kill();
    }
  };

  // src/scenes/levelEditor/popovers/ItemIconsGrid.ts
  var ItemIconsGrid = class extends Phaser.GameObjects.Container {
    constructor(scene, iconsAtlas, itemTypes) {
      super(scene);
      this.cellSize = 100;
      this.lineHeight = 100;
      this.name = "item_icons";
      this.atlas = iconsAtlas;
      this.icons = [];
      this.addIconLines(itemTypes);
    }
    addIconLines(itemTypes) {
      let lines = itemTypes.map((types, index) => {
        let line = this.createIconsLine(types);
        line.y = index * this.lineHeight;
        return line;
      });
      this.add(lines);
    }
    createIconsLine(itemTypes) {
      let icons = itemTypes.map((itemType, index) => {
        if (itemType === null) {
          return null;
        }
        let icon = new EditorItemIcon(this.scene, this.cellSize, this.atlas, itemType);
        icon.x = this.cellSize / 2 + index * this.cellSize;
        icon.y = this.cellSize / 2;
        this.icons.push(icon);
        return icon;
      });
      return this.scene.add.container(0, 0, icons.filter(Boolean));
    }
  };

  // src/scenes/levelEditor/popovers/AddItemPopover.ts
  var AddItemPopoverEvent;
  (function(AddItemPopoverEvent2) {
    AddItemPopoverEvent2["ITEM_CLICK"] = "AddItemPopover_ITEM_CLICK";
  })(AddItemPopoverEvent || (AddItemPopoverEvent = {}));
  var AddItemPopover = class extends Phaser.GameObjects.Container {
    constructor(scene, iconsAtlas, itemTypes) {
      super(scene);
      this.backAlpha = 0.87;
      this.name = "add_item_popover";
      this.addBack();
      this.addTip();
      this.addIcons(iconsAtlas, itemTypes);
      this.alignIcons();
      this.setSize(this.back.displayWidth, this.back.displayHeight);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "editor", "items_popover_back");
      this.back.setOrigin(0.5, 1);
      this.back.setDisplaySize(this.back.displayWidth + 40, this.back.displayHeight + 80);
      this.back.alpha = this.backAlpha;
      this.back.setInteractive();
      this.add(this.back);
    }
    addTip() {
      this.tip = this.scene.add.image(0, 0, "editor", "items_popover_tip");
      this.tip.y = this.back.bottom;
      this.tip.alpha = this.backAlpha;
      this.add(this.tip);
    }
    addIcons(iconsAtlas, iconsTypes) {
      this.icons = new ItemIconsGrid(this.scene, iconsAtlas, iconsTypes);
      this.icons.icons.forEach((icon) => icon.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onIconClick.bind(this, icon)));
      this.add(this.icons);
    }
    onIconClick(icon) {
      this.emit(AddItemPopoverEvent.ITEM_CLICK, icon.itemType);
    }
    alignIcons() {
      this.icons.setScale(1);
      let iconsBounds = this.icons.getBounds();
      let iconsWidth = iconsBounds.width;
      let iconsHeight = iconsBounds.height;
      let maxWidth = this.back.displayWidth * 0.95;
      let maxHeight = this.back.displayHeight * 0.9;
      let scaleX = maxWidth / iconsWidth;
      let scaleY = maxHeight / iconsHeight;
      let iconsScale = Math.min(1, scaleX, scaleY);
      this.icons.scale = iconsScale;
      let topLeft = this.back.getTopLeft();
      this.icons.x = topLeft.x + (this.back.displayWidth - iconsBounds.width * iconsScale) / 2;
      this.icons.y = topLeft.y + (this.back.displayHeight - iconsBounds.height * iconsScale) / 2;
    }
    show() {
      this.revive();
      this.alpha = 0;
      this.scale = 0.75;
      this.scene.tweens.killTweensOf(this);
      this.scene.tweens.add({
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        scale: 1,
        alpha: 1
      });
    }
    hide() {
      this.kill();
    }
    setTipOffset(offset) {
      this.tip.x = offset;
    }
  };

  // src/scenes/levelEditor/popovers/ModifiersPopover.ts
  var ModifiersPopover = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.backAlpha = 0.87;
      this.name = "modifiers_popover";
      this.addBack();
      this.addTip();
      this.addButtons();
      this.alignButtons();
      this.setSize(this.back.displayWidth, this.back.displayHeight);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "editor", "items_popover_back");
      this.back.setOrigin(0.5, 1);
      this.back.alpha = this.backAlpha;
      this.back.setInteractive();
      this.back.setDisplaySize(450, 100);
      this.add(this.back);
    }
    addTip() {
      this.tip = this.scene.add.image(0, 0, "editor", "items_popover_tip");
      this.tip.y = this.back.bottom;
      this.tip.alpha = this.backAlpha;
      this.add(this.tip);
    }
    addButtons() {
      this.horizontalStripes = this.scene.add.button("editor", "item_mod_horizontal_stripes");
      this.horizontalStripes.setData("mod", CookiePowerup.HORIZONTAL_STRIPES);
      this.verticalStripes = this.scene.add.button("editor", "item_mod_vertical_stripes");
      this.verticalStripes.setData("mod", CookiePowerup.VERTICAL_STRIPES);
      this.bomb = this.scene.add.button("editor", "item_mod_bomb");
      this.bomb.setData("mod", CookiePowerup.BOMB);
      this.superSphere = this.scene.add.button("editor", "item_mod_super");
      this.superSphere.setData("mod", CookiePowerup.SUPER_SPHERE);
      this.clear = this.scene.add.button("editor", "item_mod_clear");
      let cellSize = 70;
      let buttons = [this.horizontalStripes, this.verticalStripes, this.bomb, this.superSphere, this.clear];
      this.buttonsContainer = this.scene.add.container(0, 0, buttons);
      this.buttonsContainer.gridAlign({
        width: buttons.length,
        cellWidth: cellSize,
        x: cellSize / 2,
        y: cellSize / 2
      });
      buttons.forEach((button) => {
        button.setData("originalY", button.y);
        button.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, this.onButtonOver.bind(this, button));
        button.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, this.onButtonOut.bind(this, button));
      });
      this.add(this.buttonsContainer);
    }
    onButtonOver(button) {
      button.y = button.getData("originalY") - 7;
    }
    onButtonOut(button) {
      button.y = button.getData("originalY");
    }
    alignButtons() {
      let buttonsBounds = this.buttonsContainer.getBounds();
      this.buttonsContainer.x = -buttonsBounds.width / 2;
      this.buttonsContainer.y = this.back.getCenter().y - buttonsBounds.height / 2;
    }
    show() {
      this.revive();
      this.alpha = 0;
      this.scale = 0.75;
      this.scene.tweens.killTweensOf(this);
      this.scene.tweens.add({
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        scale: 1,
        alpha: 1
      });
    }
    hide() {
      this.kill();
    }
    setTipOffset(offset) {
      this.tip.x = offset;
    }
  };

  // src/scenes/levelEditor/items/ItemsContainer.ts
  var ItemsContainerEvent;
  (function(ItemsContainerEvent2) {
    ItemsContainerEvent2["ADD_ITEM"] = "ItemsContainer_ADD_ITEM";
    ItemsContainerEvent2["REMOVE_ITEM"] = "ItemsContainer_REMOVE_ITEM";
  })(ItemsContainerEvent || (ItemsContainerEvent = {}));
  var ItemsContainer = class extends Phaser.GameObjects.Container {
    constructor(scene, rows, columns, layers) {
      super(scene);
      this.name = "items";
      this.layersVisibility = layers;
      this.bottomItems = new GridArray(rows, columns);
      this.mainItems = new GridArray(rows, columns);
      this.topItems = new GridArray(rows, columns);
    }
    getArrayByItemSuperType(superType) {
      switch (superType) {
        case ItemSuperType.BISCUIT:
          return this.bottomItems;
        case ItemSuperType.LICORICE:
        case ItemSuperType.GUMMY_BLOCKER:
          return this.topItems;
        default:
          return this.mainItems;
      }
    }
    addItem(column, row, itemType, params) {
      let itemSuperType = ItemTypeUtil.getItemSuperType(itemType);
      let gridArray = this.getArrayByItemSuperType(itemSuperType);
      let isCellTaken = gridArray.checkAt(column, row);
      if (isCellTaken) {
        console.warn(`Can't add item at [${column}, ${row}], cell is taken!`);
        return;
      }
      let item = this.scene.factory.create({column, row, itemType, params});
      if (!item) {
        return;
      }
      item.column = column;
      item.row = row;
      item.setData("type", LevelEditorObjectType.ITEM);
      item.setDepth(this.getDepthByItemSuperType(itemSuperType));
      item.setVisible(this.layersVisibility[item.depth]);
      item.once(Phaser.GameObjects.Events.DESTROY, this.onItemDestroy, this);
      this.addToGridArray(gridArray, item);
      this.alignItem(item);
      this.add(item);
      this.sort("depth", this.sortChildren.bind(this));
      this.emit(ItemsContainerEvent.ADD_ITEM, item);
      return item;
    }
    addToGridArray(gridArray, item) {
      if (item.isMultiCell) {
        MultiCellUtils.addToArray(gridArray, item);
      } else {
        gridArray.add(item);
      }
    }
    alignItem(item) {
      if (typeof item["alignToGrid"] === "function") {
        item["alignToGrid"]();
        return;
      }
      let isMultiCell = MultiCellUtils.isMulticell(item.itemType);
      if (isMultiCell) {
        alignMulticellItemToGrid(item);
      } else {
        alignToGrid(item, item.column, item.row);
      }
    }
    getDepthByItemSuperType(itemType) {
      let map = {
        [ItemSuperType.BISCUIT]: LevelEditorDepth.BOTTOM_ITEMS,
        [ItemSuperType.LICORICE]: LevelEditorDepth.TOP_ITEMS,
        [ItemSuperType.GUMMY_BLOCKER]: LevelEditorDepth.TOP_ITEMS,
        [ItemSuperType.GENERATOR]: LevelEditorDepth.GENERATORS
      };
      return map[itemType] || LevelEditorDepth.MAIN_ITEMS;
    }
    onItemDestroy(item) {
      this.removeItemFromGridArray(item);
      this.emit(ItemsContainerEvent.REMOVE_ITEM, item);
    }
    removeItemFromGridArray(item) {
      let gridArray = this.getArrayByItemSuperType(item.itemSuperType);
      if (item.isMultiCell) {
        MultiCellUtils.removeFromArray(gridArray, item);
      } else {
        gridArray.remove(item);
      }
    }
    getArrayByDepth(depth) {
      switch (depth) {
        case LevelEditorDepth.BOTTOM_ITEMS:
          return this.bottomItems;
        case LevelEditorDepth.MAIN_ITEMS:
          return this.mainItems;
        case LevelEditorDepth.TOP_ITEMS:
          return this.topItems;
        default:
          return null;
      }
    }
    setLayerVisibility(layerDepth, value) {
      var _a;
      (_a = this.getArrayByDepth(layerDepth)) == null ? void 0 : _a.forEach((item) => item.visible = value);
    }
    getMatchableItems() {
      let items = this.mainItems.filter((item) => item.itemSuperType === ItemSuperType.COOKIE);
      let sortedItems = sortBy_default(items, "row", "column");
      return sortedItems;
    }
    fillFromConfig(itemsConfig) {
      itemsConfig.forEach((itemConfig) => {
        let item = this.addItem(itemConfig.column, itemConfig.row, itemConfig.itemType, itemConfig.params);
        if (item.itemSuperType === ItemSuperType.COOKIE) {
          item.setFrame(CookieUtils.getFrame(item.itemType, item.params.powerup));
          if (itemConfig.params.locked) {
            this.lockCookie(item);
          }
        }
      });
    }
    sortChildren(child_1, child_2) {
      if (child_1.depth === child_2.depth) {
        let deltaRows = child_1.row - child_2.row;
        return deltaRows > 0;
      }
      let deltaDepth = child_1.depth - child_2.depth;
      return deltaDepth > 0;
    }
    lockCookie(cookie) {
      if (cookie.lock) {
        return;
      }
      cookie.params.locked = true;
      cookie.lock = this.createCookieLock(cookie);
    }
    unlockCookie(cookie) {
      if (!cookie.lock) {
        return;
      }
      cookie.lock.destroy();
      cookie.lock = null;
      cookie.params.locked = false;
    }
    createCookieLock(cookie) {
      let lock = this.scene.add.image(0, 0, "editor", "lock_icon");
      lock.x = cookie.x + 25;
      lock.y = cookie.y - 25;
      lock.setDepth(LevelEditorDepth.LOCKS);
      this.add(lock);
      return lock;
    }
    getCookies() {
      return this.mainItems.filter((item) => item.itemSuperType === ItemSuperType.COOKIE);
    }
    getCakes() {
      return uniq_default(this.mainItems.filter((item) => item.itemSuperType === ItemSuperType.COLOR_CAKE));
    }
  };

  // src/scenes/levelEditor/levelConfig/LevelConfigValidator.ts
  var LevelConfigValidator = class {
    static validate(config2, allConfigs) {
      let {items, goals} = config2;
      let enabledCookieTypes = this.getEnabledCookieTypes(config2.generator);
      let itemTypesInGenerators = this.getItemTypesFromGenerators(items.filter((item) => item.itemType === ItemType.GENERATOR), enabledCookieTypes);
      let itemTypesInMysteryBoxes = this.getItemTypesFromMysteryBoxes(config2.mysteryBoxes, enabledCookieTypes);
      let messages = [];
      let goalsNum = Object.values(goals).filter((goal) => goal > 0).length;
      if (goalsNum === 0) {
        messages.push("Please set some goals.");
      }
      let maxGoalsNum = 4;
      if (goalsNum > maxGoalsNum) {
        messages.push(`Too much goals (${goalsNum}). Max number of goals is ${maxGoalsNum}.`);
      }
      let goalsToCheck = [GoalType.BISCUIT, GoalType.MARSHMALLOW, GoalType.DONUT, GoalType.CHOCOLATE, GoalType.DROP_ITEM, GoalType.CHICK, GoalType.GUMMY];
      goalsToCheck.forEach((goalType) => {
        let target = goals[goalType];
        if (target <= 0) {
          return;
        }
        let itemTypes = GoalUtils.getItemTypes(goalType);
        let itemsNumOnField = items.filter((item) => itemTypes.includes(item.itemType)).length;
        if (itemsNumOnField < target) {
          let inGenerators = itemTypes.some((type) => itemTypesInGenerators.includes(type));
          let inMysteryBoxes = itemTypes.some((type) => itemTypesInMysteryBoxes.includes(type));
          if (!inGenerators && !inMysteryBoxes) {
            messages.push(`Not enough ${goalType}(s)! Add ${target - itemsNumOnField} more. ${itemsNumOnField}/${target}`);
          }
        }
      });
      let targetApples = goals.APPLE;
      if (targetApples > 0) {
        let platters = items.filter((item) => item.itemType === ItemType.APPLES_PLATTER).length;
        let apples = platters * 9;
        if (apples !== targetApples) {
          messages.push(`Invalid APPLES amount! ${apples}/${targetApples}`);
        }
      }
      let targetCandies = goals.CANDY;
      if (targetCandies > 0) {
        let candyBottlesNum = items.filter((item) => item.itemType === ItemType.CANDY_BOTTLE).length;
        if (candyBottlesNum === 0 && config2.mysteryBoxes.CANDY_BOTTLE === 0) {
          messages.push("There are no candy bottles! Add the bottles or remove candies from the goals.");
        }
      }
      let colorCakes = items.filter((item) => item.itemType === ItemType.COLOR_CAKE);
      if (colorCakes.length > 0) {
        let pieceTypes = colorCakes.flatMap((cake) => cake.params.content.map((type) => type));
        pieceTypes = uniq_default(pieceTypes.filter(Boolean));
        let requiredCookieTypes = pieceTypes.map((pieceType) => findKey_default(COLOR_CAKE_COOKIES_MAP, (value) => value === pieceType));
        let availableCookieTypes = Object.keys(config2.generator.weights).filter((key) => config2.generator.weights[key] > 0);
        let difference2 = without_default(requiredCookieTypes, ...availableCookieTypes);
        if (difference2.length > 0) {
          messages.push(`Next cookie types should be enabled for color cake: ${difference2.join(", ")}`);
        }
        colorCakes.forEach((cake) => {
          let isEmpty = cake.params.content.filter(Boolean).length === 0;
          if (isEmpty) {
            messages.push(`Cake at {x: ${cake.column}, y: ${cake.row}} is EMPTY!`);
          }
        });
      }
      let tutorial = config2.tutorial;
      if (tutorial.autoGenerated === false) {
        tutorial.steps.forEach((step, index) => {
          if (step.type === TutorialStepType.MATCH && step.cells.length === 0) {
            messages.push(`Please specify cells for tutorial step #${index + 1} (areaId = ${step.areaId})`);
          }
        });
      }
      let newElement = config2.newElement;
      if (newElement !== "none") {
        let newElementsMap = allConfigs.map((config3) => ({levelNumber: config3.levelNumber, newElement: config3.newElement})).filter((value) => value.newElement !== "none" && value.levelNumber !== config2.levelNumber);
        let duplicate = newElementsMap.find((value) => value.newElement === newElement);
        if (duplicate) {
          messages.push(`The new element (${newElement}) is introduced on level ${duplicate.levelNumber}! You shouldn't introduce the same new element twice!`);
        }
      }
      let mysteryBox = config2.mysteryBoxes;
      let hasMysteryBoxes = items.some((item) => item.itemType === ItemType.MYSTERY_BOX);
      if (hasMysteryBoxes) {
        let allValuesEqualZero = Object.values(mysteryBox).every((value) => value === 0);
        if (allValuesEqualZero) {
          messages.push(`Invalid mystery boxes config. All values are equal zero!`);
        }
      }
      if (config2.newItemsTypes) {
        let newItemsTypes = attempt_default(() => JSON.parse(config2.newItemsTypes));
        if (isError_default(newItemsTypes) || this.areNewItemsTypesValid(newItemsTypes) === false) {
          messages.push(`Invalid value for "newItemsTypes"! ${config2.newItemsTypes}`);
        }
      }
      return {
        success: messages.length === 0,
        messages
      };
    }
    static getEnabledCookieTypes(generatorConfig) {
      let allCookieTypes = ItemTypeUtil.getSubtypes(ItemSuperType.COOKIE);
      return Object.keys(generatorConfig.weights).filter((key) => allCookieTypes.includes(key)).filter((key) => generatorConfig.weights[key] > 0);
    }
    static doGeneratorContains(content, enabledCookieTypes, ...itemTypes) {
      let generatorItemTypes = this.getGeneratorItemTypes(content, enabledCookieTypes);
      return itemTypes.some((type) => generatorItemTypes.includes(type));
    }
    static doMysteryBoxContains(content, enabledCookieTypes, ...itemTypes) {
      let mysteryBoxTypes = this.getMysteryBoxItemTypes(content, enabledCookieTypes);
      return itemTypes.some((type) => mysteryBoxTypes.includes(type));
    }
    static getItemTypesFromGenerators(generators, enabledCookieTypes) {
      return generators.flatMap((generator) => {
        let params = generator.params;
        return this.getGeneratorItemTypes(params.content, enabledCookieTypes);
      });
    }
    static getGeneratorItemTypes(content, enabledCookieTypes) {
      switch (content) {
        case GeneratorContent.RANDOM_COOKIE:
          return enabledCookieTypes;
        case GeneratorContent.MARSHMALLOW:
          return [ItemType.MARSHMALLOW_COMMON];
        case GeneratorContent.CHICK:
          return [ItemType.CHICK];
        case GeneratorContent.DROP_ITEM:
          return [ItemType.DROP_ITEM];
        default:
          return [GeneratorUtilts.convertContentToCookieType(content)];
      }
    }
    static getItemTypesFromMysteryBoxes(mysteryBoxes, enabledCookieTypes) {
      return Object.keys(mysteryBoxes).filter((key) => mysteryBoxes[key] > 0).flatMap((content) => this.getMysteryBoxItemTypes(content, enabledCookieTypes));
    }
    static getMysteryBoxItemTypes(content, enabledCookieTypes) {
      switch (content) {
        case ItemType.MARSHMALLOW_COMMON:
          return [ItemType.MARSHMALLOW_COMMON];
        case ItemType.MARSHMALLOW_DOUBLE:
          return [ItemType.MARSHMALLOW_DOUBLE];
        case "MARSHMALLOW_COLORED":
          return [ItemType.MARSHMALLOW_PURPLE, ItemType.MARSHMALLOW_ORANGE, ItemType.MARSHMALLOW_BLUE, ItemType.MARSHMALLOW_RED, ItemType.MARSHMALLOW_PINK, ItemType.MARSHMALLOW_YELLOW];
        case ItemType.CHOCOLATE_COMMON:
          return [ItemType.CHOCOLATE_COMMON];
        case ItemType.CANDY_BOTTLE:
          return [ItemType.CANDY_BOTTLE];
        case ItemType.DONUT_BOX:
          return [ItemType.DONUT_BOX];
        default:
          return enabledCookieTypes;
      }
    }
    static areNewItemsTypesValid(newItemsTypes) {
      let validTypes = ItemTypeUtil.getAllTypes();
      return Object.values(newItemsTypes).every((type) => validTypes.includes(type));
    }
  };

  // src/scenes/levelEditor/levelConfig/get-pregame-boosters-hints.ts
  var config = {
    [PregameBoosterType.STRIPES]: {
      goalTypes: [
        GoalType.GUMMY,
        GoalType.CHICK
      ],
      itemSuperTypes: [
        ItemSuperType.GUMMY,
        ItemSuperType.CHICK
      ]
    },
    [PregameBoosterType.BOMB]: {
      goalTypes: [
        GoalType.GUMMY,
        GoalType.CHICK
      ],
      itemSuperTypes: [
        ItemSuperType.GUMMY,
        ItemSuperType.CHICK
      ]
    },
    [PregameBoosterType.SUPER_SPHERE]: {
      goalTypes: [
        GoalType.COOKIE_RED,
        GoalType.COOKIE_BLUE,
        GoalType.COOKIE_ORANGE,
        GoalType.COOKIE_PURPLE,
        GoalType.COOKIE_PINK,
        GoalType.COOKIE_YELLOW
      ],
      itemSuperTypes: []
    }
  };
  function getPregameBoostersHints(items, goals) {
    let levelSuperTypes = uniq_default(items.map((item) => ItemTypeUtil.getItemSuperType(item.itemType)));
    let levelGoalTypes = Object.keys(goals).filter((goalType) => goals[goalType] > 0);
    return Object.entries(config).filter(([_, {goalTypes, itemSuperTypes}]) => {
      return intersection_default(levelGoalTypes, goalTypes).length > 0 || intersection_default(levelSuperTypes, itemSuperTypes).length > 0;
    }).reduce((acc, [boosterType, _]) => {
      acc[boosterType] = true;
      return acc;
    }, {});
  }

  // src/scenes/levelEditor/levelConfig/LevelConfigHelper.ts
  var LevelConfigHelper = class {
    constructor(scene) {
      this.scene = scene;
      this.configsManager = this.scene.game.levelConfigs;
      this.config = this.scene.levelConfig;
    }
    saveAs() {
      let existingLevelNumbers = this.configsManager.getLevelNumbers();
      let suggestedLevelNumber = Math.max(...existingLevelNumbers) + 1 || 1;
      let levelNumberStr = prompt("Enter level number", suggestedLevelNumber.toString());
      let levelNumber = parseInt(levelNumberStr);
      if (isNaN(levelNumber)) {
        console.warn("Please enter valid level number!", levelNumberStr);
        return;
      }
      let isLevelExist = existingLevelNumbers.includes(levelNumber);
      if (isLevelExist) {
        console.warn(`Level ${levelNumber} config exists already, please enter another number!`);
        return;
      }
      this.config = cloneDeep_default(this.config);
      this.config.levelNumber = levelNumber;
      this.configsManager.add(this.config);
      this.save().then(() => {
        this.scene.events.emit(LevelEditorEvent.CHANGE_LEVEL, levelNumber);
      }).catch((error) => {
      });
    }
    save() {
      this.updateLevelConfig();
      let validationResult = LevelConfigValidator.validate(this.config, this.scene.game.levelConfigs.getAll());
      if (validationResult.success === false) {
        console.group("Can't save level!");
        validationResult.messages.forEach((message) => console.warn(message));
        console.groupEnd();
        return Promise.reject("Invalid config!");
      }
      this.scene.gui.bottomBar.saveButton.disableInput();
      this.scene.editorPanels.disablePanels();
      console.log(`Uploading level ${this.config.levelNumber} config...`);
      return Promise.allSettled([
        this.configsManager.saveLocally()
      ]).then(() => {
        console.log("Upload complete! \u2714");
      }).catch((error) => {
        console.warn(error);
      }).finally(() => {
        this.scene.gui.bottomBar.saveButton.enableInput();
        this.scene.editorPanels.enablePanels();
      });
    }
    fixExistingMatchesAndDeadlock() {
      let matches;
      let safetyCounter = 1e3;
      let matchableItems = this.scene.items.getMatchableItems();
      let cookieTypes = this.getItemTypes();
      do {
        matches = MatchFinder.findAll(matchableItems);
        matches.forEach((match) => {
          for (let i = 0; i < match.items.length; i++) {
            let cookie = match.items[i];
            let oldType = cookie.itemType;
            let newType = Phaser.Math.RND.pickExcept(cookieTypes, cookie.itemType);
            cookie.updateItemType(newType);
            let newMatches = MatchFinder.findAll(matchableItems);
            if (newMatches.length === matches.length) {
              cookie.updateItemType(oldType);
            } else {
              break;
            }
          }
        });
      } while (matches.length > 0 && --safetyCounter > 0);
    }
    getItemTypes() {
      return Object.keys(this.config.generator.weights).filter((itemType) => {
        let isCookie2 = ItemTypeUtil.getItemSuperType(itemType) === ItemSuperType.COOKIE;
        let nonZero = this.config.generator.weights[itemType] > 0;
        return isCookie2 && nonZero;
      });
    }
    remove() {
      this.scene.editorPanels.disablePanels();
      this.scene.gui.bottomBar.disableInput();
      this.configsManager.remove(this.config.levelNumber);
      return this.configsManager.saveLocally().then(() => {
        console.info(`Level ${this.config.levelNumber} config was succesfully removed!`);
      }).catch((xhr) => {
        console.warn(`Can't remove level ${this.config.levelNumber} config. Please try again!`);
      }).finally(() => {
        this.scene.editorPanels.enablePanels();
        this.scene.gui.bottomBar.enableInput();
      });
    }
    removeAndShift() {
      this.scene.editorPanels.disablePanels();
      this.scene.gui.bottomBar.disableInput();
      this.configsManager.removeAndShift(this.config.levelNumber);
      return this.configsManager.saveLocally().then(() => {
        console.info(`Level ${this.config.levelNumber} config was succesfully removed!`);
      }).catch((xhr) => {
        console.warn(`Can't remove level ${this.config.levelNumber} config. Please try again!`);
      }).finally(() => {
        this.scene.editorPanels.enablePanels();
        this.scene.gui.bottomBar.enableInput();
      });
    }
    swapWith(levelNumber) {
      let levelConfigs = this.scene.game.levelConfigs;
      let levelNumber_1 = this.config.levelNumber;
      let levelNumber_2 = levelNumber;
      let level_1 = levelConfigs.get(levelNumber_1);
      let level_2 = levelConfigs.get(levelNumber_2);
      if (!level_1 || !level_2) {
        return Promise.reject("These levels don't exist!");
      }
      this.scene.editorPanels.disablePanels();
      this.scene.gui.topBar.disableInput();
      this.scene.gui.bottomBar.disableInput();
      levelConfigs.remove(levelNumber_1);
      levelConfigs.remove(levelNumber_2);
      level_1.levelNumber = levelNumber_2;
      levelConfigs.add(level_1);
      level_2.levelNumber = levelNumber_1;
      levelConfigs.add(level_2);
      return this.configsManager.saveLocally().then(() => {
        console.info(`Levels ${levelNumber_1} & ${levelNumber_2} was succesfully swapped!`);
      }).catch((xhr) => {
        console.warn(`Can't swap levels ${levelNumber_1} & ${levelNumber_2}. Please try again!`);
      }).finally(() => {
        this.scene.editorPanels.enablePanels();
        this.scene.gui.topBar.enableInput();
        this.scene.gui.bottomBar.enableInput();
      });
    }
    updateLevelConfig() {
      let itemsConfig = this.getItemsConfig();
      let fixResult = fixItemsLayout(itemsConfig, this.scene.createCookieTypesGenerator(), 100, Phaser.Math.RND);
      if (fixResult.hasDeadlock) {
        console.warn("Can't fix DEADLOCK! Please change layout or adjust weights.");
      }
      if (fixResult.hasMatches) {
        console.warn("Can't fix MATCHES! Please change layout or adjust weights.");
      }
      if (!fixResult.hasMatches && !fixResult.hasDeadlock && fixResult.wasChanged) {
        console.log("Items layout was fixed (no matches and deadlock now).");
      }
      this.updateExistingCookies(fixResult.items);
      this.suggestPregameBoostersHints(this.config.items, this.config.goals);
      this.config.grid = {columns: this.scene.grid.columns, rows: this.scene.grid.rows};
      this.config.field = this.getFieldConfig();
      this.config.tutorial = this.getTutorialConfig();
      this.config.items = fixResult.items;
    }
    getItemsConfig() {
      let itemsManager = this.scene.items;
      let bottomItems = itemsManager.bottomItems.toArrayUniq().slice(0);
      let middleItems = itemsManager.mainItems.toArrayUniq().slice(0);
      let topItems = itemsManager.topItems.toArray().slice(0);
      let allItems = [...bottomItems, ...middleItems, ...topItems].sort(sortUpBottom);
      return allItems.map((item) => {
        return {
          column: item.column,
          row: item.row,
          itemType: item.itemType,
          params: item.params
        };
      });
    }
    getFieldConfig() {
      return this.scene.field.cells.toArray().slice(0).sort(sortUpBottom).map((cell) => {
        return {column: cell.column, row: cell.row};
      });
    }
    suggestPregameBoostersHints(items, goals) {
      let suggestedHints = Object.keys(getPregameBoostersHints(items, goals));
      let actualHints = Object.keys(this.config.preGameBoostersHints).filter((boosterType) => this.config.preGameBoostersHints[boosterType]);
      let missingHints = without_default(suggestedHints, ...actualHints);
      if (missingHints.length > 0) {
        console.log("\u{1F4A1} Suggested pregame boosters:", missingHints.join(", "));
      }
    }
    getTutorialConfig() {
      this.config.tutorial.autoGenerated = this.config.tutorial.steps.length === 0;
      this.config.tutorial.steps.forEach((step) => {
        if (step.type === TutorialStepType.MATCH) {
          let tutorialArea = this.scene.getTutorialById(step.areaId);
          if (tutorialArea) {
            step.cells = tutorialArea.cells.slice(0);
          }
        }
      });
      return this.config.tutorial;
    }
    updateExistingCookies(items) {
      let configCookies = getCookies(items);
      let existingCookies = this.scene.items.getCookies();
      configCookies.forEach((cookieConfig) => {
        let {column, row, itemType: newItemType} = cookieConfig;
        let cookie = existingCookies.find((cookie2) => cookie2.column === column && cookie2.row === row);
        if (cookie.itemType === newItemType) {
          return;
        }
        cookie.updateItemType(newItemType);
        let powerup = cookie.params.powerup;
        if (powerup) {
          cookie.setFrame(CookieUtils.getFrame(cookie.itemType, powerup));
        }
      });
    }
  };

  // src/scenes/levelEditor/floatButtons/FloatingButton.ts
  var FloatingButton = class extends SimpleButton {
    constructor(scene, atlasKey, frame, parent) {
      super(scene, atlasKey, frame, parent);
      this.defaultAlpha = 0.75;
      this.alpha = this.defaultAlpha;
      this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, this.onPointerOver, this);
      this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, this.onPointerOut, this);
    }
    onPointerOver() {
      this.alpha = 1;
    }
    onPointerOut() {
      this.alpha = this.defaultAlpha;
    }
    enableInput() {
      super.enableInput();
      this.alpha = this.defaultAlpha;
    }
    disableInput() {
      super.disableInput();
      this.alpha = 0.33;
    }
  };

  // src/scenes/levelEditor/floatButtons/ButtonsFloatPanel.ts
  var ButtonsFloatPanel = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.slotSize = 46;
      this.name = "float_buttons";
      this.addButtons();
      this.gridAlign({
        width: this.list.length,
        cellWidth: this.slotSize,
        position: Phaser.Display.Align.CENTER,
        x: this.slotSize / 2
      });
      this.setSize(this.list.length * this.slotSize, this.removeButton.height);
    }
    addButtons() {
      this.removeButton = new FloatingButton(this.scene, "editor", "small_button_remove", this);
      this.fillButton = new FloatingButton(this.scene, "editor", "small_button_fill", this);
      this.addButton = new FloatingButton(this.scene, "editor", "small_button_add", this);
      this.modsButton = new FloatingButton(this.scene, "editor", "small_button_edit", this);
      this.lockButton = new FloatingButton(this.scene, "editor", "small_button_lock", this);
      this.tutorialButton = new FloatingButton(this.scene, "editor", "small_button_tutorial", this);
    }
    show() {
      var _a;
      this.revive();
      (_a = this.hideTween) == null ? void 0 : _a.remove();
      this.alpha = 1;
    }
    hide() {
      this.hideTween = this.scene.tweens.add({
        delay: 50,
        targets: this,
        duration: 100,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.kill();
        }
      });
    }
    enableAllButtons() {
      this.iterate((button) => {
        button.enableInput();
      });
    }
    updateViewBySelection(selectedItem) {
      let selectedItemType = selectedItem.getData("type");
      switch (selectedItemType) {
        case LevelEditorObjectType.GRID_CELL:
          this.removeButton.disableInput();
          this.fillButton.enableInput();
          this.addButton.enableInput();
          this.modsButton.disableInput();
          this.lockButton.disableInput();
          this.tutorialButton.enableInput();
          break;
        case LevelEditorObjectType.FIELD_CELL:
          this.removeButton.enableInput();
          this.fillButton.enableInput();
          this.addButton.enableInput();
          this.modsButton.disableInput();
          this.lockButton.disableInput();
          this.tutorialButton.enableInput();
          break;
        case LevelEditorObjectType.ITEM:
          let editorItem = selectedItem;
          this.removeButton.enableInput();
          this.fillButton.disableInput();
          this.addButton.enableInput();
          this.tutorialButton.enableInput();
          if (editorItem.itemSuperType === ItemSuperType.COOKIE) {
            this.modsButton.enableInput();
            this.lockButton.enableInput();
          } else {
            this.modsButton.disableInput();
            this.lockButton.disableInput();
          }
          break;
        case LevelEditorObjectType.TUTORIAL:
          this.removeButton.enableInput();
          this.fillButton.disableInput();
          this.addButton.disableInput();
          this.modsButton.disableInput();
          this.lockButton.disableInput();
          this.tutorialButton.disableInput();
          break;
        default:
          this.enableAllButtons();
          break;
      }
    }
  };

  // src/scenes/levelEditor/tutorial/TutorialArea.ts
  var TutorialArea = class extends Phaser.GameObjects.Container {
    constructor(scene, id, cells) {
      super(scene);
      this.column = 0;
      this.row = 0;
      this._isSelected = false;
      this.id = id;
      this.name = `tutorial_${this.id}`;
      this.cells = cells;
      this.setData("type", LevelEditorObjectType.TUTORIAL);
      this.calculateGridBounds();
      this.addGraphics();
      this.addIdText();
      this.fillCells();
      this.setSize(CELL_SIZE, CELL_SIZE);
      this.setInteractive();
      this.input.cursor = "pointer";
    }
    get isSelected() {
      return this._isSelected;
    }
    calculateGridBounds() {
      let top = minBy_default(this.cells, "row").row;
      let bottom = maxBy_default(this.cells, "row").row;
      let left = minBy_default(this.cells, "column").column;
      let right = maxBy_default(this.cells, "column").column;
      this.column = left;
      this.row = top;
      this.gridBounds = {
        column: left,
        row: top,
        width: right - left + 1,
        height: bottom - top + 1
      };
    }
    addGraphics() {
      this.graphics = this.scene.add.graphics();
      this.graphics.fillStyle(0, 0.8);
      this.graphics.x = -CELL_SIZE / 2;
      this.graphics.y = -CELL_SIZE / 2;
      this.add(this.graphics);
    }
    addIdText() {
      let content = this.id.toString();
      let style = {
        fontFamily: "monospace",
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "22px",
        color: "#ffffff",
        align: "center"
      };
      this.idText = this.scene.add.text(0, 0, content, style);
      this.idText.setStroke("#000000", 12);
      this.idText.setOrigin(0.5, 0.5);
      this.add(this.idText);
    }
    fillCells() {
      let left = this.gridBounds.column;
      let top = this.gridBounds.row;
      this.cells.forEach((cell) => {
        let column = cell.column - left;
        let row = cell.row - top;
        this.graphics.fillRect(column * CELL_SIZE, row * CELL_SIZE, CELL_SIZE, CELL_SIZE);
      });
    }
    select() {
      if (this._isSelected) {
        return;
      }
      this._isSelected = true;
      this.emit(SelectableEvent.SELECT, this);
    }
    unselect() {
      if (this._isSelected === false) {
        return;
      }
      this._isSelected = false;
      this.emit(SelectableEvent.UNSELECT, this);
    }
    alignToGrid() {
      let {x, y} = gridToPixels(this.gridBounds.column, this.gridBounds.row);
      this.x = x;
      this.y = y;
    }
  };

  // src/scenes/levelEditor/items/EditorGummy.ts
  var EditorGummy = class extends Phaser.GameObjects.Image {
    constructor(scene, itemType, params) {
      super(scene, 0, 0, "gameplay", ItemTypeUtil.getFrameByItemType(itemType));
      this.itemSuperType = ItemSuperType.GUMMY;
      this._isSelected = false;
      this.name = "gummy";
      this.id = Phaser.Math.RND.uuid();
      this.itemType = itemType;
      this.params = params;
      this.setData("itemType", this.itemType);
      this.setData("itemSuperType", this.itemSuperType);
      this.setMulticell();
      this.setSize(this.itemWidth * CELL_SIZE, this.itemHeight * CELL_SIZE);
      this.setInteractive();
    }
    get isSelected() {
      return this._isSelected;
    }
    setMulticell() {
      this.isMultiCell = MultiCellUtils.isMulticell(this.itemType);
      if (this.isMultiCell) {
        let size = MultiCellUtils.getSize(this.itemType);
        this.itemWidth = size.width;
        this.itemHeight = size.height;
      }
    }
    select() {
      if (this._isSelected) {
        return;
      }
      this._isSelected = true;
      this.emit(SelectableEvent.SELECT, this);
    }
    unselect() {
      if (this._isSelected === false) {
        return;
      }
      this._isSelected = false;
      this.emit(SelectableEvent.UNSELECT, this);
    }
    alignToGrid() {
      let topLeft = gridToPixels(this.column, this.row);
      let top = topLeft.y - CELL_SIZE / 2;
      let left = topLeft.x - CELL_SIZE / 2;
      this.x = left + this.width / 2;
      this.y = top + this.height / 2;
    }
  };

  // src/scenes/levelEditor/items/EditorApplePlatter.ts
  var EditorApplePlatterEvent;
  (function(EditorApplePlatterEvent2) {
    EditorApplePlatterEvent2["APPLES_NUM_CHANGE"] = "__APPLES_NUM_CHANGE";
  })(EditorApplePlatterEvent || (EditorApplePlatterEvent = {}));
  var _EditorApplePlatter = class extends Phaser.GameObjects.Container {
    constructor(scene, params) {
      super(scene, 0, 0);
      this.itemType = ItemType.APPLES_PLATTER;
      this.itemSuperType = ItemSuperType.APPLE_PLATTER;
      this._isSelected = false;
      this.id = Phaser.Math.RND.uuid();
      this.name = `apple_platter__${this.id}`;
      this.params = params;
      this.setData("itemType", this.itemType);
      this.setData("itemSuperType", this.itemSuperType);
      this.setMulticell();
      this.addPlatterBack();
      this.addApples(this.params.applesNum);
      this.alignApples();
      this.addPlatterFrontEdge();
      this.setSize(this.itemWidth * CELL_SIZE, this.itemHeight * CELL_SIZE);
      this.setInteractive();
    }
    get isSelected() {
      return this._isSelected;
    }
    setMulticell() {
      this.isMultiCell = MultiCellUtils.isMulticell(this.itemType);
      if (this.isMultiCell) {
        let size = MultiCellUtils.getSize(this.itemType);
        this.itemWidth = size.width;
        this.itemHeight = size.height;
      }
    }
    addPlatterBack() {
      this.platterBack = this.scene.add.image(0, 0, "gameplay", ItemTypeUtil.getFrameByItemType(this.itemType));
      this.add(this.platterBack);
    }
    addApples(applesNum) {
      this.apples = times_default(applesNum, () => {
        return this.scene.make.image({
          key: "gameplay",
          frame: "apples_platter/apple"
        });
      });
      this.add(this.apples);
    }
    alignApples() {
      let positions = this.getApplePositions();
      this.apples.forEach((apple, index) => {
        let position = positions[index];
        apple.x = position.x;
        apple.y = position.y;
        this.bringToTop(apple);
      });
      this.apples = this.apples.reverse();
      this.apples.forEach((apple) => this.bringToTop(apple));
    }
    getApplePositions() {
      let columns = 3;
      let rows = 3;
      let cellWidth = 39;
      let cellHeight = 38;
      let totalWidth = cellWidth * columns;
      let totalHeight = cellHeight * rows;
      let startX = cellWidth / 2 - totalWidth / 2;
      let startY = cellHeight / 2 - totalHeight / 2 - 8;
      let positions = [];
      for (let row = 0; row < columns; row++) {
        for (let column = 0; column < rows; column++) {
          positions.push({
            x: startX + column * cellWidth,
            y: startY + row * cellHeight
          });
        }
      }
      return positions.reverse();
    }
    addPlatterFrontEdge() {
      this.platterFrontEdge = this.scene.add.image(0, 0, "gameplay", "apples_platter/Tray_01");
      this.platterFrontEdge.setOrigin(0.5, 1);
      this.platterFrontEdge.y = this.platterBack.bottom;
      this.add(this.platterFrontEdge);
    }
    select() {
      if (this._isSelected) {
        return;
      }
      this._isSelected = true;
      this.emit(SelectableEvent.SELECT, this);
    }
    unselect() {
      if (this._isSelected === false) {
        return;
      }
      this._isSelected = false;
      this.emit(SelectableEvent.UNSELECT, this);
    }
    getApplesNum() {
      return this.params.applesNum;
    }
    setApplesNum(value) {
      let oldValue = this.params.applesNum;
      let newValue = Phaser.Math.Clamp(value, 1, _EditorApplePlatter.DEFAULT_APPLES_NUM);
      if (newValue === oldValue) {
        return;
      }
      this.params.applesNum = newValue;
      this.updateApplesVisibility(newValue);
      this.emit(EditorApplePlatterEvent.APPLES_NUM_CHANGE, this, newValue);
    }
    updateApplesVisibility(newValue) {
      this.apples.forEach((apple, index) => {
        let reverseIndex = this.apples.length - 1 - index;
        if (reverseIndex < newValue) {
          apple.revive();
        } else {
          apple.kill();
        }
      });
    }
  };
  var EditorApplePlatter = _EditorApplePlatter;
  EditorApplePlatter.DEFAULT_APPLES_NUM = 9;

  // src/scenes/levelEditor/items/EditorItemsFactory.ts
  var EditorItemsFactory = class extends Phaser.Events.EventEmitter {
    constructor(scene) {
      super();
      this.scene = scene;
    }
    create(config2) {
      let superType = ItemTypeUtil.getItemSuperType(config2.itemType);
      switch (superType) {
        case ItemSuperType.BISCUIT:
        case ItemSuperType.MARSHMALLOW:
        case ItemSuperType.DROP_ITEM:
        case ItemSuperType.CHOCOLATE:
        case ItemSuperType.CANDY_BOTTLE:
        case ItemSuperType.DONUT_BOX:
        case ItemSuperType.LICORICE:
        case ItemSuperType.MYSTERY_BOX:
        case ItemSuperType.CHICK:
        case ItemSuperType.GUMMY_BLOCKER:
          return this.createBasicItem(config2.itemType, config2.params);
        case ItemSuperType.COOKIE:
          return this.createCookie(config2.itemType, config2.params);
        case ItemSuperType.COLOR_CAKE:
          return this.createColorCake(config2.params);
        case ItemSuperType.GENERATOR:
          return this.createGenerator(config2.params);
        case ItemSuperType.GUMMY:
          return this.createGummy(config2.itemType, config2.params);
        case ItemSuperType.APPLE_PLATTER:
          return this.createApplePlatter(config2.params);
        default:
          console.warn("Unknown item type!", config2);
          return null;
      }
    }
    createBasicItem(itemType, params) {
      let item = new EditorItemBasic(this.scene, "gameplay", itemType);
      item.params = params != null ? params : {type: "basic"};
      return item;
    }
    createCookie(itemType, params) {
      let item = new EditorCookie(this.scene, "gameplay", itemType);
      item.params = params != null ? params : {type: "cookie"};
      item.on(SelectableEvent.SELECT, this.onItemSelect, this);
      item.on(SelectableEvent.UNSELECT, this.onItemUnselect, this);
      return item;
    }
    createColorCake(params) {
      params = params != null ? params : {
        type: "color_cake",
        content: ColorCake.getDefaultContent()
      };
      let cake = new EditorColorCake(this.scene, params.content);
      cake.params = params;
      cake.on(SelectableEvent.SELECT, this.onItemSelect, this);
      cake.on(SelectableEvent.UNSELECT, this.onItemUnselect, this);
      return cake;
    }
    createGenerator(params) {
      params = params != null ? params : {
        type: "generator",
        turnsNum: 3,
        content: GeneratorContent.DROP_ITEM,
        contentMod: GeneratorContentMod.NONE,
        invisible: false
      };
      let generator = new EditorGenerator(this.scene, params.turnsNum, params.content, params.contentMod, params.invisible);
      generator.params = params;
      generator.on(SelectableEvent.SELECT, this.onItemSelect, this);
      generator.on(SelectableEvent.UNSELECT, this.onItemUnselect, this);
      return generator;
    }
    createGummy(itemType, params) {
      params != null ? params : params = {
        type: "gummy"
      };
      let gummy = new EditorGummy(this.scene, itemType, params);
      gummy.on(SelectableEvent.SELECT, this.onItemSelect, this);
      gummy.on(SelectableEvent.UNSELECT, this.onItemUnselect, this);
      return gummy;
    }
    createApplePlatter(params) {
      params != null ? params : params = {
        type: "apple_platter",
        applesNum: EditorApplePlatter.DEFAULT_APPLES_NUM
      };
      let applePlatter = new EditorApplePlatter(this.scene, params);
      applePlatter.on(SelectableEvent.SELECT, this.onItemSelect, this);
      applePlatter.on(SelectableEvent.UNSELECT, this.onItemUnselect, this);
      return applePlatter;
    }
    onItemSelect(item) {
      let panel = this.scene.editorPanels.itemPanels[item.itemSuperType];
      if (panel) {
        panel.setItem(item);
        panel.show();
      }
    }
    onItemUnselect(item) {
      let panel = this.scene.editorPanels.itemPanels[item.itemSuperType];
      if (panel) {
        panel.resetItem();
        panel.hide();
      }
    }
  };

  // src/scenes/levelEditor/LevelEditor.ts
  var LevelEditorEvent;
  (function(LevelEditorEvent2) {
    LevelEditorEvent2["BACKGROUND_CHANGE"] = "__BACKGROUND_CHANGE";
    LevelEditorEvent2["CONFIG_REMOVE"] = "__CONFIG_REMOVE";
    LevelEditorEvent2["TEST_LEVEL"] = "__TEST_LEVEL";
    LevelEditorEvent2["CHANGE_LEVEL"] = "__CHANGE_LEVEL";
    LevelEditorEvent2["RESTART"] = "__RESTART";
  })(LevelEditorEvent || (LevelEditorEvent = {}));
  var LevelEditor3 = class extends BaseScene {
    init(data) {
      super.init(data);
      this.levelConfig = data;
      this.levelConfigHelper = new LevelConfigHelper(this);
      this.levelNumber = data.levelNumber;
      this.tutorialsId = 1;
    }
    create() {
      this.setLayersVisibility();
      this.addEditorPanels();
      this.addSelectionManager();
      this.addItemsFactory();
      this.addGrid();
      this.addField();
      this.addItemsLayer();
      this.addTutorialLayer();
      this.addFloatButtons();
      this.addItemsPopover();
      this.addCookiePowerupsPopover();
      this.addPointerCallbacks();
      this.addKeyboardCallbacks();
      this.resize();
    }
    setLayersVisibility() {
      this.layers = {
        [LevelEditorDepth.BOTTOM_ITEMS]: true,
        [LevelEditorDepth.MAIN_ITEMS]: true,
        [LevelEditorDepth.TOP_ITEMS]: true,
        [LevelEditorDepth.TUTORIAL]: true,
        [LevelEditorDepth.GENERATORS]: true
      };
    }
    addEditorPanels() {
      this.editorPanels = new EditorPanelsManager(this);
    }
    addSelectionManager() {
      this.selection = new SelectionManager(this);
      this.selection.on(SelectionManagerEvent.SELECT, this.onItemSelect, this);
      this.selection.on(SelectionManagerEvent.UNSELECT, this.onItemUnselect, this);
      this.selection.setDepth(LevelEditorDepth.SELECT_FRAMES);
      this.add.existing(this.selection);
    }
    onItemSelect(item) {
      let instantMove = this.floatButtons.visible === false;
      this.moveFloatButtonsTo(item.column, item.row, instantMove);
      this.floatButtons.revive();
      this.floatButtons.updateViewBySelection(item);
    }
    onItemUnselect(item) {
      let selection = this.selection.getSelectedItems();
      if (selection.length === 0) {
        this.floatButtons.kill();
        return;
      }
      let closest = minBy_default(selection, (selectedItem) => Phaser.Math.Distance.Between(item.x, item.y, selectedItem.x, selectedItem.y));
      this.moveFloatButtonsTo(closest.column, closest.row, false);
    }
    addSelectable(item) {
      this.selection.addSelectable(item);
    }
    removeSelectable(item) {
      this.selection.removeSelectable(item);
    }
    addItemsFactory() {
      this.factory = new EditorItemsFactory(this);
    }
    addGrid() {
      this.grid = new BaseGrid(this, this.levelConfig.grid.columns, this.levelConfig.grid.rows);
      this.grid.on(EditorGridEvent.ADD_CELL, this.addSelectable, this);
      this.grid.on(EditorGridEvent.REMOVE_CELL, this.removeSelectable, this);
      this.grid.on(EditorGridEvent.HIGHLIGHT, this.onGridHighlight, this);
      this.grid.on(EditorGridEvent.UNHIGHLIGHT, this.onGridUnhighlight, this);
      this.add.existing(this.grid);
      this.selection.addFrames(this.grid);
      this.selection.addSelectable(this.grid.cells.toArray());
    }
    onGridHighlight(type, value) {
      if (type === "column") {
        this.selection.highlightColumn(value);
      } else {
        this.selection.highlightRow(value);
      }
    }
    onGridUnhighlight(type, value) {
      if (type === "column") {
        this.selection.unhighlightColumn(value);
      } else {
        this.selection.unhighlightRow(value);
      }
    }
    addField() {
      this.field = new Field(this, this.grid.rows, this.grid.columns);
      this.field.on(FieldEvent.ADD_CELL, this.onFieldCellAdd, this);
      this.field.on(FieldEvent.REMOVE_CELL, this.onFieldCellRemove, this);
      this.field.fillFromConfig(this.levelConfig.field);
      this.add.existing(this.field);
      this.addDefaultField();
    }
    onFieldCellAdd(cell) {
      this.selection.addSelectable(cell);
    }
    onFieldCellRemove(cell) {
      this.selection.removeSelectable(cell);
    }
    addDefaultField() {
      let isEmpty = this.levelConfig.field.length === 0;
      if (!isEmpty) {
        return;
      }
      for (let row = 1; row < this.grid.rows - 1; row++) {
        for (let column = 1; column < this.grid.columns - 1; column++) {
          this.field.addCell(column, row);
        }
      }
    }
    addItemsLayer() {
      this.items = new ItemsContainer(this, this.grid.rows, this.grid.columns, this.layers);
      this.items.setDepth(LevelEditorDepth.MAIN_ITEMS);
      this.items.on(ItemsContainerEvent.ADD_ITEM, this.addSelectable, this);
      this.items.on(ItemsContainerEvent.REMOVE_ITEM, this.removeSelectable, this);
      this.items.fillFromConfig(this.levelConfig.items);
      this.add.existing(this.items);
    }
    addTutorialLayer() {
      this.tutorialLayer = this.add.container(0, 0);
      this.tutorialLayer.setName("tutorial");
      this.tutorialLayer.setDepth(LevelEditorDepth.TUTORIAL);
      this.tutorials = [];
      this.levelConfig.tutorial.steps.forEach((step) => {
        if (step.type === TutorialStepType.MATCH) {
          this.doAddTutorial(step.cells);
        }
      });
    }
    addFloatButtons() {
      this.floatButtons = new ButtonsFloatPanel(this);
      this.floatButtons.setDepth(LevelEditorDepth.FLOATING_BUTTONS);
      this.floatButtons.kill();
      this.floatButtons.fillButton.on(ButtonEvent.PRESS, this.onFloatingFillButtonClick, this);
      this.floatButtons.removeButton.on(ButtonEvent.PRESS, this.onFloatingRemoveButtonClick, this);
      this.floatButtons.lockButton.on(ButtonEvent.PRESS, this.onFloatingLockButtonClick, this);
      this.floatButtons.addButton.on(ButtonEvent.PRESS, this.onFloatingAddButtonClick, this);
      this.floatButtons.modsButton.on(ButtonEvent.PRESS, this.onFloatingModsButtonClick, this);
      this.floatButtons.tutorialButton.on(ButtonEvent.PRESS, this.tryToAddTutorial, this);
      this.add.existing(this.floatButtons);
    }
    onFloatingFillButtonClick() {
      this.fillSelectedCells();
    }
    onFloatingRemoveButtonClick() {
      this.removeSelectedItems();
      this.floatButtons.kill();
    }
    onFloatingLockButtonClick() {
      this.lockSelectedCookies();
      this.floatButtons.kill();
    }
    onKeyDownL() {
      if (this.selection.selectionType === LevelEditorObjectType.ITEM && this.getSelectedCookies().length > 0) {
        this.lockSelectedCookies();
      } else {
        this.fillSelectedFieldCellsWith(ItemType.LICORICE_CHOCO);
      }
    }
    lockSelectedCookies() {
      this.getSelectedCookies().forEach((cookie) => {
        if (!cookie.params.locked) {
          this.items.lockCookie(cookie);
        }
      });
    }
    unlockSelectedCookies() {
      this.getSelectedCookies().forEach((cookie) => {
        if (cookie.params.locked) {
          this.items.unlockCookie(cookie);
        }
      });
    }
    lockAllCookies() {
      this.items.getCookies().forEach((cookie) => {
        if (!cookie.params.locked) {
          this.items.lockCookie(cookie);
        }
      });
    }
    unlockAllCookies() {
      this.items.getCookies().forEach((cookie) => {
        if (cookie.params.locked) {
          this.items.unlockCookie(cookie);
        }
      });
    }
    onFloatingAddButtonClick() {
      let selectedItem = this.selection.lastSelected;
      if (!selectedItem) {
        return;
      }
      selectedItem.once(SelectableEvent.UNSELECT, () => {
        this.itemsPopover.hide();
      });
      this.showPopoverAt(this.itemsPopover, selectedItem.column, selectedItem.row);
      this.floatButtons.kill();
    }
    onFloatingModsButtonClick() {
      let selectedItem = this.selection.lastSelected;
      if (!selectedItem) {
        return;
      }
      selectedItem.once(SelectableEvent.UNSELECT, () => {
        this.powerupsPopover.hide();
      });
      this.showPopoverAt(this.powerupsPopover, selectedItem.column, selectedItem.row);
      this.floatButtons.kill();
    }
    tryToAddTutorial() {
      let selectedItems = this.selection.getSelectedItems();
      if (selectedItems.length === 0) {
        return;
      }
      this.addTutorial();
      this.selection.unselectAll();
      this.floatButtons.kill();
    }
    addTutorial() {
      let cells = this.selection.getSelectedItems().map((item) => ({column: item.column, row: item.row}));
      this.doAddTutorial(cells);
    }
    doAddTutorial(cells, id) {
      let tutorialId = id != null ? id : this.getNewTutorialId();
      let tutorial = new TutorialArea(this, tutorialId, cells);
      tutorial.once(Phaser.GameObjects.Events.DESTROY, this.onTutorialDestroy.bind(this, tutorial));
      tutorial.alignToGrid();
      this.addSelectable(tutorial);
      this.tutorialLayer.add(tutorial);
      this.tutorials.push(tutorial);
      return tutorial;
    }
    getNewTutorialId() {
      let ids = this.tutorials.map((tutorial) => tutorial.id);
      if (ids.length > 0) {
        return Math.max(...ids) + 1;
      }
      return 1;
    }
    onTutorialDestroy(tutorial) {
      pull_default(this.tutorials, tutorial);
    }
    getTutorialById(id) {
      return this.tutorials.find((tutorial) => tutorial.id === id);
    }
    showPopoverAt(popover, column, row) {
      let cell = this.grid.getCellAt(column, row);
      if (!cell) {
        return;
      }
      let worldPosition = cell.getWorldPosition();
      let paddingX = popover.width / 2 + 10;
      let minX = paddingX;
      let maxX = Config.GAME_WIDTH - paddingX;
      popover.x = Phaser.Math.Clamp(worldPosition.x, minX, maxX);
      let minY = popover.height - 20;
      let maxY = Config.GAME_HEIGHT;
      popover.y = Phaser.Math.Clamp(worldPosition.y - 40, minY, maxY);
      popover.setTipOffset(worldPosition.x - popover.x);
      popover.show();
    }
    moveFloatButtonsTo(column, row, instant = true) {
      var _a;
      let cell = this.grid.getCellAt(column, row);
      if (!cell) {
        return;
      }
      (_a = this.floatButtons.moveTween) == null ? void 0 : _a.remove();
      let worldPosition = cell.getWorldPosition();
      let x = worldPosition.x - this.floatButtons.width / 2;
      let y = worldPosition.y - this.floatButtons.height / 2 - 42;
      if (instant) {
        this.floatButtons.x = x;
        this.floatButtons.y = y;
      } else {
        this.floatButtons.moveTween = this.tweens.add({
          targets: this.floatButtons,
          duration: 200,
          ease: Phaser.Math.Easing.Quadratic.Out,
          x,
          y
        });
      }
    }
    addItemsPopover() {
      let types = [
        [null, ...ItemTypeUtil.getSubtypes(ItemSuperType.COOKIE)],
        ItemTypeUtil.getSubtypes(ItemSuperType.MARSHMALLOW),
        ItemTypeUtil.getSubtypes(ItemSuperType.CHOCOLATE),
        [ItemType.DROP_ITEM, ItemType.BISCUIT, ItemType.CANDY_BOTTLE, ItemType.DONUT_BOX, ...ItemTypeUtil.getSubtypes(ItemSuperType.LICORICE), ItemType.APPLES_PLATTER, ItemType.COLOR_CAKE],
        [...ItemTypeUtil.getSubtypes(ItemSuperType.GUMMY), ItemType.GUMMY_BLOCKER, ItemType.MYSTERY_BOX, ItemType.GENERATOR, ItemType.CHICK]
      ];
      this.itemsPopover = new AddItemPopover(this, "gameplay", types);
      this.itemsPopover.on(AddItemPopoverEvent.ITEM_CLICK, this.addItemsToSelectedCells, this);
      this.itemsPopover.kill();
      this.itemsPopover.setDepth(LevelEditorDepth.POPOVERS);
      this.add.existing(this.itemsPopover);
    }
    addItemsToSelectedCells(itemType) {
      if (itemType === ItemType.GENERATOR) {
        this.addGeneratorsToSelectedCells();
        return;
      }
      this.selection.getSelectedItems().map((item) => this.field.getCellAt(item.column, item.row)).forEach((cell) => {
        let isMulticell = MultiCellUtils.isMulticell(itemType);
        if (isMulticell === false) {
          this.items.addItem(cell.column, cell.row, itemType);
          return;
        }
        let canFit = this.canAddMulticellItemAt(itemType, cell);
        if (canFit) {
          let newItem = this.items.addItem(cell.column, cell.row, itemType);
          if (newItem.itemSuperType === ItemSuperType.GUMMY) {
            this.autoAddGummyBlockers(newItem);
          }
        }
      });
      this.itemsPopover.hide();
      this.selection.unselectAll();
    }
    addGeneratorsToSelectedCells() {
      this.selection.getSelectedItems().filter(({column, row}) => this.field.cells.checkAt(column, row) === false).forEach(({column, row}) => {
        this.items.addItem(column, row, ItemType.GENERATOR);
      });
      this.itemsPopover.hide();
      this.selection.unselectAll();
    }
    canAddMulticellItemAt(itemType, cell) {
      let size = MultiCellUtils.getSize(itemType);
      let positions = MultiCellUtils.getPositions(cell.column, cell.row, size);
      return positions.every((position) => {
        let isCellExist = !!this.field.getCellAt(position.column, position.row);
        let isCellFree = this.items.mainItems.checkAt(position.column, position.row) === false;
        return isCellExist && isCellFree;
      });
    }
    autoAddGummyBlockers(gummy) {
      MultiCellUtils.getItemPositions(gummy).forEach((position) => {
        this.items.addItem(position.column, position.row, ItemType.GUMMY_BLOCKER);
      });
    }
    addCookiePowerupsPopover() {
      this.powerupsPopover = new ModifiersPopover(this);
      this.powerupsPopover.horizontalStripes.on(ButtonEvent.PRESS, this.onModButtonClick, this);
      this.powerupsPopover.verticalStripes.on(ButtonEvent.PRESS, this.onModButtonClick, this);
      this.powerupsPopover.bomb.on(ButtonEvent.PRESS, this.onModButtonClick, this);
      this.powerupsPopover.superSphere.on(ButtonEvent.PRESS, this.onModButtonClick, this);
      this.powerupsPopover.clear.on(ButtonEvent.PRESS, this.clearMods, this);
      this.powerupsPopover.setDepth(LevelEditorDepth.POPOVERS);
      this.powerupsPopover.kill();
      this.add.existing(this.powerupsPopover);
      this.powerupsPopover.x = Config.HALF_GAME_WIDTH;
      this.powerupsPopover.y = Config.HALF_GAME_HEIGHT;
    }
    getSelectedCookies() {
      let selectionType = this.selection.selectionType;
      if (selectionType !== LevelEditorObjectType.ITEM) {
        return [];
      }
      return this.selection.getSelectedItems().filter((item) => item.itemSuperType === ItemSuperType.COOKIE);
    }
    onModButtonClick(button) {
      let powerup = button.getData("mod");
      this.getSelectedCookies().forEach((cookie) => this.setPowerupOnCookie(cookie, powerup));
      this.powerupsPopover.hide();
    }
    setPowerupOnCookie(cookie, powerup) {
      cookie.setPowerup(powerup);
    }
    clearMods() {
      this.getSelectedCookies().forEach((cookie) => this.removePowerupFromCookie(cookie));
      this.powerupsPopover.hide();
    }
    removePowerupFromCookie(cookie) {
      cookie.setPowerup(null);
    }
    addPointerCallbacks() {
      this.input.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onPointerDown, this);
      this.input.on(Phaser.Input.Events.POINTER_WHEEL, this.onPointerWheel, this);
    }
    onPointerDown(pointer, objects) {
      let event = pointer.event;
      if (event instanceof MouseEvent) {
        if (event.button === 1) {
          let localPos = this.items.pointToContainer({x: pointer.x, y: pointer.y});
          let {column, row} = pixelsToGridXY(localPos.x, localPos.y);
          let item = this.items.mainItems.getAt(column, row);
          if (!item) {
            return;
          }
          if (item.itemSuperType === ItemSuperType.COOKIE) {
            let powerups = [CookiePowerup.VERTICAL_STRIPES, CookiePowerup.HORIZONTAL_STRIPES, CookiePowerup.BOMB, CookiePowerup.SUPER_SPHERE];
            let powerup = item.params.powerup;
            if (powerup) {
              if (powerup === CookiePowerup.SUPER_SPHERE) {
                this.removePowerupFromCookie(item);
                return;
              }
              let index = powerups.indexOf(powerup);
              let newIndex = Phaser.Math.Wrap(index + 1, 0, powerups.length);
              let newPowerup = powerups[newIndex];
              this.setPowerupOnCookie(item, newPowerup);
            } else {
              this.setPowerupOnCookie(item, powerups[0]);
            }
          } else if (item.itemSuperType === ItemSuperType.GENERATOR) {
            item.toggleInvisibility();
          }
          return;
        }
      }
      this.selection.handleClick(pointer, objects);
    }
    onPointerWheel(pointer, objects, dx, dy) {
      let selectedItems = this.selection.getSelectedItems();
      let items = selectedItems.filter((item) => item.getData("type") === LevelEditorObjectType.ITEM);
      items.forEach((item) => {
        let itemSuperType = item.itemSuperType;
        let delta = -Phaser.Math.Sign(dy);
        if (itemSuperType === ItemSuperType.GENERATOR) {
          let generator = item;
          generator.updateTurnsNum(generator.params.turnsNum + delta);
          return;
        }
        if (itemSuperType === ItemSuperType.APPLE_PLATTER) {
          let applePlatter = item;
          applePlatter.setApplesNum(applePlatter.getApplesNum() + delta);
          return;
        }
        if (itemSuperType === ItemSuperType.COLOR_CAKE) {
          let colorCake = item;
          let piecesNum = colorCake.getLastActivePieceIndex();
          let enabledCookieTypes = LevelConfigValidator.getEnabledCookieTypes(this.levelConfig.generator);
          colorCake.setActivePiecesNum(piecesNum + delta, enabledCookieTypes);
          return;
        }
        let itemTypes = this.getItemTypesToScrollThrough(itemSuperType);
        if (!itemTypes) {
          return;
        }
        let currentIndex = itemTypes.indexOf(item.itemType);
        let newIndex = Phaser.Math.Wrap(currentIndex + delta, 0, itemTypes.length);
        let newItemType = itemTypes[newIndex];
        item.updateItemType(newItemType);
        if (itemSuperType === ItemSuperType.COOKIE) {
          let powerup = item.params.powerup;
          if (powerup) {
            ;
            item.setFrame(CookieUtils.getFrame(item.itemType, powerup));
          }
        }
      });
    }
    getItemTypesToScrollThrough(superType) {
      let itemTypes = ItemTypeUtil.getSubtypes(superType);
      if (superType === ItemSuperType.COOKIE) {
        return itemTypes.filter((cookieType) => this.levelConfig.generator.weights[cookieType] > 0);
      }
      return itemTypes;
    }
    addKeyboardCallbacks() {
      this.onKeyDown("A", this.onKeyDownA, this);
      this.onKeyDown("I", this.toggleItemsPopover, this);
      this.onKeyDown("S", this.onKeyDownS, this);
      this.onKeyDown("F", this.fillSelectedCells, this);
      this.onKeyDown("B", this.fillSelectedFieldCellsWith.bind(this, ItemType.BISCUIT));
      this.onKeyDown("M", this.fillSelectedFieldCellsWith.bind(this, ItemType.MARSHMALLOW_COMMON));
      this.onKeyDown("D", this.fillSelectedFieldCellsWith.bind(this, ItemType.DONUT_BOX));
      this.onKeyDown("C", this.fillSelectedFieldCellsWith.bind(this, ItemType.CHOCOLATE_COMMON));
      this.onKeyDown("G", this.onKeyDownG, this);
      this.onKeyDown("L", this.onKeyDownL, this);
      this.onKeyDown("U", this.unlockSelectedCookies, this);
      this.onKeyDown("T", this.tryToAddTutorial, this);
      this.onKeyDown("DELETE", this.removeSelectedItems, this);
      this.onKeyDown("ENTER", this.testLevel, this);
      this.onKeyDown("PLUS", () => this.editorPanels.changeZoom(1));
      this.onKeyDown("MINUS", () => this.editorPanels.changeZoom(-1));
      this.onKeyDown("ZERO", () => this.editorPanels.resetZoom());
      this.onKeyDown("OPEN_BRACKET", this.changeCanvasMargin.bind(this, -1));
      this.onKeyDown("CLOSED_BRACKET", this.changeCanvasMargin.bind(this, 1));
      this.onKeyDown("BACK_SLASH", this.resetCanvasMargin, this);
    }
    onKeyDownA(event) {
      if (event.ctrlKey) {
        this.selection.selectionType = LevelEditorObjectType.GRID_CELL;
        this.grid.cells.forEach((cell) => cell.select());
      }
    }
    toggleItemsPopover() {
      if (this.itemsPopover.visible) {
        this.itemsPopover.hide();
      } else {
        let pointer = this.input.activePointer;
        this.itemsPopover.show();
        this.itemsPopover.x = pointer.x;
        this.itemsPopover.y = pointer.y;
      }
    }
    onKeyDownS(event) {
      let isShiftDown = event.shiftKey;
      if (isShiftDown) {
        this.saveLevelConfigAs();
      } else {
        this.saveLevelConfig();
      }
    }
    clearField() {
      this.field.cells.forEach((cell) => cell.destroy());
    }
    clearAllItems() {
      this.items.bottomItems.forEach((item) => item.destroy());
      this.items.mainItems.forEach((item) => item.destroy());
      this.items.topItems.forEach((item) => item.destroy());
    }
    clearCookies() {
      this.items.mainItems.filter((item) => item.itemSuperType === ItemSuperType.COOKIE).forEach((item) => item.destroy());
    }
    onKeyDownG() {
      if (this.selection.selectionType === LevelEditorObjectType.GRID_CELL) {
        this.fillSelectedGridCellsWith(ItemType.GENERATOR);
        return;
      }
      let freeCells = this.field.cells.filter((cell) => this.items.mainItems.checkAt(cell.column, cell.row) === false);
      this.fillCellsWithCookies(freeCells);
    }
    fillCellsWithCookies(cells) {
      let newItems = [];
      let generator = this.createCookieTypesGenerator();
      cells.forEach((cell) => {
        let repeat = false;
        let safetyCounter = 1e3;
        do {
          let newItemType = generator.getItem();
          let newItem = this.items.addItem(cell.column, cell.row, newItemType);
          let itemsToCheck = this.items.getMatchableItems();
          let hasMatches = MatchFinder.hasAny(itemsToCheck);
          if (hasMatches) {
            newItem.destroy();
            repeat = true;
          } else {
            newItems.push(newItem);
            repeat = false;
          }
        } while (repeat && --safetyCounter > 0);
      });
      return newItems;
    }
    createCookieTypesGenerator() {
      let weights = this.levelConfig.generator.weights;
      let seed = Date.now().toString();
      return new ItemsGenerator(weights, seed);
    }
    fillSelectedCells() {
      let selectionType = this.selection.selectionType;
      if (selectionType !== LevelEditorObjectType.GRID_CELL && selectionType !== LevelEditorObjectType.FIELD_CELL) {
        return [];
      }
      let selectedItems = this.selection.getSelectedItems();
      if (selectedItems.length === 0) {
        return [];
      }
      let newItems = [];
      if (selectionType === LevelEditorObjectType.GRID_CELL) {
        newItems = selectedItems.map((cell) => this.field.addCell(cell.column, cell.row));
      } else if (selectionType === LevelEditorObjectType.FIELD_CELL) {
        newItems = this.fillCellsWithCookies(selectedItems);
      }
      this.selection.unselectAll();
      return newItems;
    }
    fillSelectedFieldCellsWith(itemType) {
      let selectionType = this.selection.selectionType;
      if (selectionType !== LevelEditorObjectType.FIELD_CELL) {
        return [];
      }
      let newItems = this.selection.getSelectedItems().map((cell) => {
        return this.items.addItem(cell.column, cell.row, itemType);
      });
      this.selection.unselectAll();
      newItems.forEach((item) => item.select());
    }
    fillSelectedGridCellsWith(itemType) {
      let selectionType = this.selection.selectionType;
      if (selectionType !== LevelEditorObjectType.GRID_CELL) {
        return [];
      }
      let allowedItemTypes = [ItemType.GENERATOR];
      if (allowedItemTypes.includes(itemType) === false) {
        return [];
      }
      this.selection.getSelectedItems().forEach((cell) => {
        this.items.addItem(cell.column, cell.row, itemType);
      });
      this.selection.unselectAll();
    }
    removeSelectedItems() {
      this.selection.getSelectedItems().filter((item) => item.getData("type") !== LevelEditorObjectType.GRID_CELL).forEach((item) => {
        let itemType = item.getData("type");
        if (itemType === LevelEditorObjectType.GRID_CELL) {
          return;
        }
        item.destroy();
      });
    }
    changeCanvasMargin(sign) {
      let canvasStyle = this.game.canvas.style;
      let marginStr = canvasStyle.marginLeft.slice(0, -2);
      let margin = parseFloat(marginStr);
      let newMargin = margin + 50 * sign;
      canvasStyle.marginLeft = newMargin + "px";
    }
    resetCanvasMargin() {
      this.scale.updateCenter();
    }
    resize() {
      super.resize();
      this.alignGrid();
      this.alignField();
      this.alignItems();
      this.alignSelection();
      this.alignTutorial();
    }
    alignGrid() {
      let maxWidth = Config.GAME_WIDTH * 0.8;
      this.grid.scale = maxWidth / this.grid.width;
      this.grid.x = (Config.GAME_WIDTH - this.grid.displayWidth) / 2;
      this.grid.y = (Config.GAME_HEIGHT - this.grid.displayHeight) / 2;
    }
    alignField() {
      this.field.scale = this.grid.scale;
      this.field.x = this.grid.x;
      this.field.y = this.grid.y;
    }
    alignItems() {
      this.items.scale = this.grid.scale;
      this.items.x = this.grid.x;
      this.items.y = this.grid.y;
    }
    alignSelection() {
      this.selection.scale = this.grid.scale;
      this.selection.x = this.grid.x;
      this.selection.y = this.grid.y;
    }
    alignTutorial() {
      this.tutorialLayer.scale = this.grid.scale;
      this.tutorialLayer.x = this.grid.x;
      this.tutorialLayer.y = this.grid.y;
    }
    onGuiCreated() {
      let {lockButton, unlockButton, clearButton, generateButton} = this.gui.topBar;
      lockButton.on(ButtonEvent.PRESS, this.lockAllCookies, this);
      unlockButton.on(ButtonEvent.PRESS, this.unlockAllCookies, this);
      clearButton.on(ButtonEvent.PRESS, this.onClearButtonClick, this);
      generateButton.on(ButtonEvent.PRESS, this.onGenerateButtonClick, this);
    }
    onClearButtonClick() {
      if (this.shiftKey.isDown) {
        this.clearField();
        this.clearAllItems();
      } else {
        this.clearCookies();
      }
    }
    onGenerateButtonClick() {
      this.onKeyDownG();
    }
    testLevel() {
      this.levelConfigHelper.updateLevelConfig();
      this.events.emit(LevelEditorEvent.TEST_LEVEL, {
        type: "play",
        levelNumber: this.levelNumber
      });
    }
    removeLevelConfig() {
      let isConfirmed = window.confirm(`Do you want to remove level ${this.levelNumber} config?`);
      if (isConfirmed === false) {
        return;
      }
      this.levelConfigHelper.remove().then(() => {
        var _a;
        let existingLevels = this.game.levelConfigs.getLevelNumbers();
        let nextLevel = existingLevels.find((level) => level > this.levelNumber);
        let newLevelNumber = (_a = nextLevel != null ? nextLevel : existingLevels[0]) != null ? _a : 1;
        this.events.emit(LevelEditorEvent.CHANGE_LEVEL, newLevelNumber);
      });
    }
    removeAndShiftLevelConfig() {
      let isConfirmed = window.confirm(`Do you want to remove level ${this.levelNumber} config and shift all the levels after?`);
      if (isConfirmed === false) {
        return;
      }
      this.levelConfigHelper.removeAndShift().then(() => {
        let levelNumbers = this.game.levelConfigs.getLevelNumbers();
        let newLevelNumber = levelNumbers.includes(this.levelNumber) ? this.levelNumber : last_default(levelNumbers);
        newLevelNumber === this.levelNumber ? this.events.emit(LevelEditorEvent.RESTART) : this.events.emit(LevelEditorEvent.CHANGE_LEVEL, newLevelNumber);
      });
    }
    saveLevelConfigAs() {
      this.levelConfigHelper.saveAs();
    }
    saveLevelConfig() {
      this.levelConfigHelper.save().catch((error) => {
      });
    }
    onShutdown() {
      super.onShutdown();
      this.editorPanels.destroy();
    }
  };

  // src/scenes/levelEditorGui/levelsList/LevelListItem.ts
  var _LevelListItem = class extends Phaser.GameObjects.Container {
    constructor(scene, levelNumber) {
      super(scene);
      this.isActiveLevel = false;
      this.name = "level_" + levelNumber;
      this.levelNumber = levelNumber;
      this.addBack();
      this.addText();
      this.setSize(this.back.displayWidth, this.back.displayHeight);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "editor", "levels_list_active");
      this.back.setOrigin(0, 0);
      this.back.alpha = 0.2;
      this.back.kill();
      this.back.displayWidth = _LevelListItem.WIDTH - _LevelListItem.PADDING;
      this.back.displayHeight = _LevelListItem.HEIGHT;
      this.add(this.back);
    }
    addText() {
      let content = `Level ${this.levelNumber}`;
      this.text = this.scene.add.bitmapText(0, 0, BitmapFont.LEVELS_EDITOR_LIST, content, 22);
      this.text.setOrigin(0, 0.5);
      this.text.x = this.back.left + 25;
      this.text.y = this.back.displayHeight / 2 + 2;
      this.text.originalX = this.text.x;
      this.add(this.text);
    }
    markAsActive() {
      this.isActiveLevel = true;
      this.text.text = `> Level ${this.levelNumber}`;
      this.back.revive();
      this.back.alpha = 0.3;
    }
    markAsHard() {
      this.addSkullIcon();
    }
    addSkullIcon() {
      let skull = this.scene.add.image(0, 0, "editor", "skull_icon");
      skull.x = 166;
      skull.y = this.back.displayHeight / 2 - 3;
      skull.scale = 0.4;
      this.add(skull);
    }
    markAsTutorial() {
      this.addTutorialIcon();
    }
    addTutorialIcon() {
      let tutorial = this.scene.add.image(0, 0, "editor", "tutorial_icon");
      tutorial.x = 194;
      tutorial.y = this.back.displayHeight / 2 - 3;
      this.add(tutorial);
    }
    makeInteractive() {
      this.setInteractive();
      this.input.hitArea.x += this.width / 2;
      this.input.hitArea.y += this.height / 2;
      this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, this.onPointerOver, this);
      this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, this.onPointerOut, this);
    }
    onPointerOver() {
      var _a;
      this.back.revive();
      (_a = this.moveTween) == null ? void 0 : _a.remove();
      this.moveTween = this.scene.tweens.add({
        targets: this.text,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        x: this.text.originalX + 12
      });
    }
    onPointerOut() {
      var _a;
      this.back.kill();
      (_a = this.moveTween) == null ? void 0 : _a.remove();
      this.moveTween = this.scene.tweens.add({
        targets: this.text,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        x: this.text.originalX
      });
    }
  };
  var LevelListItem = _LevelListItem;
  LevelListItem.WIDTH = 250;
  LevelListItem.HEIGHT = 46;
  LevelListItem.PADDING = 2;

  // src/scenes/levelEditorGui/levelsList/LevelListScrollbar.ts
  var LevelListScrollbar = class extends Phaser.GameObjects.Image {
    constructor(scene, minY, maxY) {
      super(scene, 0, 0, "editor", "levels_list_scrollbar");
      this.inactiveAlpha = 0.8;
      this.minY = minY;
      this.maxY = maxY;
      this.deltaY = this.maxY - this.minY;
      this.setAlpha(this.inactiveAlpha);
      this.setInteractive(this.createHitArea(), Phaser.Geom.Rectangle.Contains);
      this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, this.onPointerOver, this);
      this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, this.onPointerOut, this);
      this.input.cursor = "pointer";
      this.scene.input.setDraggable(this);
      this.on(Phaser.Input.Events.DRAG, this.onDrag, this);
    }
    createHitArea() {
      let width = this.displayWidth * 5;
      let height = this.displayHeight * 1.5;
      let x = -(width - this.displayWidth) / 2;
      let y = -(height - this.displayHeight) / 2;
      return new Phaser.Geom.Rectangle(x, y, width, height);
    }
    onDrag(pointer, x, y) {
      this.updatePositionY(y);
    }
    getScrollPercent() {
      return (this.y - this.minY) / this.deltaY;
    }
    setScrollPercent(value) {
      this.updatePositionY(this.calculatePositionY(value));
    }
    calculatePositionY(percent) {
      return this.minY + this.deltaY * Phaser.Math.Clamp(percent, 0, 1);
    }
    updatePositionY(newY) {
      this.y = Phaser.Math.Clamp(newY, this.minY, this.maxY);
    }
    onPointerOver() {
      this.alpha = 1;
    }
    onPointerOut() {
      this.alpha = this.inactiveAlpha;
    }
  };

  // src/scenes/levelEditorGui/levelsList/LevelsList.ts
  var LevelsListEvent;
  (function(LevelsListEvent2) {
    LevelsListEvent2["LEVEL_SELECT"] = "LevelsList_LEVEL_SELECT";
  })(LevelsListEvent || (LevelsListEvent = {}));
  var LevelsList = class extends Phaser.GameObjects.Container {
    constructor(scene, currentLevel, levelNumbers) {
      super(scene);
      this.name = "levels_list";
      this.addBack();
      this.addLevels(currentLevel, levelNumbers);
      this.addScrollbar();
      this.setSize(this.back.displayWidth, this.back.displayHeight);
      this.disableInvisibleItems();
      this.scrollToLevel(currentLevel);
      this.scene.input.on(Phaser.Input.Events.POINTER_WHEEL, this.onWheel, this);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "editor", "levels_list_back");
      this.back.setOrigin(0, 0);
      this.add(this.back);
    }
    addLevels(currentLevel, levelNumbers) {
      this.levels = this.createLevelItems(levelNumbers, currentLevel);
      let containerHeight = this.levels[0].height * this.levels.length;
      let maxY = 4;
      let minY = maxY + this.back.height - containerHeight;
      this.levelsContainer = this.scene.add.container(0, maxY, this.levels);
      this.levelsContainer.setSize(this.levels[0].displayWidth, containerHeight);
      this.levelsContainer.minY = minY;
      this.levelsContainer.maxY = maxY;
      this.levelsContainer.deltaY = maxY - minY;
      this.levelsContainer.originalY = this.levelsContainer.y;
      this.add(this.levelsContainer);
    }
    createLevelItems(levelNumbers, currentLevel) {
      return levelNumbers.map((levelNumber, index) => {
        let levelConfig = this.scene.game.levelConfigs.get(levelNumber);
        let item = new LevelListItem(this.scene, levelNumber);
        item.x = LevelListItem.PADDING;
        item.y = index * item.height;
        item.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onLevelItemClick.bind(this, item));
        if (levelConfig.hard) {
          item.markAsHard();
        }
        if (levelConfig.tutorial.autoGenerated === false) {
          item.markAsTutorial();
        }
        if (levelNumber === currentLevel) {
          item.markAsActive();
        } else {
          item.makeInteractive();
        }
        return item;
      });
    }
    onLevelItemClick(item) {
      this.emit(LevelsListEvent.LEVEL_SELECT, item.levelNumber);
    }
    addScrollbar() {
      let padding = 30;
      let minY = this.back.top + padding;
      let maxY = this.back.bottom - padding;
      this.scrollbar = new LevelListScrollbar(this.scene, minY, maxY);
      this.scrollbar.x = this.back.right - 12;
      this.scrollbar.y = minY;
      this.scrollbar.on(Phaser.Input.Events.DRAG_START, this.onScrollbarDragStart, this);
      this.scrollbar.on(Phaser.Input.Events.DRAG_END, this.onScrollbarDragEnd, this);
      this.add(this.scrollbar);
    }
    onScrollbarDragStart() {
      this.levels.forEach((item) => item.disableInteractive());
    }
    onScrollbarDragEnd(pointer, x, y) {
      let containerY = Phaser.Math.Snap.To(this.levelsContainer.y, LevelListItem.HEIGHT, this.levelsContainer.maxY);
      let scrollPercent = (this.levelsContainer.maxY - containerY) / this.levelsContainer.deltaY;
      let scrollbarY = this.scrollbar.calculatePositionY(scrollPercent);
      this.scrollTo(scrollbarY);
    }
    onWheel(pointer, objects, dx, dy) {
      if (this.visible === false) {
        return;
      }
      let multiplier = pointer.event.shiftKey ? 5 : 1;
      let scrollAmount = -Phaser.Math.Sign(dy) * LevelListItem.HEIGHT * multiplier;
      let containerY = Phaser.Math.Clamp(this.levelsContainer.y + scrollAmount, this.levelsContainer.minY, this.levelsContainer.maxY);
      let scrollPercent = (this.levelsContainer.maxY - containerY) / this.levelsContainer.deltaY;
      let scrollbarY = this.scrollbar.calculatePositionY(scrollPercent);
      this.scrollTo(scrollbarY);
    }
    scrollToBottom() {
      this.scrollTo(this.scrollbar.maxY);
    }
    scrollToTop() {
      this.scrollTo(this.scrollbar.minY);
    }
    scrollToLevel(level) {
      let item = this.levels.find((item2) => item2.levelNumber === level);
      if (!item) {
        return;
      }
      let containerY = -item.y + this.displayHeight / 2;
      let snapped = Phaser.Math.Snap.To(containerY, LevelListItem.HEIGHT, this.levelsContainer.maxY);
      let scrollPercent = (this.levelsContainer.maxY - snapped) / this.levelsContainer.deltaY;
      let scrollbarY = this.scrollbar.calculatePositionY(scrollPercent);
      this.scrollTo(scrollbarY);
    }
    scrollTo(scrollbarY) {
      this.scrollbar.updatePositionY(scrollbarY);
      this.updateLevelsPosition();
      this.disableInvisibleItems();
    }
    updateLevelsPosition() {
      let bottom = this.levelsContainer.originalY;
      let top = bottom - this.levelsContainer.height + this.displayHeight;
      let dy = bottom - top;
      this.levelsContainer.y = this.levelsContainer.originalY - dy * this.scrollbar.getScrollPercent();
    }
    disableInvisibleItems() {
      let topVisible = this.levelsContainer.originalY - this.levelsContainer.y;
      let bottomVisible = topVisible + this.displayHeight;
      this.levels.forEach((item) => {
        if (item.isActiveLevel) {
          return;
        }
        let itemCenterY = item.y + item.displayHeight / 2;
        if (itemCenterY >= topVisible && itemCenterY <= bottomVisible) {
          item.setInteractive();
        } else {
          item.disableInteractive();
        }
      });
    }
    preUpdate(time, delta) {
      this.updateLevelsPosition();
    }
    preDestroy() {
      this.scene.input.off(Phaser.Input.Events.POINTER_WHEEL, this.onWheel, this);
      super.preDestroy();
    }
  };

  // src/scenes/levelEditor/LevelsEditorRoot.ts
  var LevelEditorRoot = class extends BaseScene {
    init(data) {
      super.init(data);
      this.levelNumber = data ? data.levelNumber : 1;
      this.levelConfig = this.getLevelConfig(this.levelNumber);
      console.group(`Level ${this.levelNumber} - Editor`);
      this.editor = null;
      this.editorGui = null;
    }
    getLevelConfig(levelNumber) {
      let isConfigExist = this.game.levelConfigs.check(levelNumber);
      if (isConfigExist) {
        return this.game.levelConfigs.get(levelNumber);
      }
      return this.game.levelConfigs.create(levelNumber);
    }
    preload() {
      let loader = this.game.globalScene.delayedLoader;
      let areAssetsReady = loader.areGameplayAssetsReady;
      if (areAssetsReady === false) {
        this.waitForGameplayAssets(loader);
      }
    }
    waitForGameplayAssets(loader) {
      this.load.rexAwait(Phaser.Math.RND.uuid(), {
        callback: (onSuccess) => {
          loader.once(DelayedLoaderEvent.GAMEPLAY_ASSETS_READY, () => {
            onSuccess();
          });
        }
      });
    }
    create() {
      this.addBackground();
      this.addKeyboardCallbacks();
      this.launchEditorScene();
    }
    addBackground() {
      this.background = this.add.image(0, 0, "editor", "Background");
      this.background.alpha = 0.5;
    }
    addKeyboardCallbacks() {
      this.onceKeyDown("R", this.restart, this);
      this.onceKeyDown("ESC", this.gotoLevelsMapDev, this);
    }
    restart() {
      this.changeScene(SceneKey.LEVEL_EDITOR_ROOT, {levelNumber: this.levelNumber});
    }
    gotoPrevLevel() {
      let prevExistingLevel = this.game.levelConfigs.getPrevExistingLevel(this.levelNumber);
      if (prevExistingLevel) {
        this.gotoLevel(prevExistingLevel);
      }
    }
    gotoNextLevel() {
      let nextExistingLevel = this.game.levelConfigs.getNextExistingLevel(this.levelNumber);
      if (nextExistingLevel) {
        this.gotoLevel(nextExistingLevel);
      }
    }
    gotoLevel(levelNumber) {
      if (levelNumber === this.levelNumber) {
        return;
      }
      let isLevelExist = this.game.levelConfigs.check(levelNumber);
      if (isLevelExist === false) {
        console.warn(`Level ${levelNumber} doesn't exist!`);
        return;
      }
      this.scene.start(SceneKey.LEVEL_EDITOR_ROOT, {levelNumber});
    }
    gotoLevelsMapDev() {
      this.scene.start(SceneKey.LEVEL_MAP_EDITOR);
    }
    launchEditorScene() {
      this.editor = this.launchScene(SceneKey.LEVEL_EDITOR, this.levelConfig);
      this.editor.events.on(Phaser.Scenes.Events.CREATE, this.launchEditorGuiScene, this);
      this.editor.events.on(LevelEditorEvent.BACKGROUND_CHANGE, this.onBackgroundChange, this);
      this.editor.events.on(LevelEditorEvent.CONFIG_REMOVE, this.gotoLevelsMapDev, this);
      this.editor.events.once(LevelEditorEvent.TEST_LEVEL, this.testLevelConfig, this);
      this.editor.events.once(LevelEditorEvent.CHANGE_LEVEL, this.gotoLevel, this);
      this.editor.events.once(LevelEditorEvent.RESTART, this.restart, this);
    }
    launchEditorGuiScene() {
      this.editorGui = this.launchScene(SceneKey.LEVEL_EDITOR_GUI, {
        levelConfig: this.levelConfig,
        editor: this.editor
      });
      this.editorGui.events.on(Phaser.Scenes.Events.CREATE, this.onGuiCreated, this);
    }
    onGuiCreated() {
      this.editor.gui = this.editorGui;
      this.editor.onGuiCreated();
      this.editorGui.bottomBar.swapButton.on(ButtonEvent.RELEASE, this.onSwapButtonClick, this);
      this.editorGui.bottomBar.removeButton.on(ButtonEvent.RELEASE, this.onRemoveButtonClick, this);
      this.editorGui.bottomBar.createButton.on(ButtonEvent.RELEASE, this.onCreateButtonClick, this);
      this.editorGui.bottomBar.saveButton.on(ButtonEvent.RELEASE, this.onSaveButtonClick, this);
      this.editorGui.bottomBar.playButton.on(ButtonEvent.RELEASE, this.onPlayButtonClick, this);
      this.editorGui.bottomBar.exitButton.on(ButtonEvent.RELEASE, this.onExitButtonClick, this);
      this.editorGui.bottomBar.prevLevelButton.on(ButtonEvent.RELEASE, this.gotoPrevLevel, this);
      this.editorGui.bottomBar.nextLevelButton.on(ButtonEvent.RELEASE, this.gotoNextLevel, this);
      this.editorGui.levelsList.once(LevelsListEvent.LEVEL_SELECT, this.gotoLevel, this);
      this.resize();
    }
    onSwapButtonClick() {
      let result = prompt(`Enter level number (current level ${this.levelNumber} will be swapped with it)`);
      if (result === null) {
        return;
      }
      let levelNumber = parseInt(result);
      if (isNaN(levelNumber)) {
        console.warn("Please enter valid level number!");
        return;
      }
      let isLevelExist = this.game.levelConfigs.check(levelNumber);
      if (!isLevelExist) {
        console.warn(`Level ${levelNumber} doesn't exists, please enter another number!`);
        return;
      }
      this.editor.levelConfigHelper.swapWith(levelNumber).then(() => this.restart());
    }
    onRemoveButtonClick(button, pointer) {
      if (pointer.event.shiftKey) {
        this.editor.removeAndShiftLevelConfig();
      } else {
        this.editor.removeLevelConfig();
      }
    }
    onCreateButtonClick() {
      let firstMissingLevel = this.game.levelConfigs.getGaps()[0];
      let suggestedLevelNumber = firstMissingLevel != null ? firstMissingLevel : this.game.levelConfigs.getLastLevelNumber() + 1;
      let levelNumberStr = prompt("Enter new level number", suggestedLevelNumber.toString());
      if (levelNumberStr === null) {
        return;
      }
      let newLevelNumber = parseInt(levelNumberStr);
      if (isNaN(newLevelNumber)) {
        console.warn("Please enter valid level number!", levelNumberStr);
        return;
      }
      let existingLevelNumbers = this.game.levelConfigs.getLevelNumbers();
      let isLevelExist = existingLevelNumbers.includes(newLevelNumber);
      if (isLevelExist) {
        console.warn(`Level ${newLevelNumber} config exists already, please enter another number!`);
        return;
      }
      this.scene.start(SceneKey.LEVEL_EDITOR_ROOT, {levelNumber: newLevelNumber});
    }
    onSaveButtonClick(button, pointer) {
      if (pointer.event.shiftKey) {
        this.editor.saveLevelConfigAs();
      } else {
        this.editor.saveLevelConfig();
      }
    }
    onPlayButtonClick() {
      this.editor.testLevel();
    }
    onExitButtonClick() {
      this.gotoLevelsMapDev();
    }
    onBackgroundChange(backgroundFrame) {
      this.background.setFrame(backgroundFrame);
      this.background.setOrigin(0.5, 1);
    }
    testLevelConfig(data) {
      this.scene.start(SceneKey.GAMEPLAY_ROOT, data);
    }
    launchScene(key, data) {
      return this.scene.launch(key, data).get(key);
    }
    resize() {
      super.resize();
      this.resizeBackground();
    }
    resizeBackground() {
      this.background.envelop(Config.GAME_WIDTH + 2, Config.GAME_HEIGHT + 2);
      this.background.x = Config.HALF_GAME_WIDTH;
      this.background.y = Config.HALF_GAME_HEIGHT;
    }
    onShutdown() {
      super.onShutdown();
      console.groupEnd();
      if (this.editor) {
        this.scene.stop(this.editor.scene.key);
        this.editor.events.off(Phaser.Scenes.Events.CREATE, this.launchEditorGuiScene, this);
        this.editor.events.off(LevelEditorEvent.BACKGROUND_CHANGE, this.onBackgroundChange, this);
        this.editor.events.off(LevelEditorEvent.CONFIG_REMOVE, this.gotoLevelsMapDev, this);
        this.editor.events.off(LevelEditorEvent.TEST_LEVEL, this.testLevelConfig, this);
        this.editor.events.off(LevelEditorEvent.CHANGE_LEVEL, this.gotoLevel, this);
        this.editor.events.off(LevelEditorEvent.RESTART, this.restart, this);
      }
      if (this.editorGui) {
        this.scene.stop(this.editorGui.scene.key);
        this.editorGui.events.off(Phaser.Scenes.Events.CREATE, this.onGuiCreated, this);
      }
    }
  };

  // src/scenes/levelEditorGui/panels/LevelEditorBarButton.ts
  var LevelEditorBarButton = class extends SimpleButton {
    constructor(scene, texture, frame, parent) {
      super(scene, texture, frame, parent);
      this.originalY = 0;
      this.deltaY = 5;
      this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, this.onPointerOver, this);
      this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, this.onPointerOut, this);
    }
    onPointerOver() {
      var _a;
      (_a = this.moveTween) == null ? void 0 : _a.remove();
      this.moveTween = this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        y: this.originalY - this.deltaY
      });
    }
    onPointerOut() {
      var _a;
      (_a = this.moveTween) == null ? void 0 : _a.remove();
      this.moveTween = this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        y: this.originalY
      });
    }
    disableInput() {
      super.disableInput();
      this.alpha = 0.5;
    }
    enableInput() {
      super.enableInput();
      this.alpha = 1;
    }
  };

  // src/scenes/levelEditorGui/panels/LevelEditorBottomBar.ts
  var LevelEditorBottomBar = class extends Phaser.GameObjects.Container {
    constructor(scene, currentLevelNumber) {
      super(scene);
      this.separatorAlpha = 0.4;
      this.name = "main_panel";
      this.addBack();
      this.addLevelButton(currentLevelNumber);
      this.addPrevLevelButton();
      this.addNextLevelButton();
      this.addSeparator_1();
      this.addButtonsGroup();
      this.addSeparator_2();
      this.addExitButton();
      this.align();
      this.setSize(this.back.width, this.back.height);
      this.addInputOverlay();
    }
    addBack() {
      this.back = this.scene.add.rectangle(0, 0, Config.SOURCE_GAME_WIDTH, 60, 0, 0.5);
      this.back.setOrigin(0, 0.5);
      this.add(this.back);
    }
    addLevelButton(currentLevelNumber) {
      let content = "Level " + currentLevelNumber.toString();
      this.levelButton = new ComplexButton(this.scene, "editor", "levels_list_button_back");
      this.levelButton.back.alpha = 0.66;
      this.levelButton.addBitmapText(content, BitmapFont.LEVELS_EDITOR_LIST, 25, 0, 4);
      this.add(this.levelButton);
    }
    addPrevLevelButton() {
      this.prevLevelButton = this.scene.add.button("editor", "button_prev_level", this);
      this.prevLevelButton.alpha = 0.8;
      this.prevLevelButton.areTweensEnabled = false;
      this.addPointerListeners(this.prevLevelButton);
    }
    addNextLevelButton() {
      this.nextLevelButton = this.scene.add.button("editor", "button_next_level", this);
      this.nextLevelButton.alpha = this.prevLevelButton.alpha;
      this.nextLevelButton.areTweensEnabled = false;
      this.addPointerListeners(this.nextLevelButton);
    }
    addPointerListeners(button) {
      button.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, this.onLevelButtonPointerOver.bind(this, button));
      button.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, this.onLevelButtonPointerOut.bind(this, button));
    }
    onLevelButtonPointerOver(button) {
      button.alpha = 1;
      button.scale = 1.15;
    }
    onLevelButtonPointerOut(button) {
      button.alpha = 0.8;
      button.scale = 1;
    }
    addSeparator_1() {
      this.separator_1 = this.scene.add.image(0, 0, "editor", "panel_separator");
      this.separator_1.alpha = this.separatorAlpha;
      this.add(this.separator_1);
    }
    addButtonsGroup() {
      this.swapButton = new LevelEditorBarButton(this.scene, "editor", "swap_button", this);
      this.removeButton = new LevelEditorBarButton(this.scene, "editor", "remove_icon", this);
      this.createButton = new LevelEditorBarButton(this.scene, "editor", "create_icon_2", this);
      this.saveButton = new LevelEditorBarButton(this.scene, "editor", "save_icon", this);
      this.playButton = new LevelEditorBarButton(this.scene, "editor", "play_icon", this);
    }
    addSeparator_2() {
      this.separator_2 = this.scene.add.image(0, 0, "editor", "panel_separator");
      this.separator_2.alpha = this.separatorAlpha;
      this.add(this.separator_2);
    }
    addExitButton() {
      this.exitButton = new LevelEditorBarButton(this.scene, "editor", "exit_icon", this);
    }
    align() {
      let buttonsGap = 61;
      let separatorGap = 40;
      this.exitButton.x = this.back.right - separatorGap;
      this.separator_2.x = this.exitButton.x - separatorGap;
      this.playButton.x = this.exitButton.x - separatorGap * 2;
      this.saveButton.x = this.playButton.x - buttonsGap;
      this.createButton.x = this.saveButton.x - buttonsGap;
      this.removeButton.x = this.createButton.x - buttonsGap;
      this.swapButton.x = this.removeButton.x - buttonsGap;
      this.separator_1.x = this.swapButton.x - separatorGap;
      this.alignLevelButton();
    }
    alignLevelButton() {
      let left = 0;
      let right = this.separator_1.x;
      let width = right - left;
      this.levelButton.x = left + width / 2;
      let margin = 114;
      this.prevLevelButton.x = this.levelButton.x - margin;
      this.prevLevelButton.originalX = this.prevLevelButton.x;
      this.nextLevelButton.x = this.levelButton.x + margin;
      this.nextLevelButton.originalX = this.nextLevelButton.x;
    }
    addInputOverlay() {
      this.inputOverlay = this.scene.add.rectangle(0, 0, this.width, this.height, 16777215);
      this.inputOverlay.setOrigin(0.5, 0.5);
      this.inputOverlay.x = this.width / 2;
      this.inputOverlay.setInteractive();
      this.inputOverlay.alpha = 0.2;
      this.inputOverlay.kill();
      this.add(this.inputOverlay);
    }
    enableInput() {
      this.inputOverlay.kill();
    }
    disableInput() {
      this.inputOverlay.revive();
    }
  };

  // src/scenes/levelEditorGui/panels/LevelEditorBar.ts
  var LevelEditorBar = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.separatorAlpha = 0.4;
      this.name = "editor_bar";
      this.addBack();
      this.addContent();
      this.setSize(this.back.width, this.back.height);
      this.addInputOverlay();
    }
    addBack() {
      this.back = this.scene.add.rectangle(0, 0, Config.SOURCE_GAME_WIDTH, 60, 0, 0.5);
      this.back.setOrigin(0, 0.5);
      this.add(this.back);
    }
    addContent() {
    }
    addSeparator(x) {
      let separator = this.scene.add.image(0, 0, "editor", "panel_separator");
      separator.alpha = this.separatorAlpha;
      this.add(separator);
      if (typeof x !== "undefined") {
        separator.x = x;
      }
      return separator;
    }
    addInputOverlay() {
      this.inputOverlay = this.scene.add.rectangle(0, 0, this.width, this.height, 16777215);
      this.inputOverlay.setOrigin(0.5, 0.5);
      this.inputOverlay.x = this.width / 2;
      this.inputOverlay.setInteractive();
      this.inputOverlay.alpha = 0.2;
      this.inputOverlay.kill();
      this.add(this.inputOverlay);
    }
    enableInput() {
      this.inputOverlay.kill();
    }
    disableInput() {
      this.inputOverlay.revive();
    }
  };

  // src/scenes/levelEditorGui/panels/LevelEditorTopBar.ts
  var LevelEditorTopBar = class extends LevelEditorBar {
    constructor(scene) {
      super(scene);
      this.name = "top_bar";
    }
    addContent() {
      this.separator_2 = this.addSeparator();
      this.addLockButton();
      this.addUnlockButton();
      this.separator_1 = this.addSeparator();
      this.addClearButton();
      this.addGenerateButton();
      this.align();
    }
    addLockButton() {
      this.lockButton = new LevelEditorBarButton(this.scene, "editor", "lock_button", this);
      this.lockButton.deltaY = -5;
    }
    addUnlockButton() {
      this.unlockButton = new LevelEditorBarButton(this.scene, "editor", "unlock_button", this);
      this.unlockButton.deltaY = -5;
    }
    addClearButton() {
      this.clearButton = new LevelEditorBarButton(this.scene, "editor", "clear_button", this);
      this.clearButton.deltaY = -5;
    }
    addGenerateButton() {
      this.generateButton = new LevelEditorBarButton(this.scene, "editor", "generate_button", this);
      this.generateButton.deltaY = -5;
    }
    align() {
      let buttonsGap = 61;
      let separatorGap = 40;
      this.generateButton.x = this.back.right - separatorGap;
      this.clearButton.x = this.generateButton.x - buttonsGap;
      this.separator_1.x = this.clearButton.x - separatorGap;
      this.unlockButton.x = this.separator_1.x - separatorGap;
      this.lockButton.x = this.unlockButton.x - buttonsGap;
      this.separator_2.x = this.lockButton.x - separatorGap;
    }
  };

  // src/scenes/levelEditorGui/LevelEditorGui.ts
  var LevelEditorGui = class extends BaseScene {
    init(data) {
      super.init(data);
      this.editor = data.editor;
      this.levelConfig = data.levelConfig;
    }
    create() {
      this.addTopBar();
      this.addBottomBar();
      this.addLevelsList();
      this.addLevelsListMask();
      this.resize();
      this.addKeyboardCallbacks();
    }
    addTopBar() {
      this.topBar = new LevelEditorTopBar(this);
      this.pin(this.topBar, 0, 0, 0, this.topBar.height / 2);
      this.size(this.topBar);
      this.add.existing(this.topBar);
    }
    addBottomBar() {
      let currentLevelNumber = this.levelConfig.levelNumber;
      this.bottomBar = new LevelEditorBottomBar(this, currentLevelNumber);
      this.bottomBar.levelButton.on(ButtonEvent.PRESS, this.onLevelButtonPress, this);
      this.pin(this.bottomBar, 0, 1, 0, -this.bottomBar.height / 2);
      this.size(this.bottomBar);
      this.add.existing(this.bottomBar);
    }
    onLevelButtonPress() {
      if (this.levelsList.visible) {
        this.hideLevelsList();
      } else {
        this.showLevelsList();
      }
    }
    showLevelsList() {
      this.input.on(Phaser.Input.Events.POINTER_DOWN, this.hideLevelsListByClick, this);
      this.editor.input.enabled = false;
      this.levelsList.revive();
      this.levelsList.alpha = 0;
      this.tweens.killTweensOf(this.levelsList);
      this.tweens.add({
        targets: this.levelsList,
        duration: 100,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 1
      });
    }
    hideLevelsListByClick(pointer, object) {
      if (object.length > 0) {
        return;
      }
      this.hideLevelsList();
    }
    hideLevelsList() {
      this.input.off(Phaser.Input.Events.POINTER_DOWN, this.hideLevelsListByClick, this);
      this.editor.input.enabled = true;
      this.levelsList.kill();
    }
    addLevelsList() {
      let currentLevelNumber = this.levelConfig.levelNumber;
      let levelNumbers = this.game.levelConfigs.getLevelNumbers();
      this.levelsList = new LevelsList(this, currentLevelNumber, levelNumbers);
      this.levelsList.kill();
      this.size(this.levelsList);
      this.add.existing(this.levelsList);
    }
    addLevelsListMask() {
      this.levelsListMask = this.make.graphics();
      this.levelsList.mask = this.levelsListMask.createGeometryMask();
    }
    resize() {
      super.resize();
      this.alignLevelsList();
      this.alignLevelsListMask();
    }
    alignLevelsList() {
      let levelButton = this.bottomBar.levelButton;
      let levelButtonPosition = levelButton.getWorldPosition();
      this.levelsList.x = levelButtonPosition.x - levelButton.displayWidth / 2;
      this.levelsList.y = levelButtonPosition.y - levelButton.displayHeight / 2 - this.levelsList.displayHeight - 12;
    }
    alignLevelsListMask() {
      this.levelsListMask.clear();
      this.levelsListMask.fillRect(0, 0, this.levelsList.displayWidth, this.levelsList.displayHeight);
      this.levelsListMask.x = this.levelsList.x;
      this.levelsListMask.y = this.levelsList.y;
    }
    addKeyboardCallbacks() {
      this.onKeyDown("HOME", this.scrollToFirstLevel, this);
      this.onKeyDown("END", this.scrollToLastLevel, this);
    }
    scrollToFirstLevel() {
      let firstLevel = this.game.levelConfigs.getLevelNumbers()[0];
      if (firstLevel) {
        this.levelsList.scrollToTop();
      }
    }
    scrollToLastLevel() {
      let lastLevel = last_default(this.game.levelConfigs.getLevelNumbers());
      if (lastLevel) {
        this.levelsList.scrollToBottom();
      }
    }
    onShutdown() {
      super.onShutdown();
    }
  };

  // src/scenes/levelMapEditor/LevelMapEditorLevelIcon.ts
  var LevelMapEditorLevelIcon = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this._levelNumber = 0;
      this.name = "level_icon";
      this.addBack();
      this.addLevelNumberText();
      this.setSize(this.back.width, this.back.height);
      this.setInteractive();
    }
    get levelNumber() {
      return this._levelNumber;
    }
    set levelNumber(value) {
      this._levelNumber = value;
      this.levelNumberText.text = this._levelNumber.toString();
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "level_map", "level_icons/level_icon_classic");
      this.add(this.back);
    }
    addLevelNumberText() {
      this.levelNumberText = this.scene.add.bitmapText(0, 0, BitmapFont.LEVEL_ICONS_CLASSIC, "0", 38);
      this.levelNumberText.setOrigin(0.5, 0.5);
      this.levelNumberText.x = -4;
      this.levelNumberText.y = -16;
      this.add(this.levelNumberText);
    }
  };

  // src/FileUtil.ts
  var FileUtil = class {
    static saveLocally(filePath, content) {
      let isBrowserSyncAvailable = typeof window["___browserSync___"] !== "undefined";
      if (isBrowserSyncAvailable === false) {
        return Promise.resolve(false);
      }
      let url = `${location.protocol}//${location.host}/files`;
      return this.doSave(url, filePath, content);
    }
    static saveRemotely(filePath, content) {
      let url = Config.SERVER_URL + "upload.php";
      return this.doSave(url, filePath, content);
    }
    static doSave(url, filepath, content) {
      return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.open("POST", url, true);
        xhr.onload = function() {
          resolve(xhr);
        };
        xhr.onerror = function() {
          reject(xhr);
        };
        xhr.send(this.createRequestBody(filepath, content));
      });
    }
    static createRequestBody(filepath, content) {
      let data = {
        filename: filepath,
        content: JSON.stringify(content)
      };
      return this.convertObjectToURLSearchParams(data);
    }
    static convertObjectToURLSearchParams(obj) {
      return new URLSearchParams(obj);
    }
  };

  // src/robowhale/phaser3/camera/KineticScroll.ts
  var KineticScroll = class {
    constructor(scene, settings) {
      this.thresholdOfTapTime = 100;
      this.thresholdOfTapDistance = 10;
      this.moveTimestamp = 0;
      this.scene = scene;
      let defaultSettings = {
        camera: this.scene.cameras.main,
        kineticMovement: true,
        timeConstantScroll: 325,
        horizontalScroll: true,
        verticalScroll: true,
        horizontalWheel: false,
        verticalWheel: false,
        wheelScrollAmount: 100,
        wheelDeceleration: 0.95,
        onUpdate: null,
        scrollMultiplier: 1
      };
      this.settings = __spreadValues(__spreadValues({}, defaultSettings), settings);
      this.tempCameraBounds = new Phaser.Geom.Rectangle();
    }
    addPointerListeners() {
      this.scene.input.on("pointerdown", this.onPointerDown, this);
      this.scene.input.on("pointerup", this.endMove, this);
      this.scene.input.on("pointermove", this.move, this);
      if (this.settings.verticalWheel || this.settings.horizontalWheel) {
        this.scene.input.on(Phaser.Input.Events.POINTER_WHEEL, this.onPointerWheel, this);
      }
    }
    onPointerDown(pointer, objects) {
      if (objects.length > 0) {
        return;
      }
      this.beginMove(pointer);
    }
    onPointerWheel(pointer, objects, dx, dy) {
      if (this.settings.verticalWheel) {
        this.velocityWheelY = -Phaser.Math.Sign(dy) * this.settings.wheelScrollAmount;
      }
    }
    removePointerListeners() {
      this.scene.input.off("pointerdown", this.onPointerDown, this);
      this.scene.input.off("pointerup", this.endMove, this);
      this.scene.input.off("pointermove", this.move, this);
      this.scene.input.off(Phaser.Input.Events.POINTER_WHEEL, this.onPointerWheel, this);
    }
    beginMove(pointer) {
      this.pointerId = pointer.id;
      this.startX = this.scene.input.x;
      this.startY = this.scene.input.y;
      this.screenX = pointer.screenX;
      this.screenY = pointer.screenY;
      this.pressedDown = true;
      this.timestamp = this.getNow();
      this.beginTime = this.timestamp;
      this.velocityY = this.amplitudeY = this.velocityX = this.amplitudeX = 0;
    }
    canCameraMoveY() {
      let camera = this.settings.camera;
      camera.getBounds(this.tempCameraBounds);
      return camera.scrollY > 0 && camera.scrollY + camera.height < this.tempCameraBounds.height;
    }
    canCameraMoveX() {
      let camera = this.settings.camera;
      camera.getBounds(this.tempCameraBounds);
      return camera.scrollX > 0 && camera.scrollX + camera.width < this.tempCameraBounds.right;
    }
    move(pointer) {
      let x = pointer.x;
      let y = pointer.y;
      if (!this.pressedDown) {
        return;
      }
      if (this.pointerId !== pointer.id) {
        return;
      }
      this.now = this.getNow();
      let elapsed = this.now - this.timestamp;
      this.timestamp = this.now;
      let deltaX = 0;
      let deltaY = 0;
      if (this.isTap(pointer)) {
        return;
      }
      let cam = this.settings.camera;
      if (this.settings.horizontalScroll) {
        deltaX = x - this.startX;
        if (deltaX !== 0) {
          this.dragging = true;
        }
        this.startX = x;
        this.velocityX = 0.8 * (1e3 * deltaX / (1 + elapsed)) + 0.2 * this.velocityX;
        cam.setScroll(cam.scrollX - deltaX, cam.scrollY);
      }
      if (this.settings.verticalScroll) {
        deltaY = (y - this.startY) * this.settings.scrollMultiplier;
        if (deltaY !== 0) {
          this.dragging = true;
        }
        this.startY = y;
        this.velocityY = 0.8 * (1e3 * deltaY / (1 + elapsed)) + 0.2 * this.velocityY;
        cam.setScroll(cam.scrollX, cam.scrollY - deltaY);
      }
      this.callCustomUpdate(deltaX, deltaY);
      this.moveTimestamp = this.getNow();
    }
    callCustomUpdate(deltaX, deltaY) {
      if (typeof this.settings.onUpdate !== "function") {
        return;
      }
      let updateX = this.canCameraMoveX() ? deltaX : 0;
      let updateY = this.canCameraMoveY() ? deltaY : 0;
      this.settings.onUpdate(updateX, updateY);
    }
    isTap(pointer) {
      return this.now - this.beginTime < this.thresholdOfTapTime && Math.abs(pointer.screenY - this.screenY) < this.thresholdOfTapDistance && Math.abs(pointer.screenX - this.screenX) < this.thresholdOfTapDistance;
    }
    endMove() {
      this.pointerId = null;
      this.pressedDown = false;
      this.autoScrollX = false;
      this.autoScrollY = false;
      if (!this.settings.kineticMovement) {
        return;
      }
      this.now = this.getNow();
      let cam = this.settings.camera;
      if (this.withinGame()) {
        if (this.velocityX > 10 || this.velocityX < -10) {
          this.amplitudeX = 0.8 * this.velocityX;
          this.targetX = Math.round(cam.scrollX - this.amplitudeX);
          this.autoScrollX = true;
        }
        if (this.velocityY > 10 || this.velocityY < -10) {
          this.amplitudeY = 0.8 * this.velocityY;
          this.targetY = Math.round(cam.scrollY - this.amplitudeY);
          this.autoScrollY = true;
        }
      }
      if (!this.withinGame()) {
        this.velocityWheelXAbs = Math.abs(this.velocityWheelX);
        this.velocityWheelYAbs = Math.abs(this.velocityWheelY);
        if (this.settings.horizontalScroll && (this.velocityWheelXAbs < 0.1 || !this.withinGame())) {
          this.autoScrollX = true;
        }
        if (this.settings.verticalScroll && (this.velocityWheelYAbs < 0.1 || !this.withinGame())) {
          this.autoScrollY = true;
        }
      }
    }
    update() {
      let timeSinceMove = this.getNow() - this.moveTimestamp;
      if (timeSinceMove > 20) {
        this.velocityX = 0;
        this.velocityY = 0;
      }
      this.elapsed = this.getNow() - this.timestamp;
      this.velocityWheelXAbs = Math.abs(this.velocityWheelX);
      this.velocityWheelYAbs = Math.abs(this.velocityWheelY);
      let delta = 0;
      let cam = this.settings.camera;
      if (this.autoScrollX && this.amplitudeX !== 0) {
        delta = -this.amplitudeX * Math.exp(-this.elapsed / this.settings.timeConstantScroll);
        if (this.canCameraMoveX() && (delta > 0.5 || delta < -0.5)) {
          cam.setScroll(this.targetX - delta, cam.scrollY);
        } else {
          this.autoScrollX = false;
          cam.setScroll(this.targetX, cam.scrollY);
        }
      }
      if (this.autoScrollY && this.amplitudeY !== 0) {
        delta = -this.amplitudeY * Math.exp(-this.elapsed / this.settings.timeConstantScroll);
        if (this.canCameraMoveY() && (delta > 0.5 || delta < -0.5)) {
          cam.setScroll(cam.scrollX, this.targetY - delta);
        } else {
          this.autoScrollY = false;
          cam.setScroll(cam.scrollX, this.targetY);
        }
      }
      if (!this.autoScrollX && !this.autoScrollY) {
        this.dragging = false;
      }
      if (this.settings.horizontalWheel && this.velocityWheelXAbs > 0.1) {
        this.dragging = true;
        this.amplitudeX = 0;
        this.autoScrollX = false;
        cam.setScroll(cam.scrollX - this.velocityWheelX, cam.scrollY);
        this.velocityWheelX *= this.settings.wheelDeceleration;
      }
      if (this.settings.verticalWheel && this.velocityWheelYAbs > 0.1) {
        this.dragging = true;
        this.autoScrollY = false;
        cam.setScroll(cam.scrollX, cam.scrollY - this.velocityWheelY);
        this.velocityWheelY *= this.settings.wheelDeceleration;
      }
    }
    getNow() {
      if (performance && performance.now) {
        return performance.now();
      }
      return Date.now();
    }
    withinGame() {
      return true;
    }
    resetScroll() {
      this.autoScrollX = false;
      this.autoScrollY = false;
      this.velocityWheelX = 0;
      this.velocityWheelY = 0;
    }
  };

  // src/robowhale/phaser3/gameObjects/CameraScrollbar.ts
  var CameraScrollbar = class extends Phaser.GameObjects.Image {
    constructor(scene, camera, texture, frame) {
      super(scene, 0, 0, texture, frame);
      this.isDragged = false;
      this.scrollTop = 0;
      this.scrollBottom = 0;
      this.scrollHeight = 0;
      this.camera = camera;
      this.setInteractive();
      this.scene.input.setDraggable(this);
      this.input.cursor = "pointer";
      this.on(Phaser.Input.Events.GAMEOBJECT_DRAG_START, this.onDragStart, this);
      this.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, this.onDragEnd, this);
    }
    onDragStart() {
      this.isDragged = true;
      document.onpointermove = (event) => {
        let gameY = this.scene.scale.transformY(event.pageY);
        this.y = Phaser.Math.Clamp(gameY, this.scrollTop, this.scrollBottom);
        this.updateCameraPosition();
      };
    }
    updateCameraPosition() {
      let cameraBounds = this.camera.getBounds();
      let cameraTop = cameraBounds.y;
      let cameraBottom = cameraBounds.bottom - Config.GAME_HEIGHT / this.camera.zoom;
      let scrollPercent = (this.y - this.scrollTop) / this.scrollHeight;
      this.camera.scrollY = (cameraBottom - cameraTop) * scrollPercent;
    }
    onDragEnd() {
      this.isDragged = false;
      document.onpointermove = null;
    }
    onResize() {
      let scrollOffset = this.displayHeight / 2 + 6 * this.scaleY;
      this.scrollTop = scrollOffset;
      this.scrollBottom = Config.GAME_HEIGHT - scrollOffset;
      this.scrollHeight = this.scrollBottom - this.scrollTop;
    }
    preUpdate(time, delta) {
      if (this.isDragged) {
        return;
      }
      let cameraBounds = this.camera.getBounds();
      let cameraTop = cameraBounds.y;
      let cameraBottom = cameraBounds.bottom - Config.GAME_HEIGHT / this.camera.zoom;
      let cameraY = Math.max(0, this.camera.scrollY);
      let percent = Phaser.Math.Clamp(cameraY / (cameraBottom - cameraTop), 0, 1);
      this.y = this.scrollTop + (this.scrollBottom - this.scrollTop) * percent;
    }
    destroy() {
      document.onpointermove = null;
      this.off(Phaser.Input.Events.GAMEOBJECT_DRAG_START, this.onDragStart, this);
      this.off(Phaser.Input.Events.GAMEOBJECT_DRAG_END, this.onDragEnd, this);
      super.destroy();
    }
  };

  // src/scenes/levelMap/LevelMapBackground.ts
  var LevelMapBackground = class extends Phaser.GameObjects.Container {
    constructor(scene, config2) {
      super(scene);
      this.name = "background";
      this.createPieces(config2);
      this.alignPieces();
      let width = this.pieces[0].width;
      let height = this.pieces[this.pieces.length - 1].bottom;
      this.setSize(width, height);
    }
    createPieces(config2) {
      this.pieces = config2.map((data) => {
        let piece = this.scene.add.image(0, 0, data.texture, data.frame);
        piece.setOrigin(0);
        this.add(piece);
        return piece;
      });
    }
    alignPieces() {
      this.pieces.forEach((piece, index) => {
        let prevPiece = this.pieces[index - 1];
        if (prevPiece) {
          piece.y = prevPiece.bottom;
        } else {
          piece.y = 0;
        }
      });
    }
    cull(camera, cameraTop, cameraBottom) {
      this.pieces.forEach((piece) => {
        let pieceTop = piece.y;
        let pieceBottom = piece.y + piece.displayHeight;
        if (cameraTop >= pieceTop && cameraTop < pieceBottom || cameraBottom > pieceTop && cameraBottom < pieceBottom) {
          piece.revive();
        } else {
          piece.kill();
        }
      });
    }
  };

  // src/scenes/levelMapEditor/LevelMapEditor.ts
  var LevelMapEditor = class extends BaseScene {
    init() {
      super.init();
      this.config = this.cache.json.get("level_map_config");
      this.lastTapTime = 0;
      console.group("Level Map Editor");
    }
    create() {
      this.addBackground();
      this.addLevelIcons();
      this.addScrollbar();
      this.addCameraScroll();
      this.addPointerCallbacks();
      this.addKeyboardCallbacks();
      this.resize();
    }
    addBackground() {
      this.background = new LevelMapBackground(this, this.config.background);
      this.add.existing(this.background);
    }
    addLevelIcons() {
      this.levelIcons = [];
      this.config.levelIcons.forEach((data) => {
        this.doAddLevelIcon(data.level_number, data.x, data.y);
      });
    }
    addScrollbar() {
      this.scrollbar = new CameraScrollbar(this, this.cameras.main, "level_map", "scrollbar");
      this.scrollbar.setAlpha(0.5);
      this.scrollbar.on(Phaser.Input.Events.DRAG_START, this.onScrollbarDragStart, this);
      this.add.existing(this.scrollbar);
    }
    onScrollbarDragStart() {
      this.cameraScroll.resetScroll();
    }
    addCameraScroll() {
      this.cameraScroll = new KineticScroll(this, {
        camera: this.cameras.main,
        timeConstantScroll: 300,
        horizontalScroll: false,
        verticalScroll: true,
        verticalWheel: true,
        wheelScrollAmount: 50,
        scrollMultiplier: 2
      });
      this.cameraScroll.addPointerListeners();
    }
    addPointerCallbacks() {
      this.input.on(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
      this.input.on(Phaser.Input.Events.DRAG, this.onPointerDrag, this);
    }
    onPointerDown(pointer, objects) {
      let now2 = Date.now();
      if (objects.length > 0) {
        this.lastTapTime = now2;
        return;
      }
      this.cameraScroll.beginMove(pointer);
      let deltaTapTime = now2 - this.lastTapTime;
      if (deltaTapTime < 300) {
        this.addLevelIcon();
      }
      this.lastTapTime = now2;
    }
    onPointerDrag(pointer, gameObject, dragX, dragY) {
      if (gameObject === this.scrollbar) {
        return;
      }
      gameObject.x = dragX;
      gameObject.y = dragY;
    }
    addLevelIcon() {
      let pointerWorldPosition = {x: this.input.activePointer.worldX, y: this.input.activePointer.worldY};
      let iconX = pointerWorldPosition.x;
      let iconY = pointerWorldPosition.y;
      let levelNumber = Math.max(...this.levelIcons.map((icon) => icon.levelNumber), 0) + 1;
      this.doAddLevelIcon(levelNumber, iconX, iconY);
    }
    doAddLevelIcon(levelNumber, x, y) {
      let icon = new LevelMapEditorLevelIcon(this);
      icon.x = x;
      icon.y = y;
      icon.levelNumber = levelNumber;
      icon.on(Phaser.Input.Events.GAMEOBJECT_POINTER_WHEEL, this.onLevelIconWheel.bind(this, icon));
      this.input.setDraggable(icon);
      this.levelIcons.push(icon);
      this.add.existing(icon);
      return icon;
    }
    onLevelIconWheel(icon, pointer, dx, dy) {
      if (!pointer.event.shiftKey) {
        return;
      }
      icon.levelNumber = Math.max(1, icon.levelNumber - Phaser.Math.Sign(dy));
    }
    onPointerWheel(pointer, objects, dx, dy) {
      if (objects.length > 0) {
        return;
      }
      let camera = this.cameras.main;
      camera.scrollY += Phaser.Math.Sign(dy) * 100;
    }
    addKeyboardCallbacks() {
      this.onKeyDown("END", this.scrollToBottom, this);
      this.onKeyDown("HOME", this.scrollToTop, this);
      this.onKeyDown("S", this.saveConfig, this);
      this.onKeyDown("F", this.findLevelIcon, this);
      this.onKeyDown("DELETE", this.deleteLevelIcon, this);
      this.onKeyDown("PAGE_DOWN", this.scrollPageDown, this);
      this.onKeyDown("PAGE_UP", this.scrollPageUp, this);
      this.onceKeyDown("ESC", this.gotoLevelEditor, this);
      this.onceKeyDown("ENTER", this.gotoLevelMap, this);
    }
    gotoLevelEditor() {
      let levelNumbers = this.game.levelConfigs.getLevelNumbers();
      let lastLevel = last_default(levelNumbers) || 1;
      this.changeScene(SceneKey.LEVEL_EDITOR_ROOT, {levelNumber: lastLevel});
    }
    gotoLevelMap() {
      this.changeScene(SceneKey.LEVEL_MAP);
    }
    deleteLevelIcon() {
      this.input.hitTestPointer(this.input.activePointer).filter((object) => object instanceof LevelMapEditorLevelIcon).forEach((icon) => {
        icon.destroy();
        pull_default(this.levelIcons, icon);
      });
    }
    scrollToBottom() {
      let camera = this.cameras.main;
      camera.scrollY = camera.getBounds().bottom;
    }
    scrollToTop() {
      let camera = this.cameras.main;
      camera.scrollY = 0;
    }
    scrollPageDown() {
      this.cameras.main.scrollY += Config.GAME_HEIGHT;
    }
    scrollPageUp() {
      this.cameras.main.scrollY -= Config.GAME_HEIGHT;
    }
    saveConfig() {
      this.updateConfig();
      this.validateConfig();
      FileUtil.saveLocally("dev/assets/configs/level_map_config.json", this.config).then(() => {
        console.log("Level map config was saved!");
      }).catch((error) => {
        console.warn("Can't save level map config", error);
      });
    }
    updateConfig() {
      this.config.levelIcons = sortBy_default(this.levelIcons, "levelNumber").map((icon) => {
        return {
          level_number: icon.levelNumber,
          x: icon.x,
          y: icon.y
        };
      });
    }
    validateConfig() {
      let actualLevelNumbers = this.levelIcons.map((icon) => icon.levelNumber).sort((n1, n2) => n1 - n2);
      let duplicates = Object.values(groupBy_default(actualLevelNumbers)).filter((arr) => arr.length > 1).map((arr) => arr[0]);
      if (duplicates.length > 0) {
        console.warn("Remove duplicate level icons", duplicates);
      }
      let requiredLevelNumbers = range_default(1, 101);
      let missingLevelNumbers = difference_default(requiredLevelNumbers, actualLevelNumbers);
      if (missingLevelNumbers.length > 0) {
        console.warn("Add missing level icons!", missingLevelNumbers);
      }
    }
    findLevelIcon() {
      let existingLevels = this.levelIcons.map((icon2) => icon2.levelNumber);
      let min = Math.min(...existingLevels);
      let max = Math.max(...existingLevels);
      let levelNumberStr = prompt(`Enter level number (between ${min} and ${max}`);
      if (levelNumberStr === null) {
        return;
      }
      let levelNumber = parseInt(levelNumberStr);
      if (isNaN(levelNumber)) {
        console.warn("Please enter valid level number!", levelNumberStr);
        return;
      }
      let icon = this.levelIcons.find((icon2) => icon2.levelNumber === levelNumber);
      if (!icon) {
        console.warn(`Level ${levelNumber} doesn't exist!`);
        return;
      }
      let {main: camera} = this.cameras;
      let iconY = Phaser.Display.Bounds.GetCenterY(icon);
      camera.scrollY = iconY - camera.displayHeight / 2;
    }
    resize() {
      super.resize();
      this.resizeCamera();
      this.alignScrollbar();
    }
    resizeCamera() {
      let camera = this.cameras.main;
      camera.setOrigin(0);
      camera.zoom = Config.GAME_WIDTH / this.background.width;
      camera.setBounds((Config.GAME_WIDTH - camera.displayWidth) / 2, (Config.GAME_HEIGHT - camera.displayHeight) / 2, camera.displayWidth, this.background.height);
    }
    alignScrollbar() {
      this.scrollbar.x = Config.GAME_WIDTH - 10;
      this.scrollbar.onResize();
    }
    update(time, delta) {
      this.cameraScroll.update();
    }
    onShutdown() {
      console.groupEnd();
      this.cameraScroll.removePointerListeners();
    }
  };

  // src/scenes/levelMap/LevelIcon.ts
  var LevelIconState;
  (function(LevelIconState2) {
    LevelIconState2["LOCKED"] = "LOCKED";
    LevelIconState2["UNLOCKED"] = "UNLOCKED";
    LevelIconState2["COMPLETE"] = "COMPLETE";
  })(LevelIconState || (LevelIconState = {}));
  var LevelIcon = class extends Phaser.GameObjects.Container {
    get levelNumber() {
      return this._levelNumber;
    }
    get iconState() {
      return this._iconState;
    }
    constructor(scene, data) {
      super(scene);
      this.iconData = data;
      this.name = "level_icon_" + this.iconData.levelNumber.toString();
      this._levelNumber = this.iconData.levelNumber;
      this.addBack();
      this.addIcon();
      this.addLevelNumber();
      this.setSize(this.back.width, this.back.height);
      this.setInitialState();
    }
    setInitialState() {
      if (this.iconData.locked) {
        this.setLocked();
      } else {
        if (this.iconData.complete) {
          this.setComplete();
        } else {
          this.setUnlocked();
        }
      }
    }
    setLocked() {
      this._iconState = LevelIconState.LOCKED;
      this.back.setFrame("level_icons/level_icon_locked");
      this.icon.kill();
      this.levelNumberText.kill();
      this.removeInteractive();
    }
    setUnlocked() {
      this._iconState = LevelIconState.UNLOCKED;
      this.back.setFrame(this.getBackFrame());
      this.icon.revive();
      this.levelNumberText.revive();
      this.setInteractive();
      this.input.cursor = "pointer";
    }
    setComplete() {
      this._iconState = LevelIconState.COMPLETE;
      this.back.setFrame(this.getBackFrame());
      this.icon.revive();
      this.icon.setFrame("level_icons/check_icon");
      this.levelNumberText.revive();
      this.setInteractive();
      this.input.cursor = "pointer";
    }
    addBack() {
      let backFrame = this.getBackFrame();
      this.back = this.scene.add.image(0, 0, "level_map", backFrame);
      this.add(this.back);
    }
    getBackFrame() {
      return this.iconData.isHard ? "level_icons/level_icon_hard" : "level_icons/level_icon_classic";
    }
    addIcon() {
      let iconFrame = this.iconData.isHard ? "level_icons/skull_icon" : "level_icons/chef_hat_icon";
      this.icon = this.scene.add.image(0, 0, "level_map", iconFrame);
      this.icon.x = 1;
      this.icon.y = -20;
      this.icon.alpha = 0.8;
      this.add(this.icon);
    }
    addLevelNumber() {
      let font = this.iconData.isHard ? BitmapFont.LEVEL_ICONS_HARD : BitmapFont.LEVEL_ICONS_CLASSIC;
      this.levelNumberText = this.scene.add.bitmapText(0, 0, font, this._levelNumber.toString(), 32);
      this.levelNumberText.setLetterSpacing(1);
      this.levelNumberText.setOrigin(0.5, 0.5);
      this.levelNumberText.x = -2;
      this.levelNumberText.y = 24;
      this.add(this.levelNumberText);
    }
  };

  // src/scenes/levelMap/topPanel/TopPanelLabel.ts
  var TopPanelLabel = class extends Phaser.GameObjects.Container {
    constructor(scene, iconFrameName) {
      super(scene);
      this.name = "label";
      this.addBack();
      this.addIcon(iconFrameName);
      this.addPlusButton();
      this.addText();
      this.addParticles();
      this.setSize(this.back.width, this.back.height);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "level_map", "top_panel/label_back");
      this.add(this.back);
    }
    addIcon(iconFrameName) {
      let iconImage = this.scene.add.image(0, 0, "level_map", iconFrameName);
      this.icon = this.scene.add.container(0, 0, iconImage);
      this.icon.x = this.back.left;
      this.add(this.icon);
    }
    addPlusButton() {
      this.plusButton = this.scene.add.button("level_map", "top_panel/PinkPurple-RectangleButton", this);
      this.plusButton.x = this.back.right;
      this.plusButton.y = -3;
      this.plusButton.inflateHitArea(10, 10);
      this.add(this.plusButton);
    }
    addText() {
      let content = "0000";
      this.text = this.scene.add.bitmapText(0, 0, BitmapFont.LEVEL_MAP_TOP_PANEL, content, 25);
      this.text.setOrigin(0.5, 0.5);
      this.text.y = 4;
      this.add(this.text);
    }
    addParticles() {
      this.particles = this.scene.add.particles("level_map");
      this.particles.x = this.icon.x;
      this.particles.y = this.icon.y;
      this.emitter = this.particles.createEmitter({
        frame: ["circle_fx"],
        scale: {start: 0.66, end: 1.33, ease: Ease.ExpoOut},
        alpha: {start: 0.55, end: 0, ease: Ease.ExpoOut},
        lifespan: 2e3,
        frequency: 500,
        on: false
      });
      this.addAt(this.particles, 0);
    }
    updateText(value) {
      this.text.text = value;
    }
    animateIcon() {
      var _a;
      (_a = this.iconTween) == null ? void 0 : _a.remove();
      this.iconTween = this.scene.tweens.add({
        targets: this.icon,
        duration: 233,
        ease: Phaser.Math.Easing.Cubic.Out,
        scale: 1.15,
        onComplete: () => {
          this.scene.time.delayedCall(100, () => {
            this.emitter.emitParticle();
          });
          this.iconTween = this.scene.tweens.add({
            targets: this.icon,
            duration: 900,
            ease: Phaser.Math.Easing.Elastic.Out,
            easeParams: [0.1, 0.45],
            scale: 1
          });
        }
      });
    }
    showTextFx(content) {
      let textFx = this.createTextFx(content);
      textFx.setOrigin(0.5, 0.5);
      textFx.setShadow(0, 3, "rgba(0,0,0,0.3)", 0);
      textFx.x = this.text.x;
      textFx.y = this.text.y + 15;
      this.add(textFx);
      this.animateTextFx(textFx);
    }
    createTextFx(content) {
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "25px",
        color: "#FEEDBD",
        align: "center",
        resolution: 2
      };
      return this.scene.add.text(0, 0, content, style);
    }
    animateTextFx(text) {
      text.alpha = 0;
      this.scene.tweens.add({
        targets: text,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1,
        onComplete: () => {
          this.scene.tweens.add({
            delay: 1300,
            targets: text,
            duration: 500,
            ease: Phaser.Math.Easing.Cubic.Out,
            alpha: 0,
            onComplete: () => {
              text.destroy();
            }
          });
        }
      });
      text.scale = 0.5;
      this.scene.tweens.add({
        targets: text,
        duration: 900,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.5],
        scale: 1
      });
      this.scene.tweens.add({
        targets: text,
        duration: 1800,
        ease: Phaser.Math.Easing.Linear,
        y: "+=25"
      });
    }
  };

  // src/scenes/levelMap/topPanel/LivesLabel.ts
  var LivesLabel = class extends TopPanelLabel {
    constructor(scene, livesManager) {
      super(scene, "top_panel/Red-Life-Icon");
      this.scene.sys.updateList.add(this);
      this.name = "lives_label";
      this.addLivesText();
      this.addFullLabel();
      this.initLivesManager(livesManager);
      this.updateLivesNum(this.lives.getLivesNum());
      if (this.lives.isUnlimited()) {
        this.onUnlimitedTimerStart();
        return;
      }
      if (this.lives.isFull()) {
        this.showFullLabel();
      } else {
        this.hideFullLabel();
      }
    }
    addLivesText() {
      let content = this.scene.game.store.getNumber(GameStoreKey.LIVES).toString();
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "24px",
        color: "#ffffff",
        align: "center",
        strokeThickness: 5,
        stroke: "#E63C7B"
      };
      this.livesTextDefaultStyle = style;
      this.livesText = this.scene.add.text(0, 0, content, this.livesTextDefaultStyle);
      this.livesText.setOrigin(0.5, 0.5);
      this.livesText.y = -1;
      this.icon.add(this.livesText);
    }
    addFullLabel() {
      let content = this.scene.texts.lives.full;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "22px",
        color: "#FEEDBD",
        align: "center"
      };
      this.fullLabel = this.scene.add.text(0, 0, content, style);
      this.fullLabel.setOrigin(0.5, 0.5);
      this.fullLabel.x = this.text.x;
      this.fullLabel.y = -1;
      this.fullLabel.kill();
      this.add(this.fullLabel);
    }
    initLivesManager(livesManager) {
      this.lives = livesManager;
      this.lives.on(LivesManagerEvent.REFILL_TIMER_START, this.onRefillTimerStart, this);
      this.lives.on(LivesManagerEvent.REFILL_TIMER_COMPLETE, this.onRefillTimerComplete, this);
      this.lives.on(LivesManagerEvent.UNLIMITED_TIMER_START, this.onUnlimitedTimerStart, this);
      this.lives.on(LivesManagerEvent.UNLIMITED_TIMER_COMPLETE, this.onUnlimitedTimerComplete, this);
      this.lives.on(LivesManagerEvent.LIVES_ADDED, this.onLivesAdded, this);
      this.lives.on(LivesManagerEvent.PAGE_VISIBLE, this.onPageVisible, this);
    }
    onRefillTimerStart(livesManager, seconds) {
      this.hideFullLabel();
      this.updateLivesNum(livesManager.getLivesNum());
      this.updateText(livesManager.refillTimer.getFormattedTime());
    }
    onRefillTimerComplete() {
      this.updateLivesNum(this.lives.getLivesNum());
      this.animateIcon();
      if (this.lives.isFull()) {
        this.showFullLabel();
      }
    }
    onUnlimitedTimerStart() {
      this.hideFullLabel();
      this.updateLivesNum(Infinity);
      this.updateText(this.lives.unlimitedTimer.getFormattedTime());
    }
    onUnlimitedTimerComplete() {
      this.updateLivesNum(this.lives.getLivesNum());
      this.animateIcon();
      if (this.lives.isFull()) {
        this.showFullLabel();
      }
    }
    onLivesAdded() {
      this.updateLivesNum(this.lives.getLivesNum());
    }
    onPageVisible(livesManager, livesGained) {
      if (livesGained <= 0) {
        return;
      }
      this.updateLivesNum(this.lives.getLivesNum());
      this.animateIcon();
      if (this.lives.isFull()) {
        this.showFullLabel();
      }
    }
    updateLivesNum(value) {
      if (value === Infinity) {
        this.livesText.setFontFamily("Arial");
        this.livesText.setFontSize(42);
        this.livesText.setFontStyle(FontWeight.BOLD);
        this.livesText.text = INFINITY_SIGN;
      } else {
        this.livesText.setStyle(this.livesTextDefaultStyle);
        this.livesText.text = value.toString();
      }
    }
    showFullLabel() {
      this.fullLabel.revive();
      this.text.kill();
    }
    hideFullLabel() {
      this.fullLabel.kill();
      this.text.revive();
    }
    preUpdate(time, delta) {
      var _a, _b;
      if ((_a = this.lives.unlimitedTimer) == null ? void 0 : _a.isRunning) {
        this.updateText(this.lives.unlimitedTimer.getFormattedTime());
        return;
      }
      if ((_b = this.lives.refillTimer) == null ? void 0 : _b.isRunning) {
        this.updateText(this.lives.refillTimer.getFormattedTime());
      }
    }
    onLanguageChange() {
      this.fullLabel.text = this.scene.texts.lives.full;
    }
    preDestroy() {
      this.lives.off(LivesManagerEvent.REFILL_TIMER_START, this.onRefillTimerStart, this);
      this.lives.off(LivesManagerEvent.REFILL_TIMER_COMPLETE, this.onRefillTimerComplete, this);
      this.lives.off(LivesManagerEvent.UNLIMITED_TIMER_START, this.onUnlimitedTimerStart, this);
      this.lives.off(LivesManagerEvent.UNLIMITED_TIMER_COMPLETE, this.onUnlimitedTimerComplete, this);
      this.lives.off(LivesManagerEvent.LIVES_ADDED, this.onLivesAdded, this);
      this.lives.off(LivesManagerEvent.PAGE_VISIBLE, this.onPageVisible, this);
      this.scene.sys.updateList.remove(this);
      super.preDestroy();
    }
  };

  // src/scenes/levelMap/topPanel/CoinsLabel.ts
  var CoinsLabel = class extends TopPanelLabel {
    constructor(scene) {
      super(scene, "top_panel/Coin");
      this.scene.game.store.on(GameStoreEvent.CLEAR, this.onClearStore, this);
      this.coinSoundThrottled = throttle_default(this.playCoinAddSound.bind(this), 100);
    }
    playCoinAddSound() {
      this.scene.audio.play(GameSoundKey.COIN_ADD);
    }
    onClearStore() {
      this.text.text = this.scene.game.store.getNumber(GameStoreKey.COINS).toLocaleString();
    }
    updateContent(value) {
      var _a;
      let startValueStr = this.text.text.replace(/[,. ]/g, "");
      let startValue = parseInt(startValueStr) || 0;
      let playSound = value > 0;
      (_a = this.counterTween) == null ? void 0 : _a.remove();
      this.counterTween = this.scene.tweens.addCounter({
        from: startValue,
        to: value,
        duration: 1e3,
        ease: Phaser.Math.Easing.Expo.Out,
        onUpdate: (tween) => {
          this.updateContentInstant(Math.round(tween.getValue()));
          if (playSound && tween.progress < 0.85) {
            this.coinSoundThrottled();
          }
        }
      });
    }
    updateContentInstant(value) {
      this.text.text = value.toLocaleString();
    }
    syncWithGameStore(instant) {
      let coinsNum = this.scene.game.store.getNumber(GameStoreKey.COINS);
      if (instant) {
        this.updateContentInstant(coinsNum);
      } else {
        this.updateContent(coinsNum);
      }
    }
    showCoinsTextFx(value) {
      let prefix = value >= 0 ? "+" : "";
      let content = prefix + value.toString();
      super.showTextFx(content);
    }
    preDestroy() {
      this.coinSoundThrottled.cancel();
      this.scene.game.store.off(GameStoreEvent.CLEAR, this.onClearStore, this);
      super.preDestroy();
    }
  };

  // src/scenes/levelMap/topPanel/LevelMapTopPanel.ts
  var LevelMapTopPanel = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.name = "top_panel";
      this.addBack();
      this.addLivesLabel();
      this.addCoinsLabel();
      this.addSettingsButton();
      this.setSize(this.back.width, this.back.height);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "level_map", "top_panel/top_panel_back");
      this.add(this.back);
    }
    addLivesLabel() {
      this.livesLabel = new LivesLabel(this.scene, this.scene.game.lives);
      this.livesLabel.x = this.back.left + 150;
      this.livesLabel.y = 45;
      this.add(this.livesLabel);
    }
    addCoinsLabel() {
      let coins = this.scene.game.store.getNumber(GameStoreKey.COINS);
      this.coinsLabel = new CoinsLabel(this.scene);
      this.coinsLabel.x = 82;
      this.coinsLabel.y = this.livesLabel.y;
      this.coinsLabel.updateText(coins.toLocaleString());
      this.add(this.coinsLabel);
      if (!this.scene.game.purchases) {
        this.coinsLabel.plusButton.kill();
        this.coinsLabel.x = 100;
      }
    }
    addSettingsButton() {
      this.settingsButton = this.scene.add.button("level_map", "top_panel/button_settings", this);
      this.settingsButton.x = this.back.right - 70;
      this.settingsButton.y = this.coinsLabel.y - 2;
    }
    enableInteractiveItems() {
      this.getInteractiveItems().forEach((item) => item.enableInput());
    }
    disableInteractiveItems() {
      this.getInteractiveItems().forEach((item) => item.disableInput());
    }
    getInteractiveItems() {
      return [this.settingsButton, this.livesLabel.plusButton, this.coinsLabel.plusButton];
    }
  };

  // src/scenes/levelMap/settings/LanguagesButton.ts
  var LanguagesButton = class extends Phaser.GameObjects.Container {
    constructor(scene, parent) {
      super(scene);
      if (parent) {
        parent.add(this);
      } else {
        this.scene.add.existing(this);
      }
      this.addBack();
      this.addArrows();
      this.addText();
      this.setSize(this.back.displayWidth, this.back.displayHeight);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "level_map", "settings/pink_button_long");
      this.add(this.back);
    }
    addArrows() {
      let dx = 160;
      let y = 2;
      this.leftArrow = this.scene.add.button("level_map", "settings/arrow_left", this);
      this.leftArrow.x = -dx;
      this.leftArrow.y = y;
      this.rightArrow = this.scene.add.button("level_map", "settings/arrow_right", this);
      this.rightArrow.x = dx;
      this.rightArrow.y = y;
    }
    addText() {
      this.text = this.scene.add.text(0, 0, "Language", this.getTextStyle());
      this.text.setOrigin(0.5, 0.5);
      this.text.x = 6;
      this.text.y = -2;
      this.add(this.text);
    }
    getTextStyle() {
      return {
        color: "#FFFFFF",
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "45px",
        align: "center",
        padding: {
          x: 2,
          y: 6
        },
        shadow: {
          fill: true,
          blur: 0,
          offsetY: 3,
          color: "rgba(0,0,0,0.2)"
        }
      };
    }
    updateText(content) {
      this.scene.tweens.killTweensOf(this.text);
      this.scene.tweens.add({
        targets: this.text,
        duration: 66,
        ease: Phaser.Math.Easing.Linear,
        alpha: 0,
        onComplete: () => {
          this.text.setText(content);
          this.adjustTextSize();
          this.scene.tweens.add({
            targets: this.text,
            duration: 150,
            ease: Phaser.Math.Easing.Cubic.Out,
            alpha: 1
          });
        }
      });
    }
    adjustTextSize() {
      let left = this.leftArrow.right;
      let right = this.rightArrow.left;
      let width = right - left;
      let maxWidth = width * 0.9;
      this.text.scale = Math.min(1, maxWidth / this.text.width);
    }
  };

  // src/scenes/levelMap/settings/SettingsScreenContent.ts
  var SettingsScreenContent = class extends Phaser.GameObjects.Container {
    constructor(scene, atlasKey) {
      super(scene);
      this.atlasKey = atlasKey;
      this.name = "buttons_container";
      this.addBackground();
      this.addButtons();
      this.addRoboWhaleInfo();
      this.alignItems();
      this.settingsContent = this.getSettingsContent();
      this.creditsContent = [this.robowhaleInfo];
      this.showSettingsContent();
      this.setSize(this.background.width, this.background.height);
    }
    getSettingsContent() {
      return [this.soundButton, this.musicButton, this.languagesButton, this.graphicsQualityButton];
    }
    showContent(content) {
      content.forEach((item) => item.visible = true);
      this.scene.tweens.add({
        targets: content,
        alpha: {from: 0, to: 1, ease: Phaser.Math.Easing.Cubic.Out, duration: 200},
        scale: {from: 0.75, to: 1, ease: Phaser.Math.Easing.Back.Out, duration: 400}
      });
    }
    hideContent(content) {
      content.forEach((item) => item.visible = false);
    }
    showSettingsContent() {
      this.showContent(this.settingsContent);
      this.hideContent(this.creditsContent);
      this.makePrimaryButton(this.settingsButton);
      this.makeSecondaryButton(this.creditsButton);
    }
    showCreditsContent() {
      this.showContent(this.creditsContent);
      this.hideContent(this.settingsContent);
      this.makePrimaryButton(this.creditsButton);
      this.makeSecondaryButton(this.settingsButton);
    }
    makePrimaryButton(button) {
      button.disableInteractive();
      this.scene.tweens.killTweensOf(button);
      this.scene.tweens.add({
        targets: button,
        duration: 200,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 1
      });
      this.scene.tweens.add({
        targets: button,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.33],
        scale: 1
      });
    }
    makeSecondaryButton(button) {
      button.setInteractive();
      this.scene.tweens.killTweensOf(button);
      this.scene.tweens.add({
        targets: button,
        duration: 200,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 0.7
      });
      this.scene.tweens.add({
        targets: button,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.33],
        scale: 0.85
      });
    }
    addBackground() {
      this.background = this.scene.add.image(0, 0, this.atlasKey, "settings/white_rect");
      this.background.displayWidth = 465;
      this.background.displayHeight = 660;
      this.background.alpha = 0;
      this.add(this.background);
    }
    addButtons() {
      this.settingsButton = this.scene.add.button(this.atlasKey, "settings/button_settings", this);
      this.settingsButton.areTweensEnabled = false;
      this.settingsButton.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.showSettingsContent, this);
      this.creditsButton = this.scene.add.button(this.atlasKey, "settings/button_credits", this);
      this.creditsButton.areTweensEnabled = false;
      this.creditsButton.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.showCreditsContent, this);
      this.soundButton = this.scene.add.soundButton(this.atlasKey, "settings/button_sound_on", "settings/button_sound_off", this);
      this.musicButton = this.scene.add.musicButton(this.atlasKey, "settings/button_music_on", "settings/button_music_off", this);
      this.addLanguageButton();
      this.addGraphicsQualityButton();
    }
    addLanguageButton() {
      let content = getLanguageTitle(this.scene.game.texts.language);
      this.languagesButton = new LanguagesButton(this.scene, this);
      this.languagesButton.leftArrow.on(ButtonEvent.PRESS, this.updateLanguage.bind(this, -1));
      this.languagesButton.rightArrow.on(ButtonEvent.PRESS, this.updateLanguage.bind(this, 1));
      this.languagesButton.updateText(content);
    }
    updateLanguage(direction) {
      let texts = this.scene.game.texts;
      let currentLanguage = texts.language;
      let languages = texts.allLanguages;
      let currentIndex = languages.indexOf(currentLanguage);
      let newIndex = Phaser.Math.Wrap(currentIndex + direction, 0, languages.length);
      let newLanguage = languages[newIndex];
      this.scene.game.store.saveValue(GameStoreKey.LANGUAGE, newLanguage);
      this.scene.game.texts.setLanguage(newLanguage);
      this.languagesButton.updateText(getLanguageTitle(newLanguage));
    }
    addGraphicsQualityButton() {
      let props = {
        back: {key: "level_map", frame: "settings/pink_button_long"},
        leftArrow: {key: "level_map", frame: "settings/arrow_left"},
        rightArrow: {key: "level_map", frame: "settings/arrow_right"},
        title: this.scene.texts.graphics_quality.title
      };
      this.graphicsQualityButton = new GraphicsQualityButton(this.scene, props, this);
    }
    addRoboWhaleInfo() {
      this.robowhaleInfo = this.scene.add.image(0, 0, this.atlasKey, "settings/robowhale_info");
      this.add(this.robowhaleInfo);
    }
    onRobowhaleClick() {
      window.open("https://robowhale.com/?utm_source=papa_cherry_saga");
    }
    alignItems() {
      let bounds = this.background.getBounds();
      let xOffset = 86;
      let topButtonsY = bounds.top + this.settingsButton.displayHeight / 2;
      this.settingsButton.x = bounds.centerX - xOffset;
      this.settingsButton.y = topButtonsY;
      this.creditsButton.x = bounds.centerX + xOffset;
      this.creditsButton.y = topButtonsY;
      this.alignMiddleButtons(bounds);
      this.languagesButton.y = bounds.bottom - 255;
      this.graphicsQualityButton.y = bounds.bottom - this.graphicsQualityButton.displayHeight / 2;
      this.robowhaleInfo.y = bounds.top + 370;
    }
    alignMiddleButtons(bounds) {
      let middleButtonsY = bounds.top + 232;
      this.soundButton.x = this.settingsButton.x;
      this.soundButton.y = middleButtonsY;
      this.musicButton.x = this.creditsButton.x;
      this.musicButton.y = middleButtonsY;
    }
    onLanguageChange() {
      this.graphicsQualityButton.onLanguageChange();
    }
  };

  // src/scenes/levelMap/settings/SettingsScreen.ts
  var SettingsScreenEvent;
  (function(SettingsScreenEvent2) {
    SettingsScreenEvent2["CLOSE"] = "__CLOSE";
    SettingsScreenEvent2["CLEAR_SAVED_DATA"] = "__CLEAR_SAVED_DATA";
  })(SettingsScreenEvent || (SettingsScreenEvent = {}));
  var SettingsScreen = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "settings_screen",
        backgroundKey: "level_map",
        backgroundFrame: "black_rect",
        backgroundAlpha: 0.85
      });
      this.isActive = true;
      this.ignoreBackgroundClicks = false;
      this.addContent();
      this.addCloseButton();
      this.addBuildInfo();
    }
    addContent() {
      this.content = new SettingsScreenContent(this.scene, "level_map");
      this.add(this.content);
      this.pin(this.content, 0.5, 0.48);
    }
    addCloseButton() {
      this.closeButton = this.scene.add.button("level_map", "settings/button_close", this);
      this.pin(this.closeButton, 1, 0, -80, 80);
    }
    addBuildInfo() {
      let gameConfig = window.game.config;
      let buildVersion = gameConfig.build_version.toString();
      let buildDate = gameConfig.build_time;
      let publisher = gameConfig.publisher;
      let content = `Build #${buildVersion} ${buildDate}
${publisher}`;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: "normal",
        fontSize: "24px",
        color: "#ffffff",
        padding: {x: 20, y: 12},
        align: "center"
      };
      let alpha = 0.8;
      this.buildInfo = this.scene.add.text(0, 0, content, style);
      this.buildInfo.setOrigin(0.5, 0.5);
      this.buildInfo.alpha = alpha;
      this.buildInfo.originalAlpha = alpha;
      this.buildInfo.clicks = 0;
      this.buildInfo.setInteractive();
      this.buildInfo.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onBuildInfoClick, this);
      this.buildInfo.input.cursor = "pointer";
      this.add(this.buildInfo);
      this.pin(this.buildInfo, 0.5, 1, 0, -46);
    }
    onBuildInfoClick() {
      this.scene.audio.playClick();
      if (++this.buildInfo.clicks === 5) {
        this.buildInfo.clicks = 0;
        this.emit(SettingsScreenEvent.CLEAR_SAVED_DATA);
      }
    }
    resize() {
      super.resize();
    }
    show() {
      this.alpha = 1;
      this.revive();
      this.showBackground();
      this.showBuildInfo();
      this.showContent();
      this.emit(PhaserScreenEvent.SHOW, this);
      this.closeButton.once(ButtonEvent.PRESS, this.close, this);
      this.background.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onBackgroundClick, this);
    }
    showBuildInfo() {
      this.scene.tweens.add({
        targets: this.buildInfo,
        duration: 1e3,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: {from: 0, to: this.buildInfo.originalAlpha}
      });
    }
    showContent() {
      let items = [this.content, this.closeButton];
      items.forEach((item, index) => {
        let delay = index * 100;
        item.alpha = 0;
        this.scene.tweens.add({
          delay,
          targets: item,
          duration: 200,
          ease: Phaser.Math.Easing.Cubic.Out,
          alpha: 1
        });
        let originalScale = item.scale;
        item.scale = originalScale * 0.8;
        this.scene.tweens.add({
          delay,
          targets: item,
          duration: 1e3,
          ease: Phaser.Math.Easing.Elastic.Out,
          easeParams: [0.1, 0.45],
          scale: originalScale
        });
      });
    }
    hide() {
      this.scene.tweens.add({
        targets: this,
        duration: 100,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.kill();
          this.emit(PhaserScreenEvent.HIDE_COMPLETE, this);
        }
      });
    }
    close() {
      this.emit(SettingsScreenEvent.CLOSE, this);
      this.closeButton.off(ButtonEvent.PRESS, this.close, this);
      this.background.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.close, this);
    }
    onBackgroundClick() {
      if (this.ignoreBackgroundClicks) {
        return;
      }
      this.background.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onBackgroundClick, this);
      this.close();
    }
    activate() {
      if (this.isActive) {
        return;
      }
      this.isActive = true;
      this.content.revive();
      this.content.alpha = 0;
      this.scene.tweens.add({
        targets: this.content,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.content.scale = 0.75;
      this.scene.tweens.add({
        targets: this.content,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1
      });
      this.closeButton.revive();
      this.closeButton.alpha = 0;
      this.scene.tweens.add({
        targets: this.closeButton,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.closeButton.scale = 0.75;
      this.scene.tweens.add({
        targets: this.closeButton,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1
      });
      this.buildInfo.revive();
      this.scene.tweens.add({
        targets: this.buildInfo,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: this.buildInfo.originalAlpha
      });
    }
    deactivate() {
      if (this.isActive === false) {
        return;
      }
      this.isActive = false;
      this.content.kill();
      this.closeButton.kill();
      this.buildInfo.kill();
    }
    onLanguageChange() {
      this.content.onLanguageChange();
    }
  };

  // src/scenes/levelMap/wheel/Wheel.ts
  var CasinoWheelEvent;
  (function(CasinoWheelEvent2) {
    CasinoWheelEvent2["SPIN_START"] = "Wheel_SPIN_START";
    CasinoWheelEvent2["SPIN_COMPLETE"] = "Wheel_SPIN_COMPLETE";
  })(CasinoWheelEvent || (CasinoWheelEvent = {}));
  var Wheel = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.isSpinning = false;
      this.isIdling = false;
      this.scene.sys.updateList.add(this);
      this.name = "wheel";
      this.addShine();
      this.addWheel();
      this.addArrow();
      this.setSize(this.back.width, this.back.height);
    }
    addShine() {
      this.shine = this.scene.add.image(0, 0, "level_map", "wheel/Shine Background");
      this.add(this.shine);
    }
    addWheel() {
      this.back = this.scene.add.image(0, 0, "level_map", "wheel/Center Background");
      this.items = this.createWheelItems();
      this.alignItems();
      this.border = this.scene.add.image(0, 0, "level_map", "wheel/Border");
      this.particles = this.createParticles();
      this.wheel = this.scene.add.container(0, 0, [this.back, ...this.items, this.border, this.particles]);
      this.add(this.wheel);
    }
    createWheelItems() {
      let types = [
        WheelRewardType.SUPER_SPHERE,
        WheelRewardType.LOLLIPOP,
        WheelRewardType.COINS,
        WheelRewardType.ROLLING_PIN,
        WheelRewardType.GLOVE,
        WheelRewardType.STRIPES,
        WheelRewardType.UNDO,
        WheelRewardType.BOMB
      ];
      return types.map((itemType) => {
        let frame = this.getFrameByItemType(itemType);
        let item = this.scene.add.image(0, 0, "level_map", frame);
        item.itemType = itemType;
        return item;
      });
    }
    getFrameByItemType(itemType) {
      let map = {
        [WheelRewardType.SUPER_SPHERE]: "wheel/items/super_sphere",
        [WheelRewardType.LOLLIPOP]: "wheel/items/Lollipop",
        [WheelRewardType.COINS]: "wheel/items/Coin",
        [WheelRewardType.ROLLING_PIN]: "wheel/items/rolling_pin",
        [WheelRewardType.GLOVE]: "wheel/items/Glove",
        [WheelRewardType.STRIPES]: "wheel/items/stripes",
        [WheelRewardType.UNDO]: "wheel/items/undo",
        [WheelRewardType.BOMB]: "wheel/items/bomb"
      };
      return map[itemType];
    }
    alignItems() {
      let radius = 162;
      let circle = new Phaser.Geom.Circle(0, 0, radius);
      let positions = Phaser.Geom.Circle.GetPoints(circle, this.items.length);
      positions.unshift(positions[positions.length - 1]);
      positions.unshift(positions[positions.length - 2]);
      this.items.forEach((item, index) => {
        let position = positions[index];
        item.x = position.x;
        item.y = position.y;
      });
    }
    createParticles() {
      let particles = this.scene.add.particles("level_map");
      this.circles = particles.createEmitter({
        frame: "particles/circle_fx_3",
        scale: {start: 0.6, end: 1.5, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        lifespan: 1e3,
        on: false
      });
      this.sparks = particles.createEmitter(__spreadProps(__spreadValues({}, ParticleUtil.getCircleEdgeEmitZone(35)), {
        speed: 50,
        frame: "particles/star_1",
        lifespan: {min: 500, max: 900},
        scale: {start: 1, end: 0.5},
        alpha: {start: 1, end: 0, ease: Ease.ExpoIn},
        on: false
      }));
      return particles;
    }
    addArrow() {
      this.arrow = this.scene.add.image(0, 0, "level_map", "wheel/Prize Arrow");
      this.add(this.arrow);
    }
    spin() {
      if (this.isSpinning) {
        return;
      }
      this.isIdling = false;
      this.emit(CasinoWheelEvent.SPIN_START, this);
      let sectorSize = 360 / this.items.length;
      let minSectorsToSpin = this.items.length * 2;
      let sectorsToSpin = Phaser.Math.RND.between(minSectorsToSpin, minSectorsToSpin * 2);
      let targetAngle = Phaser.Math.Snap.To(this.wheel.angle + sectorsToSpin * sectorSize, sectorSize);
      let budgeAngle = sectorSize / 2;
      let spinDuration = this.getSpinDuration(sectorsToSpin);
      this.scene.tweens.addCounter({
        from: this.wheel.angle,
        to: targetAngle,
        duration: spinDuration,
        ease: Ease.ExpoOut,
        onUpdate: (tween, target) => {
          this.wheel.angle = target.value;
          if (target.value > budgeAngle) {
            budgeAngle += sectorSize;
            this.flickArrow(Phaser.Math.MapLinear(tween.progress, 0, 1, 33, 300));
          }
        },
        onComplete: () => {
          this.onSpinComplete();
        }
      });
    }
    getSpinDuration(sectorsToSpin) {
      if (UrlParams.has("wheel")) {
        return UrlParams.getNumber("wheel", 300);
      }
      return sectorsToSpin * 250;
    }
    flickArrow(duration = 66) {
      this.arrow.angle = 0;
      let tween = this.scene.tweens.getTweensOf(this.arrow)[0];
      if (tween) {
        this.scene.audio.play(GameSoundKey.WHEEL_SPIN_TICK);
        tween.remove();
      }
      this.scene.tweens.add({
        targets: this.arrow,
        duration,
        ease: Phaser.Math.Easing.Sine.InOut,
        angle: "+=10",
        yoyo: true,
        onComplete: () => {
          this.scene.audio.play(GameSoundKey.WHEEL_SPIN_TICK);
        }
      });
    }
    onSpinComplete() {
      let item = this.getCurrentItem();
      this.scene.tweens.add({
        targets: item,
        duration: 800,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1.25
      });
      this.sparks.setPosition(item.x, item.y);
      this.sparks.explode(10, item.x, item.y);
      this.circles.emitParticle(3, item.x, item.y);
      this.scene.audio.play(GameSoundKey.TWINKLE_3);
      this.emit(CasinoWheelEvent.SPIN_COMPLETE, this);
    }
    getCurrentItem() {
      let sectorSize = 360 / this.items.length;
      let angle = this.wheel.angle < 0 ? this.wheel.angle + 360 : this.wheel.angle;
      angle = (angle + sectorSize / 2) % 360;
      angle = 360 - angle;
      let index = (Math.floor(angle / sectorSize) + 1) % this.items.length;
      return this.items[index];
    }
    reset() {
      this.wheel.angle = 0;
      this.isIdling = true;
      this.items.forEach((item) => item.scale = 1);
    }
    preUpdate(time, delta) {
      if (this.isIdling) {
        this.wheel.angle -= 0.01 * delta;
      }
    }
  };

  // src/scenes/levelMap/wheel/WheelScreen.ts
  var WheelScreenEvent;
  (function(WheelScreenEvent2) {
    WheelScreenEvent2["SPIN_START"] = "__SPIN_START";
    WheelScreenEvent2["SPIN_COMPLETE"] = "__SPIN_COMPLETE";
    WheelScreenEvent2["START_FAST_FORWARD"] = "__START_FAST_FORWARD";
    WheelScreenEvent2["STOP_FAST_FORWARD"] = "__STOP_FAST_FORWARD";
  })(WheelScreenEvent || (WheelScreenEvent = {}));
  var WheelScreen = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "wheel_screen",
        backgroundKey: "level_map",
        backgroundFrame: "black_rect",
        backgroundAlpha: 0.85
      });
      this.addCloseButton();
      this.addWheel();
      this.addSpinButton();
    }
    addCloseButton() {
      this.closeButton = this.scene.add.button("level_map", "wheel/Close Button", this);
      this.closeButton.on(ButtonEvent.PRESS, this.hide, this);
      this.add(this.closeButton);
      this.pin(this.closeButton, 1, 0, -64, 64);
    }
    addWheel() {
      this.wheel = new Wheel(this.scene);
      this.wheel.on(CasinoWheelEvent.SPIN_START, this.onSpinStart, this);
      this.wheel.on(CasinoWheelEvent.SPIN_COMPLETE, this.onSpinComplete, this);
      this.add(this.wheel);
      this.pin(this.wheel, 0.5, 0.425);
    }
    onSpinStart(wheel) {
      this.emit(WheelScreenEvent.SPIN_START, this);
    }
    onSpinComplete(wheel) {
      this.cancelFastForward();
      this.background.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN);
      this.scene.tweens.add({
        delay: 666,
        targets: wheel,
        duration: 400,
        ease: Phaser.Math.Easing.Back.In,
        scale: 0,
        alpha: 0,
        onComplete: () => {
          this.emit(WheelScreenEvent.SPIN_COMPLETE, this, this.wheel);
          this.hideInstant();
        }
      });
    }
    addSpinButton() {
      this.spinButton = this.scene.add.button("level_map", "wheel/Pink Button", this);
      this.spinButton.on(ButtonEvent.PRESS, this.onSpinButtonClick, this);
    }
    onSpinButtonClick() {
      this.hideCloseButton();
      this.hideSpinButton();
      this.wheel.spin();
      this.background.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.applyFastForward, this);
    }
    applyFastForward() {
      this.emit(WheelScreenEvent.START_FAST_FORWARD, this, 4);
    }
    cancelFastForward() {
      this.emit(WheelScreenEvent.STOP_FAST_FORWARD, this);
    }
    hideCloseButton() {
      this.closeButton.disableInput();
      this.scene.tweens.add({
        targets: this.closeButton,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.closeButton.kill();
        }
      });
    }
    hideSpinButton() {
      this.spinButton.disableInput();
      this.scene.tweens.add({
        targets: this.spinButton,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.stopAnimatingSpinButton();
          this.spinButton.kill();
        }
      });
    }
    resize() {
      super.resize();
      this.alignSpinButton();
    }
    alignSpinButton() {
      let top = this.wheel.y + this.wheel.height / 2;
      let bottom = this.screenHeight;
      let height = bottom - top;
      this.spinButton.x = this.screenCenter.x;
      this.spinButton.y = top + height / 2 + 35;
    }
    show() {
      this.alpha = 1;
      this.wheel.reset();
      this.closeButton.alpha = 1;
      this.closeButton.enableInput();
      this.closeButton.revive();
      this.spinButton.alpha = 1;
      this.spinButton.enableInput();
      this.spinButton.revive();
      this.scene.audio.play(GameSoundKey.WHEEL_OPEN, {volume: 0.66});
      this.revive();
      this.showItems();
      this.startAnimatingSpinButton();
      this.emit(PhaserScreenEvent.SHOW, this);
    }
    showItems() {
      let items = [this.wheel, this.spinButton, this.closeButton];
      items.forEach((item) => {
        item.alpha = 0;
        item.scale = 0.8;
      });
      let delay = this.scene.tweens.stagger(100);
      this.scene.tweens.add({
        targets: items,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1,
        delay
      });
      this.scene.tweens.add({
        targets: items,
        duration: 1e3,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1,
        delay
      });
    }
    hide() {
      this.emit(PhaserScreenEvent.HIDE_START, this);
      this.scene.tweens.add({
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.onHideComplete();
        }
      });
    }
    hideInstant() {
      this.emit(PhaserScreenEvent.HIDE_START, this);
      this.onHideComplete();
    }
    onHideComplete() {
      this.kill();
      this.stopAnimatingSpinButton();
      this.emit(PhaserScreenEvent.HIDE_COMPLETE, this);
    }
    startAnimatingSpinButton() {
      this.animateSpinButtonEvent = this.scene.time.addEvent({
        repeat: -1,
        startAt: 2e3,
        delay: 3e3,
        callback: this.shakeSpinButton,
        callbackScope: this
      });
    }
    shakeSpinButton() {
      this.scene.tweens.add({
        targets: this.spinButton,
        duration: 266,
        ease: Phaser.Math.Easing.Sine.InOut,
        scaleX: 1.1,
        scaleY: 1.1,
        repeat: 2,
        yoyo: true
      });
    }
    stopAnimatingSpinButton() {
      var _a;
      (_a = this.animateSpinButtonEvent) == null ? void 0 : _a.remove();
      this.scene.tweens.killTweensOf(this.spinButton);
      this.spinButton.scale = 1;
    }
    preDestroy() {
      this.cancelFastForward();
      super.preDestroy();
    }
  };

  // src/scenes/levelMap/LevelMapAvatar.ts
  var LevelMapAvatarDirection;
  (function(LevelMapAvatarDirection2) {
    LevelMapAvatarDirection2[LevelMapAvatarDirection2["UP"] = 0] = "UP";
    LevelMapAvatarDirection2[LevelMapAvatarDirection2["DOWN"] = 1] = "DOWN";
  })(LevelMapAvatarDirection || (LevelMapAvatarDirection = {}));
  var LevelMapAvatar = class extends Phaser.GameObjects.Container {
    constructor(scene) {
      super(scene);
      this.originalScale = 1;
      this.wasInCamera = false;
      this.direction = 1;
      this.name = "avatar";
      this.addAvatar();
      this.addBorder();
      this.setSize(this.avatar.width, this.avatar.height);
      this.setInteractive();
      this.input.hitArea.y = this.avatar.y;
      this.input.cursor = "pointer";
    }
    enableInput() {
      this.input.enabled = true;
    }
    disableInput() {
      this.input.enabled = false;
    }
    addAvatar() {
      this.avatar = this.scene.add.image(0, 0, "level_map", "avatar");
      this.avatar.y = -74;
      this.add(this.avatar);
    }
    addBorder() {
      this.border = this.scene.add.image(0, 0, "level_map", "avatar_back");
      this.add(this.border);
    }
    lookUp() {
      if (this.direction === 0) {
        return;
      }
      this.border.angle = -180;
      this.avatar.y = 74;
      this.input.hitArea.y = this.avatar.y;
      this.direction = 0;
    }
    lookBottom() {
      if (this.direction === 1) {
        return;
      }
      this.border.angle = 0;
      this.avatar.y = -74;
      this.input.hitArea.y = this.avatar.y;
      this.direction = 1;
    }
    show() {
      var _a;
      this.alpha = 0;
      this.scale = 0.8;
      (_a = this.showTween) == null ? void 0 : _a.remove();
      this.showTween = this.scene.tweens.add({
        targets: this,
        alpha: {value: 1, duration: 150, ease: Phaser.Math.Easing.Cubic.Out},
        scale: {value: 1, duration: 400, ease: Phaser.Math.Easing.Back.Out}
      });
      return this.showTween;
    }
    hide() {
      this.kill();
    }
    startWiggle() {
      var _a;
      (_a = this.wiggleTween) == null ? void 0 : _a.remove();
      this.wiggleTween = this.scene.tweens.add({
        targets: this,
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: this.originalScale * 0.9,
        repeat: -1,
        yoyo: true
      });
    }
    stopWiggle() {
      var _a;
      (_a = this.wiggleTween) == null ? void 0 : _a.remove();
      this.wiggleTween = this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        scale: this.originalScale
      });
    }
    addParticles() {
      if (this.particles) {
        return;
      }
      this.particles = this.scene.add.particles("level_map");
      this.particles.x = this.avatar.x;
      this.particles.y = this.avatar.y;
      this.circlesEmitter = this.particles.createEmitter({
        frame: "circle_fx",
        scale: {start: 1, end: 2, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        lifespan: 2e3,
        frequency: 500,
        on: false
      });
      this.add(this.particles);
    }
    getOffsetY() {
      return -70;
    }
    budgeUp() {
      let dy = 20;
      let targetY = this.direction === 1 ? `-=${dy}` : `+=${dy}`;
      this.scene.tweens.add({
        targets: this.list,
        duration: 188,
        ease: Phaser.Math.Easing.Sine.InOut,
        y: targetY,
        yoyo: true
      });
    }
    showCircleFx() {
      if (!this.particles) {
        this.addParticles();
      }
      this.circlesEmitter.explode(1, 0, 0);
    }
    getGlobalCenter() {
      return this.avatar.getGlobalCenter();
    }
    moveBetweenLevelIcons(targetPosition) {
      let moveDuration = 600;
      let budgeDuration = 200;
      this.scene.tweens.add({
        delay: budgeDuration,
        targets: this,
        duration: moveDuration,
        ease: Phaser.Math.Easing.Quadratic.InOut,
        x: targetPosition.x,
        y: targetPosition.y
      });
      let deltaAngle = 15;
      let targetAngle = targetPosition.x > this.x ? -deltaAngle : deltaAngle;
      this.scene.tweens.add({
        targets: this,
        duration: budgeDuration,
        ease: Phaser.Math.Easing.Cubic.Out,
        angle: targetAngle,
        onComplete: () => {
          this.scene.tweens.add({
            targets: this,
            duration: moveDuration + 50,
            ease: Phaser.Math.Easing.Cubic.Out,
            angle: this.angle * -1,
            onComplete: () => {
              this.scene.tweens.add({
                targets: this,
                duration: 800,
                ease: Phaser.Math.Easing.Elastic.Out,
                easeParams: [0.1, 0.55],
                angle: 0
              });
            }
          });
        }
      });
    }
  };

  // src/scenes/levelMap/wheelReward/WheelRewardScreen.ts
  var WheelRewardScreen = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "wheel_reward_screen",
        backgroundKey: "rewards",
        backgroundFrame: "rewards/black_rect.png",
        backgroundAlpha: 0.85
      });
      this.addFlags();
      this.addParticles();
      this.addRewardButtons();
      this.addClaimRewardText();
    }
    addFlags() {
      this.leftFlags = this.scene.add.image(0, 0, "rewards", "rewards/flags_left.png");
      this.add(this.leftFlags);
      this.pin(this.leftFlags, 0, 0);
      this.rightFlags = this.scene.add.image(0, 0, "rewards", "rewards/flags_right.png");
      this.add(this.rightFlags);
      this.pin(this.rightFlags, 1, 0);
    }
    addParticles() {
      this.particles = this.scene.add.particles("rewards");
      this.pin(this.particles, 0.5, 0.5);
      this.add(this.particles);
      this.circlesEmitter = this.particles.createEmitter({
        frame: "rewards/particles/wheel_reward_circle.png",
        scale: {start: 0.4, end: 3, ease: Ease.ExpoOut},
        alpha: {start: 0.8, end: 0, ease: Ease.CubicOut},
        lifespan: 2e3,
        on: false
      });
      this.sparksEmitter = this.particles.createEmitter({
        frame: "rewards/particles/wheel_reward_spark.png",
        lifespan: 3e3,
        speed: {min: 10, max: 1200},
        alpha: {start: 1, end: 0, ease: Ease.ExpoOut},
        scale: {start: 1.33, end: 0},
        emitZone: {
          source: new Phaser.Geom.Circle(0, 0, 100),
          type: "random"
        },
        on: false
      });
      this.sparksEmitter.reserve(100);
    }
    addRewardButtons() {
      let options = {
        extraButtonText: this.scene.texts.rewards.x2,
        claimButtonText: this.scene.texts.rewards.decline
      };
      this.rewardButtons = new RewardButtons(this, options);
      this.rewardButtons.extraRewardButton.on(ButtonEvent.RELEASE, this.onDoubleRewardButtonClick, this);
      this.rewardButtons.claimButton.on(ButtonEvent.PRESS, this.onClaimButtonClick, this);
    }
    onDoubleRewardButtonClick() {
      this.scene.game.gdSdk.showRewardedAd("LevelMap:WheelReward:DoubleRewardButton").then((success) => {
        if (success) {
          this.onWheelRewardDoubled();
        }
      });
    }
    onWheelRewardDoubled() {
      this.rewardButtons.extraRewardButton.kill();
      this.rewardButtons.claimButton.kill();
      this.onRewardDoubled();
    }
    onClaimButtonClick() {
      this.scene.game.toasts.dismissAll();
      this.collectReward();
    }
    addClaimRewardText() {
      let content = this.scene.texts.stars_gift.claim_rewards;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "36px",
        color: "#ffffff",
        align: "center",
        stroke: "rgba(0,0,0,0.28)",
        strokeThickness: 10
      };
      this.claimRewardText = this.scene.add.text(0, 0, content, style);
      this.claimRewardText.setOrigin(0.5, 0.5);
      this.claimRewardText.setWordWrapWidth(Config.SOURCE_GAME_WIDTH * 0.8, true);
      this.claimRewardText.setLineSpacing(-8);
      this.claimRewardText.kill();
      this.add(this.claimRewardText);
      this.pin(this.claimRewardText, 0.5, 0.8);
    }
    resize() {
      super.resize();
      this.leftFlags.originalX = this.leftFlags.x;
      this.rightFlags.originalX = this.rightFlags.x;
      this.claimRewardText.originalY = this.claimRewardText.y;
    }
    alignReward() {
      if (!this.reward) {
        return;
      }
      this.reward.x = this.screenWidth / 2;
      this.reward.y = this.screenHeight * this.reward.originalY;
    }
    addReward(type, num = 1) {
      if (this.reward) {
        console.warn("Remove existing reward before adding new one!");
        return;
      }
      this.reward = new WheelReward(this.scene);
      this.reward.updateView(type, num);
      this.reward.originalY = 0.425;
      this.add(this.reward);
      this.alignReward();
    }
    show() {
      this.scene.audio.play(GameSoundKey.WHEEL_REWARD, {volume: 0.5});
      this.alpha = 1;
      this.background.alpha = this.options.backgroundAlpha;
      this.rewardButtons.reset();
      this.emit(PhaserScreenEvent.SHOW, this);
      this.revive();
      this.showFlags(300);
      this.showReward();
      this.showParticles();
      if (window.game.config.ads.rewarded) {
        this.rewardButtons.show(800);
        this.moveRewardUp(800);
      } else {
        this.rewardButtons.extraRewardButton.kill();
        this.rewardButtons.claimButton.kill();
        this.showClaimRewardText(800);
        this.scene.time.delayedCall(800, () => {
          this.background.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.collectReward, this);
        });
      }
    }
    showFlags(delay) {
      this.leftFlags.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.leftFlags,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.leftFlags.scale = 0.75;
      this.scene.tweens.add({
        delay,
        targets: this.leftFlags,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1
      });
      this.rightFlags.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.rightFlags,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.rightFlags.scale = 0.75;
      this.scene.tweens.add({
        delay,
        targets: this.rightFlags,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1
      });
      let dx = 60;
      let dy = 50;
      this.leftFlags.x = this.leftFlags.originalX - dx;
      this.scene.tweens.add({
        delay,
        targets: this.leftFlags,
        duration: 800,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.55],
        x: this.leftFlags.originalX
      });
      this.rightFlags.x = this.rightFlags.originalX + dx;
      this.scene.tweens.add({
        delay,
        targets: this.rightFlags,
        duration: 800,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.55],
        x: this.rightFlags.originalX
      });
      this.leftFlags.y = -dy;
      this.rightFlags.y = -dy;
      this.scene.tweens.add({
        delay,
        targets: [this.leftFlags, this.rightFlags],
        duration: 900,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.55],
        y: 0
      });
    }
    showReward() {
      if (!this.reward) {
        return;
      }
      this.reward.alpha = 0;
      this.scene.tweens.add({
        targets: this.reward,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.reward.scale = 0.5;
      this.scene.tweens.add({
        targets: this.reward,
        duration: 800,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.5],
        scale: 1,
        onComplete: () => {
          var _a;
          (_a = this.reward) == null ? void 0 : _a.startFloat(0);
        }
      });
      this.reward.showText(300);
    }
    showParticles() {
      this.particles.setPosition(this.reward.x, this.reward.y);
      this.circlesEmitter.emitParticle(1, 0, -6);
      this.sparksEmitter.emitParticle(100);
    }
    moveRewardUp(delay) {
      this.scene.tweens.add({
        delay,
        targets: this.reward,
        duration: 400,
        ease: Phaser.Math.Easing.Quadratic.InOut,
        y: "-=60"
      });
    }
    onRewardDoubled() {
      this.scene.audio.play(GameSoundKey.WHEEL_REWARD, {volume: 0.5});
      this.showParticles();
      this.doubleReward();
      this.showClaimRewardText(600);
      this.background.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.collectReward, this);
    }
    doubleReward() {
      this.reward.stopFloat();
      this.reward.setRewardNum(this.reward.rewardNum * 2);
      this.reward.showTextDoubled(300);
      this.reward.alpha = 0;
      this.scene.tweens.add({
        targets: this.reward,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.reward.scale = 0.3;
      this.scene.tweens.add({
        targets: this.reward,
        duration: 900,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1,
        onComplete: () => {
          var _a;
          (_a = this.reward) == null ? void 0 : _a.startFloat();
        }
      });
    }
    showClaimRewardText(delay) {
      this.claimRewardText.revive();
      this.claimRewardText.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.claimRewardText,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.claimRewardText.y = this.claimRewardText.originalY + 20;
      this.scene.tweens.add({
        delay,
        targets: this.claimRewardText,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        y: this.claimRewardText.originalY
      });
      this.scene.tweens.add({
        delay,
        targets: this.claimRewardText,
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.1,
        yoyo: true,
        repeat: -1
      });
    }
    collectReward() {
      this.scene.audio.play(GameSoundKey.FANCY_TAP);
      this.emit(WheelRewardEvent.COLLECT_START, this);
      this.rewardButtons.hide();
      this.hideFlags();
      this.hideClaimRewardsText();
      this.doCollectReward();
    }
    hideFlags() {
      this.scene.tweens.add({
        targets: this.leftFlags,
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.Out,
        x: "-=60",
        alpha: 0
      });
      this.scene.tweens.add({
        targets: this.rightFlags,
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.Out,
        x: "+=60",
        alpha: 0
      });
    }
    hideClaimRewardsText() {
      this.scene.tweens.killTweensOf(this.claimRewardText);
      this.scene.tweens.add({
        targets: this.claimRewardText,
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.Out,
        y: "+=30",
        alpha: 0,
        onComplete: () => {
          this.claimRewardText.kill();
        }
      });
    }
    doCollectReward() {
      this.reward.hideTextAndRays();
      this.reward.stopFloat();
      this.scene.tweens.add({
        targets: this.reward,
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        y: "-=30",
        onComplete: () => {
          this.emit(WheelRewardEvent.COLLECT_COMPLETE, this.reward);
          this.reward.destroy();
          this.reward = null;
          this.hide();
        }
      });
    }
    hide() {
      this.emit(PhaserScreenEvent.HIDE_START, this);
      this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.kill();
          this.emit(PhaserScreenEvent.HIDE_COMPLETE, this);
        }
      });
    }
    onLanguageChange() {
      this.rewardButtons.extraRewardButton.text.text = this.scene.texts.rewards.x2;
      this.rewardButtons.claimButton.text.text = this.scene.texts.rewards.decline;
      this.claimRewardText.text = this.scene.texts.stars_gift.claim_rewards;
    }
  };

  // src/scenes/levelMap/gift/GiftScreen.ts
  var GiftScreenEvent;
  (function(GiftScreenEvent2) {
    GiftScreenEvent2["ALL_REWARDS_COLLECTED"] = "__ALL_REWARDS_COLLECTED";
  })(GiftScreenEvent || (GiftScreenEvent = {}));
  var GiftScreen = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "gift_screen",
        backgroundKey: "rewards",
        backgroundFrame: "rewards/black_rect.png",
        backgroundAlpha: 0.85
      });
      this.autoPlay = false;
      this.addRewards();
      this.addGift();
      this.addRewardButtons();
      this.addClaimRewardsText();
    }
    addRewards() {
      let rewardsData = this.scene.game.gifts.getGiftRewards(3);
      this.rewards = rewardsData.map((data) => {
        let reward = new GiftReward(this.scene, data.type, data.num);
        reward.kill();
        this.add(reward);
        return reward;
      });
    }
    addGift() {
      this.gift = new Gift(this.scene);
      this.add(this.gift);
      this.pin(this.gift, 0.5, 0.62);
    }
    addRewardButtons() {
      let options = {
        extraButtonText: this.scene.texts.rewards.bonus,
        claimButtonText: this.scene.texts.rewards.decline
      };
      this.rewardButtons = new RewardButtons(this, options);
    }
    addClaimRewardsText() {
      let content = this.scene.texts.stars_gift.claim_rewards;
      let style = this.getHintTextStyle();
      this.claimRewardsText = this.scene.add.text(0, 0, content, style);
      this.claimRewardsText.setWordWrapWidth(Config.SOURCE_GAME_WIDTH * 0.75, true);
      this.claimRewardsText.setLineSpacing(-8);
      this.claimRewardsText.setOrigin(0.5, 0.5);
      this.claimRewardsText.kill();
      this.claimRewardsText.originalY = this.claimRewardsText.y;
      this.pin(this.claimRewardsText, 0.5, 0.87);
      this.add(this.claimRewardsText);
    }
    getHintTextStyle() {
      return {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "36px",
        color: "#ffffff",
        align: "center",
        stroke: "rgba(0,0,0,0.28)",
        strokeThickness: 10
      };
    }
    resize() {
      super.resize();
      this.alignRewards();
      this.alignHintTexts();
    }
    alignRewards() {
      let centerX = this.screenWidth / 2;
      let centerY = this.screenHeight * 0.3;
      let dx = 230;
      let dy = 50;
      this.rewards[0].x = centerX - dx;
      this.rewards[0].y = centerY + dy;
      this.rewards[1].x = centerX;
      this.rewards[1].y = centerY;
      this.rewards[2].x = centerX + dx;
      this.rewards[2].y = centerY + dy;
    }
    alignHintTexts() {
      let top = this.gift.y;
      let bottom = this.screenHeight;
      let height = bottom - top;
      let y = top + height / 2;
      this.claimRewardsText.x = this.screenWidth / 2;
      this.claimRewardsText.y = y;
    }
    show() {
      this.emit(PhaserScreenEvent.SHOW, this);
      this.revive();
      this.showBackground();
      this.showGift(200);
      if (this.autoPlay) {
        this.scene.time.delayedCall(400, () => this.openGift());
      } else {
        this.background.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.openGift, this);
      }
    }
    showGift(delay) {
      this.gift.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.gift,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.gift.scale = 0.66;
      this.scene.tweens.add({
        delay,
        targets: this.gift,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1,
        onStart: () => {
          this.gift.show();
        }
      });
    }
    openGift() {
      this.scene.audio.playClick();
      this.gift.once(LevelCompleteGiftEvent.EXPLODE_COMPLETE, this.onGiftExplodeComplete, this);
      this.gift.explode();
    }
    onGiftExplodeComplete() {
      this.scene.time.delayedCall(1500, () => {
        this.gift.kill();
      });
      this.showRewards(0);
      if (window.game.config.ads.rewarded) {
        this.rewardButtons.show(400);
        this.rewardButtons.extraRewardButton.once(ButtonEvent.RELEASE, this.showBonusRewardVideo, this);
        this.rewardButtons.claimButton.once(ButtonEvent.PRESS, this.claimRewards, this);
      } else {
        this.showClaimRewardText(0);
        this.background.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.claimRewards, this);
      }
    }
    showRewards(initialDelay) {
      this.rewards.forEach((reward, index) => {
        let delay = initialDelay + index * 100;
        let originalX = reward.x;
        let originalY = reward.y;
        reward.revive();
        reward.startFloat(delay);
        reward.alpha = 0;
        this.scene.tweens.add({
          targets: reward,
          duration: 150,
          ease: Phaser.Math.Easing.Cubic.Out,
          alpha: 1,
          onComplete: () => {
            reward.showParticles();
          }
        });
        reward.scale = 0.66;
        this.scene.tweens.add({
          targets: reward,
          duration: 800,
          ease: Phaser.Math.Easing.Elastic.Out,
          easeParams: [0.1, 0.5],
          scale: 1
        });
        reward.x = this.gift.x;
        reward.y = this.gift.y;
        this.scene.tweens.add({
          targets: reward,
          duration: 1e3,
          ease: Phaser.Math.Easing.Elastic.Out,
          easeParams: [0.1, 0.55],
          x: originalX,
          y: originalY
        });
      });
    }
    showClaimRewardText(delay) {
      this.claimRewardsText.revive();
      this.claimRewardsText.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.claimRewardsText,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.claimRewardsText.y = this.claimRewardsText.originalY + 30;
      this.scene.tweens.add({
        delay,
        targets: this.claimRewardsText,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        y: this.claimRewardsText.originalY
      });
      this.scene.tweens.add({
        delay,
        targets: this.claimRewardsText,
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.1,
        yoyo: true,
        repeat: -1
      });
    }
    showBonusRewardVideo() {
      this.scene.game.gdSdk.showRewardedAd("LevelMap:GiftScreen:BonusButton").then((success) => {
        if (!success) {
          return;
        }
        this.rewardButtons.hide();
        this.addBonusReward(200);
        this.showClaimRewardText(500);
        this.background.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.claimRewards, this);
        this.scene.audio.play(GameSoundKey.WHEEL_REWARD, {volume: 0.5});
      });
    }
    addBonusReward(delay) {
      let rewardType = this.getBonusRewardType();
      let rewardNum = this.getBonusRewardsNum(rewardType);
      let bonusReward = new GiftReward(this.scene, rewardType, rewardNum);
      bonusReward.x = this.screenWidth / 2;
      bonusReward.y = this.rewards[1].y + 270;
      this.add(bonusReward);
      this.rewards.push(bonusReward);
      bonusReward.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: bonusReward,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1,
        onComplete: () => {
          bonusReward.startFloat(0);
          bonusReward.showParticles();
        }
      });
      bonusReward.scale = 0.5;
      this.scene.tweens.add({
        delay,
        targets: bonusReward,
        duration: 800,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
      let originalY = bonusReward.y;
      bonusReward.y = originalY + 50;
      this.scene.tweens.add({
        delay,
        targets: bonusReward,
        duration: 900,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.55],
        y: originalY
      });
    }
    getBonusRewardType() {
      let allTypes = WheelRewardUtils.getAllTypes();
      let existingTypes = this.rewards.map((reward) => reward.rewardType);
      let remainingTypes = without_default(allTypes, ...existingTypes);
      return Phaser.Math.RND.pick(remainingTypes);
    }
    getBonusRewardsNum(rewardType) {
      var _a;
      return (_a = window.game.config.video_rewards[rewardType]) != null ? _a : 1;
    }
    claimRewards() {
      this.rewardButtons.hide();
      this.hideClaimRewardsText();
      this.collectRewards();
      this.scene.game.toasts.dismissAll();
      this.scene.audio.play(GameSoundKey.FANCY_TAP);
      this.scene.time.delayedCall(300, () => {
        this.hide();
      });
    }
    hideClaimRewardsText() {
      this.scene.tweens.killTweensOf(this.claimRewardsText);
      this.scene.tweens.add({
        targets: this.claimRewardsText,
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        y: "+=30",
        onComplete: () => {
          this.claimRewardsText.kill();
        }
      });
    }
    collectRewards() {
      this.scene.tweens.add({
        targets: this.rewards,
        duration: 300,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        y: "-=30"
      });
    }
    hide() {
      this.emitHideStartEvent();
      this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.emitRewardsCollectedEvent();
          this.emitHideCompleteEvent();
          this.destroy();
        }
      });
    }
    emitRewardsCollectedEvent() {
      let rewardsData = this.rewards.map((reward) => ({
        type: reward.rewardType,
        num: reward.rewardNum
      }));
      this.emit(GiftScreenEvent.ALL_REWARDS_COLLECTED, rewardsData);
    }
  };

  // src/scenes/levelMap/buttons/LevelMapButton.ts
  var LevelMapButton = class extends ComplexButton {
    constructor(scene, atlas, frame, parent) {
      super(scene, atlas, frame, parent);
      this.addBitmapText("0000", BitmapFont.LEVEL_MAP_BOTTOM_LABELS, 24);
      this.bitmapText.setLetterSpacing(1);
    }
  };

  // src/scenes/levelMap/buttons/GiftButton.ts
  var GiftButton = class extends LevelMapButton {
    constructor(scene) {
      super(scene, "level_map", "button_gift");
      this.name = "button_gift";
      this.store = this.scene.game.store;
      this.giftsManager = this.scene.game.gifts;
      this.currentStars = this.giftsManager.getCurrentStars();
      this.targetStars = this.giftsManager.getTargetStars();
      this.back.y = 32;
      this.doAddIcon();
      this.addParticles();
      this.setupText();
      if (this.currentStars >= this.targetStars) {
        this.onTargetStarsNumReached();
      }
    }
    doAddIcon() {
      this.addIcon("level_map", "button_gift_star", 0, 18);
      this.icon.originalX = this.icon.x;
      this.icon.originalY = this.icon.y;
    }
    addParticles() {
      this.circlesManager = this.scene.add.particles("level_map");
      this.circlesManager.setPosition(0, -10);
      this.addAt(this.circlesManager, 0);
      this.circles = this.circlesManager.createEmitter({
        frame: "particles/circle_fx_2",
        scale: {start: 0.5, end: 2, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.CubicOut},
        lifespan: 1600,
        on: false
      });
      this.sparksManager = this.scene.add.particles("level_map");
      this.add(this.sparksManager);
      this.sparks = this.sparksManager.createEmitter({
        speed: 30,
        frame: "particles/star_1",
        lifespan: {min: 800, max: 1400},
        rotate: {start: 0, end: 180, random: true},
        angle: -90,
        scale: {start: 1, end: 0, ease: Ease.ExpoIn},
        alpha: {start: 0, end: 1, ease: Ease.ExpoOut},
        frequency: 300,
        on: false
      });
      this.sparks.setEmitZone({
        source: new Phaser.Geom.Circle(0, 0, this.back.displayWidth * 0.4),
        type: "random",
        quantity: 360
      });
    }
    setupText() {
      this.updateTextContent();
      this.bitmapText.x = -2;
      this.bitmapText.y = 52;
      this.bitmapText.originalX = this.bitmapText.x;
      this.bitmapText.originalY = this.bitmapText.y;
      this.bringToTop(this.bitmapText);
    }
    updateTextContent() {
      this.bitmapText.text = `${this.currentStars}/${this.targetStars}`;
    }
    isGiftReady() {
      return this.currentStars >= this.targetStars;
    }
    onStarArrived() {
      var _a;
      this.circles.emitParticle(1);
      this.bitmapText.scale = 1;
      this.scene.tweens.killTweensOf(this.bitmapText);
      this.scene.tweens.add({
        targets: this.bitmapText,
        duration: 233,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.2,
        yoyo: true
      });
      this.icon.y = this.icon.originalY;
      this.icon.scale = 1;
      this.scene.tweens.killTweensOf(this.icon);
      this.scene.tweens.add({
        targets: this.icon,
        duration: 233,
        ease: Phaser.Math.Easing.Sine.InOut,
        scale: 1.2,
        y: this.icon.originalY - 14,
        yoyo: true
      });
      if ((_a = this.squeezeTween) == null ? void 0 : _a.isPlaying()) {
        return;
      }
      this.back.scaleX = 1;
      this.back.scaleY = 1;
      this.scene.tweens.killTweensOf(this.back);
      this.scene.tweens.add({
        targets: this.back,
        duration: 233,
        ease: Phaser.Math.Easing.Sine.InOut,
        scaleX: 0.9,
        scaleY: 1.1,
        yoyo: true
      });
    }
    incrementStarsNum() {
      this.currentStars++;
      this.updateTextContent();
      this.store.saveValue(GameStoreKey.GIFT_STARS_NUM, this.currentStars);
      if (this.currentStars === this.targetStars) {
        this.scene.tweens.add({
          targets: this.back,
          duration: 233,
          ease: Phaser.Math.Easing.Sine.InOut,
          y: "-=18",
          yoyo: true
        });
        this.onTargetStarsNumReached();
      }
    }
    onTargetStarsNumReached() {
      this.bitmapText.kill();
      this.icon.kill();
      this.sparks.on = true;
      this.playSqueezeTween();
    }
    playSqueezeTween() {
      this.back.scaleX = 1;
      this.back.scaleY = 1;
      this.scene.tweens.killTweensByProperty(this.back, "scaleX", "scaleY");
      this.squeezeTween = this.scene.tweens.add({
        targets: this.back,
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        scaleX: 1.06,
        scaleY: 0.94,
        yoyo: true,
        repeat: -1
      });
    }
    stopSqueezeTween() {
      var _a;
      (_a = this.squeezeTween) == null ? void 0 : _a.remove();
      this.squeezeTween = null;
      this.scene.tweens.add({
        targets: this.back,
        duration: 150,
        ease: Phaser.Math.Easing.Linear,
        scaleX: 1,
        scaleY: 1
      });
    }
    onGiftRewardClaimed() {
      this.giftsManager.onGiftOpen();
      this.currentStars = this.giftsManager.getCurrentStars();
      this.targetStars = this.giftsManager.getTargetStars();
      if (this.isGiftReady() === false) {
        this.bitmapText.revive();
        this.icon.revive();
        this.sparks.on = false;
        this.updateTextContent();
        this.stopSqueezeTween();
      }
    }
    shakeText() {
      this.bitmapText.x = this.bitmapText.originalX;
      this.scene.tweens.killTweensByProperty(this.bitmapText, "x");
      this.scene.tweens.add({
        targets: this.bitmapText,
        duration: 44,
        ease: Phaser.Math.Easing.Sine.InOut,
        x: this.bitmapText.x + Phaser.Math.RND.sign() * 8,
        yoyo: true,
        repeat: 3
      });
    }
  };

  // src/scenes/levelMap/buttons/WheelButton.ts
  var WheelButtonState;
  (function(WheelButtonState2) {
    WheelButtonState2["LOCKED"] = "LOCKED";
    WheelButtonState2["DISABLED"] = "DISABLED";
    WheelButtonState2["ENABLED"] = "ENABLED";
  })(WheelButtonState || (WheelButtonState = {}));
  var WheelButton = class extends LevelMapButton {
    constructor(scene) {
      super(scene, "level_map", "button_wheel");
      this.name = "button_wheel";
      this.store = this.scene.game.store;
      this.addCircles();
      this.setupBitmapText();
      this.setInitialState();
    }
    addCircles() {
      this.circlesManager = this.scene.add.particles("level_map");
      this.circlesManager.setPosition(0, -10);
      this.addAt(this.circlesManager, 0);
      this.circles = this.circlesManager.createEmitter({
        frame: "particles/circle_fx_2",
        scale: {start: 0.5, end: 1.6, ease: Ease.ExpoOut},
        alpha: {start: 1, end: 0, ease: Ease.CubicOut},
        lifespan: 1800,
        on: false
      });
    }
    setupBitmapText() {
      this.bitmapText.x = -2;
      this.bitmapText.y = 50;
      this.bitmapText.originalX = this.bitmapText.x;
      this.bitmapText.originalY = this.bitmapText.y;
      this.bitmapText.updateTimer = 0;
    }
    setInitialState() {
      let unlockLevel = window.game.config.wheel_unlock_level - 1;
      let isLevelComplete = !!this.scene.game.store.getLevelResult(unlockLevel);
      if (isLevelComplete === false) {
        this.setLockedState();
        return;
      }
      let isWheelLocked = this.store.getBoolean(GameStoreKey.WHEEL_LOCKED);
      let isTimeToUnlock = Date.now() > this.store.getNumber(GameStoreKey.WHEEL_RESET_TIMESTAMP);
      if (isWheelLocked && isTimeToUnlock === false) {
        this.setDisabledState();
      } else {
        this.setEnabledState();
      }
    }
    setLockedState() {
      this.buttonState = WheelButtonState.LOCKED;
      this.bitmapText.kill();
      this.back.alpha = 0.75;
    }
    setDisabledState() {
      var _a;
      this.buttonState = WheelButtonState.DISABLED;
      this.bitmapText.revive();
      this.bitmapText.updateTimer = 1e3;
      this.back.alpha = 1;
      this.back.scaleX = 1;
      this.back.scaleY = 1;
      (_a = this.backTween) == null ? void 0 : _a.remove();
    }
    setEnabledState() {
      this.buttonState = WheelButtonState.ENABLED;
      this.bitmapText.kill();
      this.back.alpha = 1;
      this.backTween = this.scene.tweens.add({
        targets: this.back,
        duration: 600,
        ease: Phaser.Math.Easing.Sine.InOut,
        scaleX: 1.07,
        scaleY: 0.93,
        yoyo: true,
        repeat: -1
      });
    }
    shakeTimer() {
      this.bitmapText.x = this.bitmapText.originalX;
      this.scene.tweens.killTweensByProperty(this.bitmapText, "x");
      this.scene.tweens.add({
        targets: this.bitmapText,
        duration: 44,
        ease: Phaser.Math.Easing.Sine.InOut,
        x: this.bitmapText.x + Phaser.Math.RND.sign() * 8,
        yoyo: true,
        repeat: 3
      });
    }
    showTimer() {
      this.bitmapText.alpha = 0;
      this.scene.tweens.add({
        targets: this.bitmapText,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.bitmapText.scale = 0.66;
      this.scene.tweens.add({
        targets: this.bitmapText,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1
      });
    }
    preUpdate(time, delta) {
      if (this.buttonState === WheelButtonState.DISABLED) {
        this.updateDisabledTimer(delta);
      }
    }
    updateDisabledTimer(delta) {
      let resetTimestamp = this.store.getNumber(GameStoreKey.WHEEL_RESET_TIMESTAMP);
      let timeLeftMs = resetTimestamp - Date.now();
      if (timeLeftMs <= 1e3) {
        this.store.saveValue(GameStoreKey.WHEEL_LOCKED, false);
        this.circles.emitParticle(1);
        this.setEnabledState();
      } else {
        this.bitmapText.updateTimer += delta;
        if (this.bitmapText.updateTimer >= 1e3) {
          this.bitmapText.updateTimer -= 1e3;
          this.doUpdateDisabledTimer(timeLeftMs);
        }
      }
    }
    doUpdateDisabledTimer(ms) {
      let hours = Math.floor(ms / 36e5);
      let minutes = Math.floor(ms % 36e5 / 6e4);
      let seconds = Math.floor(ms % 36e4 % 6e4 / 1e3);
      let hoursStr = hours.toString().padStart(2, "0");
      let minutesStr = minutes.toString().padStart(2, "0");
      let secondsStr = seconds.toString().padStart(2, "0");
      if (hours > 0) {
        this.bitmapText.text = `${hoursStr}:${minutesStr}:${secondsStr}`;
      } else {
        this.bitmapText.text = `${minutesStr}:${secondsStr}`;
      }
    }
  };

  // src/scenes/levelMap/LevelMapScrollManager.ts
  var LevelMapScrollManager = class extends Phaser.Events.EventEmitter {
    constructor(scene) {
      super();
      this.scene = scene;
      this.addKinecticScroll();
    }
    addKinecticScroll() {
      this.kineticScroll = new KineticScroll(this.scene, {
        camera: this.scene.firstCamera,
        timeConstantScroll: 300,
        horizontalScroll: false,
        verticalScroll: true,
        verticalWheel: true,
        wheelScrollAmount: 50
      });
      this.kineticScroll.onPointerDown = this.onPointerDown.bind(this);
      this.kineticScroll.addPointerListeners();
    }
    onPointerDown(pointer, objects) {
      let clickOnLevelIcons = objects.every((item) => item instanceof LevelIcon);
      if (clickOnLevelIcons === false) {
        return;
      }
      this.kineticScroll.beginMove(pointer);
    }
    onResize() {
      let zoom = this.scene.firstCamera.zoom;
      this.kineticScroll.settings.scrollMultiplier = 1 / zoom * 1.33;
    }
    update(delta) {
      this.kineticScroll.update();
    }
    enable() {
      if (this.scene.isLocked) {
        return;
      }
      this.kineticScroll.settings.verticalWheel = true;
      this.kineticScroll.addPointerListeners();
    }
    disable() {
      this.kineticScroll.settings.verticalWheel = false;
      this.kineticScroll.removePointerListeners();
    }
    scrollToBottom() {
      var _a;
      (_a = this.cameraScrollTween) == null ? void 0 : _a.remove();
      this.kineticScroll.resetScroll();
      this.scene.firstCamera.scrollY = this.scene.firstCamera.getBounds().bottom;
    }
    scrollToTop() {
      var _a;
      (_a = this.cameraScrollTween) == null ? void 0 : _a.remove();
      this.kineticScroll.resetScroll();
      this.scene.firstCamera.scrollY = 0;
    }
    scrollToLevel(levelNumber) {
      if (this.cameraScrollTween) {
        return;
      }
      let scrollY = this.getCameraScrollByLevelNumber(levelNumber);
      if (scrollY === null) {
        return;
      }
      this.kineticScroll.resetScroll();
      this.cameraScrollTween = this.scene.tweens.add({
        targets: this.scene.firstCamera,
        duration: 500,
        ease: Phaser.Math.Easing.Quadratic.InOut,
        scrollY,
        onComplete: () => {
          this.cameraScrollTween = null;
        }
      });
    }
    scrollTo(y) {
      this.kineticScroll.resetScroll();
      this.cameraScrollTween = this.scene.tweens.add({
        targets: this.scene.firstCamera,
        duration: 500,
        ease: Phaser.Math.Easing.Quadratic.InOut,
        scrollY: y,
        onComplete: () => {
          this.cameraScrollTween = null;
        }
      });
    }
    scrollToLevelInstant(levelNumber) {
      let scrollY = this.getCameraScrollByLevelNumber(levelNumber);
      if (scrollY === null) {
        return;
      }
      this.scene.firstCamera.scrollY = scrollY;
    }
    getCameraScrollByLevelNumber(levelNumber) {
      let levelIcon = this.scene.levelIcons.getByLevelNumber(levelNumber);
      if (!levelIcon) {
        return null;
      }
      return this.getCameraScroll(Phaser.Display.Bounds.GetCenterY(levelIcon));
    }
    getCameraScroll(y) {
      return y - this.scene.firstCamera.displayHeight / 2;
    }
  };

  // src/scenes/levelMap/LevelMapDepth.ts
  var LevelMapDepth;
  (function(LevelMapDepth2) {
    LevelMapDepth2[LevelMapDepth2["BACKGROUND"] = 0] = "BACKGROUND";
    LevelMapDepth2[LevelMapDepth2["LEVEL_ICONS"] = 1] = "LEVEL_ICONS";
    LevelMapDepth2[LevelMapDepth2["LEVEL_ICONS_FX"] = 2] = "LEVEL_ICONS_FX";
    LevelMapDepth2[LevelMapDepth2["LEVEL_ICONS_FX_PARTICLES"] = 3] = "LEVEL_ICONS_FX_PARTICLES";
    LevelMapDepth2[LevelMapDepth2["LEVEL_ICONS_SNEAK_PEEKS"] = 4] = "LEVEL_ICONS_SNEAK_PEEKS";
    LevelMapDepth2[LevelMapDepth2["CLOUDS"] = 5] = "CLOUDS";
    LevelMapDepth2[LevelMapDepth2["LEVEL_ICON_AVATAR"] = 6] = "LEVEL_ICON_AVATAR";
    LevelMapDepth2[LevelMapDepth2["LEVEL_ICON_TUTORIAL_HAND"] = 7] = "LEVEL_ICON_TUTORIAL_HAND";
    LevelMapDepth2[LevelMapDepth2["EDGE_AVATAR"] = 8] = "EDGE_AVATAR";
  })(LevelMapDepth || (LevelMapDepth = {}));

  // src/scenes/levelMap/LevelIconsManager.ts
  var LevelIconsManager = class extends Phaser.Events.EventEmitter {
    constructor(scene, config2) {
      super();
      this.scene = scene;
      this.addIcons(config2);
      this.lastCompleteIcon = this.getLastCompleteIcon();
      this.lastUnlockedIcon = this.getLastUnlockedLevelIcon();
    }
    addIcons(config2) {
      this.levelIcons = config2.levelIcons.map((config3) => {
        let levelNumber = config3.level_number;
        let levelConfig = this.scene.game.levelConfigs.get(levelNumber);
        let isHard = levelConfig && levelConfig.hard;
        let data = this.getLevelIconData(levelNumber, isHard);
        let icon = new LevelIcon(this.scene, data);
        icon.x = config3.x;
        icon.y = config3.y;
        icon.setData("type", "LevelIcon");
        icon.setDepth(LevelMapDepth.LEVEL_ICONS);
        if (!levelConfig) {
          icon.alpha = 0.5;
        }
        this.scene.add.existing(icon);
        return icon;
      });
    }
    getLevelIconData(levelNumber, isHard) {
      let levelResult = this.scene.game.store.getLevelResult(levelNumber);
      if (levelResult) {
        return {
          levelNumber,
          isHard,
          complete: levelResult.complete,
          locked: false
        };
      }
      return {
        levelNumber,
        isHard,
        complete: false,
        locked: this.isLevelLocked(levelNumber)
      };
    }
    isLevelLocked(levelNumber) {
      if (levelNumber === 1) {
        return false;
      }
      let prevLevelNumber = levelNumber - 1;
      let prevLevelResult = this.scene.game.store.getLevelResult(prevLevelNumber);
      return !(prevLevelResult && prevLevelResult.complete);
    }
    getLastUnlockedLevelIcon() {
      let unlockedLevelIcons = this.levelIcons.filter((icon) => icon.iconState === LevelIconState.UNLOCKED);
      return maxBy_default(unlockedLevelIcons, "levelNumber");
    }
    getLastCompleteIcon() {
      let completeLevelIcons = this.levelIcons.filter((icon) => icon.iconState === LevelIconState.COMPLETE);
      return maxBy_default(completeLevelIcons, "levelNumber");
    }
    getCurrentIcon() {
      return this.getLastUnlockedLevelIcon() || this.getLastCompleteIcon() || this.levelIcons[0];
    }
    getByLevelNumber(levelNumber) {
      return this.levelIcons.find((icon) => icon.levelNumber === levelNumber);
    }
    disable() {
      this.levelIcons.forEach((icon) => icon.disableInteractive());
    }
    enable() {
      this.levelIcons.filter((icon) => icon.iconState !== LevelIconState.LOCKED).forEach((icon) => icon.setInteractive());
    }
    unlockAll() {
      this.levelIcons.forEach((icon) => {
        if (icon.iconState === LevelIconState.LOCKED) {
          icon.setUnlocked();
        }
      });
    }
    resetToInitialState() {
      this.levelIcons.forEach((icon) => {
        icon.setInitialState();
      });
    }
    findAndScrollToLevelIcon() {
      let existingLevels = this.levelIcons.map((icon) => icon.levelNumber);
      let min = Math.min(...existingLevels);
      let max = Math.max(...existingLevels);
      let levelNumberStr = prompt(`Enter level number (between ${min} and ${max})`);
      if (levelNumberStr === null) {
        return;
      }
      let levelNumber = parseInt(levelNumberStr);
      if (isNaN(levelNumber)) {
        console.warn("Invalid level number!", levelNumberStr);
        return;
      }
      let isLevelExist = existingLevels.includes(levelNumber);
      if (isLevelExist === false) {
        console.warn(`Level ${levelNumber} doesn't exist!`);
        return;
      }
      this.scene.scroll.scrollToLevelInstant(levelNumber);
    }
  };

  // src/scenes/levelMap/UnlockLevelIconFx.ts
  var UnlockLevelIconFx = class extends Phaser.GameObjects.Container {
    constructor(scene, originalIcon) {
      super(scene);
      this.name = "unlock_level_icon";
      this.originalIcon = originalIcon;
      this.addLockedIcon();
      this.addWhite();
      this.addParticles();
    }
    addLockedIcon() {
      this.locked = this.scene.add.image(0, 0, "level_map", "level_icons/level_icon_locked");
      this.add(this.locked);
    }
    addParticles() {
      this.particles = this.scene.add.particles("level_map");
      this.particles.setDepth(LevelMapDepth.LEVEL_ICONS_FX_PARTICLES);
      this.attractCircles = this.particles.createEmitter({
        frame: "particles/circle_fx_3",
        alpha: {start: 0, end: 0.4, ease: Ease.ExpoOut},
        scale: {start: 2.2, end: 0.33, ease: Ease.Linear},
        lifespan: 600,
        frequency: 333,
        on: false
      });
      this.explodeSparks = this.particles.createEmitter(__spreadProps(__spreadValues({}, ParticleUtil.getCircleEdgeEmitZone(40, 30)), {
        frame: "particles/double_spheres_particle",
        lifespan: 600,
        speed: {min: 150, max: 250},
        scale: {start: 1, end: 0},
        alpha: {start: 1, end: 0, ease: Ease.ExpoIn},
        on: false
      }));
      this.explodeCircles = this.particles.createEmitter({
        frame: "particles/circle_fx_3",
        alpha: {start: 1, end: 0, ease: Ease.CubicOut},
        scale: {start: 0.4, end: 6, ease: Ease.Linear},
        lifespan: 1200,
        on: false
      });
    }
    addWhite() {
      this.white = this.scene.add.image(0, 0, "level_map", "level_icons/level_icon_white");
      this.add(this.white);
    }
    show(initialDelay) {
      let originalX = this.x;
      let squeezeDuration = 1e3;
      this.scene.time.delayedCall(initialDelay + 50, () => {
        var _a;
        (_a = this.scene.audio.play(GameSoundKey.LEVEL_ICON_UNLOCK)) == null ? void 0 : _a.fade(0, 0.75, squeezeDuration);
        this.attractCircles.flow(150, 1);
      });
      this.fadeInWhite(initialDelay, squeezeDuration);
      this.playShakeTween(initialDelay);
      this.playShrinkTween(initialDelay, squeezeDuration, originalX);
    }
    fadeInWhite(initialDelay, duration) {
      this.white.alpha = 0;
      this.scene.tweens.add({
        delay: initialDelay,
        targets: this.white,
        duration,
        ease: Phaser.Math.Easing.Linear,
        alpha: 1
      });
    }
    playShakeTween(initialDelay) {
      this.shakeTween = this.scene.tweens.addYoyoTween({
        delay: initialDelay,
        target: this,
        duration: 16,
        property: "x",
        base: this.x,
        delta: 4,
        repeat: -1
      });
    }
    playShrinkTween(initialDelay, duration, originalX) {
      this.scene.tweens.add({
        delay: initialDelay,
        targets: this,
        duration,
        ease: Phaser.Math.Easing.Linear,
        scale: 0.6,
        onComplete: () => {
          this.locked.kill();
          this.attractCircles.killAll();
          this.attractCircles.on = false;
          this.moveToOriginalPosition(originalX);
          this.playExplodeTweens();
        }
      });
    }
    moveToOriginalPosition(originalX) {
      this.shakeTween.remove();
      this.scene.tweens.add({
        targets: this,
        duration: 300,
        ease: Phaser.Math.Easing.Linear,
        x: originalX
      });
    }
    playExplodeTweens() {
      let delay = 66;
      this.scene.tweens.add({
        delay,
        targets: this,
        duration: 800,
        ease: Phaser.Math.Easing.Expo.Out,
        scale: 2.5,
        onStart: () => {
          this.explodeSparks.explode(30, 0, 0);
          this.explodeCircles.explode(1, 0, 0);
        }
      });
      this.scene.tweens.add({
        delay,
        targets: this,
        duration: 1e3,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        y: "-=50",
        onComplete: () => {
          this.destroy();
        }
      });
    }
    preUpdate(time, delta) {
      if (this.attractCircles.on) {
        this.particles.setPosition(this.x, this.y);
      }
    }
    preDestroy() {
      this.particles.destroy();
      super.preDestroy();
    }
  };

  // src/scenes/levelMap/LevelMapPopover.ts
  var LevelMapPopover = class extends Phaser.GameObjects.Container {
    constructor(scene, backTexture, backFrame) {
      super(scene);
      this.originalScale = 1;
      this.name = "popover";
      this.addBack(backTexture, backFrame);
      this.addText();
      this.setSize(this.back.displayWidth, this.back.displayHeight);
    }
    addBack(backTexture, backFrame) {
      this.back = this.scene.add.image(0, 0, backTexture, backFrame);
      this.add(this.back);
    }
    addText() {
      let textContent = "Some long ass text and little bit more. And MOAR!";
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "26px",
        color: "#B35F44",
        align: "center"
      };
      let backWidth = 340;
      let backHeight = 120;
      this.text = this.scene.add.text(0, 0, textContent, style);
      this.text.setOrigin(0.5, 0.5);
      this.text.setWordWrapWidth(backWidth * 0.9, true);
      this.text.x = this.back.left + 12 + backWidth / 2;
      this.text.y = this.back.top + 11 + backHeight / 2;
      this.add(this.text);
      this.adjustTextScale();
    }
    adjustTextScale() {
      this.text.scale = Math.min(1, 110 / this.text.height);
    }
    updateText(content) {
      this.text.setText(content);
      this.adjustTextScale();
    }
    show() {
      this.scene.tweens.killTweensOf(this);
      this.revive();
      this.alpha = 0;
      this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.scale = this.originalScale * 0.66;
      this.scene.tweens.add({
        targets: this,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: this.originalScale,
        onComplete: () => {
          this.hide(1600);
        }
      });
    }
    hide(delay) {
      this.scene.tweens.killTweensOf(this);
      this.scene.tweens.add({
        delay,
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.kill();
        }
      });
    }
  };

  // src/scenes/levelMap/LevelMapCloud.ts
  var LevelMapCloud = class extends Phaser.GameObjects.Image {
    constructor(scene, atlas, frame) {
      super(scene, 0, 0, atlas, frame);
      this.speed = 1;
    }
    preUpdate(time, delta) {
      this.x += this.speed * delta;
      if (this.x > Config.SOURCE_GAME_WIDTH + this.displayWidth / 2) {
        this.x = -this.displayWidth / 2;
      }
    }
  };

  // src/scenes/levelMap/resetDataScreen/ResetDataPopover.ts
  var ResetDataPopover = class extends Phaser.GameObjects.Container {
    constructor(scene, backTexture, backFrame) {
      super(scene);
      this.originalScale = 1;
      this.name = "popover";
      this.addBack(backTexture, backFrame);
      this.addText();
      this.setSize(this.back.displayWidth, this.back.displayHeight);
      this.setInteractive(new Phaser.Geom.Rectangle(12, -60, 340, 120), Phaser.Geom.Rectangle.Contains);
      this.input.cursor = "pointer";
    }
    addBack(backTexture, backFrame) {
      this.back = this.scene.add.image(0, 0, backTexture, backFrame);
      this.add(this.back);
    }
    addText() {
      let textContent = "Some long ass text and little bit more. And MOAR!";
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "26px",
        color: "#B35F44",
        align: "center"
      };
      let backWidth = 340;
      let backHeight = 120;
      this.text = this.scene.add.text(0, 0, textContent, style);
      this.text.setOrigin(0.5, 0.5);
      this.text.setWordWrapWidth(backWidth * 0.9, true);
      this.text.x = this.back.left + 12 + backWidth / 2;
      this.text.y = this.back.top + 11 + backHeight / 2;
      this.add(this.text);
      this.adjustTextScale();
    }
    adjustTextScale() {
      this.text.scale = Math.min(1, 110 / this.text.height);
    }
    updateText(content) {
      this.text.setText(content);
      this.adjustTextScale();
    }
    show() {
      this.scene.tweens.killTweensOf(this);
      this.revive();
      this.alpha = 0;
      this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.scale = this.originalScale * 0.66;
      this.scene.tweens.add({
        targets: this,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: this.originalScale
      });
    }
    hide(delay) {
      this.scene.tweens.killTweensOf(this);
      this.scene.tweens.add({
        delay,
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.kill();
        }
      });
    }
  };

  // src/scenes/levelMap/resetDataScreen/ResetDataPopup.ts
  var ResetDataPopupEvent;
  (function(ResetDataPopupEvent2) {
    ResetDataPopupEvent2["RESET_DATA"] = "__RESET_DATA";
  })(ResetDataPopupEvent || (ResetDataPopupEvent = {}));
  var ResetDataPopup = class extends ConfirmPopup {
    constructor(scene) {
      super(scene);
      this.yesClicks = 0;
      this.addConfirmPopover();
      this.yesButton.on(ButtonEvent.PRESS, this.onYesButtonClick, this);
    }
    onYesButtonClick() {
      this.yesClicks++;
      if (this.yesClicks === 1) {
        this.confirmPopover.show();
      } else if (this.yesClicks === 2) {
        this.emit(ResetDataPopupEvent.RESET_DATA, this);
      }
    }
    addConfirmPopover() {
      let content = this.scene.texts.reset_data.press_to_\u0441onfirm;
      this.confirmPopover = new ResetDataPopover(this.scene, "popups", "popups/quit/popover.png");
      this.confirmPopover.x = this.yesButton.x;
      this.confirmPopover.y = this.yesButton.y - 32;
      this.confirmPopover.updateText(content);
      this.confirmPopover.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onPopoverClick, this);
      this.add(this.confirmPopover);
    }
    onPopoverClick() {
      this.yesClicks = 0;
      this.confirmPopover.hide(0);
    }
    onShow() {
      this.confirmPopover.kill();
      this.yesClicks = 0;
    }
    onHide() {
    }
    onLanguageChange() {
      super.onLanguageChange();
      let {title, text, press_to_\u0441onfirm} = this.scene.texts.reset_data;
      this.title.text = title;
      this.adjustTitleTextSize();
      this.text.setText(text);
      this.confirmPopover.updateText(press_to_\u0441onfirm);
    }
  };

  // src/scenes/levelMap/resetDataScreen/ResetDataScreen.ts
  var ResetDataScreen = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "confirm_data_reset_screen",
        backgroundKey: "popups",
        backgroundFrame: "popups/black_rect.png",
        backgroundAlpha: 1e-3,
        backgroundInteractive: false
      });
      this.addPopup();
    }
    addPopup() {
      let {title, text} = this.scene.texts.reset_data;
      let data = {title, text};
      this.popup = new ResetDataPopup(this.scene);
      this.popup.updateData(data);
      this.popup.closeButton.on(ButtonEvent.PRESS, this.hide, this);
      this.popup.noButton.on(ButtonEvent.PRESS, this.hide, this);
      this.add(this.popup);
      this.pin(this.popup, 0.5, 0.5);
    }
    resize() {
      super.resize();
    }
    show() {
      this.alpha = 1;
      this.emitShowEvent();
      this.revive();
      this.showPopup();
    }
    showPopup() {
      this.popup.alpha = 0;
      this.scene.tweens.add({
        delay: 0,
        targets: this.popup,
        alpha: {value: 1, ease: Phaser.Math.Easing.Cubic.Out, duration: 200}
      });
      this.popup.scale = 0.85;
      this.scene.tweens.add({
        delay: 0,
        targets: this.popup,
        duration: 1e3,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
      this.popup.y += 100;
      this.scene.tweens.add({
        targets: this.popup,
        duration: 500,
        ease: Phaser.Math.Easing.Back.Out,
        y: "-=100"
      });
      this.popup.closeButton.enableInput();
      this.popup.noButton.enableInput();
      this.popup.yesButton.enableInput();
      this.popup.onShow();
    }
    hide() {
      this.emitHideStartEvent();
      this.popup.closeButton.disableInput();
      this.popup.noButton.disableInput();
      this.popup.yesButton.disableInput();
      this.scene.tweens.add({
        targets: this,
        duration: 100,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.popup.onHide();
          this.kill();
          this.emitHideCompleteEvent();
        }
      });
    }
    onLanguageChange() {
      this.popup.onLanguageChange();
    }
  };

  // src/scenes/levelMap/specialOfferScreen/SpecialOfferPopup.ts
  var SpecialOfferPopup = class extends Phaser.GameObjects.Container {
    constructor(scene, options) {
      super(scene);
      this.name = "special_offer_popup";
      this.options = options;
      this.addBack();
      this.addTitleBack();
      this.addTitleText();
      this.addCloseButton();
      this.addOffer();
      this.addDiscountLabel();
      this.addBuyButton();
      this.bringToTop(this.buyButton);
      this.bringToTop(this.title);
      this.setSize(this.back.width, this.back.height);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "popups", "popups/popup_small_back.png");
      this.add(this.back);
    }
    addTitleBack() {
      this.titleBack = this.scene.add.image(0, 0, "popups", "popups/special_offer/headline_flag_pink.png");
      this.titleBack.y = this.back.top + 36;
      this.add(this.titleBack);
    }
    addTitleText() {
      let content = this.scene.texts.shop.special_offer;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "40px",
        color: "#ffffff",
        align: "center"
      };
      this.title = this.scene.add.text(0, 0, content, style);
      this.title.setOrigin(0.5, 0.5);
      this.title.scale = Math.min(1, 210 / this.title.width);
      this.title.setShadow(0, 2, "rgba(0,0,0,0.2)", 0);
      this.title.x = this.titleBack.x;
      this.title.y = this.titleBack.y - 4;
      this.add(this.title);
    }
    addCloseButton() {
      this.closeButton = this.scene.add.button("popups", "popups/Close Button.png", this);
      this.closeButton.x = this.back.right - 60;
      this.closeButton.y = this.back.top + 46;
    }
    addOffer() {
      this.offer = new SpecialOffer(this.scene, this.options);
      this.offer.y = -25;
      this.offer.title.y += 10;
      this.offer.title.setText(this.scene.texts.shop.sale);
      this.offer.subtitle.y += 14;
      this.offer.button.kill();
      this.add(this.offer);
    }
    addDiscountLabel() {
      let back = this.scene.add.image(0, 0, "popups", "popups/special_offer/discount_label_back.png");
      let text = this.createDiscountLabelText();
      this.discountLabel = this.scene.add.container(0, 0, [back, text]);
      this.discountLabel.back = back;
      this.discountLabel.text = text;
      this.discountLabel.text.y = -1;
      this.discountLabel.x = this.offer.title.x;
      this.discountLabel.y = this.offer.subtitle.y + 60;
      this.offer.add(this.discountLabel);
      this.adjustDiscountLabelTextSize();
    }
    createDiscountLabelText() {
      let content = this.getDiscountLabelContent();
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "22px",
        color: "#ffffff",
        align: "center"
      };
      let text = this.scene.add.text(0, 0, content, style);
      text.setOrigin(0.5, 0.5);
      text.setShadow(0, 2, "rgba(0,0,0,0.2)", 0);
      return text;
    }
    getDiscountLabelContent() {
      return this.scene.texts.shop.discount.replace("#", this.options.discount.toString());
    }
    adjustDiscountLabelTextSize() {
      let {back, text} = this.discountLabel;
      let maxWidth = back.displayWidth * 0.75;
      text.scale = Math.min(1, maxWidth / text.width);
    }
    addBuyButton() {
      let options = {
        type: "common",
        price: this.options.price,
        offerId: this.options.offerId
      };
      this.buyButton = new OfferButton(this.scene, options);
      this.buyButton.back.setFrame("popups/special_offer/button_pink_large.png");
      this.buyButton.text.setFontSize(28);
      this.buyButton.y = 133;
      this.buyButton.on(ButtonEvent.PRESS, this.stopBuyButtonAnimation, this);
      this.add(this.buyButton);
    }
    onShow() {
      this.startBuyButtonAnimation();
      this.showCloseButton(2e3);
    }
    showBuyButton(delay) {
      this.buyButton.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.buyButton,
        duration: 150,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 1
      });
      this.buyButton.scale = 0.8;
      this.scene.tweens.add({
        delay,
        targets: this.buyButton,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.5],
        scale: 1
      });
    }
    showCloseButton(delay) {
      this.closeButton.kill();
      this.closeButton.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.closeButton,
        duration: 150,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 1,
        onStart: () => {
          this.closeButton.revive();
        }
      });
    }
    onHide() {
      this.stopBuyButtonAnimation();
    }
    startBuyButtonAnimation() {
      this.buyButtonAnimateEvent = this.scene.time.addEvent({
        repeat: -1,
        startAt: 2500,
        delay: 3e3,
        callback: this.shakeBuyButton,
        callbackScope: this
      });
    }
    stopBuyButtonAnimation() {
      var _a;
      (_a = this.buyButtonAnimateEvent) == null ? void 0 : _a.remove();
      this.scene.tweens.killTweensOf(this.buyButton);
      this.buyButton.scale = 1;
    }
    shakeBuyButton() {
      this.scene.tweens.add({
        targets: this.buyButton,
        duration: 600,
        ease: Phaser.Math.Easing.Quadratic.Out,
        scale: 0.83,
        onComplete: () => {
          this.scene.tweens.add({
            targets: this.buyButton,
            duration: 900,
            ease: Phaser.Math.Easing.Elastic.Out,
            easeParams: [0.1, 0.4],
            scale: 1
          });
        }
      });
    }
    onLanguageChange() {
    }
  };

  // src/scenes/levelMap/specialOfferScreen/SpecialOfferScreen.ts
  var SpecialOfferScreenEvent;
  (function(SpecialOfferScreenEvent2) {
    SpecialOfferScreenEvent2["PURCHASE_COMPLETE"] = "__PURCHASE_COMPLETE";
  })(SpecialOfferScreenEvent || (SpecialOfferScreenEvent = {}));
  var SpecialOfferScreen = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "special_offer_screen",
        backgroundKey: "popups",
        backgroundFrame: "popups/black_rect.png",
        backgroundAlpha: 0.85
      });
      this.purchases = this.scene.game.purchases;
      this.addFlags();
      this.addPopup();
      this.addAdsText();
    }
    addFlags() {
      this.leftFlags = this.scene.add.image(0, 0, "rewards", "rewards/flags_left.png");
      this.add(this.leftFlags);
      this.pin(this.leftFlags, 0, 0);
      this.rightFlags = this.scene.add.image(0, 0, "rewards", "rewards/flags_right.png");
      this.add(this.rightFlags);
      this.pin(this.rightFlags, 1, 0);
    }
    addPopup() {
      let offerId = "special_30000";
      let offerData = this.scene.game.purchases.getOfferById(offerId);
      let options = {
        offerId,
        coinsNum: offerData.content.coins,
        livesNum: offerData.content.lives,
        price: offerData.price,
        isSpecial: true,
        height: 0,
        discount: 50,
        iconFrame: "popups/shop/coins_chest.png",
        useSeparator: false
      };
      this.popup = new SpecialOfferPopup(this.scene, options);
      this.popup.closeButton.on(ButtonEvent.PRESS, this.hide, this);
      this.popup.buyButton.on(ButtonEvent.RELEASE, this.onBuyButtonClick.bind(this, offerId));
      this.add(this.popup);
      this.pin(this.popup, 0.5, 0.55);
    }
    onBuyButtonClick(offerId) {
      this.purchases.make(offerId, "SpecialOffer").then(() => {
        this.onPurchaseComplete(offerId);
      });
    }
    onPurchaseComplete(offerId) {
      this.purchases.savePurchase(offerId);
      this.popup.closeButton.disableInput();
      this.popup.buyButton.disableInput();
      this.emit(SpecialOfferScreenEvent.PURCHASE_COMPLETE, this, offerId);
    }
    addAdsText() {
      let content = this.scene.texts.shop.ads_hint;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "30px",
        color: "#FFE0AD",
        align: "center",
        stroke: "#41211F",
        strokeThickness: 6
      };
      this.adsText = this.scene.add.text(0, 0, content, style);
      this.adsText.setOrigin(0.5, 0.5);
      this.adsText.setWordWrapWidth(this.popup.width * 0.85);
      this.adsText.setLineSpacing(-6);
      this.adsText.alpha = 0.85;
      this.adsText.originalAlpha = this.adsText.alpha;
      this.adsText.originalScale = 1;
      this.add(this.adsText);
    }
    resize() {
      super.resize();
      this.leftFlags.originalX = this.leftFlags.x;
      this.rightFlags.originalX = this.rightFlags.x;
      this.resizePopup();
      this.alignAdsText();
    }
    resizePopup() {
      let maxHeight = this.screenHeight * 0.8;
      this.popup.scale = Math.min(1, maxHeight / this.popup.height);
      this.popup.originalScale = this.popup.scale;
      this.popup.originalY = this.popup.y;
    }
    alignAdsText() {
      let top = this.popup.y + this.popup.displayHeight / 2 - 40;
      let bottom = this.screenHeight;
      let height = bottom - top;
      this.adsText.x = this.screenWidth / 2;
      this.adsText.y = top + height / 2;
      this.adsText.originalY = this.adsText.y;
    }
    show(options) {
      this.alpha = 1;
      this.emitShowEvent();
      this.revive();
      this.showFlags(0);
      this.showPopup();
      this.showAdsText(66);
      if (options.showBackground) {
        this.background.revive();
        this.showBackground({duration: 200, ease: Phaser.Math.Easing.Quadratic.Out});
      } else {
        this.background.kill();
      }
      this.scene.audio.play(GameSoundKey.SHOP_OPEN, {volume: 0.25, seek: 0.3});
    }
    showFlags(delay) {
      this.leftFlags.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.leftFlags,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.leftFlags.scale = 0.75;
      this.scene.tweens.add({
        delay,
        targets: this.leftFlags,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.5],
        scale: 1
      });
      this.rightFlags.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.rightFlags,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.rightFlags.scale = 0.75;
      this.scene.tweens.add({
        delay,
        targets: this.rightFlags,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.5],
        scale: 1
      });
      let dx = 60;
      let dy = 50;
      this.leftFlags.x = this.leftFlags.originalX - dx;
      this.scene.tweens.add({
        delay,
        targets: this.leftFlags,
        duration: 800,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.55],
        x: this.leftFlags.originalX
      });
      this.rightFlags.x = this.rightFlags.originalX + dx;
      this.scene.tweens.add({
        delay,
        targets: this.rightFlags,
        duration: 800,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.55],
        x: this.rightFlags.originalX
      });
      this.leftFlags.y = -dy;
      this.rightFlags.y = -dy;
      this.scene.tweens.add({
        delay,
        targets: [this.leftFlags, this.rightFlags],
        duration: 900,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.55],
        y: 0
      });
    }
    showPopup() {
      this.popup.alpha = 0;
      this.scene.tweens.add({
        delay: 0,
        targets: this.popup,
        alpha: {value: 1, ease: Phaser.Math.Easing.Cubic.Out, duration: 200}
      });
      this.popup.y += 60;
      this.scene.tweens.add({
        targets: this.popup,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.5],
        y: "-=60"
      });
      this.popup.onShow();
    }
    showAdsText(delay) {
      this.adsText.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.adsText,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: this.adsText.originalAlpha
      });
      this.adsText.y += 60;
      this.scene.tweens.add({
        delay,
        targets: this.adsText,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.5],
        y: "-=60"
      });
    }
    hide() {
      this.emitHideStartEvent();
      this.scene.audio.stop(GameSoundKey.SHOP_OPEN);
      this.popup.onHide();
      this.scene.tweens.add({
        targets: this,
        duration: 100,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 0,
        onComplete: () => {
          this.kill();
          this.emitHideCompleteEvent();
        }
      });
    }
    onLanguageChange() {
      this.adsText.text = this.scene.texts.shop.ads_hint;
      this.popup.onLanguageChange();
    }
    preDestroy() {
      this.scene.audio.stop(GameSoundKey.SHOP_OPEN);
      super.preDestroy();
    }
  };

  // src/scenes/levelMap/buttons/PiggyBackButton.ts
  var PiggyBankButton = class extends LevelMapButton {
    constructor(scene) {
      super(scene, "level_map", "button_piggy");
      this.name = "button_piggy_bank";
      this.back.x -= 2;
      this.back.y -= 4;
      this.doAddIcon();
      this.setupText();
      this.addFullPopover();
      let isFull = this.isPiggyBankFull();
      if (isFull) {
        this.fullPopover.revive();
        this.animateFullPopover();
      }
    }
    doAddIcon() {
      this.addIcon("level_map", "button_piggy_coin");
      this.icon.scale = 0.9;
      this.icon.x = 2;
      this.icon.y = 13;
    }
    setupText() {
      let coinsNum = this.scene.game.store.getNumber(GameStoreKey.PIGGY_BANK_COINS);
      this.bitmapText.setLetterSpacing(2);
      this.bitmapText.text = coinsNum.toString();
      this.bitmapText.y = 48;
    }
    addFullPopover() {
      let back = this.scene.add.image(0, 0, "level_map", "piggy_bank_popover");
      let text = this.createFullText(back.width * 0.8);
      text.y = -28;
      this.fullPopover = this.scene.add.container(0, 0, [back, text]);
      this.fullPopover.text = text;
      this.fullPopover.x = -18;
      this.fullPopover.y = -60;
      this.fullPopover.kill();
      this.add(this.fullPopover);
    }
    createFullText(maxWidth) {
      let content = this.scene.texts.piggy_bank.full;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "24px",
        color: "#ffffff",
        align: "center",
        padding: {x: 0, y: 2}
      };
      let text = this.scene.add.text(0, 0, content, style);
      text.setOrigin(0.5, 0.5);
      text.setShadow(0, 2, "rgba(0,0,0,0.2)");
      text.scale = Math.min(1, maxWidth / text.width);
      return text;
    }
    isPiggyBankFull() {
      let coinsInPiggy = this.scene.game.store.getNumber(GameStoreKey.PIGGY_BANK_COINS);
      let piggyCapacity = window.game.config.piggy_bank.max_capacity;
      return coinsInPiggy >= piggyCapacity;
    }
    animateFullPopover() {
      let deltaAngle = 5;
      this.fullPopover.angle = -deltaAngle;
      this.scene.tweens.add({
        targets: this.fullPopover,
        duration: 900,
        ease: Phaser.Math.Easing.Sine.InOut,
        angle: deltaAngle,
        yoyo: true,
        repeat: -1
      });
    }
    updateCoinsNum(coinsNum) {
      this.bitmapText.text = coinsNum.toString();
    }
    showFullPopover(delay) {
      this.fullPopover.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.fullPopover,
        duration: 150,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 1
      });
      this.fullPopover.scale = 0.75;
      this.scene.tweens.add({
        delay,
        targets: this.fullPopover,
        duration: 1e3,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.4],
        scale: 1
      });
    }
    hideFullPopover() {
      if (this.fullPopover.visible === false) {
        return;
      }
      this.scene.tweens.killTweensOf(this.fullPopover);
      this.scene.tweens.add({
        targets: this.fullPopover,
        y: "-=10",
        duration: 150,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 0,
        onComplete: () => {
          this.fullPopover.kill();
        }
      });
    }
    onLanguageChange() {
      this.fullPopover.text.text = this.scene.texts.piggy_bank.full;
    }
  };

  // src/robowhale/utils/parse-ms.ts
  function parseMilliseconds(milliseconds) {
    const roundTowardsZero = milliseconds > 0 ? Math.floor : Math.ceil;
    return {
      days: roundTowardsZero(milliseconds / 864e5),
      hours: roundTowardsZero(milliseconds / 36e5) % 24,
      minutes: roundTowardsZero(milliseconds / 6e4) % 60,
      seconds: roundTowardsZero(milliseconds / 1e3) % 60,
      milliseconds: roundTowardsZero(milliseconds) % 1e3,
      microseconds: roundTowardsZero(milliseconds * 1e3) % 1e3,
      nanoseconds: roundTowardsZero(milliseconds * 1e6) % 1e3
    };
  }

  // src/scenes/levelMap/greetingsScreen/GreetingsCard.ts
  var GreetingsCard = class extends Phaser.GameObjects.Container {
    constructor(scene, options) {
      super(scene);
      this.options = options;
      this.addBack();
      this.addTitleBack();
      this.addTitleText();
      this.addCoinsIcon();
      this.addCoinsParticles();
      this.addCoinsText();
      this.addLives();
      this.addButton();
      this.bringToTop(this.button);
      this.bringToTop(this.titleText);
      this.bringToTop(this.coinsText);
      this.setSize(this.back.displayWidth, this.back.displayHeight);
    }
    addBack() {
      this.back = this.scene.add.image(0, 0, "popups", "popups/greetings/card_back.png");
      this.add(this.back);
    }
    addTitleBack() {
      this.titleBack = this.scene.add.image(0, 0, "popups", "popups/greetings/title_back.png");
      this.titleBack.x = 2;
      this.titleBack.y = this.back.top + 58;
      this.add(this.titleBack);
    }
    addTitleText() {
      let content = this.options.title;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "30px",
        color: "#ffffff",
        align: "center",
        padding: {x: 0, y: 4}
      };
      this.titleText = this.scene.add.text(0, 0, content, style);
      this.titleText.setOrigin(0.5, 0.5);
      this.titleText.setShadow(0, 3, "rgba(0,0,0,0.15)", 0);
      this.titleText.x = 0;
      this.titleText.y = this.titleBack.y - 9;
      this.add(this.titleText);
    }
    addCoinsIcon() {
      this.coinsIcon = this.scene.add.image(0, 0, "popups", this.options.coinsIconFrame);
      this.coinsIcon.y = 70;
      this.add(this.coinsIcon);
    }
    addCoinsParticles() {
      if (this.options.coinsParticles === false) {
        return;
      }
      this.sparksManager = this.scene.add.particles("popups");
      this.add(this.sparksManager);
      this.sparks = this.sparksManager.createEmitter({
        speed: 30,
        frame: "popups/particles/star_1.png",
        lifespan: {min: 800, max: 1400},
        rotate: {start: 0, end: 180, random: true},
        angle: -90,
        scale: {start: 1, end: 0, ease: Ease.ExpoIn},
        alpha: {start: 0, end: 1, ease: Ease.ExpoOut},
        frequency: 300,
        on: true
      });
      this.sparks.setEmitZone({
        source: new Phaser.Geom.Circle(0, 0, this.coinsIcon.displayWidth * 0.4),
        type: "random",
        quantity: 360
      });
    }
    addCoinsText() {
      let content = this.options.content.coins.toString();
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "34px",
        color: "#ffffff",
        align: "center",
        stroke: "#AA5800",
        strokeThickness: 8
      };
      this.coinsText = this.scene.add.text(0, 0, content, style);
      this.coinsText.setOrigin(0.5, 0.5);
      this.coinsText.setShadow(0, 3, "rgba(0,0,0,0.15)", 0, true, false);
      this.coinsText.y = 68;
      this.add(this.coinsText);
    }
    addLives() {
      if (this.options.content.unlimitedLivesMs <= 0) {
        return;
      }
      let content = this.getUnlimLivesDurationFormatted();
      this.livesIcon = new LifeIcon(this.scene);
      this.livesIcon.text.setFontSize(22);
      this.livesIcon.updateTextContent(content);
      this.livesIcon.x = 106;
      this.livesIcon.y = -100;
      this.add(this.livesIcon);
      let plusSign = this.scene.add.image(0, 0, "popups", "popups/greetings/plus_sign.png");
      plusSign.x = 44;
      plusSign.y = this.livesIcon.y + 10;
      this.add(plusSign);
    }
    getUnlimLivesDurationFormatted() {
      let texts = this.scene.texts.greetings;
      let result = parseMilliseconds(this.options.content.unlimitedLivesMs);
      let hours = result.hours > 0 ? texts.hours.replace("#", result.hours.toString()) : "";
      let minutes = result.minutes > 0 ? texts.minutes.replace("#", result.minutes.toString()) : "";
      return [hours, minutes].filter(Boolean).join(" ");
    }
    addButton() {
      this.button = this.options.buttonType === "normal" ? this.createNormalButton() : this.createVideoButton();
      this.button.inflateHitArea(15, 15);
      this.button.x = 0;
      this.button.y = this.back.bottom - 70;
      this.add(this.button);
    }
    createNormalButton() {
      let content = this.scene.texts.greetings.take;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "25px",
        color: "#ffffff",
        align: "center",
        stroke: "#F06B5C",
        strokeThickness: 5
      };
      let button = new ComplexButton(this.scene, "popups", "popups/greetings/button_pink.png");
      button.addText(content, style, 0, -4);
      return button;
    }
    createVideoButton() {
      let button = new ComplexButton(this.scene, "popups", "popups/greetings/button_pink.png");
      button.addIcon("popups", "popups/greetings/watch ad.png", 0, -15);
      button.icon.scale = 0.66;
      button.on(ButtonEvent.PRESS, this.stopButtonAnimation, this);
      return button;
    }
    onShow() {
      if (this.options.buttonType === "rewarded_ad") {
        this.startButtonAnimation();
      }
    }
    startButtonAnimation() {
      this.buttonAnimateEvent = this.scene.time.addEvent({
        repeat: -1,
        startAt: 2300,
        delay: 3e3,
        callback: this.animateButton,
        callbackScope: this
      });
    }
    stopButtonAnimation() {
      var _a;
      (_a = this.buttonAnimateEvent) == null ? void 0 : _a.remove();
      this.scene.tweens.killTweensOf(this.button);
      this.button.scale = 1;
    }
    animateButton() {
      this.scene.tweens.add({
        targets: this.button,
        duration: 600,
        ease: Phaser.Math.Easing.Quadratic.Out,
        scale: 1.15,
        onComplete: () => {
          var _a;
          (_a = this.scene) == null ? void 0 : _a.tweens.add({
            targets: this.button,
            duration: 900,
            ease: Phaser.Math.Easing.Elastic.Out,
            easeParams: [0.1, 0.4],
            scale: 1
          });
        }
      });
    }
    preDestroy() {
      this.stopButtonAnimation();
      super.preDestroy();
    }
  };

  // src/scenes/levelMap/greetingsScreen/ChefPopover.ts
  var ChefPopover = class extends Phaser.GameObjects.Container {
    constructor(scene, backTexture, backFrame) {
      super(scene);
      this.originalScale = 1;
      this.name = "popover";
      this.addBack(backTexture, backFrame);
      this.addText();
      this.setSize(this.back.displayWidth, this.back.displayHeight);
    }
    addBack(backTexture, backFrame) {
      this.back = this.scene.add.image(0, 0, backTexture, backFrame);
      this.add(this.back);
    }
    addText() {
      let textContent = "Some long ass text and little bit more. And MOAR!";
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "26px",
        color: "#B35F44",
        align: "center"
      };
      let backWidth = 340;
      let backHeight = 120;
      this.text = this.scene.add.text(0, 0, textContent, style);
      this.text.setOrigin(0.5, 0.5);
      this.text.setWordWrapWidth(backWidth * 0.9, true);
      this.text.x = this.back.left + 39 + backWidth / 2;
      this.text.y = this.back.top + 11 + backHeight / 2;
      this.add(this.text);
      this.adjustTextScale();
    }
    adjustTextScale() {
      this.text.scale = Math.min(1, 110 / this.text.height);
    }
    updateText(content) {
      this.text.setText(content);
      this.adjustTextScale();
    }
    show() {
      this.scene.tweens.killTweensOf(this);
      this.revive();
      this.alpha = 0;
      this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      this.scale = this.originalScale * 0.66;
      this.scene.tweens.add({
        targets: this,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        scale: this.originalScale,
        onComplete: () => {
          this.hide(1600);
        }
      });
    }
    hide(delay) {
      this.scene.tweens.killTweensOf(this);
      this.scene.tweens.add({
        delay,
        targets: this,
        duration: 200,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.kill();
        }
      });
    }
  };

  // src/scenes/levelMap/greetingsScreen/GreetingsScreen.ts
  var GreetingsScreenEvent;
  (function(GreetingsScreenEvent2) {
    GreetingsScreenEvent2["GIFTS_OPEN_COMPLETE"] = "__GIFTS_OPEN_COMPLETE";
  })(GreetingsScreenEvent || (GreetingsScreenEvent = {}));
  var GreetingsScreen = class extends PhaserScreen {
    constructor(scene) {
      super(scene, {
        name: "greetings-screen",
        backgroundKey: "popups",
        backgroundFrame: "popups/black_rect.png",
        backgroundAlpha: 0.85
      });
      this.addTitle();
      this.addBonusCard();
      this.addSuperBonusCard();
      this.addChef();
      this.addChefPopover();
    }
    addTitle() {
      let content = this.scene.texts.greetings.title;
      let style = {
        fontFamily: WebFonts.DEFAULT_FAMILY,
        fontStyle: WebFonts.DEFAULT_WEIGHT,
        fontSize: "55px",
        color: "#FFA48E",
        align: "center",
        padding: {x: 0, y: 10}
      };
      this.title = this.scene.add.text(0, 0, content, style);
      this.title.setOrigin(0.5, 0.5);
      this.title.setShadow(0, 4, "#AC4717", 2);
      this.add(this.title);
      this.pin(this.title, 0.5, 0);
    }
    addBonusCard() {
      let config2 = window.game.config.greetings_screen;
      let options = {
        title: this.scene.texts.greetings.bonus,
        buttonType: "normal",
        coinsIconFrame: "popups/greetings/Coins Bag.png",
        coinsParticles: false,
        content: {
          coins: config2.bonus.coins,
          unlimitedLivesMs: config2.bonus.unlimitedLivesMs
        }
      };
      this.bonusCard = new GreetingsCard(this.scene, options);
      this.bonusCard.name = "bonus_card";
      this.bonusCard.button.once(ButtonEvent.PRESS, this.onBonusCardClick, this);
      this.bonusCard.button.name = "bonus_button";
      this.add(this.bonusCard);
      this.pin(this.bonusCard, 0.25, 0.5, 10);
    }
    onBonusCardClick() {
      this.emitGiftsOpenEvent(this.bonusCard.options.content.coins, this.bonusCard.options.content.unlimitedLivesMs);
      this.hide();
    }
    addSuperBonusCard() {
      let config2 = window.game.config.greetings_screen;
      let options = {
        title: this.scene.texts.greetings.super_bonus,
        buttonType: "rewarded_ad",
        coinsIconFrame: "popups/greetings/Coins Chest.png",
        coinsParticles: true,
        content: {
          coins: config2.superBonus.coins,
          unlimitedLivesMs: config2.superBonus.unlimitedLivesMs
        }
      };
      this.superBonusCard = new GreetingsCard(this.scene, options);
      this.superBonusCard.name = "super_bonus_card";
      this.superBonusCard.button.on(ButtonEvent.RELEASE, this.onSuperBonusCardClick, this);
      this.superBonusCard.button.name = "super_bonus_button";
      this.add(this.superBonusCard);
      this.pin(this.superBonusCard, 0.75, 0.5, -10);
    }
    onSuperBonusCardClick(button) {
      this.scene.game.gdSdk.showRewardedAd("GreetingsScreen").then((success) => {
        if (success) {
          button.disableInput();
          this.emitGiftsOpenEvent(this.superBonusCard.options.content.coins, this.superBonusCard.options.content.unlimitedLivesMs);
          this.hide();
        }
      });
    }
    addChef() {
      this.chef = this.scene.add.image(0, 0, "popups", "popups/Chef Cherry.png");
      this.add(this.chef);
      this.pin(this.chef, 0, 1, 200);
    }
    addChefPopover() {
      let content = this.scene.texts.greetings.greeting;
      let chefPin = this.pinner.getPin(this.chef);
      this.chefPopover = new ChefPopover(this.scene, "popups", "popups/greetings/popover.png");
      this.chefPopover.updateText(content);
      this.add(this.chefPopover);
      this.pin(this.chefPopover, chefPin.x, chefPin.y, 290, -100);
    }
    resize() {
      super.resize();
      this.alignCards();
      this.alignTitle();
    }
    alignCards() {
      let chefTop = this.chef.y - this.chef.displayHeight;
      let cardBottom = this.bonusCard.y + this.bonusCard.displayHeight / 2;
      let cardNewBottom = Math.min(cardBottom, chefTop + 40);
      this.bonusCard.y = cardNewBottom - this.bonusCard.displayHeight / 2;
      this.bonusCard.originalY = this.bonusCard.y;
      this.superBonusCard.y = this.bonusCard.y;
      this.superBonusCard.originalY = this.superBonusCard.y;
    }
    alignTitle() {
      let cardTop = this.bonusCard.y - this.bonusCard.displayHeight / 2;
      let titleY = cardTop > 200 ? cardTop - 100 : cardTop / 2;
      this.title.y = titleY;
      this.title.originalY = this.title.y;
      this.title.visible = cardTop > 150;
    }
    show() {
      this.emitShowEvent();
      this.showBackground();
      this.showTitle(0);
      this.showCards(100);
      this.showChef(0);
      this.showChefPopover(100);
      this.scene.time.delayedCall(200, () => {
        this.scene.audio.play(GameSoundKey.WHOOSH_1, {volume: 0.33});
      });
    }
    showTitle(delay) {
      this.title.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.title,
        duration: 150,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 1
      });
      this.title.scale = 0.75;
      this.scene.tweens.add({
        delay,
        targets: this.title,
        duration: 500,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.5],
        scale: 1
      });
      this.title.y = this.title.originalY - 100;
      this.scene.tweens.add({
        delay,
        targets: this.title,
        duration: 400,
        ease: Phaser.Math.Easing.Back.Out,
        easeParams: [1.5],
        y: this.title.originalY
      });
    }
    showCards(initialDelay) {
      let cards = [this.bonusCard, this.superBonusCard];
      cards.forEach((card, index) => {
        let delay = initialDelay + index * 66;
        card.alpha = 0;
        this.scene.tweens.add({
          delay,
          targets: card,
          duration: 150,
          ease: Phaser.Math.Easing.Quadratic.Out,
          alpha: 1
        });
        card.scale = 0.8;
        this.scene.tweens.add({
          delay,
          targets: card,
          duration: 500,
          ease: Phaser.Math.Easing.Back.Out,
          scale: 1
        });
        card.y = card.originalY - 100;
        this.scene.tweens.add({
          delay,
          targets: card,
          duration: 400,
          ease: Phaser.Math.Easing.Back.Out,
          easeParams: [1.5],
          y: card.originalY
        });
        card.onShow();
      });
    }
    showChef(delay) {
      this.chef.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.chef,
        duration: 150,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 1
      });
      this.chef.scale = 0.75;
      this.scene.tweens.add({
        delay,
        targets: this.chef,
        duration: 500,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1
      });
    }
    showChefPopover(delay) {
      this.chefPopover.alpha = 0;
      this.scene.tweens.add({
        delay,
        targets: this.chefPopover,
        duration: 150,
        ease: Phaser.Math.Easing.Quadratic.Out,
        alpha: 1
      });
      this.chefPopover.scale = 0.75;
      this.scene.tweens.add({
        delay,
        targets: this.chefPopover,
        duration: 500,
        ease: Phaser.Math.Easing.Back.Out,
        scale: 1
      });
      this.chefPopover.angle = -1;
      this.scene.tweens.add({
        targets: this.chefPopover,
        duration: 900,
        ease: Phaser.Math.Easing.Sine.InOut,
        angle: Math.abs(this.chefPopover.angle),
        yoyo: true,
        repeat: -1
      });
    }
    emitGiftsOpenEvent(coins, livesMs) {
      this.emit(GreetingsScreenEvent.GIFTS_OPEN_COMPLETE, coins, livesMs);
    }
    hide() {
      this.emitHideStartEvent();
      this.bonusCard.button.disableInput();
      this.superBonusCard.button.disableInput();
      this.scene.tweens.add({
        targets: this,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 0,
        onComplete: () => {
          this.emitHideCompleteEvent();
          this.destroy();
        }
      });
    }
  };

  // src/scenes/levelMap/LevelMap.ts
  var LevelMap = class extends BaseScene {
    init(data) {
      super.init(data);
      this.pointerDownPosition = {x: 0, y: 0};
      this.pointerDownTime = 0;
      this.pointerDownLevelIcon = null;
      this.cameraScrollY = 0;
      this.isLocked = false;
      this.resetDataScreen = null;
      this.shopScreen = null;
      this.specialOfferScreen = null;
      this.piggyBankScreen = null;
      this.greetingsScreen = null;
      this.config = this.cache.json.get("level_map_config");
      this.tutorialHand = null;
    }
    create() {
      this.addBackground();
      this.addLevelIcons();
      this.addSneakPeeks();
      this.addTopCover();
      this.addClouds();
      this.addIconAvatar();
      this.addEdgeAvatar();
      this.addTopPanel();
      this.addGiftButton();
      this.addPiggyBankButton();
      this.addPopover();
      this.addSettingsScreen();
      this.addStartLevelScreen();
      this.addLivesScreen();
      this.addPregameBoosterBuyScreen();
      this.addTutorial();
      this.setupCameras();
      this.setupScroll();
      this.cullLevelIconsThrottled = throttle_default(this.doCullLevelIcons.bind(this), 66, {trailing: true});
      this.addPointerCallbacks();
      this.addKeyboardCallbacks();
      this.addLanguageChangeCallback();
      this.resize();
      this.onCreateComplete();
    }
    onCreateComplete() {
      if (!this.initData || !this.initData.type) {
        this.onCreateCompleteAfterPreloader();
        return;
      }
      if (this.initData.type !== "complete") {
        this.doInitialScroll();
        return;
      }
      let levelResult = this.game.store.getLevelResult(this.initData.levelNumber);
      let isCompleteFirstTime = levelResult && levelResult.timesCompleteNum === 1;
      if (isCompleteFirstTime) {
        this.playLevelUnlockAnimation(this.initData.levelNumber);
      } else {
        this.doInitialScroll();
      }
    }
    onCreateCompleteAfterPreloader() {
      this.doInitialScroll();
      if (this.canShowGreetingsScreen()) {
        this.showGreetingsScreen();
      } else {
        this.showSpecialOfferScreen();
      }
    }
    canShowGreetingsScreen() {
      if (!window.game.config.ads.rewarded) {
        return false;
      }
      if (window.game.config.greetings_screen.enabled === false) {
        return false;
      }
      let forceDisplay = UrlParams.getBool("greetings");
      if (forceDisplay) {
        return true;
      }
      let isFirstLogin = this.game.store.getNumber(GameStoreKey.LOGIN_NUM) === 1;
      if (isFirstLogin) {
        return false;
      }
      let threshold = window.game.config.greetings_screen.displayInterval;
      let lastGiftTs = this.game.store.getNumber(GameStoreKey.GREETING_GIFT_OPEN_TS);
      let timePassed = Date.now() - lastGiftTs;
      return timePassed > threshold;
    }
    showGreetingsScreen() {
      this.greetingsScreen = new GreetingsScreen(this);
      this.greetingsScreen.once(GreetingsScreenEvent.GIFTS_OPEN_COMPLETE, this.onGreetingsGiftsOpen, this);
      this.greetingsScreen.on(PhaserScreenEvent.SHOW, () => this.scroll.disable());
      this.greetingsScreen.on(PhaserScreenEvent.HIDE_COMPLETE, this.onGreetingsScreenHideComplete, this);
      this.greetingsScreen.resize();
      this.add.existing(this.greetingsScreen);
      this.firstCamera.ignore(this.greetingsScreen);
      this.greetingsScreen.show();
    }
    onGreetingsGiftsOpen(coins, unlimitedLivesMs) {
      var _a;
      this.game.store.saveValue(GameStoreKey.GREETING_GIFT_OPEN_TS, Date.now());
      this.game.store.changeNumber(GameStoreKey.COINS, coins);
      this.topPanel.coinsLabel.syncWithGameStore(false);
      this.topPanel.coinsLabel.showCoinsTextFx(coins);
      this.livesScreen.coinsLabel.syncWithGameStore(true);
      (_a = this.pregameBoosterBuyScreen) == null ? void 0 : _a.coinsLabel.syncWithGameStore(true);
      if (unlimitedLivesMs > 0) {
        this.game.lives.startUnlimitedLives(unlimitedLivesMs);
        this.topPanel.livesLabel.animateIcon();
      }
    }
    onGreetingsScreenHideComplete() {
      this.scroll.enable();
      this.greetingsScreen = null;
      this.showSpecialOfferScreen();
    }
    showSpecialOfferScreen(options = {force: false}) {
      if (options.force === false && this.canShowSpecialOfferScreen() === false) {
        return false;
      }
      this.addSpecialOfferScreen();
      this.specialOfferScreen.resize();
      this.specialOfferScreen.show({showBackground: true});
      this.game.store.saveValue(GameStoreKey.SHOP_SPECIAL_OFFER_DISPLAY_TS, Date.now());
      return true;
    }
    canShowSpecialOfferScreen() {
      if (!this.game.purchases) {
        return false;
      }
      let wasAnyPurchaseMade = this.game.store.getBoolean(GameStoreKey.SHOP_ANY_PURCHASE_COMPLETE);
      if (wasAnyPurchaseMade) {
        return false;
      }
      let completeLevelsNum = this.game.store.getCompleteLevelsNum();
      if (completeLevelsNum < 10) {
        return false;
      }
      let timePassedSinceLastDisplay = Date.now() - this.game.store.getNumber(GameStoreKey.SHOP_SPECIAL_OFFER_DISPLAY_TS);
      let threshold = toMs({hours: 8});
      if (timePassedSinceLastDisplay < threshold) {
        return false;
      }
      return true;
    }
    isFeedbackLevel(levelNumber) {
      let feedbackLevels = [21, 51, 100, 150, 200];
      return feedbackLevels.includes(levelNumber);
    }
    playLevelUnlockAnimation(completedLevel) {
      let levelIcon = this.levelIcons.getByLevelNumber(completedLevel);
      if (!levelIcon) {
        this.doInitialScroll();
        return;
      }
      let nextLevel = levelIcon.levelNumber + 1;
      let nextLevelIcon = this.levelIcons.getByLevelNumber(nextLevel);
      if (!nextLevelIcon) {
        this.pointIconAvatarAt(levelIcon.levelNumber);
        this.scroll.scrollToLevelInstant(levelIcon.levelNumber);
        return;
      }
      this.lockScene();
      this.hideCloudsOver(levelIcon, nextLevelIcon);
      this.scroll.scrollToLevelInstant(levelIcon.levelNumber);
      this.game.globalScene.input.once(Phaser.Input.Events.POINTER_DOWN, this.applyFastForward, this);
      let fakeLevelIcon = new UnlockLevelIconFx(this, nextLevelIcon);
      fakeLevelIcon.x = nextLevelIcon.x;
      fakeLevelIcon.y = nextLevelIcon.y;
      fakeLevelIcon.setDepth(LevelMapDepth.LEVEL_ICONS_FX);
      fakeLevelIcon.show(500);
      this.add.existing(fakeLevelIcon);
      this.secondCamera.ignore(fakeLevelIcon);
      nextLevelIcon.alpha = 0;
      this.time.delayedCall(1700, () => {
        this.showNextLevelIcon(nextLevelIcon);
        this.showLevelUnlockParticles(nextLevelIcon);
      });
      let avatarPosition = this.getIconAvatarPosition(levelIcon);
      this.iconAvatar.x = avatarPosition.x;
      this.iconAvatar.y = avatarPosition.y;
      this.time.delayedCall(2e3, () => {
        let newAvatarPosition = this.getIconAvatarPosition(nextLevelIcon);
        this.iconAvatar.moveBetweenLevelIcons(newAvatarPosition);
        this.scroll.scrollToLevel(nextLevelIcon.levelNumber);
        this.time.delayedCall(220, () => {
          this.audio.play(GameSoundKey.WHOOSH_2, {volume: 0.5});
        });
      });
      this.time.delayedCall(3300, () => {
        this.onLevelUnlockAnimationComplete(completedLevel, nextLevel);
      });
    }
    onLevelUnlockAnimationComplete(completedLevel, nextLevel) {
      this.unlockScene();
      this.cancelFastForward();
      let wasFeedbackDialogShown = this.showFeedbackDialog(completedLevel);
      if (wasFeedbackDialogShown) {
        return;
      }
      let specialOfferLevels = [10];
      let isSpecialOfferLevel = specialOfferLevels.includes(completedLevel);
      let wasSpecialOfferShown = isSpecialOfferLevel && this.showSpecialOfferScreen();
      if (wasSpecialOfferShown) {
        return;
      }
      if (completedLevel === window.game.config.wheel_unlock_level - 1) {
        this.openWheelScreen();
      } else {
        this.openStartLevelPopup(nextLevel);
      }
    }
    showFeedbackDialog(completedLevel) {
      if (window.game.config.feedback_enabled === false) {
        return false;
      }
      let isFeedbackLevel = this.isFeedbackLevel(completedLevel);
      if (isFeedbackLevel === false) {
        return false;
      }
      let gaveFeeback = this.game.store.getBoolean(GameStoreKey.GAVE_FEEDBACK);
      if (gaveFeeback) {
        return false;
      }
      this.game.feedbackWidget.show();
      return true;
    }
    applyFastForward() {
      this.fastForward.start(2);
    }
    cancelFastForward() {
      this.game.globalScene.input.off(Phaser.Input.Events.POINTER_DOWN, this.applyFastForward, this);
      this.fastForward.stop();
    }
    hideCloudsOver(levelIcon_1, levelIcon_2) {
      let top = Math.min(levelIcon_1.y, levelIcon_2.y) - 120;
      let bottom = Math.max(levelIcon_1.y, levelIcon_2.y) + 120;
      this.clouds.some((cloud) => {
        if (cloud.y > top && cloud.y < bottom) {
          cloud.kill();
          return true;
        }
      });
    }
    showNextLevelIcon(levelIcon) {
      levelIcon.alpha = 0;
      this.tweens.add({
        targets: levelIcon,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        alpha: 1
      });
      levelIcon.scale = 0.5;
      this.tweens.add({
        targets: levelIcon,
        duration: 800,
        ease: Phaser.Math.Easing.Elastic.Out,
        easeParams: [0.1, 0.45],
        scale: 1
      });
    }
    showLevelUnlockParticles(levelIcon) {
      let particles = this.add.particles("level_map");
      particles.setDepth(LevelMapDepth.LEVEL_ICONS_FX);
      this.secondCamera.ignore(particles);
      let particlesNum = 12;
      let sparks = particles.createEmitter({
        gravityY: -100,
        delay: {min: 0, max: 500, steps: particlesNum},
        frame: "particles/star_white_1",
        lifespan: 600,
        scale: {start: 0, end: 1, ease: CustomEase.BellQuad},
        on: false
      });
      sparks.setEmitZone({
        source: new Phaser.Geom.Circle(0, 0, 55),
        type: "random",
        quantity: 360
      });
      let completeCallback = after_default(particlesNum, () => particles.destroy());
      sparks.onParticleDeath(completeCallback);
      sparks.explode(particlesNum, levelIcon.x, levelIcon.y);
    }
    doInitialScroll() {
      var _a;
      let targetLevelIcon = (_a = this.levelIcons.lastUnlockedIcon) != null ? _a : this.levelIcons.lastCompleteIcon;
      if (targetLevelIcon) {
        this.scroll.scrollToLevelInstant(targetLevelIcon.levelNumber);
        return;
      }
      this.scroll.scrollToLevelInstant(1);
    }
    setupCameras() {
      this.firstCamera = this.cameras.main;
      this.firstCamera.ignore([
        this.topPanel,
        this.giftButton,
        this.piggyBankButton,
        this.popover,
        this.settingsScreen,
        this.startLevelScreen,
        this.pregameBoosterBuyScreen,
        this.livesScreen
      ]);
      this.secondCamera = this.cameras.add();
      this.secondCamera.ignore([
        this.background,
        this.topCover,
        ...this.levelIcons.levelIcons,
        ...this.sneakPeaks,
        ...this.clouds,
        this.iconAvatar,
        this.edgeAvatar
      ]);
      if (this.tutorialHand) {
        this.secondCamera.ignore(this.tutorialHand);
      }
    }
    addBackground() {
      this.background = new LevelMapBackground(this, this.config.background);
      this.background.setDepth(LevelMapDepth.BACKGROUND);
      this.add.existing(this.background);
    }
    addLevelIcons() {
      this.levelIcons = new LevelIconsManager(this, this.config);
      let levelsToUnlock = this.getLevelsToUnlock();
      if (levelsToUnlock > 0) {
        this.levelIcons.levelIcons.forEach((icon) => {
          if (icon.levelNumber <= levelsToUnlock) {
            icon.setUnlocked();
          }
        });
      }
    }
    getLevelsToUnlock() {
      let valueStr = UrlParams.get("unlockLevels");
      if (valueStr === null) {
        return 0;
      }
      if (valueStr === "all") {
        return this.game.levelConfigs.getLastLevelNumber();
      }
      let value = parseInt(valueStr);
      if (isNaN(value)) {
        return 0;
      }
      return value;
    }
    addSneakPeeks() {
      let levelsWithNewElements = this.game.levelConfigs.getAll().filter((config2) => config2.newElement !== "none");
      let lockedLevels = levelsWithNewElements.filter((config2) => {
        return this.levelIcons.getByLevelNumber(config2.levelNumber).iconState === LevelIconState.LOCKED;
      });
      this.sneakPeaks = lockedLevels.map((config2, index) => {
        let levelNumber = config2.levelNumber;
        let newElement = config2.newElement;
        let frame = `sneak_peeks/popover_${newElement}`;
        let sneakPeak = this.add.image(0, 0, "level_map", frame);
        sneakPeak.setDepth(LevelMapDepth.LEVEL_ICONS_SNEAK_PEEKS);
        sneakPeak.setData("levelNumber", levelNumber);
        let levelIcon = this.levelIcons.getByLevelNumber(levelNumber);
        sneakPeak.x = levelIcon.x;
        sneakPeak.y = levelIcon.y - 40;
        let duration = 600;
        let delay = index % 2 === 0 ? 0 : duration / 2;
        this.tweens.addYoyoTween({
          delay,
          target: sneakPeak,
          property: "angle",
          base: 0,
          delta: 6,
          duration,
          repeat: -1
        });
        return sneakPeak;
      });
    }
    addTopCover() {
      this.topCover = this.add.image(0, 0, "level_map", "top_cover");
      this.topCover.scale = 2;
      this.topCover.x = Config.SOURCE_GAME_WIDTH / 2;
      this.topCover.y = -180;
    }
    addClouds() {
      let cloudsNum = 13;
      let top = 750;
      let bottom = this.background.height - 400;
      let height = bottom - top;
      let heightPerCloud = height / (cloudsNum - 1);
      let variance = heightPerCloud / 4;
      let frames = ["clouds/Cloud1", "clouds/Cloud2", "clouds/Cloud3"];
      this.clouds = times_default(cloudsNum, (index) => {
        let y = top + index * heightPerCloud + Phaser.Math.RND.between(-variance, variance);
        let frame = Phaser.Math.RND.pick(frames);
        let cloud = new LevelMapCloud(this, "level_map", frame);
        cloud.x = Phaser.Math.RND.between(0, Config.SOURCE_GAME_WIDTH);
        cloud.y = y;
        cloud.speed = Phaser.Math.RND.realInRange(0.05, 0.1);
        cloud.setDepth(LevelMapDepth.CLOUDS);
        this.add.existing(cloud);
        return cloud;
      });
    }
    addIconAvatar() {
      this.iconAvatar = new LevelMapAvatar(this);
      this.iconAvatar.disableInteractive();
      this.iconAvatar.startWiggle();
      this.iconAvatar.setDepth(LevelMapDepth.LEVEL_ICON_AVATAR);
      this.add.existing(this.iconAvatar);
      let targetLevelIcon = this.levelIcons.getCurrentIcon();
      if (targetLevelIcon) {
        this.pointIconAvatarAt(targetLevelIcon.levelNumber);
      } else {
        this.iconAvatar.kill();
      }
    }
    pointIconAvatarAt(levelNumber) {
      let levelIcon = this.levelIcons.getByLevelNumber(levelNumber);
      if (levelIcon) {
        let {x, y} = this.getIconAvatarPosition(levelIcon);
        this.iconAvatar.x = x;
        this.iconAvatar.y = y;
        return true;
      }
      return false;
    }
    getIconAvatarPosition(levelIcon) {
      let iconGlobalPosition = levelIcon.getWorldPosition();
      return {
        x: iconGlobalPosition.x,
        y: iconGlobalPosition.y - 46
      };
    }
    addEdgeAvatar() {
      this.edgeAvatar = new LevelMapAvatar(this);
      this.edgeAvatar.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onAvatarPointerDown, this);
      this.edgeAvatar.setDepth(LevelMapDepth.EDGE_AVATAR);
      this.add.existing(this.edgeAvatar);
    }
    onAvatarPointerDown() {
      this.game.audio.playClick();
      let scrollY = this.scroll.getCameraScroll(this.iconAvatar.y);
      this.scroll.scrollTo(scrollY);
    }
    addTopPanel() {
      this.topPanel = new LevelMapTopPanel(this);
      this.topPanel.settingsButton.on(ButtonEvent.PRESS, this.showSettings, this);
      this.pin(this.topPanel, 0.5, 0, 0, -1);
      this.size(this.topPanel);
      this.add.existing(this.topPanel);
      this.topPanel.livesLabel.plusButton.on(ButtonEvent.PRESS, this.onPlusLifeButtonClick, this);
      this.topPanel.coinsLabel.plusButton.on(ButtonEvent.PRESS, this.onPlusCoinsButtonClick, this);
    }
    onPlusLifeButtonClick() {
      this.scroll.disable();
      this.livesScreen.once(PhaserScreenEvent.HIDE_COMPLETE, this.scroll.enable, this.scroll);
      this.livesScreen.show();
    }
    onPlusCoinsButtonClick() {
      this.showShopScreen("LevelMap:CoinsLabel", {showBackground: true});
    }
    addGiftButton() {
      this.giftButton = new GiftButton(this);
      this.giftButton.on(ButtonEvent.RELEASE, this.onGiftButtonClick, this);
      this.add.existing(this.giftButton);
      this.pin(this.giftButton, 1, 1, -85, -95);
      this.size(this.giftButton);
    }
    onGiftButtonClick() {
      if (this.giftButton.isGiftReady() === false) {
        this.audio.play(GameSoundKey.BOOSTER_CANT_USE);
        this.giftButton.shakeText();
        this.showGiftPopover();
      } else {
        this.openGiftScreen();
      }
    }
    showGiftPopover() {
      let cameraZoom = this.firstCamera.zoom;
      let popoverText = this.texts.stars_gift.collect_popover.replace("#", this.giftButton.targetStars.toString());
      this.popover.updateText(popoverText);
      this.popover.x = this.giftButton.x - 70 * cameraZoom;
      this.popover.y = this.giftButton.y - 10 * cameraZoom;
      this.popover.show();
    }
    openGiftScreen() {
      let giftScreen = new GiftScreen(this);
      giftScreen.autoPlay = UrlParams.getBool("autoGift");
      giftScreen.on(PhaserScreenEvent.SHOW, this.scroll.disable, this.scroll);
      giftScreen.on(Phaser.GameObjects.Events.DESTROY, this.scroll.enable, this.scroll);
      giftScreen.once(GiftScreenEvent.ALL_REWARDS_COLLECTED, this.onGiftRewardsCollected, this);
      this.add.existing(giftScreen);
      this.firstCamera.ignore(giftScreen);
      giftScreen.resize();
      giftScreen.show();
    }
    onGiftRewardsCollected(rewardsData) {
      this.giftButton.onGiftRewardClaimed();
      this.game.gifts.saveRewards(...rewardsData);
      let coinsReward = rewardsData.find((data) => data.type === WheelRewardType.COINS);
      if (coinsReward) {
        let coinsNum = this.game.store.getNumber(GameStoreKey.COINS);
        this.topPanel.coinsLabel.updateContent(coinsNum);
      }
    }
    addWheelButton() {
      this.wheelButton = new WheelButton(this);
      this.wheelButton.on(ButtonEvent.PRESS, this.onWheelButtonClick, this);
      this.add.existing(this.wheelButton);
      this.pin(this.wheelButton, 1, 1, -85, -80);
      this.size(this.wheelButton);
    }
    onWheelButtonClick() {
      switch (this.wheelButton.buttonState) {
        case WheelButtonState.LOCKED:
          this.showWheelPopover();
          break;
        case WheelButtonState.DISABLED:
          this.wheelButton.shakeTimer();
          break;
        case WheelButtonState.ENABLED:
          this.openWheelScreen();
          break;
      }
    }
    showWheelPopover() {
      let cameraZoom = this.firstCamera.zoom;
      let popoverText = this.texts.wheel_lock.replace("#", window.game.config.wheel_unlock_level.toString());
      this.popover.updateText(popoverText);
      this.popover.x = this.wheelButton.x - 70 * cameraZoom;
      this.popover.y = this.wheelButton.y;
      this.popover.show();
    }
    openWheelScreen() {
      var _a;
      (_a = this.wheelScreen) == null ? void 0 : _a.show();
    }
    addPiggyBankButton() {
      this.piggyBankButton = new PiggyBankButton(this);
      this.piggyBankButton.on(ButtonEvent.RELEASE, () => this.showPiggyBackScreen({showBackground: true}));
      this.pin(this.piggyBankButton, 1, 1, -85, -260);
      this.size(this.piggyBankButton);
      if (!this.game.piggyBank) {
        this.piggyBankButton.kill();
      }
    }
    showPiggyBackScreen(options) {
      if (!this.piggyBankScreen) {
        this.addPiggyBankScreen();
      }
      let data = {
        currentCoins: this.game.store.getNumber(GameStoreKey.PIGGY_BANK_COINS),
        maxCoins: window.game.config.piggy_bank.max_capacity
      };
      this.piggyBankScreen.resize();
      this.piggyBankScreen.updateData(data);
      this.piggyBankScreen.show({showBackground: options.showBackground});
    }
    addPopover() {
      this.popover = new LevelMapPopover(this, "level_map", "popover");
      this.popover.kill();
      this.add.existing(this.popover);
      this.size(this.popover);
    }
    addSettingsScreen() {
      this.settingsScreen = new SettingsScreen(this);
      this.settingsScreen.on(SettingsScreenEvent.CLOSE, this.hideSettings, this);
      this.settingsScreen.on(SettingsScreenEvent.CLEAR_SAVED_DATA, this.showResetDataScreen, this);
      this.settingsScreen.on(PhaserScreenEvent.SHOW, () => this.scroll.disable());
      this.settingsScreen.on(PhaserScreenEvent.HIDE_COMPLETE, () => this.scroll.enable());
      this.settingsScreen.kill();
      this.add.existing(this.settingsScreen);
    }
    showResetDataScreen() {
      if (!this.resetDataScreen) {
        this.addResetDataScreen();
      }
      this.resetDataScreen.resize();
      this.resetDataScreen.show();
    }
    showShopScreen(referrer, showOptions) {
      if (!this.shopScreen) {
        this.addShopScreen();
      }
      this.shopScreen.referrer = referrer;
      this.shopScreen.resize();
      this.shopScreen.show(showOptions);
    }
    showSettings() {
      if (this.settingsScreen.visible === false) {
        this.settingsScreen.show();
      }
    }
    hideSettings() {
      this.settingsScreen.hide();
    }
    addResetDataScreen() {
      this.resetDataScreen = new ResetDataScreen(this);
      this.resetDataScreen.popup.once(ResetDataPopupEvent.RESET_DATA, this.resetSavedData, this);
      this.resetDataScreen.on(PhaserScreenEvent.SHOW, this.onResetDataScreenShow, this);
      this.resetDataScreen.on(PhaserScreenEvent.HIDE_START, this.onResetDataScreenHide, this);
      this.resetDataScreen.kill();
      this.add.existing(this.resetDataScreen);
      this.firstCamera.ignore(this.resetDataScreen);
    }
    resetSavedData() {
      this.game.store.resetSaveData().finally(() => {
        this.restart({});
      });
    }
    onResetDataScreenShow() {
      this.settingsScreen.ignoreBackgroundClicks = true;
      this.settingsScreen.deactivate();
    }
    onResetDataScreenHide() {
      this.settingsScreen.ignoreBackgroundClicks = false;
      this.settingsScreen.activate();
    }
    addShopScreen() {
      this.shopScreen = new ShopScreen(this);
      this.shopScreen.on(PhaserScreenEvent.SHOW, this.onShopScreenShow, this);
      this.shopScreen.on(PhaserScreenEvent.HIDE_START, this.onShopScreenHideStart, this);
      this.shopScreen.on(ShopScreenEvent.PURCHASE_COMPLETE, this.onPurchaseComplete, this);
      this.shopScreen.kill();
      this.add.existing(this.shopScreen);
      this.firstCamera.ignore(this.shopScreen);
    }
    onShopScreenShow() {
      this.scroll.disable();
      if (this.livesScreen.visible) {
        this.livesScreen.deactivate();
      }
      if (this.pregameBoosterBuyScreen.visible) {
        this.pregameBoosterBuyScreen.deactivate();
      }
    }
    onShopScreenHideStart() {
      if (this.livesScreen.visible) {
        this.livesScreen.activate();
      }
      if (this.pregameBoosterBuyScreen.visible) {
        this.pregameBoosterBuyScreen.activate();
      }
      let allScreenAreHidden = !this.livesScreen.visible && !this.startLevelScreen.visible && !this.pregameBoosterBuyScreen.visible;
      if (allScreenAreHidden) {
        this.scroll.enable();
      }
    }
    onPurchaseComplete(screen2, offerId) {
      var _a;
      let coinsNum = this.game.store.getNumber(GameStoreKey.COINS);
      this.topPanel.coinsLabel.updateContentInstant(coinsNum);
      this.livesScreen.coinsLabel.updateCoinsNumInstant(coinsNum);
      (_a = this.pregameBoosterBuyScreen) == null ? void 0 : _a.coinsLabel.syncWithGameStore(true);
    }
    addSpecialOfferScreen() {
      this.specialOfferScreen = new SpecialOfferScreen(this);
      this.specialOfferScreen.on(PhaserScreenEvent.SHOW, () => this.scroll.disable());
      this.specialOfferScreen.on(PhaserScreenEvent.HIDE_START, () => this.scroll.enable());
      this.specialOfferScreen.on(ShopScreenEvent.PURCHASE_COMPLETE, this.onSpecialOfferPurchaseComplete, this);
      this.specialOfferScreen.kill();
      this.add.existing(this.specialOfferScreen);
      this.firstCamera.ignore(this.specialOfferScreen);
    }
    onSpecialOfferPurchaseComplete() {
      this.specialOfferScreen.hide();
      this.time.delayedCall(300, () => {
        var _a;
        this.topPanel.livesLabel.animateIcon();
        this.topPanel.coinsLabel.syncWithGameStore(false);
        this.livesScreen.coinsLabel.syncWithGameStore(true);
        (_a = this.pregameBoosterBuyScreen) == null ? void 0 : _a.coinsLabel.syncWithGameStore(true);
      });
    }
    addStartLevelScreen() {
      this.startLevelScreen = new StartLevelScreen(this);
      this.startLevelScreen.popup.playButton.on(ButtonEvent.RELEASE, this.onPlayButtonClick, this);
      this.startLevelScreen.popup.pregameBoosters.on(PregameBoostersPanelEvent.ADD_BOOSTER_CLICK, this.onBoosterClick, this);
      this.startLevelScreen.on(PhaserScreenEvent.SHOW, this.onStartLevelPopupShow, this);
      this.startLevelScreen.on(PhaserScreenEvent.HIDE_COMPLETE, this.onStartLevelPopupHideComplete, this);
      this.startLevelScreen.on(StartLevelScreenEvent.SHOW_PIGGY_BANK_SCREEN, () => this.showPiggyBackScreen({showBackground: false}));
      this.startLevelScreen.kill();
      this.add.existing(this.startLevelScreen);
    }
    onBoosterClick(booster) {
      let rewardType = VideoRewardUtils.getRewardByPregameBooster(booster.type);
      this.openPregameBoosterBuyScreen(rewardType);
    }
    addLivesScreen() {
      this.livesScreen = new LivesScreen(this);
      this.livesScreen.on(PhaserScreenEvent.SHOW, this.onLivesScreenShow, this);
      this.livesScreen.on(PhaserScreenEvent.HIDE_START, this.onLivesScreenHide, this);
      this.livesScreen.on(LivesScreenEvent.SHOW_COINS_SHOP, () => this.showShopScreen("LevelMap:LivesScreen", {showBackground: false}));
      this.livesScreen.on(LivesScreenEvent.LIVES_PURCHASE_COMPLETE, this.onLivesPurchaseComplete, this);
      this.livesScreen.kill();
      this.add.existing(this.livesScreen);
    }
    onLivesScreenShow() {
      if (this.startLevelScreen.visible) {
        this.livesScreen.hideBackground();
        this.startLevelScreen.deactivate();
      }
    }
    onLivesScreenHide() {
      this.game.toasts.dismissAll();
      if (this.startLevelScreen.isDeactivated) {
        this.startLevelScreen.activate();
      }
    }
    onLivesPurchaseComplete() {
      var _a;
      this.topPanel.coinsLabel.syncWithGameStore(true);
      (_a = this.shopScreen) == null ? void 0 : _a.coinsLabel.syncWithGameStore(true);
      this.pregameBoosterBuyScreen.coinsLabel.syncWithGameStore(true);
    }
    addPregameBoosterBuyScreen() {
      this.pregameBoosterBuyScreen = new BoosterBuyScreen(this);
      this.pregameBoosterBuyScreen.on(BoosterBuyScreenEvent.SHOW_SHOP, () => this.showShopScreen("LevelMap:PregameBoosterBuyScreen", {showBackground: false}));
      this.pregameBoosterBuyScreen.on(BoosterBuyScreenEvent.BOOSTER_BUY_COMPLETE, this.onVideoRewardAdComplete, this);
      this.pregameBoosterBuyScreen.on(PhaserScreenEvent.SHOW, this.onRewardPopupShow, this);
      this.pregameBoosterBuyScreen.on(PhaserScreenEvent.HIDE_START, this.onRewardPopupHideStart, this);
      this.pregameBoosterBuyScreen.kill();
      this.add.existing(this.pregameBoosterBuyScreen);
    }
    onVideoRewardAdComplete(screenData, source) {
      if (source === "coins") {
        this.topPanel.coinsLabel.syncWithGameStore(true);
        this.livesScreen.coinsLabel.syncWithGameStore(true);
      }
      this.saveVideoReward(screenData.rewardType, screenData.rewardNum);
      this.pregameBoosterBuyScreen.hide();
    }
    saveVideoReward(rewardType, rewardNum) {
      switch (rewardType) {
        case VideoRewardType.STRIPES:
        case VideoRewardType.BOMB:
        case VideoRewardType.SUPER_SPHERE:
          let boosterType = VideoRewardUtils.getPregameBoosterByReward(rewardType);
          this.game.analytics.addResource(ResourceCurrency.PREGAME_BOOSTERS, rewardNum, boosterType, "StartLevelPopup");
          this.game.pregameBoosters.getByType(boosterType).num += rewardNum;
          this.startLevelScreen.popup.pregameBoosters.getByType(boosterType).onRewardArrive(rewardNum);
          break;
        default:
          console.warn("Can't handle this reward type!", rewardType, rewardNum);
          break;
      }
    }
    onRewardPopupShow() {
      if (this.startLevelScreen.visible) {
        this.startLevelScreen.deactivate();
      }
    }
    onRewardPopupHideStart() {
      if (this.startLevelScreen.isDeactivated) {
        this.startLevelScreen.activate();
      }
      this.game.toasts.dismissAll();
    }
    openPregameBoosterBuyScreen(rewardType) {
      let data = __spreadProps(__spreadValues({}, VideoRewardUtils.getVideoRewardScreenData(rewardType, this.texts)), {
        boosterPriceInCoins: 1e3,
        coinsTotal: this.game.store.getNumber(GameStoreKey.COINS),
        disableVideoButton: window.game.config.ads.rewarded === false
      });
      this.pregameBoosterBuyScreen.updateData(data);
      this.pregameBoosterBuyScreen.show({showBackground: false});
    }
    onWheelRewardCollected(reward) {
      this.game.gifts.saveReward(reward.rewardType, reward.rewardNum);
      let isCoinReward = reward.rewardType === WheelRewardType.COINS;
      if (isCoinReward) {
        this.topPanel.coinsLabel.syncWithGameStore(false);
      }
    }
    addWheelScreen() {
      this.wheelScreen = new WheelScreen(this);
      this.wheelScreen.on(PhaserScreenEvent.SHOW, this.disableScroll, this);
      this.wheelScreen.on(PhaserScreenEvent.HIDE_COMPLETE, this.onWheelScreenHideComplete, this);
      this.wheelScreen.on(WheelScreenEvent.SPIN_START, this.onWheelSpinStart, this);
      this.wheelScreen.on(WheelScreenEvent.SPIN_COMPLETE, this.onWheelSpinComplete, this);
      this.wheelScreen.on(WheelScreenEvent.START_FAST_FORWARD, (_, timeScale) => this.fastForward.start(timeScale));
      this.wheelScreen.on(WheelScreenEvent.STOP_FAST_FORWARD, () => this.fastForward.stop());
      this.wheelScreen.kill();
      this.add.existing(this.wheelScreen);
    }
    onWheelScreenHideComplete() {
      if (this.wheelRewardScreen.visible === false) {
        this.enableScroll();
      }
    }
    onWheelSpinStart() {
      let currentDay = new Date();
      let nextDay = new Date(currentDay);
      nextDay.setDate(nextDay.getDate() + 1);
      nextDay.setHours(0, 0, 0, 0);
      this.game.store.saveValue(GameStoreKey.WHEEL_LOCKED, true);
      this.game.store.saveValue(GameStoreKey.WHEEL_RESET_TIMESTAMP, nextDay.getTime());
      this.wheelButton.setDisabledState();
      this.wheelButton.showTimer();
    }
    onWheelSpinComplete(wheelScreen, wheel) {
      let rewardType = wheel.getCurrentItem().itemType;
      let rewardNum = WheelRewardUtils.getRewardNum(rewardType);
      this.wheelRewardScreen.addReward(rewardType, rewardNum);
      this.wheelRewardScreen.show();
    }
    addWheelRewardScreen() {
      this.wheelRewardScreen = new WheelRewardScreen(this);
      this.wheelRewardScreen.on(PhaserScreenEvent.SHOW, this.disableScroll, this);
      this.wheelRewardScreen.on(PhaserScreenEvent.HIDE_COMPLETE, this.enableScroll, this);
      this.wheelRewardScreen.on(WheelRewardEvent.COLLECT_COMPLETE, this.onWheelRewardCollected, this);
      this.wheelRewardScreen.kill();
      this.add.existing(this.wheelRewardScreen);
    }
    openWheelRewardScreen(type) {
      let rewardNum = WheelRewardUtils.getRewardNum(type);
      this.wheelRewardScreen.addReward(type, rewardNum);
      this.wheelRewardScreen.show();
    }
    addPiggyBankScreen() {
      this.piggyBankScreen = new PiggyBankScreen(this);
      this.piggyBankScreen.on(PhaserScreenEvent.SHOW, this.onPiggyBankScreenShow, this);
      this.piggyBankScreen.on(PhaserScreenEvent.HIDE_START, this.onPiggyBankScreenHideStart, this);
      this.piggyBankScreen.on(PiggyBankScreenEvent.BREAK, this.onPiggyBankBreak, this);
      this.piggyBankScreen.kill();
      this.add.existing(this.piggyBankScreen);
    }
    onPiggyBankScreenShow() {
      this.scroll.disable();
      if (this.startLevelScreen.visible) {
        this.startLevelScreen.deactivate();
      }
    }
    onPiggyBankScreenHideStart() {
      if (this.startLevelScreen.visible) {
        this.startLevelScreen.activate();
      }
      if (this.startLevelScreen.visible === false) {
        this.scroll.enable();
      }
    }
    onPiggyBankBreak(screen2, coins) {
      this.time.delayedCall(300, () => {
        var _a;
        this.topPanel.coinsLabel.syncWithGameStore(true);
        this.livesScreen.coinsLabel.syncWithGameStore(true);
        (_a = this.pregameBoosterBuyScreen) == null ? void 0 : _a.coinsLabel.syncWithGameStore(true);
        this.piggyBankButton.hideFullPopover();
        this.piggyBankButton.updateCoinsNum(0);
      });
    }
    addTutorial() {
      let isAnyLevelComplete = this.isAnyLevelComplete();
      if (isAnyLevelComplete) {
        return;
      }
      let firstLevelIcon = this.levelIcons.getByLevelNumber(1);
      firstLevelIcon.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
        this.tutorialHand.stopAnimation();
        this.tutorialHand.kill();
      });
      this.piggyBankButton.kill();
      this.giftButton.kill();
      this.addTutorialHand(firstLevelIcon);
      this.hideCloudsOver(firstLevelIcon, firstLevelIcon);
    }
    isAnyLevelComplete() {
      let levelNumbers = this.game.levelConfigs.getLevelNumbers();
      return levelNumbers.some((levelNumber) => {
        let levelResult = this.game.store.getLevelResult(levelNumber);
        if (levelResult && levelResult.complete) {
          return true;
        }
      });
    }
    addTutorialHand(levelIcon) {
      this.tutorialHand = new TapTutorialHand(this, "popups", "popups/start_level/hand.png");
      this.tutorialHand.setDepth(LevelMapDepth.LEVEL_ICON_TUTORIAL_HAND);
      this.tutorialHand.x = levelIcon.x + 74;
      this.tutorialHand.y = levelIcon.y + 60;
      this.tutorialHand.playAnimation(800);
      this.add.existing(this.tutorialHand);
    }
    onPlayButtonClick() {
      let noLives = this.game.lives.getLivesNum() === 0;
      if (noLives) {
        this.livesScreen.show({backgroundAlpha: 1e-3, autoCloseAfterAd: true});
        return;
      }
      let levelNumber = this.startLevelScreen.levelNumber;
      if (levelNumber === 1) {
        this.game.analytics.sendDesignEvent(`LevelMap:PlayButtonClick:Level_${levelNumber}`);
      }
      this.startLevelScreen.popup.playButton.off(ButtonEvent.RELEASE, this.onPlayButtonClick, this);
      this.game.gdSdk.showInterstitialAd("LevelMap:PlayButton").finally(() => {
        this.gotoLevel(levelNumber);
      });
    }
    gotoLevel(levelNumber) {
      let pregameBoosters = this.startLevelScreen.popup.pregameBoosters.getSelectedBoosters();
      this.changeScene(SceneKey.GAMEPLAY_ROOT, {type: "play", levelNumber, pregameBoosters});
    }
    onStartLevelPopupShow() {
      this.scroll.disable();
    }
    onStartLevelPopupHideComplete() {
      this.scroll.enable();
    }
    setupScroll() {
      this.scroll = new LevelMapScrollManager(this);
    }
    addPointerCallbacks() {
      this.input.on(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
      this.input.on(Phaser.Input.Events.POINTER_UP, this.onPointerUp, this);
    }
    onPointerDown(pointer, items) {
      this.pointerDownPosition.x = pointer.x;
      this.pointerDownPosition.y = pointer.y;
      this.pointerDownTime = Date.now();
      this.pointerDownLevelIcon = items.find((item) => item.getData("type") === "LevelIcon");
    }
    onPointerUp(pointer, items) {
      let levelIcon = items.find((item) => item.getData("type") === "LevelIcon");
      if (levelIcon && this.pointerDownLevelIcon === levelIcon) {
        let dragDistance = Phaser.Math.Distance.Between(this.pointerDownPosition.x, this.pointerDownPosition.y, pointer.x, pointer.y);
        let dragTime = Date.now() - this.pointerDownTime;
        if (dragDistance < levelIcon.height / 2 && dragTime < 150) {
          this.onLevelIconClick(levelIcon);
        }
      }
    }
    onLevelIconClick(levelIcon) {
      let levelNumber = levelIcon.levelNumber;
      if (levelNumber === 1) {
        this.game.analytics.sendDesignEvent(`LevelMap:LevelIconClick:Level_${levelIcon.levelNumber}`);
      }
      this.game.audio.playClick();
      this.openStartLevelPopup(levelIcon.levelNumber);
    }
    openStartLevelPopup(levelNumber) {
      let isLevelExist = this.game.levelConfigs.check(levelNumber);
      if (isLevelExist) {
        this.startLevelScreen.updateData(levelNumber);
        this.startLevelScreen.show({fadeInBackground: true});
      }
    }
    addKeyboardCallbacks() {
      if (Main.development) {
        this.onKeyDown("HOME", this.scroll.scrollToBottom, this.scroll);
        this.onKeyDown("END", this.scroll.scrollToTop, this.scroll);
        this.onKeyDown("R", () => this.restart());
        this.onKeyDown("PLUS", this.addGiftStar, this);
        this.onKeyDown("OPEN_BRACKET", this.removeLife, this);
        this.onKeyDown("LEFT", this.updateStartLevelPopup.bind(this, -1));
        this.onKeyDown("RIGHT", this.updateStartLevelPopup.bind(this, 1));
        this.onKeyDown("U", this.levelIcons.unlockAll, this.levelIcons);
        this.onKeyDown("L", this.levelIcons.resetToInitialState, this.levelIcons);
        this.onKeyDown("W", this.openWheelScreen, this);
        this.onKeyDown("G", this.openGiftScreen, this);
        this.onKeyDown("F", this.levelIcons.findAndScrollToLevelIcon, this.levelIcons);
        this.onKeyDown("ONE", this.setGraphicsQuality.bind(this, GraphicsQuality.LOW));
        this.onKeyDown("TWO", this.setGraphicsQuality.bind(this, GraphicsQuality.MEDIUM));
        this.onKeyDown("THREE", this.setGraphicsQuality.bind(this, GraphicsQuality.HIGH));
      }
      if (Main.editorEnabled) {
        this.onceKeyDown("E", this.gotoLevelMapEditor, this);
      }
      if (Main.development) {
        this.onKeyDown("X", this.testSentry, this);
      } else {
        this.onceKeyDown("X", this.testSentry, this);
      }
    }
    setGraphicsQuality(quality) {
      this.game.store.saveValue(GameStoreKey.GRAPHICS_QUALITY, quality);
      this.game.scaler.setQuality(quality);
    }
    testSentry() {
      return __async(this, null, function* () {
        var _a;
        if (!this.game.sentry || this.game.sentry.isEnabled === false) {
          console.log("Sentry is disabled. Test exception wasn't sent.");
          return;
        }
        if (this.shiftKey.isDown === false) {
          return;
        }
        this.game.sentry.captureException(new Error("test error"), {
          extra: {
            snapshot: yield this.game.sentry.getGameSnapshotAsBlob(),
            json: JSON.stringify({key: "value"})
          }
        });
        (_a = this.game.toasts) == null ? void 0 : _a.show({
          message: `[Sentry] Test`,
          lifespan: 3e3
        });
      });
    }
    gotoLevelMapEditor() {
      this.changeScene(SceneKey.LEVEL_MAP_EDITOR);
    }
    removeLife() {
      this.game.lives.removeLife();
    }
    addGiftStar() {
      this.giftButton.onStarArrived();
      this.giftButton.incrementStarsNum();
    }
    updateStartLevelPopup(delta) {
      if (this.startLevelScreen.visible === false) {
        return;
      }
      let newLevelNumber = this.startLevelScreen.levelNumber + delta;
      let isLevelExist = this.game.levelConfigs.check(newLevelNumber);
      if (isLevelExist) {
        this.startLevelScreen.updateData(newLevelNumber);
      }
    }
    resize() {
      var _a, _b, _c, _d, _e, _f, _g;
      super.resize();
      this.resizeCamera();
      this.scroll.onResize();
      this.piggyBankButton.originalScale = this.piggyBankButton.scale;
      this.giftButton.originalScale = this.giftButton.scale;
      this.popover.originalScale = this.popover.scale;
      this.livesScreen.resize();
      this.settingsScreen.resize();
      this.startLevelScreen.resize();
      this.pregameBoosterBuyScreen.resize();
      (_a = this.wheelScreen) == null ? void 0 : _a.resize();
      (_b = this.wheelRewardScreen) == null ? void 0 : _b.resize();
      (_c = this.resetDataScreen) == null ? void 0 : _c.resize();
      (_d = this.shopScreen) == null ? void 0 : _d.resize();
      (_e = this.specialOfferScreen) == null ? void 0 : _e.resize();
      (_f = this.piggyBankScreen) == null ? void 0 : _f.resize();
      (_g = this.greetingsScreen) == null ? void 0 : _g.resize();
    }
    resizeCamera() {
      let camera = this.firstCamera;
      camera.setOrigin(0);
      camera.zoom = Config.GAME_WIDTH / this.background.width;
      let x = (Config.GAME_WIDTH - camera.displayWidth) / 2;
      let y = (Config.GAME_HEIGHT - camera.displayHeight) / 2;
      camera.setBounds(x, y, camera.displayWidth, this.background.height);
    }
    update(time, delta) {
      super.update(time, delta);
      this.scroll.update(delta);
      this.updateAvatars();
      this.cullItems();
    }
    updateAvatars() {
      let topPanelHeight = this.topPanel.height;
      let cameraTop = this.firstCamera.clampY(this.firstCamera.scrollY) + topPanelHeight;
      let cameraBottom = cameraTop + this.firstCamera.displayHeight - topPanelHeight;
      let iconAvatarTop = this.iconAvatar.y - this.iconAvatar.height;
      let iconAvatarBottom = this.iconAvatar.y;
      let isIconAvatarInCamera = iconAvatarBottom > cameraTop && iconAvatarTop < cameraBottom;
      if (this.iconAvatar.wasInCamera && isIconAvatarInCamera === false) {
        this.edgeAvatar.revive();
        this.edgeAvatar.show();
      }
      if (this.iconAvatar.wasInCamera === false && isIconAvatarInCamera) {
        this.edgeAvatar.hide();
      }
      if (this.iconAvatar.visible) {
        this.edgeAvatar.x = this.firstCamera.displayWidth / 2;
        let cameraHeight = cameraBottom - cameraTop;
        let cameraCenterY = cameraTop + cameraHeight / 2;
        if (iconAvatarBottom > cameraCenterY) {
          this.edgeAvatar.y = cameraBottom - 14;
          this.edgeAvatar.lookBottom();
        } else {
          this.edgeAvatar.y = cameraTop;
          this.edgeAvatar.lookUp();
        }
      }
      this.iconAvatar.wasInCamera = isIconAvatarInCamera;
    }
    cullItems() {
      let camera = this.firstCamera;
      let scrollY = Phaser.Math.Clamp(camera.scrollY, 0, camera._bounds.height - camera.displayHeight);
      let bottom = scrollY + camera.displayHeight;
      if (scrollY === this.cameraScrollY && bottom === this.cameraBottom) {
        return;
      }
      this.cameraScrollY = scrollY;
      this.cameraTop = scrollY;
      this.cameraBottom = bottom;
      this.background.cull(camera, this.cameraTop, this.cameraBottom);
      this.cullLevelIconsThrottled(camera, this.cameraTop, this.cameraBottom);
      this.cullClouds(camera, this.cameraTop, this.cameraBottom);
    }
    doCullLevelIcons(camera, cameraTop, cameraBottom) {
      let zoom = camera.zoom;
      let top = cameraTop - 10 * zoom;
      let bottom = cameraBottom + 100 * zoom;
      this.levelIcons.levelIcons.forEach((icon) => {
        if (icon.y > top && icon.y < bottom) {
          icon.revive();
        } else {
          icon.kill();
        }
      });
    }
    cullClouds(camera, cameraTop, cameraBottom) {
      this.clouds.forEach((cloud) => {
        if (cloud.y > cameraTop - 130 && cloud.y < cameraBottom + 130) {
          cloud.revive();
        } else {
          cloud.kill();
        }
      });
    }
    lockScene() {
      if (this.isLocked) {
        return;
      }
      this.isLocked = true;
      this.input.enabled = false;
      this.levelIcons.disable();
      this.disableScroll();
    }
    unlockScene() {
      if (this.isLocked === false) {
        return;
      }
      this.isLocked = false;
      this.input.enabled = true;
      this.levelIcons.enable();
      this.enableScroll();
    }
    enableScroll() {
      this.scroll.enable();
    }
    disableScroll() {
      this.scroll.disable();
    }
    addLanguageChangeCallback() {
      this.game.texts.on(GameTextsEvent.LANGUAGE_CHANGE, this.onLanguageChange, this);
    }
    onLanguageChange(language) {
      var _a, _b, _c, _d, _e;
      this.livesScreen.onLanguageChange();
      this.topPanel.livesLabel.onLanguageChange();
      (_a = this.wheelRewardScreen) == null ? void 0 : _a.onLanguageChange();
      (_b = this.resetDataScreen) == null ? void 0 : _b.onLanguageChange();
      this.startLevelScreen.onLanguageChange();
      this.settingsScreen.onLanguageChange();
      (_c = this.shopScreen) == null ? void 0 : _c.onLanguageChange();
      (_d = this.specialOfferScreen) == null ? void 0 : _d.onLanguageChange();
      (_e = this.piggyBankScreen) == null ? void 0 : _e.onLanguageChange();
      this.piggyBankButton.onLanguageChange();
    }
    onShutdown() {
      this.game.texts.off(GameTextsEvent.LANGUAGE_CHANGE, this.onLanguageChange, this);
      this.cancelFastForward();
      super.onShutdown();
    }
  };

  // src/GdSdkWrapper.ts
  var GdSdkWrapperEvent;
  (function(GdSdkWrapperEvent2) {
    GdSdkWrapperEvent2["INIT"] = "__INIT";
    GdSdkWrapperEvent2["SDK_EVENT"] = "__SDK_EVENT";
  })(GdSdkWrapperEvent || (GdSdkWrapperEvent = {}));
  var GdSdkWrapper = class extends Phaser.Events.EventEmitter {
    constructor(game) {
      super();
      this.adProvider = "game-monetize";
      this._adblock = false;
      this.rewardedAdTimestamp = 0;
      this.interstitialAdTimestamp = 0;
      this.game = game;
      this.initOptions();
    }
    get adblock() {
      return this._adblock;
    }
    initOptions() {
      window["SDK_OPTIONS"] = {
        gameId: "1tj7nxrptpkidz6b491m83qh7n78iv7k",
        onEvent: (event) => {
          switch (event.name) {
            case "SDK_READY":
              this.onSdkReady();
              break;
            case "SDK_ERROR":
              this.onSdkError(event);
              break;
            default:
              this.emit(GdSdkWrapperEvent.SDK_EVENT, this, event);
              break;
          }
        }
      };
    }
    onSdkReady() {
      this.state = "ready";
      this._adblock = false;
      this.onSdkInitComplete();
    }
    onSdkError(event) {
      var _a;
      this.state = "error";
      this._adblock = event.message.includes("Blocked");
      (_a = this.game.analytics) == null ? void 0 : _a.sendError(`GdSdk:${event.name}:${event.message}`);
      this.onSdkInitComplete();
    }
    onSdkInitComplete() {
      let showConsole = UrlParams.getBool("gdConsole");
      if (showConsole) {
        sdk.openConsole();
      }
      this.sendSdkStatusToSentry();
      this.sendAdblockStatusToAnalytics();
      this.emit(GdSdkWrapperEvent.INIT, this);
    }
    sendSdkStatusToSentry() {
      let callback = () => {
        sentry == null ? void 0 : sentry.setTag("gdSdk.adblock", this._adblock.toString());
        sentry == null ? void 0 : sentry.setTag("gdSdk.state", this.state);
      };
      let sentry = this.game.sentry;
      if (sentry) {
        callback();
      } else {
        setTimeout(callback, 5e3);
      }
    }
    sendAdblockStatusToAnalytics() {
      let adBlockStatus = this._adblock ? "adblock_enabled" : "adblock_disabled";
      GameAnalytics("setCustomDimension03", adBlockStatus);
    }
    showInterstitialAd(placement) {
      var _a, _b;
      if (window.game.config.ads.interstitials === false) {
        return Promise.resolve();
      }
      if (this.state !== "ready") {
        return Promise.resolve();
      }
      let wasAnyPurchaseMade = this.game.store.getBoolean(GameStoreKey.SHOP_ANY_PURCHASE_COMPLETE);
      if (wasAnyPurchaseMade) {
        return Promise.resolve();
      }
      let canShowInterstitial = this.canShowInterstitialAd();
      if (canShowInterstitial === false) {
        (_a = this.game.analytics) == null ? void 0 : _a.sendDesignEvent("Ad:Interstitial:Skipped");
        return Promise.resolve();
      }
      (_b = this.game.analytics) == null ? void 0 : _b.sendAdEvent(EGAAdAction.Clicked, EGAAdType.Interstitial, placement, this.adProvider);
      this.addAdBreadcrumb(AdType.INTERSTITIAL, "requested", placement);
      return new Promise((resolve) => {
        this.game.adsHelper.onBeforeAdStart(AdType.INTERSTITIAL).finally(() => {
          this.doShowInsterstitialAd(placement, resolve);
        });
      });
    }
    canShowInterstitialAd() {
      let now2 = Date.now();
      let minInterval = window.game.config.ads.minIntervalMs;
      let timeSinceLastInterstitialAd = now2 - this.interstitialAdTimestamp;
      let timeSinceLastRewardedAd = now2 - this.rewardedAdTimestamp;
      return timeSinceLastInterstitialAd > minInterval && timeSinceLastRewardedAd > minInterval;
    }
    doShowFakeInterstitialAd(durationMs) {
      return new Promise((resolve) => {
        this.game.adsHelper.onBeforeAdStart(AdType.INTERSTITIAL).finally(() => {
          setTimeout(() => {
            resolve();
            this.game.adsHelper.onAdComplete(AdType.INTERSTITIAL);
          }, durationMs);
        });
      });
    }
    doShowInsterstitialAd(placement, resolve) {
      let adStarted = false;
      let onComplete = () => {
        var _a;
        this.interstitialAdTimestamp = Date.now();
        (_a = this.game.analytics) == null ? void 0 : _a.sendAdEvent(EGAAdAction.Show, EGAAdType.Interstitial, placement, this.adProvider);
        this.game.store.changeNumber(GameStoreKey.INTERSTITIAL_ADS_WATCHED, 1);
        this.addAdBreadcrumb(AdType.INTERSTITIAL, "complete", placement);
      };
      let onFailed = () => {
        this.sendAdError(AdType.INTERSTITIAL, "unknown", placement);
        this.addAdBreadcrumb(AdType.INTERSTITIAL, "failed", placement);
      };
      let listener = (wrapper, event) => {
        switch (event.name) {
          case "SDK_GAME_PAUSE":
            adStarted = true;
            break;
          case "SDK_GAME_START":
            adStarted ? onComplete() : onFailed();
            this.off(GdSdkWrapperEvent.SDK_EVENT, listener);
            this.game.adsHelper.onAdComplete(AdType.INTERSTITIAL);
            resolve();
            break;
          default:
            break;
        }
      };
      this.on(GdSdkWrapperEvent.SDK_EVENT, listener);
      sdk.showBanner();
    }
    showRewardedAd(placement) {
      var _a;
      if (window.game.config.ads.rewarded === false) {
        return Promise.resolve(false);
      }
      let useFakeAds = UrlParams.getBool("fakeAds");
      if (useFakeAds) {
        let fakeAdsDuration = UrlParams.getNumber("fakeAdsDuration", 1e3);
        return this.doShowFakeRewardedAd(fakeAdsDuration);
      }
      if (this.state !== "ready") {
        this.game.toasts.showVideoAdWarning();
        return Promise.resolve(false);
      }
      (_a = this.game.analytics) == null ? void 0 : _a.sendAdEvent(EGAAdAction.Clicked, EGAAdType.RewardedVideo, placement, this.adProvider);
      this.addAdBreadcrumb(AdType.REWARDED, "requested", placement);
      return new Promise((resolve) => {
        this.game.adsHelper.onBeforeAdStart(AdType.REWARDED).finally(() => {
          this.doShowRewardedAd(placement, resolve);
        });
      });
    }
    doShowFakeRewardedAd(durationMs = 1e3) {
      return new Promise((resolve) => {
        this.game.adsHelper.onBeforeAdStart(AdType.REWARDED).finally(() => {
          setTimeout(() => {
            resolve(true);
            this.game.adsHelper.onAdComplete(AdType.REWARDED);
          }, durationMs);
        });
      });
    }
    doShowRewardedAd(placement, resolve) {
      let adStarted = false;
      let onComplete = () => {
        var _a;
        this.rewardedAdTimestamp = Date.now();
        (_a = this.game.analytics) == null ? void 0 : _a.sendAdEvent(EGAAdAction.Show, EGAAdType.RewardedVideo, placement, this.adProvider);
        this.game.store.changeNumber(GameStoreKey.REWARDED_ADS_WATCHED, 1);
        this.game.adsHelper.onAdComplete(AdType.REWARDED);
        this.addAdBreadcrumb(AdType.REWARDED, "complete", placement);
        this.preloadAd();
        resolve(true);
      };
      let onFailed = () => {
        this.addAdBreadcrumb(AdType.REWARDED, "failed", placement);
        this.sendAdError(AdType.REWARDED, "unknown", placement);
        this.resolveOnAdTimerComplete(resolve);
      };
      let listener = (wrapper, event) => {
        switch (event.name) {
          case "SDK_GAME_PAUSE":
            adStarted = true;
            break;
          case "SDK_GAME_START":
            adStarted ? onComplete() : onFailed();
            this.off(GdSdkWrapperEvent.SDK_EVENT, listener);
            break;
          default:
            break;
        }
      };
      this.on(GdSdkWrapperEvent.SDK_EVENT, listener);
      sdk.adRequestTimer = "";
      sdk.showBanner();
    }
    resolveOnAdTimerComplete(resolve) {
      this.game.adsHelper.waitUntilAdTimeComplete().finally(() => {
        this.game.adsHelper.onAdComplete(AdType.REWARDED);
        resolve(true);
      });
    }
    sendAdError(adType, error, placement) {
      var _a, _b;
      if (error && error.includes("The advertisement was requested too soon")) {
        return;
      }
      (_a = this.game.analytics) == null ? void 0 : _a.sendAdFailedEvent(this.convertToGAAdType(adType), placement, this.adProvider);
      (_b = this.game.analytics) == null ? void 0 : _b.sendError(`Ads:${adType}:${error}`, EGAErrorSeverity.Warning);
    }
    convertToGAAdType(adType) {
      switch (adType) {
        case AdType.REWARDED:
          return EGAAdType.RewardedVideo;
        default:
          return EGAAdType.Interstitial;
      }
    }
    addAdBreadcrumb(adType, adAction, placement) {
      this.game.sentry.addBreadcrumb({
        category: "ads",
        message: `${adType} ad ${adAction}`,
        data: {
          placement
        }
      });
    }
    preloadAd() {
      if (this.state !== "ready") {
        return;
      }
      return false;
    }
  };

  // src/preloader/SvgCircularProgressBar.ts
  var SvgCircularProgressBar = class {
    constructor(parent, options) {
      this.parent = parent;
      this.setParentSize(options);
      this.options = options;
      this.circumference = this.options.radius * 2 * Math.PI;
      this.createCircle();
    }
    setParentSize(options) {
      let size = options.radius * 2 + options.strokeWidth * 2;
      this.parent.setAttribute("width", size.toString());
      this.parent.setAttribute("height", size.toString());
    }
    createCircle() {
      var _a;
      let centerX = this.options.radius + this.options.strokeWidth;
      let centerY = centerX;
      this.circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
      this.circle.setAttributeNS(null, "cx", centerX.toString());
      this.circle.setAttributeNS(null, "cy", centerY.toString());
      this.circle.setAttributeNS(null, "r", this.options.radius.toString());
      this.circle.setAttributeNS(null, "fill", "transparent");
      this.circle.setAttributeNS(null, "stroke", this.options.strokeColor);
      this.circle.setAttributeNS(null, "stroke-width", this.options.strokeWidth.toString());
      this.circle.setAttributeNS(null, "stroke-linecap", (_a = this.options.linecap) != null ? _a : "round");
      this.circle.style.strokeDasharray = `${this.circumference} ${this.circumference}`;
      this.circle.style.strokeDashoffset = `${this.circumference}`;
      this.parent.appendChild(this.circle);
    }
    setProgress(value) {
      this.circle.style.strokeDashoffset = (this.circumference - value * this.circumference).toString();
    }
  };

  // src/robowhale/utils/cssAnimate.ts
  function cssAnimate(element, animation, durationMs) {
    if (typeof element.onanimationend === "undefined") {
      return Promise.resolve();
    }
    if (typeof durationMs === "number") {
      element.style.setProperty("--animate-duration", `${durationMs / 1e3}s`);
    }
    return new Promise((resolve) => {
      element.classList.add("animate__animated", animation);
      element.onanimationend = () => {
        element.classList.remove(animation);
        resolve();
      };
    });
  }

  // src/preloader/CssPreloader.ts
  var CssPreloader = class extends Phaser.Events.EventEmitter {
    constructor(game, container) {
      super();
      this.game = game;
      this.container = container;
      this.icon = this.container.querySelector("#game-icon");
      this.progressBar = this.createProgressBar();
      this.progressText = this.container.querySelector("p");
    }
    createProgressBar() {
      let parent = this.container.querySelector("svg");
      let options = {
        radius: 77,
        strokeWidth: 7,
        strokeColor: "white",
        linecap: "round"
      };
      return new SvgCircularProgressBar(parent, options);
    }
    show() {
      this.container.style.display = "flex";
      cssAnimate(this.container, "animate__fadeIn", 300);
    }
    hide() {
      this.container.style.display = "none";
    }
    updateProgress(progress) {
      this.progressText.innerText = (progress * 100).toFixed(0);
      this.progressBar.setProgress(progress);
    }
  };

  // src/LoadingOverlay.ts
  var LoadingOverlay = class {
    constructor(game) {
      this.game = game;
      this.overlay = document.getElementById("loading-overlay");
      this.overlay.classList.add("animate__animated");
      this.preloader = new CssPreloader(this.game, document.getElementById("preloader"));
      this.spinner = this.overlay.querySelector(".loading-spinner");
      this.copyright = this.overlay.querySelector(".copyright");
      this.copyright.innerText = this.getCopyrightContent();
      window.addEventListener("resize", this.onWindowResize.bind(this));
      this.onWindowResize();
    }
    getCopyrightContent() {
      let developmentYear = 2020;
      let currentYear = new Date().getUTCFullYear();
      let years = currentYear === developmentYear ? currentYear.toString() : `${developmentYear}-${currentYear}`;
      return `Developed by RoboWhale, ${years}
Use with permission`;
    }
    onWindowResize() {
      let maxWidth = window.innerWidth * 0.33;
      let maxHeight = window.innerHeight * 0.33;
      let scaleX = maxWidth / this.preloader.icon.clientWidth;
      let scaleY = maxHeight / this.preloader.icon.clientHeight;
      let scale = Math.min(1, scaleX, scaleY);
      let transform = `scale(${scale})`;
      this.preloader.container.style.transform = transform;
      this.copyright.style.transform = transform;
    }
    showPreloader() {
      this.preloader.show();
      this.onWindowResize();
    }
    hidePreloader() {
      this.preloader.hide();
    }
    fadeIn() {
      this.overlay.style.display = "flex";
      this.overlay.classList.remove("animate__fadeOut");
      cssAnimate(this.overlay, "animate__fadeIn", 300);
    }
    fadeOut() {
      let instant = UrlParams.getBool("instantSceneChange");
      if (instant) {
        this.overlay.style.display = "none";
        return;
      }
      this.overlay.classList.remove("animate__fadeIn");
      cssAnimate(this.overlay, "animate__fadeOut", 200).then(() => {
        this.overlay.style.display = "none";
      });
    }
    isVisible() {
      return this.overlay.style.display === "flex";
    }
    trackProgress(loader) {
    }
  };

  // src/feedback/send-feedback-sentry.ts
  function sendFeedbackToSentry(sentry, email, message) {
    if (!sentry || sentry.isEnabled === false) {
      return Promise.resolve("");
    }
    return sentry.sendFeedback(message, email);
  }

  // src/feedback/send-feedback-google-sheets.ts
  function sendFeebackToGoogleSheets(game, sentryEventId, email, message) {
    return __async(this, null, function* () {
      let rowData = {
        sentryEventId,
        build: window.game.config.build_version,
        date: new Date().toUTCString().slice(4, -4),
        completeLevelsNum: game.store.getCompleteLevelsNum(),
        email,
        message
      };
      let response = yield fetch(window.game.config.feedback_url, {
        method: "POST",
        body: JSON.stringify([rowData]),
        headers: {
          "Content-Type": "application/json"
        }
      });
      let isSuccess = response.status >= 200 && response.status < 300;
      return isSuccess;
    });
  }

  // src/feedback/FeedbackWidget.ts
  var FeedbackWidgetEvent;
  (function(FeedbackWidgetEvent2) {
    FeedbackWidgetEvent2["OPEN"] = "__OPEN";
    FeedbackWidgetEvent2["CLOSE"] = "__CLOSE";
  })(FeedbackWidgetEvent || (FeedbackWidgetEvent = {}));
  var FeedbackWidget = class extends Phaser.Events.EventEmitter {
    constructor(game) {
      super();
      this._isVisible = false;
      this.game = game;
      this.container = document.getElementById("feedback-widget-container");
      this.container.addEventListener("click", (event) => {
        if (event.target === this.container || event.target === this.alert) {
          this.hide();
        }
      });
      this.initAlert();
      this.initWidget();
      this.addWindowResizeListener();
      this.setCanHoverClass();
    }
    get isVisible() {
      return this._isVisible;
    }
    initAlert() {
      this.alert = this.container.querySelector("#alert");
      this.alert.classList.add("animate__animated");
    }
    initWidget() {
      this.wrapper = document.getElementById("feedback-widget-wrapper");
      this.widget = document.getElementById("feedback-widget");
      this.widget.classList.add("animate__animated");
      this.title = this.widget.querySelector(".title");
      this.subtitle = this.widget.querySelector(".subtitle");
      let messageId = "message";
      this.messageLabel = this.widget.querySelector(`label[for=${messageId}]`);
      this.messageTextArea = this.widget.querySelector(`#${messageId}`);
      let emailId = "email";
      this.emailLabel = this.widget.querySelector(`label[for=${emailId}]`);
      this.emailInput = this.widget.querySelector(`#${emailId}`);
      this.sendButton = this.widget.querySelector(".button");
      this.sendButton.addEventListener("click", this.onSendButtonClick.bind(this));
      this.closeButton = this.widget.querySelector(".button-close");
      this.closeButton.addEventListener("click", this.hide.bind(this));
    }
    onSendButtonClick() {
      let message = this.messageTextArea.value;
      let email = this.emailInput.value;
      if (message.length === 0) {
        cssAnimate(this.messageTextArea, "animate__wrongInput");
        this.sendButton.blur();
        this.messageTextArea.focus({preventScroll: false});
        return;
      }
      let isValidMessage = this.isValidMessage(message);
      if (isValidMessage) {
        this.sendFeedback({email, message: trim_default(message)});
      }
      this.messageTextArea.value = "";
      this.hideWidget();
      this.showAlert(this.getTexts().thank_you);
      this.scrollWindowToTop();
      this.hideTimeoutId = setTimeout(() => {
        this.hide();
      }, 2500);
    }
    isValidMessage(message) {
      let hasSpaces = message.includes(" ");
      return message.length > 5 && message.length < 1500 && hasSpaces;
    }
    sendFeedback(data) {
      return __async(this, null, function* () {
        try {
          let eventId = yield sendFeedbackToSentry(this.game.sentry, data.email, data.message);
          let isSuccess = yield sendFeebackToGoogleSheets(this.game, eventId, data.email, data.message);
          if (isSuccess) {
            console.log("Feedback was sent!", data);
          } else {
            this.game.sentry.captureMessage("Can't send feedback to Google Sheets!");
            console.warn("Can't send feedback to Google Sheets!");
          }
        } catch (error) {
          this.game.sentry.captureException(error);
        }
      });
    }
    hideWidget() {
      cssAnimate(this.widget, "animate__fadeOut", 300).then(() => {
        this.widget.style.display = "none";
      });
    }
    showAlert(text) {
      this.alert.style.display = "flex";
      this.alert.innerText = text;
      cssAnimate(this.alert, "animate__fadeInUpLight", 300);
    }
    addWindowResizeListener() {
      let listener = throttle_default(this.resize.bind(this), 100, {leading: false});
      window.addEventListener("resize", listener);
    }
    setCanHoverClass() {
      let canHover = !matchMedia("(hover: none)").matches;
      if (canHover) {
        document.body.classList.add("can-hover");
      }
    }
    show() {
      this._isVisible = true;
      this.container.style.display = "flex";
      this.alert.style.display = "none";
      this.widget.style.display = "flex";
      this.messageTextArea.focus();
      cssAnimate(this.widget, "animate__fadeInUpLight", 300);
      this.updateTexts();
      this.resize();
      this.handleInputOnShow();
      this.emit(FeedbackWidgetEvent.OPEN, this);
    }
    handleInputOnShow() {
      this.wasInputEnabled = this.game.input.enabled;
      this.wasKeyboardEnabled = this.game.input.keyboard.enabled;
      this.game.input.enabled = false;
      this.game.input.keyboard.enabled = false;
    }
    updateTexts() {
      let texts = this.getTexts();
      this.title.innerText = texts.feedback;
      this.subtitle.innerText = texts.feedback_subtitle;
      this.messageLabel.textContent = texts.message;
      this.emailLabel.textContent = texts.email;
      this.sendButton.textContent = texts.send;
    }
    resize() {
      let maxWidth = window.innerWidth * 0.85;
      let maxHeight = window.innerHeight * 0.8;
      let scaleX = maxWidth / this.wrapper.clientWidth;
      let scaleY = maxHeight / this.wrapper.clientHeight;
      let scale = Math.min(1, scaleX, scaleY);
      this.wrapper.style.transform = `scale(${scale})`;
    }
    hide() {
      if (typeof this.hideTimeoutId !== "undefined") {
        clearTimeout(this.hideTimeoutId);
      }
      cssAnimate(this.container, "animate__fadeOut", 150).then(() => {
        this.container.style.display = "none";
        this._isVisible = false;
        this.handleInputOnHide();
        this.scrollWindowToTop();
        this.emit(FeedbackWidgetEvent.CLOSE, this);
      });
    }
    handleInputOnHide() {
      this.game.input.enabled = this.wasInputEnabled;
      this.game.input.keyboard.enabled = this.wasKeyboardEnabled;
    }
    scrollWindowToTop() {
      window.scrollTo(0, 0);
    }
    getTexts() {
      return this.game.texts.texts.feedback_dialog;
    }
  };

  // src/PauseHandler.ts
  var PauseHandlerEvent;
  (function(PauseHandlerEvent2) {
    PauseHandlerEvent2["PAUSE"] = "__PAUSE";
    PauseHandlerEvent2["RESUME"] = "__RESUME";
  })(PauseHandlerEvent || (PauseHandlerEvent = {}));
  var PauseHandler = class extends Phaser.Events.EventEmitter {
    constructor(game, options) {
      super();
      this.isPaused = false;
      this.pausedScenes = [];
      this.game = game;
      this.options = options;
    }
    pause() {
      var _a;
      if (this.isPaused) {
        return;
      }
      this.isPaused = true;
      this.pausedScenes = this.game.scene.getScenes(true);
      this.pausedScenes.forEach((scene) => scene.scene.pause());
      if (this.options.muteOnPause) {
        (_a = this.game.audio.global) == null ? void 0 : _a.mute(true);
      }
      this.game.events.emit(PauseHandlerEvent.PAUSE, this.game);
    }
    resume() {
      var _a;
      if (this.isPaused === false) {
        return;
      }
      this.isPaused = false;
      this.pausedScenes.forEach((scene) => scene.scene.resume());
      this.pausedScenes.length = 0;
      if (this.options.muteOnPause) {
        (_a = this.game.audio.global) == null ? void 0 : _a.mute(false);
      }
      this.game.events.emit(PauseHandlerEvent.RESUME, this.game);
    }
  };

  // src/FtueAnalytics.ts
  var FtueAnalytics = class {
    constructor(game, saveKey) {
      this.isFtue = false;
      this.game = game;
      this.saveKey = saveKey;
      this.checkFtue();
      this.sendEvent("Startup");
    }
    checkFtue() {
      try {
        let value = localStorage.getItem(this.saveKey);
        localStorage.setItem(this.saveKey, "true");
        this.isFtue = value === null;
      } catch (error) {
      }
    }
    sendEvent(event) {
      if (this.isFtue === false) {
        return;
      }
      GameAnalytics("addDesignEvent", `FTUE:${event}`);
    }
  };

  // src/Main.ts
  var _Main = class extends Phaser.Game {
    constructor() {
      _Main.detectDevMode();
      _Main.detectEditorMode();
      Polyfills.polyfill();
      Phaser3Extensions.extend();
      super(GameConfigCreator.create());
      this.webp = false;
      this.avif = false;
      this.loadingScreen = new LoadingOverlay(this);
      this.store = new GameStore(this, "PapaCherrySaga");
      this.audio = new HowlerWrapper(this, {muteTrigger: "hidden"});
      this.adsHelper = new AdsHelper(this, {muteMethod: "context_suspend", disableInput: true});
      this.gdSdk = new GdSdkWrapper(this);
      this.feedbackWidget = new FeedbackWidget(this);
      this.pauseHandler = new PauseHandler(this, {muteOnPause: true});
      this.ftue = new FtueAnalytics(this, `papa-cherry--${window.game.config.publisher}`);
      this.addScenes();
    }
    static detectDevMode() {
      _Main.development = UrlParams.getBool("dev");
      if (_Main.development) {
        console.info("Developer mode is ON");
      }
    }
    static detectEditorMode() {
      let allowedHosts = ["localhost", "192.168", "robowhale"];
      let isHostAllowed = allowedHosts.some((host) => location.hostname.includes(host));
      if (isHostAllowed && UrlParams.getBool("editor")) {
        _Main.editorEnabled = true;
        document.title = document.title + " + Editor";
        console.info("Editor is enabled");
      }
    }
    addScenes() {
      this.scene.add(SceneKey.GLOBAL, GlobalScene);
      this.scene.add(SceneKey.BOOT, Boot, true);
      this.scene.add(SceneKey.PRELOADER, Preloader);
      this.scene.add(SceneKey.LEVEL_MAP, LevelMap);
      this.scene.add(SceneKey.GAMEPLAY_ROOT, GameplayRoot);
      this.scene.add(SceneKey.GAMEPLAY, Gameplay2);
      this.scene.add(SceneKey.GAMEPLAY_GUI, GameplayGui2);
      if (_Main.editorEnabled) {
        this.scene.add(SceneKey.LEVEL_MAP_EDITOR, LevelMapEditor);
        this.scene.add(SceneKey.LEVEL_EDITOR_ROOT, LevelEditorRoot);
        this.scene.add(SceneKey.LEVEL_EDITOR, LevelEditor3);
        this.scene.add(SceneKey.LEVEL_EDITOR_GUI, LevelEditorGui);
      }
    }
    changeScene(currentSceneKey, newSceneKey, newSceneData) {
      this.globalScene.sceneTransition.changeScene(currentSceneKey, newSceneKey, newSceneData);
    }
    restartScene(currentScene, data) {
      this.globalScene.sceneTransition.changeScene(currentScene, currentScene, data);
    }
    injectIntoScenes(obj, key) {
      this.scene.scenes.forEach((scene) => {
        let isKeyTaken = scene.hasOwnProperty(key);
        if (isKeyTaken) {
          console.warn(`Key ${key} is taken in ${scene.scene.key} scene!`);
          return;
        }
        scene[key] = obj;
      });
    }
    pause() {
      this.pauseHandler.pause();
    }
    resume() {
      this.pauseHandler.resume();
    }
  };
  var Main = _Main;
  Main.development = false;
  Main.editorEnabled = false;

  // src/startup/init-sentry.ts
  var Sentry2 = __toModule(require("@sentry/browser"));
  var gaDisabledWasSent = false;
  var ignoredBreadcrumbUrls = [
    "gameanalytics.com",
    "adnxs.com",
    "headerlift.com",
    "360yield.com",
    "pubmatic.com",
    "doubleclick.net",
    "smartadserver.com",
    "criteo.com",
    "id5-sync.com",
    "msgrt.gamedistribution.com",
    "tracker.gamedock.io"
  ];
  function initSentry() {
    let forceSentry = UrlParams.getBool("sentry");
    if (forceSentry === false && window.environment === GameEnvironment.DEVELOP) {
      return;
    }
    Sentry2.init({
      dsn: "https://a63d1fe2b8b342d28e6720187f9af089@o122971.ingest.sentry.io/5509553",
      environment: window.environment,
      release: window.game.config.build_version.toString(),
      tracesSampleRate: 1,
      ignoreErrors: [
        "freed script",
        "out of memory",
        "Blocked a restricted frame",
        "NS_ERROR_NOT_INITIALIZED",
        "Non-Error promise rejection captured",
        "Permission denied to access property",
        "An attempt was made to use an object",
        "Failed to fetch"
      ],
      denyUrls: [
        /adnxs\.com/,
        /improvedigital\.com/,
        /imasdk\.googleapis\.com/,
        /innovid\.com/
      ],
      beforeBreadcrumb,
      beforeSend
    });
    addSnapshotsProcessor();
    addJsonProcessor();
  }
  function beforeBreadcrumb(breadcrumb, hint) {
    var _a, _b, _c;
    if (breadcrumb.category === "console" && breadcrumb.level === "log") {
      if ((_a = breadcrumb.message) == null ? void 0 : _a.includes("GameMonetize.com")) {
        return null;
      }
    }
    if (breadcrumb.category === "console" && breadcrumb.level === "warning") {
      delete breadcrumb.data;
    }
    if ((_b = breadcrumb.message) == null ? void 0 : _b.includes("https://phaser.io")) {
      return null;
    }
    if (breadcrumb.category === "console" && breadcrumb.level === "warning") {
      let message = breadcrumb.message;
      if (message == null ? void 0 : message.startsWith("Warning/GameAnalytics: Event queue: Failed to send events to collector")) {
        return null;
      }
      if ((message == null ? void 0 : message.includes("Warning/GameAnalytics")) && (message == null ? void 0 : message.includes("SDK is disabled"))) {
        if (gaDisabledWasSent === true) {
          return null;
        }
        gaDisabledWasSent = true;
      }
    }
    if (breadcrumb.category === "xhr" || breadcrumb.category === "fetch") {
      let url = (_c = breadcrumb.data) == null ? void 0 : _c.url;
      if (url) {
        let shouldBeIgnored = ignoredBreadcrumbUrls.some((ignoredUrl) => url.includes(ignoredUrl));
        if (shouldBeIgnored) {
          return null;
        }
      }
      if (breadcrumb.category === "fetch" && typeof url === "string" && url.startsWith("data:image")) {
        return null;
      }
      if (breadcrumb.category === "xhr" && typeof url === "string") {
        let data = breadcrumb.data;
        if (data && data.status_code === 200 && url.match(/^(assets\/)|(css\/)|(js\/)/g)) {
          return null;
        }
      }
      return breadcrumb;
    }
    return breadcrumb.category === "ui.click" ? null : breadcrumb;
  }
  function beforeSend(event, hint) {
    let exception = event.exception;
    if (!exception) {
      return event;
    }
    let regexs = [
      /game(\.[a-z0-9]{10})?\.js/g,
      /game(\.[a-z0-9]{10})?\.min\.js/g,
      /vendor\.min(\.[a-z0-9]{10})?\.js/g,
      /tweakpane\.min(\.[a-z0-9]{10})?\.js/g
    ];
    let isValidException = event.exception.values.some((exception2) => {
      let stacktrace = exception2.stacktrace;
      let hasStacktrace = typeof stacktrace !== "undefined";
      if (hasStacktrace === false) {
        return false;
      }
      let frames = stacktrace.frames;
      if (!frames || frames.length === 0) {
        return false;
      }
      return frames.some((frame) => {
        return regexs.some((regex) => frame.filename.match(regex));
      });
    });
    return isValidException ? event : null;
  }
  function addSnapshotsProcessor() {
    Sentry2.addGlobalEventProcessor((event, hint) => {
      try {
        let key = "snapshot";
        if (!event.extra || !event.extra[key]) {
          return event;
        }
        let snapshotBlob = event.extra[key];
        if (isBlob(snapshotBlob) === false) {
          console.warn("Snapshot should be a Blob!", snapshotBlob);
          return event;
        }
        let formData = convertScreenshotBlobToFormData(snapshotBlob);
        upload(event.event_id, formData, "snapshot");
        delete event.extra[key];
        return event;
      } catch (ex) {
        console.error(ex);
      }
    });
  }
  function addJsonProcessor() {
    Sentry2.addGlobalEventProcessor((event, hint) => {
      try {
        let key = "json";
        if (!event.extra || !event.extra[key]) {
          return event;
        }
        let json = event.extra[key];
        if (typeof json !== "string") {
          console.warn("json should be a string!", json);
          return event;
        }
        let formData = convertStringToJsonFile(json);
        upload(event.event_id, formData, "json");
        delete event.extra[key];
        return event;
      } catch (ex) {
        console.error(ex);
      }
    });
  }
  function isBlob(value) {
    if (typeof Blob === "undefined") {
      return false;
    }
    return value instanceof Blob || Object.prototype.toString.call(value) === "[object Blob]";
  }
  function getAttachmentUrlFromDsn(dsn, eventId) {
    const {host, path, projectId, port, protocol, user} = dsn;
    return `${protocol}://${host}${port !== "" ? `:${port}` : ""}${path !== "" ? `/${path}` : ""}/api/${projectId}/events/${eventId}/attachments/?sentry_key=${user}&sentry_version=7&sentry_client=custom-javascript`;
  }
  function convertScreenshotBlobToFormData(blob) {
    let format = blob.type === "image/jpeg" ? "jpg" : "png";
    let formData = new FormData();
    formData.append("screenshot", blob, `screenshot.${format}`);
    return formData;
  }
  function convertStringToJsonFile(value) {
    let blob = new Blob([value], {type: "application/json"});
    let formData = new FormData();
    formData.append("data", blob, `data.json`);
    return formData;
  }
  function upload(eventId, formData, key) {
    let client = Sentry2.getCurrentHub().getClient();
    let endpoint = getAttachmentUrlFromDsn(client.getDsn(), eventId);
    fetch(endpoint, {
      method: "POST",
      body: formData
    }).then((response) => {
      let isSuccess = response.status >= 200 && response.status < 300;
      if (isSuccess) {
        console.log("[Sentry] Upload complete!", key);
      } else {
        console.log("[Sentry] Upload failed!", response.status, response.statusText);
      }
    }).catch((error) => {
      console.error("[Sentry] Upload failed!", error);
    });
  }

  // src/Publishers.ts
  var Publisher;
  (function(Publisher2) {
    Publisher2["ROBOWHALE"] = "robowhale";
    Publisher2["GAME_DISTRIBUTION"] = "game-distribution";
    Publisher2["GAME_DISTRIBUTION_PREMIUM"] = "game-distribution-premium";
    Publisher2["GAME_DISTRIBUTION_ANDROID"] = "game-distribution-android";
    Publisher2["POKI"] = "poki";
    Publisher2["CRAZY_GAMES"] = "crazy-games";
    Publisher2["WORKER_BEE"] = "worker-bee";
    Publisher2["WORKER_BEE_NO_REWARDED"] = "worker-bee-no-rewarded";
    Publisher2["YANDEX"] = "yandex";
    Publisher2["VK"] = "vk";
    Publisher2["OK"] = "ok";
    Publisher2["FACEBOOK"] = "facebook";
    Publisher2["ORANGE_FRANCE"] = "orange-france";
    Publisher2["GAME_MONETIZE"] = "game-monetize";
    Publisher2["LAGGED"] = "lagged";
    Publisher2["UFREE_GAMES"] = "ufree-games";
    Publisher2["KILOO"] = "kiloo";
    Publisher2["GAME_REVSHARE"] = "game-revshare";
    Publisher2["GAMEPIX"] = "gamepix";
    Publisher2["OTHER"] = "other";
  })(Publisher || (Publisher = {}));

  // src/robowhale/utils/NetUtil.ts
  var NetUtil = class {
    static getCurrentHost() {
      if (window.location && window.location.hostname) {
        return window.location.hostname;
      }
      return null;
    }
    static isLocalhost(...localhostAliases) {
      return NetUtil.isHostAllowed([...localhostAliases, "localhost"]);
    }
    static isHostAllowed(allowedHosts) {
      let currentHost = NetUtil.getCurrentHost();
      if (currentHost) {
        return allowedHosts.some((host) => {
          return currentHost.includes(host);
        });
      }
      return false;
    }
    static inIFrame() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  };

  // src/startup/init-analytics.ts
  function initAnalytics() {
    var _a;
    (_a = window["GameAnalytics"]) != null ? _a : window["GameAnalytics"] = function() {
      (GameAnalytics.q = GameAnalytics.q || []).push(arguments);
    };
    let isLoggingEnabled = UrlParams.getBool("analyticsLog");
    GameAnalytics("setEnabledInfoLog", isLoggingEnabled);
    GameAnalytics("configureBuild", window.game.config.build_version.toString());
    GameAnalytics("configureAvailableResourceCurrencies", Object.values(ResourceCurrency));
    GameAnalytics("configureAvailableResourceItemTypes", Object.values(ResourceItemType));
    GameAnalytics("configureAvailableCustomDimensions01", Object.values(Publisher));
    GameAnalytics("configureAvailableCustomDimensions02", [RendererType.CANVAS, RendererType.WEBGL]);
    GameAnalytics("configureAvailableCustomDimensions03", ["adblock_enabled", "adblock_disabled"]);
    let {gameKey, secret} = getAnalyticsKeys();
    GameAnalytics("initialize", gameKey, secret);
    GameAnalytics("addDesignEvent", "Startup");
  }
  function getAnalyticsKeys() {
    let keys2 = {gameKey: "", secret: ""};
    let currentHost = NetUtil.getCurrentHost();
    let isTestHost = ["robowhale.com", "localhost", "192.168"].some((testHost) => currentHost.includes(testHost));
    let isTesting = UrlParams.getBool("dev") || UrlParams.has("unlockLevels") || UrlParams.getBool("fakeAds");
    let useDevKeys = window.environment === GameEnvironment.DEVELOP || isTestHost || isTesting;
    if (useDevKeys) {
      keys2.gameKey = "a3bef38f8d6f806f9e82d95c5372ab8d";
      keys2.secret = "065467ce1790a9a891e5ceb07bb695d3bb1b38c4";
    } else {
      keys2.gameKey = "39cc03509731bff78f56ac3df452387a";
      keys2.secret = "9837cc71274790b27002f348006ea23331f4fd2b";
    }
    return keys2;
  }

  // src/robowhale/utils/update-url-query.ts
  function updateUrlQuery(key, value) {
    let query = new URLSearchParams(window.location.search);
    if (value) {
      query.set(key, value);
    } else {
      query.delete(key);
    }
    return window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + query.toString();
  }

  // src/startup/Startup.ts
  window.addEventListener("load", () => {
    loadErudaConsole();
    initCacheBusters();
    initSentry();
    initAnalytics();
    createGame();
  });
  function loadErudaConsole() {
    let erudaValue = UrlParams.getNumber("console");
    if (erudaValue <= 0) {
      logBuildInfo();
      return;
    }
    doLoadErudaConsole(erudaValue);
  }
  function logBuildInfo() {
    console.info("Build #" + window.game.config.build_version, window.game.config.build_time);
  }
  function doLoadErudaConsole(erudaValue) {
    let body = document.getElementsByTagName("body")[0];
    let script = document.createElement("script");
    script.src = "//cdn.jsdelivr.net/npm/eruda";
    script.type = "text/javascript";
    script.onload = onErudaConsoleLoad.bind(this, erudaValue);
    body.appendChild(script);
  }
  function onErudaConsoleLoad(value) {
    eruda.init({
      tool: ["console", "elements", "info"]
    });
    logBuildInfo();
    if (value === 2) {
      eruda.show();
    }
  }
  function createGame() {
    try {
      window["gameInstance"] = new Main();
    } catch (error) {
      let _isWebglError = isWebglError(error.toString());
      if (_isWebglError) {
        handleWebGlError(error.toString());
        return;
      }
      throw error;
    }
  }
  function isWebglError(error) {
    let webgErrors = [
      "WebGL unsupported",
      "Framebuffer status",
      "Vertex Shader failed",
      "Fragment Shader failed",
      "Link Program failed"
    ];
    return webgErrors.some((webglError) => error.includes(webglError));
  }
  function handleWebGlError(error) {
    try {
      localStorage.setItem("webgl_error", error);
    } catch (e) {
    }
    let usingCanvasRenderer = window.location.search.includes("forceCanvas=1");
    if (usingCanvasRenderer === false) {
      location.replace(updateUrlQuery("forceCanvas", "1"));
    }
  }
})();
